/******/ var __webpack_modules__ = ({

/***/ 556:
/***/ (function(module) {



(function(root) {

    function checkInt(value) {
        return (parseInt(value) === value);
    }

    function checkInts(arrayish) {
        if (!checkInt(arrayish.length)) { return false; }

        for (var i = 0; i < arrayish.length; i++) {
            if (!checkInt(arrayish[i]) || arrayish[i] < 0 || arrayish[i] > 255) {
                return false;
            }
        }

        return true;
    }

    function coerceArray(arg, copy) {

        // ArrayBuffer view
        if (arg.buffer && ArrayBuffer.isView(arg) && arg.name === 'Uint8Array') {

            if (copy) {
                if (arg.slice) {
                    arg = arg.slice();
                } else {
                    arg = Array.prototype.slice.call(arg);
                }
            }

            return arg;
        }

        // It's an array; check it is a valid representation of a byte
        if (Array.isArray(arg)) {
            if (!checkInts(arg)) {
                throw new Error('Array contains invalid value: ' + arg);
            }

            return new Uint8Array(arg);
        }

        // Something else, but behaves like an array (maybe a Buffer? Arguments?)
        if (checkInt(arg.length) && checkInts(arg)) {
            return new Uint8Array(arg);
        }

        throw new Error('unsupported array-like object');
    }

    function createArray(length) {
        return new Uint8Array(length);
    }

    function copyArray(sourceArray, targetArray, targetStart, sourceStart, sourceEnd) {
        if (sourceStart != null || sourceEnd != null) {
            if (sourceArray.slice) {
                sourceArray = sourceArray.slice(sourceStart, sourceEnd);
            } else {
                sourceArray = Array.prototype.slice.call(sourceArray, sourceStart, sourceEnd);
            }
        }
        targetArray.set(sourceArray, targetStart);
    }



    var convertUtf8 = (function() {
        function toBytes(text) {
            var result = [], i = 0;
            text = encodeURI(text);
            while (i < text.length) {
                var c = text.charCodeAt(i++);

                // if it is a % sign, encode the following 2 bytes as a hex value
                if (c === 37) {
                    result.push(parseInt(text.substr(i, 2), 16))
                    i += 2;

                // otherwise, just the actual byte
                } else {
                    result.push(c)
                }
            }

            return coerceArray(result);
        }

        function fromBytes(bytes) {
            var result = [], i = 0;

            while (i < bytes.length) {
                var c = bytes[i];

                if (c < 128) {
                    result.push(String.fromCharCode(c));
                    i++;
                } else if (c > 191 && c < 224) {
                    result.push(String.fromCharCode(((c & 0x1f) << 6) | (bytes[i + 1] & 0x3f)));
                    i += 2;
                } else {
                    result.push(String.fromCharCode(((c & 0x0f) << 12) | ((bytes[i + 1] & 0x3f) << 6) | (bytes[i + 2] & 0x3f)));
                    i += 3;
                }
            }

            return result.join('');
        }

        return {
            toBytes: toBytes,
            fromBytes: fromBytes,
        }
    })();

    var convertHex = (function() {
        function toBytes(text) {
            var result = [];
            for (var i = 0; i < text.length; i += 2) {
                result.push(parseInt(text.substr(i, 2), 16));
            }

            return result;
        }

        // http://ixti.net/development/javascript/2011/11/11/base64-encodedecode-of-utf8-in-browser-with-js.html
        var Hex = '0123456789abcdef';

        function fromBytes(bytes) {
                var result = [];
                for (var i = 0; i < bytes.length; i++) {
                    var v = bytes[i];
                    result.push(Hex[(v & 0xf0) >> 4] + Hex[v & 0x0f]);
                }
                return result.join('');
        }

        return {
            toBytes: toBytes,
            fromBytes: fromBytes,
        }
    })();


    // Number of rounds by keysize
    var numberOfRounds = {16: 10, 24: 12, 32: 14}

    // Round constant words
    var rcon = [0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36, 0x6c, 0xd8, 0xab, 0x4d, 0x9a, 0x2f, 0x5e, 0xbc, 0x63, 0xc6, 0x97, 0x35, 0x6a, 0xd4, 0xb3, 0x7d, 0xfa, 0xef, 0xc5, 0x91];

    // S-box and Inverse S-box (S is for Substitution)
    var S = [0x63, 0x7c, 0x77, 0x7b, 0xf2, 0x6b, 0x6f, 0xc5, 0x30, 0x01, 0x67, 0x2b, 0xfe, 0xd7, 0xab, 0x76, 0xca, 0x82, 0xc9, 0x7d, 0xfa, 0x59, 0x47, 0xf0, 0xad, 0xd4, 0xa2, 0xaf, 0x9c, 0xa4, 0x72, 0xc0, 0xb7, 0xfd, 0x93, 0x26, 0x36, 0x3f, 0xf7, 0xcc, 0x34, 0xa5, 0xe5, 0xf1, 0x71, 0xd8, 0x31, 0x15, 0x04, 0xc7, 0x23, 0xc3, 0x18, 0x96, 0x05, 0x9a, 0x07, 0x12, 0x80, 0xe2, 0xeb, 0x27, 0xb2, 0x75, 0x09, 0x83, 0x2c, 0x1a, 0x1b, 0x6e, 0x5a, 0xa0, 0x52, 0x3b, 0xd6, 0xb3, 0x29, 0xe3, 0x2f, 0x84, 0x53, 0xd1, 0x00, 0xed, 0x20, 0xfc, 0xb1, 0x5b, 0x6a, 0xcb, 0xbe, 0x39, 0x4a, 0x4c, 0x58, 0xcf, 0xd0, 0xef, 0xaa, 0xfb, 0x43, 0x4d, 0x33, 0x85, 0x45, 0xf9, 0x02, 0x7f, 0x50, 0x3c, 0x9f, 0xa8, 0x51, 0xa3, 0x40, 0x8f, 0x92, 0x9d, 0x38, 0xf5, 0xbc, 0xb6, 0xda, 0x21, 0x10, 0xff, 0xf3, 0xd2, 0xcd, 0x0c, 0x13, 0xec, 0x5f, 0x97, 0x44, 0x17, 0xc4, 0xa7, 0x7e, 0x3d, 0x64, 0x5d, 0x19, 0x73, 0x60, 0x81, 0x4f, 0xdc, 0x22, 0x2a, 0x90, 0x88, 0x46, 0xee, 0xb8, 0x14, 0xde, 0x5e, 0x0b, 0xdb, 0xe0, 0x32, 0x3a, 0x0a, 0x49, 0x06, 0x24, 0x5c, 0xc2, 0xd3, 0xac, 0x62, 0x91, 0x95, 0xe4, 0x79, 0xe7, 0xc8, 0x37, 0x6d, 0x8d, 0xd5, 0x4e, 0xa9, 0x6c, 0x56, 0xf4, 0xea, 0x65, 0x7a, 0xae, 0x08, 0xba, 0x78, 0x25, 0x2e, 0x1c, 0xa6, 0xb4, 0xc6, 0xe8, 0xdd, 0x74, 0x1f, 0x4b, 0xbd, 0x8b, 0x8a, 0x70, 0x3e, 0xb5, 0x66, 0x48, 0x03, 0xf6, 0x0e, 0x61, 0x35, 0x57, 0xb9, 0x86, 0xc1, 0x1d, 0x9e, 0xe1, 0xf8, 0x98, 0x11, 0x69, 0xd9, 0x8e, 0x94, 0x9b, 0x1e, 0x87, 0xe9, 0xce, 0x55, 0x28, 0xdf, 0x8c, 0xa1, 0x89, 0x0d, 0xbf, 0xe6, 0x42, 0x68, 0x41, 0x99, 0x2d, 0x0f, 0xb0, 0x54, 0xbb, 0x16];
    var Si =[0x52, 0x09, 0x6a, 0xd5, 0x30, 0x36, 0xa5, 0x38, 0xbf, 0x40, 0xa3, 0x9e, 0x81, 0xf3, 0xd7, 0xfb, 0x7c, 0xe3, 0x39, 0x82, 0x9b, 0x2f, 0xff, 0x87, 0x34, 0x8e, 0x43, 0x44, 0xc4, 0xde, 0xe9, 0xcb, 0x54, 0x7b, 0x94, 0x32, 0xa6, 0xc2, 0x23, 0x3d, 0xee, 0x4c, 0x95, 0x0b, 0x42, 0xfa, 0xc3, 0x4e, 0x08, 0x2e, 0xa1, 0x66, 0x28, 0xd9, 0x24, 0xb2, 0x76, 0x5b, 0xa2, 0x49, 0x6d, 0x8b, 0xd1, 0x25, 0x72, 0xf8, 0xf6, 0x64, 0x86, 0x68, 0x98, 0x16, 0xd4, 0xa4, 0x5c, 0xcc, 0x5d, 0x65, 0xb6, 0x92, 0x6c, 0x70, 0x48, 0x50, 0xfd, 0xed, 0xb9, 0xda, 0x5e, 0x15, 0x46, 0x57, 0xa7, 0x8d, 0x9d, 0x84, 0x90, 0xd8, 0xab, 0x00, 0x8c, 0xbc, 0xd3, 0x0a, 0xf7, 0xe4, 0x58, 0x05, 0xb8, 0xb3, 0x45, 0x06, 0xd0, 0x2c, 0x1e, 0x8f, 0xca, 0x3f, 0x0f, 0x02, 0xc1, 0xaf, 0xbd, 0x03, 0x01, 0x13, 0x8a, 0x6b, 0x3a, 0x91, 0x11, 0x41, 0x4f, 0x67, 0xdc, 0xea, 0x97, 0xf2, 0xcf, 0xce, 0xf0, 0xb4, 0xe6, 0x73, 0x96, 0xac, 0x74, 0x22, 0xe7, 0xad, 0x35, 0x85, 0xe2, 0xf9, 0x37, 0xe8, 0x1c, 0x75, 0xdf, 0x6e, 0x47, 0xf1, 0x1a, 0x71, 0x1d, 0x29, 0xc5, 0x89, 0x6f, 0xb7, 0x62, 0x0e, 0xaa, 0x18, 0xbe, 0x1b, 0xfc, 0x56, 0x3e, 0x4b, 0xc6, 0xd2, 0x79, 0x20, 0x9a, 0xdb, 0xc0, 0xfe, 0x78, 0xcd, 0x5a, 0xf4, 0x1f, 0xdd, 0xa8, 0x33, 0x88, 0x07, 0xc7, 0x31, 0xb1, 0x12, 0x10, 0x59, 0x27, 0x80, 0xec, 0x5f, 0x60, 0x51, 0x7f, 0xa9, 0x19, 0xb5, 0x4a, 0x0d, 0x2d, 0xe5, 0x7a, 0x9f, 0x93, 0xc9, 0x9c, 0xef, 0xa0, 0xe0, 0x3b, 0x4d, 0xae, 0x2a, 0xf5, 0xb0, 0xc8, 0xeb, 0xbb, 0x3c, 0x83, 0x53, 0x99, 0x61, 0x17, 0x2b, 0x04, 0x7e, 0xba, 0x77, 0xd6, 0x26, 0xe1, 0x69, 0x14, 0x63, 0x55, 0x21, 0x0c, 0x7d];

    // Transformations for encryption
    var T1 = [0xc66363a5, 0xf87c7c84, 0xee777799, 0xf67b7b8d, 0xfff2f20d, 0xd66b6bbd, 0xde6f6fb1, 0x91c5c554, 0x60303050, 0x02010103, 0xce6767a9, 0x562b2b7d, 0xe7fefe19, 0xb5d7d762, 0x4dababe6, 0xec76769a, 0x8fcaca45, 0x1f82829d, 0x89c9c940, 0xfa7d7d87, 0xeffafa15, 0xb25959eb, 0x8e4747c9, 0xfbf0f00b, 0x41adadec, 0xb3d4d467, 0x5fa2a2fd, 0x45afafea, 0x239c9cbf, 0x53a4a4f7, 0xe4727296, 0x9bc0c05b, 0x75b7b7c2, 0xe1fdfd1c, 0x3d9393ae, 0x4c26266a, 0x6c36365a, 0x7e3f3f41, 0xf5f7f702, 0x83cccc4f, 0x6834345c, 0x51a5a5f4, 0xd1e5e534, 0xf9f1f108, 0xe2717193, 0xabd8d873, 0x62313153, 0x2a15153f, 0x0804040c, 0x95c7c752, 0x46232365, 0x9dc3c35e, 0x30181828, 0x379696a1, 0x0a05050f, 0x2f9a9ab5, 0x0e070709, 0x24121236, 0x1b80809b, 0xdfe2e23d, 0xcdebeb26, 0x4e272769, 0x7fb2b2cd, 0xea75759f, 0x1209091b, 0x1d83839e, 0x582c2c74, 0x341a1a2e, 0x361b1b2d, 0xdc6e6eb2, 0xb45a5aee, 0x5ba0a0fb, 0xa45252f6, 0x763b3b4d, 0xb7d6d661, 0x7db3b3ce, 0x5229297b, 0xdde3e33e, 0x5e2f2f71, 0x13848497, 0xa65353f5, 0xb9d1d168, 0x00000000, 0xc1eded2c, 0x40202060, 0xe3fcfc1f, 0x79b1b1c8, 0xb65b5bed, 0xd46a6abe, 0x8dcbcb46, 0x67bebed9, 0x7239394b, 0x944a4ade, 0x984c4cd4, 0xb05858e8, 0x85cfcf4a, 0xbbd0d06b, 0xc5efef2a, 0x4faaaae5, 0xedfbfb16, 0x864343c5, 0x9a4d4dd7, 0x66333355, 0x11858594, 0x8a4545cf, 0xe9f9f910, 0x04020206, 0xfe7f7f81, 0xa05050f0, 0x783c3c44, 0x259f9fba, 0x4ba8a8e3, 0xa25151f3, 0x5da3a3fe, 0x804040c0, 0x058f8f8a, 0x3f9292ad, 0x219d9dbc, 0x70383848, 0xf1f5f504, 0x63bcbcdf, 0x77b6b6c1, 0xafdada75, 0x42212163, 0x20101030, 0xe5ffff1a, 0xfdf3f30e, 0xbfd2d26d, 0x81cdcd4c, 0x180c0c14, 0x26131335, 0xc3ecec2f, 0xbe5f5fe1, 0x359797a2, 0x884444cc, 0x2e171739, 0x93c4c457, 0x55a7a7f2, 0xfc7e7e82, 0x7a3d3d47, 0xc86464ac, 0xba5d5de7, 0x3219192b, 0xe6737395, 0xc06060a0, 0x19818198, 0x9e4f4fd1, 0xa3dcdc7f, 0x44222266, 0x542a2a7e, 0x3b9090ab, 0x0b888883, 0x8c4646ca, 0xc7eeee29, 0x6bb8b8d3, 0x2814143c, 0xa7dede79, 0xbc5e5ee2, 0x160b0b1d, 0xaddbdb76, 0xdbe0e03b, 0x64323256, 0x743a3a4e, 0x140a0a1e, 0x924949db, 0x0c06060a, 0x4824246c, 0xb85c5ce4, 0x9fc2c25d, 0xbdd3d36e, 0x43acacef, 0xc46262a6, 0x399191a8, 0x319595a4, 0xd3e4e437, 0xf279798b, 0xd5e7e732, 0x8bc8c843, 0x6e373759, 0xda6d6db7, 0x018d8d8c, 0xb1d5d564, 0x9c4e4ed2, 0x49a9a9e0, 0xd86c6cb4, 0xac5656fa, 0xf3f4f407, 0xcfeaea25, 0xca6565af, 0xf47a7a8e, 0x47aeaee9, 0x10080818, 0x6fbabad5, 0xf0787888, 0x4a25256f, 0x5c2e2e72, 0x381c1c24, 0x57a6a6f1, 0x73b4b4c7, 0x97c6c651, 0xcbe8e823, 0xa1dddd7c, 0xe874749c, 0x3e1f1f21, 0x964b4bdd, 0x61bdbddc, 0x0d8b8b86, 0x0f8a8a85, 0xe0707090, 0x7c3e3e42, 0x71b5b5c4, 0xcc6666aa, 0x904848d8, 0x06030305, 0xf7f6f601, 0x1c0e0e12, 0xc26161a3, 0x6a35355f, 0xae5757f9, 0x69b9b9d0, 0x17868691, 0x99c1c158, 0x3a1d1d27, 0x279e9eb9, 0xd9e1e138, 0xebf8f813, 0x2b9898b3, 0x22111133, 0xd26969bb, 0xa9d9d970, 0x078e8e89, 0x339494a7, 0x2d9b9bb6, 0x3c1e1e22, 0x15878792, 0xc9e9e920, 0x87cece49, 0xaa5555ff, 0x50282878, 0xa5dfdf7a, 0x038c8c8f, 0x59a1a1f8, 0x09898980, 0x1a0d0d17, 0x65bfbfda, 0xd7e6e631, 0x844242c6, 0xd06868b8, 0x824141c3, 0x299999b0, 0x5a2d2d77, 0x1e0f0f11, 0x7bb0b0cb, 0xa85454fc, 0x6dbbbbd6, 0x2c16163a];
    var T2 = [0xa5c66363, 0x84f87c7c, 0x99ee7777, 0x8df67b7b, 0x0dfff2f2, 0xbdd66b6b, 0xb1de6f6f, 0x5491c5c5, 0x50603030, 0x03020101, 0xa9ce6767, 0x7d562b2b, 0x19e7fefe, 0x62b5d7d7, 0xe64dabab, 0x9aec7676, 0x458fcaca, 0x9d1f8282, 0x4089c9c9, 0x87fa7d7d, 0x15effafa, 0xebb25959, 0xc98e4747, 0x0bfbf0f0, 0xec41adad, 0x67b3d4d4, 0xfd5fa2a2, 0xea45afaf, 0xbf239c9c, 0xf753a4a4, 0x96e47272, 0x5b9bc0c0, 0xc275b7b7, 0x1ce1fdfd, 0xae3d9393, 0x6a4c2626, 0x5a6c3636, 0x417e3f3f, 0x02f5f7f7, 0x4f83cccc, 0x5c683434, 0xf451a5a5, 0x34d1e5e5, 0x08f9f1f1, 0x93e27171, 0x73abd8d8, 0x53623131, 0x3f2a1515, 0x0c080404, 0x5295c7c7, 0x65462323, 0x5e9dc3c3, 0x28301818, 0xa1379696, 0x0f0a0505, 0xb52f9a9a, 0x090e0707, 0x36241212, 0x9b1b8080, 0x3ddfe2e2, 0x26cdebeb, 0x694e2727, 0xcd7fb2b2, 0x9fea7575, 0x1b120909, 0x9e1d8383, 0x74582c2c, 0x2e341a1a, 0x2d361b1b, 0xb2dc6e6e, 0xeeb45a5a, 0xfb5ba0a0, 0xf6a45252, 0x4d763b3b, 0x61b7d6d6, 0xce7db3b3, 0x7b522929, 0x3edde3e3, 0x715e2f2f, 0x97138484, 0xf5a65353, 0x68b9d1d1, 0x00000000, 0x2cc1eded, 0x60402020, 0x1fe3fcfc, 0xc879b1b1, 0xedb65b5b, 0xbed46a6a, 0x468dcbcb, 0xd967bebe, 0x4b723939, 0xde944a4a, 0xd4984c4c, 0xe8b05858, 0x4a85cfcf, 0x6bbbd0d0, 0x2ac5efef, 0xe54faaaa, 0x16edfbfb, 0xc5864343, 0xd79a4d4d, 0x55663333, 0x94118585, 0xcf8a4545, 0x10e9f9f9, 0x06040202, 0x81fe7f7f, 0xf0a05050, 0x44783c3c, 0xba259f9f, 0xe34ba8a8, 0xf3a25151, 0xfe5da3a3, 0xc0804040, 0x8a058f8f, 0xad3f9292, 0xbc219d9d, 0x48703838, 0x04f1f5f5, 0xdf63bcbc, 0xc177b6b6, 0x75afdada, 0x63422121, 0x30201010, 0x1ae5ffff, 0x0efdf3f3, 0x6dbfd2d2, 0x4c81cdcd, 0x14180c0c, 0x35261313, 0x2fc3ecec, 0xe1be5f5f, 0xa2359797, 0xcc884444, 0x392e1717, 0x5793c4c4, 0xf255a7a7, 0x82fc7e7e, 0x477a3d3d, 0xacc86464, 0xe7ba5d5d, 0x2b321919, 0x95e67373, 0xa0c06060, 0x98198181, 0xd19e4f4f, 0x7fa3dcdc, 0x66442222, 0x7e542a2a, 0xab3b9090, 0x830b8888, 0xca8c4646, 0x29c7eeee, 0xd36bb8b8, 0x3c281414, 0x79a7dede, 0xe2bc5e5e, 0x1d160b0b, 0x76addbdb, 0x3bdbe0e0, 0x56643232, 0x4e743a3a, 0x1e140a0a, 0xdb924949, 0x0a0c0606, 0x6c482424, 0xe4b85c5c, 0x5d9fc2c2, 0x6ebdd3d3, 0xef43acac, 0xa6c46262, 0xa8399191, 0xa4319595, 0x37d3e4e4, 0x8bf27979, 0x32d5e7e7, 0x438bc8c8, 0x596e3737, 0xb7da6d6d, 0x8c018d8d, 0x64b1d5d5, 0xd29c4e4e, 0xe049a9a9, 0xb4d86c6c, 0xfaac5656, 0x07f3f4f4, 0x25cfeaea, 0xafca6565, 0x8ef47a7a, 0xe947aeae, 0x18100808, 0xd56fbaba, 0x88f07878, 0x6f4a2525, 0x725c2e2e, 0x24381c1c, 0xf157a6a6, 0xc773b4b4, 0x5197c6c6, 0x23cbe8e8, 0x7ca1dddd, 0x9ce87474, 0x213e1f1f, 0xdd964b4b, 0xdc61bdbd, 0x860d8b8b, 0x850f8a8a, 0x90e07070, 0x427c3e3e, 0xc471b5b5, 0xaacc6666, 0xd8904848, 0x05060303, 0x01f7f6f6, 0x121c0e0e, 0xa3c26161, 0x5f6a3535, 0xf9ae5757, 0xd069b9b9, 0x91178686, 0x5899c1c1, 0x273a1d1d, 0xb9279e9e, 0x38d9e1e1, 0x13ebf8f8, 0xb32b9898, 0x33221111, 0xbbd26969, 0x70a9d9d9, 0x89078e8e, 0xa7339494, 0xb62d9b9b, 0x223c1e1e, 0x92158787, 0x20c9e9e9, 0x4987cece, 0xffaa5555, 0x78502828, 0x7aa5dfdf, 0x8f038c8c, 0xf859a1a1, 0x80098989, 0x171a0d0d, 0xda65bfbf, 0x31d7e6e6, 0xc6844242, 0xb8d06868, 0xc3824141, 0xb0299999, 0x775a2d2d, 0x111e0f0f, 0xcb7bb0b0, 0xfca85454, 0xd66dbbbb, 0x3a2c1616];
    var T3 = [0x63a5c663, 0x7c84f87c, 0x7799ee77, 0x7b8df67b, 0xf20dfff2, 0x6bbdd66b, 0x6fb1de6f, 0xc55491c5, 0x30506030, 0x01030201, 0x67a9ce67, 0x2b7d562b, 0xfe19e7fe, 0xd762b5d7, 0xabe64dab, 0x769aec76, 0xca458fca, 0x829d1f82, 0xc94089c9, 0x7d87fa7d, 0xfa15effa, 0x59ebb259, 0x47c98e47, 0xf00bfbf0, 0xadec41ad, 0xd467b3d4, 0xa2fd5fa2, 0xafea45af, 0x9cbf239c, 0xa4f753a4, 0x7296e472, 0xc05b9bc0, 0xb7c275b7, 0xfd1ce1fd, 0x93ae3d93, 0x266a4c26, 0x365a6c36, 0x3f417e3f, 0xf702f5f7, 0xcc4f83cc, 0x345c6834, 0xa5f451a5, 0xe534d1e5, 0xf108f9f1, 0x7193e271, 0xd873abd8, 0x31536231, 0x153f2a15, 0x040c0804, 0xc75295c7, 0x23654623, 0xc35e9dc3, 0x18283018, 0x96a13796, 0x050f0a05, 0x9ab52f9a, 0x07090e07, 0x12362412, 0x809b1b80, 0xe23ddfe2, 0xeb26cdeb, 0x27694e27, 0xb2cd7fb2, 0x759fea75, 0x091b1209, 0x839e1d83, 0x2c74582c, 0x1a2e341a, 0x1b2d361b, 0x6eb2dc6e, 0x5aeeb45a, 0xa0fb5ba0, 0x52f6a452, 0x3b4d763b, 0xd661b7d6, 0xb3ce7db3, 0x297b5229, 0xe33edde3, 0x2f715e2f, 0x84971384, 0x53f5a653, 0xd168b9d1, 0x00000000, 0xed2cc1ed, 0x20604020, 0xfc1fe3fc, 0xb1c879b1, 0x5bedb65b, 0x6abed46a, 0xcb468dcb, 0xbed967be, 0x394b7239, 0x4ade944a, 0x4cd4984c, 0x58e8b058, 0xcf4a85cf, 0xd06bbbd0, 0xef2ac5ef, 0xaae54faa, 0xfb16edfb, 0x43c58643, 0x4dd79a4d, 0x33556633, 0x85941185, 0x45cf8a45, 0xf910e9f9, 0x02060402, 0x7f81fe7f, 0x50f0a050, 0x3c44783c, 0x9fba259f, 0xa8e34ba8, 0x51f3a251, 0xa3fe5da3, 0x40c08040, 0x8f8a058f, 0x92ad3f92, 0x9dbc219d, 0x38487038, 0xf504f1f5, 0xbcdf63bc, 0xb6c177b6, 0xda75afda, 0x21634221, 0x10302010, 0xff1ae5ff, 0xf30efdf3, 0xd26dbfd2, 0xcd4c81cd, 0x0c14180c, 0x13352613, 0xec2fc3ec, 0x5fe1be5f, 0x97a23597, 0x44cc8844, 0x17392e17, 0xc45793c4, 0xa7f255a7, 0x7e82fc7e, 0x3d477a3d, 0x64acc864, 0x5de7ba5d, 0x192b3219, 0x7395e673, 0x60a0c060, 0x81981981, 0x4fd19e4f, 0xdc7fa3dc, 0x22664422, 0x2a7e542a, 0x90ab3b90, 0x88830b88, 0x46ca8c46, 0xee29c7ee, 0xb8d36bb8, 0x143c2814, 0xde79a7de, 0x5ee2bc5e, 0x0b1d160b, 0xdb76addb, 0xe03bdbe0, 0x32566432, 0x3a4e743a, 0x0a1e140a, 0x49db9249, 0x060a0c06, 0x246c4824, 0x5ce4b85c, 0xc25d9fc2, 0xd36ebdd3, 0xacef43ac, 0x62a6c462, 0x91a83991, 0x95a43195, 0xe437d3e4, 0x798bf279, 0xe732d5e7, 0xc8438bc8, 0x37596e37, 0x6db7da6d, 0x8d8c018d, 0xd564b1d5, 0x4ed29c4e, 0xa9e049a9, 0x6cb4d86c, 0x56faac56, 0xf407f3f4, 0xea25cfea, 0x65afca65, 0x7a8ef47a, 0xaee947ae, 0x08181008, 0xbad56fba, 0x7888f078, 0x256f4a25, 0x2e725c2e, 0x1c24381c, 0xa6f157a6, 0xb4c773b4, 0xc65197c6, 0xe823cbe8, 0xdd7ca1dd, 0x749ce874, 0x1f213e1f, 0x4bdd964b, 0xbddc61bd, 0x8b860d8b, 0x8a850f8a, 0x7090e070, 0x3e427c3e, 0xb5c471b5, 0x66aacc66, 0x48d89048, 0x03050603, 0xf601f7f6, 0x0e121c0e, 0x61a3c261, 0x355f6a35, 0x57f9ae57, 0xb9d069b9, 0x86911786, 0xc15899c1, 0x1d273a1d, 0x9eb9279e, 0xe138d9e1, 0xf813ebf8, 0x98b32b98, 0x11332211, 0x69bbd269, 0xd970a9d9, 0x8e89078e, 0x94a73394, 0x9bb62d9b, 0x1e223c1e, 0x87921587, 0xe920c9e9, 0xce4987ce, 0x55ffaa55, 0x28785028, 0xdf7aa5df, 0x8c8f038c, 0xa1f859a1, 0x89800989, 0x0d171a0d, 0xbfda65bf, 0xe631d7e6, 0x42c68442, 0x68b8d068, 0x41c38241, 0x99b02999, 0x2d775a2d, 0x0f111e0f, 0xb0cb7bb0, 0x54fca854, 0xbbd66dbb, 0x163a2c16];
    var T4 = [0x6363a5c6, 0x7c7c84f8, 0x777799ee, 0x7b7b8df6, 0xf2f20dff, 0x6b6bbdd6, 0x6f6fb1de, 0xc5c55491, 0x30305060, 0x01010302, 0x6767a9ce, 0x2b2b7d56, 0xfefe19e7, 0xd7d762b5, 0xababe64d, 0x76769aec, 0xcaca458f, 0x82829d1f, 0xc9c94089, 0x7d7d87fa, 0xfafa15ef, 0x5959ebb2, 0x4747c98e, 0xf0f00bfb, 0xadadec41, 0xd4d467b3, 0xa2a2fd5f, 0xafafea45, 0x9c9cbf23, 0xa4a4f753, 0x727296e4, 0xc0c05b9b, 0xb7b7c275, 0xfdfd1ce1, 0x9393ae3d, 0x26266a4c, 0x36365a6c, 0x3f3f417e, 0xf7f702f5, 0xcccc4f83, 0x34345c68, 0xa5a5f451, 0xe5e534d1, 0xf1f108f9, 0x717193e2, 0xd8d873ab, 0x31315362, 0x15153f2a, 0x04040c08, 0xc7c75295, 0x23236546, 0xc3c35e9d, 0x18182830, 0x9696a137, 0x05050f0a, 0x9a9ab52f, 0x0707090e, 0x12123624, 0x80809b1b, 0xe2e23ddf, 0xebeb26cd, 0x2727694e, 0xb2b2cd7f, 0x75759fea, 0x09091b12, 0x83839e1d, 0x2c2c7458, 0x1a1a2e34, 0x1b1b2d36, 0x6e6eb2dc, 0x5a5aeeb4, 0xa0a0fb5b, 0x5252f6a4, 0x3b3b4d76, 0xd6d661b7, 0xb3b3ce7d, 0x29297b52, 0xe3e33edd, 0x2f2f715e, 0x84849713, 0x5353f5a6, 0xd1d168b9, 0x00000000, 0xeded2cc1, 0x20206040, 0xfcfc1fe3, 0xb1b1c879, 0x5b5bedb6, 0x6a6abed4, 0xcbcb468d, 0xbebed967, 0x39394b72, 0x4a4ade94, 0x4c4cd498, 0x5858e8b0, 0xcfcf4a85, 0xd0d06bbb, 0xefef2ac5, 0xaaaae54f, 0xfbfb16ed, 0x4343c586, 0x4d4dd79a, 0x33335566, 0x85859411, 0x4545cf8a, 0xf9f910e9, 0x02020604, 0x7f7f81fe, 0x5050f0a0, 0x3c3c4478, 0x9f9fba25, 0xa8a8e34b, 0x5151f3a2, 0xa3a3fe5d, 0x4040c080, 0x8f8f8a05, 0x9292ad3f, 0x9d9dbc21, 0x38384870, 0xf5f504f1, 0xbcbcdf63, 0xb6b6c177, 0xdada75af, 0x21216342, 0x10103020, 0xffff1ae5, 0xf3f30efd, 0xd2d26dbf, 0xcdcd4c81, 0x0c0c1418, 0x13133526, 0xecec2fc3, 0x5f5fe1be, 0x9797a235, 0x4444cc88, 0x1717392e, 0xc4c45793, 0xa7a7f255, 0x7e7e82fc, 0x3d3d477a, 0x6464acc8, 0x5d5de7ba, 0x19192b32, 0x737395e6, 0x6060a0c0, 0x81819819, 0x4f4fd19e, 0xdcdc7fa3, 0x22226644, 0x2a2a7e54, 0x9090ab3b, 0x8888830b, 0x4646ca8c, 0xeeee29c7, 0xb8b8d36b, 0x14143c28, 0xdede79a7, 0x5e5ee2bc, 0x0b0b1d16, 0xdbdb76ad, 0xe0e03bdb, 0x32325664, 0x3a3a4e74, 0x0a0a1e14, 0x4949db92, 0x06060a0c, 0x24246c48, 0x5c5ce4b8, 0xc2c25d9f, 0xd3d36ebd, 0xacacef43, 0x6262a6c4, 0x9191a839, 0x9595a431, 0xe4e437d3, 0x79798bf2, 0xe7e732d5, 0xc8c8438b, 0x3737596e, 0x6d6db7da, 0x8d8d8c01, 0xd5d564b1, 0x4e4ed29c, 0xa9a9e049, 0x6c6cb4d8, 0x5656faac, 0xf4f407f3, 0xeaea25cf, 0x6565afca, 0x7a7a8ef4, 0xaeaee947, 0x08081810, 0xbabad56f, 0x787888f0, 0x25256f4a, 0x2e2e725c, 0x1c1c2438, 0xa6a6f157, 0xb4b4c773, 0xc6c65197, 0xe8e823cb, 0xdddd7ca1, 0x74749ce8, 0x1f1f213e, 0x4b4bdd96, 0xbdbddc61, 0x8b8b860d, 0x8a8a850f, 0x707090e0, 0x3e3e427c, 0xb5b5c471, 0x6666aacc, 0x4848d890, 0x03030506, 0xf6f601f7, 0x0e0e121c, 0x6161a3c2, 0x35355f6a, 0x5757f9ae, 0xb9b9d069, 0x86869117, 0xc1c15899, 0x1d1d273a, 0x9e9eb927, 0xe1e138d9, 0xf8f813eb, 0x9898b32b, 0x11113322, 0x6969bbd2, 0xd9d970a9, 0x8e8e8907, 0x9494a733, 0x9b9bb62d, 0x1e1e223c, 0x87879215, 0xe9e920c9, 0xcece4987, 0x5555ffaa, 0x28287850, 0xdfdf7aa5, 0x8c8c8f03, 0xa1a1f859, 0x89898009, 0x0d0d171a, 0xbfbfda65, 0xe6e631d7, 0x4242c684, 0x6868b8d0, 0x4141c382, 0x9999b029, 0x2d2d775a, 0x0f0f111e, 0xb0b0cb7b, 0x5454fca8, 0xbbbbd66d, 0x16163a2c];

    // Transformations for decryption
    var T5 = [0x51f4a750, 0x7e416553, 0x1a17a4c3, 0x3a275e96, 0x3bab6bcb, 0x1f9d45f1, 0xacfa58ab, 0x4be30393, 0x2030fa55, 0xad766df6, 0x88cc7691, 0xf5024c25, 0x4fe5d7fc, 0xc52acbd7, 0x26354480, 0xb562a38f, 0xdeb15a49, 0x25ba1b67, 0x45ea0e98, 0x5dfec0e1, 0xc32f7502, 0x814cf012, 0x8d4697a3, 0x6bd3f9c6, 0x038f5fe7, 0x15929c95, 0xbf6d7aeb, 0x955259da, 0xd4be832d, 0x587421d3, 0x49e06929, 0x8ec9c844, 0x75c2896a, 0xf48e7978, 0x99583e6b, 0x27b971dd, 0xbee14fb6, 0xf088ad17, 0xc920ac66, 0x7dce3ab4, 0x63df4a18, 0xe51a3182, 0x97513360, 0x62537f45, 0xb16477e0, 0xbb6bae84, 0xfe81a01c, 0xf9082b94, 0x70486858, 0x8f45fd19, 0x94de6c87, 0x527bf8b7, 0xab73d323, 0x724b02e2, 0xe31f8f57, 0x6655ab2a, 0xb2eb2807, 0x2fb5c203, 0x86c57b9a, 0xd33708a5, 0x302887f2, 0x23bfa5b2, 0x02036aba, 0xed16825c, 0x8acf1c2b, 0xa779b492, 0xf307f2f0, 0x4e69e2a1, 0x65daf4cd, 0x0605bed5, 0xd134621f, 0xc4a6fe8a, 0x342e539d, 0xa2f355a0, 0x058ae132, 0xa4f6eb75, 0x0b83ec39, 0x4060efaa, 0x5e719f06, 0xbd6e1051, 0x3e218af9, 0x96dd063d, 0xdd3e05ae, 0x4de6bd46, 0x91548db5, 0x71c45d05, 0x0406d46f, 0x605015ff, 0x1998fb24, 0xd6bde997, 0x894043cc, 0x67d99e77, 0xb0e842bd, 0x07898b88, 0xe7195b38, 0x79c8eedb, 0xa17c0a47, 0x7c420fe9, 0xf8841ec9, 0x00000000, 0x09808683, 0x322bed48, 0x1e1170ac, 0x6c5a724e, 0xfd0efffb, 0x0f853856, 0x3daed51e, 0x362d3927, 0x0a0fd964, 0x685ca621, 0x9b5b54d1, 0x24362e3a, 0x0c0a67b1, 0x9357e70f, 0xb4ee96d2, 0x1b9b919e, 0x80c0c54f, 0x61dc20a2, 0x5a774b69, 0x1c121a16, 0xe293ba0a, 0xc0a02ae5, 0x3c22e043, 0x121b171d, 0x0e090d0b, 0xf28bc7ad, 0x2db6a8b9, 0x141ea9c8, 0x57f11985, 0xaf75074c, 0xee99ddbb, 0xa37f60fd, 0xf701269f, 0x5c72f5bc, 0x44663bc5, 0x5bfb7e34, 0x8b432976, 0xcb23c6dc, 0xb6edfc68, 0xb8e4f163, 0xd731dcca, 0x42638510, 0x13972240, 0x84c61120, 0x854a247d, 0xd2bb3df8, 0xaef93211, 0xc729a16d, 0x1d9e2f4b, 0xdcb230f3, 0x0d8652ec, 0x77c1e3d0, 0x2bb3166c, 0xa970b999, 0x119448fa, 0x47e96422, 0xa8fc8cc4, 0xa0f03f1a, 0x567d2cd8, 0x223390ef, 0x87494ec7, 0xd938d1c1, 0x8ccaa2fe, 0x98d40b36, 0xa6f581cf, 0xa57ade28, 0xdab78e26, 0x3fadbfa4, 0x2c3a9de4, 0x5078920d, 0x6a5fcc9b, 0x547e4662, 0xf68d13c2, 0x90d8b8e8, 0x2e39f75e, 0x82c3aff5, 0x9f5d80be, 0x69d0937c, 0x6fd52da9, 0xcf2512b3, 0xc8ac993b, 0x10187da7, 0xe89c636e, 0xdb3bbb7b, 0xcd267809, 0x6e5918f4, 0xec9ab701, 0x834f9aa8, 0xe6956e65, 0xaaffe67e, 0x21bccf08, 0xef15e8e6, 0xbae79bd9, 0x4a6f36ce, 0xea9f09d4, 0x29b07cd6, 0x31a4b2af, 0x2a3f2331, 0xc6a59430, 0x35a266c0, 0x744ebc37, 0xfc82caa6, 0xe090d0b0, 0x33a7d815, 0xf104984a, 0x41ecdaf7, 0x7fcd500e, 0x1791f62f, 0x764dd68d, 0x43efb04d, 0xccaa4d54, 0xe49604df, 0x9ed1b5e3, 0x4c6a881b, 0xc12c1fb8, 0x4665517f, 0x9d5eea04, 0x018c355d, 0xfa877473, 0xfb0b412e, 0xb3671d5a, 0x92dbd252, 0xe9105633, 0x6dd64713, 0x9ad7618c, 0x37a10c7a, 0x59f8148e, 0xeb133c89, 0xcea927ee, 0xb761c935, 0xe11ce5ed, 0x7a47b13c, 0x9cd2df59, 0x55f2733f, 0x1814ce79, 0x73c737bf, 0x53f7cdea, 0x5ffdaa5b, 0xdf3d6f14, 0x7844db86, 0xcaaff381, 0xb968c43e, 0x3824342c, 0xc2a3405f, 0x161dc372, 0xbce2250c, 0x283c498b, 0xff0d9541, 0x39a80171, 0x080cb3de, 0xd8b4e49c, 0x6456c190, 0x7bcb8461, 0xd532b670, 0x486c5c74, 0xd0b85742];
    var T6 = [0x5051f4a7, 0x537e4165, 0xc31a17a4, 0x963a275e, 0xcb3bab6b, 0xf11f9d45, 0xabacfa58, 0x934be303, 0x552030fa, 0xf6ad766d, 0x9188cc76, 0x25f5024c, 0xfc4fe5d7, 0xd7c52acb, 0x80263544, 0x8fb562a3, 0x49deb15a, 0x6725ba1b, 0x9845ea0e, 0xe15dfec0, 0x02c32f75, 0x12814cf0, 0xa38d4697, 0xc66bd3f9, 0xe7038f5f, 0x9515929c, 0xebbf6d7a, 0xda955259, 0x2dd4be83, 0xd3587421, 0x2949e069, 0x448ec9c8, 0x6a75c289, 0x78f48e79, 0x6b99583e, 0xdd27b971, 0xb6bee14f, 0x17f088ad, 0x66c920ac, 0xb47dce3a, 0x1863df4a, 0x82e51a31, 0x60975133, 0x4562537f, 0xe0b16477, 0x84bb6bae, 0x1cfe81a0, 0x94f9082b, 0x58704868, 0x198f45fd, 0x8794de6c, 0xb7527bf8, 0x23ab73d3, 0xe2724b02, 0x57e31f8f, 0x2a6655ab, 0x07b2eb28, 0x032fb5c2, 0x9a86c57b, 0xa5d33708, 0xf2302887, 0xb223bfa5, 0xba02036a, 0x5ced1682, 0x2b8acf1c, 0x92a779b4, 0xf0f307f2, 0xa14e69e2, 0xcd65daf4, 0xd50605be, 0x1fd13462, 0x8ac4a6fe, 0x9d342e53, 0xa0a2f355, 0x32058ae1, 0x75a4f6eb, 0x390b83ec, 0xaa4060ef, 0x065e719f, 0x51bd6e10, 0xf93e218a, 0x3d96dd06, 0xaedd3e05, 0x464de6bd, 0xb591548d, 0x0571c45d, 0x6f0406d4, 0xff605015, 0x241998fb, 0x97d6bde9, 0xcc894043, 0x7767d99e, 0xbdb0e842, 0x8807898b, 0x38e7195b, 0xdb79c8ee, 0x47a17c0a, 0xe97c420f, 0xc9f8841e, 0x00000000, 0x83098086, 0x48322bed, 0xac1e1170, 0x4e6c5a72, 0xfbfd0eff, 0x560f8538, 0x1e3daed5, 0x27362d39, 0x640a0fd9, 0x21685ca6, 0xd19b5b54, 0x3a24362e, 0xb10c0a67, 0x0f9357e7, 0xd2b4ee96, 0x9e1b9b91, 0x4f80c0c5, 0xa261dc20, 0x695a774b, 0x161c121a, 0x0ae293ba, 0xe5c0a02a, 0x433c22e0, 0x1d121b17, 0x0b0e090d, 0xadf28bc7, 0xb92db6a8, 0xc8141ea9, 0x8557f119, 0x4caf7507, 0xbbee99dd, 0xfda37f60, 0x9ff70126, 0xbc5c72f5, 0xc544663b, 0x345bfb7e, 0x768b4329, 0xdccb23c6, 0x68b6edfc, 0x63b8e4f1, 0xcad731dc, 0x10426385, 0x40139722, 0x2084c611, 0x7d854a24, 0xf8d2bb3d, 0x11aef932, 0x6dc729a1, 0x4b1d9e2f, 0xf3dcb230, 0xec0d8652, 0xd077c1e3, 0x6c2bb316, 0x99a970b9, 0xfa119448, 0x2247e964, 0xc4a8fc8c, 0x1aa0f03f, 0xd8567d2c, 0xef223390, 0xc787494e, 0xc1d938d1, 0xfe8ccaa2, 0x3698d40b, 0xcfa6f581, 0x28a57ade, 0x26dab78e, 0xa43fadbf, 0xe42c3a9d, 0x0d507892, 0x9b6a5fcc, 0x62547e46, 0xc2f68d13, 0xe890d8b8, 0x5e2e39f7, 0xf582c3af, 0xbe9f5d80, 0x7c69d093, 0xa96fd52d, 0xb3cf2512, 0x3bc8ac99, 0xa710187d, 0x6ee89c63, 0x7bdb3bbb, 0x09cd2678, 0xf46e5918, 0x01ec9ab7, 0xa8834f9a, 0x65e6956e, 0x7eaaffe6, 0x0821bccf, 0xe6ef15e8, 0xd9bae79b, 0xce4a6f36, 0xd4ea9f09, 0xd629b07c, 0xaf31a4b2, 0x312a3f23, 0x30c6a594, 0xc035a266, 0x37744ebc, 0xa6fc82ca, 0xb0e090d0, 0x1533a7d8, 0x4af10498, 0xf741ecda, 0x0e7fcd50, 0x2f1791f6, 0x8d764dd6, 0x4d43efb0, 0x54ccaa4d, 0xdfe49604, 0xe39ed1b5, 0x1b4c6a88, 0xb8c12c1f, 0x7f466551, 0x049d5eea, 0x5d018c35, 0x73fa8774, 0x2efb0b41, 0x5ab3671d, 0x5292dbd2, 0x33e91056, 0x136dd647, 0x8c9ad761, 0x7a37a10c, 0x8e59f814, 0x89eb133c, 0xeecea927, 0x35b761c9, 0xede11ce5, 0x3c7a47b1, 0x599cd2df, 0x3f55f273, 0x791814ce, 0xbf73c737, 0xea53f7cd, 0x5b5ffdaa, 0x14df3d6f, 0x867844db, 0x81caaff3, 0x3eb968c4, 0x2c382434, 0x5fc2a340, 0x72161dc3, 0x0cbce225, 0x8b283c49, 0x41ff0d95, 0x7139a801, 0xde080cb3, 0x9cd8b4e4, 0x906456c1, 0x617bcb84, 0x70d532b6, 0x74486c5c, 0x42d0b857];
    var T7 = [0xa75051f4, 0x65537e41, 0xa4c31a17, 0x5e963a27, 0x6bcb3bab, 0x45f11f9d, 0x58abacfa, 0x03934be3, 0xfa552030, 0x6df6ad76, 0x769188cc, 0x4c25f502, 0xd7fc4fe5, 0xcbd7c52a, 0x44802635, 0xa38fb562, 0x5a49deb1, 0x1b6725ba, 0x0e9845ea, 0xc0e15dfe, 0x7502c32f, 0xf012814c, 0x97a38d46, 0xf9c66bd3, 0x5fe7038f, 0x9c951592, 0x7aebbf6d, 0x59da9552, 0x832dd4be, 0x21d35874, 0x692949e0, 0xc8448ec9, 0x896a75c2, 0x7978f48e, 0x3e6b9958, 0x71dd27b9, 0x4fb6bee1, 0xad17f088, 0xac66c920, 0x3ab47dce, 0x4a1863df, 0x3182e51a, 0x33609751, 0x7f456253, 0x77e0b164, 0xae84bb6b, 0xa01cfe81, 0x2b94f908, 0x68587048, 0xfd198f45, 0x6c8794de, 0xf8b7527b, 0xd323ab73, 0x02e2724b, 0x8f57e31f, 0xab2a6655, 0x2807b2eb, 0xc2032fb5, 0x7b9a86c5, 0x08a5d337, 0x87f23028, 0xa5b223bf, 0x6aba0203, 0x825ced16, 0x1c2b8acf, 0xb492a779, 0xf2f0f307, 0xe2a14e69, 0xf4cd65da, 0xbed50605, 0x621fd134, 0xfe8ac4a6, 0x539d342e, 0x55a0a2f3, 0xe132058a, 0xeb75a4f6, 0xec390b83, 0xefaa4060, 0x9f065e71, 0x1051bd6e, 0x8af93e21, 0x063d96dd, 0x05aedd3e, 0xbd464de6, 0x8db59154, 0x5d0571c4, 0xd46f0406, 0x15ff6050, 0xfb241998, 0xe997d6bd, 0x43cc8940, 0x9e7767d9, 0x42bdb0e8, 0x8b880789, 0x5b38e719, 0xeedb79c8, 0x0a47a17c, 0x0fe97c42, 0x1ec9f884, 0x00000000, 0x86830980, 0xed48322b, 0x70ac1e11, 0x724e6c5a, 0xfffbfd0e, 0x38560f85, 0xd51e3dae, 0x3927362d, 0xd9640a0f, 0xa621685c, 0x54d19b5b, 0x2e3a2436, 0x67b10c0a, 0xe70f9357, 0x96d2b4ee, 0x919e1b9b, 0xc54f80c0, 0x20a261dc, 0x4b695a77, 0x1a161c12, 0xba0ae293, 0x2ae5c0a0, 0xe0433c22, 0x171d121b, 0x0d0b0e09, 0xc7adf28b, 0xa8b92db6, 0xa9c8141e, 0x198557f1, 0x074caf75, 0xddbbee99, 0x60fda37f, 0x269ff701, 0xf5bc5c72, 0x3bc54466, 0x7e345bfb, 0x29768b43, 0xc6dccb23, 0xfc68b6ed, 0xf163b8e4, 0xdccad731, 0x85104263, 0x22401397, 0x112084c6, 0x247d854a, 0x3df8d2bb, 0x3211aef9, 0xa16dc729, 0x2f4b1d9e, 0x30f3dcb2, 0x52ec0d86, 0xe3d077c1, 0x166c2bb3, 0xb999a970, 0x48fa1194, 0x642247e9, 0x8cc4a8fc, 0x3f1aa0f0, 0x2cd8567d, 0x90ef2233, 0x4ec78749, 0xd1c1d938, 0xa2fe8cca, 0x0b3698d4, 0x81cfa6f5, 0xde28a57a, 0x8e26dab7, 0xbfa43fad, 0x9de42c3a, 0x920d5078, 0xcc9b6a5f, 0x4662547e, 0x13c2f68d, 0xb8e890d8, 0xf75e2e39, 0xaff582c3, 0x80be9f5d, 0x937c69d0, 0x2da96fd5, 0x12b3cf25, 0x993bc8ac, 0x7da71018, 0x636ee89c, 0xbb7bdb3b, 0x7809cd26, 0x18f46e59, 0xb701ec9a, 0x9aa8834f, 0x6e65e695, 0xe67eaaff, 0xcf0821bc, 0xe8e6ef15, 0x9bd9bae7, 0x36ce4a6f, 0x09d4ea9f, 0x7cd629b0, 0xb2af31a4, 0x23312a3f, 0x9430c6a5, 0x66c035a2, 0xbc37744e, 0xcaa6fc82, 0xd0b0e090, 0xd81533a7, 0x984af104, 0xdaf741ec, 0x500e7fcd, 0xf62f1791, 0xd68d764d, 0xb04d43ef, 0x4d54ccaa, 0x04dfe496, 0xb5e39ed1, 0x881b4c6a, 0x1fb8c12c, 0x517f4665, 0xea049d5e, 0x355d018c, 0x7473fa87, 0x412efb0b, 0x1d5ab367, 0xd25292db, 0x5633e910, 0x47136dd6, 0x618c9ad7, 0x0c7a37a1, 0x148e59f8, 0x3c89eb13, 0x27eecea9, 0xc935b761, 0xe5ede11c, 0xb13c7a47, 0xdf599cd2, 0x733f55f2, 0xce791814, 0x37bf73c7, 0xcdea53f7, 0xaa5b5ffd, 0x6f14df3d, 0xdb867844, 0xf381caaf, 0xc43eb968, 0x342c3824, 0x405fc2a3, 0xc372161d, 0x250cbce2, 0x498b283c, 0x9541ff0d, 0x017139a8, 0xb3de080c, 0xe49cd8b4, 0xc1906456, 0x84617bcb, 0xb670d532, 0x5c74486c, 0x5742d0b8];
    var T8 = [0xf4a75051, 0x4165537e, 0x17a4c31a, 0x275e963a, 0xab6bcb3b, 0x9d45f11f, 0xfa58abac, 0xe303934b, 0x30fa5520, 0x766df6ad, 0xcc769188, 0x024c25f5, 0xe5d7fc4f, 0x2acbd7c5, 0x35448026, 0x62a38fb5, 0xb15a49de, 0xba1b6725, 0xea0e9845, 0xfec0e15d, 0x2f7502c3, 0x4cf01281, 0x4697a38d, 0xd3f9c66b, 0x8f5fe703, 0x929c9515, 0x6d7aebbf, 0x5259da95, 0xbe832dd4, 0x7421d358, 0xe0692949, 0xc9c8448e, 0xc2896a75, 0x8e7978f4, 0x583e6b99, 0xb971dd27, 0xe14fb6be, 0x88ad17f0, 0x20ac66c9, 0xce3ab47d, 0xdf4a1863, 0x1a3182e5, 0x51336097, 0x537f4562, 0x6477e0b1, 0x6bae84bb, 0x81a01cfe, 0x082b94f9, 0x48685870, 0x45fd198f, 0xde6c8794, 0x7bf8b752, 0x73d323ab, 0x4b02e272, 0x1f8f57e3, 0x55ab2a66, 0xeb2807b2, 0xb5c2032f, 0xc57b9a86, 0x3708a5d3, 0x2887f230, 0xbfa5b223, 0x036aba02, 0x16825ced, 0xcf1c2b8a, 0x79b492a7, 0x07f2f0f3, 0x69e2a14e, 0xdaf4cd65, 0x05bed506, 0x34621fd1, 0xa6fe8ac4, 0x2e539d34, 0xf355a0a2, 0x8ae13205, 0xf6eb75a4, 0x83ec390b, 0x60efaa40, 0x719f065e, 0x6e1051bd, 0x218af93e, 0xdd063d96, 0x3e05aedd, 0xe6bd464d, 0x548db591, 0xc45d0571, 0x06d46f04, 0x5015ff60, 0x98fb2419, 0xbde997d6, 0x4043cc89, 0xd99e7767, 0xe842bdb0, 0x898b8807, 0x195b38e7, 0xc8eedb79, 0x7c0a47a1, 0x420fe97c, 0x841ec9f8, 0x00000000, 0x80868309, 0x2bed4832, 0x1170ac1e, 0x5a724e6c, 0x0efffbfd, 0x8538560f, 0xaed51e3d, 0x2d392736, 0x0fd9640a, 0x5ca62168, 0x5b54d19b, 0x362e3a24, 0x0a67b10c, 0x57e70f93, 0xee96d2b4, 0x9b919e1b, 0xc0c54f80, 0xdc20a261, 0x774b695a, 0x121a161c, 0x93ba0ae2, 0xa02ae5c0, 0x22e0433c, 0x1b171d12, 0x090d0b0e, 0x8bc7adf2, 0xb6a8b92d, 0x1ea9c814, 0xf1198557, 0x75074caf, 0x99ddbbee, 0x7f60fda3, 0x01269ff7, 0x72f5bc5c, 0x663bc544, 0xfb7e345b, 0x4329768b, 0x23c6dccb, 0xedfc68b6, 0xe4f163b8, 0x31dccad7, 0x63851042, 0x97224013, 0xc6112084, 0x4a247d85, 0xbb3df8d2, 0xf93211ae, 0x29a16dc7, 0x9e2f4b1d, 0xb230f3dc, 0x8652ec0d, 0xc1e3d077, 0xb3166c2b, 0x70b999a9, 0x9448fa11, 0xe9642247, 0xfc8cc4a8, 0xf03f1aa0, 0x7d2cd856, 0x3390ef22, 0x494ec787, 0x38d1c1d9, 0xcaa2fe8c, 0xd40b3698, 0xf581cfa6, 0x7ade28a5, 0xb78e26da, 0xadbfa43f, 0x3a9de42c, 0x78920d50, 0x5fcc9b6a, 0x7e466254, 0x8d13c2f6, 0xd8b8e890, 0x39f75e2e, 0xc3aff582, 0x5d80be9f, 0xd0937c69, 0xd52da96f, 0x2512b3cf, 0xac993bc8, 0x187da710, 0x9c636ee8, 0x3bbb7bdb, 0x267809cd, 0x5918f46e, 0x9ab701ec, 0x4f9aa883, 0x956e65e6, 0xffe67eaa, 0xbccf0821, 0x15e8e6ef, 0xe79bd9ba, 0x6f36ce4a, 0x9f09d4ea, 0xb07cd629, 0xa4b2af31, 0x3f23312a, 0xa59430c6, 0xa266c035, 0x4ebc3774, 0x82caa6fc, 0x90d0b0e0, 0xa7d81533, 0x04984af1, 0xecdaf741, 0xcd500e7f, 0x91f62f17, 0x4dd68d76, 0xefb04d43, 0xaa4d54cc, 0x9604dfe4, 0xd1b5e39e, 0x6a881b4c, 0x2c1fb8c1, 0x65517f46, 0x5eea049d, 0x8c355d01, 0x877473fa, 0x0b412efb, 0x671d5ab3, 0xdbd25292, 0x105633e9, 0xd647136d, 0xd7618c9a, 0xa10c7a37, 0xf8148e59, 0x133c89eb, 0xa927eece, 0x61c935b7, 0x1ce5ede1, 0x47b13c7a, 0xd2df599c, 0xf2733f55, 0x14ce7918, 0xc737bf73, 0xf7cdea53, 0xfdaa5b5f, 0x3d6f14df, 0x44db8678, 0xaff381ca, 0x68c43eb9, 0x24342c38, 0xa3405fc2, 0x1dc37216, 0xe2250cbc, 0x3c498b28, 0x0d9541ff, 0xa8017139, 0x0cb3de08, 0xb4e49cd8, 0x56c19064, 0xcb84617b, 0x32b670d5, 0x6c5c7448, 0xb85742d0];

    // Transformations for decryption key expansion
    var U1 = [0x00000000, 0x0e090d0b, 0x1c121a16, 0x121b171d, 0x3824342c, 0x362d3927, 0x24362e3a, 0x2a3f2331, 0x70486858, 0x7e416553, 0x6c5a724e, 0x62537f45, 0x486c5c74, 0x4665517f, 0x547e4662, 0x5a774b69, 0xe090d0b0, 0xee99ddbb, 0xfc82caa6, 0xf28bc7ad, 0xd8b4e49c, 0xd6bde997, 0xc4a6fe8a, 0xcaaff381, 0x90d8b8e8, 0x9ed1b5e3, 0x8ccaa2fe, 0x82c3aff5, 0xa8fc8cc4, 0xa6f581cf, 0xb4ee96d2, 0xbae79bd9, 0xdb3bbb7b, 0xd532b670, 0xc729a16d, 0xc920ac66, 0xe31f8f57, 0xed16825c, 0xff0d9541, 0xf104984a, 0xab73d323, 0xa57ade28, 0xb761c935, 0xb968c43e, 0x9357e70f, 0x9d5eea04, 0x8f45fd19, 0x814cf012, 0x3bab6bcb, 0x35a266c0, 0x27b971dd, 0x29b07cd6, 0x038f5fe7, 0x0d8652ec, 0x1f9d45f1, 0x119448fa, 0x4be30393, 0x45ea0e98, 0x57f11985, 0x59f8148e, 0x73c737bf, 0x7dce3ab4, 0x6fd52da9, 0x61dc20a2, 0xad766df6, 0xa37f60fd, 0xb16477e0, 0xbf6d7aeb, 0x955259da, 0x9b5b54d1, 0x894043cc, 0x87494ec7, 0xdd3e05ae, 0xd33708a5, 0xc12c1fb8, 0xcf2512b3, 0xe51a3182, 0xeb133c89, 0xf9082b94, 0xf701269f, 0x4de6bd46, 0x43efb04d, 0x51f4a750, 0x5ffdaa5b, 0x75c2896a, 0x7bcb8461, 0x69d0937c, 0x67d99e77, 0x3daed51e, 0x33a7d815, 0x21bccf08, 0x2fb5c203, 0x058ae132, 0x0b83ec39, 0x1998fb24, 0x1791f62f, 0x764dd68d, 0x7844db86, 0x6a5fcc9b, 0x6456c190, 0x4e69e2a1, 0x4060efaa, 0x527bf8b7, 0x5c72f5bc, 0x0605bed5, 0x080cb3de, 0x1a17a4c3, 0x141ea9c8, 0x3e218af9, 0x302887f2, 0x223390ef, 0x2c3a9de4, 0x96dd063d, 0x98d40b36, 0x8acf1c2b, 0x84c61120, 0xaef93211, 0xa0f03f1a, 0xb2eb2807, 0xbce2250c, 0xe6956e65, 0xe89c636e, 0xfa877473, 0xf48e7978, 0xdeb15a49, 0xd0b85742, 0xc2a3405f, 0xccaa4d54, 0x41ecdaf7, 0x4fe5d7fc, 0x5dfec0e1, 0x53f7cdea, 0x79c8eedb, 0x77c1e3d0, 0x65daf4cd, 0x6bd3f9c6, 0x31a4b2af, 0x3fadbfa4, 0x2db6a8b9, 0x23bfa5b2, 0x09808683, 0x07898b88, 0x15929c95, 0x1b9b919e, 0xa17c0a47, 0xaf75074c, 0xbd6e1051, 0xb3671d5a, 0x99583e6b, 0x97513360, 0x854a247d, 0x8b432976, 0xd134621f, 0xdf3d6f14, 0xcd267809, 0xc32f7502, 0xe9105633, 0xe7195b38, 0xf5024c25, 0xfb0b412e, 0x9ad7618c, 0x94de6c87, 0x86c57b9a, 0x88cc7691, 0xa2f355a0, 0xacfa58ab, 0xbee14fb6, 0xb0e842bd, 0xea9f09d4, 0xe49604df, 0xf68d13c2, 0xf8841ec9, 0xd2bb3df8, 0xdcb230f3, 0xcea927ee, 0xc0a02ae5, 0x7a47b13c, 0x744ebc37, 0x6655ab2a, 0x685ca621, 0x42638510, 0x4c6a881b, 0x5e719f06, 0x5078920d, 0x0a0fd964, 0x0406d46f, 0x161dc372, 0x1814ce79, 0x322bed48, 0x3c22e043, 0x2e39f75e, 0x2030fa55, 0xec9ab701, 0xe293ba0a, 0xf088ad17, 0xfe81a01c, 0xd4be832d, 0xdab78e26, 0xc8ac993b, 0xc6a59430, 0x9cd2df59, 0x92dbd252, 0x80c0c54f, 0x8ec9c844, 0xa4f6eb75, 0xaaffe67e, 0xb8e4f163, 0xb6edfc68, 0x0c0a67b1, 0x02036aba, 0x10187da7, 0x1e1170ac, 0x342e539d, 0x3a275e96, 0x283c498b, 0x26354480, 0x7c420fe9, 0x724b02e2, 0x605015ff, 0x6e5918f4, 0x44663bc5, 0x4a6f36ce, 0x587421d3, 0x567d2cd8, 0x37a10c7a, 0x39a80171, 0x2bb3166c, 0x25ba1b67, 0x0f853856, 0x018c355d, 0x13972240, 0x1d9e2f4b, 0x47e96422, 0x49e06929, 0x5bfb7e34, 0x55f2733f, 0x7fcd500e, 0x71c45d05, 0x63df4a18, 0x6dd64713, 0xd731dcca, 0xd938d1c1, 0xcb23c6dc, 0xc52acbd7, 0xef15e8e6, 0xe11ce5ed, 0xf307f2f0, 0xfd0efffb, 0xa779b492, 0xa970b999, 0xbb6bae84, 0xb562a38f, 0x9f5d80be, 0x91548db5, 0x834f9aa8, 0x8d4697a3];
    var U2 = [0x00000000, 0x0b0e090d, 0x161c121a, 0x1d121b17, 0x2c382434, 0x27362d39, 0x3a24362e, 0x312a3f23, 0x58704868, 0x537e4165, 0x4e6c5a72, 0x4562537f, 0x74486c5c, 0x7f466551, 0x62547e46, 0x695a774b, 0xb0e090d0, 0xbbee99dd, 0xa6fc82ca, 0xadf28bc7, 0x9cd8b4e4, 0x97d6bde9, 0x8ac4a6fe, 0x81caaff3, 0xe890d8b8, 0xe39ed1b5, 0xfe8ccaa2, 0xf582c3af, 0xc4a8fc8c, 0xcfa6f581, 0xd2b4ee96, 0xd9bae79b, 0x7bdb3bbb, 0x70d532b6, 0x6dc729a1, 0x66c920ac, 0x57e31f8f, 0x5ced1682, 0x41ff0d95, 0x4af10498, 0x23ab73d3, 0x28a57ade, 0x35b761c9, 0x3eb968c4, 0x0f9357e7, 0x049d5eea, 0x198f45fd, 0x12814cf0, 0xcb3bab6b, 0xc035a266, 0xdd27b971, 0xd629b07c, 0xe7038f5f, 0xec0d8652, 0xf11f9d45, 0xfa119448, 0x934be303, 0x9845ea0e, 0x8557f119, 0x8e59f814, 0xbf73c737, 0xb47dce3a, 0xa96fd52d, 0xa261dc20, 0xf6ad766d, 0xfda37f60, 0xe0b16477, 0xebbf6d7a, 0xda955259, 0xd19b5b54, 0xcc894043, 0xc787494e, 0xaedd3e05, 0xa5d33708, 0xb8c12c1f, 0xb3cf2512, 0x82e51a31, 0x89eb133c, 0x94f9082b, 0x9ff70126, 0x464de6bd, 0x4d43efb0, 0x5051f4a7, 0x5b5ffdaa, 0x6a75c289, 0x617bcb84, 0x7c69d093, 0x7767d99e, 0x1e3daed5, 0x1533a7d8, 0x0821bccf, 0x032fb5c2, 0x32058ae1, 0x390b83ec, 0x241998fb, 0x2f1791f6, 0x8d764dd6, 0x867844db, 0x9b6a5fcc, 0x906456c1, 0xa14e69e2, 0xaa4060ef, 0xb7527bf8, 0xbc5c72f5, 0xd50605be, 0xde080cb3, 0xc31a17a4, 0xc8141ea9, 0xf93e218a, 0xf2302887, 0xef223390, 0xe42c3a9d, 0x3d96dd06, 0x3698d40b, 0x2b8acf1c, 0x2084c611, 0x11aef932, 0x1aa0f03f, 0x07b2eb28, 0x0cbce225, 0x65e6956e, 0x6ee89c63, 0x73fa8774, 0x78f48e79, 0x49deb15a, 0x42d0b857, 0x5fc2a340, 0x54ccaa4d, 0xf741ecda, 0xfc4fe5d7, 0xe15dfec0, 0xea53f7cd, 0xdb79c8ee, 0xd077c1e3, 0xcd65daf4, 0xc66bd3f9, 0xaf31a4b2, 0xa43fadbf, 0xb92db6a8, 0xb223bfa5, 0x83098086, 0x8807898b, 0x9515929c, 0x9e1b9b91, 0x47a17c0a, 0x4caf7507, 0x51bd6e10, 0x5ab3671d, 0x6b99583e, 0x60975133, 0x7d854a24, 0x768b4329, 0x1fd13462, 0x14df3d6f, 0x09cd2678, 0x02c32f75, 0x33e91056, 0x38e7195b, 0x25f5024c, 0x2efb0b41, 0x8c9ad761, 0x8794de6c, 0x9a86c57b, 0x9188cc76, 0xa0a2f355, 0xabacfa58, 0xb6bee14f, 0xbdb0e842, 0xd4ea9f09, 0xdfe49604, 0xc2f68d13, 0xc9f8841e, 0xf8d2bb3d, 0xf3dcb230, 0xeecea927, 0xe5c0a02a, 0x3c7a47b1, 0x37744ebc, 0x2a6655ab, 0x21685ca6, 0x10426385, 0x1b4c6a88, 0x065e719f, 0x0d507892, 0x640a0fd9, 0x6f0406d4, 0x72161dc3, 0x791814ce, 0x48322bed, 0x433c22e0, 0x5e2e39f7, 0x552030fa, 0x01ec9ab7, 0x0ae293ba, 0x17f088ad, 0x1cfe81a0, 0x2dd4be83, 0x26dab78e, 0x3bc8ac99, 0x30c6a594, 0x599cd2df, 0x5292dbd2, 0x4f80c0c5, 0x448ec9c8, 0x75a4f6eb, 0x7eaaffe6, 0x63b8e4f1, 0x68b6edfc, 0xb10c0a67, 0xba02036a, 0xa710187d, 0xac1e1170, 0x9d342e53, 0x963a275e, 0x8b283c49, 0x80263544, 0xe97c420f, 0xe2724b02, 0xff605015, 0xf46e5918, 0xc544663b, 0xce4a6f36, 0xd3587421, 0xd8567d2c, 0x7a37a10c, 0x7139a801, 0x6c2bb316, 0x6725ba1b, 0x560f8538, 0x5d018c35, 0x40139722, 0x4b1d9e2f, 0x2247e964, 0x2949e069, 0x345bfb7e, 0x3f55f273, 0x0e7fcd50, 0x0571c45d, 0x1863df4a, 0x136dd647, 0xcad731dc, 0xc1d938d1, 0xdccb23c6, 0xd7c52acb, 0xe6ef15e8, 0xede11ce5, 0xf0f307f2, 0xfbfd0eff, 0x92a779b4, 0x99a970b9, 0x84bb6bae, 0x8fb562a3, 0xbe9f5d80, 0xb591548d, 0xa8834f9a, 0xa38d4697];
    var U3 = [0x00000000, 0x0d0b0e09, 0x1a161c12, 0x171d121b, 0x342c3824, 0x3927362d, 0x2e3a2436, 0x23312a3f, 0x68587048, 0x65537e41, 0x724e6c5a, 0x7f456253, 0x5c74486c, 0x517f4665, 0x4662547e, 0x4b695a77, 0xd0b0e090, 0xddbbee99, 0xcaa6fc82, 0xc7adf28b, 0xe49cd8b4, 0xe997d6bd, 0xfe8ac4a6, 0xf381caaf, 0xb8e890d8, 0xb5e39ed1, 0xa2fe8cca, 0xaff582c3, 0x8cc4a8fc, 0x81cfa6f5, 0x96d2b4ee, 0x9bd9bae7, 0xbb7bdb3b, 0xb670d532, 0xa16dc729, 0xac66c920, 0x8f57e31f, 0x825ced16, 0x9541ff0d, 0x984af104, 0xd323ab73, 0xde28a57a, 0xc935b761, 0xc43eb968, 0xe70f9357, 0xea049d5e, 0xfd198f45, 0xf012814c, 0x6bcb3bab, 0x66c035a2, 0x71dd27b9, 0x7cd629b0, 0x5fe7038f, 0x52ec0d86, 0x45f11f9d, 0x48fa1194, 0x03934be3, 0x0e9845ea, 0x198557f1, 0x148e59f8, 0x37bf73c7, 0x3ab47dce, 0x2da96fd5, 0x20a261dc, 0x6df6ad76, 0x60fda37f, 0x77e0b164, 0x7aebbf6d, 0x59da9552, 0x54d19b5b, 0x43cc8940, 0x4ec78749, 0x05aedd3e, 0x08a5d337, 0x1fb8c12c, 0x12b3cf25, 0x3182e51a, 0x3c89eb13, 0x2b94f908, 0x269ff701, 0xbd464de6, 0xb04d43ef, 0xa75051f4, 0xaa5b5ffd, 0x896a75c2, 0x84617bcb, 0x937c69d0, 0x9e7767d9, 0xd51e3dae, 0xd81533a7, 0xcf0821bc, 0xc2032fb5, 0xe132058a, 0xec390b83, 0xfb241998, 0xf62f1791, 0xd68d764d, 0xdb867844, 0xcc9b6a5f, 0xc1906456, 0xe2a14e69, 0xefaa4060, 0xf8b7527b, 0xf5bc5c72, 0xbed50605, 0xb3de080c, 0xa4c31a17, 0xa9c8141e, 0x8af93e21, 0x87f23028, 0x90ef2233, 0x9de42c3a, 0x063d96dd, 0x0b3698d4, 0x1c2b8acf, 0x112084c6, 0x3211aef9, 0x3f1aa0f0, 0x2807b2eb, 0x250cbce2, 0x6e65e695, 0x636ee89c, 0x7473fa87, 0x7978f48e, 0x5a49deb1, 0x5742d0b8, 0x405fc2a3, 0x4d54ccaa, 0xdaf741ec, 0xd7fc4fe5, 0xc0e15dfe, 0xcdea53f7, 0xeedb79c8, 0xe3d077c1, 0xf4cd65da, 0xf9c66bd3, 0xb2af31a4, 0xbfa43fad, 0xa8b92db6, 0xa5b223bf, 0x86830980, 0x8b880789, 0x9c951592, 0x919e1b9b, 0x0a47a17c, 0x074caf75, 0x1051bd6e, 0x1d5ab367, 0x3e6b9958, 0x33609751, 0x247d854a, 0x29768b43, 0x621fd134, 0x6f14df3d, 0x7809cd26, 0x7502c32f, 0x5633e910, 0x5b38e719, 0x4c25f502, 0x412efb0b, 0x618c9ad7, 0x6c8794de, 0x7b9a86c5, 0x769188cc, 0x55a0a2f3, 0x58abacfa, 0x4fb6bee1, 0x42bdb0e8, 0x09d4ea9f, 0x04dfe496, 0x13c2f68d, 0x1ec9f884, 0x3df8d2bb, 0x30f3dcb2, 0x27eecea9, 0x2ae5c0a0, 0xb13c7a47, 0xbc37744e, 0xab2a6655, 0xa621685c, 0x85104263, 0x881b4c6a, 0x9f065e71, 0x920d5078, 0xd9640a0f, 0xd46f0406, 0xc372161d, 0xce791814, 0xed48322b, 0xe0433c22, 0xf75e2e39, 0xfa552030, 0xb701ec9a, 0xba0ae293, 0xad17f088, 0xa01cfe81, 0x832dd4be, 0x8e26dab7, 0x993bc8ac, 0x9430c6a5, 0xdf599cd2, 0xd25292db, 0xc54f80c0, 0xc8448ec9, 0xeb75a4f6, 0xe67eaaff, 0xf163b8e4, 0xfc68b6ed, 0x67b10c0a, 0x6aba0203, 0x7da71018, 0x70ac1e11, 0x539d342e, 0x5e963a27, 0x498b283c, 0x44802635, 0x0fe97c42, 0x02e2724b, 0x15ff6050, 0x18f46e59, 0x3bc54466, 0x36ce4a6f, 0x21d35874, 0x2cd8567d, 0x0c7a37a1, 0x017139a8, 0x166c2bb3, 0x1b6725ba, 0x38560f85, 0x355d018c, 0x22401397, 0x2f4b1d9e, 0x642247e9, 0x692949e0, 0x7e345bfb, 0x733f55f2, 0x500e7fcd, 0x5d0571c4, 0x4a1863df, 0x47136dd6, 0xdccad731, 0xd1c1d938, 0xc6dccb23, 0xcbd7c52a, 0xe8e6ef15, 0xe5ede11c, 0xf2f0f307, 0xfffbfd0e, 0xb492a779, 0xb999a970, 0xae84bb6b, 0xa38fb562, 0x80be9f5d, 0x8db59154, 0x9aa8834f, 0x97a38d46];
    var U4 = [0x00000000, 0x090d0b0e, 0x121a161c, 0x1b171d12, 0x24342c38, 0x2d392736, 0x362e3a24, 0x3f23312a, 0x48685870, 0x4165537e, 0x5a724e6c, 0x537f4562, 0x6c5c7448, 0x65517f46, 0x7e466254, 0x774b695a, 0x90d0b0e0, 0x99ddbbee, 0x82caa6fc, 0x8bc7adf2, 0xb4e49cd8, 0xbde997d6, 0xa6fe8ac4, 0xaff381ca, 0xd8b8e890, 0xd1b5e39e, 0xcaa2fe8c, 0xc3aff582, 0xfc8cc4a8, 0xf581cfa6, 0xee96d2b4, 0xe79bd9ba, 0x3bbb7bdb, 0x32b670d5, 0x29a16dc7, 0x20ac66c9, 0x1f8f57e3, 0x16825ced, 0x0d9541ff, 0x04984af1, 0x73d323ab, 0x7ade28a5, 0x61c935b7, 0x68c43eb9, 0x57e70f93, 0x5eea049d, 0x45fd198f, 0x4cf01281, 0xab6bcb3b, 0xa266c035, 0xb971dd27, 0xb07cd629, 0x8f5fe703, 0x8652ec0d, 0x9d45f11f, 0x9448fa11, 0xe303934b, 0xea0e9845, 0xf1198557, 0xf8148e59, 0xc737bf73, 0xce3ab47d, 0xd52da96f, 0xdc20a261, 0x766df6ad, 0x7f60fda3, 0x6477e0b1, 0x6d7aebbf, 0x5259da95, 0x5b54d19b, 0x4043cc89, 0x494ec787, 0x3e05aedd, 0x3708a5d3, 0x2c1fb8c1, 0x2512b3cf, 0x1a3182e5, 0x133c89eb, 0x082b94f9, 0x01269ff7, 0xe6bd464d, 0xefb04d43, 0xf4a75051, 0xfdaa5b5f, 0xc2896a75, 0xcb84617b, 0xd0937c69, 0xd99e7767, 0xaed51e3d, 0xa7d81533, 0xbccf0821, 0xb5c2032f, 0x8ae13205, 0x83ec390b, 0x98fb2419, 0x91f62f17, 0x4dd68d76, 0x44db8678, 0x5fcc9b6a, 0x56c19064, 0x69e2a14e, 0x60efaa40, 0x7bf8b752, 0x72f5bc5c, 0x05bed506, 0x0cb3de08, 0x17a4c31a, 0x1ea9c814, 0x218af93e, 0x2887f230, 0x3390ef22, 0x3a9de42c, 0xdd063d96, 0xd40b3698, 0xcf1c2b8a, 0xc6112084, 0xf93211ae, 0xf03f1aa0, 0xeb2807b2, 0xe2250cbc, 0x956e65e6, 0x9c636ee8, 0x877473fa, 0x8e7978f4, 0xb15a49de, 0xb85742d0, 0xa3405fc2, 0xaa4d54cc, 0xecdaf741, 0xe5d7fc4f, 0xfec0e15d, 0xf7cdea53, 0xc8eedb79, 0xc1e3d077, 0xdaf4cd65, 0xd3f9c66b, 0xa4b2af31, 0xadbfa43f, 0xb6a8b92d, 0xbfa5b223, 0x80868309, 0x898b8807, 0x929c9515, 0x9b919e1b, 0x7c0a47a1, 0x75074caf, 0x6e1051bd, 0x671d5ab3, 0x583e6b99, 0x51336097, 0x4a247d85, 0x4329768b, 0x34621fd1, 0x3d6f14df, 0x267809cd, 0x2f7502c3, 0x105633e9, 0x195b38e7, 0x024c25f5, 0x0b412efb, 0xd7618c9a, 0xde6c8794, 0xc57b9a86, 0xcc769188, 0xf355a0a2, 0xfa58abac, 0xe14fb6be, 0xe842bdb0, 0x9f09d4ea, 0x9604dfe4, 0x8d13c2f6, 0x841ec9f8, 0xbb3df8d2, 0xb230f3dc, 0xa927eece, 0xa02ae5c0, 0x47b13c7a, 0x4ebc3774, 0x55ab2a66, 0x5ca62168, 0x63851042, 0x6a881b4c, 0x719f065e, 0x78920d50, 0x0fd9640a, 0x06d46f04, 0x1dc37216, 0x14ce7918, 0x2bed4832, 0x22e0433c, 0x39f75e2e, 0x30fa5520, 0x9ab701ec, 0x93ba0ae2, 0x88ad17f0, 0x81a01cfe, 0xbe832dd4, 0xb78e26da, 0xac993bc8, 0xa59430c6, 0xd2df599c, 0xdbd25292, 0xc0c54f80, 0xc9c8448e, 0xf6eb75a4, 0xffe67eaa, 0xe4f163b8, 0xedfc68b6, 0x0a67b10c, 0x036aba02, 0x187da710, 0x1170ac1e, 0x2e539d34, 0x275e963a, 0x3c498b28, 0x35448026, 0x420fe97c, 0x4b02e272, 0x5015ff60, 0x5918f46e, 0x663bc544, 0x6f36ce4a, 0x7421d358, 0x7d2cd856, 0xa10c7a37, 0xa8017139, 0xb3166c2b, 0xba1b6725, 0x8538560f, 0x8c355d01, 0x97224013, 0x9e2f4b1d, 0xe9642247, 0xe0692949, 0xfb7e345b, 0xf2733f55, 0xcd500e7f, 0xc45d0571, 0xdf4a1863, 0xd647136d, 0x31dccad7, 0x38d1c1d9, 0x23c6dccb, 0x2acbd7c5, 0x15e8e6ef, 0x1ce5ede1, 0x07f2f0f3, 0x0efffbfd, 0x79b492a7, 0x70b999a9, 0x6bae84bb, 0x62a38fb5, 0x5d80be9f, 0x548db591, 0x4f9aa883, 0x4697a38d];

    function convertToInt32(bytes) {
        var result = [];
        for (var i = 0; i < bytes.length; i += 4) {
            result.push(
                (bytes[i    ] << 24) |
                (bytes[i + 1] << 16) |
                (bytes[i + 2] <<  8) |
                 bytes[i + 3]
            );
        }
        return result;
    }

    var AES = function(key) {
        if (!(this instanceof AES)) {
            throw Error('AES must be instanitated with `new`');
        }

        Object.defineProperty(this, 'key', {
            value: coerceArray(key, true)
        });

        this._prepare();
    }


    AES.prototype._prepare = function() {

        var rounds = numberOfRounds[this.key.length];
        if (rounds == null) {
            throw new Error('invalid key size (must be 16, 24 or 32 bytes)');
        }

        // encryption round keys
        this._Ke = [];

        // decryption round keys
        this._Kd = [];

        for (var i = 0; i <= rounds; i++) {
            this._Ke.push([0, 0, 0, 0]);
            this._Kd.push([0, 0, 0, 0]);
        }

        var roundKeyCount = (rounds + 1) * 4;
        var KC = this.key.length / 4;

        // convert the key into ints
        var tk = convertToInt32(this.key);

        // copy values into round key arrays
        var index;
        for (var i = 0; i < KC; i++) {
            index = i >> 2;
            this._Ke[index][i % 4] = tk[i];
            this._Kd[rounds - index][i % 4] = tk[i];
        }

        // key expansion (fips-197 section 5.2)
        var rconpointer = 0;
        var t = KC, tt;
        while (t < roundKeyCount) {
            tt = tk[KC - 1];
            tk[0] ^= ((S[(tt >> 16) & 0xFF] << 24) ^
                      (S[(tt >>  8) & 0xFF] << 16) ^
                      (S[ tt        & 0xFF] <<  8) ^
                       S[(tt >> 24) & 0xFF]        ^
                      (rcon[rconpointer] << 24));
            rconpointer += 1;

            // key expansion (for non-256 bit)
            if (KC != 8) {
                for (var i = 1; i < KC; i++) {
                    tk[i] ^= tk[i - 1];
                }

            // key expansion for 256-bit keys is "slightly different" (fips-197)
            } else {
                for (var i = 1; i < (KC / 2); i++) {
                    tk[i] ^= tk[i - 1];
                }
                tt = tk[(KC / 2) - 1];

                tk[KC / 2] ^= (S[ tt        & 0xFF]        ^
                              (S[(tt >>  8) & 0xFF] <<  8) ^
                              (S[(tt >> 16) & 0xFF] << 16) ^
                              (S[(tt >> 24) & 0xFF] << 24));

                for (var i = (KC / 2) + 1; i < KC; i++) {
                    tk[i] ^= tk[i - 1];
                }
            }

            // copy values into round key arrays
            var i = 0, r, c;
            while (i < KC && t < roundKeyCount) {
                r = t >> 2;
                c = t % 4;
                this._Ke[r][c] = tk[i];
                this._Kd[rounds - r][c] = tk[i++];
                t++;
            }
        }

        // inverse-cipher-ify the decryption round key (fips-197 section 5.3)
        for (var r = 1; r < rounds; r++) {
            for (var c = 0; c < 4; c++) {
                tt = this._Kd[r][c];
                this._Kd[r][c] = (U1[(tt >> 24) & 0xFF] ^
                                  U2[(tt >> 16) & 0xFF] ^
                                  U3[(tt >>  8) & 0xFF] ^
                                  U4[ tt        & 0xFF]);
            }
        }
    }

    AES.prototype.encrypt = function(plaintext) {
        if (plaintext.length != 16) {
            throw new Error('invalid plaintext size (must be 16 bytes)');
        }

        var rounds = this._Ke.length - 1;
        var a = [0, 0, 0, 0];

        // convert plaintext to (ints ^ key)
        var t = convertToInt32(plaintext);
        for (var i = 0; i < 4; i++) {
            t[i] ^= this._Ke[0][i];
        }

        // apply round transforms
        for (var r = 1; r < rounds; r++) {
            for (var i = 0; i < 4; i++) {
                a[i] = (T1[(t[ i         ] >> 24) & 0xff] ^
                        T2[(t[(i + 1) % 4] >> 16) & 0xff] ^
                        T3[(t[(i + 2) % 4] >>  8) & 0xff] ^
                        T4[ t[(i + 3) % 4]        & 0xff] ^
                        this._Ke[r][i]);
            }
            t = a.slice();
        }

        // the last round is special
        var result = createArray(16), tt;
        for (var i = 0; i < 4; i++) {
            tt = this._Ke[rounds][i];
            result[4 * i    ] = (S[(t[ i         ] >> 24) & 0xff] ^ (tt >> 24)) & 0xff;
            result[4 * i + 1] = (S[(t[(i + 1) % 4] >> 16) & 0xff] ^ (tt >> 16)) & 0xff;
            result[4 * i + 2] = (S[(t[(i + 2) % 4] >>  8) & 0xff] ^ (tt >>  8)) & 0xff;
            result[4 * i + 3] = (S[ t[(i + 3) % 4]        & 0xff] ^  tt       ) & 0xff;
        }

        return result;
    }

    AES.prototype.decrypt = function(ciphertext) {
        if (ciphertext.length != 16) {
            throw new Error('invalid ciphertext size (must be 16 bytes)');
        }

        var rounds = this._Kd.length - 1;
        var a = [0, 0, 0, 0];

        // convert plaintext to (ints ^ key)
        var t = convertToInt32(ciphertext);
        for (var i = 0; i < 4; i++) {
            t[i] ^= this._Kd[0][i];
        }

        // apply round transforms
        for (var r = 1; r < rounds; r++) {
            for (var i = 0; i < 4; i++) {
                a[i] = (T5[(t[ i          ] >> 24) & 0xff] ^
                        T6[(t[(i + 3) % 4] >> 16) & 0xff] ^
                        T7[(t[(i + 2) % 4] >>  8) & 0xff] ^
                        T8[ t[(i + 1) % 4]        & 0xff] ^
                        this._Kd[r][i]);
            }
            t = a.slice();
        }

        // the last round is special
        var result = createArray(16), tt;
        for (var i = 0; i < 4; i++) {
            tt = this._Kd[rounds][i];
            result[4 * i    ] = (Si[(t[ i         ] >> 24) & 0xff] ^ (tt >> 24)) & 0xff;
            result[4 * i + 1] = (Si[(t[(i + 3) % 4] >> 16) & 0xff] ^ (tt >> 16)) & 0xff;
            result[4 * i + 2] = (Si[(t[(i + 2) % 4] >>  8) & 0xff] ^ (tt >>  8)) & 0xff;
            result[4 * i + 3] = (Si[ t[(i + 1) % 4]        & 0xff] ^  tt       ) & 0xff;
        }

        return result;
    }


    /**
     *  Mode Of Operation - Electonic Codebook (ECB)
     */
    var ModeOfOperationECB = function(key) {
        if (!(this instanceof ModeOfOperationECB)) {
            throw Error('AES must be instanitated with `new`');
        }

        this.description = "Electronic Code Block";
        this.name = "ecb";

        this._aes = new AES(key);
    }

    ModeOfOperationECB.prototype.encrypt = function(plaintext) {
        plaintext = coerceArray(plaintext);

        if ((plaintext.length % 16) !== 0) {
            throw new Error('invalid plaintext size (must be multiple of 16 bytes)');
        }

        var ciphertext = createArray(plaintext.length);
        var block = createArray(16);

        for (var i = 0; i < plaintext.length; i += 16) {
            copyArray(plaintext, block, 0, i, i + 16);
            block = this._aes.encrypt(block);
            copyArray(block, ciphertext, i);
        }

        return ciphertext;
    }

    ModeOfOperationECB.prototype.decrypt = function(ciphertext) {
        ciphertext = coerceArray(ciphertext);

        if ((ciphertext.length % 16) !== 0) {
            throw new Error('invalid ciphertext size (must be multiple of 16 bytes)');
        }

        var plaintext = createArray(ciphertext.length);
        var block = createArray(16);

        for (var i = 0; i < ciphertext.length; i += 16) {
            copyArray(ciphertext, block, 0, i, i + 16);
            block = this._aes.decrypt(block);
            copyArray(block, plaintext, i);
        }

        return plaintext;
    }


    /**
     *  Mode Of Operation - Cipher Block Chaining (CBC)
     */
    var ModeOfOperationCBC = function(key, iv) {
        if (!(this instanceof ModeOfOperationCBC)) {
            throw Error('AES must be instanitated with `new`');
        }

        this.description = "Cipher Block Chaining";
        this.name = "cbc";

        if (!iv) {
            iv = createArray(16);

        } else if (iv.length != 16) {
            throw new Error('invalid initialation vector size (must be 16 bytes)');
        }

        this._lastCipherblock = coerceArray(iv, true);

        this._aes = new AES(key);
    }

    ModeOfOperationCBC.prototype.encrypt = function(plaintext) {
        plaintext = coerceArray(plaintext);

        if ((plaintext.length % 16) !== 0) {
            throw new Error('invalid plaintext size (must be multiple of 16 bytes)');
        }

        var ciphertext = createArray(plaintext.length);
        var block = createArray(16);

        for (var i = 0; i < plaintext.length; i += 16) {
            copyArray(plaintext, block, 0, i, i + 16);

            for (var j = 0; j < 16; j++) {
                block[j] ^= this._lastCipherblock[j];
            }

            this._lastCipherblock = this._aes.encrypt(block);
            copyArray(this._lastCipherblock, ciphertext, i);
        }

        return ciphertext;
    }

    ModeOfOperationCBC.prototype.decrypt = function(ciphertext) {
        ciphertext = coerceArray(ciphertext);

        if ((ciphertext.length % 16) !== 0) {
            throw new Error('invalid ciphertext size (must be multiple of 16 bytes)');
        }

        var plaintext = createArray(ciphertext.length);
        var block = createArray(16);

        for (var i = 0; i < ciphertext.length; i += 16) {
            copyArray(ciphertext, block, 0, i, i + 16);
            block = this._aes.decrypt(block);

            for (var j = 0; j < 16; j++) {
                plaintext[i + j] = block[j] ^ this._lastCipherblock[j];
            }

            copyArray(ciphertext, this._lastCipherblock, 0, i, i + 16);
        }

        return plaintext;
    }


    /**
     *  Mode Of Operation - Cipher Feedback (CFB)
     */
    var ModeOfOperationCFB = function(key, iv, segmentSize) {
        if (!(this instanceof ModeOfOperationCFB)) {
            throw Error('AES must be instanitated with `new`');
        }

        this.description = "Cipher Feedback";
        this.name = "cfb";

        if (!iv) {
            iv = createArray(16);

        } else if (iv.length != 16) {
            throw new Error('invalid initialation vector size (must be 16 size)');
        }

        if (!segmentSize) { segmentSize = 1; }

        this.segmentSize = segmentSize;

        this._shiftRegister = coerceArray(iv, true);

        this._aes = new AES(key);
    }

    ModeOfOperationCFB.prototype.encrypt = function(plaintext) {
        if ((plaintext.length % this.segmentSize) != 0) {
            throw new Error('invalid plaintext size (must be segmentSize bytes)');
        }

        var encrypted = coerceArray(plaintext, true);

        var xorSegment;
        for (var i = 0; i < encrypted.length; i += this.segmentSize) {
            xorSegment = this._aes.encrypt(this._shiftRegister);
            for (var j = 0; j < this.segmentSize; j++) {
                encrypted[i + j] ^= xorSegment[j];
            }

            // Shift the register
            copyArray(this._shiftRegister, this._shiftRegister, 0, this.segmentSize);
            copyArray(encrypted, this._shiftRegister, 16 - this.segmentSize, i, i + this.segmentSize);
        }

        return encrypted;
    }

    ModeOfOperationCFB.prototype.decrypt = function(ciphertext) {
        if ((ciphertext.length % this.segmentSize) != 0) {
            throw new Error('invalid ciphertext size (must be segmentSize bytes)');
        }

        var plaintext = coerceArray(ciphertext, true);

        var xorSegment;
        for (var i = 0; i < plaintext.length; i += this.segmentSize) {
            xorSegment = this._aes.encrypt(this._shiftRegister);

            for (var j = 0; j < this.segmentSize; j++) {
                plaintext[i + j] ^= xorSegment[j];
            }

            // Shift the register
            copyArray(this._shiftRegister, this._shiftRegister, 0, this.segmentSize);
            copyArray(ciphertext, this._shiftRegister, 16 - this.segmentSize, i, i + this.segmentSize);
        }

        return plaintext;
    }

    /**
     *  Mode Of Operation - Output Feedback (OFB)
     */
    var ModeOfOperationOFB = function(key, iv) {
        if (!(this instanceof ModeOfOperationOFB)) {
            throw Error('AES must be instanitated with `new`');
        }

        this.description = "Output Feedback";
        this.name = "ofb";

        if (!iv) {
            iv = createArray(16);

        } else if (iv.length != 16) {
            throw new Error('invalid initialation vector size (must be 16 bytes)');
        }

        this._lastPrecipher = coerceArray(iv, true);
        this._lastPrecipherIndex = 16;

        this._aes = new AES(key);
    }

    ModeOfOperationOFB.prototype.encrypt = function(plaintext) {
        var encrypted = coerceArray(plaintext, true);

        for (var i = 0; i < encrypted.length; i++) {
            if (this._lastPrecipherIndex === 16) {
                this._lastPrecipher = this._aes.encrypt(this._lastPrecipher);
                this._lastPrecipherIndex = 0;
            }
            encrypted[i] ^= this._lastPrecipher[this._lastPrecipherIndex++];
        }

        return encrypted;
    }

    // Decryption is symetric
    ModeOfOperationOFB.prototype.decrypt = ModeOfOperationOFB.prototype.encrypt;


    /**
     *  Counter object for CTR common mode of operation
     */
    var Counter = function(initialValue) {
        if (!(this instanceof Counter)) {
            throw Error('Counter must be instanitated with `new`');
        }

        // We allow 0, but anything false-ish uses the default 1
        if (initialValue !== 0 && !initialValue) { initialValue = 1; }

        if (typeof(initialValue) === 'number') {
            this._counter = createArray(16);
            this.setValue(initialValue);

        } else {
            this.setBytes(initialValue);
        }
    }

    Counter.prototype.setValue = function(value) {
        if (typeof(value) !== 'number' || parseInt(value) != value) {
            throw new Error('invalid counter value (must be an integer)');
        }

        for (var index = 15; index >= 0; --index) {
            this._counter[index] = value % 256;
            value = value >> 8;
        }
    }

    Counter.prototype.setBytes = function(bytes) {
        bytes = coerceArray(bytes, true);

        if (bytes.length != 16) {
            throw new Error('invalid counter bytes size (must be 16 bytes)');
        }

        this._counter = bytes;
    };

    Counter.prototype.increment = function() {
        for (var i = 15; i >= 0; i--) {
            if (this._counter[i] === 255) {
                this._counter[i] = 0;
            } else {
                this._counter[i]++;
                break;
            }
        }
    }


    /**
     *  Mode Of Operation - Counter (CTR)
     */
    var ModeOfOperationCTR = function(key, counter) {
        if (!(this instanceof ModeOfOperationCTR)) {
            throw Error('AES must be instanitated with `new`');
        }

        this.description = "Counter";
        this.name = "ctr";

        if (!(counter instanceof Counter)) {
            counter = new Counter(counter)
        }

        this._counter = counter;

        this._remainingCounter = null;
        this._remainingCounterIndex = 16;

        this._aes = new AES(key);
    }

    ModeOfOperationCTR.prototype.encrypt = function(plaintext) {
        var encrypted = coerceArray(plaintext, true);

        for (var i = 0; i < encrypted.length; i++) {
            if (this._remainingCounterIndex === 16) {
                this._remainingCounter = this._aes.encrypt(this._counter._counter);
                this._remainingCounterIndex = 0;
                this._counter.increment();
            }
            encrypted[i] ^= this._remainingCounter[this._remainingCounterIndex++];
        }

        return encrypted;
    }

    // Decryption is symetric
    ModeOfOperationCTR.prototype.decrypt = ModeOfOperationCTR.prototype.encrypt;


    ///////////////////////
    // Padding

    // See:https://tools.ietf.org/html/rfc2315
    function pkcs7pad(data) {
        data = coerceArray(data, true);
        var padder = 16 - (data.length % 16);
        var result = createArray(data.length + padder);
        copyArray(data, result);
        for (var i = data.length; i < result.length; i++) {
            result[i] = padder;
        }
        return result;
    }

    function pkcs7strip(data) {
        data = coerceArray(data, true);
        if (data.length < 16) { throw new Error('PKCS#7 invalid length'); }

        var padder = data[data.length - 1];
        if (padder > 16) { throw new Error('PKCS#7 padding byte out of range'); }

        var length = data.length - padder;
        for (var i = 0; i < padder; i++) {
            if (data[length + i] !== padder) {
                throw new Error('PKCS#7 invalid padding byte');
            }
        }

        var result = createArray(length);
        copyArray(data, result, 0, 0, length);
        return result;
    }

    ///////////////////////
    // Exporting


    // The block cipher
    var aesjs = {
        AES: AES,
        Counter: Counter,

        ModeOfOperation: {
            ecb: ModeOfOperationECB,
            cbc: ModeOfOperationCBC,
            cfb: ModeOfOperationCFB,
            ofb: ModeOfOperationOFB,
            ctr: ModeOfOperationCTR
        },

        utils: {
            hex: convertHex,
            utf8: convertUtf8
        },

        padding: {
            pkcs7: {
                pad: pkcs7pad,
                strip: pkcs7strip
            }
        },

        _arrayTest: {
            coerceArray: coerceArray,
            createArray: createArray,
            copyArray: copyArray,
        }
    };


    // node.js
    if (true) {
        module.exports = aesjs

    // RequireJS/AMD
    // http://www.requirejs.org/docs/api.html
    // https://github.com/amdjs/amdjs-api/wiki/AMD
    } else {}


})(this);


/***/ }),

/***/ 203:
/***/ ((module) => {


var ALPHABET = 'qpzry9x8gf2tvdw0s3jn54khce6mua7l'

// pre-compute lookup table
var ALPHABET_MAP = {}
for (var z = 0; z < ALPHABET.length; z++) {
  var x = ALPHABET.charAt(z)

  if (ALPHABET_MAP[x] !== undefined) throw new TypeError(x + ' is ambiguous')
  ALPHABET_MAP[x] = z
}

function polymodStep (pre) {
  var b = pre >> 25
  return ((pre & 0x1FFFFFF) << 5) ^
    (-((b >> 0) & 1) & 0x3b6a57b2) ^
    (-((b >> 1) & 1) & 0x26508e6d) ^
    (-((b >> 2) & 1) & 0x1ea119fa) ^
    (-((b >> 3) & 1) & 0x3d4233dd) ^
    (-((b >> 4) & 1) & 0x2a1462b3)
}

function prefixChk (prefix) {
  var chk = 1
  for (var i = 0; i < prefix.length; ++i) {
    var c = prefix.charCodeAt(i)
    if (c < 33 || c > 126) return 'Invalid prefix (' + prefix + ')'

    chk = polymodStep(chk) ^ (c >> 5)
  }
  chk = polymodStep(chk)

  for (i = 0; i < prefix.length; ++i) {
    var v = prefix.charCodeAt(i)
    chk = polymodStep(chk) ^ (v & 0x1f)
  }
  return chk
}

function encode (prefix, words, LIMIT) {
  LIMIT = LIMIT || 90
  if ((prefix.length + 7 + words.length) > LIMIT) throw new TypeError('Exceeds length limit')

  prefix = prefix.toLowerCase()

  // determine chk mod
  var chk = prefixChk(prefix)
  if (typeof chk === 'string') throw new Error(chk)

  var result = prefix + '1'
  for (var i = 0; i < words.length; ++i) {
    var x = words[i]
    if ((x >> 5) !== 0) throw new Error('Non 5-bit word')

    chk = polymodStep(chk) ^ x
    result += ALPHABET.charAt(x)
  }

  for (i = 0; i < 6; ++i) {
    chk = polymodStep(chk)
  }
  chk ^= 1

  for (i = 0; i < 6; ++i) {
    var v = (chk >> ((5 - i) * 5)) & 0x1f
    result += ALPHABET.charAt(v)
  }

  return result
}

function __decode (str, LIMIT) {
  LIMIT = LIMIT || 90
  if (str.length < 8) return str + ' too short'
  if (str.length > LIMIT) return 'Exceeds length limit'

  // don't allow mixed case
  var lowered = str.toLowerCase()
  var uppered = str.toUpperCase()
  if (str !== lowered && str !== uppered) return 'Mixed-case string ' + str
  str = lowered

  var split = str.lastIndexOf('1')
  if (split === -1) return 'No separator character for ' + str
  if (split === 0) return 'Missing prefix for ' + str

  var prefix = str.slice(0, split)
  var wordChars = str.slice(split + 1)
  if (wordChars.length < 6) return 'Data too short'

  var chk = prefixChk(prefix)
  if (typeof chk === 'string') return chk

  var words = []
  for (var i = 0; i < wordChars.length; ++i) {
    var c = wordChars.charAt(i)
    var v = ALPHABET_MAP[c]
    if (v === undefined) return 'Unknown character ' + c
    chk = polymodStep(chk) ^ v

    // not in the checksum?
    if (i + 6 >= wordChars.length) continue
    words.push(v)
  }

  if (chk !== 1) return 'Invalid checksum for ' + str
  return { prefix: prefix, words: words }
}

function decodeUnsafe () {
  var res = __decode.apply(null, arguments)
  if (typeof res === 'object') return res
}

function decode (str) {
  var res = __decode.apply(null, arguments)
  if (typeof res === 'object') return res

  throw new Error(res)
}

function convert (data, inBits, outBits, pad) {
  var value = 0
  var bits = 0
  var maxV = (1 << outBits) - 1

  var result = []
  for (var i = 0; i < data.length; ++i) {
    value = (value << inBits) | data[i]
    bits += inBits

    while (bits >= outBits) {
      bits -= outBits
      result.push((value >> bits) & maxV)
    }
  }

  if (pad) {
    if (bits > 0) {
      result.push((value << (outBits - bits)) & maxV)
    }
  } else {
    if (bits >= inBits) return 'Excess padding'
    if ((value << (outBits - bits)) & maxV) return 'Non-zero padding'
  }

  return result
}

function toWordsUnsafe (bytes) {
  var res = convert(bytes, 8, 5, true)
  if (Array.isArray(res)) return res
}

function toWords (bytes) {
  var res = convert(bytes, 8, 5, true)
  if (Array.isArray(res)) return res

  throw new Error(res)
}

function fromWordsUnsafe (words) {
  var res = convert(words, 5, 8, false)
  if (Array.isArray(res)) return res
}

function fromWords (words) {
  var res = convert(words, 5, 8, false)
  if (Array.isArray(res)) return res

  throw new Error(res)
}

module.exports = {
  decodeUnsafe: decodeUnsafe,
  decode: decode,
  encode: encode,
  toWordsUnsafe: toWordsUnsafe,
  toWords: toWords,
  fromWordsUnsafe: fromWordsUnsafe,
  fromWords: fromWords
}


/***/ }),

/***/ 98:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
(function (module, exports) {
  'use strict';

  // Utils
  function assert (val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  // Could use `inherits` module, but don't want to move from single file
  // architecture yet.
  function inherits (ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  }

  // BN

  function BN (number, base, endian) {
    if (BN.isBN(number)) {
      return number;
    }

    this.negative = 0;
    this.words = null;
    this.length = 0;

    // Reduction context
    this.red = null;

    if (number !== null) {
      if (base === 'le' || base === 'be') {
        endian = base;
        base = 10;
      }

      this._init(number || 0, base || 10, endian || 'be');
    }
  }
  if (typeof module === 'object') {
    module.exports = BN;
  } else {
    exports.BN = BN;
  }

  BN.BN = BN;
  BN.wordSize = 26;

  var Buffer;
  try {
    if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') {
      Buffer = window.Buffer;
    } else {
      Buffer = (__webpack_require__(391).Buffer);
    }
  } catch (e) {
  }

  BN.isBN = function isBN (num) {
    if (num instanceof BN) {
      return true;
    }

    return num !== null && typeof num === 'object' &&
      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  };

  BN.max = function max (left, right) {
    if (left.cmp(right) > 0) return left;
    return right;
  };

  BN.min = function min (left, right) {
    if (left.cmp(right) < 0) return left;
    return right;
  };

  BN.prototype._init = function init (number, base, endian) {
    if (typeof number === 'number') {
      return this._initNumber(number, base, endian);
    }

    if (typeof number === 'object') {
      return this._initArray(number, base, endian);
    }

    if (base === 'hex') {
      base = 16;
    }
    assert(base === (base | 0) && base >= 2 && base <= 36);

    number = number.toString().replace(/\s+/g, '');
    var start = 0;
    if (number[0] === '-') {
      start++;
      this.negative = 1;
    }

    if (start < number.length) {
      if (base === 16) {
        this._parseHex(number, start, endian);
      } else {
        this._parseBase(number, base, start);
        if (endian === 'le') {
          this._initArray(this.toArray(), base, endian);
        }
      }
    }
  };

  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    if (number < 0) {
      this.negative = 1;
      number = -number;
    }
    if (number < 0x4000000) {
      this.words = [number & 0x3ffffff];
      this.length = 1;
    } else if (number < 0x10000000000000) {
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff
      ];
      this.length = 2;
    } else {
      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff,
        1
      ];
      this.length = 3;
    }

    if (endian !== 'le') return;

    // Reverse the bytes
    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initArray = function _initArray (number, base, endian) {
    // Perhaps a Uint8Array
    assert(typeof number.length === 'number');
    if (number.length <= 0) {
      this.words = [0];
      this.length = 1;
      return this;
    }

    this.length = Math.ceil(number.length / 3);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    var off = 0;
    if (endian === 'be') {
      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    } else if (endian === 'le') {
      for (i = 0, j = 0; i < number.length; i += 3) {
        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    }
    return this._strip();
  };

  function parseHex4Bits (string, index) {
    var c = string.charCodeAt(index);
    // '0' - '9'
    if (c >= 48 && c <= 57) {
      return c - 48;
    // 'A' - 'F'
    } else if (c >= 65 && c <= 70) {
      return c - 55;
    // 'a' - 'f'
    } else if (c >= 97 && c <= 102) {
      return c - 87;
    } else {
      assert(false, 'Invalid character in ' + string);
    }
  }

  function parseHexByte (string, lowerBound, index) {
    var r = parseHex4Bits(string, index);
    if (index - 1 >= lowerBound) {
      r |= parseHex4Bits(string, index - 1) << 4;
    }
    return r;
  }

  BN.prototype._parseHex = function _parseHex (number, start, endian) {
    // Create possibly bigger array to ensure that it fits the number
    this.length = Math.ceil((number.length - start) / 6);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    // 24-bits chunks
    var off = 0;
    var j = 0;

    var w;
    if (endian === 'be') {
      for (i = number.length - 1; i >= start; i -= 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    } else {
      var parseLength = number.length - start;
      for (i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    }

    this._strip();
  };

  function parseBase (str, start, end, mul) {
    var r = 0;
    var b = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r *= mul;

      // 'a'
      if (c >= 49) {
        b = c - 49 + 0xa;

      // 'A'
      } else if (c >= 17) {
        b = c - 17 + 0xa;

      // '0' - '9'
      } else {
        b = c;
      }
      assert(c >= 0 && b < mul, 'Invalid character');
      r += b;
    }
    return r;
  }

  BN.prototype._parseBase = function _parseBase (number, base, start) {
    // Initialize as zero
    this.words = [0];
    this.length = 1;

    // Find length of limb in base
    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
      limbLen++;
    }
    limbLen--;
    limbPow = (limbPow / base) | 0;

    var total = number.length - start;
    var mod = total % limbLen;
    var end = Math.min(total, total - mod) + start;

    var word = 0;
    for (var i = start; i < end; i += limbLen) {
      word = parseBase(number, i, i + limbLen, base);

      this.imuln(limbPow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    if (mod !== 0) {
      var pow = 1;
      word = parseBase(number, i, number.length, base);

      for (i = 0; i < mod; i++) {
        pow *= base;
      }

      this.imuln(pow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    this._strip();
  };

  BN.prototype.copy = function copy (dest) {
    dest.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      dest.words[i] = this.words[i];
    }
    dest.length = this.length;
    dest.negative = this.negative;
    dest.red = this.red;
  };

  function move (dest, src) {
    dest.words = src.words;
    dest.length = src.length;
    dest.negative = src.negative;
    dest.red = src.red;
  }

  BN.prototype._move = function _move (dest) {
    move(dest, this);
  };

  BN.prototype.clone = function clone () {
    var r = new BN(null);
    this.copy(r);
    return r;
  };

  BN.prototype._expand = function _expand (size) {
    while (this.length < size) {
      this.words[this.length++] = 0;
    }
    return this;
  };

  // Remove leading `0` from `this`
  BN.prototype._strip = function strip () {
    while (this.length > 1 && this.words[this.length - 1] === 0) {
      this.length--;
    }
    return this._normSign();
  };

  BN.prototype._normSign = function _normSign () {
    // -0 = 0
    if (this.length === 1 && this.words[0] === 0) {
      this.negative = 0;
    }
    return this;
  };

  // Check Symbol.for because not everywhere where Symbol defined
  // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
  if (typeof Symbol !== 'undefined' && typeof Symbol.for === 'function') {
    try {
      BN.prototype[Symbol.for('nodejs.util.inspect.custom')] = inspect;
    } catch (e) {
      BN.prototype.inspect = inspect;
    }
  } else {
    BN.prototype.inspect = inspect;
  }

  function inspect () {
    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  }

  /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */

  var zeros = [
    '',
    '0',
    '00',
    '000',
    '0000',
    '00000',
    '000000',
    '0000000',
    '00000000',
    '000000000',
    '0000000000',
    '00000000000',
    '000000000000',
    '0000000000000',
    '00000000000000',
    '000000000000000',
    '0000000000000000',
    '00000000000000000',
    '000000000000000000',
    '0000000000000000000',
    '00000000000000000000',
    '000000000000000000000',
    '0000000000000000000000',
    '00000000000000000000000',
    '000000000000000000000000',
    '0000000000000000000000000'
  ];

  var groupSizes = [
    0, 0,
    25, 16, 12, 11, 10, 9, 8,
    8, 7, 7, 7, 7, 6, 6,
    6, 6, 6, 6, 6, 5, 5,
    5, 5, 5, 5, 5, 5, 5,
    5, 5, 5, 5, 5, 5, 5
  ];

  var groupBases = [
    0, 0,
    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
  ];

  BN.prototype.toString = function toString (base, padding) {
    base = base || 10;
    padding = padding | 0 || 1;

    var out;
    if (base === 16 || base === 'hex') {
      out = '';
      var off = 0;
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = this.words[i];
        var word = (((w << off) | carry) & 0xffffff).toString(16);
        carry = (w >>> (24 - off)) & 0xffffff;
        off += 2;
        if (off >= 26) {
          off -= 26;
          i--;
        }
        if (carry !== 0 || i !== this.length - 1) {
          out = zeros[6 - word.length] + word + out;
        } else {
          out = word + out;
        }
      }
      if (carry !== 0) {
        out = carry.toString(16) + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    if (base === (base | 0) && base >= 2 && base <= 36) {
      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
      var groupSize = groupSizes[base];
      // var groupBase = Math.pow(base, groupSize);
      var groupBase = groupBases[base];
      out = '';
      var c = this.clone();
      c.negative = 0;
      while (!c.isZero()) {
        var r = c.modrn(groupBase).toString(base);
        c = c.idivn(groupBase);

        if (!c.isZero()) {
          out = zeros[groupSize - r.length] + r + out;
        } else {
          out = r + out;
        }
      }
      if (this.isZero()) {
        out = '0' + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    assert(false, 'Base should be between 2 and 36');
  };

  BN.prototype.toNumber = function toNumber () {
    var ret = this.words[0];
    if (this.length === 2) {
      ret += this.words[1] * 0x4000000;
    } else if (this.length === 3 && this.words[2] === 0x01) {
      // NOTE: at this stage it is known that the top bit is set
      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    } else if (this.length > 2) {
      assert(false, 'Number can only safely store up to 53 bits');
    }
    return (this.negative !== 0) ? -ret : ret;
  };

  BN.prototype.toJSON = function toJSON () {
    return this.toString(16, 2);
  };

  if (Buffer) {
    BN.prototype.toBuffer = function toBuffer (endian, length) {
      return this.toArrayLike(Buffer, endian, length);
    };
  }

  BN.prototype.toArray = function toArray (endian, length) {
    return this.toArrayLike(Array, endian, length);
  };

  var allocate = function allocate (ArrayType, size) {
    if (ArrayType.allocUnsafe) {
      return ArrayType.allocUnsafe(size);
    }
    return new ArrayType(size);
  };

  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    this._strip();

    var byteLength = this.byteLength();
    var reqLength = length || Math.max(1, byteLength);
    assert(byteLength <= reqLength, 'byte array longer than desired length');
    assert(reqLength > 0, 'Requested array length <= 0');

    var res = allocate(ArrayType, reqLength);
    var postfix = endian === 'le' ? 'LE' : 'BE';
    this['_toArrayLike' + postfix](res, byteLength);
    return res;
  };

  BN.prototype._toArrayLikeLE = function _toArrayLikeLE (res, byteLength) {
    var position = 0;
    var carry = 0;

    for (var i = 0, shift = 0; i < this.length; i++) {
      var word = (this.words[i] << shift) | carry;

      res[position++] = word & 0xff;
      if (position < res.length) {
        res[position++] = (word >> 8) & 0xff;
      }
      if (position < res.length) {
        res[position++] = (word >> 16) & 0xff;
      }

      if (shift === 6) {
        if (position < res.length) {
          res[position++] = (word >> 24) & 0xff;
        }
        carry = 0;
        shift = 0;
      } else {
        carry = word >>> 24;
        shift += 2;
      }
    }

    if (position < res.length) {
      res[position++] = carry;

      while (position < res.length) {
        res[position++] = 0;
      }
    }
  };

  BN.prototype._toArrayLikeBE = function _toArrayLikeBE (res, byteLength) {
    var position = res.length - 1;
    var carry = 0;

    for (var i = 0, shift = 0; i < this.length; i++) {
      var word = (this.words[i] << shift) | carry;

      res[position--] = word & 0xff;
      if (position >= 0) {
        res[position--] = (word >> 8) & 0xff;
      }
      if (position >= 0) {
        res[position--] = (word >> 16) & 0xff;
      }

      if (shift === 6) {
        if (position >= 0) {
          res[position--] = (word >> 24) & 0xff;
        }
        carry = 0;
        shift = 0;
      } else {
        carry = word >>> 24;
        shift += 2;
      }
    }

    if (position >= 0) {
      res[position--] = carry;

      while (position >= 0) {
        res[position--] = 0;
      }
    }
  };

  if (Math.clz32) {
    BN.prototype._countBits = function _countBits (w) {
      return 32 - Math.clz32(w);
    };
  } else {
    BN.prototype._countBits = function _countBits (w) {
      var t = w;
      var r = 0;
      if (t >= 0x1000) {
        r += 13;
        t >>>= 13;
      }
      if (t >= 0x40) {
        r += 7;
        t >>>= 7;
      }
      if (t >= 0x8) {
        r += 4;
        t >>>= 4;
      }
      if (t >= 0x02) {
        r += 2;
        t >>>= 2;
      }
      return r + t;
    };
  }

  BN.prototype._zeroBits = function _zeroBits (w) {
    // Short-cut
    if (w === 0) return 26;

    var t = w;
    var r = 0;
    if ((t & 0x1fff) === 0) {
      r += 13;
      t >>>= 13;
    }
    if ((t & 0x7f) === 0) {
      r += 7;
      t >>>= 7;
    }
    if ((t & 0xf) === 0) {
      r += 4;
      t >>>= 4;
    }
    if ((t & 0x3) === 0) {
      r += 2;
      t >>>= 2;
    }
    if ((t & 0x1) === 0) {
      r++;
    }
    return r;
  };

  // Return number of used bits in a BN
  BN.prototype.bitLength = function bitLength () {
    var w = this.words[this.length - 1];
    var hi = this._countBits(w);
    return (this.length - 1) * 26 + hi;
  };

  function toBitArray (num) {
    var w = new Array(num.bitLength());

    for (var bit = 0; bit < w.length; bit++) {
      var off = (bit / 26) | 0;
      var wbit = bit % 26;

      w[bit] = (num.words[off] >>> wbit) & 0x01;
    }

    return w;
  }

  // Number of trailing zero bits
  BN.prototype.zeroBits = function zeroBits () {
    if (this.isZero()) return 0;

    var r = 0;
    for (var i = 0; i < this.length; i++) {
      var b = this._zeroBits(this.words[i]);
      r += b;
      if (b !== 26) break;
    }
    return r;
  };

  BN.prototype.byteLength = function byteLength () {
    return Math.ceil(this.bitLength() / 8);
  };

  BN.prototype.toTwos = function toTwos (width) {
    if (this.negative !== 0) {
      return this.abs().inotn(width).iaddn(1);
    }
    return this.clone();
  };

  BN.prototype.fromTwos = function fromTwos (width) {
    if (this.testn(width - 1)) {
      return this.notn(width).iaddn(1).ineg();
    }
    return this.clone();
  };

  BN.prototype.isNeg = function isNeg () {
    return this.negative !== 0;
  };

  // Return negative clone of `this`
  BN.prototype.neg = function neg () {
    return this.clone().ineg();
  };

  BN.prototype.ineg = function ineg () {
    if (!this.isZero()) {
      this.negative ^= 1;
    }

    return this;
  };

  // Or `num` with `this` in-place
  BN.prototype.iuor = function iuor (num) {
    while (this.length < num.length) {
      this.words[this.length++] = 0;
    }

    for (var i = 0; i < num.length; i++) {
      this.words[i] = this.words[i] | num.words[i];
    }

    return this._strip();
  };

  BN.prototype.ior = function ior (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuor(num);
  };

  // Or `num` with `this`
  BN.prototype.or = function or (num) {
    if (this.length > num.length) return this.clone().ior(num);
    return num.clone().ior(this);
  };

  BN.prototype.uor = function uor (num) {
    if (this.length > num.length) return this.clone().iuor(num);
    return num.clone().iuor(this);
  };

  // And `num` with `this` in-place
  BN.prototype.iuand = function iuand (num) {
    // b = min-length(num, this)
    var b;
    if (this.length > num.length) {
      b = num;
    } else {
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = this.words[i] & num.words[i];
    }

    this.length = b.length;

    return this._strip();
  };

  BN.prototype.iand = function iand (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuand(num);
  };

  // And `num` with `this`
  BN.prototype.and = function and (num) {
    if (this.length > num.length) return this.clone().iand(num);
    return num.clone().iand(this);
  };

  BN.prototype.uand = function uand (num) {
    if (this.length > num.length) return this.clone().iuand(num);
    return num.clone().iuand(this);
  };

  // Xor `num` with `this` in-place
  BN.prototype.iuxor = function iuxor (num) {
    // a.length > b.length
    var a;
    var b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = a.words[i] ^ b.words[i];
    }

    if (this !== a) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = a.length;

    return this._strip();
  };

  BN.prototype.ixor = function ixor (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuxor(num);
  };

  // Xor `num` with `this`
  BN.prototype.xor = function xor (num) {
    if (this.length > num.length) return this.clone().ixor(num);
    return num.clone().ixor(this);
  };

  BN.prototype.uxor = function uxor (num) {
    if (this.length > num.length) return this.clone().iuxor(num);
    return num.clone().iuxor(this);
  };

  // Not ``this`` with ``width`` bitwidth
  BN.prototype.inotn = function inotn (width) {
    assert(typeof width === 'number' && width >= 0);

    var bytesNeeded = Math.ceil(width / 26) | 0;
    var bitsLeft = width % 26;

    // Extend the buffer with leading zeroes
    this._expand(bytesNeeded);

    if (bitsLeft > 0) {
      bytesNeeded--;
    }

    // Handle complete words
    for (var i = 0; i < bytesNeeded; i++) {
      this.words[i] = ~this.words[i] & 0x3ffffff;
    }

    // Handle the residue
    if (bitsLeft > 0) {
      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
    }

    // And remove leading zeroes
    return this._strip();
  };

  BN.prototype.notn = function notn (width) {
    return this.clone().inotn(width);
  };

  // Set `bit` of `this`
  BN.prototype.setn = function setn (bit, val) {
    assert(typeof bit === 'number' && bit >= 0);

    var off = (bit / 26) | 0;
    var wbit = bit % 26;

    this._expand(off + 1);

    if (val) {
      this.words[off] = this.words[off] | (1 << wbit);
    } else {
      this.words[off] = this.words[off] & ~(1 << wbit);
    }

    return this._strip();
  };

  // Add `num` to `this` in-place
  BN.prototype.iadd = function iadd (num) {
    var r;

    // negative + positive
    if (this.negative !== 0 && num.negative === 0) {
      this.negative = 0;
      r = this.isub(num);
      this.negative ^= 1;
      return this._normSign();

    // positive + negative
    } else if (this.negative === 0 && num.negative !== 0) {
      num.negative = 0;
      r = this.isub(num);
      num.negative = 1;
      return r._normSign();
    }

    // a.length > b.length
    var a, b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }

    this.length = a.length;
    if (carry !== 0) {
      this.words[this.length] = carry;
      this.length++;
    // Copy the rest of the words
    } else if (a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    return this;
  };

  // Add `num` to `this`
  BN.prototype.add = function add (num) {
    var res;
    if (num.negative !== 0 && this.negative === 0) {
      num.negative = 0;
      res = this.sub(num);
      num.negative ^= 1;
      return res;
    } else if (num.negative === 0 && this.negative !== 0) {
      this.negative = 0;
      res = num.sub(this);
      this.negative = 1;
      return res;
    }

    if (this.length > num.length) return this.clone().iadd(num);

    return num.clone().iadd(this);
  };

  // Subtract `num` from `this` in-place
  BN.prototype.isub = function isub (num) {
    // this - (-num) = this + num
    if (num.negative !== 0) {
      num.negative = 0;
      var r = this.iadd(num);
      num.negative = 1;
      return r._normSign();

    // -this - num = -(this + num)
    } else if (this.negative !== 0) {
      this.negative = 0;
      this.iadd(num);
      this.negative = 1;
      return this._normSign();
    }

    // At this point both numbers are positive
    var cmp = this.cmp(num);

    // Optimization - zeroify
    if (cmp === 0) {
      this.negative = 0;
      this.length = 1;
      this.words[0] = 0;
      return this;
    }

    // a > b
    var a, b;
    if (cmp > 0) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }

    // Copy rest of the words
    if (carry === 0 && i < a.length && a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = Math.max(this.length, i);

    if (a !== this) {
      this.negative = 1;
    }

    return this._strip();
  };

  // Subtract `num` from `this`
  BN.prototype.sub = function sub (num) {
    return this.clone().isub(num);
  };

  function smallMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    var len = (self.length + num.length) | 0;
    out.length = len;
    len = (len - 1) | 0;

    // Peel one iteration (compiler can't do it, because of code complexity)
    var a = self.words[0] | 0;
    var b = num.words[0] | 0;
    var r = a * b;

    var lo = r & 0x3ffffff;
    var carry = (r / 0x4000000) | 0;
    out.words[0] = lo;

    for (var k = 1; k < len; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = carry >>> 26;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = (k - j) | 0;
        a = self.words[i] | 0;
        b = num.words[j] | 0;
        r = a * b + rword;
        ncarry += (r / 0x4000000) | 0;
        rword = r & 0x3ffffff;
      }
      out.words[k] = rword | 0;
      carry = ncarry | 0;
    }
    if (carry !== 0) {
      out.words[k] = carry | 0;
    } else {
      out.length--;
    }

    return out._strip();
  }

  // TODO(indutny): it may be reasonable to omit it for users who don't need
  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  // multiplication (like elliptic secp256k1).
  var comb10MulTo = function comb10MulTo (self, num, out) {
    var a = self.words;
    var b = num.words;
    var o = out.words;
    var c = 0;
    var lo;
    var mid;
    var hi;
    var a0 = a[0] | 0;
    var al0 = a0 & 0x1fff;
    var ah0 = a0 >>> 13;
    var a1 = a[1] | 0;
    var al1 = a1 & 0x1fff;
    var ah1 = a1 >>> 13;
    var a2 = a[2] | 0;
    var al2 = a2 & 0x1fff;
    var ah2 = a2 >>> 13;
    var a3 = a[3] | 0;
    var al3 = a3 & 0x1fff;
    var ah3 = a3 >>> 13;
    var a4 = a[4] | 0;
    var al4 = a4 & 0x1fff;
    var ah4 = a4 >>> 13;
    var a5 = a[5] | 0;
    var al5 = a5 & 0x1fff;
    var ah5 = a5 >>> 13;
    var a6 = a[6] | 0;
    var al6 = a6 & 0x1fff;
    var ah6 = a6 >>> 13;
    var a7 = a[7] | 0;
    var al7 = a7 & 0x1fff;
    var ah7 = a7 >>> 13;
    var a8 = a[8] | 0;
    var al8 = a8 & 0x1fff;
    var ah8 = a8 >>> 13;
    var a9 = a[9] | 0;
    var al9 = a9 & 0x1fff;
    var ah9 = a9 >>> 13;
    var b0 = b[0] | 0;
    var bl0 = b0 & 0x1fff;
    var bh0 = b0 >>> 13;
    var b1 = b[1] | 0;
    var bl1 = b1 & 0x1fff;
    var bh1 = b1 >>> 13;
    var b2 = b[2] | 0;
    var bl2 = b2 & 0x1fff;
    var bh2 = b2 >>> 13;
    var b3 = b[3] | 0;
    var bl3 = b3 & 0x1fff;
    var bh3 = b3 >>> 13;
    var b4 = b[4] | 0;
    var bl4 = b4 & 0x1fff;
    var bh4 = b4 >>> 13;
    var b5 = b[5] | 0;
    var bl5 = b5 & 0x1fff;
    var bh5 = b5 >>> 13;
    var b6 = b[6] | 0;
    var bl6 = b6 & 0x1fff;
    var bh6 = b6 >>> 13;
    var b7 = b[7] | 0;
    var bl7 = b7 & 0x1fff;
    var bh7 = b7 >>> 13;
    var b8 = b[8] | 0;
    var bl8 = b8 & 0x1fff;
    var bh8 = b8 >>> 13;
    var b9 = b[9] | 0;
    var bl9 = b9 & 0x1fff;
    var bh9 = b9 >>> 13;

    out.negative = self.negative ^ num.negative;
    out.length = 19;
    /* k = 0 */
    lo = Math.imul(al0, bl0);
    mid = Math.imul(al0, bh0);
    mid = (mid + Math.imul(ah0, bl0)) | 0;
    hi = Math.imul(ah0, bh0);
    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    w0 &= 0x3ffffff;
    /* k = 1 */
    lo = Math.imul(al1, bl0);
    mid = Math.imul(al1, bh0);
    mid = (mid + Math.imul(ah1, bl0)) | 0;
    hi = Math.imul(ah1, bh0);
    lo = (lo + Math.imul(al0, bl1)) | 0;
    mid = (mid + Math.imul(al0, bh1)) | 0;
    mid = (mid + Math.imul(ah0, bl1)) | 0;
    hi = (hi + Math.imul(ah0, bh1)) | 0;
    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    w1 &= 0x3ffffff;
    /* k = 2 */
    lo = Math.imul(al2, bl0);
    mid = Math.imul(al2, bh0);
    mid = (mid + Math.imul(ah2, bl0)) | 0;
    hi = Math.imul(ah2, bh0);
    lo = (lo + Math.imul(al1, bl1)) | 0;
    mid = (mid + Math.imul(al1, bh1)) | 0;
    mid = (mid + Math.imul(ah1, bl1)) | 0;
    hi = (hi + Math.imul(ah1, bh1)) | 0;
    lo = (lo + Math.imul(al0, bl2)) | 0;
    mid = (mid + Math.imul(al0, bh2)) | 0;
    mid = (mid + Math.imul(ah0, bl2)) | 0;
    hi = (hi + Math.imul(ah0, bh2)) | 0;
    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    w2 &= 0x3ffffff;
    /* k = 3 */
    lo = Math.imul(al3, bl0);
    mid = Math.imul(al3, bh0);
    mid = (mid + Math.imul(ah3, bl0)) | 0;
    hi = Math.imul(ah3, bh0);
    lo = (lo + Math.imul(al2, bl1)) | 0;
    mid = (mid + Math.imul(al2, bh1)) | 0;
    mid = (mid + Math.imul(ah2, bl1)) | 0;
    hi = (hi + Math.imul(ah2, bh1)) | 0;
    lo = (lo + Math.imul(al1, bl2)) | 0;
    mid = (mid + Math.imul(al1, bh2)) | 0;
    mid = (mid + Math.imul(ah1, bl2)) | 0;
    hi = (hi + Math.imul(ah1, bh2)) | 0;
    lo = (lo + Math.imul(al0, bl3)) | 0;
    mid = (mid + Math.imul(al0, bh3)) | 0;
    mid = (mid + Math.imul(ah0, bl3)) | 0;
    hi = (hi + Math.imul(ah0, bh3)) | 0;
    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    w3 &= 0x3ffffff;
    /* k = 4 */
    lo = Math.imul(al4, bl0);
    mid = Math.imul(al4, bh0);
    mid = (mid + Math.imul(ah4, bl0)) | 0;
    hi = Math.imul(ah4, bh0);
    lo = (lo + Math.imul(al3, bl1)) | 0;
    mid = (mid + Math.imul(al3, bh1)) | 0;
    mid = (mid + Math.imul(ah3, bl1)) | 0;
    hi = (hi + Math.imul(ah3, bh1)) | 0;
    lo = (lo + Math.imul(al2, bl2)) | 0;
    mid = (mid + Math.imul(al2, bh2)) | 0;
    mid = (mid + Math.imul(ah2, bl2)) | 0;
    hi = (hi + Math.imul(ah2, bh2)) | 0;
    lo = (lo + Math.imul(al1, bl3)) | 0;
    mid = (mid + Math.imul(al1, bh3)) | 0;
    mid = (mid + Math.imul(ah1, bl3)) | 0;
    hi = (hi + Math.imul(ah1, bh3)) | 0;
    lo = (lo + Math.imul(al0, bl4)) | 0;
    mid = (mid + Math.imul(al0, bh4)) | 0;
    mid = (mid + Math.imul(ah0, bl4)) | 0;
    hi = (hi + Math.imul(ah0, bh4)) | 0;
    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    w4 &= 0x3ffffff;
    /* k = 5 */
    lo = Math.imul(al5, bl0);
    mid = Math.imul(al5, bh0);
    mid = (mid + Math.imul(ah5, bl0)) | 0;
    hi = Math.imul(ah5, bh0);
    lo = (lo + Math.imul(al4, bl1)) | 0;
    mid = (mid + Math.imul(al4, bh1)) | 0;
    mid = (mid + Math.imul(ah4, bl1)) | 0;
    hi = (hi + Math.imul(ah4, bh1)) | 0;
    lo = (lo + Math.imul(al3, bl2)) | 0;
    mid = (mid + Math.imul(al3, bh2)) | 0;
    mid = (mid + Math.imul(ah3, bl2)) | 0;
    hi = (hi + Math.imul(ah3, bh2)) | 0;
    lo = (lo + Math.imul(al2, bl3)) | 0;
    mid = (mid + Math.imul(al2, bh3)) | 0;
    mid = (mid + Math.imul(ah2, bl3)) | 0;
    hi = (hi + Math.imul(ah2, bh3)) | 0;
    lo = (lo + Math.imul(al1, bl4)) | 0;
    mid = (mid + Math.imul(al1, bh4)) | 0;
    mid = (mid + Math.imul(ah1, bl4)) | 0;
    hi = (hi + Math.imul(ah1, bh4)) | 0;
    lo = (lo + Math.imul(al0, bl5)) | 0;
    mid = (mid + Math.imul(al0, bh5)) | 0;
    mid = (mid + Math.imul(ah0, bl5)) | 0;
    hi = (hi + Math.imul(ah0, bh5)) | 0;
    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    w5 &= 0x3ffffff;
    /* k = 6 */
    lo = Math.imul(al6, bl0);
    mid = Math.imul(al6, bh0);
    mid = (mid + Math.imul(ah6, bl0)) | 0;
    hi = Math.imul(ah6, bh0);
    lo = (lo + Math.imul(al5, bl1)) | 0;
    mid = (mid + Math.imul(al5, bh1)) | 0;
    mid = (mid + Math.imul(ah5, bl1)) | 0;
    hi = (hi + Math.imul(ah5, bh1)) | 0;
    lo = (lo + Math.imul(al4, bl2)) | 0;
    mid = (mid + Math.imul(al4, bh2)) | 0;
    mid = (mid + Math.imul(ah4, bl2)) | 0;
    hi = (hi + Math.imul(ah4, bh2)) | 0;
    lo = (lo + Math.imul(al3, bl3)) | 0;
    mid = (mid + Math.imul(al3, bh3)) | 0;
    mid = (mid + Math.imul(ah3, bl3)) | 0;
    hi = (hi + Math.imul(ah3, bh3)) | 0;
    lo = (lo + Math.imul(al2, bl4)) | 0;
    mid = (mid + Math.imul(al2, bh4)) | 0;
    mid = (mid + Math.imul(ah2, bl4)) | 0;
    hi = (hi + Math.imul(ah2, bh4)) | 0;
    lo = (lo + Math.imul(al1, bl5)) | 0;
    mid = (mid + Math.imul(al1, bh5)) | 0;
    mid = (mid + Math.imul(ah1, bl5)) | 0;
    hi = (hi + Math.imul(ah1, bh5)) | 0;
    lo = (lo + Math.imul(al0, bl6)) | 0;
    mid = (mid + Math.imul(al0, bh6)) | 0;
    mid = (mid + Math.imul(ah0, bl6)) | 0;
    hi = (hi + Math.imul(ah0, bh6)) | 0;
    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    w6 &= 0x3ffffff;
    /* k = 7 */
    lo = Math.imul(al7, bl0);
    mid = Math.imul(al7, bh0);
    mid = (mid + Math.imul(ah7, bl0)) | 0;
    hi = Math.imul(ah7, bh0);
    lo = (lo + Math.imul(al6, bl1)) | 0;
    mid = (mid + Math.imul(al6, bh1)) | 0;
    mid = (mid + Math.imul(ah6, bl1)) | 0;
    hi = (hi + Math.imul(ah6, bh1)) | 0;
    lo = (lo + Math.imul(al5, bl2)) | 0;
    mid = (mid + Math.imul(al5, bh2)) | 0;
    mid = (mid + Math.imul(ah5, bl2)) | 0;
    hi = (hi + Math.imul(ah5, bh2)) | 0;
    lo = (lo + Math.imul(al4, bl3)) | 0;
    mid = (mid + Math.imul(al4, bh3)) | 0;
    mid = (mid + Math.imul(ah4, bl3)) | 0;
    hi = (hi + Math.imul(ah4, bh3)) | 0;
    lo = (lo + Math.imul(al3, bl4)) | 0;
    mid = (mid + Math.imul(al3, bh4)) | 0;
    mid = (mid + Math.imul(ah3, bl4)) | 0;
    hi = (hi + Math.imul(ah3, bh4)) | 0;
    lo = (lo + Math.imul(al2, bl5)) | 0;
    mid = (mid + Math.imul(al2, bh5)) | 0;
    mid = (mid + Math.imul(ah2, bl5)) | 0;
    hi = (hi + Math.imul(ah2, bh5)) | 0;
    lo = (lo + Math.imul(al1, bl6)) | 0;
    mid = (mid + Math.imul(al1, bh6)) | 0;
    mid = (mid + Math.imul(ah1, bl6)) | 0;
    hi = (hi + Math.imul(ah1, bh6)) | 0;
    lo = (lo + Math.imul(al0, bl7)) | 0;
    mid = (mid + Math.imul(al0, bh7)) | 0;
    mid = (mid + Math.imul(ah0, bl7)) | 0;
    hi = (hi + Math.imul(ah0, bh7)) | 0;
    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    w7 &= 0x3ffffff;
    /* k = 8 */
    lo = Math.imul(al8, bl0);
    mid = Math.imul(al8, bh0);
    mid = (mid + Math.imul(ah8, bl0)) | 0;
    hi = Math.imul(ah8, bh0);
    lo = (lo + Math.imul(al7, bl1)) | 0;
    mid = (mid + Math.imul(al7, bh1)) | 0;
    mid = (mid + Math.imul(ah7, bl1)) | 0;
    hi = (hi + Math.imul(ah7, bh1)) | 0;
    lo = (lo + Math.imul(al6, bl2)) | 0;
    mid = (mid + Math.imul(al6, bh2)) | 0;
    mid = (mid + Math.imul(ah6, bl2)) | 0;
    hi = (hi + Math.imul(ah6, bh2)) | 0;
    lo = (lo + Math.imul(al5, bl3)) | 0;
    mid = (mid + Math.imul(al5, bh3)) | 0;
    mid = (mid + Math.imul(ah5, bl3)) | 0;
    hi = (hi + Math.imul(ah5, bh3)) | 0;
    lo = (lo + Math.imul(al4, bl4)) | 0;
    mid = (mid + Math.imul(al4, bh4)) | 0;
    mid = (mid + Math.imul(ah4, bl4)) | 0;
    hi = (hi + Math.imul(ah4, bh4)) | 0;
    lo = (lo + Math.imul(al3, bl5)) | 0;
    mid = (mid + Math.imul(al3, bh5)) | 0;
    mid = (mid + Math.imul(ah3, bl5)) | 0;
    hi = (hi + Math.imul(ah3, bh5)) | 0;
    lo = (lo + Math.imul(al2, bl6)) | 0;
    mid = (mid + Math.imul(al2, bh6)) | 0;
    mid = (mid + Math.imul(ah2, bl6)) | 0;
    hi = (hi + Math.imul(ah2, bh6)) | 0;
    lo = (lo + Math.imul(al1, bl7)) | 0;
    mid = (mid + Math.imul(al1, bh7)) | 0;
    mid = (mid + Math.imul(ah1, bl7)) | 0;
    hi = (hi + Math.imul(ah1, bh7)) | 0;
    lo = (lo + Math.imul(al0, bl8)) | 0;
    mid = (mid + Math.imul(al0, bh8)) | 0;
    mid = (mid + Math.imul(ah0, bl8)) | 0;
    hi = (hi + Math.imul(ah0, bh8)) | 0;
    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    w8 &= 0x3ffffff;
    /* k = 9 */
    lo = Math.imul(al9, bl0);
    mid = Math.imul(al9, bh0);
    mid = (mid + Math.imul(ah9, bl0)) | 0;
    hi = Math.imul(ah9, bh0);
    lo = (lo + Math.imul(al8, bl1)) | 0;
    mid = (mid + Math.imul(al8, bh1)) | 0;
    mid = (mid + Math.imul(ah8, bl1)) | 0;
    hi = (hi + Math.imul(ah8, bh1)) | 0;
    lo = (lo + Math.imul(al7, bl2)) | 0;
    mid = (mid + Math.imul(al7, bh2)) | 0;
    mid = (mid + Math.imul(ah7, bl2)) | 0;
    hi = (hi + Math.imul(ah7, bh2)) | 0;
    lo = (lo + Math.imul(al6, bl3)) | 0;
    mid = (mid + Math.imul(al6, bh3)) | 0;
    mid = (mid + Math.imul(ah6, bl3)) | 0;
    hi = (hi + Math.imul(ah6, bh3)) | 0;
    lo = (lo + Math.imul(al5, bl4)) | 0;
    mid = (mid + Math.imul(al5, bh4)) | 0;
    mid = (mid + Math.imul(ah5, bl4)) | 0;
    hi = (hi + Math.imul(ah5, bh4)) | 0;
    lo = (lo + Math.imul(al4, bl5)) | 0;
    mid = (mid + Math.imul(al4, bh5)) | 0;
    mid = (mid + Math.imul(ah4, bl5)) | 0;
    hi = (hi + Math.imul(ah4, bh5)) | 0;
    lo = (lo + Math.imul(al3, bl6)) | 0;
    mid = (mid + Math.imul(al3, bh6)) | 0;
    mid = (mid + Math.imul(ah3, bl6)) | 0;
    hi = (hi + Math.imul(ah3, bh6)) | 0;
    lo = (lo + Math.imul(al2, bl7)) | 0;
    mid = (mid + Math.imul(al2, bh7)) | 0;
    mid = (mid + Math.imul(ah2, bl7)) | 0;
    hi = (hi + Math.imul(ah2, bh7)) | 0;
    lo = (lo + Math.imul(al1, bl8)) | 0;
    mid = (mid + Math.imul(al1, bh8)) | 0;
    mid = (mid + Math.imul(ah1, bl8)) | 0;
    hi = (hi + Math.imul(ah1, bh8)) | 0;
    lo = (lo + Math.imul(al0, bl9)) | 0;
    mid = (mid + Math.imul(al0, bh9)) | 0;
    mid = (mid + Math.imul(ah0, bl9)) | 0;
    hi = (hi + Math.imul(ah0, bh9)) | 0;
    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    w9 &= 0x3ffffff;
    /* k = 10 */
    lo = Math.imul(al9, bl1);
    mid = Math.imul(al9, bh1);
    mid = (mid + Math.imul(ah9, bl1)) | 0;
    hi = Math.imul(ah9, bh1);
    lo = (lo + Math.imul(al8, bl2)) | 0;
    mid = (mid + Math.imul(al8, bh2)) | 0;
    mid = (mid + Math.imul(ah8, bl2)) | 0;
    hi = (hi + Math.imul(ah8, bh2)) | 0;
    lo = (lo + Math.imul(al7, bl3)) | 0;
    mid = (mid + Math.imul(al7, bh3)) | 0;
    mid = (mid + Math.imul(ah7, bl3)) | 0;
    hi = (hi + Math.imul(ah7, bh3)) | 0;
    lo = (lo + Math.imul(al6, bl4)) | 0;
    mid = (mid + Math.imul(al6, bh4)) | 0;
    mid = (mid + Math.imul(ah6, bl4)) | 0;
    hi = (hi + Math.imul(ah6, bh4)) | 0;
    lo = (lo + Math.imul(al5, bl5)) | 0;
    mid = (mid + Math.imul(al5, bh5)) | 0;
    mid = (mid + Math.imul(ah5, bl5)) | 0;
    hi = (hi + Math.imul(ah5, bh5)) | 0;
    lo = (lo + Math.imul(al4, bl6)) | 0;
    mid = (mid + Math.imul(al4, bh6)) | 0;
    mid = (mid + Math.imul(ah4, bl6)) | 0;
    hi = (hi + Math.imul(ah4, bh6)) | 0;
    lo = (lo + Math.imul(al3, bl7)) | 0;
    mid = (mid + Math.imul(al3, bh7)) | 0;
    mid = (mid + Math.imul(ah3, bl7)) | 0;
    hi = (hi + Math.imul(ah3, bh7)) | 0;
    lo = (lo + Math.imul(al2, bl8)) | 0;
    mid = (mid + Math.imul(al2, bh8)) | 0;
    mid = (mid + Math.imul(ah2, bl8)) | 0;
    hi = (hi + Math.imul(ah2, bh8)) | 0;
    lo = (lo + Math.imul(al1, bl9)) | 0;
    mid = (mid + Math.imul(al1, bh9)) | 0;
    mid = (mid + Math.imul(ah1, bl9)) | 0;
    hi = (hi + Math.imul(ah1, bh9)) | 0;
    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    w10 &= 0x3ffffff;
    /* k = 11 */
    lo = Math.imul(al9, bl2);
    mid = Math.imul(al9, bh2);
    mid = (mid + Math.imul(ah9, bl2)) | 0;
    hi = Math.imul(ah9, bh2);
    lo = (lo + Math.imul(al8, bl3)) | 0;
    mid = (mid + Math.imul(al8, bh3)) | 0;
    mid = (mid + Math.imul(ah8, bl3)) | 0;
    hi = (hi + Math.imul(ah8, bh3)) | 0;
    lo = (lo + Math.imul(al7, bl4)) | 0;
    mid = (mid + Math.imul(al7, bh4)) | 0;
    mid = (mid + Math.imul(ah7, bl4)) | 0;
    hi = (hi + Math.imul(ah7, bh4)) | 0;
    lo = (lo + Math.imul(al6, bl5)) | 0;
    mid = (mid + Math.imul(al6, bh5)) | 0;
    mid = (mid + Math.imul(ah6, bl5)) | 0;
    hi = (hi + Math.imul(ah6, bh5)) | 0;
    lo = (lo + Math.imul(al5, bl6)) | 0;
    mid = (mid + Math.imul(al5, bh6)) | 0;
    mid = (mid + Math.imul(ah5, bl6)) | 0;
    hi = (hi + Math.imul(ah5, bh6)) | 0;
    lo = (lo + Math.imul(al4, bl7)) | 0;
    mid = (mid + Math.imul(al4, bh7)) | 0;
    mid = (mid + Math.imul(ah4, bl7)) | 0;
    hi = (hi + Math.imul(ah4, bh7)) | 0;
    lo = (lo + Math.imul(al3, bl8)) | 0;
    mid = (mid + Math.imul(al3, bh8)) | 0;
    mid = (mid + Math.imul(ah3, bl8)) | 0;
    hi = (hi + Math.imul(ah3, bh8)) | 0;
    lo = (lo + Math.imul(al2, bl9)) | 0;
    mid = (mid + Math.imul(al2, bh9)) | 0;
    mid = (mid + Math.imul(ah2, bl9)) | 0;
    hi = (hi + Math.imul(ah2, bh9)) | 0;
    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    w11 &= 0x3ffffff;
    /* k = 12 */
    lo = Math.imul(al9, bl3);
    mid = Math.imul(al9, bh3);
    mid = (mid + Math.imul(ah9, bl3)) | 0;
    hi = Math.imul(ah9, bh3);
    lo = (lo + Math.imul(al8, bl4)) | 0;
    mid = (mid + Math.imul(al8, bh4)) | 0;
    mid = (mid + Math.imul(ah8, bl4)) | 0;
    hi = (hi + Math.imul(ah8, bh4)) | 0;
    lo = (lo + Math.imul(al7, bl5)) | 0;
    mid = (mid + Math.imul(al7, bh5)) | 0;
    mid = (mid + Math.imul(ah7, bl5)) | 0;
    hi = (hi + Math.imul(ah7, bh5)) | 0;
    lo = (lo + Math.imul(al6, bl6)) | 0;
    mid = (mid + Math.imul(al6, bh6)) | 0;
    mid = (mid + Math.imul(ah6, bl6)) | 0;
    hi = (hi + Math.imul(ah6, bh6)) | 0;
    lo = (lo + Math.imul(al5, bl7)) | 0;
    mid = (mid + Math.imul(al5, bh7)) | 0;
    mid = (mid + Math.imul(ah5, bl7)) | 0;
    hi = (hi + Math.imul(ah5, bh7)) | 0;
    lo = (lo + Math.imul(al4, bl8)) | 0;
    mid = (mid + Math.imul(al4, bh8)) | 0;
    mid = (mid + Math.imul(ah4, bl8)) | 0;
    hi = (hi + Math.imul(ah4, bh8)) | 0;
    lo = (lo + Math.imul(al3, bl9)) | 0;
    mid = (mid + Math.imul(al3, bh9)) | 0;
    mid = (mid + Math.imul(ah3, bl9)) | 0;
    hi = (hi + Math.imul(ah3, bh9)) | 0;
    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    w12 &= 0x3ffffff;
    /* k = 13 */
    lo = Math.imul(al9, bl4);
    mid = Math.imul(al9, bh4);
    mid = (mid + Math.imul(ah9, bl4)) | 0;
    hi = Math.imul(ah9, bh4);
    lo = (lo + Math.imul(al8, bl5)) | 0;
    mid = (mid + Math.imul(al8, bh5)) | 0;
    mid = (mid + Math.imul(ah8, bl5)) | 0;
    hi = (hi + Math.imul(ah8, bh5)) | 0;
    lo = (lo + Math.imul(al7, bl6)) | 0;
    mid = (mid + Math.imul(al7, bh6)) | 0;
    mid = (mid + Math.imul(ah7, bl6)) | 0;
    hi = (hi + Math.imul(ah7, bh6)) | 0;
    lo = (lo + Math.imul(al6, bl7)) | 0;
    mid = (mid + Math.imul(al6, bh7)) | 0;
    mid = (mid + Math.imul(ah6, bl7)) | 0;
    hi = (hi + Math.imul(ah6, bh7)) | 0;
    lo = (lo + Math.imul(al5, bl8)) | 0;
    mid = (mid + Math.imul(al5, bh8)) | 0;
    mid = (mid + Math.imul(ah5, bl8)) | 0;
    hi = (hi + Math.imul(ah5, bh8)) | 0;
    lo = (lo + Math.imul(al4, bl9)) | 0;
    mid = (mid + Math.imul(al4, bh9)) | 0;
    mid = (mid + Math.imul(ah4, bl9)) | 0;
    hi = (hi + Math.imul(ah4, bh9)) | 0;
    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    w13 &= 0x3ffffff;
    /* k = 14 */
    lo = Math.imul(al9, bl5);
    mid = Math.imul(al9, bh5);
    mid = (mid + Math.imul(ah9, bl5)) | 0;
    hi = Math.imul(ah9, bh5);
    lo = (lo + Math.imul(al8, bl6)) | 0;
    mid = (mid + Math.imul(al8, bh6)) | 0;
    mid = (mid + Math.imul(ah8, bl6)) | 0;
    hi = (hi + Math.imul(ah8, bh6)) | 0;
    lo = (lo + Math.imul(al7, bl7)) | 0;
    mid = (mid + Math.imul(al7, bh7)) | 0;
    mid = (mid + Math.imul(ah7, bl7)) | 0;
    hi = (hi + Math.imul(ah7, bh7)) | 0;
    lo = (lo + Math.imul(al6, bl8)) | 0;
    mid = (mid + Math.imul(al6, bh8)) | 0;
    mid = (mid + Math.imul(ah6, bl8)) | 0;
    hi = (hi + Math.imul(ah6, bh8)) | 0;
    lo = (lo + Math.imul(al5, bl9)) | 0;
    mid = (mid + Math.imul(al5, bh9)) | 0;
    mid = (mid + Math.imul(ah5, bl9)) | 0;
    hi = (hi + Math.imul(ah5, bh9)) | 0;
    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    w14 &= 0x3ffffff;
    /* k = 15 */
    lo = Math.imul(al9, bl6);
    mid = Math.imul(al9, bh6);
    mid = (mid + Math.imul(ah9, bl6)) | 0;
    hi = Math.imul(ah9, bh6);
    lo = (lo + Math.imul(al8, bl7)) | 0;
    mid = (mid + Math.imul(al8, bh7)) | 0;
    mid = (mid + Math.imul(ah8, bl7)) | 0;
    hi = (hi + Math.imul(ah8, bh7)) | 0;
    lo = (lo + Math.imul(al7, bl8)) | 0;
    mid = (mid + Math.imul(al7, bh8)) | 0;
    mid = (mid + Math.imul(ah7, bl8)) | 0;
    hi = (hi + Math.imul(ah7, bh8)) | 0;
    lo = (lo + Math.imul(al6, bl9)) | 0;
    mid = (mid + Math.imul(al6, bh9)) | 0;
    mid = (mid + Math.imul(ah6, bl9)) | 0;
    hi = (hi + Math.imul(ah6, bh9)) | 0;
    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    w15 &= 0x3ffffff;
    /* k = 16 */
    lo = Math.imul(al9, bl7);
    mid = Math.imul(al9, bh7);
    mid = (mid + Math.imul(ah9, bl7)) | 0;
    hi = Math.imul(ah9, bh7);
    lo = (lo + Math.imul(al8, bl8)) | 0;
    mid = (mid + Math.imul(al8, bh8)) | 0;
    mid = (mid + Math.imul(ah8, bl8)) | 0;
    hi = (hi + Math.imul(ah8, bh8)) | 0;
    lo = (lo + Math.imul(al7, bl9)) | 0;
    mid = (mid + Math.imul(al7, bh9)) | 0;
    mid = (mid + Math.imul(ah7, bl9)) | 0;
    hi = (hi + Math.imul(ah7, bh9)) | 0;
    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    w16 &= 0x3ffffff;
    /* k = 17 */
    lo = Math.imul(al9, bl8);
    mid = Math.imul(al9, bh8);
    mid = (mid + Math.imul(ah9, bl8)) | 0;
    hi = Math.imul(ah9, bh8);
    lo = (lo + Math.imul(al8, bl9)) | 0;
    mid = (mid + Math.imul(al8, bh9)) | 0;
    mid = (mid + Math.imul(ah8, bl9)) | 0;
    hi = (hi + Math.imul(ah8, bh9)) | 0;
    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    w17 &= 0x3ffffff;
    /* k = 18 */
    lo = Math.imul(al9, bl9);
    mid = Math.imul(al9, bh9);
    mid = (mid + Math.imul(ah9, bl9)) | 0;
    hi = Math.imul(ah9, bh9);
    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    w18 &= 0x3ffffff;
    o[0] = w0;
    o[1] = w1;
    o[2] = w2;
    o[3] = w3;
    o[4] = w4;
    o[5] = w5;
    o[6] = w6;
    o[7] = w7;
    o[8] = w8;
    o[9] = w9;
    o[10] = w10;
    o[11] = w11;
    o[12] = w12;
    o[13] = w13;
    o[14] = w14;
    o[15] = w15;
    o[16] = w16;
    o[17] = w17;
    o[18] = w18;
    if (c !== 0) {
      o[19] = c;
      out.length++;
    }
    return out;
  };

  // Polyfill comb
  if (!Math.imul) {
    comb10MulTo = smallMulTo;
  }

  function bigMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    out.length = self.length + num.length;

    var carry = 0;
    var hncarry = 0;
    for (var k = 0; k < out.length - 1; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = hncarry;
      hncarry = 0;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j;
        var a = self.words[i] | 0;
        var b = num.words[j] | 0;
        var r = a * b;

        var lo = r & 0x3ffffff;
        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
        lo = (lo + rword) | 0;
        rword = lo & 0x3ffffff;
        ncarry = (ncarry + (lo >>> 26)) | 0;

        hncarry += ncarry >>> 26;
        ncarry &= 0x3ffffff;
      }
      out.words[k] = rword;
      carry = ncarry;
      ncarry = hncarry;
    }
    if (carry !== 0) {
      out.words[k] = carry;
    } else {
      out.length--;
    }

    return out._strip();
  }

  function jumboMulTo (self, num, out) {
    // Temporary disable, see https://github.com/indutny/bn.js/issues/211
    // var fftm = new FFTM();
    // return fftm.mulp(self, num, out);
    return bigMulTo(self, num, out);
  }

  BN.prototype.mulTo = function mulTo (num, out) {
    var res;
    var len = this.length + num.length;
    if (this.length === 10 && num.length === 10) {
      res = comb10MulTo(this, num, out);
    } else if (len < 63) {
      res = smallMulTo(this, num, out);
    } else if (len < 1024) {
      res = bigMulTo(this, num, out);
    } else {
      res = jumboMulTo(this, num, out);
    }

    return res;
  };

  // Cooley-Tukey algorithm for FFT
  // slightly revisited to rely on looping instead of recursion

  function FFTM (x, y) {
    this.x = x;
    this.y = y;
  }

  FFTM.prototype.makeRBT = function makeRBT (N) {
    var t = new Array(N);
    var l = BN.prototype._countBits(N) - 1;
    for (var i = 0; i < N; i++) {
      t[i] = this.revBin(i, l, N);
    }

    return t;
  };

  // Returns binary-reversed representation of `x`
  FFTM.prototype.revBin = function revBin (x, l, N) {
    if (x === 0 || x === N - 1) return x;

    var rb = 0;
    for (var i = 0; i < l; i++) {
      rb |= (x & 1) << (l - i - 1);
      x >>= 1;
    }

    return rb;
  };

  // Performs "tweedling" phase, therefore 'emulating'
  // behaviour of the recursive algorithm
  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    for (var i = 0; i < N; i++) {
      rtws[i] = rws[rbt[i]];
      itws[i] = iws[rbt[i]];
    }
  };

  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    this.permute(rbt, rws, iws, rtws, itws, N);

    for (var s = 1; s < N; s <<= 1) {
      var l = s << 1;

      var rtwdf = Math.cos(2 * Math.PI / l);
      var itwdf = Math.sin(2 * Math.PI / l);

      for (var p = 0; p < N; p += l) {
        var rtwdf_ = rtwdf;
        var itwdf_ = itwdf;

        for (var j = 0; j < s; j++) {
          var re = rtws[p + j];
          var ie = itws[p + j];

          var ro = rtws[p + j + s];
          var io = itws[p + j + s];

          var rx = rtwdf_ * ro - itwdf_ * io;

          io = rtwdf_ * io + itwdf_ * ro;
          ro = rx;

          rtws[p + j] = re + ro;
          itws[p + j] = ie + io;

          rtws[p + j + s] = re - ro;
          itws[p + j + s] = ie - io;

          /* jshint maxdepth : false */
          if (j !== l) {
            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
            rtwdf_ = rx;
          }
        }
      }
    }
  };

  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    var N = Math.max(m, n) | 1;
    var odd = N & 1;
    var i = 0;
    for (N = N / 2 | 0; N; N = N >>> 1) {
      i++;
    }

    return 1 << i + 1 + odd;
  };

  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    if (N <= 1) return;

    for (var i = 0; i < N / 2; i++) {
      var t = rws[i];

      rws[i] = rws[N - i - 1];
      rws[N - i - 1] = t;

      t = iws[i];

      iws[i] = -iws[N - i - 1];
      iws[N - i - 1] = -t;
    }
  };

  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    var carry = 0;
    for (var i = 0; i < N / 2; i++) {
      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
        Math.round(ws[2 * i] / N) +
        carry;

      ws[i] = w & 0x3ffffff;

      if (w < 0x4000000) {
        carry = 0;
      } else {
        carry = w / 0x4000000 | 0;
      }
    }

    return ws;
  };

  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    var carry = 0;
    for (var i = 0; i < len; i++) {
      carry = carry + (ws[i] | 0);

      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    }

    // Pad with zeroes
    for (i = 2 * len; i < N; ++i) {
      rws[i] = 0;
    }

    assert(carry === 0);
    assert((carry & ~0x1fff) === 0);
  };

  FFTM.prototype.stub = function stub (N) {
    var ph = new Array(N);
    for (var i = 0; i < N; i++) {
      ph[i] = 0;
    }

    return ph;
  };

  FFTM.prototype.mulp = function mulp (x, y, out) {
    var N = 2 * this.guessLen13b(x.length, y.length);

    var rbt = this.makeRBT(N);

    var _ = this.stub(N);

    var rws = new Array(N);
    var rwst = new Array(N);
    var iwst = new Array(N);

    var nrws = new Array(N);
    var nrwst = new Array(N);
    var niwst = new Array(N);

    var rmws = out.words;
    rmws.length = N;

    this.convert13b(x.words, x.length, rws, N);
    this.convert13b(y.words, y.length, nrws, N);

    this.transform(rws, _, rwst, iwst, N, rbt);
    this.transform(nrws, _, nrwst, niwst, N, rbt);

    for (var i = 0; i < N; i++) {
      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
      rwst[i] = rx;
    }

    this.conjugate(rwst, iwst, N);
    this.transform(rwst, iwst, rmws, _, N, rbt);
    this.conjugate(rmws, _, N);
    this.normalize13b(rmws, N);

    out.negative = x.negative ^ y.negative;
    out.length = x.length + y.length;
    return out._strip();
  };

  // Multiply `this` by `num`
  BN.prototype.mul = function mul (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return this.mulTo(num, out);
  };

  // Multiply employing FFT
  BN.prototype.mulf = function mulf (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return jumboMulTo(this, num, out);
  };

  // In-place Multiplication
  BN.prototype.imul = function imul (num) {
    return this.clone().mulTo(num, this);
  };

  BN.prototype.imuln = function imuln (num) {
    var isNegNum = num < 0;
    if (isNegNum) num = -num;

    assert(typeof num === 'number');
    assert(num < 0x4000000);

    // Carry
    var carry = 0;
    for (var i = 0; i < this.length; i++) {
      var w = (this.words[i] | 0) * num;
      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
      carry >>= 26;
      carry += (w / 0x4000000) | 0;
      // NOTE: lo is 27bit maximum
      carry += lo >>> 26;
      this.words[i] = lo & 0x3ffffff;
    }

    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }

    return isNegNum ? this.ineg() : this;
  };

  BN.prototype.muln = function muln (num) {
    return this.clone().imuln(num);
  };

  // `this` * `this`
  BN.prototype.sqr = function sqr () {
    return this.mul(this);
  };

  // `this` * `this` in-place
  BN.prototype.isqr = function isqr () {
    return this.imul(this.clone());
  };

  // Math.pow(`this`, `num`)
  BN.prototype.pow = function pow (num) {
    var w = toBitArray(num);
    if (w.length === 0) return new BN(1);

    // Skip leading zeroes
    var res = this;
    for (var i = 0; i < w.length; i++, res = res.sqr()) {
      if (w[i] !== 0) break;
    }

    if (++i < w.length) {
      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
        if (w[i] === 0) continue;

        res = res.mul(q);
      }
    }

    return res;
  };

  // Shift-left in-place
  BN.prototype.iushln = function iushln (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;
    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    var i;

    if (r !== 0) {
      var carry = 0;

      for (i = 0; i < this.length; i++) {
        var newCarry = this.words[i] & carryMask;
        var c = ((this.words[i] | 0) - newCarry) << r;
        this.words[i] = c | carry;
        carry = newCarry >>> (26 - r);
      }

      if (carry) {
        this.words[i] = carry;
        this.length++;
      }
    }

    if (s !== 0) {
      for (i = this.length - 1; i >= 0; i--) {
        this.words[i + s] = this.words[i];
      }

      for (i = 0; i < s; i++) {
        this.words[i] = 0;
      }

      this.length += s;
    }

    return this._strip();
  };

  BN.prototype.ishln = function ishln (bits) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushln(bits);
  };

  // Shift-right in-place
  // NOTE: `hint` is a lowest bit before trailing zeroes
  // NOTE: if `extended` is present - it will be filled with destroyed bits
  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    assert(typeof bits === 'number' && bits >= 0);
    var h;
    if (hint) {
      h = (hint - (hint % 26)) / 26;
    } else {
      h = 0;
    }

    var r = bits % 26;
    var s = Math.min((bits - r) / 26, this.length);
    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    var maskedWords = extended;

    h -= s;
    h = Math.max(0, h);

    // Extended mode, copy masked part
    if (maskedWords) {
      for (var i = 0; i < s; i++) {
        maskedWords.words[i] = this.words[i];
      }
      maskedWords.length = s;
    }

    if (s === 0) {
      // No-op, we should not move anything at all
    } else if (this.length > s) {
      this.length -= s;
      for (i = 0; i < this.length; i++) {
        this.words[i] = this.words[i + s];
      }
    } else {
      this.words[0] = 0;
      this.length = 1;
    }

    var carry = 0;
    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
      var word = this.words[i] | 0;
      this.words[i] = (carry << (26 - r)) | (word >>> r);
      carry = word & mask;
    }

    // Push carried bits as a mask
    if (maskedWords && carry !== 0) {
      maskedWords.words[maskedWords.length++] = carry;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this._strip();
  };

  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushrn(bits, hint, extended);
  };

  // Shift-left
  BN.prototype.shln = function shln (bits) {
    return this.clone().ishln(bits);
  };

  BN.prototype.ushln = function ushln (bits) {
    return this.clone().iushln(bits);
  };

  // Shift-right
  BN.prototype.shrn = function shrn (bits) {
    return this.clone().ishrn(bits);
  };

  BN.prototype.ushrn = function ushrn (bits) {
    return this.clone().iushrn(bits);
  };

  // Test if n bit is set
  BN.prototype.testn = function testn (bit) {
    assert(typeof bit === 'number' && bit >= 0);
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) return false;

    // Check bit and return
    var w = this.words[s];

    return !!(w & q);
  };

  // Return only lowers bits of number (in-place)
  BN.prototype.imaskn = function imaskn (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;

    assert(this.negative === 0, 'imaskn works only with positive numbers');

    if (this.length <= s) {
      return this;
    }

    if (r !== 0) {
      s++;
    }
    this.length = Math.min(s, this.length);

    if (r !== 0) {
      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
      this.words[this.length - 1] &= mask;
    }

    return this._strip();
  };

  // Return only lowers bits of number
  BN.prototype.maskn = function maskn (bits) {
    return this.clone().imaskn(bits);
  };

  // Add plain number `num` to `this`
  BN.prototype.iaddn = function iaddn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.isubn(-num);

    // Possible sign change
    if (this.negative !== 0) {
      if (this.length === 1 && (this.words[0] | 0) <= num) {
        this.words[0] = num - (this.words[0] | 0);
        this.negative = 0;
        return this;
      }

      this.negative = 0;
      this.isubn(num);
      this.negative = 1;
      return this;
    }

    // Add without checks
    return this._iaddn(num);
  };

  BN.prototype._iaddn = function _iaddn (num) {
    this.words[0] += num;

    // Carry
    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
      this.words[i] -= 0x4000000;
      if (i === this.length - 1) {
        this.words[i + 1] = 1;
      } else {
        this.words[i + 1]++;
      }
    }
    this.length = Math.max(this.length, i + 1);

    return this;
  };

  // Subtract plain number `num` from `this`
  BN.prototype.isubn = function isubn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.iaddn(-num);

    if (this.negative !== 0) {
      this.negative = 0;
      this.iaddn(num);
      this.negative = 1;
      return this;
    }

    this.words[0] -= num;

    if (this.length === 1 && this.words[0] < 0) {
      this.words[0] = -this.words[0];
      this.negative = 1;
    } else {
      // Carry
      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
        this.words[i] += 0x4000000;
        this.words[i + 1] -= 1;
      }
    }

    return this._strip();
  };

  BN.prototype.addn = function addn (num) {
    return this.clone().iaddn(num);
  };

  BN.prototype.subn = function subn (num) {
    return this.clone().isubn(num);
  };

  BN.prototype.iabs = function iabs () {
    this.negative = 0;

    return this;
  };

  BN.prototype.abs = function abs () {
    return this.clone().iabs();
  };

  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    var len = num.length + shift;
    var i;

    this._expand(len);

    var w;
    var carry = 0;
    for (i = 0; i < num.length; i++) {
      w = (this.words[i + shift] | 0) + carry;
      var right = (num.words[i] | 0) * mul;
      w -= right & 0x3ffffff;
      carry = (w >> 26) - ((right / 0x4000000) | 0);
      this.words[i + shift] = w & 0x3ffffff;
    }
    for (; i < this.length - shift; i++) {
      w = (this.words[i + shift] | 0) + carry;
      carry = w >> 26;
      this.words[i + shift] = w & 0x3ffffff;
    }

    if (carry === 0) return this._strip();

    // Subtraction overflow
    assert(carry === -1);
    carry = 0;
    for (i = 0; i < this.length; i++) {
      w = -(this.words[i] | 0) + carry;
      carry = w >> 26;
      this.words[i] = w & 0x3ffffff;
    }
    this.negative = 1;

    return this._strip();
  };

  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    var shift = this.length - num.length;

    var a = this.clone();
    var b = num;

    // Normalize
    var bhi = b.words[b.length - 1] | 0;
    var bhiBits = this._countBits(bhi);
    shift = 26 - bhiBits;
    if (shift !== 0) {
      b = b.ushln(shift);
      a.iushln(shift);
      bhi = b.words[b.length - 1] | 0;
    }

    // Initialize quotient
    var m = a.length - b.length;
    var q;

    if (mode !== 'mod') {
      q = new BN(null);
      q.length = m + 1;
      q.words = new Array(q.length);
      for (var i = 0; i < q.length; i++) {
        q.words[i] = 0;
      }
    }

    var diff = a.clone()._ishlnsubmul(b, 1, m);
    if (diff.negative === 0) {
      a = diff;
      if (q) {
        q.words[m] = 1;
      }
    }

    for (var j = m - 1; j >= 0; j--) {
      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
        (a.words[b.length + j - 1] | 0);

      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
      // (0x7ffffff)
      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

      a._ishlnsubmul(b, qj, j);
      while (a.negative !== 0) {
        qj--;
        a.negative = 0;
        a._ishlnsubmul(b, 1, j);
        if (!a.isZero()) {
          a.negative ^= 1;
        }
      }
      if (q) {
        q.words[j] = qj;
      }
    }
    if (q) {
      q._strip();
    }
    a._strip();

    // Denormalize
    if (mode !== 'div' && shift !== 0) {
      a.iushrn(shift);
    }

    return {
      div: q || null,
      mod: a
    };
  };

  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  //       to `div` to request div only, or be absent to
  //       request both div & mod
  //       2) `positive` is true if unsigned mod is requested
  BN.prototype.divmod = function divmod (num, mode, positive) {
    assert(!num.isZero());

    if (this.isZero()) {
      return {
        div: new BN(0),
        mod: new BN(0)
      };
    }

    var div, mod, res;
    if (this.negative !== 0 && num.negative === 0) {
      res = this.neg().divmod(num, mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.iadd(num);
        }
      }

      return {
        div: div,
        mod: mod
      };
    }

    if (this.negative === 0 && num.negative !== 0) {
      res = this.divmod(num.neg(), mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      return {
        div: div,
        mod: res.mod
      };
    }

    if ((this.negative & num.negative) !== 0) {
      res = this.neg().divmod(num.neg(), mode);

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.isub(num);
        }
      }

      return {
        div: res.div,
        mod: mod
      };
    }

    // Both numbers are positive at this point

    // Strip both numbers to approximate shift value
    if (num.length > this.length || this.cmp(num) < 0) {
      return {
        div: new BN(0),
        mod: this
      };
    }

    // Very short reduction
    if (num.length === 1) {
      if (mode === 'div') {
        return {
          div: this.divn(num.words[0]),
          mod: null
        };
      }

      if (mode === 'mod') {
        return {
          div: null,
          mod: new BN(this.modrn(num.words[0]))
        };
      }

      return {
        div: this.divn(num.words[0]),
        mod: new BN(this.modrn(num.words[0]))
      };
    }

    return this._wordDiv(num, mode);
  };

  // Find `this` / `num`
  BN.prototype.div = function div (num) {
    return this.divmod(num, 'div', false).div;
  };

  // Find `this` % `num`
  BN.prototype.mod = function mod (num) {
    return this.divmod(num, 'mod', false).mod;
  };

  BN.prototype.umod = function umod (num) {
    return this.divmod(num, 'mod', true).mod;
  };

  // Find Round(`this` / `num`)
  BN.prototype.divRound = function divRound (num) {
    var dm = this.divmod(num);

    // Fast case - exact division
    if (dm.mod.isZero()) return dm.div;

    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

    var half = num.ushrn(1);
    var r2 = num.andln(1);
    var cmp = mod.cmp(half);

    // Round down
    if (cmp < 0 || (r2 === 1 && cmp === 0)) return dm.div;

    // Round up
    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
  };

  BN.prototype.modrn = function modrn (num) {
    var isNegNum = num < 0;
    if (isNegNum) num = -num;

    assert(num <= 0x3ffffff);
    var p = (1 << 26) % num;

    var acc = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      acc = (p * acc + (this.words[i] | 0)) % num;
    }

    return isNegNum ? -acc : acc;
  };

  // WARNING: DEPRECATED
  BN.prototype.modn = function modn (num) {
    return this.modrn(num);
  };

  // In-place division by number
  BN.prototype.idivn = function idivn (num) {
    var isNegNum = num < 0;
    if (isNegNum) num = -num;

    assert(num <= 0x3ffffff);

    var carry = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var w = (this.words[i] | 0) + carry * 0x4000000;
      this.words[i] = (w / num) | 0;
      carry = w % num;
    }

    this._strip();
    return isNegNum ? this.ineg() : this;
  };

  BN.prototype.divn = function divn (num) {
    return this.clone().idivn(num);
  };

  BN.prototype.egcd = function egcd (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var x = this;
    var y = p.clone();

    if (x.negative !== 0) {
      x = x.umod(p);
    } else {
      x = x.clone();
    }

    // A * x + B * y = x
    var A = new BN(1);
    var B = new BN(0);

    // C * x + D * y = y
    var C = new BN(0);
    var D = new BN(1);

    var g = 0;

    while (x.isEven() && y.isEven()) {
      x.iushrn(1);
      y.iushrn(1);
      ++g;
    }

    var yp = y.clone();
    var xp = x.clone();

    while (!x.isZero()) {
      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        x.iushrn(i);
        while (i-- > 0) {
          if (A.isOdd() || B.isOdd()) {
            A.iadd(yp);
            B.isub(xp);
          }

          A.iushrn(1);
          B.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        y.iushrn(j);
        while (j-- > 0) {
          if (C.isOdd() || D.isOdd()) {
            C.iadd(yp);
            D.isub(xp);
          }

          C.iushrn(1);
          D.iushrn(1);
        }
      }

      if (x.cmp(y) >= 0) {
        x.isub(y);
        A.isub(C);
        B.isub(D);
      } else {
        y.isub(x);
        C.isub(A);
        D.isub(B);
      }
    }

    return {
      a: C,
      b: D,
      gcd: y.iushln(g)
    };
  };

  // This is reduced incarnation of the binary EEA
  // above, designated to invert members of the
  // _prime_ fields F(p) at a maximal speed
  BN.prototype._invmp = function _invmp (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var a = this;
    var b = p.clone();

    if (a.negative !== 0) {
      a = a.umod(p);
    } else {
      a = a.clone();
    }

    var x1 = new BN(1);
    var x2 = new BN(0);

    var delta = b.clone();

    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        a.iushrn(i);
        while (i-- > 0) {
          if (x1.isOdd()) {
            x1.iadd(delta);
          }

          x1.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        b.iushrn(j);
        while (j-- > 0) {
          if (x2.isOdd()) {
            x2.iadd(delta);
          }

          x2.iushrn(1);
        }
      }

      if (a.cmp(b) >= 0) {
        a.isub(b);
        x1.isub(x2);
      } else {
        b.isub(a);
        x2.isub(x1);
      }
    }

    var res;
    if (a.cmpn(1) === 0) {
      res = x1;
    } else {
      res = x2;
    }

    if (res.cmpn(0) < 0) {
      res.iadd(p);
    }

    return res;
  };

  BN.prototype.gcd = function gcd (num) {
    if (this.isZero()) return num.abs();
    if (num.isZero()) return this.abs();

    var a = this.clone();
    var b = num.clone();
    a.negative = 0;
    b.negative = 0;

    // Remove common factor of two
    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
      a.iushrn(1);
      b.iushrn(1);
    }

    do {
      while (a.isEven()) {
        a.iushrn(1);
      }
      while (b.isEven()) {
        b.iushrn(1);
      }

      var r = a.cmp(b);
      if (r < 0) {
        // Swap `a` and `b` to make `a` always bigger than `b`
        var t = a;
        a = b;
        b = t;
      } else if (r === 0 || b.cmpn(1) === 0) {
        break;
      }

      a.isub(b);
    } while (true);

    return b.iushln(shift);
  };

  // Invert number in the field F(num)
  BN.prototype.invm = function invm (num) {
    return this.egcd(num).a.umod(num);
  };

  BN.prototype.isEven = function isEven () {
    return (this.words[0] & 1) === 0;
  };

  BN.prototype.isOdd = function isOdd () {
    return (this.words[0] & 1) === 1;
  };

  // And first word and num
  BN.prototype.andln = function andln (num) {
    return this.words[0] & num;
  };

  // Increment at the bit position in-line
  BN.prototype.bincn = function bincn (bit) {
    assert(typeof bit === 'number');
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) {
      this._expand(s + 1);
      this.words[s] |= q;
      return this;
    }

    // Add bit and propagate, if needed
    var carry = q;
    for (var i = s; carry !== 0 && i < this.length; i++) {
      var w = this.words[i] | 0;
      w += carry;
      carry = w >>> 26;
      w &= 0x3ffffff;
      this.words[i] = w;
    }
    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    return this;
  };

  BN.prototype.isZero = function isZero () {
    return this.length === 1 && this.words[0] === 0;
  };

  BN.prototype.cmpn = function cmpn (num) {
    var negative = num < 0;

    if (this.negative !== 0 && !negative) return -1;
    if (this.negative === 0 && negative) return 1;

    this._strip();

    var res;
    if (this.length > 1) {
      res = 1;
    } else {
      if (negative) {
        num = -num;
      }

      assert(num <= 0x3ffffff, 'Number is too big');

      var w = this.words[0] | 0;
      res = w === num ? 0 : w < num ? -1 : 1;
    }
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Compare two numbers and return:
  // 1 - if `this` > `num`
  // 0 - if `this` == `num`
  // -1 - if `this` < `num`
  BN.prototype.cmp = function cmp (num) {
    if (this.negative !== 0 && num.negative === 0) return -1;
    if (this.negative === 0 && num.negative !== 0) return 1;

    var res = this.ucmp(num);
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Unsigned comparison
  BN.prototype.ucmp = function ucmp (num) {
    // At this point both numbers have the same sign
    if (this.length > num.length) return 1;
    if (this.length < num.length) return -1;

    var res = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var a = this.words[i] | 0;
      var b = num.words[i] | 0;

      if (a === b) continue;
      if (a < b) {
        res = -1;
      } else if (a > b) {
        res = 1;
      }
      break;
    }
    return res;
  };

  BN.prototype.gtn = function gtn (num) {
    return this.cmpn(num) === 1;
  };

  BN.prototype.gt = function gt (num) {
    return this.cmp(num) === 1;
  };

  BN.prototype.gten = function gten (num) {
    return this.cmpn(num) >= 0;
  };

  BN.prototype.gte = function gte (num) {
    return this.cmp(num) >= 0;
  };

  BN.prototype.ltn = function ltn (num) {
    return this.cmpn(num) === -1;
  };

  BN.prototype.lt = function lt (num) {
    return this.cmp(num) === -1;
  };

  BN.prototype.lten = function lten (num) {
    return this.cmpn(num) <= 0;
  };

  BN.prototype.lte = function lte (num) {
    return this.cmp(num) <= 0;
  };

  BN.prototype.eqn = function eqn (num) {
    return this.cmpn(num) === 0;
  };

  BN.prototype.eq = function eq (num) {
    return this.cmp(num) === 0;
  };

  //
  // A reduce context, could be using montgomery or something better, depending
  // on the `m` itself.
  //
  BN.red = function red (num) {
    return new Red(num);
  };

  BN.prototype.toRed = function toRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    assert(this.negative === 0, 'red works only with positives');
    return ctx.convertTo(this)._forceRed(ctx);
  };

  BN.prototype.fromRed = function fromRed () {
    assert(this.red, 'fromRed works only with numbers in reduction context');
    return this.red.convertFrom(this);
  };

  BN.prototype._forceRed = function _forceRed (ctx) {
    this.red = ctx;
    return this;
  };

  BN.prototype.forceRed = function forceRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    return this._forceRed(ctx);
  };

  BN.prototype.redAdd = function redAdd (num) {
    assert(this.red, 'redAdd works only with red numbers');
    return this.red.add(this, num);
  };

  BN.prototype.redIAdd = function redIAdd (num) {
    assert(this.red, 'redIAdd works only with red numbers');
    return this.red.iadd(this, num);
  };

  BN.prototype.redSub = function redSub (num) {
    assert(this.red, 'redSub works only with red numbers');
    return this.red.sub(this, num);
  };

  BN.prototype.redISub = function redISub (num) {
    assert(this.red, 'redISub works only with red numbers');
    return this.red.isub(this, num);
  };

  BN.prototype.redShl = function redShl (num) {
    assert(this.red, 'redShl works only with red numbers');
    return this.red.shl(this, num);
  };

  BN.prototype.redMul = function redMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.mul(this, num);
  };

  BN.prototype.redIMul = function redIMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.imul(this, num);
  };

  BN.prototype.redSqr = function redSqr () {
    assert(this.red, 'redSqr works only with red numbers');
    this.red._verify1(this);
    return this.red.sqr(this);
  };

  BN.prototype.redISqr = function redISqr () {
    assert(this.red, 'redISqr works only with red numbers');
    this.red._verify1(this);
    return this.red.isqr(this);
  };

  // Square root over p
  BN.prototype.redSqrt = function redSqrt () {
    assert(this.red, 'redSqrt works only with red numbers');
    this.red._verify1(this);
    return this.red.sqrt(this);
  };

  BN.prototype.redInvm = function redInvm () {
    assert(this.red, 'redInvm works only with red numbers');
    this.red._verify1(this);
    return this.red.invm(this);
  };

  // Return negative clone of `this` % `red modulo`
  BN.prototype.redNeg = function redNeg () {
    assert(this.red, 'redNeg works only with red numbers');
    this.red._verify1(this);
    return this.red.neg(this);
  };

  BN.prototype.redPow = function redPow (num) {
    assert(this.red && !num.red, 'redPow(normalNum)');
    this.red._verify1(this);
    return this.red.pow(this, num);
  };

  // Prime numbers with efficient reduction
  var primes = {
    k256: null,
    p224: null,
    p192: null,
    p25519: null
  };

  // Pseudo-Mersenne prime
  function MPrime (name, p) {
    // P = 2 ^ N - K
    this.name = name;
    this.p = new BN(p, 16);
    this.n = this.p.bitLength();
    this.k = new BN(1).iushln(this.n).isub(this.p);

    this.tmp = this._tmp();
  }

  MPrime.prototype._tmp = function _tmp () {
    var tmp = new BN(null);
    tmp.words = new Array(Math.ceil(this.n / 13));
    return tmp;
  };

  MPrime.prototype.ireduce = function ireduce (num) {
    // Assumes that `num` is less than `P^2`
    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    var r = num;
    var rlen;

    do {
      this.split(r, this.tmp);
      r = this.imulK(r);
      r = r.iadd(this.tmp);
      rlen = r.bitLength();
    } while (rlen > this.n);

    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    if (cmp === 0) {
      r.words[0] = 0;
      r.length = 1;
    } else if (cmp > 0) {
      r.isub(this.p);
    } else {
      if (r.strip !== undefined) {
        // r is a BN v4 instance
        r.strip();
      } else {
        // r is a BN v5 instance
        r._strip();
      }
    }

    return r;
  };

  MPrime.prototype.split = function split (input, out) {
    input.iushrn(this.n, 0, out);
  };

  MPrime.prototype.imulK = function imulK (num) {
    return num.imul(this.k);
  };

  function K256 () {
    MPrime.call(
      this,
      'k256',
      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  }
  inherits(K256, MPrime);

  K256.prototype.split = function split (input, output) {
    // 256 = 9 * 26 + 22
    var mask = 0x3fffff;

    var outLen = Math.min(input.length, 9);
    for (var i = 0; i < outLen; i++) {
      output.words[i] = input.words[i];
    }
    output.length = outLen;

    if (input.length <= 9) {
      input.words[0] = 0;
      input.length = 1;
      return;
    }

    // Shift by 9 limbs
    var prev = input.words[9];
    output.words[output.length++] = prev & mask;

    for (i = 10; i < input.length; i++) {
      var next = input.words[i] | 0;
      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
      prev = next;
    }
    prev >>>= 22;
    input.words[i - 10] = prev;
    if (prev === 0 && input.length > 10) {
      input.length -= 10;
    } else {
      input.length -= 9;
    }
  };

  K256.prototype.imulK = function imulK (num) {
    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    num.words[num.length] = 0;
    num.words[num.length + 1] = 0;
    num.length += 2;

    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    var lo = 0;
    for (var i = 0; i < num.length; i++) {
      var w = num.words[i] | 0;
      lo += w * 0x3d1;
      num.words[i] = lo & 0x3ffffff;
      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    }

    // Fast length reduction
    if (num.words[num.length - 1] === 0) {
      num.length--;
      if (num.words[num.length - 1] === 0) {
        num.length--;
      }
    }
    return num;
  };

  function P224 () {
    MPrime.call(
      this,
      'p224',
      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  }
  inherits(P224, MPrime);

  function P192 () {
    MPrime.call(
      this,
      'p192',
      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  }
  inherits(P192, MPrime);

  function P25519 () {
    // 2 ^ 255 - 19
    MPrime.call(
      this,
      '25519',
      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  }
  inherits(P25519, MPrime);

  P25519.prototype.imulK = function imulK (num) {
    // K = 0x13
    var carry = 0;
    for (var i = 0; i < num.length; i++) {
      var hi = (num.words[i] | 0) * 0x13 + carry;
      var lo = hi & 0x3ffffff;
      hi >>>= 26;

      num.words[i] = lo;
      carry = hi;
    }
    if (carry !== 0) {
      num.words[num.length++] = carry;
    }
    return num;
  };

  // Exported mostly for testing purposes, use plain name instead
  BN._prime = function prime (name) {
    // Cached version of prime
    if (primes[name]) return primes[name];

    var prime;
    if (name === 'k256') {
      prime = new K256();
    } else if (name === 'p224') {
      prime = new P224();
    } else if (name === 'p192') {
      prime = new P192();
    } else if (name === 'p25519') {
      prime = new P25519();
    } else {
      throw new Error('Unknown prime ' + name);
    }
    primes[name] = prime;

    return prime;
  };

  //
  // Base reduction engine
  //
  function Red (m) {
    if (typeof m === 'string') {
      var prime = BN._prime(m);
      this.m = prime.p;
      this.prime = prime;
    } else {
      assert(m.gtn(1), 'modulus must be greater than 1');
      this.m = m;
      this.prime = null;
    }
  }

  Red.prototype._verify1 = function _verify1 (a) {
    assert(a.negative === 0, 'red works only with positives');
    assert(a.red, 'red works only with red numbers');
  };

  Red.prototype._verify2 = function _verify2 (a, b) {
    assert((a.negative | b.negative) === 0, 'red works only with positives');
    assert(a.red && a.red === b.red,
      'red works only with red numbers');
  };

  Red.prototype.imod = function imod (a) {
    if (this.prime) return this.prime.ireduce(a)._forceRed(this);

    move(a, a.umod(this.m)._forceRed(this));
    return a;
  };

  Red.prototype.neg = function neg (a) {
    if (a.isZero()) {
      return a.clone();
    }

    return this.m.sub(a)._forceRed(this);
  };

  Red.prototype.add = function add (a, b) {
    this._verify2(a, b);

    var res = a.add(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.iadd = function iadd (a, b) {
    this._verify2(a, b);

    var res = a.iadd(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res;
  };

  Red.prototype.sub = function sub (a, b) {
    this._verify2(a, b);

    var res = a.sub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.isub = function isub (a, b) {
    this._verify2(a, b);

    var res = a.isub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res;
  };

  Red.prototype.shl = function shl (a, num) {
    this._verify1(a);
    return this.imod(a.ushln(num));
  };

  Red.prototype.imul = function imul (a, b) {
    this._verify2(a, b);
    return this.imod(a.imul(b));
  };

  Red.prototype.mul = function mul (a, b) {
    this._verify2(a, b);
    return this.imod(a.mul(b));
  };

  Red.prototype.isqr = function isqr (a) {
    return this.imul(a, a.clone());
  };

  Red.prototype.sqr = function sqr (a) {
    return this.mul(a, a);
  };

  Red.prototype.sqrt = function sqrt (a) {
    if (a.isZero()) return a.clone();

    var mod3 = this.m.andln(3);
    assert(mod3 % 2 === 1);

    // Fast case
    if (mod3 === 3) {
      var pow = this.m.add(new BN(1)).iushrn(2);
      return this.pow(a, pow);
    }

    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    //
    // Find Q and S, that Q * 2 ^ S = (P - 1)
    var q = this.m.subn(1);
    var s = 0;
    while (!q.isZero() && q.andln(1) === 0) {
      s++;
      q.iushrn(1);
    }
    assert(!q.isZero());

    var one = new BN(1).toRed(this);
    var nOne = one.redNeg();

    // Find quadratic non-residue
    // NOTE: Max is such because of generalized Riemann hypothesis.
    var lpow = this.m.subn(1).iushrn(1);
    var z = this.m.bitLength();
    z = new BN(2 * z * z).toRed(this);

    while (this.pow(z, lpow).cmp(nOne) !== 0) {
      z.redIAdd(nOne);
    }

    var c = this.pow(z, q);
    var r = this.pow(a, q.addn(1).iushrn(1));
    var t = this.pow(a, q);
    var m = s;
    while (t.cmp(one) !== 0) {
      var tmp = t;
      for (var i = 0; tmp.cmp(one) !== 0; i++) {
        tmp = tmp.redSqr();
      }
      assert(i < m);
      var b = this.pow(c, new BN(1).iushln(m - i - 1));

      r = r.redMul(b);
      c = b.redSqr();
      t = t.redMul(c);
      m = i;
    }

    return r;
  };

  Red.prototype.invm = function invm (a) {
    var inv = a._invmp(this.m);
    if (inv.negative !== 0) {
      inv.negative = 0;
      return this.imod(inv).redNeg();
    } else {
      return this.imod(inv);
    }
  };

  Red.prototype.pow = function pow (a, num) {
    if (num.isZero()) return new BN(1).toRed(this);
    if (num.cmpn(1) === 0) return a.clone();

    var windowSize = 4;
    var wnd = new Array(1 << windowSize);
    wnd[0] = new BN(1).toRed(this);
    wnd[1] = a;
    for (var i = 2; i < wnd.length; i++) {
      wnd[i] = this.mul(wnd[i - 1], a);
    }

    var res = wnd[0];
    var current = 0;
    var currentLen = 0;
    var start = num.bitLength() % 26;
    if (start === 0) {
      start = 26;
    }

    for (i = num.length - 1; i >= 0; i--) {
      var word = num.words[i];
      for (var j = start - 1; j >= 0; j--) {
        var bit = (word >> j) & 1;
        if (res !== wnd[0]) {
          res = this.sqr(res);
        }

        if (bit === 0 && current === 0) {
          currentLen = 0;
          continue;
        }

        current <<= 1;
        current |= bit;
        currentLen++;
        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

        res = this.mul(res, wnd[current]);
        currentLen = 0;
        current = 0;
      }
      start = 26;
    }

    return res;
  };

  Red.prototype.convertTo = function convertTo (num) {
    var r = num.umod(this.m);

    return r === num ? r.clone() : r;
  };

  Red.prototype.convertFrom = function convertFrom (num) {
    var res = num.clone();
    res.red = null;
    return res;
  };

  //
  // Montgomery method engine
  //

  BN.mont = function mont (num) {
    return new Mont(num);
  };

  function Mont (m) {
    Red.call(this, m);

    this.shift = this.m.bitLength();
    if (this.shift % 26 !== 0) {
      this.shift += 26 - (this.shift % 26);
    }

    this.r = new BN(1).iushln(this.shift);
    this.r2 = this.imod(this.r.sqr());
    this.rinv = this.r._invmp(this.m);

    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    this.minv = this.minv.umod(this.r);
    this.minv = this.r.sub(this.minv);
  }
  inherits(Mont, Red);

  Mont.prototype.convertTo = function convertTo (num) {
    return this.imod(num.ushln(this.shift));
  };

  Mont.prototype.convertFrom = function convertFrom (num) {
    var r = this.imod(num.mul(this.rinv));
    r.red = null;
    return r;
  };

  Mont.prototype.imul = function imul (a, b) {
    if (a.isZero() || b.isZero()) {
      a.words[0] = 0;
      a.length = 1;
      return a;
    }

    var t = a.imul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;

    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.mul = function mul (a, b) {
    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    var t = a.mul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;
    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.invm = function invm (a) {
    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    var res = this.imod(a._invmp(this.m).mul(this.r2));
    return res._forceRed(this);
  };
})( false || module, this);


/***/ }),

/***/ 751:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var hash = exports;

hash.utils = __webpack_require__(582);
hash.common = __webpack_require__(567);
hash.sha = __webpack_require__(306);
hash.ripemd = __webpack_require__(498);
hash.hmac = __webpack_require__(101);

// Proxy hash functions to the main object
hash.sha1 = hash.sha.sha1;
hash.sha256 = hash.sha.sha256;
hash.sha224 = hash.sha.sha224;
hash.sha384 = hash.sha.sha384;
hash.sha512 = hash.sha.sha512;
hash.ripemd160 = hash.ripemd.ripemd160;


/***/ }),

/***/ 567:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {



var utils = __webpack_require__(582);
var assert = __webpack_require__(111);

function BlockHash() {
  this.pending = null;
  this.pendingTotal = 0;
  this.blockSize = this.constructor.blockSize;
  this.outSize = this.constructor.outSize;
  this.hmacStrength = this.constructor.hmacStrength;
  this.padLength = this.constructor.padLength / 8;
  this.endian = 'big';

  this._delta8 = this.blockSize / 8;
  this._delta32 = this.blockSize / 32;
}
exports.BlockHash = BlockHash;

BlockHash.prototype.update = function update(msg, enc) {
  // Convert message to array, pad it, and join into 32bit blocks
  msg = utils.toArray(msg, enc);
  if (!this.pending)
    this.pending = msg;
  else
    this.pending = this.pending.concat(msg);
  this.pendingTotal += msg.length;

  // Enough data, try updating
  if (this.pending.length >= this._delta8) {
    msg = this.pending;

    // Process pending data in blocks
    var r = msg.length % this._delta8;
    this.pending = msg.slice(msg.length - r, msg.length);
    if (this.pending.length === 0)
      this.pending = null;

    msg = utils.join32(msg, 0, msg.length - r, this.endian);
    for (var i = 0; i < msg.length; i += this._delta32)
      this._update(msg, i, i + this._delta32);
  }

  return this;
};

BlockHash.prototype.digest = function digest(enc) {
  this.update(this._pad());
  assert(this.pending === null);

  return this._digest(enc);
};

BlockHash.prototype._pad = function pad() {
  var len = this.pendingTotal;
  var bytes = this._delta8;
  var k = bytes - ((len + this.padLength) % bytes);
  var res = new Array(k + this.padLength);
  res[0] = 0x80;
  for (var i = 1; i < k; i++)
    res[i] = 0;

  // Append length
  len <<= 3;
  if (this.endian === 'big') {
    for (var t = 8; t < this.padLength; t++)
      res[i++] = 0;

    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = (len >>> 24) & 0xff;
    res[i++] = (len >>> 16) & 0xff;
    res[i++] = (len >>> 8) & 0xff;
    res[i++] = len & 0xff;
  } else {
    res[i++] = len & 0xff;
    res[i++] = (len >>> 8) & 0xff;
    res[i++] = (len >>> 16) & 0xff;
    res[i++] = (len >>> 24) & 0xff;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;

    for (t = 8; t < this.padLength; t++)
      res[i++] = 0;
  }

  return res;
};


/***/ }),

/***/ 101:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {



var utils = __webpack_require__(582);
var assert = __webpack_require__(111);

function Hmac(hash, key, enc) {
  if (!(this instanceof Hmac))
    return new Hmac(hash, key, enc);
  this.Hash = hash;
  this.blockSize = hash.blockSize / 8;
  this.outSize = hash.outSize / 8;
  this.inner = null;
  this.outer = null;

  this._init(utils.toArray(key, enc));
}
module.exports = Hmac;

Hmac.prototype._init = function init(key) {
  // Shorten key, if needed
  if (key.length > this.blockSize)
    key = new this.Hash().update(key).digest();
  assert(key.length <= this.blockSize);

  // Add padding to key
  for (var i = key.length; i < this.blockSize; i++)
    key.push(0);

  for (i = 0; i < key.length; i++)
    key[i] ^= 0x36;
  this.inner = new this.Hash().update(key);

  // 0x36 ^ 0x5c = 0x6a
  for (i = 0; i < key.length; i++)
    key[i] ^= 0x6a;
  this.outer = new this.Hash().update(key);
};

Hmac.prototype.update = function update(msg, enc) {
  this.inner.update(msg, enc);
  return this;
};

Hmac.prototype.digest = function digest(enc) {
  this.outer.update(this.inner.digest());
  return this.outer.digest(enc);
};


/***/ }),

/***/ 498:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {



var utils = __webpack_require__(582);
var common = __webpack_require__(567);

var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_3 = utils.sum32_3;
var sum32_4 = utils.sum32_4;
var BlockHash = common.BlockHash;

function RIPEMD160() {
  if (!(this instanceof RIPEMD160))
    return new RIPEMD160();

  BlockHash.call(this);

  this.h = [ 0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0 ];
  this.endian = 'little';
}
utils.inherits(RIPEMD160, BlockHash);
exports.ripemd160 = RIPEMD160;

RIPEMD160.blockSize = 512;
RIPEMD160.outSize = 160;
RIPEMD160.hmacStrength = 192;
RIPEMD160.padLength = 64;

RIPEMD160.prototype._update = function update(msg, start) {
  var A = this.h[0];
  var B = this.h[1];
  var C = this.h[2];
  var D = this.h[3];
  var E = this.h[4];
  var Ah = A;
  var Bh = B;
  var Ch = C;
  var Dh = D;
  var Eh = E;
  for (var j = 0; j < 80; j++) {
    var T = sum32(
      rotl32(
        sum32_4(A, f(j, B, C, D), msg[r[j] + start], K(j)),
        s[j]),
      E);
    A = E;
    E = D;
    D = rotl32(C, 10);
    C = B;
    B = T;
    T = sum32(
      rotl32(
        sum32_4(Ah, f(79 - j, Bh, Ch, Dh), msg[rh[j] + start], Kh(j)),
        sh[j]),
      Eh);
    Ah = Eh;
    Eh = Dh;
    Dh = rotl32(Ch, 10);
    Ch = Bh;
    Bh = T;
  }
  T = sum32_3(this.h[1], C, Dh);
  this.h[1] = sum32_3(this.h[2], D, Eh);
  this.h[2] = sum32_3(this.h[3], E, Ah);
  this.h[3] = sum32_3(this.h[4], A, Bh);
  this.h[4] = sum32_3(this.h[0], B, Ch);
  this.h[0] = T;
};

RIPEMD160.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'little');
  else
    return utils.split32(this.h, 'little');
};

function f(j, x, y, z) {
  if (j <= 15)
    return x ^ y ^ z;
  else if (j <= 31)
    return (x & y) | ((~x) & z);
  else if (j <= 47)
    return (x | (~y)) ^ z;
  else if (j <= 63)
    return (x & z) | (y & (~z));
  else
    return x ^ (y | (~z));
}

function K(j) {
  if (j <= 15)
    return 0x00000000;
  else if (j <= 31)
    return 0x5a827999;
  else if (j <= 47)
    return 0x6ed9eba1;
  else if (j <= 63)
    return 0x8f1bbcdc;
  else
    return 0xa953fd4e;
}

function Kh(j) {
  if (j <= 15)
    return 0x50a28be6;
  else if (j <= 31)
    return 0x5c4dd124;
  else if (j <= 47)
    return 0x6d703ef3;
  else if (j <= 63)
    return 0x7a6d76e9;
  else
    return 0x00000000;
}

var r = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
  7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
  3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
  1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
  4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
];

var rh = [
  5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
  6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
  15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
  8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
  12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
];

var s = [
  11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
  7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
  11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
  11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
  9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
];

var sh = [
  8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
  9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
  9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
  15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
  8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
];


/***/ }),

/***/ 306:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {



exports.sha1 = __webpack_require__(598);
exports.sha224 = __webpack_require__(70);
exports.sha256 = __webpack_require__(373);
exports.sha384 = __webpack_require__(744);
exports.sha512 = __webpack_require__(708);


/***/ }),

/***/ 598:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {



var utils = __webpack_require__(582);
var common = __webpack_require__(567);
var shaCommon = __webpack_require__(474);

var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_5 = utils.sum32_5;
var ft_1 = shaCommon.ft_1;
var BlockHash = common.BlockHash;

var sha1_K = [
  0x5A827999, 0x6ED9EBA1,
  0x8F1BBCDC, 0xCA62C1D6
];

function SHA1() {
  if (!(this instanceof SHA1))
    return new SHA1();

  BlockHash.call(this);
  this.h = [
    0x67452301, 0xefcdab89, 0x98badcfe,
    0x10325476, 0xc3d2e1f0 ];
  this.W = new Array(80);
}

utils.inherits(SHA1, BlockHash);
module.exports = SHA1;

SHA1.blockSize = 512;
SHA1.outSize = 160;
SHA1.hmacStrength = 80;
SHA1.padLength = 64;

SHA1.prototype._update = function _update(msg, start) {
  var W = this.W;

  for (var i = 0; i < 16; i++)
    W[i] = msg[start + i];

  for(; i < W.length; i++)
    W[i] = rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);

  var a = this.h[0];
  var b = this.h[1];
  var c = this.h[2];
  var d = this.h[3];
  var e = this.h[4];

  for (i = 0; i < W.length; i++) {
    var s = ~~(i / 20);
    var t = sum32_5(rotl32(a, 5), ft_1(s, b, c, d), e, W[i], sha1_K[s]);
    e = d;
    d = c;
    c = rotl32(b, 30);
    b = a;
    a = t;
  }

  this.h[0] = sum32(this.h[0], a);
  this.h[1] = sum32(this.h[1], b);
  this.h[2] = sum32(this.h[2], c);
  this.h[3] = sum32(this.h[3], d);
  this.h[4] = sum32(this.h[4], e);
};

SHA1.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};


/***/ }),

/***/ 70:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {



var utils = __webpack_require__(582);
var SHA256 = __webpack_require__(373);

function SHA224() {
  if (!(this instanceof SHA224))
    return new SHA224();

  SHA256.call(this);
  this.h = [
    0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939,
    0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4 ];
}
utils.inherits(SHA224, SHA256);
module.exports = SHA224;

SHA224.blockSize = 512;
SHA224.outSize = 224;
SHA224.hmacStrength = 192;
SHA224.padLength = 64;

SHA224.prototype._digest = function digest(enc) {
  // Just truncate output
  if (enc === 'hex')
    return utils.toHex32(this.h.slice(0, 7), 'big');
  else
    return utils.split32(this.h.slice(0, 7), 'big');
};



/***/ }),

/***/ 373:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {



var utils = __webpack_require__(582);
var common = __webpack_require__(567);
var shaCommon = __webpack_require__(474);
var assert = __webpack_require__(111);

var sum32 = utils.sum32;
var sum32_4 = utils.sum32_4;
var sum32_5 = utils.sum32_5;
var ch32 = shaCommon.ch32;
var maj32 = shaCommon.maj32;
var s0_256 = shaCommon.s0_256;
var s1_256 = shaCommon.s1_256;
var g0_256 = shaCommon.g0_256;
var g1_256 = shaCommon.g1_256;

var BlockHash = common.BlockHash;

var sha256_K = [
  0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5,
  0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
  0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3,
  0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
  0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc,
  0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
  0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7,
  0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
  0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13,
  0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
  0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3,
  0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
  0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5,
  0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
  0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208,
  0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
];

function SHA256() {
  if (!(this instanceof SHA256))
    return new SHA256();

  BlockHash.call(this);
  this.h = [
    0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a,
    0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19
  ];
  this.k = sha256_K;
  this.W = new Array(64);
}
utils.inherits(SHA256, BlockHash);
module.exports = SHA256;

SHA256.blockSize = 512;
SHA256.outSize = 256;
SHA256.hmacStrength = 192;
SHA256.padLength = 64;

SHA256.prototype._update = function _update(msg, start) {
  var W = this.W;

  for (var i = 0; i < 16; i++)
    W[i] = msg[start + i];
  for (; i < W.length; i++)
    W[i] = sum32_4(g1_256(W[i - 2]), W[i - 7], g0_256(W[i - 15]), W[i - 16]);

  var a = this.h[0];
  var b = this.h[1];
  var c = this.h[2];
  var d = this.h[3];
  var e = this.h[4];
  var f = this.h[5];
  var g = this.h[6];
  var h = this.h[7];

  assert(this.k.length === W.length);
  for (i = 0; i < W.length; i++) {
    var T1 = sum32_5(h, s1_256(e), ch32(e, f, g), this.k[i], W[i]);
    var T2 = sum32(s0_256(a), maj32(a, b, c));
    h = g;
    g = f;
    f = e;
    e = sum32(d, T1);
    d = c;
    c = b;
    b = a;
    a = sum32(T1, T2);
  }

  this.h[0] = sum32(this.h[0], a);
  this.h[1] = sum32(this.h[1], b);
  this.h[2] = sum32(this.h[2], c);
  this.h[3] = sum32(this.h[3], d);
  this.h[4] = sum32(this.h[4], e);
  this.h[5] = sum32(this.h[5], f);
  this.h[6] = sum32(this.h[6], g);
  this.h[7] = sum32(this.h[7], h);
};

SHA256.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};


/***/ }),

/***/ 744:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {



var utils = __webpack_require__(582);

var SHA512 = __webpack_require__(708);

function SHA384() {
  if (!(this instanceof SHA384))
    return new SHA384();

  SHA512.call(this);
  this.h = [
    0xcbbb9d5d, 0xc1059ed8,
    0x629a292a, 0x367cd507,
    0x9159015a, 0x3070dd17,
    0x152fecd8, 0xf70e5939,
    0x67332667, 0xffc00b31,
    0x8eb44a87, 0x68581511,
    0xdb0c2e0d, 0x64f98fa7,
    0x47b5481d, 0xbefa4fa4 ];
}
utils.inherits(SHA384, SHA512);
module.exports = SHA384;

SHA384.blockSize = 1024;
SHA384.outSize = 384;
SHA384.hmacStrength = 192;
SHA384.padLength = 128;

SHA384.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h.slice(0, 12), 'big');
  else
    return utils.split32(this.h.slice(0, 12), 'big');
};


/***/ }),

/***/ 708:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {



var utils = __webpack_require__(582);
var common = __webpack_require__(567);
var assert = __webpack_require__(111);

var rotr64_hi = utils.rotr64_hi;
var rotr64_lo = utils.rotr64_lo;
var shr64_hi = utils.shr64_hi;
var shr64_lo = utils.shr64_lo;
var sum64 = utils.sum64;
var sum64_hi = utils.sum64_hi;
var sum64_lo = utils.sum64_lo;
var sum64_4_hi = utils.sum64_4_hi;
var sum64_4_lo = utils.sum64_4_lo;
var sum64_5_hi = utils.sum64_5_hi;
var sum64_5_lo = utils.sum64_5_lo;

var BlockHash = common.BlockHash;

var sha512_K = [
  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
];

function SHA512() {
  if (!(this instanceof SHA512))
    return new SHA512();

  BlockHash.call(this);
  this.h = [
    0x6a09e667, 0xf3bcc908,
    0xbb67ae85, 0x84caa73b,
    0x3c6ef372, 0xfe94f82b,
    0xa54ff53a, 0x5f1d36f1,
    0x510e527f, 0xade682d1,
    0x9b05688c, 0x2b3e6c1f,
    0x1f83d9ab, 0xfb41bd6b,
    0x5be0cd19, 0x137e2179 ];
  this.k = sha512_K;
  this.W = new Array(160);
}
utils.inherits(SHA512, BlockHash);
module.exports = SHA512;

SHA512.blockSize = 1024;
SHA512.outSize = 512;
SHA512.hmacStrength = 192;
SHA512.padLength = 128;

SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
  var W = this.W;

  // 32 x 32bit words
  for (var i = 0; i < 32; i++)
    W[i] = msg[start + i];
  for (; i < W.length; i += 2) {
    var c0_hi = g1_512_hi(W[i - 4], W[i - 3]);  // i - 2
    var c0_lo = g1_512_lo(W[i - 4], W[i - 3]);
    var c1_hi = W[i - 14];  // i - 7
    var c1_lo = W[i - 13];
    var c2_hi = g0_512_hi(W[i - 30], W[i - 29]);  // i - 15
    var c2_lo = g0_512_lo(W[i - 30], W[i - 29]);
    var c3_hi = W[i - 32];  // i - 16
    var c3_lo = W[i - 31];

    W[i] = sum64_4_hi(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo);
    W[i + 1] = sum64_4_lo(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo);
  }
};

SHA512.prototype._update = function _update(msg, start) {
  this._prepareBlock(msg, start);

  var W = this.W;

  var ah = this.h[0];
  var al = this.h[1];
  var bh = this.h[2];
  var bl = this.h[3];
  var ch = this.h[4];
  var cl = this.h[5];
  var dh = this.h[6];
  var dl = this.h[7];
  var eh = this.h[8];
  var el = this.h[9];
  var fh = this.h[10];
  var fl = this.h[11];
  var gh = this.h[12];
  var gl = this.h[13];
  var hh = this.h[14];
  var hl = this.h[15];

  assert(this.k.length === W.length);
  for (var i = 0; i < W.length; i += 2) {
    var c0_hi = hh;
    var c0_lo = hl;
    var c1_hi = s1_512_hi(eh, el);
    var c1_lo = s1_512_lo(eh, el);
    var c2_hi = ch64_hi(eh, el, fh, fl, gh, gl);
    var c2_lo = ch64_lo(eh, el, fh, fl, gh, gl);
    var c3_hi = this.k[i];
    var c3_lo = this.k[i + 1];
    var c4_hi = W[i];
    var c4_lo = W[i + 1];

    var T1_hi = sum64_5_hi(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo,
      c4_hi, c4_lo);
    var T1_lo = sum64_5_lo(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo,
      c4_hi, c4_lo);

    c0_hi = s0_512_hi(ah, al);
    c0_lo = s0_512_lo(ah, al);
    c1_hi = maj64_hi(ah, al, bh, bl, ch, cl);
    c1_lo = maj64_lo(ah, al, bh, bl, ch, cl);

    var T2_hi = sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
    var T2_lo = sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);

    hh = gh;
    hl = gl;

    gh = fh;
    gl = fl;

    fh = eh;
    fl = el;

    eh = sum64_hi(dh, dl, T1_hi, T1_lo);
    el = sum64_lo(dl, dl, T1_hi, T1_lo);

    dh = ch;
    dl = cl;

    ch = bh;
    cl = bl;

    bh = ah;
    bl = al;

    ah = sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
    al = sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
  }

  sum64(this.h, 0, ah, al);
  sum64(this.h, 2, bh, bl);
  sum64(this.h, 4, ch, cl);
  sum64(this.h, 6, dh, dl);
  sum64(this.h, 8, eh, el);
  sum64(this.h, 10, fh, fl);
  sum64(this.h, 12, gh, gl);
  sum64(this.h, 14, hh, hl);
};

SHA512.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};

function ch64_hi(xh, xl, yh, yl, zh) {
  var r = (xh & yh) ^ ((~xh) & zh);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function ch64_lo(xh, xl, yh, yl, zh, zl) {
  var r = (xl & yl) ^ ((~xl) & zl);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function maj64_hi(xh, xl, yh, yl, zh) {
  var r = (xh & yh) ^ (xh & zh) ^ (yh & zh);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function maj64_lo(xh, xl, yh, yl, zh, zl) {
  var r = (xl & yl) ^ (xl & zl) ^ (yl & zl);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s0_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 28);
  var c1_hi = rotr64_hi(xl, xh, 2);  // 34
  var c2_hi = rotr64_hi(xl, xh, 7);  // 39

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s0_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 28);
  var c1_lo = rotr64_lo(xl, xh, 2);  // 34
  var c2_lo = rotr64_lo(xl, xh, 7);  // 39

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s1_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 14);
  var c1_hi = rotr64_hi(xh, xl, 18);
  var c2_hi = rotr64_hi(xl, xh, 9);  // 41

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s1_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 14);
  var c1_lo = rotr64_lo(xh, xl, 18);
  var c2_lo = rotr64_lo(xl, xh, 9);  // 41

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g0_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 1);
  var c1_hi = rotr64_hi(xh, xl, 8);
  var c2_hi = shr64_hi(xh, xl, 7);

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g0_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 1);
  var c1_lo = rotr64_lo(xh, xl, 8);
  var c2_lo = shr64_lo(xh, xl, 7);

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g1_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 19);
  var c1_hi = rotr64_hi(xl, xh, 29);  // 61
  var c2_hi = shr64_hi(xh, xl, 6);

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g1_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 19);
  var c1_lo = rotr64_lo(xl, xh, 29);  // 61
  var c2_lo = shr64_lo(xh, xl, 6);

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}


/***/ }),

/***/ 474:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {



var utils = __webpack_require__(582);
var rotr32 = utils.rotr32;

function ft_1(s, x, y, z) {
  if (s === 0)
    return ch32(x, y, z);
  if (s === 1 || s === 3)
    return p32(x, y, z);
  if (s === 2)
    return maj32(x, y, z);
}
exports.ft_1 = ft_1;

function ch32(x, y, z) {
  return (x & y) ^ ((~x) & z);
}
exports.ch32 = ch32;

function maj32(x, y, z) {
  return (x & y) ^ (x & z) ^ (y & z);
}
exports.maj32 = maj32;

function p32(x, y, z) {
  return x ^ y ^ z;
}
exports.p32 = p32;

function s0_256(x) {
  return rotr32(x, 2) ^ rotr32(x, 13) ^ rotr32(x, 22);
}
exports.s0_256 = s0_256;

function s1_256(x) {
  return rotr32(x, 6) ^ rotr32(x, 11) ^ rotr32(x, 25);
}
exports.s1_256 = s1_256;

function g0_256(x) {
  return rotr32(x, 7) ^ rotr32(x, 18) ^ (x >>> 3);
}
exports.g0_256 = g0_256;

function g1_256(x) {
  return rotr32(x, 17) ^ rotr32(x, 19) ^ (x >>> 10);
}
exports.g1_256 = g1_256;


/***/ }),

/***/ 582:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {



var assert = __webpack_require__(111);
var inherits = __webpack_require__(937);

exports.inherits = inherits;

function isSurrogatePair(msg, i) {
  if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) {
    return false;
  }
  if (i < 0 || i + 1 >= msg.length) {
    return false;
  }
  return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}

function toArray(msg, enc) {
  if (Array.isArray(msg))
    return msg.slice();
  if (!msg)
    return [];
  var res = [];
  if (typeof msg === 'string') {
    if (!enc) {
      // Inspired by stringToUtf8ByteArray() in closure-library by Google
      // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
      // Apache License 2.0
      // https://github.com/google/closure-library/blob/master/LICENSE
      var p = 0;
      for (var i = 0; i < msg.length; i++) {
        var c = msg.charCodeAt(i);
        if (c < 128) {
          res[p++] = c;
        } else if (c < 2048) {
          res[p++] = (c >> 6) | 192;
          res[p++] = (c & 63) | 128;
        } else if (isSurrogatePair(msg, i)) {
          c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
          res[p++] = (c >> 18) | 240;
          res[p++] = ((c >> 12) & 63) | 128;
          res[p++] = ((c >> 6) & 63) | 128;
          res[p++] = (c & 63) | 128;
        } else {
          res[p++] = (c >> 12) | 224;
          res[p++] = ((c >> 6) & 63) | 128;
          res[p++] = (c & 63) | 128;
        }
      }
    } else if (enc === 'hex') {
      msg = msg.replace(/[^a-z0-9]+/ig, '');
      if (msg.length % 2 !== 0)
        msg = '0' + msg;
      for (i = 0; i < msg.length; i += 2)
        res.push(parseInt(msg[i] + msg[i + 1], 16));
    }
  } else {
    for (i = 0; i < msg.length; i++)
      res[i] = msg[i] | 0;
  }
  return res;
}
exports.toArray = toArray;

function toHex(msg) {
  var res = '';
  for (var i = 0; i < msg.length; i++)
    res += zero2(msg[i].toString(16));
  return res;
}
exports.toHex = toHex;

function htonl(w) {
  var res = (w >>> 24) |
            ((w >>> 8) & 0xff00) |
            ((w << 8) & 0xff0000) |
            ((w & 0xff) << 24);
  return res >>> 0;
}
exports.htonl = htonl;

function toHex32(msg, endian) {
  var res = '';
  for (var i = 0; i < msg.length; i++) {
    var w = msg[i];
    if (endian === 'little')
      w = htonl(w);
    res += zero8(w.toString(16));
  }
  return res;
}
exports.toHex32 = toHex32;

function zero2(word) {
  if (word.length === 1)
    return '0' + word;
  else
    return word;
}
exports.zero2 = zero2;

function zero8(word) {
  if (word.length === 7)
    return '0' + word;
  else if (word.length === 6)
    return '00' + word;
  else if (word.length === 5)
    return '000' + word;
  else if (word.length === 4)
    return '0000' + word;
  else if (word.length === 3)
    return '00000' + word;
  else if (word.length === 2)
    return '000000' + word;
  else if (word.length === 1)
    return '0000000' + word;
  else
    return word;
}
exports.zero8 = zero8;

function join32(msg, start, end, endian) {
  var len = end - start;
  assert(len % 4 === 0);
  var res = new Array(len / 4);
  for (var i = 0, k = start; i < res.length; i++, k += 4) {
    var w;
    if (endian === 'big')
      w = (msg[k] << 24) | (msg[k + 1] << 16) | (msg[k + 2] << 8) | msg[k + 3];
    else
      w = (msg[k + 3] << 24) | (msg[k + 2] << 16) | (msg[k + 1] << 8) | msg[k];
    res[i] = w >>> 0;
  }
  return res;
}
exports.join32 = join32;

function split32(msg, endian) {
  var res = new Array(msg.length * 4);
  for (var i = 0, k = 0; i < msg.length; i++, k += 4) {
    var m = msg[i];
    if (endian === 'big') {
      res[k] = m >>> 24;
      res[k + 1] = (m >>> 16) & 0xff;
      res[k + 2] = (m >>> 8) & 0xff;
      res[k + 3] = m & 0xff;
    } else {
      res[k + 3] = m >>> 24;
      res[k + 2] = (m >>> 16) & 0xff;
      res[k + 1] = (m >>> 8) & 0xff;
      res[k] = m & 0xff;
    }
  }
  return res;
}
exports.split32 = split32;

function rotr32(w, b) {
  return (w >>> b) | (w << (32 - b));
}
exports.rotr32 = rotr32;

function rotl32(w, b) {
  return (w << b) | (w >>> (32 - b));
}
exports.rotl32 = rotl32;

function sum32(a, b) {
  return (a + b) >>> 0;
}
exports.sum32 = sum32;

function sum32_3(a, b, c) {
  return (a + b + c) >>> 0;
}
exports.sum32_3 = sum32_3;

function sum32_4(a, b, c, d) {
  return (a + b + c + d) >>> 0;
}
exports.sum32_4 = sum32_4;

function sum32_5(a, b, c, d, e) {
  return (a + b + c + d + e) >>> 0;
}
exports.sum32_5 = sum32_5;

function sum64(buf, pos, ah, al) {
  var bh = buf[pos];
  var bl = buf[pos + 1];

  var lo = (al + bl) >>> 0;
  var hi = (lo < al ? 1 : 0) + ah + bh;
  buf[pos] = hi >>> 0;
  buf[pos + 1] = lo;
}
exports.sum64 = sum64;

function sum64_hi(ah, al, bh, bl) {
  var lo = (al + bl) >>> 0;
  var hi = (lo < al ? 1 : 0) + ah + bh;
  return hi >>> 0;
}
exports.sum64_hi = sum64_hi;

function sum64_lo(ah, al, bh, bl) {
  var lo = al + bl;
  return lo >>> 0;
}
exports.sum64_lo = sum64_lo;

function sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
  var carry = 0;
  var lo = al;
  lo = (lo + bl) >>> 0;
  carry += lo < al ? 1 : 0;
  lo = (lo + cl) >>> 0;
  carry += lo < cl ? 1 : 0;
  lo = (lo + dl) >>> 0;
  carry += lo < dl ? 1 : 0;

  var hi = ah + bh + ch + dh + carry;
  return hi >>> 0;
}
exports.sum64_4_hi = sum64_4_hi;

function sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
  var lo = al + bl + cl + dl;
  return lo >>> 0;
}
exports.sum64_4_lo = sum64_4_lo;

function sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
  var carry = 0;
  var lo = al;
  lo = (lo + bl) >>> 0;
  carry += lo < al ? 1 : 0;
  lo = (lo + cl) >>> 0;
  carry += lo < cl ? 1 : 0;
  lo = (lo + dl) >>> 0;
  carry += lo < dl ? 1 : 0;
  lo = (lo + el) >>> 0;
  carry += lo < el ? 1 : 0;

  var hi = ah + bh + ch + dh + eh + carry;
  return hi >>> 0;
}
exports.sum64_5_hi = sum64_5_hi;

function sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
  var lo = al + bl + cl + dl + el;

  return lo >>> 0;
}
exports.sum64_5_lo = sum64_5_lo;

function rotr64_hi(ah, al, num) {
  var r = (al << (32 - num)) | (ah >>> num);
  return r >>> 0;
}
exports.rotr64_hi = rotr64_hi;

function rotr64_lo(ah, al, num) {
  var r = (ah << (32 - num)) | (al >>> num);
  return r >>> 0;
}
exports.rotr64_lo = rotr64_lo;

function shr64_hi(ah, al, num) {
  return ah >>> num;
}
exports.shr64_hi = shr64_hi;

function shr64_lo(ah, al, num) {
  var r = (ah << (32 - num)) | (al >>> num);
  return r >>> 0;
}
exports.shr64_lo = shr64_lo;


/***/ }),

/***/ 937:
/***/ ((module) => {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      })
    }
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      var TempCtor = function () {}
      TempCtor.prototype = superCtor.prototype
      ctor.prototype = new TempCtor()
      ctor.prototype.constructor = ctor
    }
  }
}


/***/ }),

/***/ 969:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// the whatwg-fetch polyfill installs the fetch() function
// on the global object (window or self)
//
// Return that as the export for use in Webpack, Browserify etc.
__webpack_require__(622);
module.exports = self.fetch.bind(self);


/***/ }),

/***/ 954:
/***/ ((module, exports, __webpack_require__) => {

var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * [js-sha3]{@link https://github.com/emn178/js-sha3}
 *
 * @version 0.8.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2015-2018
 * @license MIT
 */
/*jslint bitwise: true */
(function () {
  'use strict';

  var INPUT_ERROR = 'input is invalid type';
  var FINALIZE_ERROR = 'finalize already called';
  var WINDOW = typeof window === 'object';
  var root = WINDOW ? window : {};
  if (root.JS_SHA3_NO_WINDOW) {
    WINDOW = false;
  }
  var WEB_WORKER = !WINDOW && typeof self === 'object';
  var NODE_JS = !root.JS_SHA3_NO_NODE_JS && typeof process === 'object' && process.versions && process.versions.node;
  if (NODE_JS) {
    root = __webpack_require__.g;
  } else if (WEB_WORKER) {
    root = self;
  }
  var COMMON_JS = !root.JS_SHA3_NO_COMMON_JS && "object" === 'object' && module.exports;
  var AMD =  true && __webpack_require__.amdO;
  var ARRAY_BUFFER = !root.JS_SHA3_NO_ARRAY_BUFFER && typeof ArrayBuffer !== 'undefined';
  var HEX_CHARS = '0123456789abcdef'.split('');
  var SHAKE_PADDING = [31, 7936, 2031616, 520093696];
  var CSHAKE_PADDING = [4, 1024, 262144, 67108864];
  var KECCAK_PADDING = [1, 256, 65536, 16777216];
  var PADDING = [6, 1536, 393216, 100663296];
  var SHIFT = [0, 8, 16, 24];
  var RC = [1, 0, 32898, 0, 32906, 2147483648, 2147516416, 2147483648, 32907, 0, 2147483649,
    0, 2147516545, 2147483648, 32777, 2147483648, 138, 0, 136, 0, 2147516425, 0,
    2147483658, 0, 2147516555, 0, 139, 2147483648, 32905, 2147483648, 32771,
    2147483648, 32770, 2147483648, 128, 2147483648, 32778, 0, 2147483658, 2147483648,
    2147516545, 2147483648, 32896, 2147483648, 2147483649, 0, 2147516424, 2147483648];
  var BITS = [224, 256, 384, 512];
  var SHAKE_BITS = [128, 256];
  var OUTPUT_TYPES = ['hex', 'buffer', 'arrayBuffer', 'array', 'digest'];
  var CSHAKE_BYTEPAD = {
    '128': 168,
    '256': 136
  };

  if (root.JS_SHA3_NO_NODE_JS || !Array.isArray) {
    Array.isArray = function (obj) {
      return Object.prototype.toString.call(obj) === '[object Array]';
    };
  }

  if (ARRAY_BUFFER && (root.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) {
    ArrayBuffer.isView = function (obj) {
      return typeof obj === 'object' && obj.buffer && obj.buffer.constructor === ArrayBuffer;
    };
  }

  var createOutputMethod = function (bits, padding, outputType) {
    return function (message) {
      return new Keccak(bits, padding, bits).update(message)[outputType]();
    };
  };

  var createShakeOutputMethod = function (bits, padding, outputType) {
    return function (message, outputBits) {
      return new Keccak(bits, padding, outputBits).update(message)[outputType]();
    };
  };

  var createCshakeOutputMethod = function (bits, padding, outputType) {
    return function (message, outputBits, n, s) {
      return methods['cshake' + bits].update(message, outputBits, n, s)[outputType]();
    };
  };

  var createKmacOutputMethod = function (bits, padding, outputType) {
    return function (key, message, outputBits, s) {
      return methods['kmac' + bits].update(key, message, outputBits, s)[outputType]();
    };
  };

  var createOutputMethods = function (method, createMethod, bits, padding) {
    for (var i = 0; i < OUTPUT_TYPES.length; ++i) {
      var type = OUTPUT_TYPES[i];
      method[type] = createMethod(bits, padding, type);
    }
    return method;
  };

  var createMethod = function (bits, padding) {
    var method = createOutputMethod(bits, padding, 'hex');
    method.create = function () {
      return new Keccak(bits, padding, bits);
    };
    method.update = function (message) {
      return method.create().update(message);
    };
    return createOutputMethods(method, createOutputMethod, bits, padding);
  };

  var createShakeMethod = function (bits, padding) {
    var method = createShakeOutputMethod(bits, padding, 'hex');
    method.create = function (outputBits) {
      return new Keccak(bits, padding, outputBits);
    };
    method.update = function (message, outputBits) {
      return method.create(outputBits).update(message);
    };
    return createOutputMethods(method, createShakeOutputMethod, bits, padding);
  };

  var createCshakeMethod = function (bits, padding) {
    var w = CSHAKE_BYTEPAD[bits];
    var method = createCshakeOutputMethod(bits, padding, 'hex');
    method.create = function (outputBits, n, s) {
      if (!n && !s) {
        return methods['shake' + bits].create(outputBits);
      } else {
        return new Keccak(bits, padding, outputBits).bytepad([n, s], w);
      }
    };
    method.update = function (message, outputBits, n, s) {
      return method.create(outputBits, n, s).update(message);
    };
    return createOutputMethods(method, createCshakeOutputMethod, bits, padding);
  };

  var createKmacMethod = function (bits, padding) {
    var w = CSHAKE_BYTEPAD[bits];
    var method = createKmacOutputMethod(bits, padding, 'hex');
    method.create = function (key, outputBits, s) {
      return new Kmac(bits, padding, outputBits).bytepad(['KMAC', s], w).bytepad([key], w);
    };
    method.update = function (key, message, outputBits, s) {
      return method.create(key, outputBits, s).update(message);
    };
    return createOutputMethods(method, createKmacOutputMethod, bits, padding);
  };

  var algorithms = [
    { name: 'keccak', padding: KECCAK_PADDING, bits: BITS, createMethod: createMethod },
    { name: 'sha3', padding: PADDING, bits: BITS, createMethod: createMethod },
    { name: 'shake', padding: SHAKE_PADDING, bits: SHAKE_BITS, createMethod: createShakeMethod },
    { name: 'cshake', padding: CSHAKE_PADDING, bits: SHAKE_BITS, createMethod: createCshakeMethod },
    { name: 'kmac', padding: CSHAKE_PADDING, bits: SHAKE_BITS, createMethod: createKmacMethod }
  ];

  var methods = {}, methodNames = [];

  for (var i = 0; i < algorithms.length; ++i) {
    var algorithm = algorithms[i];
    var bits = algorithm.bits;
    for (var j = 0; j < bits.length; ++j) {
      var methodName = algorithm.name + '_' + bits[j];
      methodNames.push(methodName);
      methods[methodName] = algorithm.createMethod(bits[j], algorithm.padding);
      if (algorithm.name !== 'sha3') {
        var newMethodName = algorithm.name + bits[j];
        methodNames.push(newMethodName);
        methods[newMethodName] = methods[methodName];
      }
    }
  }

  function Keccak(bits, padding, outputBits) {
    this.blocks = [];
    this.s = [];
    this.padding = padding;
    this.outputBits = outputBits;
    this.reset = true;
    this.finalized = false;
    this.block = 0;
    this.start = 0;
    this.blockCount = (1600 - (bits << 1)) >> 5;
    this.byteCount = this.blockCount << 2;
    this.outputBlocks = outputBits >> 5;
    this.extraBytes = (outputBits & 31) >> 3;

    for (var i = 0; i < 50; ++i) {
      this.s[i] = 0;
    }
  }

  Keccak.prototype.update = function (message) {
    if (this.finalized) {
      throw new Error(FINALIZE_ERROR);
    }
    var notString, type = typeof message;
    if (type !== 'string') {
      if (type === 'object') {
        if (message === null) {
          throw new Error(INPUT_ERROR);
        } else if (ARRAY_BUFFER && message.constructor === ArrayBuffer) {
          message = new Uint8Array(message);
        } else if (!Array.isArray(message)) {
          if (!ARRAY_BUFFER || !ArrayBuffer.isView(message)) {
            throw new Error(INPUT_ERROR);
          }
        }
      } else {
        throw new Error(INPUT_ERROR);
      }
      notString = true;
    }
    var blocks = this.blocks, byteCount = this.byteCount, length = message.length,
      blockCount = this.blockCount, index = 0, s = this.s, i, code;

    while (index < length) {
      if (this.reset) {
        this.reset = false;
        blocks[0] = this.block;
        for (i = 1; i < blockCount + 1; ++i) {
          blocks[i] = 0;
        }
      }
      if (notString) {
        for (i = this.start; index < length && i < byteCount; ++index) {
          blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
        }
      } else {
        for (i = this.start; index < length && i < byteCount; ++index) {
          code = message.charCodeAt(index);
          if (code < 0x80) {
            blocks[i >> 2] |= code << SHIFT[i++ & 3];
          } else if (code < 0x800) {
            blocks[i >> 2] |= (0xc0 | (code >> 6)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | (code & 0x3f)) << SHIFT[i++ & 3];
          } else if (code < 0xd800 || code >= 0xe000) {
            blocks[i >> 2] |= (0xe0 | (code >> 12)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | ((code >> 6) & 0x3f)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | (code & 0x3f)) << SHIFT[i++ & 3];
          } else {
            code = 0x10000 + (((code & 0x3ff) << 10) | (message.charCodeAt(++index) & 0x3ff));
            blocks[i >> 2] |= (0xf0 | (code >> 18)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | ((code >> 12) & 0x3f)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | ((code >> 6) & 0x3f)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | (code & 0x3f)) << SHIFT[i++ & 3];
          }
        }
      }
      this.lastByteIndex = i;
      if (i >= byteCount) {
        this.start = i - byteCount;
        this.block = blocks[blockCount];
        for (i = 0; i < blockCount; ++i) {
          s[i] ^= blocks[i];
        }
        f(s);
        this.reset = true;
      } else {
        this.start = i;
      }
    }
    return this;
  };

  Keccak.prototype.encode = function (x, right) {
    var o = x & 255, n = 1;
    var bytes = [o];
    x = x >> 8;
    o = x & 255;
    while (o > 0) {
      bytes.unshift(o);
      x = x >> 8;
      o = x & 255;
      ++n;
    }
    if (right) {
      bytes.push(n);
    } else {
      bytes.unshift(n);
    }
    this.update(bytes);
    return bytes.length;
  };

  Keccak.prototype.encodeString = function (str) {
    var notString, type = typeof str;
    if (type !== 'string') {
      if (type === 'object') {
        if (str === null) {
          throw new Error(INPUT_ERROR);
        } else if (ARRAY_BUFFER && str.constructor === ArrayBuffer) {
          str = new Uint8Array(str);
        } else if (!Array.isArray(str)) {
          if (!ARRAY_BUFFER || !ArrayBuffer.isView(str)) {
            throw new Error(INPUT_ERROR);
          }
        }
      } else {
        throw new Error(INPUT_ERROR);
      }
      notString = true;
    }
    var bytes = 0, length = str.length;
    if (notString) {
      bytes = length;
    } else {
      for (var i = 0; i < str.length; ++i) {
        var code = str.charCodeAt(i);
        if (code < 0x80) {
          bytes += 1;
        } else if (code < 0x800) {
          bytes += 2;
        } else if (code < 0xd800 || code >= 0xe000) {
          bytes += 3;
        } else {
          code = 0x10000 + (((code & 0x3ff) << 10) | (str.charCodeAt(++i) & 0x3ff));
          bytes += 4;
        }
      }
    }
    bytes += this.encode(bytes * 8);
    this.update(str);
    return bytes;
  };

  Keccak.prototype.bytepad = function (strs, w) {
    var bytes = this.encode(w);
    for (var i = 0; i < strs.length; ++i) {
      bytes += this.encodeString(strs[i]);
    }
    var paddingBytes = w - bytes % w;
    var zeros = [];
    zeros.length = paddingBytes;
    this.update(zeros);
    return this;
  };

  Keccak.prototype.finalize = function () {
    if (this.finalized) {
      return;
    }
    this.finalized = true;
    var blocks = this.blocks, i = this.lastByteIndex, blockCount = this.blockCount, s = this.s;
    blocks[i >> 2] |= this.padding[i & 3];
    if (this.lastByteIndex === this.byteCount) {
      blocks[0] = blocks[blockCount];
      for (i = 1; i < blockCount + 1; ++i) {
        blocks[i] = 0;
      }
    }
    blocks[blockCount - 1] |= 0x80000000;
    for (i = 0; i < blockCount; ++i) {
      s[i] ^= blocks[i];
    }
    f(s);
  };

  Keccak.prototype.toString = Keccak.prototype.hex = function () {
    this.finalize();

    var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks,
      extraBytes = this.extraBytes, i = 0, j = 0;
    var hex = '', block;
    while (j < outputBlocks) {
      for (i = 0; i < blockCount && j < outputBlocks; ++i, ++j) {
        block = s[i];
        hex += HEX_CHARS[(block >> 4) & 0x0F] + HEX_CHARS[block & 0x0F] +
          HEX_CHARS[(block >> 12) & 0x0F] + HEX_CHARS[(block >> 8) & 0x0F] +
          HEX_CHARS[(block >> 20) & 0x0F] + HEX_CHARS[(block >> 16) & 0x0F] +
          HEX_CHARS[(block >> 28) & 0x0F] + HEX_CHARS[(block >> 24) & 0x0F];
      }
      if (j % blockCount === 0) {
        f(s);
        i = 0;
      }
    }
    if (extraBytes) {
      block = s[i];
      hex += HEX_CHARS[(block >> 4) & 0x0F] + HEX_CHARS[block & 0x0F];
      if (extraBytes > 1) {
        hex += HEX_CHARS[(block >> 12) & 0x0F] + HEX_CHARS[(block >> 8) & 0x0F];
      }
      if (extraBytes > 2) {
        hex += HEX_CHARS[(block >> 20) & 0x0F] + HEX_CHARS[(block >> 16) & 0x0F];
      }
    }
    return hex;
  };

  Keccak.prototype.arrayBuffer = function () {
    this.finalize();

    var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks,
      extraBytes = this.extraBytes, i = 0, j = 0;
    var bytes = this.outputBits >> 3;
    var buffer;
    if (extraBytes) {
      buffer = new ArrayBuffer((outputBlocks + 1) << 2);
    } else {
      buffer = new ArrayBuffer(bytes);
    }
    var array = new Uint32Array(buffer);
    while (j < outputBlocks) {
      for (i = 0; i < blockCount && j < outputBlocks; ++i, ++j) {
        array[j] = s[i];
      }
      if (j % blockCount === 0) {
        f(s);
      }
    }
    if (extraBytes) {
      array[i] = s[i];
      buffer = buffer.slice(0, bytes);
    }
    return buffer;
  };

  Keccak.prototype.buffer = Keccak.prototype.arrayBuffer;

  Keccak.prototype.digest = Keccak.prototype.array = function () {
    this.finalize();

    var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks,
      extraBytes = this.extraBytes, i = 0, j = 0;
    var array = [], offset, block;
    while (j < outputBlocks) {
      for (i = 0; i < blockCount && j < outputBlocks; ++i, ++j) {
        offset = j << 2;
        block = s[i];
        array[offset] = block & 0xFF;
        array[offset + 1] = (block >> 8) & 0xFF;
        array[offset + 2] = (block >> 16) & 0xFF;
        array[offset + 3] = (block >> 24) & 0xFF;
      }
      if (j % blockCount === 0) {
        f(s);
      }
    }
    if (extraBytes) {
      offset = j << 2;
      block = s[i];
      array[offset] = block & 0xFF;
      if (extraBytes > 1) {
        array[offset + 1] = (block >> 8) & 0xFF;
      }
      if (extraBytes > 2) {
        array[offset + 2] = (block >> 16) & 0xFF;
      }
    }
    return array;
  };

  function Kmac(bits, padding, outputBits) {
    Keccak.call(this, bits, padding, outputBits);
  }

  Kmac.prototype = new Keccak();

  Kmac.prototype.finalize = function () {
    this.encode(this.outputBits, true);
    return Keccak.prototype.finalize.call(this);
  };

  var f = function (s) {
    var h, l, n, c0, c1, c2, c3, c4, c5, c6, c7, c8, c9,
      b0, b1, b2, b3, b4, b5, b6, b7, b8, b9, b10, b11, b12, b13, b14, b15, b16, b17,
      b18, b19, b20, b21, b22, b23, b24, b25, b26, b27, b28, b29, b30, b31, b32, b33,
      b34, b35, b36, b37, b38, b39, b40, b41, b42, b43, b44, b45, b46, b47, b48, b49;
    for (n = 0; n < 48; n += 2) {
      c0 = s[0] ^ s[10] ^ s[20] ^ s[30] ^ s[40];
      c1 = s[1] ^ s[11] ^ s[21] ^ s[31] ^ s[41];
      c2 = s[2] ^ s[12] ^ s[22] ^ s[32] ^ s[42];
      c3 = s[3] ^ s[13] ^ s[23] ^ s[33] ^ s[43];
      c4 = s[4] ^ s[14] ^ s[24] ^ s[34] ^ s[44];
      c5 = s[5] ^ s[15] ^ s[25] ^ s[35] ^ s[45];
      c6 = s[6] ^ s[16] ^ s[26] ^ s[36] ^ s[46];
      c7 = s[7] ^ s[17] ^ s[27] ^ s[37] ^ s[47];
      c8 = s[8] ^ s[18] ^ s[28] ^ s[38] ^ s[48];
      c9 = s[9] ^ s[19] ^ s[29] ^ s[39] ^ s[49];

      h = c8 ^ ((c2 << 1) | (c3 >>> 31));
      l = c9 ^ ((c3 << 1) | (c2 >>> 31));
      s[0] ^= h;
      s[1] ^= l;
      s[10] ^= h;
      s[11] ^= l;
      s[20] ^= h;
      s[21] ^= l;
      s[30] ^= h;
      s[31] ^= l;
      s[40] ^= h;
      s[41] ^= l;
      h = c0 ^ ((c4 << 1) | (c5 >>> 31));
      l = c1 ^ ((c5 << 1) | (c4 >>> 31));
      s[2] ^= h;
      s[3] ^= l;
      s[12] ^= h;
      s[13] ^= l;
      s[22] ^= h;
      s[23] ^= l;
      s[32] ^= h;
      s[33] ^= l;
      s[42] ^= h;
      s[43] ^= l;
      h = c2 ^ ((c6 << 1) | (c7 >>> 31));
      l = c3 ^ ((c7 << 1) | (c6 >>> 31));
      s[4] ^= h;
      s[5] ^= l;
      s[14] ^= h;
      s[15] ^= l;
      s[24] ^= h;
      s[25] ^= l;
      s[34] ^= h;
      s[35] ^= l;
      s[44] ^= h;
      s[45] ^= l;
      h = c4 ^ ((c8 << 1) | (c9 >>> 31));
      l = c5 ^ ((c9 << 1) | (c8 >>> 31));
      s[6] ^= h;
      s[7] ^= l;
      s[16] ^= h;
      s[17] ^= l;
      s[26] ^= h;
      s[27] ^= l;
      s[36] ^= h;
      s[37] ^= l;
      s[46] ^= h;
      s[47] ^= l;
      h = c6 ^ ((c0 << 1) | (c1 >>> 31));
      l = c7 ^ ((c1 << 1) | (c0 >>> 31));
      s[8] ^= h;
      s[9] ^= l;
      s[18] ^= h;
      s[19] ^= l;
      s[28] ^= h;
      s[29] ^= l;
      s[38] ^= h;
      s[39] ^= l;
      s[48] ^= h;
      s[49] ^= l;

      b0 = s[0];
      b1 = s[1];
      b32 = (s[11] << 4) | (s[10] >>> 28);
      b33 = (s[10] << 4) | (s[11] >>> 28);
      b14 = (s[20] << 3) | (s[21] >>> 29);
      b15 = (s[21] << 3) | (s[20] >>> 29);
      b46 = (s[31] << 9) | (s[30] >>> 23);
      b47 = (s[30] << 9) | (s[31] >>> 23);
      b28 = (s[40] << 18) | (s[41] >>> 14);
      b29 = (s[41] << 18) | (s[40] >>> 14);
      b20 = (s[2] << 1) | (s[3] >>> 31);
      b21 = (s[3] << 1) | (s[2] >>> 31);
      b2 = (s[13] << 12) | (s[12] >>> 20);
      b3 = (s[12] << 12) | (s[13] >>> 20);
      b34 = (s[22] << 10) | (s[23] >>> 22);
      b35 = (s[23] << 10) | (s[22] >>> 22);
      b16 = (s[33] << 13) | (s[32] >>> 19);
      b17 = (s[32] << 13) | (s[33] >>> 19);
      b48 = (s[42] << 2) | (s[43] >>> 30);
      b49 = (s[43] << 2) | (s[42] >>> 30);
      b40 = (s[5] << 30) | (s[4] >>> 2);
      b41 = (s[4] << 30) | (s[5] >>> 2);
      b22 = (s[14] << 6) | (s[15] >>> 26);
      b23 = (s[15] << 6) | (s[14] >>> 26);
      b4 = (s[25] << 11) | (s[24] >>> 21);
      b5 = (s[24] << 11) | (s[25] >>> 21);
      b36 = (s[34] << 15) | (s[35] >>> 17);
      b37 = (s[35] << 15) | (s[34] >>> 17);
      b18 = (s[45] << 29) | (s[44] >>> 3);
      b19 = (s[44] << 29) | (s[45] >>> 3);
      b10 = (s[6] << 28) | (s[7] >>> 4);
      b11 = (s[7] << 28) | (s[6] >>> 4);
      b42 = (s[17] << 23) | (s[16] >>> 9);
      b43 = (s[16] << 23) | (s[17] >>> 9);
      b24 = (s[26] << 25) | (s[27] >>> 7);
      b25 = (s[27] << 25) | (s[26] >>> 7);
      b6 = (s[36] << 21) | (s[37] >>> 11);
      b7 = (s[37] << 21) | (s[36] >>> 11);
      b38 = (s[47] << 24) | (s[46] >>> 8);
      b39 = (s[46] << 24) | (s[47] >>> 8);
      b30 = (s[8] << 27) | (s[9] >>> 5);
      b31 = (s[9] << 27) | (s[8] >>> 5);
      b12 = (s[18] << 20) | (s[19] >>> 12);
      b13 = (s[19] << 20) | (s[18] >>> 12);
      b44 = (s[29] << 7) | (s[28] >>> 25);
      b45 = (s[28] << 7) | (s[29] >>> 25);
      b26 = (s[38] << 8) | (s[39] >>> 24);
      b27 = (s[39] << 8) | (s[38] >>> 24);
      b8 = (s[48] << 14) | (s[49] >>> 18);
      b9 = (s[49] << 14) | (s[48] >>> 18);

      s[0] = b0 ^ (~b2 & b4);
      s[1] = b1 ^ (~b3 & b5);
      s[10] = b10 ^ (~b12 & b14);
      s[11] = b11 ^ (~b13 & b15);
      s[20] = b20 ^ (~b22 & b24);
      s[21] = b21 ^ (~b23 & b25);
      s[30] = b30 ^ (~b32 & b34);
      s[31] = b31 ^ (~b33 & b35);
      s[40] = b40 ^ (~b42 & b44);
      s[41] = b41 ^ (~b43 & b45);
      s[2] = b2 ^ (~b4 & b6);
      s[3] = b3 ^ (~b5 & b7);
      s[12] = b12 ^ (~b14 & b16);
      s[13] = b13 ^ (~b15 & b17);
      s[22] = b22 ^ (~b24 & b26);
      s[23] = b23 ^ (~b25 & b27);
      s[32] = b32 ^ (~b34 & b36);
      s[33] = b33 ^ (~b35 & b37);
      s[42] = b42 ^ (~b44 & b46);
      s[43] = b43 ^ (~b45 & b47);
      s[4] = b4 ^ (~b6 & b8);
      s[5] = b5 ^ (~b7 & b9);
      s[14] = b14 ^ (~b16 & b18);
      s[15] = b15 ^ (~b17 & b19);
      s[24] = b24 ^ (~b26 & b28);
      s[25] = b25 ^ (~b27 & b29);
      s[34] = b34 ^ (~b36 & b38);
      s[35] = b35 ^ (~b37 & b39);
      s[44] = b44 ^ (~b46 & b48);
      s[45] = b45 ^ (~b47 & b49);
      s[6] = b6 ^ (~b8 & b0);
      s[7] = b7 ^ (~b9 & b1);
      s[16] = b16 ^ (~b18 & b10);
      s[17] = b17 ^ (~b19 & b11);
      s[26] = b26 ^ (~b28 & b20);
      s[27] = b27 ^ (~b29 & b21);
      s[36] = b36 ^ (~b38 & b30);
      s[37] = b37 ^ (~b39 & b31);
      s[46] = b46 ^ (~b48 & b40);
      s[47] = b47 ^ (~b49 & b41);
      s[8] = b8 ^ (~b0 & b2);
      s[9] = b9 ^ (~b1 & b3);
      s[18] = b18 ^ (~b10 & b12);
      s[19] = b19 ^ (~b11 & b13);
      s[28] = b28 ^ (~b20 & b22);
      s[29] = b29 ^ (~b21 & b23);
      s[38] = b38 ^ (~b30 & b32);
      s[39] = b39 ^ (~b31 & b33);
      s[48] = b48 ^ (~b40 & b42);
      s[49] = b49 ^ (~b41 & b43);

      s[0] ^= RC[n];
      s[1] ^= RC[n + 1];
    }
  };

  if (COMMON_JS) {
    module.exports = methods;
  } else {
    for (i = 0; i < methodNames.length; ++i) {
      root[methodNames[i]] = methods[methodNames[i]];
    }
    if (AMD) {
      !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
        return methods;
      }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    }
  }
})();


/***/ }),

/***/ 111:
/***/ ((module) => {

module.exports = assert;

function assert(val, msg) {
  if (!val)
    throw new Error(msg || 'Assertion failed');
}

assert.equal = function assertEqual(l, r, msg) {
  if (l != r)
    throw new Error(msg || ('Assertion failed: ' + l + ' != ' + r));
};


/***/ }),

/***/ 495:
/***/ (function(module) {



(function(root) {
    const MAX_VALUE = 0x7fffffff;

    // The SHA256 and PBKDF2 implementation are from scrypt-async-js:
    // See: https://github.com/dchest/scrypt-async-js
    function SHA256(m) {
        const K = new Uint32Array([
           0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5, 0x3956c25b,
           0x59f111f1, 0x923f82a4, 0xab1c5ed5, 0xd807aa98, 0x12835b01,
           0x243185be, 0x550c7dc3, 0x72be5d74, 0x80deb1fe, 0x9bdc06a7,
           0xc19bf174, 0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc,
           0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da, 0x983e5152,
           0xa831c66d, 0xb00327c8, 0xbf597fc7, 0xc6e00bf3, 0xd5a79147,
           0x06ca6351, 0x14292967, 0x27b70a85, 0x2e1b2138, 0x4d2c6dfc,
           0x53380d13, 0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
           0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3, 0xd192e819,
           0xd6990624, 0xf40e3585, 0x106aa070, 0x19a4c116, 0x1e376c08,
           0x2748774c, 0x34b0bcb5, 0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f,
           0x682e6ff3, 0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208,
           0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
       ]);

        let h0 = 0x6a09e667, h1 = 0xbb67ae85, h2 = 0x3c6ef372, h3 = 0xa54ff53a;
        let h4 = 0x510e527f, h5 = 0x9b05688c, h6 = 0x1f83d9ab, h7 = 0x5be0cd19;
        const w = new Uint32Array(64);

        function blocks(p) {
            let off = 0, len = p.length;
            while (len >= 64) {
                let a = h0, b = h1, c = h2, d = h3, e = h4, f = h5, g = h6, h = h7, u, i, j, t1, t2;

                for (i = 0; i < 16; i++) {
                    j = off + i*4;
                    w[i] = ((p[j] & 0xff)<<24) | ((p[j+1] & 0xff)<<16) |
                    ((p[j+2] & 0xff)<<8) | (p[j+3] & 0xff);
                }

                for (i = 16; i < 64; i++) {
                    u = w[i-2];
                    t1 = ((u>>>17) | (u<<(32-17))) ^ ((u>>>19) | (u<<(32-19))) ^ (u>>>10);

                    u = w[i-15];
                    t2 = ((u>>>7) | (u<<(32-7))) ^ ((u>>>18) | (u<<(32-18))) ^ (u>>>3);

                    w[i] = (((t1 + w[i-7]) | 0) + ((t2 + w[i-16]) | 0)) | 0;
                }

                for (i = 0; i < 64; i++) {
                    t1 = ((((((e>>>6) | (e<<(32-6))) ^ ((e>>>11) | (e<<(32-11))) ^
                             ((e>>>25) | (e<<(32-25)))) + ((e & f) ^ (~e & g))) | 0) +
                          ((h + ((K[i] + w[i]) | 0)) | 0)) | 0;

                    t2 = ((((a>>>2) | (a<<(32-2))) ^ ((a>>>13) | (a<<(32-13))) ^
                           ((a>>>22) | (a<<(32-22)))) + ((a & b) ^ (a & c) ^ (b & c))) | 0;

                    h = g;
                    g = f;
                    f = e;
                    e = (d + t1) | 0;
                    d = c;
                    c = b;
                    b = a;
                    a = (t1 + t2) | 0;
                }

                h0 = (h0 + a) | 0;
                h1 = (h1 + b) | 0;
                h2 = (h2 + c) | 0;
                h3 = (h3 + d) | 0;
                h4 = (h4 + e) | 0;
                h5 = (h5 + f) | 0;
                h6 = (h6 + g) | 0;
                h7 = (h7 + h) | 0;

                off += 64;
                len -= 64;
            }
        }

        blocks(m);

        let i, bytesLeft = m.length % 64,
        bitLenHi = (m.length / 0x20000000) | 0,
        bitLenLo = m.length << 3,
        numZeros = (bytesLeft < 56) ? 56 : 120,
        p = m.slice(m.length - bytesLeft, m.length);

        p.push(0x80);
        for (i = bytesLeft + 1; i < numZeros; i++) { p.push(0); }
        p.push((bitLenHi >>> 24) & 0xff);
        p.push((bitLenHi >>> 16) & 0xff);
        p.push((bitLenHi >>> 8)  & 0xff);
        p.push((bitLenHi >>> 0)  & 0xff);
        p.push((bitLenLo >>> 24) & 0xff);
        p.push((bitLenLo >>> 16) & 0xff);
        p.push((bitLenLo >>> 8)  & 0xff);
        p.push((bitLenLo >>> 0)  & 0xff);

        blocks(p);

        return [
            (h0 >>> 24) & 0xff, (h0 >>> 16) & 0xff, (h0 >>> 8) & 0xff, (h0 >>> 0) & 0xff,
            (h1 >>> 24) & 0xff, (h1 >>> 16) & 0xff, (h1 >>> 8) & 0xff, (h1 >>> 0) & 0xff,
            (h2 >>> 24) & 0xff, (h2 >>> 16) & 0xff, (h2 >>> 8) & 0xff, (h2 >>> 0) & 0xff,
            (h3 >>> 24) & 0xff, (h3 >>> 16) & 0xff, (h3 >>> 8) & 0xff, (h3 >>> 0) & 0xff,
            (h4 >>> 24) & 0xff, (h4 >>> 16) & 0xff, (h4 >>> 8) & 0xff, (h4 >>> 0) & 0xff,
            (h5 >>> 24) & 0xff, (h5 >>> 16) & 0xff, (h5 >>> 8) & 0xff, (h5 >>> 0) & 0xff,
            (h6 >>> 24) & 0xff, (h6 >>> 16) & 0xff, (h6 >>> 8) & 0xff, (h6 >>> 0) & 0xff,
            (h7 >>> 24) & 0xff, (h7 >>> 16) & 0xff, (h7 >>> 8) & 0xff, (h7 >>> 0) & 0xff
        ];
    }

    function PBKDF2_HMAC_SHA256_OneIter(password, salt, dkLen) {
        // compress password if it's longer than hash block length
        password = (password.length <= 64) ? password : SHA256(password);

        const innerLen = 64 + salt.length + 4;
        const inner = new Array(innerLen);
        const outerKey = new Array(64);

        let i;
        let dk = [];

        // inner = (password ^ ipad) || salt || counter
        for (i = 0; i < 64; i++) { inner[i] = 0x36; }
        for (i = 0; i < password.length; i++) { inner[i] ^= password[i]; }
        for (i = 0; i < salt.length; i++) { inner[64 + i] = salt[i]; }
        for (i = innerLen - 4; i < innerLen; i++) { inner[i] = 0; }

        // outerKey = password ^ opad
        for (i = 0; i < 64; i++) outerKey[i] = 0x5c;
        for (i = 0; i < password.length; i++) outerKey[i] ^= password[i];

        // increments counter inside inner
        function incrementCounter() {
            for (let i = innerLen - 1; i >= innerLen - 4; i--) {
                inner[i]++;
                if (inner[i] <= 0xff) return;
                inner[i] = 0;
            }
        }

        // output blocks = SHA256(outerKey || SHA256(inner)) ...
        while (dkLen >= 32) {
            incrementCounter();
            dk = dk.concat(SHA256(outerKey.concat(SHA256(inner))));
            dkLen -= 32;
        }
        if (dkLen > 0) {
            incrementCounter();
            dk = dk.concat(SHA256(outerKey.concat(SHA256(inner))).slice(0, dkLen));
        }

        return dk;
    }

    // The following is an adaptation of scryptsy
    // See: https://www.npmjs.com/package/scryptsy
    function blockmix_salsa8(BY, Yi, r, x, _X) {
        let i;

        arraycopy(BY, (2 * r - 1) * 16, _X, 0, 16);
        for (i = 0; i < 2 * r; i++) {
            blockxor(BY, i * 16, _X, 16);
            salsa20_8(_X, x);
            arraycopy(_X, 0, BY, Yi + (i * 16), 16);
        }

        for (i = 0; i < r; i++) {
            arraycopy(BY, Yi + (i * 2) * 16, BY, (i * 16), 16);
        }

        for (i = 0; i < r; i++) {
            arraycopy(BY, Yi + (i * 2 + 1) * 16, BY, (i + r) * 16, 16);
        }
    }

    function R(a, b) {
        return (a << b) | (a >>> (32 - b));
    }

    function salsa20_8(B, x) {
        arraycopy(B, 0, x, 0, 16);

        for (let i = 8; i > 0; i -= 2) {
            x[ 4] ^= R(x[ 0] + x[12], 7);
            x[ 8] ^= R(x[ 4] + x[ 0], 9);
            x[12] ^= R(x[ 8] + x[ 4], 13);
            x[ 0] ^= R(x[12] + x[ 8], 18);
            x[ 9] ^= R(x[ 5] + x[ 1], 7);
            x[13] ^= R(x[ 9] + x[ 5], 9);
            x[ 1] ^= R(x[13] + x[ 9], 13);
            x[ 5] ^= R(x[ 1] + x[13], 18);
            x[14] ^= R(x[10] + x[ 6], 7);
            x[ 2] ^= R(x[14] + x[10], 9);
            x[ 6] ^= R(x[ 2] + x[14], 13);
            x[10] ^= R(x[ 6] + x[ 2], 18);
            x[ 3] ^= R(x[15] + x[11], 7);
            x[ 7] ^= R(x[ 3] + x[15], 9);
            x[11] ^= R(x[ 7] + x[ 3], 13);
            x[15] ^= R(x[11] + x[ 7], 18);
            x[ 1] ^= R(x[ 0] + x[ 3], 7);
            x[ 2] ^= R(x[ 1] + x[ 0], 9);
            x[ 3] ^= R(x[ 2] + x[ 1], 13);
            x[ 0] ^= R(x[ 3] + x[ 2], 18);
            x[ 6] ^= R(x[ 5] + x[ 4], 7);
            x[ 7] ^= R(x[ 6] + x[ 5], 9);
            x[ 4] ^= R(x[ 7] + x[ 6], 13);
            x[ 5] ^= R(x[ 4] + x[ 7], 18);
            x[11] ^= R(x[10] + x[ 9], 7);
            x[ 8] ^= R(x[11] + x[10], 9);
            x[ 9] ^= R(x[ 8] + x[11], 13);
            x[10] ^= R(x[ 9] + x[ 8], 18);
            x[12] ^= R(x[15] + x[14], 7);
            x[13] ^= R(x[12] + x[15], 9);
            x[14] ^= R(x[13] + x[12], 13);
            x[15] ^= R(x[14] + x[13], 18);
        }

        for (let i = 0; i < 16; ++i) {
            B[i] += x[i];
        }
    }

    // naive approach... going back to loop unrolling may yield additional performance
    function blockxor(S, Si, D, len) {
        for (let i = 0; i < len; i++) {
            D[i] ^= S[Si + i]
        }
    }

    function arraycopy(src, srcPos, dest, destPos, length) {
        while (length--) {
            dest[destPos++] = src[srcPos++];
        }
    }

    function checkBufferish(o) {
        if (!o || typeof(o.length) !== 'number') { return false; }

        for (let i = 0; i < o.length; i++) {
            const v = o[i];
            if (typeof(v) !== 'number' || v % 1 || v < 0 || v >= 256) {
                return false;
            }
        }

        return true;
    }

    function ensureInteger(value, name) {
        if (typeof(value) !== "number" || (value % 1)) { throw new Error('invalid ' + name); }
        return value;
    }

    // N = Cpu cost, r = Memory cost, p = parallelization cost
    // callback(error, progress, key)
    function _scrypt(password, salt, N, r, p, dkLen, callback) {

        N = ensureInteger(N, 'N');
        r = ensureInteger(r, 'r');
        p = ensureInteger(p, 'p');

        dkLen = ensureInteger(dkLen, 'dkLen');

        if (N === 0 || (N & (N - 1)) !== 0) { throw new Error('N must be power of 2'); }

        if (N > MAX_VALUE / 128 / r) { throw new Error('N too large'); }
        if (r > MAX_VALUE / 128 / p) { throw new Error('r too large'); }

        if (!checkBufferish(password)) {
            throw new Error('password must be an array or buffer');
        }
        password = Array.prototype.slice.call(password);

        if (!checkBufferish(salt)) {
            throw new Error('salt must be an array or buffer');
        }
        salt = Array.prototype.slice.call(salt);

        let b = PBKDF2_HMAC_SHA256_OneIter(password, salt, p * 128 * r);
        const B = new Uint32Array(p * 32 * r)
        for (let i = 0; i < B.length; i++) {
            const j = i * 4;
            B[i] = ((b[j + 3] & 0xff) << 24) |
                   ((b[j + 2] & 0xff) << 16) |
                   ((b[j + 1] & 0xff) << 8) |
                   ((b[j + 0] & 0xff) << 0);
        }

        const XY = new Uint32Array(64 * r);
        const V = new Uint32Array(32 * r * N);

        const Yi = 32 * r;

        // scratch space
        const x = new Uint32Array(16);       // salsa20_8
        const _X = new Uint32Array(16);      // blockmix_salsa8

        const totalOps = p * N * 2;
        let currentOp = 0;
        let lastPercent10 = null;

        // Set this to true to abandon the scrypt on the next step
        let stop = false;

        // State information
        let state = 0;
        let i0 = 0, i1;
        let Bi;

        // How many blockmix_salsa8 can we do per step?
        const limit = callback ? parseInt(1000 / r): 0xffffffff;

        // Trick from scrypt-async; if there is a setImmediate shim in place, use it
        const nextTick = (typeof(setImmediate) !== 'undefined') ? setImmediate : setTimeout;

        // This is really all I changed; making scryptsy a state machine so we occasionally
        // stop and give other evnts on the evnt loop a chance to run. ~RicMoo
        const incrementalSMix = function() {
            if (stop) {
                return callback(new Error('cancelled'), currentOp / totalOps);
            }

            let steps;

            switch (state) {
                case 0:
                    // for (var i = 0; i < p; i++)...
                    Bi = i0 * 32 * r;

                    arraycopy(B, Bi, XY, 0, Yi);                       // ROMix - 1

                    state = 1;                                         // Move to ROMix 2
                    i1 = 0;

                    // Fall through

                case 1:

                    // Run up to 1000 steps of the first inner smix loop
                    steps = N - i1;
                    if (steps > limit) { steps = limit; }
                    for (let i = 0; i < steps; i++) {                  // ROMix - 2
                        arraycopy(XY, 0, V, (i1 + i) * Yi, Yi)         // ROMix - 3
                        blockmix_salsa8(XY, Yi, r, x, _X);             // ROMix - 4
                    }

                    // for (var i = 0; i < N; i++)
                    i1 += steps;
                    currentOp += steps;

                    if (callback) {
                        // Call the callback with the progress (optionally stopping us)
                        const percent10 = parseInt(1000 * currentOp / totalOps);
                        if (percent10 !== lastPercent10) {
                            stop = callback(null, currentOp / totalOps);
                            if (stop) { break; }
                            lastPercent10 = percent10;
                        }
                    }

                    if (i1 < N) { break; }

                    i1 = 0;                                          // Move to ROMix 6
                    state = 2;

                    // Fall through

                case 2:

                    // Run up to 1000 steps of the second inner smix loop
                    steps = N - i1;
                    if (steps > limit) { steps = limit; }
                    for (let i = 0; i < steps; i++) {                // ROMix - 6
                        const offset = (2 * r - 1) * 16;             // ROMix - 7
                        const j = XY[offset] & (N - 1);
                        blockxor(V, j * Yi, XY, Yi);                 // ROMix - 8 (inner)
                        blockmix_salsa8(XY, Yi, r, x, _X);           // ROMix - 9 (outer)
                    }

                    // for (var i = 0; i < N; i++)...
                    i1 += steps;
                    currentOp += steps;

                    // Call the callback with the progress (optionally stopping us)
                    if (callback) {
                        const percent10 = parseInt(1000 * currentOp / totalOps);
                        if (percent10 !== lastPercent10) {
                            stop = callback(null, currentOp / totalOps);
                            if (stop) { break; }
                            lastPercent10 = percent10;
                        }
                    }

                    if (i1 < N) { break; }

                    arraycopy(XY, 0, B, Bi, Yi);                     // ROMix - 10

                    // for (var i = 0; i < p; i++)...
                    i0++;
                    if (i0 < p) {
                        state = 0;
                        break;
                    }

                    b = [];
                    for (let i = 0; i < B.length; i++) {
                        b.push((B[i] >>  0) & 0xff);
                        b.push((B[i] >>  8) & 0xff);
                        b.push((B[i] >> 16) & 0xff);
                        b.push((B[i] >> 24) & 0xff);
                    }

                    const derivedKey = PBKDF2_HMAC_SHA256_OneIter(password, b, dkLen);

                    // Send the result to the callback
                    if (callback) { callback(null, 1.0, derivedKey); }

                    // Done; don't break (which would reschedule)
                    return derivedKey;
            }

            // Schedule the next steps
            if (callback) { nextTick(incrementalSMix); }
        }

        // Run the smix state machine until completion
        if (!callback) {
            while (true) {
                const derivedKey = incrementalSMix();
                if (derivedKey != undefined) { return derivedKey; }
            }
        }

        // Bootstrap the async incremental smix
        incrementalSMix();
    }

    const lib = {
        scrypt: function(password, salt, N, r, p, dkLen, progressCallback) {
            return new Promise(function(resolve, reject) {
                let lastProgress = 0;
                if (progressCallback) { progressCallback(0); }
                _scrypt(password, salt, N, r, p, dkLen, function(error, progress, key) {
                    if (error) {
                        reject(error);
                    } else if (key) {
                        if (progressCallback && lastProgress !== 1) {
                            progressCallback(1);
                        }
                        resolve(new Uint8Array(key));
                    } else if (progressCallback && progress !== lastProgress) {
                        lastProgress = progress;
                        return progressCallback(progress);
                    }
                });
            });
        },
        syncScrypt: function(password, salt, N, r, p, dkLen) {
            return new Uint8Array(_scrypt(password, salt, N, r, p, dkLen));
        }
    };

    // node.js
    if (true) {
       module.exports = lib;

    // RequireJS/AMD
    // http://www.requirejs.org/docs/api.html
    // https://github.com/amdjs/amdjs-api/wiki/AMD
    } else {}

})(this);


/***/ }),

/***/ 622:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   DOMException: () => (/* binding */ DOMException),
/* harmony export */   Headers: () => (/* binding */ Headers),
/* harmony export */   Request: () => (/* binding */ Request),
/* harmony export */   Response: () => (/* binding */ Response),
/* harmony export */   fetch: () => (/* binding */ fetch)
/* harmony export */ });
/* eslint-disable no-prototype-builtins */
var g =
  (typeof globalThis !== 'undefined' && globalThis) ||
  (typeof self !== 'undefined' && self) ||
  // eslint-disable-next-line no-undef
  (typeof __webpack_require__.g !== 'undefined' && __webpack_require__.g) ||
  {}

var support = {
  searchParams: 'URLSearchParams' in g,
  iterable: 'Symbol' in g && 'iterator' in Symbol,
  blob:
    'FileReader' in g &&
    'Blob' in g &&
    (function() {
      try {
        new Blob()
        return true
      } catch (e) {
        return false
      }
    })(),
  formData: 'FormData' in g,
  arrayBuffer: 'ArrayBuffer' in g
}

function isDataView(obj) {
  return obj && DataView.prototype.isPrototypeOf(obj)
}

if (support.arrayBuffer) {
  var viewClasses = [
    '[object Int8Array]',
    '[object Uint8Array]',
    '[object Uint8ClampedArray]',
    '[object Int16Array]',
    '[object Uint16Array]',
    '[object Int32Array]',
    '[object Uint32Array]',
    '[object Float32Array]',
    '[object Float64Array]'
  ]

  var isArrayBufferView =
    ArrayBuffer.isView ||
    function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
}

function normalizeName(name) {
  if (typeof name !== 'string') {
    name = String(name)
  }
  if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') {
    throw new TypeError('Invalid character in header field name: "' + name + '"')
  }
  return name.toLowerCase()
}

function normalizeValue(value) {
  if (typeof value !== 'string') {
    value = String(value)
  }
  return value
}

// Build a destructive iterator for the value list
function iteratorFor(items) {
  var iterator = {
    next: function() {
      var value = items.shift()
      return {done: value === undefined, value: value}
    }
  }

  if (support.iterable) {
    iterator[Symbol.iterator] = function() {
      return iterator
    }
  }

  return iterator
}

function Headers(headers) {
  this.map = {}

  if (headers instanceof Headers) {
    headers.forEach(function(value, name) {
      this.append(name, value)
    }, this)
  } else if (Array.isArray(headers)) {
    headers.forEach(function(header) {
      if (header.length != 2) {
        throw new TypeError('Headers constructor: expected name/value pair to be length 2, found' + header.length)
      }
      this.append(header[0], header[1])
    }, this)
  } else if (headers) {
    Object.getOwnPropertyNames(headers).forEach(function(name) {
      this.append(name, headers[name])
    }, this)
  }
}

Headers.prototype.append = function(name, value) {
  name = normalizeName(name)
  value = normalizeValue(value)
  var oldValue = this.map[name]
  this.map[name] = oldValue ? oldValue + ', ' + value : value
}

Headers.prototype['delete'] = function(name) {
  delete this.map[normalizeName(name)]
}

Headers.prototype.get = function(name) {
  name = normalizeName(name)
  return this.has(name) ? this.map[name] : null
}

Headers.prototype.has = function(name) {
  return this.map.hasOwnProperty(normalizeName(name))
}

Headers.prototype.set = function(name, value) {
  this.map[normalizeName(name)] = normalizeValue(value)
}

Headers.prototype.forEach = function(callback, thisArg) {
  for (var name in this.map) {
    if (this.map.hasOwnProperty(name)) {
      callback.call(thisArg, this.map[name], name, this)
    }
  }
}

Headers.prototype.keys = function() {
  var items = []
  this.forEach(function(value, name) {
    items.push(name)
  })
  return iteratorFor(items)
}

Headers.prototype.values = function() {
  var items = []
  this.forEach(function(value) {
    items.push(value)
  })
  return iteratorFor(items)
}

Headers.prototype.entries = function() {
  var items = []
  this.forEach(function(value, name) {
    items.push([name, value])
  })
  return iteratorFor(items)
}

if (support.iterable) {
  Headers.prototype[Symbol.iterator] = Headers.prototype.entries
}

function consumed(body) {
  if (body._noBody) return
  if (body.bodyUsed) {
    return Promise.reject(new TypeError('Already read'))
  }
  body.bodyUsed = true
}

function fileReaderReady(reader) {
  return new Promise(function(resolve, reject) {
    reader.onload = function() {
      resolve(reader.result)
    }
    reader.onerror = function() {
      reject(reader.error)
    }
  })
}

function readBlobAsArrayBuffer(blob) {
  var reader = new FileReader()
  var promise = fileReaderReady(reader)
  reader.readAsArrayBuffer(blob)
  return promise
}

function readBlobAsText(blob) {
  var reader = new FileReader()
  var promise = fileReaderReady(reader)
  var match = /charset=([A-Za-z0-9_-]+)/.exec(blob.type)
  var encoding = match ? match[1] : 'utf-8'
  reader.readAsText(blob, encoding)
  return promise
}

function readArrayBufferAsText(buf) {
  var view = new Uint8Array(buf)
  var chars = new Array(view.length)

  for (var i = 0; i < view.length; i++) {
    chars[i] = String.fromCharCode(view[i])
  }
  return chars.join('')
}

function bufferClone(buf) {
  if (buf.slice) {
    return buf.slice(0)
  } else {
    var view = new Uint8Array(buf.byteLength)
    view.set(new Uint8Array(buf))
    return view.buffer
  }
}

function Body() {
  this.bodyUsed = false

  this._initBody = function(body) {
    /*
      fetch-mock wraps the Response object in an ES6 Proxy to
      provide useful test harness features such as flush. However, on
      ES5 browsers without fetch or Proxy support pollyfills must be used;
      the proxy-pollyfill is unable to proxy an attribute unless it exists
      on the object before the Proxy is created. This change ensures
      Response.bodyUsed exists on the instance, while maintaining the
      semantic of setting Request.bodyUsed in the constructor before
      _initBody is called.
    */
    // eslint-disable-next-line no-self-assign
    this.bodyUsed = this.bodyUsed
    this._bodyInit = body
    if (!body) {
      this._noBody = true;
      this._bodyText = ''
    } else if (typeof body === 'string') {
      this._bodyText = body
    } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
      this._bodyBlob = body
    } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
      this._bodyFormData = body
    } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
      this._bodyText = body.toString()
    } else if (support.arrayBuffer && support.blob && isDataView(body)) {
      this._bodyArrayBuffer = bufferClone(body.buffer)
      // IE 10-11 can't handle a DataView body.
      this._bodyInit = new Blob([this._bodyArrayBuffer])
    } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
      this._bodyArrayBuffer = bufferClone(body)
    } else {
      this._bodyText = body = Object.prototype.toString.call(body)
    }

    if (!this.headers.get('content-type')) {
      if (typeof body === 'string') {
        this.headers.set('content-type', 'text/plain;charset=UTF-8')
      } else if (this._bodyBlob && this._bodyBlob.type) {
        this.headers.set('content-type', this._bodyBlob.type)
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
      }
    }
  }

  if (support.blob) {
    this.blob = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return Promise.resolve(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(new Blob([this._bodyArrayBuffer]))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as blob')
      } else {
        return Promise.resolve(new Blob([this._bodyText]))
      }
    }
  }

  this.arrayBuffer = function() {
    if (this._bodyArrayBuffer) {
      var isConsumed = consumed(this)
      if (isConsumed) {
        return isConsumed
      } else if (ArrayBuffer.isView(this._bodyArrayBuffer)) {
        return Promise.resolve(
          this._bodyArrayBuffer.buffer.slice(
            this._bodyArrayBuffer.byteOffset,
            this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength
          )
        )
      } else {
        return Promise.resolve(this._bodyArrayBuffer)
      }
    } else if (support.blob) {
      return this.blob().then(readBlobAsArrayBuffer)
    } else {
      throw new Error('could not read as ArrayBuffer')
    }
  }

  this.text = function() {
    var rejected = consumed(this)
    if (rejected) {
      return rejected
    }

    if (this._bodyBlob) {
      return readBlobAsText(this._bodyBlob)
    } else if (this._bodyArrayBuffer) {
      return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
    } else if (this._bodyFormData) {
      throw new Error('could not read FormData body as text')
    } else {
      return Promise.resolve(this._bodyText)
    }
  }

  if (support.formData) {
    this.formData = function() {
      return this.text().then(decode)
    }
  }

  this.json = function() {
    return this.text().then(JSON.parse)
  }

  return this
}

// HTTP methods whose capitalization should be normalized
var methods = ['CONNECT', 'DELETE', 'GET', 'HEAD', 'OPTIONS', 'PATCH', 'POST', 'PUT', 'TRACE']

function normalizeMethod(method) {
  var upcased = method.toUpperCase()
  return methods.indexOf(upcased) > -1 ? upcased : method
}

function Request(input, options) {
  if (!(this instanceof Request)) {
    throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.')
  }

  options = options || {}
  var body = options.body

  if (input instanceof Request) {
    if (input.bodyUsed) {
      throw new TypeError('Already read')
    }
    this.url = input.url
    this.credentials = input.credentials
    if (!options.headers) {
      this.headers = new Headers(input.headers)
    }
    this.method = input.method
    this.mode = input.mode
    this.signal = input.signal
    if (!body && input._bodyInit != null) {
      body = input._bodyInit
      input.bodyUsed = true
    }
  } else {
    this.url = String(input)
  }

  this.credentials = options.credentials || this.credentials || 'same-origin'
  if (options.headers || !this.headers) {
    this.headers = new Headers(options.headers)
  }
  this.method = normalizeMethod(options.method || this.method || 'GET')
  this.mode = options.mode || this.mode || null
  this.signal = options.signal || this.signal || (function () {
    if ('AbortController' in g) {
      var ctrl = new AbortController();
      return ctrl.signal;
    }
  }());
  this.referrer = null

  if ((this.method === 'GET' || this.method === 'HEAD') && body) {
    throw new TypeError('Body not allowed for GET or HEAD requests')
  }
  this._initBody(body)

  if (this.method === 'GET' || this.method === 'HEAD') {
    if (options.cache === 'no-store' || options.cache === 'no-cache') {
      // Search for a '_' parameter in the query string
      var reParamSearch = /([?&])_=[^&]*/
      if (reParamSearch.test(this.url)) {
        // If it already exists then set the value with the current time
        this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime())
      } else {
        // Otherwise add a new '_' parameter to the end with the current time
        var reQueryString = /\?/
        this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime()
      }
    }
  }
}

Request.prototype.clone = function() {
  return new Request(this, {body: this._bodyInit})
}

function decode(body) {
  var form = new FormData()
  body
    .trim()
    .split('&')
    .forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
  return form
}

function parseHeaders(rawHeaders) {
  var headers = new Headers()
  // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
  // https://tools.ietf.org/html/rfc7230#section-3.2
  var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
  // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
  // https://github.com/github/fetch/issues/748
  // https://github.com/zloirock/core-js/issues/751
  preProcessedHeaders
    .split('\r')
    .map(function(header) {
      return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header
    })
    .forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        try {
          headers.append(key, value)
        } catch (error) {
          console.warn('Response ' + error.message)
        }
      }
    })
  return headers
}

Body.call(Request.prototype)

function Response(bodyInit, options) {
  if (!(this instanceof Response)) {
    throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.')
  }
  if (!options) {
    options = {}
  }

  this.type = 'default'
  this.status = options.status === undefined ? 200 : options.status
  if (this.status < 200 || this.status > 599) {
    throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].")
  }
  this.ok = this.status >= 200 && this.status < 300
  this.statusText = options.statusText === undefined ? '' : '' + options.statusText
  this.headers = new Headers(options.headers)
  this.url = options.url || ''
  this._initBody(bodyInit)
}

Body.call(Response.prototype)

Response.prototype.clone = function() {
  return new Response(this._bodyInit, {
    status: this.status,
    statusText: this.statusText,
    headers: new Headers(this.headers),
    url: this.url
  })
}

Response.error = function() {
  var response = new Response(null, {status: 200, statusText: ''})
  response.status = 0
  response.type = 'error'
  return response
}

var redirectStatuses = [301, 302, 303, 307, 308]

Response.redirect = function(url, status) {
  if (redirectStatuses.indexOf(status) === -1) {
    throw new RangeError('Invalid status code')
  }

  return new Response(null, {status: status, headers: {location: url}})
}

var DOMException = g.DOMException
try {
  new DOMException()
} catch (err) {
  DOMException = function(message, name) {
    this.message = message
    this.name = name
    var error = Error(message)
    this.stack = error.stack
  }
  DOMException.prototype = Object.create(Error.prototype)
  DOMException.prototype.constructor = DOMException
}

function fetch(input, init) {
  return new Promise(function(resolve, reject) {
    var request = new Request(input, init)

    if (request.signal && request.signal.aborted) {
      return reject(new DOMException('Aborted', 'AbortError'))
    }

    var xhr = new XMLHttpRequest()

    function abortXhr() {
      xhr.abort()
    }

    xhr.onload = function() {
      var options = {
        statusText: xhr.statusText,
        headers: parseHeaders(xhr.getAllResponseHeaders() || '')
      }
      // This check if specifically for when a user fetches a file locally from the file system
      // Only if the status is out of a normal range
      if (request.url.startsWith('file://') && (xhr.status < 200 || xhr.status > 599)) {
        options.status = 200;
      } else {
        options.status = xhr.status;
      }
      options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
      var body = 'response' in xhr ? xhr.response : xhr.responseText
      setTimeout(function() {
        resolve(new Response(body, options))
      }, 0)
    }

    xhr.onerror = function() {
      setTimeout(function() {
        reject(new TypeError('Network request failed'))
      }, 0)
    }

    xhr.ontimeout = function() {
      setTimeout(function() {
        reject(new TypeError('Network request timed out'))
      }, 0)
    }

    xhr.onabort = function() {
      setTimeout(function() {
        reject(new DOMException('Aborted', 'AbortError'))
      }, 0)
    }

    function fixUrl(url) {
      try {
        return url === '' && g.location.href ? g.location.href : url
      } catch (e) {
        return url
      }
    }

    xhr.open(request.method, fixUrl(request.url), true)

    if (request.credentials === 'include') {
      xhr.withCredentials = true
    } else if (request.credentials === 'omit') {
      xhr.withCredentials = false
    }

    if ('responseType' in xhr) {
      if (support.blob) {
        xhr.responseType = 'blob'
      } else if (
        support.arrayBuffer
      ) {
        xhr.responseType = 'arraybuffer'
      }
    }

    if (init && typeof init.headers === 'object' && !(init.headers instanceof Headers || (g.Headers && init.headers instanceof g.Headers))) {
      var names = [];
      Object.getOwnPropertyNames(init.headers).forEach(function(name) {
        names.push(normalizeName(name))
        xhr.setRequestHeader(name, normalizeValue(init.headers[name]))
      })
      request.headers.forEach(function(value, name) {
        if (names.indexOf(name) === -1) {
          xhr.setRequestHeader(name, value)
        }
      })
    } else {
      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })
    }

    if (request.signal) {
      request.signal.addEventListener('abort', abortXhr)

      xhr.onreadystatechange = function() {
        // DONE (success or failure)
        if (xhr.readyState === 4) {
          request.signal.removeEventListener('abort', abortXhr)
        }
      }
    }

    xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
  })
}

fetch.polyfill = true

if (!g.fetch) {
  g.fetch = fetch
  g.Headers = Headers
  g.Request = Request
  g.Response = Response
}


/***/ }),

/***/ 391:
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ 85:
/***/ (() => {

/* (ignored) */

/***/ })

/******/ });
/************************************************************************/
/******/ // The module cache
/******/ var __webpack_module_cache__ = {};
/******/ 
/******/ // The require function
/******/ function __webpack_require__(moduleId) {
/******/ 	// Check if module is in cache
/******/ 	var cachedModule = __webpack_module_cache__[moduleId];
/******/ 	if (cachedModule !== undefined) {
/******/ 		return cachedModule.exports;
/******/ 	}
/******/ 	// Create a new module (and put it into the cache)
/******/ 	var module = __webpack_module_cache__[moduleId] = {
/******/ 		id: moduleId,
/******/ 		loaded: false,
/******/ 		exports: {}
/******/ 	};
/******/ 
/******/ 	// Execute the module function
/******/ 	__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 
/******/ 	// Flag the module as loaded
/******/ 	module.loaded = true;
/******/ 
/******/ 	// Return the exports of the module
/******/ 	return module.exports;
/******/ }
/******/ 
/************************************************************************/
/******/ /* webpack/runtime/amd options */
/******/ (() => {
/******/ 	__webpack_require__.amdO = {};
/******/ })();
/******/ 
/******/ /* webpack/runtime/compat get default export */
/******/ (() => {
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = (module) => {
/******/ 		var getter = module && module.__esModule ?
/******/ 			() => (module['default']) :
/******/ 			() => (module);
/******/ 		__webpack_require__.d(getter, { a: getter });
/******/ 		return getter;
/******/ 	};
/******/ })();
/******/ 
/******/ /* webpack/runtime/define property getters */
/******/ (() => {
/******/ 	// define getter functions for harmony exports
/******/ 	__webpack_require__.d = (exports, definition) => {
/******/ 		for(var key in definition) {
/******/ 			if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 				Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 			}
/******/ 		}
/******/ 	};
/******/ })();
/******/ 
/******/ /* webpack/runtime/global */
/******/ (() => {
/******/ 	__webpack_require__.g = (function() {
/******/ 		if (typeof globalThis === 'object') return globalThis;
/******/ 		try {
/******/ 			return this || new Function('return this')();
/******/ 		} catch (e) {
/******/ 			if (typeof window === 'object') return window;
/******/ 		}
/******/ 	})();
/******/ })();
/******/ 
/******/ /* webpack/runtime/hasOwnProperty shorthand */
/******/ (() => {
/******/ 	__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ })();
/******/ 
/******/ /* webpack/runtime/make namespace object */
/******/ (() => {
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = (exports) => {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/ })();
/******/ 
/******/ /* webpack/runtime/node module decorator */
/******/ (() => {
/******/ 	__webpack_require__.nmd = (module) => {
/******/ 		module.paths = [];
/******/ 		if (!module.children) module.children = [];
/******/ 		return module;
/******/ 	};
/******/ })();
/******/ 
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
(() => {

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  $: () => (/* reexport */ chainDetails_namespaceObject),
  Tg: () => (/* reexport */ DEFAULT_CONTRACT_VERSION),
  ez: () => (/* reexport */ contracts_namespaceObject),
  k: () => (/* reexport */ tokenDetails_namespaceObject),
  uN: () => (/* reexport */ TOKEN_TYPES),
  q4: () => (/* reexport */ VERSION),
  UM: () => (/* binding */ claimLink),
  OH: () => (/* binding */ claimLinkGasless),
  EW: () => (/* binding */ createLink),
  jf: () => (/* binding */ createLinks),
  ZP: () => (/* binding */ src),
  $K: () => (/* binding */ estimateGasLimit),
  Vk: () => (/* reexport */ getLinkFromParams),
  m9: () => (/* binding */ getLinksFromTx),
  ay: () => (/* reexport */ getParamsFromLink),
  _y: () => (/* reexport */ getParamsFromPageURL),
  zO: () => (/* reexport */ getRandomString),
  Qw: () => (/* reexport */ greeting),
  oA: () => (/* binding */ peanut),
  qT: () => (/* binding */ prepareTxs),
  Y_: () => (/* binding */ signAndSubmitTx),
  EQ: () => (/* binding */ toggleVerbose)
});

// NAMESPACE OBJECT: ./src/consts/interfaces.consts.ts
var interfaces_consts_namespaceObject = {};
__webpack_require__.r(interfaces_consts_namespaceObject);
__webpack_require__.d(interfaces_consts_namespaceObject, {
  EClaimLinkStatusCodes: () => (EClaimLinkStatusCodes),
  ECreateLinkStatusCodes: () => (ECreateLinkStatusCodes),
  ECreateLinksStatusCodes: () => (ECreateLinksStatusCodes),
  EGetLinkFromTxStatusCodes: () => (EGetLinkFromTxStatusCodes),
  EPeanutLinkType: () => (EPeanutLinkType),
  EPrepareCreateTxsStatusCodes: () => (EPrepareCreateTxsStatusCodes),
  ESignAndSubmitTx: () => (ESignAndSubmitTx),
  SDKStatus: () => (SDKStatus)
});

;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+logger@5.7.0/node_modules/@ethersproject/logger/lib.esm/_version.js
const version = "logger/5.7.0";
//# sourceMappingURL=_version.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+logger@5.7.0/node_modules/@ethersproject/logger/lib.esm/index.js

let _permanentCensorErrors = false;
let _censorErrors = false;
const LogLevels = { debug: 1, "default": 2, info: 2, warning: 3, error: 4, off: 5 };
let _logLevel = LogLevels["default"];

let _globalLogger = null;
function _checkNormalize() {
    try {
        const missing = [];
        // Make sure all forms of normalization are supported
        ["NFD", "NFC", "NFKD", "NFKC"].forEach((form) => {
            try {
                if ("test".normalize(form) !== "test") {
                    throw new Error("bad normalize");
                }
                ;
            }
            catch (error) {
                missing.push(form);
            }
        });
        if (missing.length) {
            throw new Error("missing " + missing.join(", "));
        }
        if (String.fromCharCode(0xe9).normalize("NFD") !== String.fromCharCode(0x65, 0x0301)) {
            throw new Error("broken implementation");
        }
    }
    catch (error) {
        return error.message;
    }
    return null;
}
const _normalizeError = _checkNormalize();
var LogLevel;
(function (LogLevel) {
    LogLevel["DEBUG"] = "DEBUG";
    LogLevel["INFO"] = "INFO";
    LogLevel["WARNING"] = "WARNING";
    LogLevel["ERROR"] = "ERROR";
    LogLevel["OFF"] = "OFF";
})(LogLevel || (LogLevel = {}));
var ErrorCode;
(function (ErrorCode) {
    ///////////////////
    // Generic Errors
    // Unknown Error
    ErrorCode["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    // Not Implemented
    ErrorCode["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
    // Unsupported Operation
    //   - operation
    ErrorCode["UNSUPPORTED_OPERATION"] = "UNSUPPORTED_OPERATION";
    // Network Error (i.e. Ethereum Network, such as an invalid chain ID)
    //   - event ("noNetwork" is not re-thrown in provider.ready; otherwise thrown)
    ErrorCode["NETWORK_ERROR"] = "NETWORK_ERROR";
    // Some sort of bad response from the server
    ErrorCode["SERVER_ERROR"] = "SERVER_ERROR";
    // Timeout
    ErrorCode["TIMEOUT"] = "TIMEOUT";
    ///////////////////
    // Operational  Errors
    // Buffer Overrun
    ErrorCode["BUFFER_OVERRUN"] = "BUFFER_OVERRUN";
    // Numeric Fault
    //   - operation: the operation being executed
    //   - fault: the reason this faulted
    ErrorCode["NUMERIC_FAULT"] = "NUMERIC_FAULT";
    ///////////////////
    // Argument Errors
    // Missing new operator to an object
    //  - name: The name of the class
    ErrorCode["MISSING_NEW"] = "MISSING_NEW";
    // Invalid argument (e.g. value is incompatible with type) to a function:
    //   - argument: The argument name that was invalid
    //   - value: The value of the argument
    ErrorCode["INVALID_ARGUMENT"] = "INVALID_ARGUMENT";
    // Missing argument to a function:
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["MISSING_ARGUMENT"] = "MISSING_ARGUMENT";
    // Too many arguments
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["UNEXPECTED_ARGUMENT"] = "UNEXPECTED_ARGUMENT";
    ///////////////////
    // Blockchain Errors
    // Call exception
    //  - transaction: the transaction
    //  - address?: the contract address
    //  - args?: The arguments passed into the function
    //  - method?: The Solidity method signature
    //  - errorSignature?: The EIP848 error signature
    //  - errorArgs?: The EIP848 error parameters
    //  - reason: The reason (only for EIP848 "Error(string)")
    ErrorCode["CALL_EXCEPTION"] = "CALL_EXCEPTION";
    // Insufficient funds (< value + gasLimit * gasPrice)
    //   - transaction: the transaction attempted
    ErrorCode["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    // Nonce has already been used
    //   - transaction: the transaction attempted
    ErrorCode["NONCE_EXPIRED"] = "NONCE_EXPIRED";
    // The replacement fee for the transaction is too low
    //   - transaction: the transaction attempted
    ErrorCode["REPLACEMENT_UNDERPRICED"] = "REPLACEMENT_UNDERPRICED";
    // The gas limit could not be estimated
    //   - transaction: the transaction passed to estimateGas
    ErrorCode["UNPREDICTABLE_GAS_LIMIT"] = "UNPREDICTABLE_GAS_LIMIT";
    // The transaction was replaced by one with a higher gas price
    //   - reason: "cancelled", "replaced" or "repriced"
    //   - cancelled: true if reason == "cancelled" or reason == "replaced")
    //   - hash: original transaction hash
    //   - replacement: the full TransactionsResponse for the replacement
    //   - receipt: the receipt of the replacement
    ErrorCode["TRANSACTION_REPLACED"] = "TRANSACTION_REPLACED";
    ///////////////////
    // Interaction Errors
    // The user rejected the action, such as signing a message or sending
    // a transaction
    ErrorCode["ACTION_REJECTED"] = "ACTION_REJECTED";
})(ErrorCode || (ErrorCode = {}));
;
const HEX = "0123456789abcdef";
class lib_esm_Logger {
    constructor(version) {
        Object.defineProperty(this, "version", {
            enumerable: true,
            value: version,
            writable: false
        });
    }
    _log(logLevel, args) {
        const level = logLevel.toLowerCase();
        if (LogLevels[level] == null) {
            this.throwArgumentError("invalid log level name", "logLevel", logLevel);
        }
        if (_logLevel > LogLevels[level]) {
            return;
        }
        console.log.apply(console, args);
    }
    debug(...args) {
        this._log(lib_esm_Logger.levels.DEBUG, args);
    }
    info(...args) {
        this._log(lib_esm_Logger.levels.INFO, args);
    }
    warn(...args) {
        this._log(lib_esm_Logger.levels.WARNING, args);
    }
    makeError(message, code, params) {
        // Errors are being censored
        if (_censorErrors) {
            return this.makeError("censored error", code, {});
        }
        if (!code) {
            code = lib_esm_Logger.errors.UNKNOWN_ERROR;
        }
        if (!params) {
            params = {};
        }
        const messageDetails = [];
        Object.keys(params).forEach((key) => {
            const value = params[key];
            try {
                if (value instanceof Uint8Array) {
                    let hex = "";
                    for (let i = 0; i < value.length; i++) {
                        hex += HEX[value[i] >> 4];
                        hex += HEX[value[i] & 0x0f];
                    }
                    messageDetails.push(key + "=Uint8Array(0x" + hex + ")");
                }
                else {
                    messageDetails.push(key + "=" + JSON.stringify(value));
                }
            }
            catch (error) {
                messageDetails.push(key + "=" + JSON.stringify(params[key].toString()));
            }
        });
        messageDetails.push(`code=${code}`);
        messageDetails.push(`version=${this.version}`);
        const reason = message;
        let url = "";
        switch (code) {
            case ErrorCode.NUMERIC_FAULT: {
                url = "NUMERIC_FAULT";
                const fault = message;
                switch (fault) {
                    case "overflow":
                    case "underflow":
                    case "division-by-zero":
                        url += "-" + fault;
                        break;
                    case "negative-power":
                    case "negative-width":
                        url += "-unsupported";
                        break;
                    case "unbound-bitwise-result":
                        url += "-unbound-result";
                        break;
                }
                break;
            }
            case ErrorCode.CALL_EXCEPTION:
            case ErrorCode.INSUFFICIENT_FUNDS:
            case ErrorCode.MISSING_NEW:
            case ErrorCode.NONCE_EXPIRED:
            case ErrorCode.REPLACEMENT_UNDERPRICED:
            case ErrorCode.TRANSACTION_REPLACED:
            case ErrorCode.UNPREDICTABLE_GAS_LIMIT:
                url = code;
                break;
        }
        if (url) {
            message += " [ See: https:/\/links.ethers.org/v5-errors-" + url + " ]";
        }
        if (messageDetails.length) {
            message += " (" + messageDetails.join(", ") + ")";
        }
        // @TODO: Any??
        const error = new Error(message);
        error.reason = reason;
        error.code = code;
        Object.keys(params).forEach(function (key) {
            error[key] = params[key];
        });
        return error;
    }
    throwError(message, code, params) {
        throw this.makeError(message, code, params);
    }
    throwArgumentError(message, name, value) {
        return this.throwError(message, lib_esm_Logger.errors.INVALID_ARGUMENT, {
            argument: name,
            value: value
        });
    }
    assert(condition, message, code, params) {
        if (!!condition) {
            return;
        }
        this.throwError(message, code, params);
    }
    assertArgument(condition, message, name, value) {
        if (!!condition) {
            return;
        }
        this.throwArgumentError(message, name, value);
    }
    checkNormalize(message) {
        if (message == null) {
            message = "platform missing String.prototype.normalize";
        }
        if (_normalizeError) {
            this.throwError("platform missing String.prototype.normalize", lib_esm_Logger.errors.UNSUPPORTED_OPERATION, {
                operation: "String.prototype.normalize", form: _normalizeError
            });
        }
    }
    checkSafeUint53(value, message) {
        if (typeof (value) !== "number") {
            return;
        }
        if (message == null) {
            message = "value not safe";
        }
        if (value < 0 || value >= 0x1fffffffffffff) {
            this.throwError(message, lib_esm_Logger.errors.NUMERIC_FAULT, {
                operation: "checkSafeInteger",
                fault: "out-of-safe-range",
                value: value
            });
        }
        if (value % 1) {
            this.throwError(message, lib_esm_Logger.errors.NUMERIC_FAULT, {
                operation: "checkSafeInteger",
                fault: "non-integer",
                value: value
            });
        }
    }
    checkArgumentCount(count, expectedCount, message) {
        if (message) {
            message = ": " + message;
        }
        else {
            message = "";
        }
        if (count < expectedCount) {
            this.throwError("missing argument" + message, lib_esm_Logger.errors.MISSING_ARGUMENT, {
                count: count,
                expectedCount: expectedCount
            });
        }
        if (count > expectedCount) {
            this.throwError("too many arguments" + message, lib_esm_Logger.errors.UNEXPECTED_ARGUMENT, {
                count: count,
                expectedCount: expectedCount
            });
        }
    }
    checkNew(target, kind) {
        if (target === Object || target == null) {
            this.throwError("missing new", lib_esm_Logger.errors.MISSING_NEW, { name: kind.name });
        }
    }
    checkAbstract(target, kind) {
        if (target === kind) {
            this.throwError("cannot instantiate abstract class " + JSON.stringify(kind.name) + " directly; use a sub-class", lib_esm_Logger.errors.UNSUPPORTED_OPERATION, { name: target.name, operation: "new" });
        }
        else if (target === Object || target == null) {
            this.throwError("missing new", lib_esm_Logger.errors.MISSING_NEW, { name: kind.name });
        }
    }
    static globalLogger() {
        if (!_globalLogger) {
            _globalLogger = new lib_esm_Logger(version);
        }
        return _globalLogger;
    }
    static setCensorship(censorship, permanent) {
        if (!censorship && permanent) {
            this.globalLogger().throwError("cannot permanently disable censorship", lib_esm_Logger.errors.UNSUPPORTED_OPERATION, {
                operation: "setCensorship"
            });
        }
        if (_permanentCensorErrors) {
            if (!censorship) {
                return;
            }
            this.globalLogger().throwError("error censorship permanent", lib_esm_Logger.errors.UNSUPPORTED_OPERATION, {
                operation: "setCensorship"
            });
        }
        _censorErrors = !!censorship;
        _permanentCensorErrors = !!permanent;
    }
    static setLogLevel(logLevel) {
        const level = LogLevels[logLevel.toLowerCase()];
        if (level == null) {
            lib_esm_Logger.globalLogger().warn("invalid log level - " + logLevel);
            return;
        }
        _logLevel = level;
    }
    static from(version) {
        return new lib_esm_Logger(version);
    }
}
lib_esm_Logger.errors = ErrorCode;
lib_esm_Logger.levels = LogLevel;
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+properties@5.7.0/node_modules/@ethersproject/properties/lib.esm/_version.js
const _version_version = "properties/5.7.0";
//# sourceMappingURL=_version.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+properties@5.7.0/node_modules/@ethersproject/properties/lib.esm/index.js

var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};


const logger = new lib_esm_Logger(_version_version);
function lib_esm_defineReadOnly(object, name, value) {
    Object.defineProperty(object, name, {
        enumerable: true,
        value: value,
        writable: false,
    });
}
// Crawl up the constructor chain to find a static method
function lib_esm_getStatic(ctor, key) {
    for (let i = 0; i < 32; i++) {
        if (ctor[key]) {
            return ctor[key];
        }
        if (!ctor.prototype || typeof (ctor.prototype) !== "object") {
            break;
        }
        ctor = Object.getPrototypeOf(ctor.prototype).constructor;
    }
    return null;
}
function resolveProperties(object) {
    return __awaiter(this, void 0, void 0, function* () {
        const promises = Object.keys(object).map((key) => {
            const value = object[key];
            return Promise.resolve(value).then((v) => ({ key: key, value: v }));
        });
        const results = yield Promise.all(promises);
        return results.reduce((accum, result) => {
            accum[(result.key)] = result.value;
            return accum;
        }, {});
    });
}
function checkProperties(object, properties) {
    if (!object || typeof (object) !== "object") {
        logger.throwArgumentError("invalid object", "object", object);
    }
    Object.keys(object).forEach((key) => {
        if (!properties[key]) {
            logger.throwArgumentError("invalid object key - " + key, "transaction:" + key, object);
        }
    });
}
function lib_esm_shallowCopy(object) {
    const result = {};
    for (const key in object) {
        result[key] = object[key];
    }
    return result;
}
const opaque = { bigint: true, boolean: true, "function": true, number: true, string: true };
function _isFrozen(object) {
    // Opaque objects are not mutable, so safe to copy by assignment
    if (object === undefined || object === null || opaque[typeof (object)]) {
        return true;
    }
    if (Array.isArray(object) || typeof (object) === "object") {
        if (!Object.isFrozen(object)) {
            return false;
        }
        const keys = Object.keys(object);
        for (let i = 0; i < keys.length; i++) {
            let value = null;
            try {
                value = object[keys[i]];
            }
            catch (error) {
                // If accessing a value triggers an error, it is a getter
                // designed to do so (e.g. Result) and is therefore "frozen"
                continue;
            }
            if (!_isFrozen(value)) {
                return false;
            }
        }
        return true;
    }
    return logger.throwArgumentError(`Cannot deepCopy ${typeof (object)}`, "object", object);
}
// Returns a new copy of object, such that no properties may be replaced.
// New properties may be added only to objects.
function _deepCopy(object) {
    if (_isFrozen(object)) {
        return object;
    }
    // Arrays are mutable, so we need to create a copy
    if (Array.isArray(object)) {
        return Object.freeze(object.map((item) => deepCopy(item)));
    }
    if (typeof (object) === "object") {
        const result = {};
        for (const key in object) {
            const value = object[key];
            if (value === undefined) {
                continue;
            }
            lib_esm_defineReadOnly(result, key, deepCopy(value));
        }
        return result;
    }
    return logger.throwArgumentError(`Cannot deepCopy ${typeof (object)}`, "object", object);
}
function deepCopy(object) {
    return _deepCopy(object);
}
class Description {
    constructor(info) {
        for (const key in info) {
            this[key] = deepCopy(info[key]);
        }
    }
}
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+abstract-signer@5.7.0/node_modules/@ethersproject/abstract-signer/lib.esm/_version.js
const lib_esm_version_version = "abstract-signer/5.7.0";
//# sourceMappingURL=_version.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+abstract-signer@5.7.0/node_modules/@ethersproject/abstract-signer/lib.esm/index.js

var lib_esm_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};



const lib_esm_logger = new lib_esm_Logger(lib_esm_version_version);
const allowedTransactionKeys = [
    "accessList", "ccipReadEnabled", "chainId", "customData", "data", "from", "gasLimit", "gasPrice", "maxFeePerGas", "maxPriorityFeePerGas", "nonce", "to", "type", "value"
];
const forwardErrors = [
    lib_esm_Logger.errors.INSUFFICIENT_FUNDS,
    lib_esm_Logger.errors.NONCE_EXPIRED,
    lib_esm_Logger.errors.REPLACEMENT_UNDERPRICED,
];
;
;
class lib_esm_Signer {
    ///////////////////
    // Sub-classes MUST call super
    constructor() {
        lib_esm_logger.checkAbstract(new.target, lib_esm_Signer);
        lib_esm_defineReadOnly(this, "_isSigner", true);
    }
    ///////////////////
    // Sub-classes MAY override these
    getBalance(blockTag) {
        return lib_esm_awaiter(this, void 0, void 0, function* () {
            this._checkProvider("getBalance");
            return yield this.provider.getBalance(this.getAddress(), blockTag);
        });
    }
    getTransactionCount(blockTag) {
        return lib_esm_awaiter(this, void 0, void 0, function* () {
            this._checkProvider("getTransactionCount");
            return yield this.provider.getTransactionCount(this.getAddress(), blockTag);
        });
    }
    // Populates "from" if unspecified, and estimates the gas for the transaction
    estimateGas(transaction) {
        return lib_esm_awaiter(this, void 0, void 0, function* () {
            this._checkProvider("estimateGas");
            const tx = yield resolveProperties(this.checkTransaction(transaction));
            return yield this.provider.estimateGas(tx);
        });
    }
    // Populates "from" if unspecified, and calls with the transaction
    call(transaction, blockTag) {
        return lib_esm_awaiter(this, void 0, void 0, function* () {
            this._checkProvider("call");
            const tx = yield resolveProperties(this.checkTransaction(transaction));
            return yield this.provider.call(tx, blockTag);
        });
    }
    // Populates all fields in a transaction, signs it and sends it to the network
    sendTransaction(transaction) {
        return lib_esm_awaiter(this, void 0, void 0, function* () {
            this._checkProvider("sendTransaction");
            const tx = yield this.populateTransaction(transaction);
            const signedTx = yield this.signTransaction(tx);
            return yield this.provider.sendTransaction(signedTx);
        });
    }
    getChainId() {
        return lib_esm_awaiter(this, void 0, void 0, function* () {
            this._checkProvider("getChainId");
            const network = yield this.provider.getNetwork();
            return network.chainId;
        });
    }
    getGasPrice() {
        return lib_esm_awaiter(this, void 0, void 0, function* () {
            this._checkProvider("getGasPrice");
            return yield this.provider.getGasPrice();
        });
    }
    getFeeData() {
        return lib_esm_awaiter(this, void 0, void 0, function* () {
            this._checkProvider("getFeeData");
            return yield this.provider.getFeeData();
        });
    }
    resolveName(name) {
        return lib_esm_awaiter(this, void 0, void 0, function* () {
            this._checkProvider("resolveName");
            return yield this.provider.resolveName(name);
        });
    }
    // Checks a transaction does not contain invalid keys and if
    // no "from" is provided, populates it.
    // - does NOT require a provider
    // - adds "from" is not present
    // - returns a COPY (safe to mutate the result)
    // By default called from: (overriding these prevents it)
    //   - call
    //   - estimateGas
    //   - populateTransaction (and therefor sendTransaction)
    checkTransaction(transaction) {
        for (const key in transaction) {
            if (allowedTransactionKeys.indexOf(key) === -1) {
                lib_esm_logger.throwArgumentError("invalid transaction key: " + key, "transaction", transaction);
            }
        }
        const tx = lib_esm_shallowCopy(transaction);
        if (tx.from == null) {
            tx.from = this.getAddress();
        }
        else {
            // Make sure any provided address matches this signer
            tx.from = Promise.all([
                Promise.resolve(tx.from),
                this.getAddress()
            ]).then((result) => {
                if (result[0].toLowerCase() !== result[1].toLowerCase()) {
                    lib_esm_logger.throwArgumentError("from address mismatch", "transaction", transaction);
                }
                return result[0];
            });
        }
        return tx;
    }
    // Populates ALL keys for a transaction and checks that "from" matches
    // this Signer. Should be used by sendTransaction but NOT by signTransaction.
    // By default called from: (overriding these prevents it)
    //   - sendTransaction
    //
    // Notes:
    //  - We allow gasPrice for EIP-1559 as long as it matches maxFeePerGas
    populateTransaction(transaction) {
        return lib_esm_awaiter(this, void 0, void 0, function* () {
            const tx = yield resolveProperties(this.checkTransaction(transaction));
            if (tx.to != null) {
                tx.to = Promise.resolve(tx.to).then((to) => lib_esm_awaiter(this, void 0, void 0, function* () {
                    if (to == null) {
                        return null;
                    }
                    const address = yield this.resolveName(to);
                    if (address == null) {
                        lib_esm_logger.throwArgumentError("provided ENS name resolves to null", "tx.to", to);
                    }
                    return address;
                }));
                // Prevent this error from causing an UnhandledPromiseException
                tx.to.catch((error) => { });
            }
            // Do not allow mixing pre-eip-1559 and eip-1559 properties
            const hasEip1559 = (tx.maxFeePerGas != null || tx.maxPriorityFeePerGas != null);
            if (tx.gasPrice != null && (tx.type === 2 || hasEip1559)) {
                lib_esm_logger.throwArgumentError("eip-1559 transaction do not support gasPrice", "transaction", transaction);
            }
            else if ((tx.type === 0 || tx.type === 1) && hasEip1559) {
                lib_esm_logger.throwArgumentError("pre-eip-1559 transaction do not support maxFeePerGas/maxPriorityFeePerGas", "transaction", transaction);
            }
            if ((tx.type === 2 || tx.type == null) && (tx.maxFeePerGas != null && tx.maxPriorityFeePerGas != null)) {
                // Fully-formed EIP-1559 transaction (skip getFeeData)
                tx.type = 2;
            }
            else if (tx.type === 0 || tx.type === 1) {
                // Explicit Legacy or EIP-2930 transaction
                // Populate missing gasPrice
                if (tx.gasPrice == null) {
                    tx.gasPrice = this.getGasPrice();
                }
            }
            else {
                // We need to get fee data to determine things
                const feeData = yield this.getFeeData();
                if (tx.type == null) {
                    // We need to auto-detect the intended type of this transaction...
                    if (feeData.maxFeePerGas != null && feeData.maxPriorityFeePerGas != null) {
                        // The network supports EIP-1559!
                        // Upgrade transaction from null to eip-1559
                        tx.type = 2;
                        if (tx.gasPrice != null) {
                            // Using legacy gasPrice property on an eip-1559 network,
                            // so use gasPrice as both fee properties
                            const gasPrice = tx.gasPrice;
                            delete tx.gasPrice;
                            tx.maxFeePerGas = gasPrice;
                            tx.maxPriorityFeePerGas = gasPrice;
                        }
                        else {
                            // Populate missing fee data
                            if (tx.maxFeePerGas == null) {
                                tx.maxFeePerGas = feeData.maxFeePerGas;
                            }
                            if (tx.maxPriorityFeePerGas == null) {
                                tx.maxPriorityFeePerGas = feeData.maxPriorityFeePerGas;
                            }
                        }
                    }
                    else if (feeData.gasPrice != null) {
                        // Network doesn't support EIP-1559...
                        // ...but they are trying to use EIP-1559 properties
                        if (hasEip1559) {
                            lib_esm_logger.throwError("network does not support EIP-1559", lib_esm_Logger.errors.UNSUPPORTED_OPERATION, {
                                operation: "populateTransaction"
                            });
                        }
                        // Populate missing fee data
                        if (tx.gasPrice == null) {
                            tx.gasPrice = feeData.gasPrice;
                        }
                        // Explicitly set untyped transaction to legacy
                        tx.type = 0;
                    }
                    else {
                        // getFeeData has failed us.
                        lib_esm_logger.throwError("failed to get consistent fee data", lib_esm_Logger.errors.UNSUPPORTED_OPERATION, {
                            operation: "signer.getFeeData"
                        });
                    }
                }
                else if (tx.type === 2) {
                    // Explicitly using EIP-1559
                    // Populate missing fee data
                    if (tx.maxFeePerGas == null) {
                        tx.maxFeePerGas = feeData.maxFeePerGas;
                    }
                    if (tx.maxPriorityFeePerGas == null) {
                        tx.maxPriorityFeePerGas = feeData.maxPriorityFeePerGas;
                    }
                }
            }
            if (tx.nonce == null) {
                tx.nonce = this.getTransactionCount("pending");
            }
            if (tx.gasLimit == null) {
                tx.gasLimit = this.estimateGas(tx).catch((error) => {
                    if (forwardErrors.indexOf(error.code) >= 0) {
                        throw error;
                    }
                    return lib_esm_logger.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", lib_esm_Logger.errors.UNPREDICTABLE_GAS_LIMIT, {
                        error: error,
                        tx: tx
                    });
                });
            }
            if (tx.chainId == null) {
                tx.chainId = this.getChainId();
            }
            else {
                tx.chainId = Promise.all([
                    Promise.resolve(tx.chainId),
                    this.getChainId()
                ]).then((results) => {
                    if (results[1] !== 0 && results[0] !== results[1]) {
                        lib_esm_logger.throwArgumentError("chainId address mismatch", "transaction", transaction);
                    }
                    return results[0];
                });
            }
            return yield resolveProperties(tx);
        });
    }
    ///////////////////
    // Sub-classes SHOULD leave these alone
    _checkProvider(operation) {
        if (!this.provider) {
            lib_esm_logger.throwError("missing provider", lib_esm_Logger.errors.UNSUPPORTED_OPERATION, {
                operation: (operation || "_checkProvider")
            });
        }
    }
    static isSigner(value) {
        return !!(value && value._isSigner);
    }
}
class VoidSigner extends lib_esm_Signer {
    constructor(address, provider) {
        super();
        lib_esm_defineReadOnly(this, "address", address);
        lib_esm_defineReadOnly(this, "provider", provider || null);
    }
    getAddress() {
        return Promise.resolve(this.address);
    }
    _fail(message, operation) {
        return Promise.resolve().then(() => {
            lib_esm_logger.throwError(message, lib_esm_Logger.errors.UNSUPPORTED_OPERATION, { operation: operation });
        });
    }
    signMessage(message) {
        return this._fail("VoidSigner cannot sign messages", "signMessage");
    }
    signTransaction(transaction) {
        return this._fail("VoidSigner cannot sign transactions", "signTransaction");
    }
    _signTypedData(domain, types, value) {
        return this._fail("VoidSigner cannot sign typed data", "signTypedData");
    }
    connect(provider) {
        return new VoidSigner(this.address, provider);
    }
}
//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./node_modules/.pnpm/bn.js@5.2.1/node_modules/bn.js/lib/bn.js
var bn = __webpack_require__(98);
var bn_default = /*#__PURE__*/__webpack_require__.n(bn);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+bytes@5.7.0/node_modules/@ethersproject/bytes/lib.esm/_version.js
const bytes_lib_esm_version_version = "bytes/5.7.0";
//# sourceMappingURL=_version.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+bytes@5.7.0/node_modules/@ethersproject/bytes/lib.esm/index.js



const bytes_lib_esm_logger = new lib_esm_Logger(bytes_lib_esm_version_version);
///////////////////////////////
function isHexable(value) {
    return !!(value.toHexString);
}
function addSlice(array) {
    if (array.slice) {
        return array;
    }
    array.slice = function () {
        const args = Array.prototype.slice.call(arguments);
        return addSlice(new Uint8Array(Array.prototype.slice.apply(array, args)));
    };
    return array;
}
function isBytesLike(value) {
    return ((lib_esm_isHexString(value) && !(value.length % 2)) || lib_esm_isBytes(value));
}
function isInteger(value) {
    return (typeof (value) === "number" && value == value && (value % 1) === 0);
}
function lib_esm_isBytes(value) {
    if (value == null) {
        return false;
    }
    if (value.constructor === Uint8Array) {
        return true;
    }
    if (typeof (value) === "string") {
        return false;
    }
    if (!isInteger(value.length) || value.length < 0) {
        return false;
    }
    for (let i = 0; i < value.length; i++) {
        const v = value[i];
        if (!isInteger(v) || v < 0 || v >= 256) {
            return false;
        }
    }
    return true;
}
function lib_esm_arrayify(value, options) {
    if (!options) {
        options = {};
    }
    if (typeof (value) === "number") {
        bytes_lib_esm_logger.checkSafeUint53(value, "invalid arrayify value");
        const result = [];
        while (value) {
            result.unshift(value & 0xff);
            value = parseInt(String(value / 256));
        }
        if (result.length === 0) {
            result.push(0);
        }
        return addSlice(new Uint8Array(result));
    }
    if (options.allowMissingPrefix && typeof (value) === "string" && value.substring(0, 2) !== "0x") {
        value = "0x" + value;
    }
    if (isHexable(value)) {
        value = value.toHexString();
    }
    if (lib_esm_isHexString(value)) {
        let hex = value.substring(2);
        if (hex.length % 2) {
            if (options.hexPad === "left") {
                hex = "0" + hex;
            }
            else if (options.hexPad === "right") {
                hex += "0";
            }
            else {
                bytes_lib_esm_logger.throwArgumentError("hex data is odd-length", "value", value);
            }
        }
        const result = [];
        for (let i = 0; i < hex.length; i += 2) {
            result.push(parseInt(hex.substring(i, i + 2), 16));
        }
        return addSlice(new Uint8Array(result));
    }
    if (lib_esm_isBytes(value)) {
        return addSlice(new Uint8Array(value));
    }
    return bytes_lib_esm_logger.throwArgumentError("invalid arrayify value", "value", value);
}
function lib_esm_concat(items) {
    const objects = items.map(item => lib_esm_arrayify(item));
    const length = objects.reduce((accum, item) => (accum + item.length), 0);
    const result = new Uint8Array(length);
    objects.reduce((offset, object) => {
        result.set(object, offset);
        return offset + object.length;
    }, 0);
    return addSlice(result);
}
function stripZeros(value) {
    let result = lib_esm_arrayify(value);
    if (result.length === 0) {
        return result;
    }
    // Find the first non-zero entry
    let start = 0;
    while (start < result.length && result[start] === 0) {
        start++;
    }
    // If we started with zeros, strip them
    if (start) {
        result = result.slice(start);
    }
    return result;
}
function zeroPad(value, length) {
    value = lib_esm_arrayify(value);
    if (value.length > length) {
        bytes_lib_esm_logger.throwArgumentError("value out of range", "value", arguments[0]);
    }
    const result = new Uint8Array(length);
    result.set(value, length - value.length);
    return addSlice(result);
}
function lib_esm_isHexString(value, length) {
    if (typeof (value) !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) {
        return false;
    }
    if (length && value.length !== 2 + 2 * length) {
        return false;
    }
    return true;
}
const HexCharacters = "0123456789abcdef";
function lib_esm_hexlify(value, options) {
    if (!options) {
        options = {};
    }
    if (typeof (value) === "number") {
        bytes_lib_esm_logger.checkSafeUint53(value, "invalid hexlify value");
        let hex = "";
        while (value) {
            hex = HexCharacters[value & 0xf] + hex;
            value = Math.floor(value / 16);
        }
        if (hex.length) {
            if (hex.length % 2) {
                hex = "0" + hex;
            }
            return "0x" + hex;
        }
        return "0x00";
    }
    if (typeof (value) === "bigint") {
        value = value.toString(16);
        if (value.length % 2) {
            return ("0x0" + value);
        }
        return "0x" + value;
    }
    if (options.allowMissingPrefix && typeof (value) === "string" && value.substring(0, 2) !== "0x") {
        value = "0x" + value;
    }
    if (isHexable(value)) {
        return value.toHexString();
    }
    if (lib_esm_isHexString(value)) {
        if (value.length % 2) {
            if (options.hexPad === "left") {
                value = "0x0" + value.substring(2);
            }
            else if (options.hexPad === "right") {
                value += "0";
            }
            else {
                bytes_lib_esm_logger.throwArgumentError("hex data is odd-length", "value", value);
            }
        }
        return value.toLowerCase();
    }
    if (lib_esm_isBytes(value)) {
        let result = "0x";
        for (let i = 0; i < value.length; i++) {
            let v = value[i];
            result += HexCharacters[(v & 0xf0) >> 4] + HexCharacters[v & 0x0f];
        }
        return result;
    }
    return bytes_lib_esm_logger.throwArgumentError("invalid hexlify value", "value", value);
}
/*
function unoddify(value: BytesLike | Hexable | number): BytesLike | Hexable | number {
    if (typeof(value) === "string" && value.length % 2 && value.substring(0, 2) === "0x") {
        return "0x0" + value.substring(2);
    }
    return value;
}
*/
function lib_esm_hexDataLength(data) {
    if (typeof (data) !== "string") {
        data = lib_esm_hexlify(data);
    }
    else if (!lib_esm_isHexString(data) || (data.length % 2)) {
        return null;
    }
    return (data.length - 2) / 2;
}
function lib_esm_hexDataSlice(data, offset, endOffset) {
    if (typeof (data) !== "string") {
        data = lib_esm_hexlify(data);
    }
    else if (!lib_esm_isHexString(data) || (data.length % 2)) {
        bytes_lib_esm_logger.throwArgumentError("invalid hexData", "value", data);
    }
    offset = 2 + 2 * offset;
    if (endOffset != null) {
        return "0x" + data.substring(offset, 2 + 2 * endOffset);
    }
    return "0x" + data.substring(offset);
}
function hexConcat(items) {
    let result = "0x";
    items.forEach((item) => {
        result += lib_esm_hexlify(item).substring(2);
    });
    return result;
}
function hexValue(value) {
    const trimmed = hexStripZeros(lib_esm_hexlify(value, { hexPad: "left" }));
    if (trimmed === "0x") {
        return "0x0";
    }
    return trimmed;
}
function hexStripZeros(value) {
    if (typeof (value) !== "string") {
        value = lib_esm_hexlify(value);
    }
    if (!lib_esm_isHexString(value)) {
        bytes_lib_esm_logger.throwArgumentError("invalid hex string", "value", value);
    }
    value = value.substring(2);
    let offset = 0;
    while (offset < value.length && value[offset] === "0") {
        offset++;
    }
    return "0x" + value.substring(offset);
}
function hexZeroPad(value, length) {
    if (typeof (value) !== "string") {
        value = lib_esm_hexlify(value);
    }
    else if (!lib_esm_isHexString(value)) {
        bytes_lib_esm_logger.throwArgumentError("invalid hex string", "value", value);
    }
    if (value.length > 2 * length + 2) {
        bytes_lib_esm_logger.throwArgumentError("value out of range", "value", arguments[1]);
    }
    while (value.length < 2 * length + 2) {
        value = "0x0" + value.substring(2);
    }
    return value;
}
function splitSignature(signature) {
    const result = {
        r: "0x",
        s: "0x",
        _vs: "0x",
        recoveryParam: 0,
        v: 0,
        yParityAndS: "0x",
        compact: "0x"
    };
    if (isBytesLike(signature)) {
        let bytes = lib_esm_arrayify(signature);
        // Get the r, s and v
        if (bytes.length === 64) {
            // EIP-2098; pull the v from the top bit of s and clear it
            result.v = 27 + (bytes[32] >> 7);
            bytes[32] &= 0x7f;
            result.r = lib_esm_hexlify(bytes.slice(0, 32));
            result.s = lib_esm_hexlify(bytes.slice(32, 64));
        }
        else if (bytes.length === 65) {
            result.r = lib_esm_hexlify(bytes.slice(0, 32));
            result.s = lib_esm_hexlify(bytes.slice(32, 64));
            result.v = bytes[64];
        }
        else {
            bytes_lib_esm_logger.throwArgumentError("invalid signature string", "signature", signature);
        }
        // Allow a recid to be used as the v
        if (result.v < 27) {
            if (result.v === 0 || result.v === 1) {
                result.v += 27;
            }
            else {
                bytes_lib_esm_logger.throwArgumentError("signature invalid v byte", "signature", signature);
            }
        }
        // Compute recoveryParam from v
        result.recoveryParam = 1 - (result.v % 2);
        // Compute _vs from recoveryParam and s
        if (result.recoveryParam) {
            bytes[32] |= 0x80;
        }
        result._vs = lib_esm_hexlify(bytes.slice(32, 64));
    }
    else {
        result.r = signature.r;
        result.s = signature.s;
        result.v = signature.v;
        result.recoveryParam = signature.recoveryParam;
        result._vs = signature._vs;
        // If the _vs is available, use it to populate missing s, v and recoveryParam
        // and verify non-missing s, v and recoveryParam
        if (result._vs != null) {
            const vs = zeroPad(lib_esm_arrayify(result._vs), 32);
            result._vs = lib_esm_hexlify(vs);
            // Set or check the recid
            const recoveryParam = ((vs[0] >= 128) ? 1 : 0);
            if (result.recoveryParam == null) {
                result.recoveryParam = recoveryParam;
            }
            else if (result.recoveryParam !== recoveryParam) {
                bytes_lib_esm_logger.throwArgumentError("signature recoveryParam mismatch _vs", "signature", signature);
            }
            // Set or check the s
            vs[0] &= 0x7f;
            const s = lib_esm_hexlify(vs);
            if (result.s == null) {
                result.s = s;
            }
            else if (result.s !== s) {
                bytes_lib_esm_logger.throwArgumentError("signature v mismatch _vs", "signature", signature);
            }
        }
        // Use recid and v to populate each other
        if (result.recoveryParam == null) {
            if (result.v == null) {
                bytes_lib_esm_logger.throwArgumentError("signature missing v and recoveryParam", "signature", signature);
            }
            else if (result.v === 0 || result.v === 1) {
                result.recoveryParam = result.v;
            }
            else {
                result.recoveryParam = 1 - (result.v % 2);
            }
        }
        else {
            if (result.v == null) {
                result.v = 27 + result.recoveryParam;
            }
            else {
                const recId = (result.v === 0 || result.v === 1) ? result.v : (1 - (result.v % 2));
                if (result.recoveryParam !== recId) {
                    bytes_lib_esm_logger.throwArgumentError("signature recoveryParam mismatch v", "signature", signature);
                }
            }
        }
        if (result.r == null || !lib_esm_isHexString(result.r)) {
            bytes_lib_esm_logger.throwArgumentError("signature missing or invalid r", "signature", signature);
        }
        else {
            result.r = hexZeroPad(result.r, 32);
        }
        if (result.s == null || !lib_esm_isHexString(result.s)) {
            bytes_lib_esm_logger.throwArgumentError("signature missing or invalid s", "signature", signature);
        }
        else {
            result.s = hexZeroPad(result.s, 32);
        }
        const vs = lib_esm_arrayify(result.s);
        if (vs[0] >= 128) {
            bytes_lib_esm_logger.throwArgumentError("signature s out of range", "signature", signature);
        }
        if (result.recoveryParam) {
            vs[0] |= 0x80;
        }
        const _vs = lib_esm_hexlify(vs);
        if (result._vs) {
            if (!lib_esm_isHexString(result._vs)) {
                bytes_lib_esm_logger.throwArgumentError("signature invalid _vs", "signature", signature);
            }
            result._vs = hexZeroPad(result._vs, 32);
        }
        // Set or check the _vs
        if (result._vs == null) {
            result._vs = _vs;
        }
        else if (result._vs !== _vs) {
            bytes_lib_esm_logger.throwArgumentError("signature _vs mismatch v and s", "signature", signature);
        }
    }
    result.yParityAndS = result._vs;
    result.compact = result.r + result.yParityAndS.substring(2);
    return result;
}
function joinSignature(signature) {
    signature = splitSignature(signature);
    return lib_esm_hexlify(lib_esm_concat([
        signature.r,
        signature.s,
        (signature.recoveryParam ? "0x1c" : "0x1b")
    ]));
}
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+bignumber@5.7.0/node_modules/@ethersproject/bignumber/lib.esm/_version.js
const bignumber_lib_esm_version_version = "bignumber/5.7.0";
//# sourceMappingURL=_version.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+bignumber@5.7.0/node_modules/@ethersproject/bignumber/lib.esm/bignumber.js

/**
 *  BigNumber
 *
 *  A wrapper around the BN.js object. We use the BN.js library
 *  because it is used by elliptic, so it is required regardless.
 *
 */

var BN = (bn_default()).BN;



const bignumber_logger = new lib_esm_Logger(bignumber_lib_esm_version_version);
const _constructorGuard = {};
const MAX_SAFE = 0x1fffffffffffff;
function isBigNumberish(value) {
    return (value != null) && (bignumber_BigNumber.isBigNumber(value) ||
        (typeof (value) === "number" && (value % 1) === 0) ||
        (typeof (value) === "string" && !!value.match(/^-?[0-9]+$/)) ||
        lib_esm_isHexString(value) ||
        (typeof (value) === "bigint") ||
        lib_esm_isBytes(value));
}
// Only warn about passing 10 into radix once
let _warnedToStringRadix = false;
class bignumber_BigNumber {
    constructor(constructorGuard, hex) {
        if (constructorGuard !== _constructorGuard) {
            bignumber_logger.throwError("cannot call constructor directly; use BigNumber.from", lib_esm_Logger.errors.UNSUPPORTED_OPERATION, {
                operation: "new (BigNumber)"
            });
        }
        this._hex = hex;
        this._isBigNumber = true;
        Object.freeze(this);
    }
    fromTwos(value) {
        return toBigNumber(toBN(this).fromTwos(value));
    }
    toTwos(value) {
        return toBigNumber(toBN(this).toTwos(value));
    }
    abs() {
        if (this._hex[0] === "-") {
            return bignumber_BigNumber.from(this._hex.substring(1));
        }
        return this;
    }
    add(other) {
        return toBigNumber(toBN(this).add(toBN(other)));
    }
    sub(other) {
        return toBigNumber(toBN(this).sub(toBN(other)));
    }
    div(other) {
        const o = bignumber_BigNumber.from(other);
        if (o.isZero()) {
            throwFault("division-by-zero", "div");
        }
        return toBigNumber(toBN(this).div(toBN(other)));
    }
    mul(other) {
        return toBigNumber(toBN(this).mul(toBN(other)));
    }
    mod(other) {
        const value = toBN(other);
        if (value.isNeg()) {
            throwFault("division-by-zero", "mod");
        }
        return toBigNumber(toBN(this).umod(value));
    }
    pow(other) {
        const value = toBN(other);
        if (value.isNeg()) {
            throwFault("negative-power", "pow");
        }
        return toBigNumber(toBN(this).pow(value));
    }
    and(other) {
        const value = toBN(other);
        if (this.isNegative() || value.isNeg()) {
            throwFault("unbound-bitwise-result", "and");
        }
        return toBigNumber(toBN(this).and(value));
    }
    or(other) {
        const value = toBN(other);
        if (this.isNegative() || value.isNeg()) {
            throwFault("unbound-bitwise-result", "or");
        }
        return toBigNumber(toBN(this).or(value));
    }
    xor(other) {
        const value = toBN(other);
        if (this.isNegative() || value.isNeg()) {
            throwFault("unbound-bitwise-result", "xor");
        }
        return toBigNumber(toBN(this).xor(value));
    }
    mask(value) {
        if (this.isNegative() || value < 0) {
            throwFault("negative-width", "mask");
        }
        return toBigNumber(toBN(this).maskn(value));
    }
    shl(value) {
        if (this.isNegative() || value < 0) {
            throwFault("negative-width", "shl");
        }
        return toBigNumber(toBN(this).shln(value));
    }
    shr(value) {
        if (this.isNegative() || value < 0) {
            throwFault("negative-width", "shr");
        }
        return toBigNumber(toBN(this).shrn(value));
    }
    eq(other) {
        return toBN(this).eq(toBN(other));
    }
    lt(other) {
        return toBN(this).lt(toBN(other));
    }
    lte(other) {
        return toBN(this).lte(toBN(other));
    }
    gt(other) {
        return toBN(this).gt(toBN(other));
    }
    gte(other) {
        return toBN(this).gte(toBN(other));
    }
    isNegative() {
        return (this._hex[0] === "-");
    }
    isZero() {
        return toBN(this).isZero();
    }
    toNumber() {
        try {
            return toBN(this).toNumber();
        }
        catch (error) {
            throwFault("overflow", "toNumber", this.toString());
        }
        return null;
    }
    toBigInt() {
        try {
            return BigInt(this.toString());
        }
        catch (e) { }
        return bignumber_logger.throwError("this platform does not support BigInt", lib_esm_Logger.errors.UNSUPPORTED_OPERATION, {
            value: this.toString()
        });
    }
    toString() {
        // Lots of people expect this, which we do not support, so check (See: #889)
        if (arguments.length > 0) {
            if (arguments[0] === 10) {
                if (!_warnedToStringRadix) {
                    _warnedToStringRadix = true;
                    bignumber_logger.warn("BigNumber.toString does not accept any parameters; base-10 is assumed");
                }
            }
            else if (arguments[0] === 16) {
                bignumber_logger.throwError("BigNumber.toString does not accept any parameters; use bigNumber.toHexString()", lib_esm_Logger.errors.UNEXPECTED_ARGUMENT, {});
            }
            else {
                bignumber_logger.throwError("BigNumber.toString does not accept parameters", lib_esm_Logger.errors.UNEXPECTED_ARGUMENT, {});
            }
        }
        return toBN(this).toString(10);
    }
    toHexString() {
        return this._hex;
    }
    toJSON(key) {
        return { type: "BigNumber", hex: this.toHexString() };
    }
    static from(value) {
        if (value instanceof bignumber_BigNumber) {
            return value;
        }
        if (typeof (value) === "string") {
            if (value.match(/^-?0x[0-9a-f]+$/i)) {
                return new bignumber_BigNumber(_constructorGuard, toHex(value));
            }
            if (value.match(/^-?[0-9]+$/)) {
                return new bignumber_BigNumber(_constructorGuard, toHex(new BN(value)));
            }
            return bignumber_logger.throwArgumentError("invalid BigNumber string", "value", value);
        }
        if (typeof (value) === "number") {
            if (value % 1) {
                throwFault("underflow", "BigNumber.from", value);
            }
            if (value >= MAX_SAFE || value <= -MAX_SAFE) {
                throwFault("overflow", "BigNumber.from", value);
            }
            return bignumber_BigNumber.from(String(value));
        }
        const anyValue = value;
        if (typeof (anyValue) === "bigint") {
            return bignumber_BigNumber.from(anyValue.toString());
        }
        if (lib_esm_isBytes(anyValue)) {
            return bignumber_BigNumber.from(lib_esm_hexlify(anyValue));
        }
        if (anyValue) {
            // Hexable interface (takes priority)
            if (anyValue.toHexString) {
                const hex = anyValue.toHexString();
                if (typeof (hex) === "string") {
                    return bignumber_BigNumber.from(hex);
                }
            }
            else {
                // For now, handle legacy JSON-ified values (goes away in v6)
                let hex = anyValue._hex;
                // New-form JSON
                if (hex == null && anyValue.type === "BigNumber") {
                    hex = anyValue.hex;
                }
                if (typeof (hex) === "string") {
                    if (lib_esm_isHexString(hex) || (hex[0] === "-" && lib_esm_isHexString(hex.substring(1)))) {
                        return bignumber_BigNumber.from(hex);
                    }
                }
            }
        }
        return bignumber_logger.throwArgumentError("invalid BigNumber value", "value", value);
    }
    static isBigNumber(value) {
        return !!(value && value._isBigNumber);
    }
}
// Normalize the hex string
function toHex(value) {
    // For BN, call on the hex string
    if (typeof (value) !== "string") {
        return toHex(value.toString(16));
    }
    // If negative, prepend the negative sign to the normalized positive value
    if (value[0] === "-") {
        // Strip off the negative sign
        value = value.substring(1);
        // Cannot have multiple negative signs (e.g. "--0x04")
        if (value[0] === "-") {
            bignumber_logger.throwArgumentError("invalid hex", "value", value);
        }
        // Call toHex on the positive component
        value = toHex(value);
        // Do not allow "-0x00"
        if (value === "0x00") {
            return value;
        }
        // Negate the value
        return "-" + value;
    }
    // Add a "0x" prefix if missing
    if (value.substring(0, 2) !== "0x") {
        value = "0x" + value;
    }
    // Normalize zero
    if (value === "0x") {
        return "0x00";
    }
    // Make the string even length
    if (value.length % 2) {
        value = "0x0" + value.substring(2);
    }
    // Trim to smallest even-length string
    while (value.length > 4 && value.substring(0, 4) === "0x00") {
        value = "0x" + value.substring(4);
    }
    return value;
}
function toBigNumber(value) {
    return bignumber_BigNumber.from(toHex(value));
}
function toBN(value) {
    const hex = bignumber_BigNumber.from(value).toHexString();
    if (hex[0] === "-") {
        return (new BN("-" + hex.substring(3), 16));
    }
    return new BN(hex.substring(2), 16);
}
function throwFault(fault, operation, value) {
    const params = { fault: fault, operation: operation };
    if (value != null) {
        params.value = value;
    }
    return bignumber_logger.throwError(fault, lib_esm_Logger.errors.NUMERIC_FAULT, params);
}
// value should have no prefix
function _base36To16(value) {
    return (new BN(value, 36)).toString(16);
}
// value should have no prefix
function bignumber_base16To36(value) {
    return (new BN(value, 16)).toString(36);
}
//# sourceMappingURL=bignumber.js.map
// EXTERNAL MODULE: ./node_modules/.pnpm/js-sha3@0.8.0/node_modules/js-sha3/src/sha3.js
var sha3 = __webpack_require__(954);
var sha3_default = /*#__PURE__*/__webpack_require__.n(sha3);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+keccak256@5.7.0/node_modules/@ethersproject/keccak256/lib.esm/index.js



function lib_esm_keccak256(data) {
    return '0x' + sha3_default().keccak_256(lib_esm_arrayify(data));
}
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+rlp@5.7.0/node_modules/@ethersproject/rlp/lib.esm/_version.js
const rlp_lib_esm_version_version = "rlp/5.7.0";
//# sourceMappingURL=_version.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+rlp@5.7.0/node_modules/@ethersproject/rlp/lib.esm/index.js

//See: https://github.com/ethereum/wiki/wiki/RLP



const rlp_lib_esm_logger = new lib_esm_Logger(rlp_lib_esm_version_version);
function arrayifyInteger(value) {
    const result = [];
    while (value) {
        result.unshift(value & 0xff);
        value >>= 8;
    }
    return result;
}
function unarrayifyInteger(data, offset, length) {
    let result = 0;
    for (let i = 0; i < length; i++) {
        result = (result * 256) + data[offset + i];
    }
    return result;
}
function _encode(object) {
    if (Array.isArray(object)) {
        let payload = [];
        object.forEach(function (child) {
            payload = payload.concat(_encode(child));
        });
        if (payload.length <= 55) {
            payload.unshift(0xc0 + payload.length);
            return payload;
        }
        const length = arrayifyInteger(payload.length);
        length.unshift(0xf7 + length.length);
        return length.concat(payload);
    }
    if (!isBytesLike(object)) {
        rlp_lib_esm_logger.throwArgumentError("RLP object must be BytesLike", "object", object);
    }
    const data = Array.prototype.slice.call(lib_esm_arrayify(object));
    if (data.length === 1 && data[0] <= 0x7f) {
        return data;
    }
    else if (data.length <= 55) {
        data.unshift(0x80 + data.length);
        return data;
    }
    const length = arrayifyInteger(data.length);
    length.unshift(0xb7 + length.length);
    return length.concat(data);
}
function encode(object) {
    return lib_esm_hexlify(_encode(object));
}
function _decodeChildren(data, offset, childOffset, length) {
    const result = [];
    while (childOffset < offset + 1 + length) {
        const decoded = _decode(data, childOffset);
        result.push(decoded.result);
        childOffset += decoded.consumed;
        if (childOffset > offset + 1 + length) {
            rlp_lib_esm_logger.throwError("child data too short", lib_esm_Logger.errors.BUFFER_OVERRUN, {});
        }
    }
    return { consumed: (1 + length), result: result };
}
// returns { consumed: number, result: Object }
function _decode(data, offset) {
    if (data.length === 0) {
        rlp_lib_esm_logger.throwError("data too short", lib_esm_Logger.errors.BUFFER_OVERRUN, {});
    }
    // Array with extra length prefix
    if (data[offset] >= 0xf8) {
        const lengthLength = data[offset] - 0xf7;
        if (offset + 1 + lengthLength > data.length) {
            rlp_lib_esm_logger.throwError("data short segment too short", lib_esm_Logger.errors.BUFFER_OVERRUN, {});
        }
        const length = unarrayifyInteger(data, offset + 1, lengthLength);
        if (offset + 1 + lengthLength + length > data.length) {
            rlp_lib_esm_logger.throwError("data long segment too short", lib_esm_Logger.errors.BUFFER_OVERRUN, {});
        }
        return _decodeChildren(data, offset, offset + 1 + lengthLength, lengthLength + length);
    }
    else if (data[offset] >= 0xc0) {
        const length = data[offset] - 0xc0;
        if (offset + 1 + length > data.length) {
            rlp_lib_esm_logger.throwError("data array too short", lib_esm_Logger.errors.BUFFER_OVERRUN, {});
        }
        return _decodeChildren(data, offset, offset + 1, length);
    }
    else if (data[offset] >= 0xb8) {
        const lengthLength = data[offset] - 0xb7;
        if (offset + 1 + lengthLength > data.length) {
            rlp_lib_esm_logger.throwError("data array too short", lib_esm_Logger.errors.BUFFER_OVERRUN, {});
        }
        const length = unarrayifyInteger(data, offset + 1, lengthLength);
        if (offset + 1 + lengthLength + length > data.length) {
            rlp_lib_esm_logger.throwError("data array too short", lib_esm_Logger.errors.BUFFER_OVERRUN, {});
        }
        const result = lib_esm_hexlify(data.slice(offset + 1 + lengthLength, offset + 1 + lengthLength + length));
        return { consumed: (1 + lengthLength + length), result: result };
    }
    else if (data[offset] >= 0x80) {
        const length = data[offset] - 0x80;
        if (offset + 1 + length > data.length) {
            rlp_lib_esm_logger.throwError("data too short", lib_esm_Logger.errors.BUFFER_OVERRUN, {});
        }
        const result = lib_esm_hexlify(data.slice(offset + 1, offset + 1 + length));
        return { consumed: (1 + length), result: result };
    }
    return { consumed: 1, result: lib_esm_hexlify(data[offset]) };
}
function decode(data) {
    const bytes = lib_esm_arrayify(data);
    const decoded = _decode(bytes, 0);
    if (decoded.consumed !== bytes.length) {
        rlp_lib_esm_logger.throwArgumentError("invalid rlp data", "data", data);
    }
    return decoded.result;
}
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+address@5.7.0/node_modules/@ethersproject/address/lib.esm/_version.js
const address_lib_esm_version_version = "address/5.7.0";
//# sourceMappingURL=_version.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+address@5.7.0/node_modules/@ethersproject/address/lib.esm/index.js







const address_lib_esm_logger = new lib_esm_Logger(address_lib_esm_version_version);
function getChecksumAddress(address) {
    if (!lib_esm_isHexString(address, 20)) {
        address_lib_esm_logger.throwArgumentError("invalid address", "address", address);
    }
    address = address.toLowerCase();
    const chars = address.substring(2).split("");
    const expanded = new Uint8Array(40);
    for (let i = 0; i < 40; i++) {
        expanded[i] = chars[i].charCodeAt(0);
    }
    const hashed = lib_esm_arrayify(lib_esm_keccak256(expanded));
    for (let i = 0; i < 40; i += 2) {
        if ((hashed[i >> 1] >> 4) >= 8) {
            chars[i] = chars[i].toUpperCase();
        }
        if ((hashed[i >> 1] & 0x0f) >= 8) {
            chars[i + 1] = chars[i + 1].toUpperCase();
        }
    }
    return "0x" + chars.join("");
}
// Shims for environments that are missing some required constants and functions
const MAX_SAFE_INTEGER = 0x1fffffffffffff;
function log10(x) {
    if (Math.log10) {
        return Math.log10(x);
    }
    return Math.log(x) / Math.LN10;
}
// See: https://en.wikipedia.org/wiki/International_Bank_Account_Number
// Create lookup table
const ibanLookup = {};
for (let i = 0; i < 10; i++) {
    ibanLookup[String(i)] = String(i);
}
for (let i = 0; i < 26; i++) {
    ibanLookup[String.fromCharCode(65 + i)] = String(10 + i);
}
// How many decimal digits can we process? (for 64-bit float, this is 15)
const safeDigits = Math.floor(log10(MAX_SAFE_INTEGER));
function ibanChecksum(address) {
    address = address.toUpperCase();
    address = address.substring(4) + address.substring(0, 2) + "00";
    let expanded = address.split("").map((c) => { return ibanLookup[c]; }).join("");
    // Javascript can handle integers safely up to 15 (decimal) digits
    while (expanded.length >= safeDigits) {
        let block = expanded.substring(0, safeDigits);
        expanded = parseInt(block, 10) % 97 + expanded.substring(block.length);
    }
    let checksum = String(98 - (parseInt(expanded, 10) % 97));
    while (checksum.length < 2) {
        checksum = "0" + checksum;
    }
    return checksum;
}
;
function lib_esm_getAddress(address) {
    let result = null;
    if (typeof (address) !== "string") {
        address_lib_esm_logger.throwArgumentError("invalid address", "address", address);
    }
    if (address.match(/^(0x)?[0-9a-fA-F]{40}$/)) {
        // Missing the 0x prefix
        if (address.substring(0, 2) !== "0x") {
            address = "0x" + address;
        }
        result = getChecksumAddress(address);
        // It is a checksummed address with a bad checksum
        if (address.match(/([A-F].*[a-f])|([a-f].*[A-F])/) && result !== address) {
            address_lib_esm_logger.throwArgumentError("bad address checksum", "address", address);
        }
        // Maybe ICAP? (we only support direct mode)
    }
    else if (address.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
        // It is an ICAP address with a bad checksum
        if (address.substring(2, 4) !== ibanChecksum(address)) {
            address_lib_esm_logger.throwArgumentError("bad icap checksum", "address", address);
        }
        result = _base36To16(address.substring(4));
        while (result.length < 40) {
            result = "0" + result;
        }
        result = getChecksumAddress("0x" + result);
    }
    else {
        address_lib_esm_logger.throwArgumentError("invalid address", "address", address);
    }
    return result;
}
function isAddress(address) {
    try {
        lib_esm_getAddress(address);
        return true;
    }
    catch (error) { }
    return false;
}
function getIcapAddress(address) {
    let base36 = _base16To36(lib_esm_getAddress(address).substring(2)).toUpperCase();
    while (base36.length < 30) {
        base36 = "0" + base36;
    }
    return "XE" + ibanChecksum("XE00" + base36) + base36;
}
// http://ethereum.stackexchange.com/questions/760/how-is-the-address-of-an-ethereum-contract-computed
function lib_esm_getContractAddress(transaction) {
    let from = null;
    try {
        from = lib_esm_getAddress(transaction.from);
    }
    catch (error) {
        address_lib_esm_logger.throwArgumentError("missing from address", "transaction", transaction);
    }
    const nonce = stripZeros(lib_esm_arrayify(bignumber_BigNumber.from(transaction.nonce).toHexString()));
    return lib_esm_getAddress(lib_esm_hexDataSlice(lib_esm_keccak256(encode([from, nonce])), 12));
}
function getCreate2Address(from, salt, initCodeHash) {
    if (hexDataLength(salt) !== 32) {
        address_lib_esm_logger.throwArgumentError("salt must be 32 bytes", "salt", salt);
    }
    if (hexDataLength(initCodeHash) !== 32) {
        address_lib_esm_logger.throwArgumentError("initCodeHash must be 32 bytes", "initCodeHash", initCodeHash);
    }
    return lib_esm_getAddress(hexDataSlice(keccak256(concat(["0xff", lib_esm_getAddress(from), salt, initCodeHash])), 12));
}
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+hash@5.7.0/node_modules/@ethersproject/hash/lib.esm/_version.js
const hash_lib_esm_version_version = "hash/5.7.0";
//# sourceMappingURL=_version.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+strings@5.7.0/node_modules/@ethersproject/strings/lib.esm/_version.js
const strings_lib_esm_version_version = "strings/5.7.0";
//# sourceMappingURL=_version.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+strings@5.7.0/node_modules/@ethersproject/strings/lib.esm/utf8.js




const utf8_logger = new lib_esm_Logger(strings_lib_esm_version_version);
///////////////////////////////
var UnicodeNormalizationForm;
(function (UnicodeNormalizationForm) {
    UnicodeNormalizationForm["current"] = "";
    UnicodeNormalizationForm["NFC"] = "NFC";
    UnicodeNormalizationForm["NFD"] = "NFD";
    UnicodeNormalizationForm["NFKC"] = "NFKC";
    UnicodeNormalizationForm["NFKD"] = "NFKD";
})(UnicodeNormalizationForm || (UnicodeNormalizationForm = {}));
;
var Utf8ErrorReason;
(function (Utf8ErrorReason) {
    // A continuation byte was present where there was nothing to continue
    // - offset = the index the codepoint began in
    Utf8ErrorReason["UNEXPECTED_CONTINUE"] = "unexpected continuation byte";
    // An invalid (non-continuation) byte to start a UTF-8 codepoint was found
    // - offset = the index the codepoint began in
    Utf8ErrorReason["BAD_PREFIX"] = "bad codepoint prefix";
    // The string is too short to process the expected codepoint
    // - offset = the index the codepoint began in
    Utf8ErrorReason["OVERRUN"] = "string overrun";
    // A missing continuation byte was expected but not found
    // - offset = the index the continuation byte was expected at
    Utf8ErrorReason["MISSING_CONTINUE"] = "missing continuation byte";
    // The computed code point is outside the range for UTF-8
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; outside the UTF-8 range
    Utf8ErrorReason["OUT_OF_RANGE"] = "out of UTF-8 range";
    // UTF-8 strings may not contain UTF-16 surrogate pairs
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; inside the UTF-16 surrogate range
    Utf8ErrorReason["UTF16_SURROGATE"] = "UTF-16 surrogate";
    // The string is an overlong representation
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; already bounds checked
    Utf8ErrorReason["OVERLONG"] = "overlong representation";
})(Utf8ErrorReason || (Utf8ErrorReason = {}));
;
function errorFunc(reason, offset, bytes, output, badCodepoint) {
    return utf8_logger.throwArgumentError(`invalid codepoint at offset ${offset}; ${reason}`, "bytes", bytes);
}
function ignoreFunc(reason, offset, bytes, output, badCodepoint) {
    // If there is an invalid prefix (including stray continuation), skip any additional continuation bytes
    if (reason === Utf8ErrorReason.BAD_PREFIX || reason === Utf8ErrorReason.UNEXPECTED_CONTINUE) {
        let i = 0;
        for (let o = offset + 1; o < bytes.length; o++) {
            if (bytes[o] >> 6 !== 0x02) {
                break;
            }
            i++;
        }
        return i;
    }
    // This byte runs us past the end of the string, so just jump to the end
    // (but the first byte was read already read and therefore skipped)
    if (reason === Utf8ErrorReason.OVERRUN) {
        return bytes.length - offset - 1;
    }
    // Nothing to skip
    return 0;
}
function replaceFunc(reason, offset, bytes, output, badCodepoint) {
    // Overlong representations are otherwise "valid" code points; just non-deistingtished
    if (reason === Utf8ErrorReason.OVERLONG) {
        output.push(badCodepoint);
        return 0;
    }
    // Put the replacement character into the output
    output.push(0xfffd);
    // Otherwise, process as if ignoring errors
    return ignoreFunc(reason, offset, bytes, output, badCodepoint);
}
// Common error handing strategies
const Utf8ErrorFuncs = Object.freeze({
    error: errorFunc,
    ignore: ignoreFunc,
    replace: replaceFunc
});
// http://stackoverflow.com/questions/13356493/decode-utf-8-with-javascript#13691499
function getUtf8CodePoints(bytes, onError) {
    if (onError == null) {
        onError = Utf8ErrorFuncs.error;
    }
    bytes = lib_esm_arrayify(bytes);
    const result = [];
    let i = 0;
    // Invalid bytes are ignored
    while (i < bytes.length) {
        const c = bytes[i++];
        // 0xxx xxxx
        if (c >> 7 === 0) {
            result.push(c);
            continue;
        }
        // Multibyte; how many bytes left for this character?
        let extraLength = null;
        let overlongMask = null;
        // 110x xxxx 10xx xxxx
        if ((c & 0xe0) === 0xc0) {
            extraLength = 1;
            overlongMask = 0x7f;
            // 1110 xxxx 10xx xxxx 10xx xxxx
        }
        else if ((c & 0xf0) === 0xe0) {
            extraLength = 2;
            overlongMask = 0x7ff;
            // 1111 0xxx 10xx xxxx 10xx xxxx 10xx xxxx
        }
        else if ((c & 0xf8) === 0xf0) {
            extraLength = 3;
            overlongMask = 0xffff;
        }
        else {
            if ((c & 0xc0) === 0x80) {
                i += onError(Utf8ErrorReason.UNEXPECTED_CONTINUE, i - 1, bytes, result);
            }
            else {
                i += onError(Utf8ErrorReason.BAD_PREFIX, i - 1, bytes, result);
            }
            continue;
        }
        // Do we have enough bytes in our data?
        if (i - 1 + extraLength >= bytes.length) {
            i += onError(Utf8ErrorReason.OVERRUN, i - 1, bytes, result);
            continue;
        }
        // Remove the length prefix from the char
        let res = c & ((1 << (8 - extraLength - 1)) - 1);
        for (let j = 0; j < extraLength; j++) {
            let nextChar = bytes[i];
            // Invalid continuation byte
            if ((nextChar & 0xc0) != 0x80) {
                i += onError(Utf8ErrorReason.MISSING_CONTINUE, i, bytes, result);
                res = null;
                break;
            }
            ;
            res = (res << 6) | (nextChar & 0x3f);
            i++;
        }
        // See above loop for invalid continuation byte
        if (res === null) {
            continue;
        }
        // Maximum code point
        if (res > 0x10ffff) {
            i += onError(Utf8ErrorReason.OUT_OF_RANGE, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Reserved for UTF-16 surrogate halves
        if (res >= 0xd800 && res <= 0xdfff) {
            i += onError(Utf8ErrorReason.UTF16_SURROGATE, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Check for overlong sequences (more bytes than needed)
        if (res <= overlongMask) {
            i += onError(Utf8ErrorReason.OVERLONG, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        result.push(res);
    }
    return result;
}
// http://stackoverflow.com/questions/18729405/how-to-convert-utf8-string-to-byte-array
function toUtf8Bytes(str, form = UnicodeNormalizationForm.current) {
    if (form != UnicodeNormalizationForm.current) {
        utf8_logger.checkNormalize();
        str = str.normalize(form);
    }
    let result = [];
    for (let i = 0; i < str.length; i++) {
        const c = str.charCodeAt(i);
        if (c < 0x80) {
            result.push(c);
        }
        else if (c < 0x800) {
            result.push((c >> 6) | 0xc0);
            result.push((c & 0x3f) | 0x80);
        }
        else if ((c & 0xfc00) == 0xd800) {
            i++;
            const c2 = str.charCodeAt(i);
            if (i >= str.length || (c2 & 0xfc00) !== 0xdc00) {
                throw new Error("invalid utf-8 string");
            }
            // Surrogate Pair
            const pair = 0x10000 + ((c & 0x03ff) << 10) + (c2 & 0x03ff);
            result.push((pair >> 18) | 0xf0);
            result.push(((pair >> 12) & 0x3f) | 0x80);
            result.push(((pair >> 6) & 0x3f) | 0x80);
            result.push((pair & 0x3f) | 0x80);
        }
        else {
            result.push((c >> 12) | 0xe0);
            result.push(((c >> 6) & 0x3f) | 0x80);
            result.push((c & 0x3f) | 0x80);
        }
    }
    return lib_esm_arrayify(result);
}
;
function escapeChar(value) {
    const hex = ("0000" + value.toString(16));
    return "\\u" + hex.substring(hex.length - 4);
}
function _toEscapedUtf8String(bytes, onError) {
    return '"' + getUtf8CodePoints(bytes, onError).map((codePoint) => {
        if (codePoint < 256) {
            switch (codePoint) {
                case 8: return "\\b";
                case 9: return "\\t";
                case 10: return "\\n";
                case 13: return "\\r";
                case 34: return "\\\"";
                case 92: return "\\\\";
            }
            if (codePoint >= 32 && codePoint < 127) {
                return String.fromCharCode(codePoint);
            }
        }
        if (codePoint <= 0xffff) {
            return escapeChar(codePoint);
        }
        codePoint -= 0x10000;
        return escapeChar(((codePoint >> 10) & 0x3ff) + 0xd800) + escapeChar((codePoint & 0x3ff) + 0xdc00);
    }).join("") + '"';
}
function _toUtf8String(codePoints) {
    return codePoints.map((codePoint) => {
        if (codePoint <= 0xffff) {
            return String.fromCharCode(codePoint);
        }
        codePoint -= 0x10000;
        return String.fromCharCode((((codePoint >> 10) & 0x3ff) + 0xd800), ((codePoint & 0x3ff) + 0xdc00));
    }).join("");
}
function utf8_toUtf8String(bytes, onError) {
    return _toUtf8String(getUtf8CodePoints(bytes, onError));
}
function toUtf8CodePoints(str, form = UnicodeNormalizationForm.current) {
    return getUtf8CodePoints(toUtf8Bytes(str, form));
}
//# sourceMappingURL=utf8.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+hash@5.7.0/node_modules/@ethersproject/hash/lib.esm/id.js


function id(text) {
    return lib_esm_keccak256(toUtf8Bytes(text));
}
//# sourceMappingURL=id.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+hash@5.7.0/node_modules/@ethersproject/hash/lib.esm/typed-data.js
var typed_data_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};







const typed_data_logger = new lib_esm_Logger(hash_lib_esm_version_version);

const padding = new Uint8Array(32);
padding.fill(0);
const NegativeOne = bignumber_BigNumber.from(-1);
const Zero = bignumber_BigNumber.from(0);
const One = bignumber_BigNumber.from(1);
const MaxUint256 = bignumber_BigNumber.from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
function hexPadRight(value) {
    const bytes = lib_esm_arrayify(value);
    const padOffset = bytes.length % 32;
    if (padOffset) {
        return hexConcat([bytes, padding.slice(padOffset)]);
    }
    return lib_esm_hexlify(bytes);
}
const hexTrue = hexZeroPad(One.toHexString(), 32);
const hexFalse = hexZeroPad(Zero.toHexString(), 32);
const domainFieldTypes = {
    name: "string",
    version: "string",
    chainId: "uint256",
    verifyingContract: "address",
    salt: "bytes32"
};
const domainFieldNames = [
    "name", "version", "chainId", "verifyingContract", "salt"
];
function checkString(key) {
    return function (value) {
        if (typeof (value) !== "string") {
            typed_data_logger.throwArgumentError(`invalid domain value for ${JSON.stringify(key)}`, `domain.${key}`, value);
        }
        return value;
    };
}
const domainChecks = {
    name: checkString("name"),
    version: checkString("version"),
    chainId: function (value) {
        try {
            return bignumber_BigNumber.from(value).toString();
        }
        catch (error) { }
        return typed_data_logger.throwArgumentError(`invalid domain value for "chainId"`, "domain.chainId", value);
    },
    verifyingContract: function (value) {
        try {
            return lib_esm_getAddress(value).toLowerCase();
        }
        catch (error) { }
        return typed_data_logger.throwArgumentError(`invalid domain value "verifyingContract"`, "domain.verifyingContract", value);
    },
    salt: function (value) {
        try {
            const bytes = lib_esm_arrayify(value);
            if (bytes.length !== 32) {
                throw new Error("bad length");
            }
            return lib_esm_hexlify(bytes);
        }
        catch (error) { }
        return typed_data_logger.throwArgumentError(`invalid domain value "salt"`, "domain.salt", value);
    }
};
function getBaseEncoder(type) {
    // intXX and uintXX
    {
        const match = type.match(/^(u?)int(\d*)$/);
        if (match) {
            const signed = (match[1] === "");
            const width = parseInt(match[2] || "256");
            if (width % 8 !== 0 || width > 256 || (match[2] && match[2] !== String(width))) {
                typed_data_logger.throwArgumentError("invalid numeric width", "type", type);
            }
            const boundsUpper = MaxUint256.mask(signed ? (width - 1) : width);
            const boundsLower = signed ? boundsUpper.add(One).mul(NegativeOne) : Zero;
            return function (value) {
                const v = bignumber_BigNumber.from(value);
                if (v.lt(boundsLower) || v.gt(boundsUpper)) {
                    typed_data_logger.throwArgumentError(`value out-of-bounds for ${type}`, "value", value);
                }
                return hexZeroPad(v.toTwos(256).toHexString(), 32);
            };
        }
    }
    // bytesXX
    {
        const match = type.match(/^bytes(\d+)$/);
        if (match) {
            const width = parseInt(match[1]);
            if (width === 0 || width > 32 || match[1] !== String(width)) {
                typed_data_logger.throwArgumentError("invalid bytes width", "type", type);
            }
            return function (value) {
                const bytes = lib_esm_arrayify(value);
                if (bytes.length !== width) {
                    typed_data_logger.throwArgumentError(`invalid length for ${type}`, "value", value);
                }
                return hexPadRight(value);
            };
        }
    }
    switch (type) {
        case "address": return function (value) {
            return hexZeroPad(lib_esm_getAddress(value), 32);
        };
        case "bool": return function (value) {
            return ((!value) ? hexFalse : hexTrue);
        };
        case "bytes": return function (value) {
            return lib_esm_keccak256(value);
        };
        case "string": return function (value) {
            return id(value);
        };
    }
    return null;
}
function encodeType(name, fields) {
    return `${name}(${fields.map(({ name, type }) => (type + " " + name)).join(",")})`;
}
class TypedDataEncoder {
    constructor(types) {
        lib_esm_defineReadOnly(this, "types", Object.freeze(deepCopy(types)));
        lib_esm_defineReadOnly(this, "_encoderCache", {});
        lib_esm_defineReadOnly(this, "_types", {});
        // Link struct types to their direct child structs
        const links = {};
        // Link structs to structs which contain them as a child
        const parents = {};
        // Link all subtypes within a given struct
        const subtypes = {};
        Object.keys(types).forEach((type) => {
            links[type] = {};
            parents[type] = [];
            subtypes[type] = {};
        });
        for (const name in types) {
            const uniqueNames = {};
            types[name].forEach((field) => {
                // Check each field has a unique name
                if (uniqueNames[field.name]) {
                    typed_data_logger.throwArgumentError(`duplicate variable name ${JSON.stringify(field.name)} in ${JSON.stringify(name)}`, "types", types);
                }
                uniqueNames[field.name] = true;
                // Get the base type (drop any array specifiers)
                const baseType = field.type.match(/^([^\x5b]*)(\x5b|$)/)[1];
                if (baseType === name) {
                    typed_data_logger.throwArgumentError(`circular type reference to ${JSON.stringify(baseType)}`, "types", types);
                }
                // Is this a base encoding type?
                const encoder = getBaseEncoder(baseType);
                if (encoder) {
                    return;
                }
                if (!parents[baseType]) {
                    typed_data_logger.throwArgumentError(`unknown type ${JSON.stringify(baseType)}`, "types", types);
                }
                // Add linkage
                parents[baseType].push(name);
                links[name][baseType] = true;
            });
        }
        // Deduce the primary type
        const primaryTypes = Object.keys(parents).filter((n) => (parents[n].length === 0));
        if (primaryTypes.length === 0) {
            typed_data_logger.throwArgumentError("missing primary type", "types", types);
        }
        else if (primaryTypes.length > 1) {
            typed_data_logger.throwArgumentError(`ambiguous primary types or unused types: ${primaryTypes.map((t) => (JSON.stringify(t))).join(", ")}`, "types", types);
        }
        lib_esm_defineReadOnly(this, "primaryType", primaryTypes[0]);
        // Check for circular type references
        function checkCircular(type, found) {
            if (found[type]) {
                typed_data_logger.throwArgumentError(`circular type reference to ${JSON.stringify(type)}`, "types", types);
            }
            found[type] = true;
            Object.keys(links[type]).forEach((child) => {
                if (!parents[child]) {
                    return;
                }
                // Recursively check children
                checkCircular(child, found);
                // Mark all ancestors as having this decendant
                Object.keys(found).forEach((subtype) => {
                    subtypes[subtype][child] = true;
                });
            });
            delete found[type];
        }
        checkCircular(this.primaryType, {});
        // Compute each fully describe type
        for (const name in subtypes) {
            const st = Object.keys(subtypes[name]);
            st.sort();
            this._types[name] = encodeType(name, types[name]) + st.map((t) => encodeType(t, types[t])).join("");
        }
    }
    getEncoder(type) {
        let encoder = this._encoderCache[type];
        if (!encoder) {
            encoder = this._encoderCache[type] = this._getEncoder(type);
        }
        return encoder;
    }
    _getEncoder(type) {
        // Basic encoder type (address, bool, uint256, etc)
        {
            const encoder = getBaseEncoder(type);
            if (encoder) {
                return encoder;
            }
        }
        // Array
        const match = type.match(/^(.*)(\x5b(\d*)\x5d)$/);
        if (match) {
            const subtype = match[1];
            const subEncoder = this.getEncoder(subtype);
            const length = parseInt(match[3]);
            return (value) => {
                if (length >= 0 && value.length !== length) {
                    typed_data_logger.throwArgumentError("array length mismatch; expected length ${ arrayLength }", "value", value);
                }
                let result = value.map(subEncoder);
                if (this._types[subtype]) {
                    result = result.map(lib_esm_keccak256);
                }
                return lib_esm_keccak256(hexConcat(result));
            };
        }
        // Struct
        const fields = this.types[type];
        if (fields) {
            const encodedType = id(this._types[type]);
            return (value) => {
                const values = fields.map(({ name, type }) => {
                    const result = this.getEncoder(type)(value[name]);
                    if (this._types[type]) {
                        return lib_esm_keccak256(result);
                    }
                    return result;
                });
                values.unshift(encodedType);
                return hexConcat(values);
            };
        }
        return typed_data_logger.throwArgumentError(`unknown type: ${type}`, "type", type);
    }
    encodeType(name) {
        const result = this._types[name];
        if (!result) {
            typed_data_logger.throwArgumentError(`unknown type: ${JSON.stringify(name)}`, "name", name);
        }
        return result;
    }
    encodeData(type, value) {
        return this.getEncoder(type)(value);
    }
    hashStruct(name, value) {
        return lib_esm_keccak256(this.encodeData(name, value));
    }
    encode(value) {
        return this.encodeData(this.primaryType, value);
    }
    hash(value) {
        return this.hashStruct(this.primaryType, value);
    }
    _visit(type, value, callback) {
        // Basic encoder type (address, bool, uint256, etc)
        {
            const encoder = getBaseEncoder(type);
            if (encoder) {
                return callback(type, value);
            }
        }
        // Array
        const match = type.match(/^(.*)(\x5b(\d*)\x5d)$/);
        if (match) {
            const subtype = match[1];
            const length = parseInt(match[3]);
            if (length >= 0 && value.length !== length) {
                typed_data_logger.throwArgumentError("array length mismatch; expected length ${ arrayLength }", "value", value);
            }
            return value.map((v) => this._visit(subtype, v, callback));
        }
        // Struct
        const fields = this.types[type];
        if (fields) {
            return fields.reduce((accum, { name, type }) => {
                accum[name] = this._visit(type, value[name], callback);
                return accum;
            }, {});
        }
        return typed_data_logger.throwArgumentError(`unknown type: ${type}`, "type", type);
    }
    visit(value, callback) {
        return this._visit(this.primaryType, value, callback);
    }
    static from(types) {
        return new TypedDataEncoder(types);
    }
    static getPrimaryType(types) {
        return TypedDataEncoder.from(types).primaryType;
    }
    static hashStruct(name, types, value) {
        return TypedDataEncoder.from(types).hashStruct(name, value);
    }
    static hashDomain(domain) {
        const domainFields = [];
        for (const name in domain) {
            const type = domainFieldTypes[name];
            if (!type) {
                typed_data_logger.throwArgumentError(`invalid typed-data domain key: ${JSON.stringify(name)}`, "domain", domain);
            }
            domainFields.push({ name, type });
        }
        domainFields.sort((a, b) => {
            return domainFieldNames.indexOf(a.name) - domainFieldNames.indexOf(b.name);
        });
        return TypedDataEncoder.hashStruct("EIP712Domain", { EIP712Domain: domainFields }, domain);
    }
    static encode(domain, types, value) {
        return hexConcat([
            "0x1901",
            TypedDataEncoder.hashDomain(domain),
            TypedDataEncoder.from(types).hash(value)
        ]);
    }
    static hash(domain, types, value) {
        return lib_esm_keccak256(TypedDataEncoder.encode(domain, types, value));
    }
    // Replaces all address types with ENS names with their looked up address
    static resolveNames(domain, types, value, resolveName) {
        return typed_data_awaiter(this, void 0, void 0, function* () {
            // Make a copy to isolate it from the object passed in
            domain = lib_esm_shallowCopy(domain);
            // Look up all ENS names
            const ensCache = {};
            // Do we need to look up the domain's verifyingContract?
            if (domain.verifyingContract && !lib_esm_isHexString(domain.verifyingContract, 20)) {
                ensCache[domain.verifyingContract] = "0x";
            }
            // We are going to use the encoder to visit all the base values
            const encoder = TypedDataEncoder.from(types);
            // Get a list of all the addresses
            encoder.visit(value, (type, value) => {
                if (type === "address" && !lib_esm_isHexString(value, 20)) {
                    ensCache[value] = "0x";
                }
                return value;
            });
            // Lookup each name
            for (const name in ensCache) {
                ensCache[name] = yield resolveName(name);
            }
            // Replace the domain verifyingContract if needed
            if (domain.verifyingContract && ensCache[domain.verifyingContract]) {
                domain.verifyingContract = ensCache[domain.verifyingContract];
            }
            // Replace all ENS names with their address
            value = encoder.visit(value, (type, value) => {
                if (type === "address" && ensCache[value]) {
                    return ensCache[value];
                }
                return value;
            });
            return { domain, value };
        });
    }
    static getPayload(domain, types, value) {
        // Validate the domain fields
        TypedDataEncoder.hashDomain(domain);
        // Derive the EIP712Domain Struct reference type
        const domainValues = {};
        const domainTypes = [];
        domainFieldNames.forEach((name) => {
            const value = domain[name];
            if (value == null) {
                return;
            }
            domainValues[name] = domainChecks[name](value);
            domainTypes.push({ name, type: domainFieldTypes[name] });
        });
        const encoder = TypedDataEncoder.from(types);
        const typesWithDomain = lib_esm_shallowCopy(types);
        if (typesWithDomain.EIP712Domain) {
            typed_data_logger.throwArgumentError("types must not contain EIP712Domain type", "types.EIP712Domain", types);
        }
        else {
            typesWithDomain.EIP712Domain = domainTypes;
        }
        // Validate the data structures and types
        encoder.encode(value);
        return {
            types: typesWithDomain,
            domain: domainValues,
            primaryType: encoder.primaryType,
            message: encoder.visit(value, (type, value) => {
                // bytes
                if (type.match(/^bytes(\d*)/)) {
                    return lib_esm_hexlify(lib_esm_arrayify(value));
                }
                // uint or int
                if (type.match(/^u?int/)) {
                    return bignumber_BigNumber.from(value).toString();
                }
                switch (type) {
                    case "address":
                        return value.toLowerCase();
                    case "bool":
                        return !!value;
                    case "string":
                        if (typeof (value) !== "string") {
                            typed_data_logger.throwArgumentError(`invalid string`, "value", value);
                        }
                        return value;
                }
                return typed_data_logger.throwArgumentError("unsupported type", "type", type);
            })
        };
    }
}
//# sourceMappingURL=typed-data.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+constants@5.7.0/node_modules/@ethersproject/constants/lib.esm/bignumbers.js

const bignumbers_NegativeOne = ( /*#__PURE__*/bignumber_BigNumber.from(-1));
const bignumbers_Zero = ( /*#__PURE__*/bignumber_BigNumber.from(0));
const bignumbers_One = ( /*#__PURE__*/bignumber_BigNumber.from(1));
const Two = ( /*#__PURE__*/(/* unused pure expression or super */ null && (BigNumber.from(2))));
const WeiPerEther = ( /*#__PURE__*/(/* unused pure expression or super */ null && (BigNumber.from("1000000000000000000"))));
const bignumbers_MaxUint256 = ( /*#__PURE__*/bignumber_BigNumber.from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"));
const MinInt256 = ( /*#__PURE__*/(/* unused pure expression or super */ null && (BigNumber.from("-0x8000000000000000000000000000000000000000000000000000000000000000"))));
const MaxInt256 = ( /*#__PURE__*/(/* unused pure expression or super */ null && (BigNumber.from("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"))));

//# sourceMappingURL=bignumbers.js.map
// EXTERNAL MODULE: ./node_modules/.pnpm/hash.js@1.1.7/node_modules/hash.js/lib/hash.js
var lib_hash = __webpack_require__(751);
var hash_default = /*#__PURE__*/__webpack_require__.n(lib_hash);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+signing-key@5.7.0/node_modules/@ethersproject/signing-key/lib.esm/elliptic.js



var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, basedir, module) {
	return module = {
		path: basedir,
		exports: {},
		require: function (path, base) {
			return commonjsRequire(path, (base === undefined || base === null) ? module.path : base);
		}
	}, fn(module, module.exports), module.exports;
}

function getDefaultExportFromNamespaceIfPresent (n) {
	return n && Object.prototype.hasOwnProperty.call(n, 'default') ? n['default'] : n;
}

function getDefaultExportFromNamespaceIfNotNamed (n) {
	return n && Object.prototype.hasOwnProperty.call(n, 'default') && Object.keys(n).length === 1 ? n['default'] : n;
}

function getAugmentedNamespace(n) {
	if (n.__esModule) return n;
	var a = Object.defineProperty({}, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

function commonjsRequire () {
	throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
}

var minimalisticAssert = assert;

function assert(val, msg) {
  if (!val)
    throw new Error(msg || 'Assertion failed');
}

assert.equal = function assertEqual(l, r, msg) {
  if (l != r)
    throw new Error(msg || ('Assertion failed: ' + l + ' != ' + r));
};

var utils_1 = createCommonjsModule(function (module, exports) {
'use strict';

var utils = exports;

function toArray(msg, enc) {
  if (Array.isArray(msg))
    return msg.slice();
  if (!msg)
    return [];
  var res = [];
  if (typeof msg !== 'string') {
    for (var i = 0; i < msg.length; i++)
      res[i] = msg[i] | 0;
    return res;
  }
  if (enc === 'hex') {
    msg = msg.replace(/[^a-z0-9]+/ig, '');
    if (msg.length % 2 !== 0)
      msg = '0' + msg;
    for (var i = 0; i < msg.length; i += 2)
      res.push(parseInt(msg[i] + msg[i + 1], 16));
  } else {
    for (var i = 0; i < msg.length; i++) {
      var c = msg.charCodeAt(i);
      var hi = c >> 8;
      var lo = c & 0xff;
      if (hi)
        res.push(hi, lo);
      else
        res.push(lo);
    }
  }
  return res;
}
utils.toArray = toArray;

function zero2(word) {
  if (word.length === 1)
    return '0' + word;
  else
    return word;
}
utils.zero2 = zero2;

function toHex(msg) {
  var res = '';
  for (var i = 0; i < msg.length; i++)
    res += zero2(msg[i].toString(16));
  return res;
}
utils.toHex = toHex;

utils.encode = function encode(arr, enc) {
  if (enc === 'hex')
    return toHex(arr);
  else
    return arr;
};
});

var utils_1$1 = createCommonjsModule(function (module, exports) {
'use strict';

var utils = exports;




utils.assert = minimalisticAssert;
utils.toArray = utils_1.toArray;
utils.zero2 = utils_1.zero2;
utils.toHex = utils_1.toHex;
utils.encode = utils_1.encode;

// Represent num in a w-NAF form
function getNAF(num, w, bits) {
  var naf = new Array(Math.max(num.bitLength(), bits) + 1);
  naf.fill(0);

  var ws = 1 << (w + 1);
  var k = num.clone();

  for (var i = 0; i < naf.length; i++) {
    var z;
    var mod = k.andln(ws - 1);
    if (k.isOdd()) {
      if (mod > (ws >> 1) - 1)
        z = (ws >> 1) - mod;
      else
        z = mod;
      k.isubn(z);
    } else {
      z = 0;
    }

    naf[i] = z;
    k.iushrn(1);
  }

  return naf;
}
utils.getNAF = getNAF;

// Represent k1, k2 in a Joint Sparse Form
function getJSF(k1, k2) {
  var jsf = [
    [],
    [],
  ];

  k1 = k1.clone();
  k2 = k2.clone();
  var d1 = 0;
  var d2 = 0;
  var m8;
  while (k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0) {
    // First phase
    var m14 = (k1.andln(3) + d1) & 3;
    var m24 = (k2.andln(3) + d2) & 3;
    if (m14 === 3)
      m14 = -1;
    if (m24 === 3)
      m24 = -1;
    var u1;
    if ((m14 & 1) === 0) {
      u1 = 0;
    } else {
      m8 = (k1.andln(7) + d1) & 7;
      if ((m8 === 3 || m8 === 5) && m24 === 2)
        u1 = -m14;
      else
        u1 = m14;
    }
    jsf[0].push(u1);

    var u2;
    if ((m24 & 1) === 0) {
      u2 = 0;
    } else {
      m8 = (k2.andln(7) + d2) & 7;
      if ((m8 === 3 || m8 === 5) && m14 === 2)
        u2 = -m24;
      else
        u2 = m24;
    }
    jsf[1].push(u2);

    // Second phase
    if (2 * d1 === u1 + 1)
      d1 = 1 - d1;
    if (2 * d2 === u2 + 1)
      d2 = 1 - d2;
    k1.iushrn(1);
    k2.iushrn(1);
  }

  return jsf;
}
utils.getJSF = getJSF;

function cachedProperty(obj, name, computer) {
  var key = '_' + name;
  obj.prototype[name] = function cachedProperty() {
    return this[key] !== undefined ? this[key] :
      this[key] = computer.call(this);
  };
}
utils.cachedProperty = cachedProperty;

function parseBytes(bytes) {
  return typeof bytes === 'string' ? utils.toArray(bytes, 'hex') :
    bytes;
}
utils.parseBytes = parseBytes;

function intFromLE(bytes) {
  return new (bn_default())(bytes, 'hex', 'le');
}
utils.intFromLE = intFromLE;
});

'use strict';



var getNAF = utils_1$1.getNAF;
var getJSF = utils_1$1.getJSF;
var assert$1 = utils_1$1.assert;

function BaseCurve(type, conf) {
  this.type = type;
  this.p = new (bn_default())(conf.p, 16);

  // Use Montgomery, when there is no fast reduction for the prime
  this.red = conf.prime ? bn_default().red(conf.prime) : bn_default().mont(this.p);

  // Useful for many curves
  this.zero = new (bn_default())(0).toRed(this.red);
  this.one = new (bn_default())(1).toRed(this.red);
  this.two = new (bn_default())(2).toRed(this.red);

  // Curve configuration, optional
  this.n = conf.n && new (bn_default())(conf.n, 16);
  this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);

  // Temporary arrays
  this._wnafT1 = new Array(4);
  this._wnafT2 = new Array(4);
  this._wnafT3 = new Array(4);
  this._wnafT4 = new Array(4);

  this._bitLength = this.n ? this.n.bitLength() : 0;

  // Generalized Greg Maxwell's trick
  var adjustCount = this.n && this.p.div(this.n);
  if (!adjustCount || adjustCount.cmpn(100) > 0) {
    this.redN = null;
  } else {
    this._maxwellTrick = true;
    this.redN = this.n.toRed(this.red);
  }
}
var base = BaseCurve;

BaseCurve.prototype.point = function point() {
  throw new Error('Not implemented');
};

BaseCurve.prototype.validate = function validate() {
  throw new Error('Not implemented');
};

BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
  assert$1(p.precomputed);
  var doubles = p._getDoubles();

  var naf = getNAF(k, 1, this._bitLength);
  var I = (1 << (doubles.step + 1)) - (doubles.step % 2 === 0 ? 2 : 1);
  I /= 3;

  // Translate into more windowed form
  var repr = [];
  var j;
  var nafW;
  for (j = 0; j < naf.length; j += doubles.step) {
    nafW = 0;
    for (var l = j + doubles.step - 1; l >= j; l--)
      nafW = (nafW << 1) + naf[l];
    repr.push(nafW);
  }

  var a = this.jpoint(null, null, null);
  var b = this.jpoint(null, null, null);
  for (var i = I; i > 0; i--) {
    for (j = 0; j < repr.length; j++) {
      nafW = repr[j];
      if (nafW === i)
        b = b.mixedAdd(doubles.points[j]);
      else if (nafW === -i)
        b = b.mixedAdd(doubles.points[j].neg());
    }
    a = a.add(b);
  }
  return a.toP();
};

BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
  var w = 4;

  // Precompute window
  var nafPoints = p._getNAFPoints(w);
  w = nafPoints.wnd;
  var wnd = nafPoints.points;

  // Get NAF form
  var naf = getNAF(k, w, this._bitLength);

  // Add `this`*(N+1) for every w-NAF index
  var acc = this.jpoint(null, null, null);
  for (var i = naf.length - 1; i >= 0; i--) {
    // Count zeroes
    for (var l = 0; i >= 0 && naf[i] === 0; i--)
      l++;
    if (i >= 0)
      l++;
    acc = acc.dblp(l);

    if (i < 0)
      break;
    var z = naf[i];
    assert$1(z !== 0);
    if (p.type === 'affine') {
      // J +- P
      if (z > 0)
        acc = acc.mixedAdd(wnd[(z - 1) >> 1]);
      else
        acc = acc.mixedAdd(wnd[(-z - 1) >> 1].neg());
    } else {
      // J +- J
      if (z > 0)
        acc = acc.add(wnd[(z - 1) >> 1]);
      else
        acc = acc.add(wnd[(-z - 1) >> 1].neg());
    }
  }
  return p.type === 'affine' ? acc.toP() : acc;
};

BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW,
  points,
  coeffs,
  len,
  jacobianResult) {
  var wndWidth = this._wnafT1;
  var wnd = this._wnafT2;
  var naf = this._wnafT3;

  // Fill all arrays
  var max = 0;
  var i;
  var j;
  var p;
  for (i = 0; i < len; i++) {
    p = points[i];
    var nafPoints = p._getNAFPoints(defW);
    wndWidth[i] = nafPoints.wnd;
    wnd[i] = nafPoints.points;
  }

  // Comb small window NAFs
  for (i = len - 1; i >= 1; i -= 2) {
    var a = i - 1;
    var b = i;
    if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
      naf[a] = getNAF(coeffs[a], wndWidth[a], this._bitLength);
      naf[b] = getNAF(coeffs[b], wndWidth[b], this._bitLength);
      max = Math.max(naf[a].length, max);
      max = Math.max(naf[b].length, max);
      continue;
    }

    var comb = [
      points[a], /* 1 */
      null, /* 3 */
      null, /* 5 */
      points[b], /* 7 */
    ];

    // Try to avoid Projective points, if possible
    if (points[a].y.cmp(points[b].y) === 0) {
      comb[1] = points[a].add(points[b]);
      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
    } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
      comb[1] = points[a].toJ().mixedAdd(points[b]);
      comb[2] = points[a].add(points[b].neg());
    } else {
      comb[1] = points[a].toJ().mixedAdd(points[b]);
      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
    }

    var index = [
      -3, /* -1 -1 */
      -1, /* -1 0 */
      -5, /* -1 1 */
      -7, /* 0 -1 */
      0, /* 0 0 */
      7, /* 0 1 */
      5, /* 1 -1 */
      1, /* 1 0 */
      3,  /* 1 1 */
    ];

    var jsf = getJSF(coeffs[a], coeffs[b]);
    max = Math.max(jsf[0].length, max);
    naf[a] = new Array(max);
    naf[b] = new Array(max);
    for (j = 0; j < max; j++) {
      var ja = jsf[0][j] | 0;
      var jb = jsf[1][j] | 0;

      naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
      naf[b][j] = 0;
      wnd[a] = comb;
    }
  }

  var acc = this.jpoint(null, null, null);
  var tmp = this._wnafT4;
  for (i = max; i >= 0; i--) {
    var k = 0;

    while (i >= 0) {
      var zero = true;
      for (j = 0; j < len; j++) {
        tmp[j] = naf[j][i] | 0;
        if (tmp[j] !== 0)
          zero = false;
      }
      if (!zero)
        break;
      k++;
      i--;
    }
    if (i >= 0)
      k++;
    acc = acc.dblp(k);
    if (i < 0)
      break;

    for (j = 0; j < len; j++) {
      var z = tmp[j];
      p;
      if (z === 0)
        continue;
      else if (z > 0)
        p = wnd[j][(z - 1) >> 1];
      else if (z < 0)
        p = wnd[j][(-z - 1) >> 1].neg();

      if (p.type === 'affine')
        acc = acc.mixedAdd(p);
      else
        acc = acc.add(p);
    }
  }
  // Zeroify references
  for (i = 0; i < len; i++)
    wnd[i] = null;

  if (jacobianResult)
    return acc;
  else
    return acc.toP();
};

function BasePoint(curve, type) {
  this.curve = curve;
  this.type = type;
  this.precomputed = null;
}
BaseCurve.BasePoint = BasePoint;

BasePoint.prototype.eq = function eq(/*other*/) {
  throw new Error('Not implemented');
};

BasePoint.prototype.validate = function validate() {
  return this.curve.validate(this);
};

BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
  bytes = utils_1$1.toArray(bytes, enc);

  var len = this.p.byteLength();

  // uncompressed, hybrid-odd, hybrid-even
  if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) &&
      bytes.length - 1 === 2 * len) {
    if (bytes[0] === 0x06)
      assert$1(bytes[bytes.length - 1] % 2 === 0);
    else if (bytes[0] === 0x07)
      assert$1(bytes[bytes.length - 1] % 2 === 1);

    var res =  this.point(bytes.slice(1, 1 + len),
      bytes.slice(1 + len, 1 + 2 * len));

    return res;
  } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) &&
              bytes.length - 1 === len) {
    return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
  }
  throw new Error('Unknown point format');
};

BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
  return this.encode(enc, true);
};

BasePoint.prototype._encode = function _encode(compact) {
  var len = this.curve.p.byteLength();
  var x = this.getX().toArray('be', len);

  if (compact)
    return [ this.getY().isEven() ? 0x02 : 0x03 ].concat(x);

  return [ 0x04 ].concat(x, this.getY().toArray('be', len));
};

BasePoint.prototype.encode = function encode(enc, compact) {
  return utils_1$1.encode(this._encode(compact), enc);
};

BasePoint.prototype.precompute = function precompute(power) {
  if (this.precomputed)
    return this;

  var precomputed = {
    doubles: null,
    naf: null,
    beta: null,
  };
  precomputed.naf = this._getNAFPoints(8);
  precomputed.doubles = this._getDoubles(4, power);
  precomputed.beta = this._getBeta();
  this.precomputed = precomputed;

  return this;
};

BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
  if (!this.precomputed)
    return false;

  var doubles = this.precomputed.doubles;
  if (!doubles)
    return false;

  return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};

BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
  if (this.precomputed && this.precomputed.doubles)
    return this.precomputed.doubles;

  var doubles = [ this ];
  var acc = this;
  for (var i = 0; i < power; i += step) {
    for (var j = 0; j < step; j++)
      acc = acc.dbl();
    doubles.push(acc);
  }
  return {
    step: step,
    points: doubles,
  };
};

BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
  if (this.precomputed && this.precomputed.naf)
    return this.precomputed.naf;

  var res = [ this ];
  var max = (1 << wnd) - 1;
  var dbl = max === 1 ? null : this.dbl();
  for (var i = 1; i < max; i++)
    res[i] = res[i - 1].add(dbl);
  return {
    wnd: wnd,
    points: res,
  };
};

BasePoint.prototype._getBeta = function _getBeta() {
  return null;
};

BasePoint.prototype.dblp = function dblp(k) {
  var r = this;
  for (var i = 0; i < k; i++)
    r = r.dbl();
  return r;
};

var inherits_browser = createCommonjsModule(function (module) {
if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor;
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
    }
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor;
      var TempCtor = function () {};
      TempCtor.prototype = superCtor.prototype;
      ctor.prototype = new TempCtor();
      ctor.prototype.constructor = ctor;
    }
  };
}
});

'use strict';






var assert$2 = utils_1$1.assert;

function ShortCurve(conf) {
  base.call(this, 'short', conf);

  this.a = new (bn_default())(conf.a, 16).toRed(this.red);
  this.b = new (bn_default())(conf.b, 16).toRed(this.red);
  this.tinv = this.two.redInvm();

  this.zeroA = this.a.fromRed().cmpn(0) === 0;
  this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;

  // If the curve is endomorphic, precalculate beta and lambda
  this.endo = this._getEndomorphism(conf);
  this._endoWnafT1 = new Array(4);
  this._endoWnafT2 = new Array(4);
}
inherits_browser(ShortCurve, base);
var short_1 = ShortCurve;

ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
  // No efficient endomorphism
  if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)
    return;

  // Compute beta and lambda, that lambda * P = (beta * Px; Py)
  var beta;
  var lambda;
  if (conf.beta) {
    beta = new (bn_default())(conf.beta, 16).toRed(this.red);
  } else {
    var betas = this._getEndoRoots(this.p);
    // Choose the smallest beta
    beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
    beta = beta.toRed(this.red);
  }
  if (conf.lambda) {
    lambda = new (bn_default())(conf.lambda, 16);
  } else {
    // Choose the lambda that is matching selected beta
    var lambdas = this._getEndoRoots(this.n);
    if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) {
      lambda = lambdas[0];
    } else {
      lambda = lambdas[1];
      assert$2(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
    }
  }

  // Get basis vectors, used for balanced length-two representation
  var basis;
  if (conf.basis) {
    basis = conf.basis.map(function(vec) {
      return {
        a: new (bn_default())(vec.a, 16),
        b: new (bn_default())(vec.b, 16),
      };
    });
  } else {
    basis = this._getEndoBasis(lambda);
  }

  return {
    beta: beta,
    lambda: lambda,
    basis: basis,
  };
};

ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
  // Find roots of for x^2 + x + 1 in F
  // Root = (-1 +- Sqrt(-3)) / 2
  //
  var red = num === this.p ? this.red : bn_default().mont(num);
  var tinv = new (bn_default())(2).toRed(red).redInvm();
  var ntinv = tinv.redNeg();

  var s = new (bn_default())(3).toRed(red).redNeg().redSqrt().redMul(tinv);

  var l1 = ntinv.redAdd(s).fromRed();
  var l2 = ntinv.redSub(s).fromRed();
  return [ l1, l2 ];
};

ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
  // aprxSqrt >= sqrt(this.n)
  var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));

  // 3.74
  // Run EGCD, until r(L + 1) < aprxSqrt
  var u = lambda;
  var v = this.n.clone();
  var x1 = new (bn_default())(1);
  var y1 = new (bn_default())(0);
  var x2 = new (bn_default())(0);
  var y2 = new (bn_default())(1);

  // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
  var a0;
  var b0;
  // First vector
  var a1;
  var b1;
  // Second vector
  var a2;
  var b2;

  var prevR;
  var i = 0;
  var r;
  var x;
  while (u.cmpn(0) !== 0) {
    var q = v.div(u);
    r = v.sub(q.mul(u));
    x = x2.sub(q.mul(x1));
    var y = y2.sub(q.mul(y1));

    if (!a1 && r.cmp(aprxSqrt) < 0) {
      a0 = prevR.neg();
      b0 = x1;
      a1 = r.neg();
      b1 = x;
    } else if (a1 && ++i === 2) {
      break;
    }
    prevR = r;

    v = u;
    u = r;
    x2 = x1;
    x1 = x;
    y2 = y1;
    y1 = y;
  }
  a2 = r.neg();
  b2 = x;

  var len1 = a1.sqr().add(b1.sqr());
  var len2 = a2.sqr().add(b2.sqr());
  if (len2.cmp(len1) >= 0) {
    a2 = a0;
    b2 = b0;
  }

  // Normalize signs
  if (a1.negative) {
    a1 = a1.neg();
    b1 = b1.neg();
  }
  if (a2.negative) {
    a2 = a2.neg();
    b2 = b2.neg();
  }

  return [
    { a: a1, b: b1 },
    { a: a2, b: b2 },
  ];
};

ShortCurve.prototype._endoSplit = function _endoSplit(k) {
  var basis = this.endo.basis;
  var v1 = basis[0];
  var v2 = basis[1];

  var c1 = v2.b.mul(k).divRound(this.n);
  var c2 = v1.b.neg().mul(k).divRound(this.n);

  var p1 = c1.mul(v1.a);
  var p2 = c2.mul(v2.a);
  var q1 = c1.mul(v1.b);
  var q2 = c2.mul(v2.b);

  // Calculate answer
  var k1 = k.sub(p1).sub(p2);
  var k2 = q1.add(q2).neg();
  return { k1: k1, k2: k2 };
};

ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
  x = new (bn_default())(x, 16);
  if (!x.red)
    x = x.toRed(this.red);

  var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
  var y = y2.redSqrt();
  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  // XXX Is there any way to tell if the number is odd without converting it
  // to non-red form?
  var isOdd = y.fromRed().isOdd();
  if (odd && !isOdd || !odd && isOdd)
    y = y.redNeg();

  return this.point(x, y);
};

ShortCurve.prototype.validate = function validate(point) {
  if (point.inf)
    return true;

  var x = point.x;
  var y = point.y;

  var ax = this.a.redMul(x);
  var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
  return y.redSqr().redISub(rhs).cmpn(0) === 0;
};

ShortCurve.prototype._endoWnafMulAdd =
    function _endoWnafMulAdd(points, coeffs, jacobianResult) {
      var npoints = this._endoWnafT1;
      var ncoeffs = this._endoWnafT2;
      for (var i = 0; i < points.length; i++) {
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();

        if (split.k1.negative) {
          split.k1.ineg();
          p = p.neg(true);
        }
        if (split.k2.negative) {
          split.k2.ineg();
          beta = beta.neg(true);
        }

        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
      }
      var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);

      // Clean-up references to points and coefficients
      for (var j = 0; j < i * 2; j++) {
        npoints[j] = null;
        ncoeffs[j] = null;
      }
      return res;
    };

function Point(curve, x, y, isRed) {
  base.BasePoint.call(this, curve, 'affine');
  if (x === null && y === null) {
    this.x = null;
    this.y = null;
    this.inf = true;
  } else {
    this.x = new (bn_default())(x, 16);
    this.y = new (bn_default())(y, 16);
    // Force redgomery representation when loading from JSON
    if (isRed) {
      this.x.forceRed(this.curve.red);
      this.y.forceRed(this.curve.red);
    }
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.y.red)
      this.y = this.y.toRed(this.curve.red);
    this.inf = false;
  }
}
inherits_browser(Point, base.BasePoint);

ShortCurve.prototype.point = function point(x, y, isRed) {
  return new Point(this, x, y, isRed);
};

ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
  return Point.fromJSON(this, obj, red);
};

Point.prototype._getBeta = function _getBeta() {
  if (!this.curve.endo)
    return;

  var pre = this.precomputed;
  if (pre && pre.beta)
    return pre.beta;

  var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
  if (pre) {
    var curve = this.curve;
    var endoMul = function(p) {
      return curve.point(p.x.redMul(curve.endo.beta), p.y);
    };
    pre.beta = beta;
    beta.precomputed = {
      beta: null,
      naf: pre.naf && {
        wnd: pre.naf.wnd,
        points: pre.naf.points.map(endoMul),
      },
      doubles: pre.doubles && {
        step: pre.doubles.step,
        points: pre.doubles.points.map(endoMul),
      },
    };
  }
  return beta;
};

Point.prototype.toJSON = function toJSON() {
  if (!this.precomputed)
    return [ this.x, this.y ];

  return [ this.x, this.y, this.precomputed && {
    doubles: this.precomputed.doubles && {
      step: this.precomputed.doubles.step,
      points: this.precomputed.doubles.points.slice(1),
    },
    naf: this.precomputed.naf && {
      wnd: this.precomputed.naf.wnd,
      points: this.precomputed.naf.points.slice(1),
    },
  } ];
};

Point.fromJSON = function fromJSON(curve, obj, red) {
  if (typeof obj === 'string')
    obj = JSON.parse(obj);
  var res = curve.point(obj[0], obj[1], red);
  if (!obj[2])
    return res;

  function obj2point(obj) {
    return curve.point(obj[0], obj[1], red);
  }

  var pre = obj[2];
  res.precomputed = {
    beta: null,
    doubles: pre.doubles && {
      step: pre.doubles.step,
      points: [ res ].concat(pre.doubles.points.map(obj2point)),
    },
    naf: pre.naf && {
      wnd: pre.naf.wnd,
      points: [ res ].concat(pre.naf.points.map(obj2point)),
    },
  };
  return res;
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' y: ' + this.y.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  return this.inf;
};

Point.prototype.add = function add(p) {
  // O + P = P
  if (this.inf)
    return p;

  // P + O = P
  if (p.inf)
    return this;

  // P + P = 2P
  if (this.eq(p))
    return this.dbl();

  // P + (-P) = O
  if (this.neg().eq(p))
    return this.curve.point(null, null);

  // P + Q = O
  if (this.x.cmp(p.x) === 0)
    return this.curve.point(null, null);

  var c = this.y.redSub(p.y);
  if (c.cmpn(0) !== 0)
    c = c.redMul(this.x.redSub(p.x).redInvm());
  var nx = c.redSqr().redISub(this.x).redISub(p.x);
  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
  return this.curve.point(nx, ny);
};

Point.prototype.dbl = function dbl() {
  if (this.inf)
    return this;

  // 2P = O
  var ys1 = this.y.redAdd(this.y);
  if (ys1.cmpn(0) === 0)
    return this.curve.point(null, null);

  var a = this.curve.a;

  var x2 = this.x.redSqr();
  var dyinv = ys1.redInvm();
  var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);

  var nx = c.redSqr().redISub(this.x.redAdd(this.x));
  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
  return this.curve.point(nx, ny);
};

Point.prototype.getX = function getX() {
  return this.x.fromRed();
};

Point.prototype.getY = function getY() {
  return this.y.fromRed();
};

Point.prototype.mul = function mul(k) {
  k = new (bn_default())(k, 16);
  if (this.isInfinity())
    return this;
  else if (this._hasDoubles(k))
    return this.curve._fixedNafMul(this, k);
  else if (this.curve.endo)
    return this.curve._endoWnafMulAdd([ this ], [ k ]);
  else
    return this.curve._wnafMul(this, k);
};

Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
  var points = [ this, p2 ];
  var coeffs = [ k1, k2 ];
  if (this.curve.endo)
    return this.curve._endoWnafMulAdd(points, coeffs);
  else
    return this.curve._wnafMulAdd(1, points, coeffs, 2);
};

Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
  var points = [ this, p2 ];
  var coeffs = [ k1, k2 ];
  if (this.curve.endo)
    return this.curve._endoWnafMulAdd(points, coeffs, true);
  else
    return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};

Point.prototype.eq = function eq(p) {
  return this === p ||
         this.inf === p.inf &&
             (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};

Point.prototype.neg = function neg(_precompute) {
  if (this.inf)
    return this;

  var res = this.curve.point(this.x, this.y.redNeg());
  if (_precompute && this.precomputed) {
    var pre = this.precomputed;
    var negate = function(p) {
      return p.neg();
    };
    res.precomputed = {
      naf: pre.naf && {
        wnd: pre.naf.wnd,
        points: pre.naf.points.map(negate),
      },
      doubles: pre.doubles && {
        step: pre.doubles.step,
        points: pre.doubles.points.map(negate),
      },
    };
  }
  return res;
};

Point.prototype.toJ = function toJ() {
  if (this.inf)
    return this.curve.jpoint(null, null, null);

  var res = this.curve.jpoint(this.x, this.y, this.curve.one);
  return res;
};

function JPoint(curve, x, y, z) {
  base.BasePoint.call(this, curve, 'jacobian');
  if (x === null && y === null && z === null) {
    this.x = this.curve.one;
    this.y = this.curve.one;
    this.z = new (bn_default())(0);
  } else {
    this.x = new (bn_default())(x, 16);
    this.y = new (bn_default())(y, 16);
    this.z = new (bn_default())(z, 16);
  }
  if (!this.x.red)
    this.x = this.x.toRed(this.curve.red);
  if (!this.y.red)
    this.y = this.y.toRed(this.curve.red);
  if (!this.z.red)
    this.z = this.z.toRed(this.curve.red);

  this.zOne = this.z === this.curve.one;
}
inherits_browser(JPoint, base.BasePoint);

ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
  return new JPoint(this, x, y, z);
};

JPoint.prototype.toP = function toP() {
  if (this.isInfinity())
    return this.curve.point(null, null);

  var zinv = this.z.redInvm();
  var zinv2 = zinv.redSqr();
  var ax = this.x.redMul(zinv2);
  var ay = this.y.redMul(zinv2).redMul(zinv);

  return this.curve.point(ax, ay);
};

JPoint.prototype.neg = function neg() {
  return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};

JPoint.prototype.add = function add(p) {
  // O + P = P
  if (this.isInfinity())
    return p;

  // P + O = P
  if (p.isInfinity())
    return this;

  // 12M + 4S + 7A
  var pz2 = p.z.redSqr();
  var z2 = this.z.redSqr();
  var u1 = this.x.redMul(pz2);
  var u2 = p.x.redMul(z2);
  var s1 = this.y.redMul(pz2.redMul(p.z));
  var s2 = p.y.redMul(z2.redMul(this.z));

  var h = u1.redSub(u2);
  var r = s1.redSub(s2);
  if (h.cmpn(0) === 0) {
    if (r.cmpn(0) !== 0)
      return this.curve.jpoint(null, null, null);
    else
      return this.dbl();
  }

  var h2 = h.redSqr();
  var h3 = h2.redMul(h);
  var v = u1.redMul(h2);

  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
  var nz = this.z.redMul(p.z).redMul(h);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.mixedAdd = function mixedAdd(p) {
  // O + P = P
  if (this.isInfinity())
    return p.toJ();

  // P + O = P
  if (p.isInfinity())
    return this;

  // 8M + 3S + 7A
  var z2 = this.z.redSqr();
  var u1 = this.x;
  var u2 = p.x.redMul(z2);
  var s1 = this.y;
  var s2 = p.y.redMul(z2).redMul(this.z);

  var h = u1.redSub(u2);
  var r = s1.redSub(s2);
  if (h.cmpn(0) === 0) {
    if (r.cmpn(0) !== 0)
      return this.curve.jpoint(null, null, null);
    else
      return this.dbl();
  }

  var h2 = h.redSqr();
  var h3 = h2.redMul(h);
  var v = u1.redMul(h2);

  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
  var nz = this.z.redMul(h);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.dblp = function dblp(pow) {
  if (pow === 0)
    return this;
  if (this.isInfinity())
    return this;
  if (!pow)
    return this.dbl();

  var i;
  if (this.curve.zeroA || this.curve.threeA) {
    var r = this;
    for (i = 0; i < pow; i++)
      r = r.dbl();
    return r;
  }

  // 1M + 2S + 1A + N * (4S + 5M + 8A)
  // N = 1 => 6M + 6S + 9A
  var a = this.curve.a;
  var tinv = this.curve.tinv;

  var jx = this.x;
  var jy = this.y;
  var jz = this.z;
  var jz4 = jz.redSqr().redSqr();

  // Reuse results
  var jyd = jy.redAdd(jy);
  for (i = 0; i < pow; i++) {
    var jx2 = jx.redSqr();
    var jyd2 = jyd.redSqr();
    var jyd4 = jyd2.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

    var t1 = jx.redMul(jyd2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var dny = c.redMul(t2);
    dny = dny.redIAdd(dny).redISub(jyd4);
    var nz = jyd.redMul(jz);
    if (i + 1 < pow)
      jz4 = jz4.redMul(jyd4);

    jx = nx;
    jz = nz;
    jyd = dny;
  }

  return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};

JPoint.prototype.dbl = function dbl() {
  if (this.isInfinity())
    return this;

  if (this.curve.zeroA)
    return this._zeroDbl();
  else if (this.curve.threeA)
    return this._threeDbl();
  else
    return this._dbl();
};

JPoint.prototype._zeroDbl = function _zeroDbl() {
  var nx;
  var ny;
  var nz;
  // Z = 1
  if (this.zOne) {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
    //     #doubling-mdbl-2007-bl
    // 1M + 5S + 14A

    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    s = s.redIAdd(s);
    // M = 3 * XX + a; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // T = M ^ 2 - 2*S
    var t = m.redSqr().redISub(s).redISub(s);

    // 8 * YYYY
    var yyyy8 = yyyy.redIAdd(yyyy);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    yyyy8 = yyyy8.redIAdd(yyyy8);

    // X3 = T
    nx = t;
    // Y3 = M * (S - T) - 8 * YYYY
    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
    // Z3 = 2*Y1
    nz = this.y.redAdd(this.y);
  } else {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
    //     #doubling-dbl-2009-l
    // 2M + 5S + 13A

    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = B^2
    var c = b.redSqr();
    // D = 2 * ((X1 + B)^2 - A - C)
    var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
    d = d.redIAdd(d);
    // E = 3 * A
    var e = a.redAdd(a).redIAdd(a);
    // F = E^2
    var f = e.redSqr();

    // 8 * C
    var c8 = c.redIAdd(c);
    c8 = c8.redIAdd(c8);
    c8 = c8.redIAdd(c8);

    // X3 = F - 2 * D
    nx = f.redISub(d).redISub(d);
    // Y3 = E * (D - X3) - 8 * C
    ny = e.redMul(d.redISub(nx)).redISub(c8);
    // Z3 = 2 * Y1 * Z1
    nz = this.y.redMul(this.z);
    nz = nz.redIAdd(nz);
  }

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype._threeDbl = function _threeDbl() {
  var nx;
  var ny;
  var nz;
  // Z = 1
  if (this.zOne) {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
    //     #doubling-mdbl-2007-bl
    // 1M + 5S + 15A

    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    s = s.redIAdd(s);
    // M = 3 * XX + a
    var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
    // T = M^2 - 2 * S
    var t = m.redSqr().redISub(s).redISub(s);
    // X3 = T
    nx = t;
    // Y3 = M * (S - T) - 8 * YYYY
    var yyyy8 = yyyy.redIAdd(yyyy);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
    // Z3 = 2 * Y1
    nz = this.y.redAdd(this.y);
  } else {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
    // 3M + 5S

    // delta = Z1^2
    var delta = this.z.redSqr();
    // gamma = Y1^2
    var gamma = this.y.redSqr();
    // beta = X1 * gamma
    var beta = this.x.redMul(gamma);
    // alpha = 3 * (X1 - delta) * (X1 + delta)
    var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
    alpha = alpha.redAdd(alpha).redIAdd(alpha);
    // X3 = alpha^2 - 8 * beta
    var beta4 = beta.redIAdd(beta);
    beta4 = beta4.redIAdd(beta4);
    var beta8 = beta4.redAdd(beta4);
    nx = alpha.redSqr().redISub(beta8);
    // Z3 = (Y1 + Z1)^2 - gamma - delta
    nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
    // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
    var ggamma8 = gamma.redSqr();
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
  }

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype._dbl = function _dbl() {
  var a = this.curve.a;

  // 4M + 6S + 10A
  var jx = this.x;
  var jy = this.y;
  var jz = this.z;
  var jz4 = jz.redSqr().redSqr();

  var jx2 = jx.redSqr();
  var jy2 = jy.redSqr();

  var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

  var jxd4 = jx.redAdd(jx);
  jxd4 = jxd4.redIAdd(jxd4);
  var t1 = jxd4.redMul(jy2);
  var nx = c.redSqr().redISub(t1.redAdd(t1));
  var t2 = t1.redISub(nx);

  var jyd8 = jy2.redSqr();
  jyd8 = jyd8.redIAdd(jyd8);
  jyd8 = jyd8.redIAdd(jyd8);
  jyd8 = jyd8.redIAdd(jyd8);
  var ny = c.redMul(t2).redISub(jyd8);
  var nz = jy.redAdd(jy).redMul(jz);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.trpl = function trpl() {
  if (!this.curve.zeroA)
    return this.dbl().add(this);

  // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
  // 5M + 10S + ...

  // XX = X1^2
  var xx = this.x.redSqr();
  // YY = Y1^2
  var yy = this.y.redSqr();
  // ZZ = Z1^2
  var zz = this.z.redSqr();
  // YYYY = YY^2
  var yyyy = yy.redSqr();
  // M = 3 * XX + a * ZZ2; a = 0
  var m = xx.redAdd(xx).redIAdd(xx);
  // MM = M^2
  var mm = m.redSqr();
  // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
  var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
  e = e.redIAdd(e);
  e = e.redAdd(e).redIAdd(e);
  e = e.redISub(mm);
  // EE = E^2
  var ee = e.redSqr();
  // T = 16*YYYY
  var t = yyyy.redIAdd(yyyy);
  t = t.redIAdd(t);
  t = t.redIAdd(t);
  t = t.redIAdd(t);
  // U = (M + E)^2 - MM - EE - T
  var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
  // X3 = 4 * (X1 * EE - 4 * YY * U)
  var yyu4 = yy.redMul(u);
  yyu4 = yyu4.redIAdd(yyu4);
  yyu4 = yyu4.redIAdd(yyu4);
  var nx = this.x.redMul(ee).redISub(yyu4);
  nx = nx.redIAdd(nx);
  nx = nx.redIAdd(nx);
  // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
  var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
  ny = ny.redIAdd(ny);
  ny = ny.redIAdd(ny);
  ny = ny.redIAdd(ny);
  // Z3 = (Z1 + E)^2 - ZZ - EE
  var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.mul = function mul(k, kbase) {
  k = new (bn_default())(k, kbase);

  return this.curve._wnafMul(this, k);
};

JPoint.prototype.eq = function eq(p) {
  if (p.type === 'affine')
    return this.eq(p.toJ());

  if (this === p)
    return true;

  // x1 * z2^2 == x2 * z1^2
  var z2 = this.z.redSqr();
  var pz2 = p.z.redSqr();
  if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0)
    return false;

  // y1 * z2^3 == y2 * z1^3
  var z3 = z2.redMul(this.z);
  var pz3 = pz2.redMul(p.z);
  return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};

JPoint.prototype.eqXToP = function eqXToP(x) {
  var zs = this.z.redSqr();
  var rx = x.toRed(this.curve.red).redMul(zs);
  if (this.x.cmp(rx) === 0)
    return true;

  var xc = x.clone();
  var t = this.curve.redN.redMul(zs);
  for (;;) {
    xc.iadd(this.curve.n);
    if (xc.cmp(this.curve.p) >= 0)
      return false;

    rx.redIAdd(t);
    if (this.x.cmp(rx) === 0)
      return true;
  }
};

JPoint.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC JPoint Infinity>';
  return '<EC JPoint x: ' + this.x.toString(16, 2) +
      ' y: ' + this.y.toString(16, 2) +
      ' z: ' + this.z.toString(16, 2) + '>';
};

JPoint.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.z.cmpn(0) === 0;
};

var curve_1 = createCommonjsModule(function (module, exports) {
'use strict';

var curve = exports;

curve.base = base;
curve.short = short_1;
curve.mont = /*RicMoo:ethers:require(./mont)*/(null);
curve.edwards = /*RicMoo:ethers:require(./edwards)*/(null);
});

var curves_1 = createCommonjsModule(function (module, exports) {
'use strict';

var curves = exports;





var assert = utils_1$1.assert;

function PresetCurve(options) {
  if (options.type === 'short')
    this.curve = new curve_1.short(options);
  else if (options.type === 'edwards')
    this.curve = new curve_1.edwards(options);
  else
    this.curve = new curve_1.mont(options);
  this.g = this.curve.g;
  this.n = this.curve.n;
  this.hash = options.hash;

  assert(this.g.validate(), 'Invalid curve');
  assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
}
curves.PresetCurve = PresetCurve;

function defineCurve(name, options) {
  Object.defineProperty(curves, name, {
    configurable: true,
    enumerable: true,
    get: function() {
      var curve = new PresetCurve(options);
      Object.defineProperty(curves, name, {
        configurable: true,
        enumerable: true,
        value: curve,
      });
      return curve;
    },
  });
}

defineCurve('p192', {
  type: 'short',
  prime: 'p192',
  p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
  b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
  n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
  hash: (hash_default()).sha256,
  gRed: false,
  g: [
    '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
    '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811',
  ],
});

defineCurve('p224', {
  type: 'short',
  prime: 'p224',
  p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
  b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
  n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
  hash: (hash_default()).sha256,
  gRed: false,
  g: [
    'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
    'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34',
  ],
});

defineCurve('p256', {
  type: 'short',
  prime: null,
  p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
  a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
  b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
  n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
  hash: (hash_default()).sha256,
  gRed: false,
  g: [
    '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
    '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5',
  ],
});

defineCurve('p384', {
  type: 'short',
  prime: null,
  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'fffffffe ffffffff 00000000 00000000 ffffffff',
  a: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'fffffffe ffffffff 00000000 00000000 fffffffc',
  b: 'b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f ' +
     '5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef',
  n: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 ' +
     'f4372ddf 581a0db2 48b0a77a ecec196a ccc52973',
  hash: (hash_default()).sha384,
  gRed: false,
  g: [
    'aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 ' +
    '5502f25d bf55296c 3a545e38 72760ab7',
    '3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 ' +
    '0a60b1ce 1d7e819d 7a431d7c 90ea0e5f',
  ],
});

defineCurve('p521', {
  type: 'short',
  prime: null,
  p: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff',
  a: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff fffffffc',
  b: '00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b ' +
     '99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd ' +
     '3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00',
  n: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 ' +
     'f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409',
  hash: (hash_default()).sha512,
  gRed: false,
  g: [
    '000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 ' +
    '053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 ' +
    'a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66',
    '00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 ' +
    '579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 ' +
    '3fad0761 353c7086 a272c240 88be9476 9fd16650',
  ],
});

defineCurve('curve25519', {
  type: 'mont',
  prime: 'p25519',
  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
  a: '76d06',
  b: '1',
  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
  hash: (hash_default()).sha256,
  gRed: false,
  g: [
    '9',
  ],
});

defineCurve('ed25519', {
  type: 'edwards',
  prime: 'p25519',
  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
  a: '-1',
  c: '1',
  // -121665 * (121666^(-1)) (mod P)
  d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
  hash: (hash_default()).sha256,
  gRed: false,
  g: [
    '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',

    // 4/5
    '6666666666666666666666666666666666666666666666666666666666666658',
  ],
});

var pre;
try {
  pre = /*RicMoo:ethers:require(./precomputed/secp256k1)*/(null).crash();
} catch (e) {
  pre = undefined;
}

defineCurve('secp256k1', {
  type: 'short',
  prime: 'k256',
  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
  a: '0',
  b: '7',
  n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
  h: '1',
  hash: (hash_default()).sha256,

  // Precomputed endomorphism
  beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
  lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
  basis: [
    {
      a: '3086d221a7d46bcde86c90e49284eb15',
      b: '-e4437ed6010e88286f547fa90abfe4c3',
    },
    {
      a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
      b: '3086d221a7d46bcde86c90e49284eb15',
    },
  ],

  gRed: false,
  g: [
    '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
    '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
    pre,
  ],
});
});

'use strict';





function HmacDRBG(options) {
  if (!(this instanceof HmacDRBG))
    return new HmacDRBG(options);
  this.hash = options.hash;
  this.predResist = !!options.predResist;

  this.outLen = this.hash.outSize;
  this.minEntropy = options.minEntropy || this.hash.hmacStrength;

  this._reseed = null;
  this.reseedInterval = null;
  this.K = null;
  this.V = null;

  var entropy = utils_1.toArray(options.entropy, options.entropyEnc || 'hex');
  var nonce = utils_1.toArray(options.nonce, options.nonceEnc || 'hex');
  var pers = utils_1.toArray(options.pers, options.persEnc || 'hex');
  minimalisticAssert(entropy.length >= (this.minEntropy / 8),
         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
  this._init(entropy, nonce, pers);
}
var hmacDrbg = HmacDRBG;

HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
  var seed = entropy.concat(nonce).concat(pers);

  this.K = new Array(this.outLen / 8);
  this.V = new Array(this.outLen / 8);
  for (var i = 0; i < this.V.length; i++) {
    this.K[i] = 0x00;
    this.V[i] = 0x01;
  }

  this._update(seed);
  this._reseed = 1;
  this.reseedInterval = 0x1000000000000;  // 2^48
};

HmacDRBG.prototype._hmac = function hmac() {
  return new (hash_default()).hmac(this.hash, this.K);
};

HmacDRBG.prototype._update = function update(seed) {
  var kmac = this._hmac()
                 .update(this.V)
                 .update([ 0x00 ]);
  if (seed)
    kmac = kmac.update(seed);
  this.K = kmac.digest();
  this.V = this._hmac().update(this.V).digest();
  if (!seed)
    return;

  this.K = this._hmac()
               .update(this.V)
               .update([ 0x01 ])
               .update(seed)
               .digest();
  this.V = this._hmac().update(this.V).digest();
};

HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
  // Optional entropy enc
  if (typeof entropyEnc !== 'string') {
    addEnc = add;
    add = entropyEnc;
    entropyEnc = null;
  }

  entropy = utils_1.toArray(entropy, entropyEnc);
  add = utils_1.toArray(add, addEnc);

  minimalisticAssert(entropy.length >= (this.minEntropy / 8),
         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');

  this._update(entropy.concat(add || []));
  this._reseed = 1;
};

HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
  if (this._reseed > this.reseedInterval)
    throw new Error('Reseed is required');

  // Optional encoding
  if (typeof enc !== 'string') {
    addEnc = add;
    add = enc;
    enc = null;
  }

  // Optional additional data
  if (add) {
    add = utils_1.toArray(add, addEnc || 'hex');
    this._update(add);
  }

  var temp = [];
  while (temp.length < len) {
    this.V = this._hmac().update(this.V).digest();
    temp = temp.concat(this.V);
  }

  var res = temp.slice(0, len);
  this._update(add);
  this._reseed++;
  return utils_1.encode(res, enc);
};

'use strict';



var assert$3 = utils_1$1.assert;

function KeyPair(ec, options) {
  this.ec = ec;
  this.priv = null;
  this.pub = null;

  // KeyPair(ec, { priv: ..., pub: ... })
  if (options.priv)
    this._importPrivate(options.priv, options.privEnc);
  if (options.pub)
    this._importPublic(options.pub, options.pubEnc);
}
var key = KeyPair;

KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
  if (pub instanceof KeyPair)
    return pub;

  return new KeyPair(ec, {
    pub: pub,
    pubEnc: enc,
  });
};

KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
  if (priv instanceof KeyPair)
    return priv;

  return new KeyPair(ec, {
    priv: priv,
    privEnc: enc,
  });
};

KeyPair.prototype.validate = function validate() {
  var pub = this.getPublic();

  if (pub.isInfinity())
    return { result: false, reason: 'Invalid public key' };
  if (!pub.validate())
    return { result: false, reason: 'Public key is not a point' };
  if (!pub.mul(this.ec.curve.n).isInfinity())
    return { result: false, reason: 'Public key * N != O' };

  return { result: true, reason: null };
};

KeyPair.prototype.getPublic = function getPublic(compact, enc) {
  // compact is optional argument
  if (typeof compact === 'string') {
    enc = compact;
    compact = null;
  }

  if (!this.pub)
    this.pub = this.ec.g.mul(this.priv);

  if (!enc)
    return this.pub;

  return this.pub.encode(enc, compact);
};

KeyPair.prototype.getPrivate = function getPrivate(enc) {
  if (enc === 'hex')
    return this.priv.toString(16, 2);
  else
    return this.priv;
};

KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
  this.priv = new (bn_default())(key, enc || 16);

  // Ensure that the priv won't be bigger than n, otherwise we may fail
  // in fixed multiplication method
  this.priv = this.priv.umod(this.ec.curve.n);
};

KeyPair.prototype._importPublic = function _importPublic(key, enc) {
  if (key.x || key.y) {
    // Montgomery points only have an `x` coordinate.
    // Weierstrass/Edwards points on the other hand have both `x` and
    // `y` coordinates.
    if (this.ec.curve.type === 'mont') {
      assert$3(key.x, 'Need x coordinate');
    } else if (this.ec.curve.type === 'short' ||
               this.ec.curve.type === 'edwards') {
      assert$3(key.x && key.y, 'Need both x and y coordinate');
    }
    this.pub = this.ec.curve.point(key.x, key.y);
    return;
  }
  this.pub = this.ec.curve.decodePoint(key, enc);
};

// ECDH
KeyPair.prototype.derive = function derive(pub) {
  if(!pub.validate()) {
    assert$3(pub.validate(), 'public point not validated');
  }
  return pub.mul(this.priv).getX();
};

// ECDSA
KeyPair.prototype.sign = function sign(msg, enc, options) {
  return this.ec.sign(msg, this, enc, options);
};

KeyPair.prototype.verify = function verify(msg, signature) {
  return this.ec.verify(msg, signature, this);
};

KeyPair.prototype.inspect = function inspect() {
  return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) +
         ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
};

'use strict';




var assert$4 = utils_1$1.assert;

function Signature(options, enc) {
  if (options instanceof Signature)
    return options;

  if (this._importDER(options, enc))
    return;

  assert$4(options.r && options.s, 'Signature without r or s');
  this.r = new (bn_default())(options.r, 16);
  this.s = new (bn_default())(options.s, 16);
  if (options.recoveryParam === undefined)
    this.recoveryParam = null;
  else
    this.recoveryParam = options.recoveryParam;
}
var signature = Signature;

function Position() {
  this.place = 0;
}

function getLength(buf, p) {
  var initial = buf[p.place++];
  if (!(initial & 0x80)) {
    return initial;
  }
  var octetLen = initial & 0xf;

  // Indefinite length or overflow
  if (octetLen === 0 || octetLen > 4) {
    return false;
  }

  var val = 0;
  for (var i = 0, off = p.place; i < octetLen; i++, off++) {
    val <<= 8;
    val |= buf[off];
    val >>>= 0;
  }

  // Leading zeroes
  if (val <= 0x7f) {
    return false;
  }

  p.place = off;
  return val;
}

function rmPadding(buf) {
  var i = 0;
  var len = buf.length - 1;
  while (!buf[i] && !(buf[i + 1] & 0x80) && i < len) {
    i++;
  }
  if (i === 0) {
    return buf;
  }
  return buf.slice(i);
}

Signature.prototype._importDER = function _importDER(data, enc) {
  data = utils_1$1.toArray(data, enc);
  var p = new Position();
  if (data[p.place++] !== 0x30) {
    return false;
  }
  var len = getLength(data, p);
  if (len === false) {
    return false;
  }
  if ((len + p.place) !== data.length) {
    return false;
  }
  if (data[p.place++] !== 0x02) {
    return false;
  }
  var rlen = getLength(data, p);
  if (rlen === false) {
    return false;
  }
  var r = data.slice(p.place, rlen + p.place);
  p.place += rlen;
  if (data[p.place++] !== 0x02) {
    return false;
  }
  var slen = getLength(data, p);
  if (slen === false) {
    return false;
  }
  if (data.length !== slen + p.place) {
    return false;
  }
  var s = data.slice(p.place, slen + p.place);
  if (r[0] === 0) {
    if (r[1] & 0x80) {
      r = r.slice(1);
    } else {
      // Leading zeroes
      return false;
    }
  }
  if (s[0] === 0) {
    if (s[1] & 0x80) {
      s = s.slice(1);
    } else {
      // Leading zeroes
      return false;
    }
  }

  this.r = new (bn_default())(r);
  this.s = new (bn_default())(s);
  this.recoveryParam = null;

  return true;
};

function constructLength(arr, len) {
  if (len < 0x80) {
    arr.push(len);
    return;
  }
  var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
  arr.push(octets | 0x80);
  while (--octets) {
    arr.push((len >>> (octets << 3)) & 0xff);
  }
  arr.push(len);
}

Signature.prototype.toDER = function toDER(enc) {
  var r = this.r.toArray();
  var s = this.s.toArray();

  // Pad values
  if (r[0] & 0x80)
    r = [ 0 ].concat(r);
  // Pad values
  if (s[0] & 0x80)
    s = [ 0 ].concat(s);

  r = rmPadding(r);
  s = rmPadding(s);

  while (!s[0] && !(s[1] & 0x80)) {
    s = s.slice(1);
  }
  var arr = [ 0x02 ];
  constructLength(arr, r.length);
  arr = arr.concat(r);
  arr.push(0x02);
  constructLength(arr, s.length);
  var backHalf = arr.concat(s);
  var res = [ 0x30 ];
  constructLength(res, backHalf.length);
  res = res.concat(backHalf);
  return utils_1$1.encode(res, enc);
};

'use strict';





var rand = /*RicMoo:ethers:require(brorand)*/(function() { throw new Error('unsupported'); });
var assert$5 = utils_1$1.assert;




function EC(options) {
  if (!(this instanceof EC))
    return new EC(options);

  // Shortcut `elliptic.ec(curve-name)`
  if (typeof options === 'string') {
    assert$5(Object.prototype.hasOwnProperty.call(curves_1, options),
      'Unknown curve ' + options);

    options = curves_1[options];
  }

  // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
  if (options instanceof curves_1.PresetCurve)
    options = { curve: options };

  this.curve = options.curve.curve;
  this.n = this.curve.n;
  this.nh = this.n.ushrn(1);
  this.g = this.curve.g;

  // Point on curve
  this.g = options.curve.g;
  this.g.precompute(options.curve.n.bitLength() + 1);

  // Hash for function for DRBG
  this.hash = options.hash || options.curve.hash;
}
var ec = EC;

EC.prototype.keyPair = function keyPair(options) {
  return new key(this, options);
};

EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
  return key.fromPrivate(this, priv, enc);
};

EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
  return key.fromPublic(this, pub, enc);
};

EC.prototype.genKeyPair = function genKeyPair(options) {
  if (!options)
    options = {};

  // Instantiate Hmac_DRBG
  var drbg = new hmacDrbg({
    hash: this.hash,
    pers: options.pers,
    persEnc: options.persEnc || 'utf8',
    entropy: options.entropy || rand(this.hash.hmacStrength),
    entropyEnc: options.entropy && options.entropyEnc || 'utf8',
    nonce: this.n.toArray(),
  });

  var bytes = this.n.byteLength();
  var ns2 = this.n.sub(new (bn_default())(2));
  for (;;) {
    var priv = new (bn_default())(drbg.generate(bytes));
    if (priv.cmp(ns2) > 0)
      continue;

    priv.iaddn(1);
    return this.keyFromPrivate(priv);
  }
};

EC.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
  var delta = msg.byteLength() * 8 - this.n.bitLength();
  if (delta > 0)
    msg = msg.ushrn(delta);
  if (!truncOnly && msg.cmp(this.n) >= 0)
    return msg.sub(this.n);
  else
    return msg;
};

EC.prototype.sign = function sign(msg, key, enc, options) {
  if (typeof enc === 'object') {
    options = enc;
    enc = null;
  }
  if (!options)
    options = {};

  key = this.keyFromPrivate(key, enc);
  msg = this._truncateToN(new (bn_default())(msg, 16));

  // Zero-extend key to provide enough entropy
  var bytes = this.n.byteLength();
  var bkey = key.getPrivate().toArray('be', bytes);

  // Zero-extend nonce to have the same byte size as N
  var nonce = msg.toArray('be', bytes);

  // Instantiate Hmac_DRBG
  var drbg = new hmacDrbg({
    hash: this.hash,
    entropy: bkey,
    nonce: nonce,
    pers: options.pers,
    persEnc: options.persEnc || 'utf8',
  });

  // Number of bytes to generate
  var ns1 = this.n.sub(new (bn_default())(1));

  for (var iter = 0; ; iter++) {
    var k = options.k ?
      options.k(iter) :
      new (bn_default())(drbg.generate(this.n.byteLength()));
    k = this._truncateToN(k, true);
    if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0)
      continue;

    var kp = this.g.mul(k);
    if (kp.isInfinity())
      continue;

    var kpX = kp.getX();
    var r = kpX.umod(this.n);
    if (r.cmpn(0) === 0)
      continue;

    var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
    s = s.umod(this.n);
    if (s.cmpn(0) === 0)
      continue;

    var recoveryParam = (kp.getY().isOdd() ? 1 : 0) |
                        (kpX.cmp(r) !== 0 ? 2 : 0);

    // Use complement of `s`, if it is > `n / 2`
    if (options.canonical && s.cmp(this.nh) > 0) {
      s = this.n.sub(s);
      recoveryParam ^= 1;
    }

    return new signature({ r: r, s: s, recoveryParam: recoveryParam });
  }
};

EC.prototype.verify = function verify(msg, signature$1, key, enc) {
  msg = this._truncateToN(new (bn_default())(msg, 16));
  key = this.keyFromPublic(key, enc);
  signature$1 = new signature(signature$1, 'hex');

  // Perform primitive values validation
  var r = signature$1.r;
  var s = signature$1.s;
  if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0)
    return false;
  if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0)
    return false;

  // Validate signature
  var sinv = s.invm(this.n);
  var u1 = sinv.mul(msg).umod(this.n);
  var u2 = sinv.mul(r).umod(this.n);
  var p;

  if (!this.curve._maxwellTrick) {
    p = this.g.mulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity())
      return false;

    return p.getX().umod(this.n).cmp(r) === 0;
  }

  // NOTE: Greg Maxwell's trick, inspired by:
  // https://git.io/vad3K

  p = this.g.jmulAdd(u1, key.getPublic(), u2);
  if (p.isInfinity())
    return false;

  // Compare `p.x` of Jacobian point with `r`,
  // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
  // inverse of `p.z^2`
  return p.eqXToP(r);
};

EC.prototype.recoverPubKey = function(msg, signature$1, j, enc) {
  assert$5((3 & j) === j, 'The recovery param is more than two bits');
  signature$1 = new signature(signature$1, enc);

  var n = this.n;
  var e = new (bn_default())(msg);
  var r = signature$1.r;
  var s = signature$1.s;

  // A set LSB signifies that the y-coordinate is odd
  var isYOdd = j & 1;
  var isSecondKey = j >> 1;
  if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey)
    throw new Error('Unable to find sencond key candinate');

  // 1.1. Let x = r + jn.
  if (isSecondKey)
    r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
  else
    r = this.curve.pointFromX(r, isYOdd);

  var rInv = signature$1.r.invm(n);
  var s1 = n.sub(e).mul(rInv).umod(n);
  var s2 = s.mul(rInv).umod(n);

  // 1.6.1 Compute Q = r^-1 (sR -  eG)
  //               Q = r^-1 (sR + -eG)
  return this.g.mulAdd(s1, r, s2);
};

EC.prototype.getKeyRecoveryParam = function(e, signature$1, Q, enc) {
  signature$1 = new signature(signature$1, enc);
  if (signature$1.recoveryParam !== null)
    return signature$1.recoveryParam;

  for (var i = 0; i < 4; i++) {
    var Qprime;
    try {
      Qprime = this.recoverPubKey(e, signature$1, i);
    } catch (e) {
      continue;
    }

    if (Qprime.eq(Q))
      return i;
  }
  throw new Error('Unable to find valid recovery factor');
};

var elliptic_1 = createCommonjsModule(function (module, exports) {
'use strict';

var elliptic = exports;

elliptic.version = /*RicMoo:ethers*/{ version: "6.5.4" }.version;
elliptic.utils = utils_1$1;
elliptic.rand = /*RicMoo:ethers:require(brorand)*/(function() { throw new Error('unsupported'); });
elliptic.curve = curve_1;
elliptic.curves = curves_1;

// Protocols
elliptic.ec = ec;
elliptic.eddsa = /*RicMoo:ethers:require(./elliptic/eddsa)*/(null);
});

var EC$1 = elliptic_1.ec;


//# sourceMappingURL=elliptic.js.map

;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+signing-key@5.7.0/node_modules/@ethersproject/signing-key/lib.esm/_version.js
const signing_key_lib_esm_version_version = "signing-key/5.7.0";
//# sourceMappingURL=_version.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+signing-key@5.7.0/node_modules/@ethersproject/signing-key/lib.esm/index.js






const signing_key_lib_esm_logger = new lib_esm_Logger(signing_key_lib_esm_version_version);
let _curve = null;
function getCurve() {
    if (!_curve) {
        _curve = new EC$1("secp256k1");
    }
    return _curve;
}
class SigningKey {
    constructor(privateKey) {
        lib_esm_defineReadOnly(this, "curve", "secp256k1");
        lib_esm_defineReadOnly(this, "privateKey", lib_esm_hexlify(privateKey));
        if (lib_esm_hexDataLength(this.privateKey) !== 32) {
            signing_key_lib_esm_logger.throwArgumentError("invalid private key", "privateKey", "[[ REDACTED ]]");
        }
        const keyPair = getCurve().keyFromPrivate(lib_esm_arrayify(this.privateKey));
        lib_esm_defineReadOnly(this, "publicKey", "0x" + keyPair.getPublic(false, "hex"));
        lib_esm_defineReadOnly(this, "compressedPublicKey", "0x" + keyPair.getPublic(true, "hex"));
        lib_esm_defineReadOnly(this, "_isSigningKey", true);
    }
    _addPoint(other) {
        const p0 = getCurve().keyFromPublic(lib_esm_arrayify(this.publicKey));
        const p1 = getCurve().keyFromPublic(lib_esm_arrayify(other));
        return "0x" + p0.pub.add(p1.pub).encodeCompressed("hex");
    }
    signDigest(digest) {
        const keyPair = getCurve().keyFromPrivate(lib_esm_arrayify(this.privateKey));
        const digestBytes = lib_esm_arrayify(digest);
        if (digestBytes.length !== 32) {
            signing_key_lib_esm_logger.throwArgumentError("bad digest length", "digest", digest);
        }
        const signature = keyPair.sign(digestBytes, { canonical: true });
        return splitSignature({
            recoveryParam: signature.recoveryParam,
            r: hexZeroPad("0x" + signature.r.toString(16), 32),
            s: hexZeroPad("0x" + signature.s.toString(16), 32),
        });
    }
    computeSharedSecret(otherKey) {
        const keyPair = getCurve().keyFromPrivate(lib_esm_arrayify(this.privateKey));
        const otherKeyPair = getCurve().keyFromPublic(lib_esm_arrayify(computePublicKey(otherKey)));
        return hexZeroPad("0x" + keyPair.derive(otherKeyPair.getPublic()).toString(16), 32);
    }
    static isSigningKey(value) {
        return !!(value && value._isSigningKey);
    }
}
function recoverPublicKey(digest, signature) {
    const sig = splitSignature(signature);
    const rs = { r: lib_esm_arrayify(sig.r), s: lib_esm_arrayify(sig.s) };
    return "0x" + getCurve().recoverPubKey(lib_esm_arrayify(digest), rs, sig.recoveryParam).encode("hex", false);
}
function computePublicKey(key, compressed) {
    const bytes = lib_esm_arrayify(key);
    if (bytes.length === 32) {
        const signingKey = new SigningKey(bytes);
        if (compressed) {
            return "0x" + getCurve().keyFromPrivate(bytes).getPublic(true, "hex");
        }
        return signingKey.publicKey;
    }
    else if (bytes.length === 33) {
        if (compressed) {
            return lib_esm_hexlify(bytes);
        }
        return "0x" + getCurve().keyFromPublic(bytes).getPublic(false, "hex");
    }
    else if (bytes.length === 65) {
        if (!compressed) {
            return lib_esm_hexlify(bytes);
        }
        return "0x" + getCurve().keyFromPublic(bytes).getPublic(true, "hex");
    }
    return signing_key_lib_esm_logger.throwArgumentError("invalid public or private key", "key", "[REDACTED]");
}
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+transactions@5.7.0/node_modules/@ethersproject/transactions/lib.esm/_version.js
const transactions_lib_esm_version_version = "transactions/5.7.0";
//# sourceMappingURL=_version.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+transactions@5.7.0/node_modules/@ethersproject/transactions/lib.esm/index.js











const transactions_lib_esm_logger = new lib_esm_Logger(transactions_lib_esm_version_version);
var TransactionTypes;
(function (TransactionTypes) {
    TransactionTypes[TransactionTypes["legacy"] = 0] = "legacy";
    TransactionTypes[TransactionTypes["eip2930"] = 1] = "eip2930";
    TransactionTypes[TransactionTypes["eip1559"] = 2] = "eip1559";
})(TransactionTypes || (TransactionTypes = {}));
;
///////////////////////////////
function handleAddress(value) {
    if (value === "0x") {
        return null;
    }
    return lib_esm_getAddress(value);
}
function handleNumber(value) {
    if (value === "0x") {
        return bignumbers_Zero;
    }
    return bignumber_BigNumber.from(value);
}
// Legacy Transaction Fields
const transactionFields = [
    { name: "nonce", maxLength: 32, numeric: true },
    { name: "gasPrice", maxLength: 32, numeric: true },
    { name: "gasLimit", maxLength: 32, numeric: true },
    { name: "to", length: 20 },
    { name: "value", maxLength: 32, numeric: true },
    { name: "data" },
];
const lib_esm_allowedTransactionKeys = {
    chainId: true, data: true, gasLimit: true, gasPrice: true, nonce: true, to: true, type: true, value: true
};
function computeAddress(key) {
    const publicKey = computePublicKey(key);
    return lib_esm_getAddress(lib_esm_hexDataSlice(lib_esm_keccak256(lib_esm_hexDataSlice(publicKey, 1)), 12));
}
function lib_esm_recoverAddress(digest, signature) {
    return computeAddress(recoverPublicKey(lib_esm_arrayify(digest), signature));
}
function formatNumber(value, name) {
    const result = stripZeros(bignumber_BigNumber.from(value).toHexString());
    if (result.length > 32) {
        transactions_lib_esm_logger.throwArgumentError("invalid length for " + name, ("transaction:" + name), value);
    }
    return result;
}
function accessSetify(addr, storageKeys) {
    return {
        address: lib_esm_getAddress(addr),
        storageKeys: (storageKeys || []).map((storageKey, index) => {
            if (lib_esm_hexDataLength(storageKey) !== 32) {
                transactions_lib_esm_logger.throwArgumentError("invalid access list storageKey", `accessList[${addr}:${index}]`, storageKey);
            }
            return storageKey.toLowerCase();
        })
    };
}
function accessListify(value) {
    if (Array.isArray(value)) {
        return value.map((set, index) => {
            if (Array.isArray(set)) {
                if (set.length > 2) {
                    transactions_lib_esm_logger.throwArgumentError("access list expected to be [ address, storageKeys[] ]", `value[${index}]`, set);
                }
                return accessSetify(set[0], set[1]);
            }
            return accessSetify(set.address, set.storageKeys);
        });
    }
    const result = Object.keys(value).map((addr) => {
        const storageKeys = value[addr].reduce((accum, storageKey) => {
            accum[storageKey] = true;
            return accum;
        }, {});
        return accessSetify(addr, Object.keys(storageKeys).sort());
    });
    result.sort((a, b) => (a.address.localeCompare(b.address)));
    return result;
}
function formatAccessList(value) {
    return accessListify(value).map((set) => [set.address, set.storageKeys]);
}
function _serializeEip1559(transaction, signature) {
    // If there is an explicit gasPrice, make sure it matches the
    // EIP-1559 fees; otherwise they may not understand what they
    // think they are setting in terms of fee.
    if (transaction.gasPrice != null) {
        const gasPrice = bignumber_BigNumber.from(transaction.gasPrice);
        const maxFeePerGas = bignumber_BigNumber.from(transaction.maxFeePerGas || 0);
        if (!gasPrice.eq(maxFeePerGas)) {
            transactions_lib_esm_logger.throwArgumentError("mismatch EIP-1559 gasPrice != maxFeePerGas", "tx", {
                gasPrice, maxFeePerGas
            });
        }
    }
    const fields = [
        formatNumber(transaction.chainId || 0, "chainId"),
        formatNumber(transaction.nonce || 0, "nonce"),
        formatNumber(transaction.maxPriorityFeePerGas || 0, "maxPriorityFeePerGas"),
        formatNumber(transaction.maxFeePerGas || 0, "maxFeePerGas"),
        formatNumber(transaction.gasLimit || 0, "gasLimit"),
        ((transaction.to != null) ? lib_esm_getAddress(transaction.to) : "0x"),
        formatNumber(transaction.value || 0, "value"),
        (transaction.data || "0x"),
        (formatAccessList(transaction.accessList || []))
    ];
    if (signature) {
        const sig = splitSignature(signature);
        fields.push(formatNumber(sig.recoveryParam, "recoveryParam"));
        fields.push(stripZeros(sig.r));
        fields.push(stripZeros(sig.s));
    }
    return hexConcat(["0x02", encode(fields)]);
}
function _serializeEip2930(transaction, signature) {
    const fields = [
        formatNumber(transaction.chainId || 0, "chainId"),
        formatNumber(transaction.nonce || 0, "nonce"),
        formatNumber(transaction.gasPrice || 0, "gasPrice"),
        formatNumber(transaction.gasLimit || 0, "gasLimit"),
        ((transaction.to != null) ? lib_esm_getAddress(transaction.to) : "0x"),
        formatNumber(transaction.value || 0, "value"),
        (transaction.data || "0x"),
        (formatAccessList(transaction.accessList || []))
    ];
    if (signature) {
        const sig = splitSignature(signature);
        fields.push(formatNumber(sig.recoveryParam, "recoveryParam"));
        fields.push(stripZeros(sig.r));
        fields.push(stripZeros(sig.s));
    }
    return hexConcat(["0x01", encode(fields)]);
}
// Legacy Transactions and EIP-155
function _serialize(transaction, signature) {
    checkProperties(transaction, lib_esm_allowedTransactionKeys);
    const raw = [];
    transactionFields.forEach(function (fieldInfo) {
        let value = transaction[fieldInfo.name] || ([]);
        const options = {};
        if (fieldInfo.numeric) {
            options.hexPad = "left";
        }
        value = lib_esm_arrayify(lib_esm_hexlify(value, options));
        // Fixed-width field
        if (fieldInfo.length && value.length !== fieldInfo.length && value.length > 0) {
            transactions_lib_esm_logger.throwArgumentError("invalid length for " + fieldInfo.name, ("transaction:" + fieldInfo.name), value);
        }
        // Variable-width (with a maximum)
        if (fieldInfo.maxLength) {
            value = stripZeros(value);
            if (value.length > fieldInfo.maxLength) {
                transactions_lib_esm_logger.throwArgumentError("invalid length for " + fieldInfo.name, ("transaction:" + fieldInfo.name), value);
            }
        }
        raw.push(lib_esm_hexlify(value));
    });
    let chainId = 0;
    if (transaction.chainId != null) {
        // A chainId was provided; if non-zero we'll use EIP-155
        chainId = transaction.chainId;
        if (typeof (chainId) !== "number") {
            transactions_lib_esm_logger.throwArgumentError("invalid transaction.chainId", "transaction", transaction);
        }
    }
    else if (signature && !isBytesLike(signature) && signature.v > 28) {
        // No chainId provided, but the signature is signing with EIP-155; derive chainId
        chainId = Math.floor((signature.v - 35) / 2);
    }
    // We have an EIP-155 transaction (chainId was specified and non-zero)
    if (chainId !== 0) {
        raw.push(lib_esm_hexlify(chainId)); // @TODO: hexValue?
        raw.push("0x");
        raw.push("0x");
    }
    // Requesting an unsigned transaction
    if (!signature) {
        return encode(raw);
    }
    // The splitSignature will ensure the transaction has a recoveryParam in the
    // case that the signTransaction function only adds a v.
    const sig = splitSignature(signature);
    // We pushed a chainId and null r, s on for hashing only; remove those
    let v = 27 + sig.recoveryParam;
    if (chainId !== 0) {
        raw.pop();
        raw.pop();
        raw.pop();
        v += chainId * 2 + 8;
        // If an EIP-155 v (directly or indirectly; maybe _vs) was provided, check it!
        if (sig.v > 28 && sig.v !== v) {
            transactions_lib_esm_logger.throwArgumentError("transaction.chainId/signature.v mismatch", "signature", signature);
        }
    }
    else if (sig.v !== v) {
        transactions_lib_esm_logger.throwArgumentError("transaction.chainId/signature.v mismatch", "signature", signature);
    }
    raw.push(lib_esm_hexlify(v));
    raw.push(stripZeros(lib_esm_arrayify(sig.r)));
    raw.push(stripZeros(lib_esm_arrayify(sig.s)));
    return encode(raw);
}
function serialize(transaction, signature) {
    // Legacy and EIP-155 Transactions
    if (transaction.type == null || transaction.type === 0) {
        if (transaction.accessList != null) {
            transactions_lib_esm_logger.throwArgumentError("untyped transactions do not support accessList; include type: 1", "transaction", transaction);
        }
        return _serialize(transaction, signature);
    }
    // Typed Transactions (EIP-2718)
    switch (transaction.type) {
        case 1:
            return _serializeEip2930(transaction, signature);
        case 2:
            return _serializeEip1559(transaction, signature);
        default:
            break;
    }
    return transactions_lib_esm_logger.throwError(`unsupported transaction type: ${transaction.type}`, lib_esm_Logger.errors.UNSUPPORTED_OPERATION, {
        operation: "serializeTransaction",
        transactionType: transaction.type
    });
}
function _parseEipSignature(tx, fields, serialize) {
    try {
        const recid = handleNumber(fields[0]).toNumber();
        if (recid !== 0 && recid !== 1) {
            throw new Error("bad recid");
        }
        tx.v = recid;
    }
    catch (error) {
        transactions_lib_esm_logger.throwArgumentError("invalid v for transaction type: 1", "v", fields[0]);
    }
    tx.r = hexZeroPad(fields[1], 32);
    tx.s = hexZeroPad(fields[2], 32);
    try {
        const digest = lib_esm_keccak256(serialize(tx));
        tx.from = lib_esm_recoverAddress(digest, { r: tx.r, s: tx.s, recoveryParam: tx.v });
    }
    catch (error) { }
}
function _parseEip1559(payload) {
    const transaction = decode(payload.slice(1));
    if (transaction.length !== 9 && transaction.length !== 12) {
        transactions_lib_esm_logger.throwArgumentError("invalid component count for transaction type: 2", "payload", lib_esm_hexlify(payload));
    }
    const maxPriorityFeePerGas = handleNumber(transaction[2]);
    const maxFeePerGas = handleNumber(transaction[3]);
    const tx = {
        type: 2,
        chainId: handleNumber(transaction[0]).toNumber(),
        nonce: handleNumber(transaction[1]).toNumber(),
        maxPriorityFeePerGas: maxPriorityFeePerGas,
        maxFeePerGas: maxFeePerGas,
        gasPrice: null,
        gasLimit: handleNumber(transaction[4]),
        to: handleAddress(transaction[5]),
        value: handleNumber(transaction[6]),
        data: transaction[7],
        accessList: accessListify(transaction[8]),
    };
    // Unsigned EIP-1559 Transaction
    if (transaction.length === 9) {
        return tx;
    }
    tx.hash = lib_esm_keccak256(payload);
    _parseEipSignature(tx, transaction.slice(9), _serializeEip1559);
    return tx;
}
function _parseEip2930(payload) {
    const transaction = decode(payload.slice(1));
    if (transaction.length !== 8 && transaction.length !== 11) {
        transactions_lib_esm_logger.throwArgumentError("invalid component count for transaction type: 1", "payload", lib_esm_hexlify(payload));
    }
    const tx = {
        type: 1,
        chainId: handleNumber(transaction[0]).toNumber(),
        nonce: handleNumber(transaction[1]).toNumber(),
        gasPrice: handleNumber(transaction[2]),
        gasLimit: handleNumber(transaction[3]),
        to: handleAddress(transaction[4]),
        value: handleNumber(transaction[5]),
        data: transaction[6],
        accessList: accessListify(transaction[7])
    };
    // Unsigned EIP-2930 Transaction
    if (transaction.length === 8) {
        return tx;
    }
    tx.hash = lib_esm_keccak256(payload);
    _parseEipSignature(tx, transaction.slice(8), _serializeEip2930);
    return tx;
}
// Legacy Transactions and EIP-155
function _parse(rawTransaction) {
    const transaction = decode(rawTransaction);
    if (transaction.length !== 9 && transaction.length !== 6) {
        transactions_lib_esm_logger.throwArgumentError("invalid raw transaction", "rawTransaction", rawTransaction);
    }
    const tx = {
        nonce: handleNumber(transaction[0]).toNumber(),
        gasPrice: handleNumber(transaction[1]),
        gasLimit: handleNumber(transaction[2]),
        to: handleAddress(transaction[3]),
        value: handleNumber(transaction[4]),
        data: transaction[5],
        chainId: 0
    };
    // Legacy unsigned transaction
    if (transaction.length === 6) {
        return tx;
    }
    try {
        tx.v = bignumber_BigNumber.from(transaction[6]).toNumber();
    }
    catch (error) {
        // @TODO: What makes snese to do? The v is too big
        return tx;
    }
    tx.r = hexZeroPad(transaction[7], 32);
    tx.s = hexZeroPad(transaction[8], 32);
    if (bignumber_BigNumber.from(tx.r).isZero() && bignumber_BigNumber.from(tx.s).isZero()) {
        // EIP-155 unsigned transaction
        tx.chainId = tx.v;
        tx.v = 0;
    }
    else {
        // Signed Transaction
        tx.chainId = Math.floor((tx.v - 35) / 2);
        if (tx.chainId < 0) {
            tx.chainId = 0;
        }
        let recoveryParam = tx.v - 27;
        const raw = transaction.slice(0, 6);
        if (tx.chainId !== 0) {
            raw.push(lib_esm_hexlify(tx.chainId));
            raw.push("0x");
            raw.push("0x");
            recoveryParam -= tx.chainId * 2 + 8;
        }
        const digest = lib_esm_keccak256(encode(raw));
        try {
            tx.from = lib_esm_recoverAddress(digest, { r: lib_esm_hexlify(tx.r), s: lib_esm_hexlify(tx.s), recoveryParam: recoveryParam });
        }
        catch (error) { }
        tx.hash = lib_esm_keccak256(rawTransaction);
    }
    tx.type = null;
    return tx;
}
function parse(rawTransaction) {
    const payload = lib_esm_arrayify(rawTransaction);
    // Legacy and EIP-155 Transactions
    if (payload[0] > 0x7f) {
        return _parse(payload);
    }
    // Typed Transaction (EIP-2718)
    switch (payload[0]) {
        case 1:
            return _parseEip2930(payload);
        case 2:
            return _parseEip1559(payload);
        default:
            break;
    }
    return transactions_lib_esm_logger.throwError(`unsupported transaction type: ${payload[0]}`, lib_esm_Logger.errors.UNSUPPORTED_OPERATION, {
        operation: "parseTransaction",
        transactionType: payload[0]
    });
}
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+base64@5.7.0/node_modules/@ethersproject/base64/lib.esm/base64.js


function base64_decode(textData) {
    textData = atob(textData);
    const data = [];
    for (let i = 0; i < textData.length; i++) {
        data.push(textData.charCodeAt(i));
    }
    return lib_esm_arrayify(data);
}
function base64_encode(data) {
    data = lib_esm_arrayify(data);
    let textData = "";
    for (let i = 0; i < data.length; i++) {
        textData += String.fromCharCode(data[i]);
    }
    return btoa(textData);
}
//# sourceMappingURL=base64.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+web@5.7.1/node_modules/@ethersproject/web/lib.esm/_version.js
const web_lib_esm_version_version = "web/5.7.1";
//# sourceMappingURL=_version.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+web@5.7.1/node_modules/@ethersproject/web/lib.esm/geturl.js

var geturl_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

function getUrl(href, options) {
    return geturl_awaiter(this, void 0, void 0, function* () {
        if (options == null) {
            options = {};
        }
        const request = {
            method: (options.method || "GET"),
            headers: (options.headers || {}),
            body: (options.body || undefined),
        };
        if (options.skipFetchSetup !== true) {
            request.mode = "cors"; // no-cors, cors, *same-origin
            request.cache = "no-cache"; // *default, no-cache, reload, force-cache, only-if-cached
            request.credentials = "same-origin"; // include, *same-origin, omit
            request.redirect = "follow"; // manual, *follow, error
            request.referrer = "client"; // no-referrer, *client
        }
        ;
        if (options.fetchOptions != null) {
            const opts = options.fetchOptions;
            if (opts.mode) {
                request.mode = (opts.mode);
            }
            if (opts.cache) {
                request.cache = (opts.cache);
            }
            if (opts.credentials) {
                request.credentials = (opts.credentials);
            }
            if (opts.redirect) {
                request.redirect = (opts.redirect);
            }
            if (opts.referrer) {
                request.referrer = opts.referrer;
            }
        }
        const response = yield fetch(href, request);
        const body = yield response.arrayBuffer();
        const headers = {};
        if (response.headers.forEach) {
            response.headers.forEach((value, key) => {
                headers[key.toLowerCase()] = value;
            });
        }
        else {
            ((response.headers).keys)().forEach((key) => {
                headers[key.toLowerCase()] = response.headers.get(key);
            });
        }
        return {
            headers: headers,
            statusCode: response.status,
            statusMessage: response.statusText,
            body: lib_esm_arrayify(new Uint8Array(body)),
        };
    });
}
//# sourceMappingURL=geturl.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+web@5.7.1/node_modules/@ethersproject/web/lib.esm/index.js

var web_lib_esm_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};






const web_lib_esm_logger = new lib_esm_Logger(web_lib_esm_version_version);

function staller(duration) {
    return new Promise((resolve) => {
        setTimeout(resolve, duration);
    });
}
function bodyify(value, type) {
    if (value == null) {
        return null;
    }
    if (typeof (value) === "string") {
        return value;
    }
    if (isBytesLike(value)) {
        if (type && (type.split("/")[0] === "text" || type.split(";")[0].trim() === "application/json")) {
            try {
                return utf8_toUtf8String(value);
            }
            catch (error) { }
            ;
        }
        return lib_esm_hexlify(value);
    }
    return value;
}
function unpercent(value) {
    return toUtf8Bytes(value.replace(/%([0-9a-f][0-9a-f])/gi, (all, code) => {
        return String.fromCharCode(parseInt(code, 16));
    }));
}
// This API is still a work in progress; the future changes will likely be:
// - ConnectionInfo => FetchDataRequest<T = any>
// - FetchDataRequest.body? = string | Uint8Array | { contentType: string, data: string | Uint8Array }
//   - If string => text/plain, Uint8Array => application/octet-stream (if content-type unspecified)
// - FetchDataRequest.processFunc = (body: Uint8Array, response: FetchDataResponse) => T
// For this reason, it should be considered internal until the API is finalized
function _fetchData(connection, body, processFunc) {
    // How many times to retry in the event of a throttle
    const attemptLimit = (typeof (connection) === "object" && connection.throttleLimit != null) ? connection.throttleLimit : 12;
    web_lib_esm_logger.assertArgument((attemptLimit > 0 && (attemptLimit % 1) === 0), "invalid connection throttle limit", "connection.throttleLimit", attemptLimit);
    const throttleCallback = ((typeof (connection) === "object") ? connection.throttleCallback : null);
    const throttleSlotInterval = ((typeof (connection) === "object" && typeof (connection.throttleSlotInterval) === "number") ? connection.throttleSlotInterval : 100);
    web_lib_esm_logger.assertArgument((throttleSlotInterval > 0 && (throttleSlotInterval % 1) === 0), "invalid connection throttle slot interval", "connection.throttleSlotInterval", throttleSlotInterval);
    const errorPassThrough = ((typeof (connection) === "object") ? !!(connection.errorPassThrough) : false);
    const headers = {};
    let url = null;
    // @TODO: Allow ConnectionInfo to override some of these values
    const options = {
        method: "GET",
    };
    let allow304 = false;
    let timeout = 2 * 60 * 1000;
    if (typeof (connection) === "string") {
        url = connection;
    }
    else if (typeof (connection) === "object") {
        if (connection == null || connection.url == null) {
            web_lib_esm_logger.throwArgumentError("missing URL", "connection.url", connection);
        }
        url = connection.url;
        if (typeof (connection.timeout) === "number" && connection.timeout > 0) {
            timeout = connection.timeout;
        }
        if (connection.headers) {
            for (const key in connection.headers) {
                headers[key.toLowerCase()] = { key: key, value: String(connection.headers[key]) };
                if (["if-none-match", "if-modified-since"].indexOf(key.toLowerCase()) >= 0) {
                    allow304 = true;
                }
            }
        }
        options.allowGzip = !!connection.allowGzip;
        if (connection.user != null && connection.password != null) {
            if (url.substring(0, 6) !== "https:" && connection.allowInsecureAuthentication !== true) {
                web_lib_esm_logger.throwError("basic authentication requires a secure https url", lib_esm_Logger.errors.INVALID_ARGUMENT, { argument: "url", url: url, user: connection.user, password: "[REDACTED]" });
            }
            const authorization = connection.user + ":" + connection.password;
            headers["authorization"] = {
                key: "Authorization",
                value: "Basic " + base64_encode(toUtf8Bytes(authorization))
            };
        }
        if (connection.skipFetchSetup != null) {
            options.skipFetchSetup = !!connection.skipFetchSetup;
        }
        if (connection.fetchOptions != null) {
            options.fetchOptions = lib_esm_shallowCopy(connection.fetchOptions);
        }
    }
    const reData = new RegExp("^data:([^;:]*)?(;base64)?,(.*)$", "i");
    const dataMatch = ((url) ? url.match(reData) : null);
    if (dataMatch) {
        try {
            const response = {
                statusCode: 200,
                statusMessage: "OK",
                headers: { "content-type": (dataMatch[1] || "text/plain") },
                body: (dataMatch[2] ? base64_decode(dataMatch[3]) : unpercent(dataMatch[3]))
            };
            let result = response.body;
            if (processFunc) {
                result = processFunc(response.body, response);
            }
            return Promise.resolve(result);
        }
        catch (error) {
            web_lib_esm_logger.throwError("processing response error", lib_esm_Logger.errors.SERVER_ERROR, {
                body: bodyify(dataMatch[1], dataMatch[2]),
                error: error,
                requestBody: null,
                requestMethod: "GET",
                url: url
            });
        }
    }
    if (body) {
        options.method = "POST";
        options.body = body;
        if (headers["content-type"] == null) {
            headers["content-type"] = { key: "Content-Type", value: "application/octet-stream" };
        }
        if (headers["content-length"] == null) {
            headers["content-length"] = { key: "Content-Length", value: String(body.length) };
        }
    }
    const flatHeaders = {};
    Object.keys(headers).forEach((key) => {
        const header = headers[key];
        flatHeaders[header.key] = header.value;
    });
    options.headers = flatHeaders;
    const runningTimeout = (function () {
        let timer = null;
        const promise = new Promise(function (resolve, reject) {
            if (timeout) {
                timer = setTimeout(() => {
                    if (timer == null) {
                        return;
                    }
                    timer = null;
                    reject(web_lib_esm_logger.makeError("timeout", lib_esm_Logger.errors.TIMEOUT, {
                        requestBody: bodyify(options.body, flatHeaders["content-type"]),
                        requestMethod: options.method,
                        timeout: timeout,
                        url: url
                    }));
                }, timeout);
            }
        });
        const cancel = function () {
            if (timer == null) {
                return;
            }
            clearTimeout(timer);
            timer = null;
        };
        return { promise, cancel };
    })();
    const runningFetch = (function () {
        return web_lib_esm_awaiter(this, void 0, void 0, function* () {
            for (let attempt = 0; attempt < attemptLimit; attempt++) {
                let response = null;
                try {
                    response = yield getUrl(url, options);
                    if (attempt < attemptLimit) {
                        if (response.statusCode === 301 || response.statusCode === 302) {
                            // Redirection; for now we only support absolute locataions
                            const location = response.headers.location || "";
                            if (options.method === "GET" && location.match(/^https:/)) {
                                url = response.headers.location;
                                continue;
                            }
                        }
                        else if (response.statusCode === 429) {
                            // Exponential back-off throttling
                            let tryAgain = true;
                            if (throttleCallback) {
                                tryAgain = yield throttleCallback(attempt, url);
                            }
                            if (tryAgain) {
                                let stall = 0;
                                const retryAfter = response.headers["retry-after"];
                                if (typeof (retryAfter) === "string" && retryAfter.match(/^[1-9][0-9]*$/)) {
                                    stall = parseInt(retryAfter) * 1000;
                                }
                                else {
                                    stall = throttleSlotInterval * parseInt(String(Math.random() * Math.pow(2, attempt)));
                                }
                                //console.log("Stalling 429");
                                yield staller(stall);
                                continue;
                            }
                        }
                    }
                }
                catch (error) {
                    response = error.response;
                    if (response == null) {
                        runningTimeout.cancel();
                        web_lib_esm_logger.throwError("missing response", lib_esm_Logger.errors.SERVER_ERROR, {
                            requestBody: bodyify(options.body, flatHeaders["content-type"]),
                            requestMethod: options.method,
                            serverError: error,
                            url: url
                        });
                    }
                }
                let body = response.body;
                if (allow304 && response.statusCode === 304) {
                    body = null;
                }
                else if (!errorPassThrough && (response.statusCode < 200 || response.statusCode >= 300)) {
                    runningTimeout.cancel();
                    web_lib_esm_logger.throwError("bad response", lib_esm_Logger.errors.SERVER_ERROR, {
                        status: response.statusCode,
                        headers: response.headers,
                        body: bodyify(body, ((response.headers) ? response.headers["content-type"] : null)),
                        requestBody: bodyify(options.body, flatHeaders["content-type"]),
                        requestMethod: options.method,
                        url: url
                    });
                }
                if (processFunc) {
                    try {
                        const result = yield processFunc(body, response);
                        runningTimeout.cancel();
                        return result;
                    }
                    catch (error) {
                        // Allow the processFunc to trigger a throttle
                        if (error.throttleRetry && attempt < attemptLimit) {
                            let tryAgain = true;
                            if (throttleCallback) {
                                tryAgain = yield throttleCallback(attempt, url);
                            }
                            if (tryAgain) {
                                const timeout = throttleSlotInterval * parseInt(String(Math.random() * Math.pow(2, attempt)));
                                //console.log("Stalling callback");
                                yield staller(timeout);
                                continue;
                            }
                        }
                        runningTimeout.cancel();
                        web_lib_esm_logger.throwError("processing response error", lib_esm_Logger.errors.SERVER_ERROR, {
                            body: bodyify(body, ((response.headers) ? response.headers["content-type"] : null)),
                            error: error,
                            requestBody: bodyify(options.body, flatHeaders["content-type"]),
                            requestMethod: options.method,
                            url: url
                        });
                    }
                }
                runningTimeout.cancel();
                // If we had a processFunc, it either returned a T or threw above.
                // The "body" is now a Uint8Array.
                return body;
            }
            return web_lib_esm_logger.throwError("failed response", lib_esm_Logger.errors.SERVER_ERROR, {
                requestBody: bodyify(options.body, flatHeaders["content-type"]),
                requestMethod: options.method,
                url: url
            });
        });
    })();
    return Promise.race([runningTimeout.promise, runningFetch]);
}
function fetchJson(connection, json, processFunc) {
    let processJsonFunc = (value, response) => {
        let result = null;
        if (value != null) {
            try {
                result = JSON.parse(utf8_toUtf8String(value));
            }
            catch (error) {
                web_lib_esm_logger.throwError("invalid JSON", lib_esm_Logger.errors.SERVER_ERROR, {
                    body: value,
                    error: error
                });
            }
        }
        if (processFunc) {
            result = processFunc(result, response);
        }
        return result;
    };
    // If we have json to send, we must
    // - add content-type of application/json (unless already overridden)
    // - convert the json to bytes
    let body = null;
    if (json != null) {
        body = toUtf8Bytes(json);
        // Create a connection with the content-type set for JSON
        const updated = (typeof (connection) === "string") ? ({ url: connection }) : lib_esm_shallowCopy(connection);
        if (updated.headers) {
            const hasContentType = (Object.keys(updated.headers).filter((k) => (k.toLowerCase() === "content-type")).length) !== 0;
            if (!hasContentType) {
                updated.headers = lib_esm_shallowCopy(updated.headers);
                updated.headers["content-type"] = "application/json";
            }
        }
        else {
            updated.headers = { "content-type": "application/json" };
        }
        connection = updated;
    }
    return _fetchData(connection, body, processJsonFunc);
}
function poll(func, options) {
    if (!options) {
        options = {};
    }
    options = lib_esm_shallowCopy(options);
    if (options.floor == null) {
        options.floor = 0;
    }
    if (options.ceiling == null) {
        options.ceiling = 10000;
    }
    if (options.interval == null) {
        options.interval = 250;
    }
    return new Promise(function (resolve, reject) {
        let timer = null;
        let done = false;
        // Returns true if cancel was successful. Unsuccessful cancel means we're already done.
        const cancel = () => {
            if (done) {
                return false;
            }
            done = true;
            if (timer) {
                clearTimeout(timer);
            }
            return true;
        };
        if (options.timeout) {
            timer = setTimeout(() => {
                if (cancel()) {
                    reject(new Error("timeout"));
                }
            }, options.timeout);
        }
        const retryLimit = options.retryLimit;
        let attempt = 0;
        function check() {
            return func().then(function (result) {
                // If we have a result, or are allowed null then we're done
                if (result !== undefined) {
                    if (cancel()) {
                        resolve(result);
                    }
                }
                else if (options.oncePoll) {
                    options.oncePoll.once("poll", check);
                }
                else if (options.onceBlock) {
                    options.onceBlock.once("block", check);
                    // Otherwise, exponential back-off (up to 10s) our next request
                }
                else if (!done) {
                    attempt++;
                    if (attempt > retryLimit) {
                        if (cancel()) {
                            reject(new Error("retry limit reached"));
                        }
                        return;
                    }
                    let timeout = options.interval * parseInt(String(Math.random() * Math.pow(2, attempt)));
                    if (timeout < options.floor) {
                        timeout = options.floor;
                    }
                    if (timeout > options.ceiling) {
                        timeout = options.ceiling;
                    }
                    setTimeout(check, timeout);
                }
                return null;
            }, function (error) {
                if (cancel()) {
                    reject(error);
                }
            });
        }
        check();
    });
}
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+providers@5.7.2_bufferutil@4.0.7_utf-8-validate@5.0.10/node_modules/@ethersproject/providers/lib.esm/_version.js
const providers_lib_esm_version_version = "providers/5.7.2";
//# sourceMappingURL=_version.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+abstract-provider@5.7.0/node_modules/@ethersproject/abstract-provider/lib.esm/_version.js
const abstract_provider_lib_esm_version_version = "abstract-provider/5.7.0";
//# sourceMappingURL=_version.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+abstract-provider@5.7.0/node_modules/@ethersproject/abstract-provider/lib.esm/index.js

var abstract_provider_lib_esm_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};





const abstract_provider_lib_esm_logger = new lib_esm_Logger(abstract_provider_lib_esm_version_version);
;
;
//export type CallTransactionable = {
//    call(transaction: TransactionRequest): Promise<TransactionResponse>;
//};
class ForkEvent extends Description {
    static isForkEvent(value) {
        return !!(value && value._isForkEvent);
    }
}
class BlockForkEvent extends (/* unused pure expression or super */ null && (ForkEvent)) {
    constructor(blockHash, expiry) {
        if (!isHexString(blockHash, 32)) {
            abstract_provider_lib_esm_logger.throwArgumentError("invalid blockHash", "blockHash", blockHash);
        }
        super({
            _isForkEvent: true,
            _isBlockForkEvent: true,
            expiry: (expiry || 0),
            blockHash: blockHash
        });
    }
}
class TransactionForkEvent extends (/* unused pure expression or super */ null && (ForkEvent)) {
    constructor(hash, expiry) {
        if (!isHexString(hash, 32)) {
            abstract_provider_lib_esm_logger.throwArgumentError("invalid transaction hash", "hash", hash);
        }
        super({
            _isForkEvent: true,
            _isTransactionForkEvent: true,
            expiry: (expiry || 0),
            hash: hash
        });
    }
}
class TransactionOrderForkEvent extends (/* unused pure expression or super */ null && (ForkEvent)) {
    constructor(beforeHash, afterHash, expiry) {
        if (!isHexString(beforeHash, 32)) {
            abstract_provider_lib_esm_logger.throwArgumentError("invalid transaction hash", "beforeHash", beforeHash);
        }
        if (!isHexString(afterHash, 32)) {
            abstract_provider_lib_esm_logger.throwArgumentError("invalid transaction hash", "afterHash", afterHash);
        }
        super({
            _isForkEvent: true,
            _isTransactionOrderForkEvent: true,
            expiry: (expiry || 0),
            beforeHash: beforeHash,
            afterHash: afterHash
        });
    }
}
///////////////////////////////
// Exported Abstracts
class Provider {
    constructor() {
        abstract_provider_lib_esm_logger.checkAbstract(new.target, Provider);
        lib_esm_defineReadOnly(this, "_isProvider", true);
    }
    getFeeData() {
        return abstract_provider_lib_esm_awaiter(this, void 0, void 0, function* () {
            const { block, gasPrice } = yield resolveProperties({
                block: this.getBlock("latest"),
                gasPrice: this.getGasPrice().catch((error) => {
                    // @TODO: Why is this now failing on Calaveras?
                    //console.log(error);
                    return null;
                })
            });
            let lastBaseFeePerGas = null, maxFeePerGas = null, maxPriorityFeePerGas = null;
            if (block && block.baseFeePerGas) {
                // We may want to compute this more accurately in the future,
                // using the formula "check if the base fee is correct".
                // See: https://eips.ethereum.org/EIPS/eip-1559
                lastBaseFeePerGas = block.baseFeePerGas;
                maxPriorityFeePerGas = bignumber_BigNumber.from("1500000000");
                maxFeePerGas = block.baseFeePerGas.mul(2).add(maxPriorityFeePerGas);
            }
            return { lastBaseFeePerGas, maxFeePerGas, maxPriorityFeePerGas, gasPrice };
        });
    }
    // Alias for "on"
    addListener(eventName, listener) {
        return this.on(eventName, listener);
    }
    // Alias for "off"
    removeListener(eventName, listener) {
        return this.off(eventName, listener);
    }
    static isProvider(value) {
        return !!(value && value._isProvider);
    }
}
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+basex@5.7.0/node_modules/@ethersproject/basex/lib.esm/index.js
/**
 * var basex = require("base-x");
 *
 * This implementation is heavily based on base-x. The main reason to
 * deviate was to prevent the dependency of Buffer.
 *
 * Contributors:
 *
 * base-x encoding
 * Forked from https://github.com/cryptocoinjs/bs58
 * Originally written by Mike Hearn for BitcoinJ
 * Copyright (c) 2011 Google Inc
 * Ported to JavaScript by Stefan Thomas
 * Merged Buffer refactorings from base58-native by Stephen Pair
 * Copyright (c) 2013 BitPay Inc
 *
 * The MIT License (MIT)
 *
 * Copyright base-x contributors (c) 2016
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the "Software"),
 * to deal in the Software without restriction, including without limitation
 * the rights to use, copy, modify, merge, publish, distribute, sublicense,
 * and/or sell copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
 * IN THE SOFTWARE.
 *
 */


class BaseX {
    constructor(alphabet) {
        lib_esm_defineReadOnly(this, "alphabet", alphabet);
        lib_esm_defineReadOnly(this, "base", alphabet.length);
        lib_esm_defineReadOnly(this, "_alphabetMap", {});
        lib_esm_defineReadOnly(this, "_leader", alphabet.charAt(0));
        // pre-compute lookup table
        for (let i = 0; i < alphabet.length; i++) {
            this._alphabetMap[alphabet.charAt(i)] = i;
        }
    }
    encode(value) {
        let source = lib_esm_arrayify(value);
        if (source.length === 0) {
            return "";
        }
        let digits = [0];
        for (let i = 0; i < source.length; ++i) {
            let carry = source[i];
            for (let j = 0; j < digits.length; ++j) {
                carry += digits[j] << 8;
                digits[j] = carry % this.base;
                carry = (carry / this.base) | 0;
            }
            while (carry > 0) {
                digits.push(carry % this.base);
                carry = (carry / this.base) | 0;
            }
        }
        let string = "";
        // deal with leading zeros
        for (let k = 0; source[k] === 0 && k < source.length - 1; ++k) {
            string += this._leader;
        }
        // convert digits to a string
        for (let q = digits.length - 1; q >= 0; --q) {
            string += this.alphabet[digits[q]];
        }
        return string;
    }
    decode(value) {
        if (typeof (value) !== "string") {
            throw new TypeError("Expected String");
        }
        let bytes = [];
        if (value.length === 0) {
            return new Uint8Array(bytes);
        }
        bytes.push(0);
        for (let i = 0; i < value.length; i++) {
            let byte = this._alphabetMap[value[i]];
            if (byte === undefined) {
                throw new Error("Non-base" + this.base + " character");
            }
            let carry = byte;
            for (let j = 0; j < bytes.length; ++j) {
                carry += bytes[j] * this.base;
                bytes[j] = carry & 0xff;
                carry >>= 8;
            }
            while (carry > 0) {
                bytes.push(carry & 0xff);
                carry >>= 8;
            }
        }
        // deal with leading zeros
        for (let k = 0; value[k] === this._leader && k < value.length - 1; ++k) {
            bytes.push(0);
        }
        return lib_esm_arrayify(new Uint8Array(bytes.reverse()));
    }
}
const Base32 = new BaseX("abcdefghijklmnopqrstuvwxyz234567");
const Base58 = new BaseX("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz");

//console.log(Base58.decode("Qmd2V777o5XvJbYMeMb8k2nU5f8d3ciUQ5YpYuWhzv8iDj"))
//console.log(Base58.encode(Base58.decode("Qmd2V777o5XvJbYMeMb8k2nU5f8d3ciUQ5YpYuWhzv8iDj")))
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+constants@5.7.0/node_modules/@ethersproject/constants/lib.esm/hashes.js
const HashZero = "0x0000000000000000000000000000000000000000000000000000000000000000";
//# sourceMappingURL=hashes.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+hash@5.7.0/node_modules/@ethersproject/hash/lib.esm/ens-normalize/decoder.js
/**
 * MIT License
 *
 * Copyright (c) 2021 Andrew Raffensperger
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 * This is a near carbon-copy of the original source (link below) with the
 * TypeScript typings added and a few tweaks to make it ES3-compatible.
 *
 * See: https://github.com/adraffy/ens-normalize.js
 */
// https://github.com/behnammodi/polyfill/blob/master/array.polyfill.js
function flat(array, depth) {
    if (depth == null) {
        depth = 1;
    }
    const result = [];
    const forEach = result.forEach;
    const flatDeep = function (arr, depth) {
        forEach.call(arr, function (val) {
            if (depth > 0 && Array.isArray(val)) {
                flatDeep(val, depth - 1);
            }
            else {
                result.push(val);
            }
        });
    };
    flatDeep(array, depth);
    return result;
}
function fromEntries(array) {
    const result = {};
    for (let i = 0; i < array.length; i++) {
        const value = array[i];
        result[value[0]] = value[1];
    }
    return result;
}
function decode_arithmetic(bytes) {
    let pos = 0;
    function u16() { return (bytes[pos++] << 8) | bytes[pos++]; }
    // decode the frequency table
    let symbol_count = u16();
    let total = 1;
    let acc = [0, 1]; // first symbol has frequency 1
    for (let i = 1; i < symbol_count; i++) {
        acc.push(total += u16());
    }
    // skip the sized-payload that the last 3 symbols index into
    let skip = u16();
    let pos_payload = pos;
    pos += skip;
    let read_width = 0;
    let read_buffer = 0;
    function read_bit() {
        if (read_width == 0) {
            // this will read beyond end of buffer
            // but (undefined|0) => zero pad
            read_buffer = (read_buffer << 8) | bytes[pos++];
            read_width = 8;
        }
        return (read_buffer >> --read_width) & 1;
    }
    const N = 31;
    const FULL = Math.pow(2, N);
    const HALF = FULL >>> 1;
    const QRTR = HALF >> 1;
    const MASK = FULL - 1;
    // fill register
    let register = 0;
    for (let i = 0; i < N; i++)
        register = (register << 1) | read_bit();
    let symbols = [];
    let low = 0;
    let range = FULL; // treat like a float
    while (true) {
        let value = Math.floor((((register - low + 1) * total) - 1) / range);
        let start = 0;
        let end = symbol_count;
        while (end - start > 1) { // binary search
            let mid = (start + end) >>> 1;
            if (value < acc[mid]) {
                end = mid;
            }
            else {
                start = mid;
            }
        }
        if (start == 0)
            break; // first symbol is end mark
        symbols.push(start);
        let a = low + Math.floor(range * acc[start] / total);
        let b = low + Math.floor(range * acc[start + 1] / total) - 1;
        while (((a ^ b) & HALF) == 0) {
            register = (register << 1) & MASK | read_bit();
            a = (a << 1) & MASK;
            b = (b << 1) & MASK | 1;
        }
        while (a & ~b & QRTR) {
            register = (register & HALF) | ((register << 1) & (MASK >>> 1)) | read_bit();
            a = (a << 1) ^ HALF;
            b = ((b ^ HALF) << 1) | HALF | 1;
        }
        low = a;
        range = 1 + b - a;
    }
    let offset = symbol_count - 4;
    return symbols.map(x => {
        switch (x - offset) {
            case 3: return offset + 0x10100 + ((bytes[pos_payload++] << 16) | (bytes[pos_payload++] << 8) | bytes[pos_payload++]);
            case 2: return offset + 0x100 + ((bytes[pos_payload++] << 8) | bytes[pos_payload++]);
            case 1: return offset + bytes[pos_payload++];
            default: return x - 1;
        }
    });
}
// returns an iterator which returns the next symbol
function read_payload(v) {
    let pos = 0;
    return () => v[pos++];
}
function read_compressed_payload(bytes) {
    return read_payload(decode_arithmetic(bytes));
}
// eg. [0,1,2,3...] => [0,-1,1,-2,...]
function signed(i) {
    return (i & 1) ? (~i >> 1) : (i >> 1);
}
function read_counts(n, next) {
    let v = Array(n);
    for (let i = 0; i < n; i++)
        v[i] = 1 + next();
    return v;
}
function read_ascending(n, next) {
    let v = Array(n);
    for (let i = 0, x = -1; i < n; i++)
        v[i] = x += 1 + next();
    return v;
}
function read_deltas(n, next) {
    let v = Array(n);
    for (let i = 0, x = 0; i < n; i++)
        v[i] = x += signed(next());
    return v;
}
function read_member_array(next, lookup) {
    let v = read_ascending(next(), next);
    let n = next();
    let vX = read_ascending(n, next);
    let vN = read_counts(n, next);
    for (let i = 0; i < n; i++) {
        for (let j = 0; j < vN[i]; j++) {
            v.push(vX[i] + j);
        }
    }
    return lookup ? v.map(x => lookup[x]) : v;
}
// returns array of 
// [x, ys] => single replacement rule
// [x, ys, n, dx, dx] => linear map
function read_mapped_map(next) {
    let ret = [];
    while (true) {
        let w = next();
        if (w == 0)
            break;
        ret.push(read_linear_table(w, next));
    }
    while (true) {
        let w = next() - 1;
        if (w < 0)
            break;
        ret.push(read_replacement_table(w, next));
    }
    return fromEntries(flat(ret));
}
function read_zero_terminated_array(next) {
    let v = [];
    while (true) {
        let i = next();
        if (i == 0)
            break;
        v.push(i);
    }
    return v;
}
function read_transposed(n, w, next) {
    let m = Array(n).fill(undefined).map(() => []);
    for (let i = 0; i < w; i++) {
        read_deltas(n, next).forEach((x, j) => m[j].push(x));
    }
    return m;
}
function read_linear_table(w, next) {
    let dx = 1 + next();
    let dy = next();
    let vN = read_zero_terminated_array(next);
    let m = read_transposed(vN.length, 1 + w, next);
    return flat(m.map((v, i) => {
        const x = v[0], ys = v.slice(1);
        //let [x, ...ys] = v;
        //return Array(vN[i]).fill().map((_, j) => {
        return Array(vN[i]).fill(undefined).map((_, j) => {
            let j_dy = j * dy;
            return [x + j * dx, ys.map(y => y + j_dy)];
        });
    }));
}
function read_replacement_table(w, next) {
    let n = 1 + next();
    let m = read_transposed(n, 1 + w, next);
    return m.map(v => [v[0], v.slice(1)]);
}
function read_emoji_trie(next) {
    let sorted = read_member_array(next).sort((a, b) => a - b);
    return read();
    function read() {
        let branches = [];
        while (true) {
            let keys = read_member_array(next, sorted);
            if (keys.length == 0)
                break;
            branches.push({ set: new Set(keys), node: read() });
        }
        branches.sort((a, b) => b.set.size - a.set.size); // sort by likelihood
        let temp = next();
        let valid = temp % 3;
        temp = (temp / 3) | 0;
        let fe0f = !!(temp & 1);
        temp >>= 1;
        let save = temp == 1;
        let check = temp == 2;
        return { branches, valid, fe0f, save, check };
    }
}
//# sourceMappingURL=decoder.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+hash@5.7.0/node_modules/@ethersproject/hash/lib.esm/ens-normalize/include.js
/**
 * MIT License
 *
 * Copyright (c) 2021 Andrew Raffensperger
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 * This is a near carbon-copy of the original source (link below) with the
 * TypeScript typings added and a few tweaks to make it ES3-compatible.
 *
 * See: https://github.com/adraffy/ens-normalize.js
 */


function getData() {
    return read_compressed_payload(base64_decode('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'));
}
//# sourceMappingURL=include.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+hash@5.7.0/node_modules/@ethersproject/hash/lib.esm/ens-normalize/lib.js
/**
 * MIT License
 *
 * Copyright (c) 2021 Andrew Raffensperger
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 * This is a near carbon-copy of the original source (link below) with the
 * TypeScript typings added and a few tweaks to make it ES3-compatible.
 *
 * See: https://github.com/adraffy/ens-normalize.js
 */


const r = getData();

// @TODO: This should be lazily loaded
const VALID = new Set(read_member_array(r));
const IGNORED = new Set(read_member_array(r));
const MAPPED = read_mapped_map(r);
const EMOJI_ROOT = read_emoji_trie(r);
//const NFC_CHECK = new Set(read_member_array(r, Array.from(VALID.values()).sort((a, b) => a - b)));
//const STOP = 0x2E;
const HYPHEN = 0x2D;
const UNDERSCORE = 0x5F;
function explode_cp(name) {
    return toUtf8CodePoints(name);
}
function filter_fe0f(cps) {
    return cps.filter(cp => cp != 0xFE0F);
}
function ens_normalize_post_check(name) {
    for (let label of name.split('.')) {
        let cps = explode_cp(label);
        try {
            for (let i = cps.lastIndexOf(UNDERSCORE) - 1; i >= 0; i--) {
                if (cps[i] !== UNDERSCORE) {
                    throw new Error(`underscore only allowed at start`);
                }
            }
            if (cps.length >= 4 && cps.every(cp => cp < 0x80) && cps[2] === HYPHEN && cps[3] === HYPHEN) {
                throw new Error(`invalid label extension`);
            }
        }
        catch (err) {
            throw new Error(`Invalid label "${label}": ${err.message}`);
        }
    }
    return name;
}
function ens_normalize(name) {
    return ens_normalize_post_check(normalize(name, filter_fe0f));
}
function normalize(name, emoji_filter) {
    let input = explode_cp(name).reverse(); // flip for pop
    let output = [];
    while (input.length) {
        let emoji = consume_emoji_reversed(input);
        if (emoji) {
            output.push(...emoji_filter(emoji));
            continue;
        }
        let cp = input.pop();
        if (VALID.has(cp)) {
            output.push(cp);
            continue;
        }
        if (IGNORED.has(cp)) {
            continue;
        }
        let cps = MAPPED[cp];
        if (cps) {
            output.push(...cps);
            continue;
        }
        throw new Error(`Disallowed codepoint: 0x${cp.toString(16).toUpperCase()}`);
    }
    return ens_normalize_post_check(nfc(String.fromCodePoint(...output)));
}
function nfc(s) {
    return s.normalize('NFC');
}
function consume_emoji_reversed(cps, eaten) {
    var _a;
    let node = EMOJI_ROOT;
    let emoji;
    let saved;
    let stack = [];
    let pos = cps.length;
    if (eaten)
        eaten.length = 0; // clear input buffer (if needed)
    while (pos) {
        let cp = cps[--pos];
        node = (_a = node.branches.find(x => x.set.has(cp))) === null || _a === void 0 ? void 0 : _a.node;
        if (!node)
            break;
        if (node.save) { // remember
            saved = cp;
        }
        else if (node.check) { // check exclusion
            if (cp === saved)
                break;
        }
        stack.push(cp);
        if (node.fe0f) {
            stack.push(0xFE0F);
            if (pos > 0 && cps[pos - 1] == 0xFE0F)
                pos--; // consume optional FE0F
        }
        if (node.valid) { // this is a valid emoji (so far)
            emoji = stack.slice(); // copy stack
            if (node.valid == 2)
                emoji.splice(1, 1); // delete FE0F at position 1 (RGI ZWJ don't follow spec!)
            if (eaten)
                eaten.push(...cps.slice(pos).reverse()); // copy input (if needed)
            cps.length = pos; // truncate
        }
    }
    return emoji;
}
//# sourceMappingURL=lib.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+hash@5.7.0/node_modules/@ethersproject/hash/lib.esm/namehash.js





const namehash_logger = new lib_esm_Logger(hash_lib_esm_version_version);

const Zeros = new Uint8Array(32);
Zeros.fill(0);
function checkComponent(comp) {
    if (comp.length === 0) {
        throw new Error("invalid ENS name; empty component");
    }
    return comp;
}
function ensNameSplit(name) {
    const bytes = toUtf8Bytes(ens_normalize(name));
    const comps = [];
    if (name.length === 0) {
        return comps;
    }
    let last = 0;
    for (let i = 0; i < bytes.length; i++) {
        const d = bytes[i];
        // A separator (i.e. "."); copy this component
        if (d === 0x2e) {
            comps.push(checkComponent(bytes.slice(last, i)));
            last = i + 1;
        }
    }
    // There was a stray separator at the end of the name
    if (last >= bytes.length) {
        throw new Error("invalid ENS name; empty component");
    }
    comps.push(checkComponent(bytes.slice(last)));
    return comps;
}
function ensNormalize(name) {
    return ensNameSplit(name).map((comp) => toUtf8String(comp)).join(".");
}
function isValidName(name) {
    try {
        return (ensNameSplit(name).length !== 0);
    }
    catch (error) { }
    return false;
}
function namehash(name) {
    /* istanbul ignore if */
    if (typeof (name) !== "string") {
        namehash_logger.throwArgumentError("invalid ENS name; not a string", "name", name);
    }
    let result = Zeros;
    const comps = ensNameSplit(name);
    while (comps.length) {
        result = lib_esm_keccak256(lib_esm_concat([result, lib_esm_keccak256(comps.pop())]));
    }
    return lib_esm_hexlify(result);
}
function dnsEncode(name) {
    return lib_esm_hexlify(lib_esm_concat(ensNameSplit(name).map((comp) => {
        // DNS does not allow components over 63 bytes in length
        if (comp.length > 63) {
            throw new Error("invalid DNS encoded entry; length exceeds 63 bytes");
        }
        const bytes = new Uint8Array(comp.length + 1);
        bytes.set(comp, 1);
        bytes[0] = bytes.length - 1;
        return bytes;
    }))) + "00";
}
//# sourceMappingURL=namehash.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+networks@5.7.1/node_modules/@ethersproject/networks/lib.esm/_version.js
const networks_lib_esm_version_version = "networks/5.7.1";
//# sourceMappingURL=_version.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+networks@5.7.1/node_modules/@ethersproject/networks/lib.esm/index.js



const networks_lib_esm_logger = new lib_esm_Logger(networks_lib_esm_version_version);
;
function isRenetworkable(value) {
    return (value && typeof (value.renetwork) === "function");
}
function ethDefaultProvider(network) {
    const func = function (providers, options) {
        if (options == null) {
            options = {};
        }
        const providerList = [];
        if (providers.InfuraProvider && options.infura !== "-") {
            try {
                providerList.push(new providers.InfuraProvider(network, options.infura));
            }
            catch (error) { }
        }
        if (providers.EtherscanProvider && options.etherscan !== "-") {
            try {
                providerList.push(new providers.EtherscanProvider(network, options.etherscan));
            }
            catch (error) { }
        }
        if (providers.AlchemyProvider && options.alchemy !== "-") {
            try {
                providerList.push(new providers.AlchemyProvider(network, options.alchemy));
            }
            catch (error) { }
        }
        if (providers.PocketProvider && options.pocket !== "-") {
            // These networks are currently faulty on Pocket as their
            // network does not handle the Berlin hardfork, which is
            // live on these ones.
            // @TODO: This goes away once Pocket has upgraded their nodes
            const skip = ["goerli", "ropsten", "rinkeby", "sepolia"];
            try {
                const provider = new providers.PocketProvider(network, options.pocket);
                if (provider.network && skip.indexOf(provider.network.name) === -1) {
                    providerList.push(provider);
                }
            }
            catch (error) { }
        }
        if (providers.CloudflareProvider && options.cloudflare !== "-") {
            try {
                providerList.push(new providers.CloudflareProvider(network));
            }
            catch (error) { }
        }
        if (providers.AnkrProvider && options.ankr !== "-") {
            try {
                const skip = ["ropsten"];
                const provider = new providers.AnkrProvider(network, options.ankr);
                if (provider.network && skip.indexOf(provider.network.name) === -1) {
                    providerList.push(provider);
                }
            }
            catch (error) { }
        }
        if (providerList.length === 0) {
            return null;
        }
        if (providers.FallbackProvider) {
            let quorum = 1;
            if (options.quorum != null) {
                quorum = options.quorum;
            }
            else if (network === "homestead") {
                quorum = 2;
            }
            return new providers.FallbackProvider(providerList, quorum);
        }
        return providerList[0];
    };
    func.renetwork = function (network) {
        return ethDefaultProvider(network);
    };
    return func;
}
function etcDefaultProvider(url, network) {
    const func = function (providers, options) {
        if (providers.JsonRpcProvider) {
            return new providers.JsonRpcProvider(url, network);
        }
        return null;
    };
    func.renetwork = function (network) {
        return etcDefaultProvider(url, network);
    };
    return func;
}
const homestead = {
    chainId: 1,
    ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
    name: "homestead",
    _defaultProvider: ethDefaultProvider("homestead")
};
const ropsten = {
    chainId: 3,
    ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
    name: "ropsten",
    _defaultProvider: ethDefaultProvider("ropsten")
};
const classicMordor = {
    chainId: 63,
    name: "classicMordor",
    _defaultProvider: etcDefaultProvider("https://www.ethercluster.com/mordor", "classicMordor")
};
// See: https://chainlist.org
const networks = {
    unspecified: { chainId: 0, name: "unspecified" },
    homestead: homestead,
    mainnet: homestead,
    morden: { chainId: 2, name: "morden" },
    ropsten: ropsten,
    testnet: ropsten,
    rinkeby: {
        chainId: 4,
        ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
        name: "rinkeby",
        _defaultProvider: ethDefaultProvider("rinkeby")
    },
    kovan: {
        chainId: 42,
        name: "kovan",
        _defaultProvider: ethDefaultProvider("kovan")
    },
    goerli: {
        chainId: 5,
        ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
        name: "goerli",
        _defaultProvider: ethDefaultProvider("goerli")
    },
    kintsugi: { chainId: 1337702, name: "kintsugi" },
    sepolia: {
        chainId: 11155111,
        name: "sepolia",
        _defaultProvider: ethDefaultProvider("sepolia")
    },
    // ETC (See: #351)
    classic: {
        chainId: 61,
        name: "classic",
        _defaultProvider: etcDefaultProvider("https:/\/www.ethercluster.com/etc", "classic")
    },
    classicMorden: { chainId: 62, name: "classicMorden" },
    classicMordor: classicMordor,
    classicTestnet: classicMordor,
    classicKotti: {
        chainId: 6,
        name: "classicKotti",
        _defaultProvider: etcDefaultProvider("https:/\/www.ethercluster.com/kotti", "classicKotti")
    },
    xdai: { chainId: 100, name: "xdai" },
    matic: {
        chainId: 137,
        name: "matic",
        _defaultProvider: ethDefaultProvider("matic")
    },
    maticmum: { chainId: 80001, name: "maticmum" },
    optimism: {
        chainId: 10,
        name: "optimism",
        _defaultProvider: ethDefaultProvider("optimism")
    },
    "optimism-kovan": { chainId: 69, name: "optimism-kovan" },
    "optimism-goerli": { chainId: 420, name: "optimism-goerli" },
    arbitrum: { chainId: 42161, name: "arbitrum" },
    "arbitrum-rinkeby": { chainId: 421611, name: "arbitrum-rinkeby" },
    "arbitrum-goerli": { chainId: 421613, name: "arbitrum-goerli" },
    bnb: { chainId: 56, name: "bnb" },
    bnbt: { chainId: 97, name: "bnbt" },
};
/**
 *  getNetwork
 *
 *  Converts a named common networks or chain ID (network ID) to a Network
 *  and verifies a network is a valid Network..
 */
function getNetwork(network) {
    // No network (null)
    if (network == null) {
        return null;
    }
    if (typeof (network) === "number") {
        for (const name in networks) {
            const standard = networks[name];
            if (standard.chainId === network) {
                return {
                    name: standard.name,
                    chainId: standard.chainId,
                    ensAddress: (standard.ensAddress || null),
                    _defaultProvider: (standard._defaultProvider || null)
                };
            }
        }
        return {
            chainId: network,
            name: "unknown"
        };
    }
    if (typeof (network) === "string") {
        const standard = networks[network];
        if (standard == null) {
            return null;
        }
        return {
            name: standard.name,
            chainId: standard.chainId,
            ensAddress: standard.ensAddress,
            _defaultProvider: (standard._defaultProvider || null)
        };
    }
    const standard = networks[network.name];
    // Not a standard network; check that it is a valid network in general
    if (!standard) {
        if (typeof (network.chainId) !== "number") {
            networks_lib_esm_logger.throwArgumentError("invalid network chainId", "network", network);
        }
        return network;
    }
    // Make sure the chainId matches the expected network chainId (or is 0; disable EIP-155)
    if (network.chainId !== 0 && network.chainId !== standard.chainId) {
        networks_lib_esm_logger.throwArgumentError("network chainId mismatch", "network", network);
    }
    // @TODO: In the next major version add an attach function to a defaultProvider
    // class and move the _defaultProvider internal to this file (extend Network)
    let defaultProvider = network._defaultProvider || null;
    if (defaultProvider == null && standard._defaultProvider) {
        if (isRenetworkable(standard._defaultProvider)) {
            defaultProvider = standard._defaultProvider.renetwork(network);
        }
        else {
            defaultProvider = standard._defaultProvider;
        }
    }
    // Standard Network (allow overriding the ENS address)
    return {
        name: network.name,
        chainId: standard.chainId,
        ensAddress: (network.ensAddress || standard.ensAddress || null),
        _defaultProvider: defaultProvider
    };
}
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+sha2@5.7.0/node_modules/@ethersproject/sha2/lib.esm/types.js
var SupportedAlgorithm;
(function (SupportedAlgorithm) {
    SupportedAlgorithm["sha256"] = "sha256";
    SupportedAlgorithm["sha512"] = "sha512";
})(SupportedAlgorithm || (SupportedAlgorithm = {}));
;
//# sourceMappingURL=types.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+sha2@5.7.0/node_modules/@ethersproject/sha2/lib.esm/_version.js
const sha2_lib_esm_version_version = "sha2/5.7.0";
//# sourceMappingURL=_version.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+sha2@5.7.0/node_modules/@ethersproject/sha2/lib.esm/sha2.js


//const _ripemd160 = _hash.ripemd160;




const sha2_logger = new lib_esm_Logger(sha2_lib_esm_version_version);
function ripemd160(data) {
    return "0x" + (hash_default().ripemd160().update(lib_esm_arrayify(data)).digest("hex"));
}
function sha256(data) {
    return "0x" + (hash_default().sha256().update(lib_esm_arrayify(data)).digest("hex"));
}
function sha512(data) {
    return "0x" + (hash.sha512().update(arrayify(data)).digest("hex"));
}
function computeHmac(algorithm, key, data) {
    if (!SupportedAlgorithm[algorithm]) {
        sha2_logger.throwError("unsupported algorithm " + algorithm, lib_esm_Logger.errors.UNSUPPORTED_OPERATION, {
            operation: "hmac",
            algorithm: algorithm
        });
    }
    return "0x" + hash_default().hmac((hash_default())[algorithm], lib_esm_arrayify(key)).update(lib_esm_arrayify(data)).digest("hex");
}
//# sourceMappingURL=sha2.js.map
// EXTERNAL MODULE: ./node_modules/.pnpm/bech32@1.1.4/node_modules/bech32/index.js
var bech32 = __webpack_require__(203);
var bech32_default = /*#__PURE__*/__webpack_require__.n(bech32);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+constants@5.7.0/node_modules/@ethersproject/constants/lib.esm/addresses.js
const AddressZero = "0x0000000000000000000000000000000000000000";
//# sourceMappingURL=addresses.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+providers@5.7.2_bufferutil@4.0.7_utf-8-validate@5.0.10/node_modules/@ethersproject/providers/lib.esm/formatter.js









const formatter_logger = new lib_esm_Logger(providers_lib_esm_version_version);
class Formatter {
    constructor() {
        this.formats = this.getDefaultFormats();
    }
    getDefaultFormats() {
        const formats = ({});
        const address = this.address.bind(this);
        const bigNumber = this.bigNumber.bind(this);
        const blockTag = this.blockTag.bind(this);
        const data = this.data.bind(this);
        const hash = this.hash.bind(this);
        const hex = this.hex.bind(this);
        const number = this.number.bind(this);
        const type = this.type.bind(this);
        const strictData = (v) => { return this.data(v, true); };
        formats.transaction = {
            hash: hash,
            type: type,
            accessList: Formatter.allowNull(this.accessList.bind(this), null),
            blockHash: Formatter.allowNull(hash, null),
            blockNumber: Formatter.allowNull(number, null),
            transactionIndex: Formatter.allowNull(number, null),
            confirmations: Formatter.allowNull(number, null),
            from: address,
            // either (gasPrice) or (maxPriorityFeePerGas + maxFeePerGas)
            // must be set
            gasPrice: Formatter.allowNull(bigNumber),
            maxPriorityFeePerGas: Formatter.allowNull(bigNumber),
            maxFeePerGas: Formatter.allowNull(bigNumber),
            gasLimit: bigNumber,
            to: Formatter.allowNull(address, null),
            value: bigNumber,
            nonce: number,
            data: data,
            r: Formatter.allowNull(this.uint256),
            s: Formatter.allowNull(this.uint256),
            v: Formatter.allowNull(number),
            creates: Formatter.allowNull(address, null),
            raw: Formatter.allowNull(data),
        };
        formats.transactionRequest = {
            from: Formatter.allowNull(address),
            nonce: Formatter.allowNull(number),
            gasLimit: Formatter.allowNull(bigNumber),
            gasPrice: Formatter.allowNull(bigNumber),
            maxPriorityFeePerGas: Formatter.allowNull(bigNumber),
            maxFeePerGas: Formatter.allowNull(bigNumber),
            to: Formatter.allowNull(address),
            value: Formatter.allowNull(bigNumber),
            data: Formatter.allowNull(strictData),
            type: Formatter.allowNull(number),
            accessList: Formatter.allowNull(this.accessList.bind(this), null),
        };
        formats.receiptLog = {
            transactionIndex: number,
            blockNumber: number,
            transactionHash: hash,
            address: address,
            topics: Formatter.arrayOf(hash),
            data: data,
            logIndex: number,
            blockHash: hash,
        };
        formats.receipt = {
            to: Formatter.allowNull(this.address, null),
            from: Formatter.allowNull(this.address, null),
            contractAddress: Formatter.allowNull(address, null),
            transactionIndex: number,
            // should be allowNull(hash), but broken-EIP-658 support is handled in receipt
            root: Formatter.allowNull(hex),
            gasUsed: bigNumber,
            logsBloom: Formatter.allowNull(data),
            blockHash: hash,
            transactionHash: hash,
            logs: Formatter.arrayOf(this.receiptLog.bind(this)),
            blockNumber: number,
            confirmations: Formatter.allowNull(number, null),
            cumulativeGasUsed: bigNumber,
            effectiveGasPrice: Formatter.allowNull(bigNumber),
            status: Formatter.allowNull(number),
            type: type
        };
        formats.block = {
            hash: Formatter.allowNull(hash),
            parentHash: hash,
            number: number,
            timestamp: number,
            nonce: Formatter.allowNull(hex),
            difficulty: this.difficulty.bind(this),
            gasLimit: bigNumber,
            gasUsed: bigNumber,
            miner: Formatter.allowNull(address),
            extraData: data,
            transactions: Formatter.allowNull(Formatter.arrayOf(hash)),
            baseFeePerGas: Formatter.allowNull(bigNumber)
        };
        formats.blockWithTransactions = lib_esm_shallowCopy(formats.block);
        formats.blockWithTransactions.transactions = Formatter.allowNull(Formatter.arrayOf(this.transactionResponse.bind(this)));
        formats.filter = {
            fromBlock: Formatter.allowNull(blockTag, undefined),
            toBlock: Formatter.allowNull(blockTag, undefined),
            blockHash: Formatter.allowNull(hash, undefined),
            address: Formatter.allowNull(address, undefined),
            topics: Formatter.allowNull(this.topics.bind(this), undefined),
        };
        formats.filterLog = {
            blockNumber: Formatter.allowNull(number),
            blockHash: Formatter.allowNull(hash),
            transactionIndex: number,
            removed: Formatter.allowNull(this.boolean.bind(this)),
            address: address,
            data: Formatter.allowFalsish(data, "0x"),
            topics: Formatter.arrayOf(hash),
            transactionHash: hash,
            logIndex: number,
        };
        return formats;
    }
    accessList(accessList) {
        return accessListify(accessList || []);
    }
    // Requires a BigNumberish that is within the IEEE754 safe integer range; returns a number
    // Strict! Used on input.
    number(number) {
        if (number === "0x") {
            return 0;
        }
        return bignumber_BigNumber.from(number).toNumber();
    }
    type(number) {
        if (number === "0x" || number == null) {
            return 0;
        }
        return bignumber_BigNumber.from(number).toNumber();
    }
    // Strict! Used on input.
    bigNumber(value) {
        return bignumber_BigNumber.from(value);
    }
    // Requires a boolean, "true" or  "false"; returns a boolean
    boolean(value) {
        if (typeof (value) === "boolean") {
            return value;
        }
        if (typeof (value) === "string") {
            value = value.toLowerCase();
            if (value === "true") {
                return true;
            }
            if (value === "false") {
                return false;
            }
        }
        throw new Error("invalid boolean - " + value);
    }
    hex(value, strict) {
        if (typeof (value) === "string") {
            if (!strict && value.substring(0, 2) !== "0x") {
                value = "0x" + value;
            }
            if (lib_esm_isHexString(value)) {
                return value.toLowerCase();
            }
        }
        return formatter_logger.throwArgumentError("invalid hash", "value", value);
    }
    data(value, strict) {
        const result = this.hex(value, strict);
        if ((result.length % 2) !== 0) {
            throw new Error("invalid data; odd-length - " + value);
        }
        return result;
    }
    // Requires an address
    // Strict! Used on input.
    address(value) {
        return lib_esm_getAddress(value);
    }
    callAddress(value) {
        if (!lib_esm_isHexString(value, 32)) {
            return null;
        }
        const address = lib_esm_getAddress(lib_esm_hexDataSlice(value, 12));
        return (address === AddressZero) ? null : address;
    }
    contractAddress(value) {
        return lib_esm_getContractAddress(value);
    }
    // Strict! Used on input.
    blockTag(blockTag) {
        if (blockTag == null) {
            return "latest";
        }
        if (blockTag === "earliest") {
            return "0x0";
        }
        switch (blockTag) {
            case "earliest": return "0x0";
            case "latest":
            case "pending":
            case "safe":
            case "finalized":
                return blockTag;
        }
        if (typeof (blockTag) === "number" || lib_esm_isHexString(blockTag)) {
            return hexValue(blockTag);
        }
        throw new Error("invalid blockTag");
    }
    // Requires a hash, optionally requires 0x prefix; returns prefixed lowercase hash.
    hash(value, strict) {
        const result = this.hex(value, strict);
        if (lib_esm_hexDataLength(result) !== 32) {
            return formatter_logger.throwArgumentError("invalid hash", "value", value);
        }
        return result;
    }
    // Returns the difficulty as a number, or if too large (i.e. PoA network) null
    difficulty(value) {
        if (value == null) {
            return null;
        }
        const v = bignumber_BigNumber.from(value);
        try {
            return v.toNumber();
        }
        catch (error) { }
        return null;
    }
    uint256(value) {
        if (!lib_esm_isHexString(value)) {
            throw new Error("invalid uint256");
        }
        return hexZeroPad(value, 32);
    }
    _block(value, format) {
        if (value.author != null && value.miner == null) {
            value.miner = value.author;
        }
        // The difficulty may need to come from _difficulty in recursed blocks
        const difficulty = (value._difficulty != null) ? value._difficulty : value.difficulty;
        const result = Formatter.check(format, value);
        result._difficulty = ((difficulty == null) ? null : bignumber_BigNumber.from(difficulty));
        return result;
    }
    block(value) {
        return this._block(value, this.formats.block);
    }
    blockWithTransactions(value) {
        return this._block(value, this.formats.blockWithTransactions);
    }
    // Strict! Used on input.
    transactionRequest(value) {
        return Formatter.check(this.formats.transactionRequest, value);
    }
    transactionResponse(transaction) {
        // Rename gas to gasLimit
        if (transaction.gas != null && transaction.gasLimit == null) {
            transaction.gasLimit = transaction.gas;
        }
        // Some clients (TestRPC) do strange things like return 0x0 for the
        // 0 address; correct this to be a real address
        if (transaction.to && bignumber_BigNumber.from(transaction.to).isZero()) {
            transaction.to = "0x0000000000000000000000000000000000000000";
        }
        // Rename input to data
        if (transaction.input != null && transaction.data == null) {
            transaction.data = transaction.input;
        }
        // If to and creates are empty, populate the creates from the transaction
        if (transaction.to == null && transaction.creates == null) {
            transaction.creates = this.contractAddress(transaction);
        }
        if ((transaction.type === 1 || transaction.type === 2) && transaction.accessList == null) {
            transaction.accessList = [];
        }
        const result = Formatter.check(this.formats.transaction, transaction);
        if (transaction.chainId != null) {
            let chainId = transaction.chainId;
            if (lib_esm_isHexString(chainId)) {
                chainId = bignumber_BigNumber.from(chainId).toNumber();
            }
            result.chainId = chainId;
        }
        else {
            let chainId = transaction.networkId;
            // geth-etc returns chainId
            if (chainId == null && result.v == null) {
                chainId = transaction.chainId;
            }
            if (lib_esm_isHexString(chainId)) {
                chainId = bignumber_BigNumber.from(chainId).toNumber();
            }
            if (typeof (chainId) !== "number" && result.v != null) {
                chainId = (result.v - 35) / 2;
                if (chainId < 0) {
                    chainId = 0;
                }
                chainId = parseInt(chainId);
            }
            if (typeof (chainId) !== "number") {
                chainId = 0;
            }
            result.chainId = chainId;
        }
        // 0x0000... should actually be null
        if (result.blockHash && result.blockHash.replace(/0/g, "") === "x") {
            result.blockHash = null;
        }
        return result;
    }
    transaction(value) {
        return parse(value);
    }
    receiptLog(value) {
        return Formatter.check(this.formats.receiptLog, value);
    }
    receipt(value) {
        const result = Formatter.check(this.formats.receipt, value);
        // RSK incorrectly implemented EIP-658, so we munge things a bit here for it
        if (result.root != null) {
            if (result.root.length <= 4) {
                // Could be 0x00, 0x0, 0x01 or 0x1
                const value = bignumber_BigNumber.from(result.root).toNumber();
                if (value === 0 || value === 1) {
                    // Make sure if both are specified, they match
                    if (result.status != null && (result.status !== value)) {
                        formatter_logger.throwArgumentError("alt-root-status/status mismatch", "value", { root: result.root, status: result.status });
                    }
                    result.status = value;
                    delete result.root;
                }
                else {
                    formatter_logger.throwArgumentError("invalid alt-root-status", "value.root", result.root);
                }
            }
            else if (result.root.length !== 66) {
                // Must be a valid bytes32
                formatter_logger.throwArgumentError("invalid root hash", "value.root", result.root);
            }
        }
        if (result.status != null) {
            result.byzantium = true;
        }
        return result;
    }
    topics(value) {
        if (Array.isArray(value)) {
            return value.map((v) => this.topics(v));
        }
        else if (value != null) {
            return this.hash(value, true);
        }
        return null;
    }
    filter(value) {
        return Formatter.check(this.formats.filter, value);
    }
    filterLog(value) {
        return Formatter.check(this.formats.filterLog, value);
    }
    static check(format, object) {
        const result = {};
        for (const key in format) {
            try {
                const value = format[key](object[key]);
                if (value !== undefined) {
                    result[key] = value;
                }
            }
            catch (error) {
                error.checkKey = key;
                error.checkValue = object[key];
                throw error;
            }
        }
        return result;
    }
    // if value is null-ish, nullValue is returned
    static allowNull(format, nullValue) {
        return (function (value) {
            if (value == null) {
                return nullValue;
            }
            return format(value);
        });
    }
    // If value is false-ish, replaceValue is returned
    static allowFalsish(format, replaceValue) {
        return (function (value) {
            if (!value) {
                return replaceValue;
            }
            return format(value);
        });
    }
    // Requires an Array satisfying check
    static arrayOf(format) {
        return (function (array) {
            if (!Array.isArray(array)) {
                throw new Error("not an array");
            }
            const result = [];
            array.forEach(function (value) {
                result.push(format(value));
            });
            return result;
        });
    }
}
function isCommunityResourcable(value) {
    return (value && typeof (value.isCommunityResource) === "function");
}
function isCommunityResource(value) {
    return (isCommunityResourcable(value) && value.isCommunityResource());
}
// Show the throttle message only once
let throttleMessage = false;
function showThrottleMessage() {
    if (throttleMessage) {
        return;
    }
    throttleMessage = true;
    console.log("========= NOTICE =========");
    console.log("Request-Rate Exceeded  (this message will not be repeated)");
    console.log("");
    console.log("The default API keys for each service are provided as a highly-throttled,");
    console.log("community resource for low-traffic projects and early prototyping.");
    console.log("");
    console.log("While your application will continue to function, we highly recommended");
    console.log("signing up for your own API keys to improve performance, increase your");
    console.log("request rate/limit and enable other perks, such as metrics and advanced APIs.");
    console.log("");
    console.log("For more details: https:/\/docs.ethers.io/api-keys/");
    console.log("==========================");
}
//# sourceMappingURL=formatter.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+providers@5.7.2_bufferutil@4.0.7_utf-8-validate@5.0.10/node_modules/@ethersproject/providers/lib.esm/base-provider.js

var base_provider_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};















const base_provider_logger = new lib_esm_Logger(providers_lib_esm_version_version);

const MAX_CCIP_REDIRECTS = 10;
//////////////////////////////
// Event Serializeing
function checkTopic(topic) {
    if (topic == null) {
        return "null";
    }
    if (lib_esm_hexDataLength(topic) !== 32) {
        base_provider_logger.throwArgumentError("invalid topic", "topic", topic);
    }
    return topic.toLowerCase();
}
function serializeTopics(topics) {
    // Remove trailing null AND-topics; they are redundant
    topics = topics.slice();
    while (topics.length > 0 && topics[topics.length - 1] == null) {
        topics.pop();
    }
    return topics.map((topic) => {
        if (Array.isArray(topic)) {
            // Only track unique OR-topics
            const unique = {};
            topic.forEach((topic) => {
                unique[checkTopic(topic)] = true;
            });
            // The order of OR-topics does not matter
            const sorted = Object.keys(unique);
            sorted.sort();
            return sorted.join("|");
        }
        else {
            return checkTopic(topic);
        }
    }).join("&");
}
function deserializeTopics(data) {
    if (data === "") {
        return [];
    }
    return data.split(/&/g).map((topic) => {
        if (topic === "") {
            return [];
        }
        const comps = topic.split("|").map((topic) => {
            return ((topic === "null") ? null : topic);
        });
        return ((comps.length === 1) ? comps[0] : comps);
    });
}
function getEventTag(eventName) {
    if (typeof (eventName) === "string") {
        eventName = eventName.toLowerCase();
        if (lib_esm_hexDataLength(eventName) === 32) {
            return "tx:" + eventName;
        }
        if (eventName.indexOf(":") === -1) {
            return eventName;
        }
    }
    else if (Array.isArray(eventName)) {
        return "filter:*:" + serializeTopics(eventName);
    }
    else if (ForkEvent.isForkEvent(eventName)) {
        base_provider_logger.warn("not implemented");
        throw new Error("not implemented");
    }
    else if (eventName && typeof (eventName) === "object") {
        return "filter:" + (eventName.address || "*") + ":" + serializeTopics(eventName.topics || []);
    }
    throw new Error("invalid event - " + eventName);
}
//////////////////////////////
// Helper Object
function getTime() {
    return (new Date()).getTime();
}
function stall(duration) {
    return new Promise((resolve) => {
        setTimeout(resolve, duration);
    });
}
//////////////////////////////
// Provider Object
/**
 *  EventType
 *   - "block"
 *   - "poll"
 *   - "didPoll"
 *   - "pending"
 *   - "error"
 *   - "network"
 *   - filter
 *   - topics array
 *   - transaction hash
 */
const PollableEvents = ["block", "network", "pending", "poll"];
class Event {
    constructor(tag, listener, once) {
        lib_esm_defineReadOnly(this, "tag", tag);
        lib_esm_defineReadOnly(this, "listener", listener);
        lib_esm_defineReadOnly(this, "once", once);
        this._lastBlockNumber = -2;
        this._inflight = false;
    }
    get event() {
        switch (this.type) {
            case "tx":
                return this.hash;
            case "filter":
                return this.filter;
        }
        return this.tag;
    }
    get type() {
        return this.tag.split(":")[0];
    }
    get hash() {
        const comps = this.tag.split(":");
        if (comps[0] !== "tx") {
            return null;
        }
        return comps[1];
    }
    get filter() {
        const comps = this.tag.split(":");
        if (comps[0] !== "filter") {
            return null;
        }
        const address = comps[1];
        const topics = deserializeTopics(comps[2]);
        const filter = {};
        if (topics.length > 0) {
            filter.topics = topics;
        }
        if (address && address !== "*") {
            filter.address = address;
        }
        return filter;
    }
    pollable() {
        return (this.tag.indexOf(":") >= 0 || PollableEvents.indexOf(this.tag) >= 0);
    }
}
;
// https://github.com/satoshilabs/slips/blob/master/slip-0044.md
const coinInfos = {
    "0": { symbol: "btc", p2pkh: 0x00, p2sh: 0x05, prefix: "bc" },
    "2": { symbol: "ltc", p2pkh: 0x30, p2sh: 0x32, prefix: "ltc" },
    "3": { symbol: "doge", p2pkh: 0x1e, p2sh: 0x16 },
    "60": { symbol: "eth", ilk: "eth" },
    "61": { symbol: "etc", ilk: "eth" },
    "700": { symbol: "xdai", ilk: "eth" },
};
function bytes32ify(value) {
    return hexZeroPad(bignumber_BigNumber.from(value).toHexString(), 32);
}
// Compute the Base58Check encoded data (checksum is first 4 bytes of sha256d)
function base58Encode(data) {
    return Base58.encode(lib_esm_concat([data, lib_esm_hexDataSlice(sha256(sha256(data)), 0, 4)]));
}
const matcherIpfs = new RegExp("^(ipfs):/\/(.*)$", "i");
const matchers = [
    new RegExp("^(https):/\/(.*)$", "i"),
    new RegExp("^(data):(.*)$", "i"),
    matcherIpfs,
    new RegExp("^eip155:[0-9]+/(erc[0-9]+):(.*)$", "i"),
];
function _parseString(result, start) {
    try {
        return utf8_toUtf8String(_parseBytes(result, start));
    }
    catch (error) { }
    return null;
}
function _parseBytes(result, start) {
    if (result === "0x") {
        return null;
    }
    const offset = bignumber_BigNumber.from(lib_esm_hexDataSlice(result, start, start + 32)).toNumber();
    const length = bignumber_BigNumber.from(lib_esm_hexDataSlice(result, offset, offset + 32)).toNumber();
    return lib_esm_hexDataSlice(result, offset + 32, offset + 32 + length);
}
// Trim off the ipfs:// prefix and return the default gateway URL
function getIpfsLink(link) {
    if (link.match(/^ipfs:\/\/ipfs\//i)) {
        link = link.substring(12);
    }
    else if (link.match(/^ipfs:\/\//i)) {
        link = link.substring(7);
    }
    else {
        base_provider_logger.throwArgumentError("unsupported IPFS format", "link", link);
    }
    return `https:/\/gateway.ipfs.io/ipfs/${link}`;
}
function numPad(value) {
    const result = lib_esm_arrayify(value);
    if (result.length > 32) {
        throw new Error("internal; should not happen");
    }
    const padded = new Uint8Array(32);
    padded.set(result, 32 - result.length);
    return padded;
}
function bytesPad(value) {
    if ((value.length % 32) === 0) {
        return value;
    }
    const result = new Uint8Array(Math.ceil(value.length / 32) * 32);
    result.set(value);
    return result;
}
// ABI Encodes a series of (bytes, bytes, ...)
function encodeBytes(datas) {
    const result = [];
    let byteCount = 0;
    // Add place-holders for pointers as we add items
    for (let i = 0; i < datas.length; i++) {
        result.push(null);
        byteCount += 32;
    }
    for (let i = 0; i < datas.length; i++) {
        const data = lib_esm_arrayify(datas[i]);
        // Update the bytes offset
        result[i] = numPad(byteCount);
        // The length and padded value of data
        result.push(numPad(data.length));
        result.push(bytesPad(data));
        byteCount += 32 + Math.ceil(data.length / 32) * 32;
    }
    return hexConcat(result);
}
class Resolver {
    // The resolvedAddress is only for creating a ReverseLookup resolver
    constructor(provider, address, name, resolvedAddress) {
        lib_esm_defineReadOnly(this, "provider", provider);
        lib_esm_defineReadOnly(this, "name", name);
        lib_esm_defineReadOnly(this, "address", provider.formatter.address(address));
        lib_esm_defineReadOnly(this, "_resolvedAddress", resolvedAddress);
    }
    supportsWildcard() {
        if (!this._supportsEip2544) {
            // supportsInterface(bytes4 = selector("resolve(bytes,bytes)"))
            this._supportsEip2544 = this.provider.call({
                to: this.address,
                data: "0x01ffc9a79061b92300000000000000000000000000000000000000000000000000000000"
            }).then((result) => {
                return bignumber_BigNumber.from(result).eq(1);
            }).catch((error) => {
                if (error.code === lib_esm_Logger.errors.CALL_EXCEPTION) {
                    return false;
                }
                // Rethrow the error: link is down, etc. Let future attempts retry.
                this._supportsEip2544 = null;
                throw error;
            });
        }
        return this._supportsEip2544;
    }
    _fetch(selector, parameters) {
        return base_provider_awaiter(this, void 0, void 0, function* () {
            // e.g. keccak256("addr(bytes32,uint256)")
            const tx = {
                to: this.address,
                ccipReadEnabled: true,
                data: hexConcat([selector, namehash(this.name), (parameters || "0x")])
            };
            // Wildcard support; use EIP-2544 to resolve the request
            let parseBytes = false;
            if (yield this.supportsWildcard()) {
                parseBytes = true;
                // selector("resolve(bytes,bytes)")
                tx.data = hexConcat(["0x9061b923", encodeBytes([dnsEncode(this.name), tx.data])]);
            }
            try {
                let result = yield this.provider.call(tx);
                if ((lib_esm_arrayify(result).length % 32) === 4) {
                    base_provider_logger.throwError("resolver threw error", lib_esm_Logger.errors.CALL_EXCEPTION, {
                        transaction: tx, data: result
                    });
                }
                if (parseBytes) {
                    result = _parseBytes(result, 0);
                }
                return result;
            }
            catch (error) {
                if (error.code === lib_esm_Logger.errors.CALL_EXCEPTION) {
                    return null;
                }
                throw error;
            }
        });
    }
    _fetchBytes(selector, parameters) {
        return base_provider_awaiter(this, void 0, void 0, function* () {
            const result = yield this._fetch(selector, parameters);
            if (result != null) {
                return _parseBytes(result, 0);
            }
            return null;
        });
    }
    _getAddress(coinType, hexBytes) {
        const coinInfo = coinInfos[String(coinType)];
        if (coinInfo == null) {
            base_provider_logger.throwError(`unsupported coin type: ${coinType}`, lib_esm_Logger.errors.UNSUPPORTED_OPERATION, {
                operation: `getAddress(${coinType})`
            });
        }
        if (coinInfo.ilk === "eth") {
            return this.provider.formatter.address(hexBytes);
        }
        const bytes = lib_esm_arrayify(hexBytes);
        // P2PKH: OP_DUP OP_HASH160 <pubKeyHash> OP_EQUALVERIFY OP_CHECKSIG
        if (coinInfo.p2pkh != null) {
            const p2pkh = hexBytes.match(/^0x76a9([0-9a-f][0-9a-f])([0-9a-f]*)88ac$/);
            if (p2pkh) {
                const length = parseInt(p2pkh[1], 16);
                if (p2pkh[2].length === length * 2 && length >= 1 && length <= 75) {
                    return base58Encode(lib_esm_concat([[coinInfo.p2pkh], ("0x" + p2pkh[2])]));
                }
            }
        }
        // P2SH: OP_HASH160 <scriptHash> OP_EQUAL
        if (coinInfo.p2sh != null) {
            const p2sh = hexBytes.match(/^0xa9([0-9a-f][0-9a-f])([0-9a-f]*)87$/);
            if (p2sh) {
                const length = parseInt(p2sh[1], 16);
                if (p2sh[2].length === length * 2 && length >= 1 && length <= 75) {
                    return base58Encode(lib_esm_concat([[coinInfo.p2sh], ("0x" + p2sh[2])]));
                }
            }
        }
        // Bech32
        if (coinInfo.prefix != null) {
            const length = bytes[1];
            // https://github.com/bitcoin/bips/blob/master/bip-0141.mediawiki#witness-program
            let version = bytes[0];
            if (version === 0x00) {
                if (length !== 20 && length !== 32) {
                    version = -1;
                }
            }
            else {
                version = -1;
            }
            if (version >= 0 && bytes.length === 2 + length && length >= 1 && length <= 75) {
                const words = bech32_default().toWords(bytes.slice(2));
                words.unshift(version);
                return bech32_default().encode(coinInfo.prefix, words);
            }
        }
        return null;
    }
    getAddress(coinType) {
        return base_provider_awaiter(this, void 0, void 0, function* () {
            if (coinType == null) {
                coinType = 60;
            }
            // If Ethereum, use the standard `addr(bytes32)`
            if (coinType === 60) {
                try {
                    // keccak256("addr(bytes32)")
                    const result = yield this._fetch("0x3b3b57de");
                    // No address
                    if (result === "0x" || result === HashZero) {
                        return null;
                    }
                    return this.provider.formatter.callAddress(result);
                }
                catch (error) {
                    if (error.code === lib_esm_Logger.errors.CALL_EXCEPTION) {
                        return null;
                    }
                    throw error;
                }
            }
            // keccak256("addr(bytes32,uint256")
            const hexBytes = yield this._fetchBytes("0xf1cb7e06", bytes32ify(coinType));
            // No address
            if (hexBytes == null || hexBytes === "0x") {
                return null;
            }
            // Compute the address
            const address = this._getAddress(coinType, hexBytes);
            if (address == null) {
                base_provider_logger.throwError(`invalid or unsupported coin data`, lib_esm_Logger.errors.UNSUPPORTED_OPERATION, {
                    operation: `getAddress(${coinType})`,
                    coinType: coinType,
                    data: hexBytes
                });
            }
            return address;
        });
    }
    getAvatar() {
        return base_provider_awaiter(this, void 0, void 0, function* () {
            const linkage = [{ type: "name", content: this.name }];
            try {
                // test data for ricmoo.eth
                //const avatar = "eip155:1/erc721:0x265385c7f4132228A0d54EB1A9e7460b91c0cC68/29233";
                const avatar = yield this.getText("avatar");
                if (avatar == null) {
                    return null;
                }
                for (let i = 0; i < matchers.length; i++) {
                    const match = avatar.match(matchers[i]);
                    if (match == null) {
                        continue;
                    }
                    const scheme = match[1].toLowerCase();
                    switch (scheme) {
                        case "https":
                            linkage.push({ type: "url", content: avatar });
                            return { linkage, url: avatar };
                        case "data":
                            linkage.push({ type: "data", content: avatar });
                            return { linkage, url: avatar };
                        case "ipfs":
                            linkage.push({ type: "ipfs", content: avatar });
                            return { linkage, url: getIpfsLink(avatar) };
                        case "erc721":
                        case "erc1155": {
                            // Depending on the ERC type, use tokenURI(uint256) or url(uint256)
                            const selector = (scheme === "erc721") ? "0xc87b56dd" : "0x0e89341c";
                            linkage.push({ type: scheme, content: avatar });
                            // The owner of this name
                            const owner = (this._resolvedAddress || (yield this.getAddress()));
                            const comps = (match[2] || "").split("/");
                            if (comps.length !== 2) {
                                return null;
                            }
                            const addr = yield this.provider.formatter.address(comps[0]);
                            const tokenId = hexZeroPad(bignumber_BigNumber.from(comps[1]).toHexString(), 32);
                            // Check that this account owns the token
                            if (scheme === "erc721") {
                                // ownerOf(uint256 tokenId)
                                const tokenOwner = this.provider.formatter.callAddress(yield this.provider.call({
                                    to: addr, data: hexConcat(["0x6352211e", tokenId])
                                }));
                                if (owner !== tokenOwner) {
                                    return null;
                                }
                                linkage.push({ type: "owner", content: tokenOwner });
                            }
                            else if (scheme === "erc1155") {
                                // balanceOf(address owner, uint256 tokenId)
                                const balance = bignumber_BigNumber.from(yield this.provider.call({
                                    to: addr, data: hexConcat(["0x00fdd58e", hexZeroPad(owner, 32), tokenId])
                                }));
                                if (balance.isZero()) {
                                    return null;
                                }
                                linkage.push({ type: "balance", content: balance.toString() });
                            }
                            // Call the token contract for the metadata URL
                            const tx = {
                                to: this.provider.formatter.address(comps[0]),
                                data: hexConcat([selector, tokenId])
                            };
                            let metadataUrl = _parseString(yield this.provider.call(tx), 0);
                            if (metadataUrl == null) {
                                return null;
                            }
                            linkage.push({ type: "metadata-url-base", content: metadataUrl });
                            // ERC-1155 allows a generic {id} in the URL
                            if (scheme === "erc1155") {
                                metadataUrl = metadataUrl.replace("{id}", tokenId.substring(2));
                                linkage.push({ type: "metadata-url-expanded", content: metadataUrl });
                            }
                            // Transform IPFS metadata links
                            if (metadataUrl.match(/^ipfs:/i)) {
                                metadataUrl = getIpfsLink(metadataUrl);
                            }
                            linkage.push({ type: "metadata-url", content: metadataUrl });
                            // Get the token metadata
                            const metadata = yield fetchJson(metadataUrl);
                            if (!metadata) {
                                return null;
                            }
                            linkage.push({ type: "metadata", content: JSON.stringify(metadata) });
                            // Pull the image URL out
                            let imageUrl = metadata.image;
                            if (typeof (imageUrl) !== "string") {
                                return null;
                            }
                            if (imageUrl.match(/^(https:\/\/|data:)/i)) {
                                // Allow
                            }
                            else {
                                // Transform IPFS link to gateway
                                const ipfs = imageUrl.match(matcherIpfs);
                                if (ipfs == null) {
                                    return null;
                                }
                                linkage.push({ type: "url-ipfs", content: imageUrl });
                                imageUrl = getIpfsLink(imageUrl);
                            }
                            linkage.push({ type: "url", content: imageUrl });
                            return { linkage, url: imageUrl };
                        }
                    }
                }
            }
            catch (error) { }
            return null;
        });
    }
    getContentHash() {
        return base_provider_awaiter(this, void 0, void 0, function* () {
            // keccak256("contenthash()")
            const hexBytes = yield this._fetchBytes("0xbc1c58d1");
            // No contenthash
            if (hexBytes == null || hexBytes === "0x") {
                return null;
            }
            // IPFS (CID: 1, Type: DAG-PB)
            const ipfs = hexBytes.match(/^0xe3010170(([0-9a-f][0-9a-f])([0-9a-f][0-9a-f])([0-9a-f]*))$/);
            if (ipfs) {
                const length = parseInt(ipfs[3], 16);
                if (ipfs[4].length === length * 2) {
                    return "ipfs:/\/" + Base58.encode("0x" + ipfs[1]);
                }
            }
            // IPNS (CID: 1, Type: libp2p-key)
            const ipns = hexBytes.match(/^0xe5010172(([0-9a-f][0-9a-f])([0-9a-f][0-9a-f])([0-9a-f]*))$/);
            if (ipns) {
                const length = parseInt(ipns[3], 16);
                if (ipns[4].length === length * 2) {
                    return "ipns:/\/" + Base58.encode("0x" + ipns[1]);
                }
            }
            // Swarm (CID: 1, Type: swarm-manifest; hash/length hard-coded to keccak256/32)
            const swarm = hexBytes.match(/^0xe40101fa011b20([0-9a-f]*)$/);
            if (swarm) {
                if (swarm[1].length === (32 * 2)) {
                    return "bzz:/\/" + swarm[1];
                }
            }
            const skynet = hexBytes.match(/^0x90b2c605([0-9a-f]*)$/);
            if (skynet) {
                if (skynet[1].length === (34 * 2)) {
                    // URL Safe base64; https://datatracker.ietf.org/doc/html/rfc4648#section-5
                    const urlSafe = { "=": "", "+": "-", "/": "_" };
                    const hash = base64_encode("0x" + skynet[1]).replace(/[=+\/]/g, (a) => (urlSafe[a]));
                    return "sia:/\/" + hash;
                }
            }
            return base_provider_logger.throwError(`invalid or unsupported content hash data`, lib_esm_Logger.errors.UNSUPPORTED_OPERATION, {
                operation: "getContentHash()",
                data: hexBytes
            });
        });
    }
    getText(key) {
        return base_provider_awaiter(this, void 0, void 0, function* () {
            // The key encoded as parameter to fetchBytes
            let keyBytes = toUtf8Bytes(key);
            // The nodehash consumes the first slot, so the string pointer targets
            // offset 64, with the length at offset 64 and data starting at offset 96
            keyBytes = lib_esm_concat([bytes32ify(64), bytes32ify(keyBytes.length), keyBytes]);
            // Pad to word-size (32 bytes)
            if ((keyBytes.length % 32) !== 0) {
                keyBytes = lib_esm_concat([keyBytes, hexZeroPad("0x", 32 - (key.length % 32))]);
            }
            const hexBytes = yield this._fetchBytes("0x59d1d43c", lib_esm_hexlify(keyBytes));
            if (hexBytes == null || hexBytes === "0x") {
                return null;
            }
            return utf8_toUtf8String(hexBytes);
        });
    }
}
let defaultFormatter = null;
let nextPollId = 1;
class BaseProvider extends Provider {
    /**
     *  ready
     *
     *  A Promise<Network> that resolves only once the provider is ready.
     *
     *  Sub-classes that call the super with a network without a chainId
     *  MUST set this. Standard named networks have a known chainId.
     *
     */
    constructor(network) {
        super();
        // Events being listened to
        this._events = [];
        this._emitted = { block: -2 };
        this.disableCcipRead = false;
        this.formatter = new.target.getFormatter();
        // If network is any, this Provider allows the underlying
        // network to change dynamically, and we auto-detect the
        // current network
        lib_esm_defineReadOnly(this, "anyNetwork", (network === "any"));
        if (this.anyNetwork) {
            network = this.detectNetwork();
        }
        if (network instanceof Promise) {
            this._networkPromise = network;
            // Squash any "unhandled promise" errors; that do not need to be handled
            network.catch((error) => { });
            // Trigger initial network setting (async)
            this._ready().catch((error) => { });
        }
        else {
            const knownNetwork = lib_esm_getStatic(new.target, "getNetwork")(network);
            if (knownNetwork) {
                lib_esm_defineReadOnly(this, "_network", knownNetwork);
                this.emit("network", knownNetwork, null);
            }
            else {
                base_provider_logger.throwArgumentError("invalid network", "network", network);
            }
        }
        this._maxInternalBlockNumber = -1024;
        this._lastBlockNumber = -2;
        this._maxFilterBlockRange = 10;
        this._pollingInterval = 4000;
        this._fastQueryDate = 0;
    }
    _ready() {
        return base_provider_awaiter(this, void 0, void 0, function* () {
            if (this._network == null) {
                let network = null;
                if (this._networkPromise) {
                    try {
                        network = yield this._networkPromise;
                    }
                    catch (error) { }
                }
                // Try the Provider's network detection (this MUST throw if it cannot)
                if (network == null) {
                    network = yield this.detectNetwork();
                }
                // This should never happen; every Provider sub-class should have
                // suggested a network by here (or have thrown).
                if (!network) {
                    base_provider_logger.throwError("no network detected", lib_esm_Logger.errors.UNKNOWN_ERROR, {});
                }
                // Possible this call stacked so do not call defineReadOnly again
                if (this._network == null) {
                    if (this.anyNetwork) {
                        this._network = network;
                    }
                    else {
                        lib_esm_defineReadOnly(this, "_network", network);
                    }
                    this.emit("network", network, null);
                }
            }
            return this._network;
        });
    }
    // This will always return the most recently established network.
    // For "any", this can change (a "network" event is emitted before
    // any change is reflected); otherwise this cannot change
    get ready() {
        return poll(() => {
            return this._ready().then((network) => {
                return network;
            }, (error) => {
                // If the network isn't running yet, we will wait
                if (error.code === lib_esm_Logger.errors.NETWORK_ERROR && error.event === "noNetwork") {
                    return undefined;
                }
                throw error;
            });
        });
    }
    // @TODO: Remove this and just create a singleton formatter
    static getFormatter() {
        if (defaultFormatter == null) {
            defaultFormatter = new Formatter();
        }
        return defaultFormatter;
    }
    // @TODO: Remove this and just use getNetwork
    static getNetwork(network) {
        return getNetwork((network == null) ? "homestead" : network);
    }
    ccipReadFetch(tx, calldata, urls) {
        return base_provider_awaiter(this, void 0, void 0, function* () {
            if (this.disableCcipRead || urls.length === 0) {
                return null;
            }
            const sender = tx.to.toLowerCase();
            const data = calldata.toLowerCase();
            const errorMessages = [];
            for (let i = 0; i < urls.length; i++) {
                const url = urls[i];
                // URL expansion
                const href = url.replace("{sender}", sender).replace("{data}", data);
                // If no {data} is present, use POST; otherwise GET
                const json = (url.indexOf("{data}") >= 0) ? null : JSON.stringify({ data, sender });
                const result = yield fetchJson({ url: href, errorPassThrough: true }, json, (value, response) => {
                    value.status = response.statusCode;
                    return value;
                });
                if (result.data) {
                    return result.data;
                }
                const errorMessage = (result.message || "unknown error");
                // 4xx indicates the result is not present; stop
                if (result.status >= 400 && result.status < 500) {
                    return base_provider_logger.throwError(`response not found during CCIP fetch: ${errorMessage}`, lib_esm_Logger.errors.SERVER_ERROR, { url, errorMessage });
                }
                // 5xx indicates server issue; try the next url
                errorMessages.push(errorMessage);
            }
            return base_provider_logger.throwError(`error encountered during CCIP fetch: ${errorMessages.map((m) => JSON.stringify(m)).join(", ")}`, lib_esm_Logger.errors.SERVER_ERROR, {
                urls, errorMessages
            });
        });
    }
    // Fetches the blockNumber, but will reuse any result that is less
    // than maxAge old or has been requested since the last request
    _getInternalBlockNumber(maxAge) {
        return base_provider_awaiter(this, void 0, void 0, function* () {
            yield this._ready();
            // Allowing stale data up to maxAge old
            if (maxAge > 0) {
                // While there are pending internal block requests...
                while (this._internalBlockNumber) {
                    // ..."remember" which fetch we started with
                    const internalBlockNumber = this._internalBlockNumber;
                    try {
                        // Check the result is not too stale
                        const result = yield internalBlockNumber;
                        if ((getTime() - result.respTime) <= maxAge) {
                            return result.blockNumber;
                        }
                        // Too old; fetch a new value
                        break;
                    }
                    catch (error) {
                        // The fetch rejected; if we are the first to get the
                        // rejection, drop through so we replace it with a new
                        // fetch; all others blocked will then get that fetch
                        // which won't match the one they "remembered" and loop
                        if (this._internalBlockNumber === internalBlockNumber) {
                            break;
                        }
                    }
                }
            }
            const reqTime = getTime();
            const checkInternalBlockNumber = resolveProperties({
                blockNumber: this.perform("getBlockNumber", {}),
                networkError: this.getNetwork().then((network) => (null), (error) => (error))
            }).then(({ blockNumber, networkError }) => {
                if (networkError) {
                    // Unremember this bad internal block number
                    if (this._internalBlockNumber === checkInternalBlockNumber) {
                        this._internalBlockNumber = null;
                    }
                    throw networkError;
                }
                const respTime = getTime();
                blockNumber = bignumber_BigNumber.from(blockNumber).toNumber();
                if (blockNumber < this._maxInternalBlockNumber) {
                    blockNumber = this._maxInternalBlockNumber;
                }
                this._maxInternalBlockNumber = blockNumber;
                this._setFastBlockNumber(blockNumber); // @TODO: Still need this?
                return { blockNumber, reqTime, respTime };
            });
            this._internalBlockNumber = checkInternalBlockNumber;
            // Swallow unhandled exceptions; if needed they are handled else where
            checkInternalBlockNumber.catch((error) => {
                // Don't null the dead (rejected) fetch, if it has already been updated
                if (this._internalBlockNumber === checkInternalBlockNumber) {
                    this._internalBlockNumber = null;
                }
            });
            return (yield checkInternalBlockNumber).blockNumber;
        });
    }
    poll() {
        return base_provider_awaiter(this, void 0, void 0, function* () {
            const pollId = nextPollId++;
            // Track all running promises, so we can trigger a post-poll once they are complete
            const runners = [];
            let blockNumber = null;
            try {
                blockNumber = yield this._getInternalBlockNumber(100 + this.pollingInterval / 2);
            }
            catch (error) {
                this.emit("error", error);
                return;
            }
            this._setFastBlockNumber(blockNumber);
            // Emit a poll event after we have the latest (fast) block number
            this.emit("poll", pollId, blockNumber);
            // If the block has not changed, meh.
            if (blockNumber === this._lastBlockNumber) {
                this.emit("didPoll", pollId);
                return;
            }
            // First polling cycle, trigger a "block" events
            if (this._emitted.block === -2) {
                this._emitted.block = blockNumber - 1;
            }
            if (Math.abs((this._emitted.block) - blockNumber) > 1000) {
                base_provider_logger.warn(`network block skew detected; skipping block events (emitted=${this._emitted.block} blockNumber${blockNumber})`);
                this.emit("error", base_provider_logger.makeError("network block skew detected", lib_esm_Logger.errors.NETWORK_ERROR, {
                    blockNumber: blockNumber,
                    event: "blockSkew",
                    previousBlockNumber: this._emitted.block
                }));
                this.emit("block", blockNumber);
            }
            else {
                // Notify all listener for each block that has passed
                for (let i = this._emitted.block + 1; i <= blockNumber; i++) {
                    this.emit("block", i);
                }
            }
            // The emitted block was updated, check for obsolete events
            if (this._emitted.block !== blockNumber) {
                this._emitted.block = blockNumber;
                Object.keys(this._emitted).forEach((key) => {
                    // The block event does not expire
                    if (key === "block") {
                        return;
                    }
                    // The block we were at when we emitted this event
                    const eventBlockNumber = this._emitted[key];
                    // We cannot garbage collect pending transactions or blocks here
                    // They should be garbage collected by the Provider when setting
                    // "pending" events
                    if (eventBlockNumber === "pending") {
                        return;
                    }
                    // Evict any transaction hashes or block hashes over 12 blocks
                    // old, since they should not return null anyways
                    if (blockNumber - eventBlockNumber > 12) {
                        delete this._emitted[key];
                    }
                });
            }
            // First polling cycle
            if (this._lastBlockNumber === -2) {
                this._lastBlockNumber = blockNumber - 1;
            }
            // Find all transaction hashes we are waiting on
            this._events.forEach((event) => {
                switch (event.type) {
                    case "tx": {
                        const hash = event.hash;
                        let runner = this.getTransactionReceipt(hash).then((receipt) => {
                            if (!receipt || receipt.blockNumber == null) {
                                return null;
                            }
                            this._emitted["t:" + hash] = receipt.blockNumber;
                            this.emit(hash, receipt);
                            return null;
                        }).catch((error) => { this.emit("error", error); });
                        runners.push(runner);
                        break;
                    }
                    case "filter": {
                        // We only allow a single getLogs to be in-flight at a time
                        if (!event._inflight) {
                            event._inflight = true;
                            // This is the first filter for this event, so we want to
                            // restrict events to events that happened no earlier than now
                            if (event._lastBlockNumber === -2) {
                                event._lastBlockNumber = blockNumber - 1;
                            }
                            // Filter from the last *known* event; due to load-balancing
                            // and some nodes returning updated block numbers before
                            // indexing events, a logs result with 0 entries cannot be
                            // trusted and we must retry a range which includes it again
                            const filter = event.filter;
                            filter.fromBlock = event._lastBlockNumber + 1;
                            filter.toBlock = blockNumber;
                            // Prevent fitler ranges from growing too wild, since it is quite
                            // likely there just haven't been any events to move the lastBlockNumber.
                            const minFromBlock = filter.toBlock - this._maxFilterBlockRange;
                            if (minFromBlock > filter.fromBlock) {
                                filter.fromBlock = minFromBlock;
                            }
                            if (filter.fromBlock < 0) {
                                filter.fromBlock = 0;
                            }
                            const runner = this.getLogs(filter).then((logs) => {
                                // Allow the next getLogs
                                event._inflight = false;
                                if (logs.length === 0) {
                                    return;
                                }
                                logs.forEach((log) => {
                                    // Only when we get an event for a given block number
                                    // can we trust the events are indexed
                                    if (log.blockNumber > event._lastBlockNumber) {
                                        event._lastBlockNumber = log.blockNumber;
                                    }
                                    // Make sure we stall requests to fetch blocks and txs
                                    this._emitted["b:" + log.blockHash] = log.blockNumber;
                                    this._emitted["t:" + log.transactionHash] = log.blockNumber;
                                    this.emit(filter, log);
                                });
                            }).catch((error) => {
                                this.emit("error", error);
                                // Allow another getLogs (the range was not updated)
                                event._inflight = false;
                            });
                            runners.push(runner);
                        }
                        break;
                    }
                }
            });
            this._lastBlockNumber = blockNumber;
            // Once all events for this loop have been processed, emit "didPoll"
            Promise.all(runners).then(() => {
                this.emit("didPoll", pollId);
            }).catch((error) => { this.emit("error", error); });
            return;
        });
    }
    // Deprecated; do not use this
    resetEventsBlock(blockNumber) {
        this._lastBlockNumber = blockNumber - 1;
        if (this.polling) {
            this.poll();
        }
    }
    get network() {
        return this._network;
    }
    // This method should query the network if the underlying network
    // can change, such as when connected to a JSON-RPC backend
    detectNetwork() {
        return base_provider_awaiter(this, void 0, void 0, function* () {
            return base_provider_logger.throwError("provider does not support network detection", lib_esm_Logger.errors.UNSUPPORTED_OPERATION, {
                operation: "provider.detectNetwork"
            });
        });
    }
    getNetwork() {
        return base_provider_awaiter(this, void 0, void 0, function* () {
            const network = yield this._ready();
            // Make sure we are still connected to the same network; this is
            // only an external call for backends which can have the underlying
            // network change spontaneously
            const currentNetwork = yield this.detectNetwork();
            if (network.chainId !== currentNetwork.chainId) {
                // We are allowing network changes, things can get complex fast;
                // make sure you know what you are doing if you use "any"
                if (this.anyNetwork) {
                    this._network = currentNetwork;
                    // Reset all internal block number guards and caches
                    this._lastBlockNumber = -2;
                    this._fastBlockNumber = null;
                    this._fastBlockNumberPromise = null;
                    this._fastQueryDate = 0;
                    this._emitted.block = -2;
                    this._maxInternalBlockNumber = -1024;
                    this._internalBlockNumber = null;
                    // The "network" event MUST happen before this method resolves
                    // so any events have a chance to unregister, so we stall an
                    // additional event loop before returning from /this/ call
                    this.emit("network", currentNetwork, network);
                    yield stall(0);
                    return this._network;
                }
                const error = base_provider_logger.makeError("underlying network changed", lib_esm_Logger.errors.NETWORK_ERROR, {
                    event: "changed",
                    network: network,
                    detectedNetwork: currentNetwork
                });
                this.emit("error", error);
                throw error;
            }
            return network;
        });
    }
    get blockNumber() {
        this._getInternalBlockNumber(100 + this.pollingInterval / 2).then((blockNumber) => {
            this._setFastBlockNumber(blockNumber);
        }, (error) => { });
        return (this._fastBlockNumber != null) ? this._fastBlockNumber : -1;
    }
    get polling() {
        return (this._poller != null);
    }
    set polling(value) {
        if (value && !this._poller) {
            this._poller = setInterval(() => { this.poll(); }, this.pollingInterval);
            if (!this._bootstrapPoll) {
                this._bootstrapPoll = setTimeout(() => {
                    this.poll();
                    // We block additional polls until the polling interval
                    // is done, to prevent overwhelming the poll function
                    this._bootstrapPoll = setTimeout(() => {
                        // If polling was disabled, something may require a poke
                        // since starting the bootstrap poll and it was disabled
                        if (!this._poller) {
                            this.poll();
                        }
                        // Clear out the bootstrap so we can do another
                        this._bootstrapPoll = null;
                    }, this.pollingInterval);
                }, 0);
            }
        }
        else if (!value && this._poller) {
            clearInterval(this._poller);
            this._poller = null;
        }
    }
    get pollingInterval() {
        return this._pollingInterval;
    }
    set pollingInterval(value) {
        if (typeof (value) !== "number" || value <= 0 || parseInt(String(value)) != value) {
            throw new Error("invalid polling interval");
        }
        this._pollingInterval = value;
        if (this._poller) {
            clearInterval(this._poller);
            this._poller = setInterval(() => { this.poll(); }, this._pollingInterval);
        }
    }
    _getFastBlockNumber() {
        const now = getTime();
        // Stale block number, request a newer value
        if ((now - this._fastQueryDate) > 2 * this._pollingInterval) {
            this._fastQueryDate = now;
            this._fastBlockNumberPromise = this.getBlockNumber().then((blockNumber) => {
                if (this._fastBlockNumber == null || blockNumber > this._fastBlockNumber) {
                    this._fastBlockNumber = blockNumber;
                }
                return this._fastBlockNumber;
            });
        }
        return this._fastBlockNumberPromise;
    }
    _setFastBlockNumber(blockNumber) {
        // Older block, maybe a stale request
        if (this._fastBlockNumber != null && blockNumber < this._fastBlockNumber) {
            return;
        }
        // Update the time we updated the blocknumber
        this._fastQueryDate = getTime();
        // Newer block number, use  it
        if (this._fastBlockNumber == null || blockNumber > this._fastBlockNumber) {
            this._fastBlockNumber = blockNumber;
            this._fastBlockNumberPromise = Promise.resolve(blockNumber);
        }
    }
    waitForTransaction(transactionHash, confirmations, timeout) {
        return base_provider_awaiter(this, void 0, void 0, function* () {
            return this._waitForTransaction(transactionHash, (confirmations == null) ? 1 : confirmations, timeout || 0, null);
        });
    }
    _waitForTransaction(transactionHash, confirmations, timeout, replaceable) {
        return base_provider_awaiter(this, void 0, void 0, function* () {
            const receipt = yield this.getTransactionReceipt(transactionHash);
            // Receipt is already good
            if ((receipt ? receipt.confirmations : 0) >= confirmations) {
                return receipt;
            }
            // Poll until the receipt is good...
            return new Promise((resolve, reject) => {
                const cancelFuncs = [];
                let done = false;
                const alreadyDone = function () {
                    if (done) {
                        return true;
                    }
                    done = true;
                    cancelFuncs.forEach((func) => { func(); });
                    return false;
                };
                const minedHandler = (receipt) => {
                    if (receipt.confirmations < confirmations) {
                        return;
                    }
                    if (alreadyDone()) {
                        return;
                    }
                    resolve(receipt);
                };
                this.on(transactionHash, minedHandler);
                cancelFuncs.push(() => { this.removeListener(transactionHash, minedHandler); });
                if (replaceable) {
                    let lastBlockNumber = replaceable.startBlock;
                    let scannedBlock = null;
                    const replaceHandler = (blockNumber) => base_provider_awaiter(this, void 0, void 0, function* () {
                        if (done) {
                            return;
                        }
                        // Wait 1 second; this is only used in the case of a fault, so
                        // we will trade off a little bit of latency for more consistent
                        // results and fewer JSON-RPC calls
                        yield stall(1000);
                        this.getTransactionCount(replaceable.from).then((nonce) => base_provider_awaiter(this, void 0, void 0, function* () {
                            if (done) {
                                return;
                            }
                            if (nonce <= replaceable.nonce) {
                                lastBlockNumber = blockNumber;
                            }
                            else {
                                // First check if the transaction was mined
                                {
                                    const mined = yield this.getTransaction(transactionHash);
                                    if (mined && mined.blockNumber != null) {
                                        return;
                                    }
                                }
                                // First time scanning. We start a little earlier for some
                                // wiggle room here to handle the eventually consistent nature
                                // of blockchain (e.g. the getTransactionCount was for a
                                // different block)
                                if (scannedBlock == null) {
                                    scannedBlock = lastBlockNumber - 3;
                                    if (scannedBlock < replaceable.startBlock) {
                                        scannedBlock = replaceable.startBlock;
                                    }
                                }
                                while (scannedBlock <= blockNumber) {
                                    if (done) {
                                        return;
                                    }
                                    const block = yield this.getBlockWithTransactions(scannedBlock);
                                    for (let ti = 0; ti < block.transactions.length; ti++) {
                                        const tx = block.transactions[ti];
                                        // Successfully mined!
                                        if (tx.hash === transactionHash) {
                                            return;
                                        }
                                        // Matches our transaction from and nonce; its a replacement
                                        if (tx.from === replaceable.from && tx.nonce === replaceable.nonce) {
                                            if (done) {
                                                return;
                                            }
                                            // Get the receipt of the replacement
                                            const receipt = yield this.waitForTransaction(tx.hash, confirmations);
                                            // Already resolved or rejected (prolly a timeout)
                                            if (alreadyDone()) {
                                                return;
                                            }
                                            // The reason we were replaced
                                            let reason = "replaced";
                                            if (tx.data === replaceable.data && tx.to === replaceable.to && tx.value.eq(replaceable.value)) {
                                                reason = "repriced";
                                            }
                                            else if (tx.data === "0x" && tx.from === tx.to && tx.value.isZero()) {
                                                reason = "cancelled";
                                            }
                                            // Explain why we were replaced
                                            reject(base_provider_logger.makeError("transaction was replaced", lib_esm_Logger.errors.TRANSACTION_REPLACED, {
                                                cancelled: (reason === "replaced" || reason === "cancelled"),
                                                reason,
                                                replacement: this._wrapTransaction(tx),
                                                hash: transactionHash,
                                                receipt
                                            }));
                                            return;
                                        }
                                    }
                                    scannedBlock++;
                                }
                            }
                            if (done) {
                                return;
                            }
                            this.once("block", replaceHandler);
                        }), (error) => {
                            if (done) {
                                return;
                            }
                            this.once("block", replaceHandler);
                        });
                    });
                    if (done) {
                        return;
                    }
                    this.once("block", replaceHandler);
                    cancelFuncs.push(() => {
                        this.removeListener("block", replaceHandler);
                    });
                }
                if (typeof (timeout) === "number" && timeout > 0) {
                    const timer = setTimeout(() => {
                        if (alreadyDone()) {
                            return;
                        }
                        reject(base_provider_logger.makeError("timeout exceeded", lib_esm_Logger.errors.TIMEOUT, { timeout: timeout }));
                    }, timeout);
                    if (timer.unref) {
                        timer.unref();
                    }
                    cancelFuncs.push(() => { clearTimeout(timer); });
                }
            });
        });
    }
    getBlockNumber() {
        return base_provider_awaiter(this, void 0, void 0, function* () {
            return this._getInternalBlockNumber(0);
        });
    }
    getGasPrice() {
        return base_provider_awaiter(this, void 0, void 0, function* () {
            yield this.getNetwork();
            const result = yield this.perform("getGasPrice", {});
            try {
                return bignumber_BigNumber.from(result);
            }
            catch (error) {
                return base_provider_logger.throwError("bad result from backend", lib_esm_Logger.errors.SERVER_ERROR, {
                    method: "getGasPrice",
                    result, error
                });
            }
        });
    }
    getBalance(addressOrName, blockTag) {
        return base_provider_awaiter(this, void 0, void 0, function* () {
            yield this.getNetwork();
            const params = yield resolveProperties({
                address: this._getAddress(addressOrName),
                blockTag: this._getBlockTag(blockTag)
            });
            const result = yield this.perform("getBalance", params);
            try {
                return bignumber_BigNumber.from(result);
            }
            catch (error) {
                return base_provider_logger.throwError("bad result from backend", lib_esm_Logger.errors.SERVER_ERROR, {
                    method: "getBalance",
                    params, result, error
                });
            }
        });
    }
    getTransactionCount(addressOrName, blockTag) {
        return base_provider_awaiter(this, void 0, void 0, function* () {
            yield this.getNetwork();
            const params = yield resolveProperties({
                address: this._getAddress(addressOrName),
                blockTag: this._getBlockTag(blockTag)
            });
            const result = yield this.perform("getTransactionCount", params);
            try {
                return bignumber_BigNumber.from(result).toNumber();
            }
            catch (error) {
                return base_provider_logger.throwError("bad result from backend", lib_esm_Logger.errors.SERVER_ERROR, {
                    method: "getTransactionCount",
                    params, result, error
                });
            }
        });
    }
    getCode(addressOrName, blockTag) {
        return base_provider_awaiter(this, void 0, void 0, function* () {
            yield this.getNetwork();
            const params = yield resolveProperties({
                address: this._getAddress(addressOrName),
                blockTag: this._getBlockTag(blockTag)
            });
            const result = yield this.perform("getCode", params);
            try {
                return lib_esm_hexlify(result);
            }
            catch (error) {
                return base_provider_logger.throwError("bad result from backend", lib_esm_Logger.errors.SERVER_ERROR, {
                    method: "getCode",
                    params, result, error
                });
            }
        });
    }
    getStorageAt(addressOrName, position, blockTag) {
        return base_provider_awaiter(this, void 0, void 0, function* () {
            yield this.getNetwork();
            const params = yield resolveProperties({
                address: this._getAddress(addressOrName),
                blockTag: this._getBlockTag(blockTag),
                position: Promise.resolve(position).then((p) => hexValue(p))
            });
            const result = yield this.perform("getStorageAt", params);
            try {
                return lib_esm_hexlify(result);
            }
            catch (error) {
                return base_provider_logger.throwError("bad result from backend", lib_esm_Logger.errors.SERVER_ERROR, {
                    method: "getStorageAt",
                    params, result, error
                });
            }
        });
    }
    // This should be called by any subclass wrapping a TransactionResponse
    _wrapTransaction(tx, hash, startBlock) {
        if (hash != null && lib_esm_hexDataLength(hash) !== 32) {
            throw new Error("invalid response - sendTransaction");
        }
        const result = tx;
        // Check the hash we expect is the same as the hash the server reported
        if (hash != null && tx.hash !== hash) {
            base_provider_logger.throwError("Transaction hash mismatch from Provider.sendTransaction.", lib_esm_Logger.errors.UNKNOWN_ERROR, { expectedHash: tx.hash, returnedHash: hash });
        }
        result.wait = (confirms, timeout) => base_provider_awaiter(this, void 0, void 0, function* () {
            if (confirms == null) {
                confirms = 1;
            }
            if (timeout == null) {
                timeout = 0;
            }
            // Get the details to detect replacement
            let replacement = undefined;
            if (confirms !== 0 && startBlock != null) {
                replacement = {
                    data: tx.data,
                    from: tx.from,
                    nonce: tx.nonce,
                    to: tx.to,
                    value: tx.value,
                    startBlock
                };
            }
            const receipt = yield this._waitForTransaction(tx.hash, confirms, timeout, replacement);
            if (receipt == null && confirms === 0) {
                return null;
            }
            // No longer pending, allow the polling loop to garbage collect this
            this._emitted["t:" + tx.hash] = receipt.blockNumber;
            if (receipt.status === 0) {
                base_provider_logger.throwError("transaction failed", lib_esm_Logger.errors.CALL_EXCEPTION, {
                    transactionHash: tx.hash,
                    transaction: tx,
                    receipt: receipt
                });
            }
            return receipt;
        });
        return result;
    }
    sendTransaction(signedTransaction) {
        return base_provider_awaiter(this, void 0, void 0, function* () {
            yield this.getNetwork();
            const hexTx = yield Promise.resolve(signedTransaction).then(t => lib_esm_hexlify(t));
            const tx = this.formatter.transaction(signedTransaction);
            if (tx.confirmations == null) {
                tx.confirmations = 0;
            }
            const blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
            try {
                const hash = yield this.perform("sendTransaction", { signedTransaction: hexTx });
                return this._wrapTransaction(tx, hash, blockNumber);
            }
            catch (error) {
                error.transaction = tx;
                error.transactionHash = tx.hash;
                throw error;
            }
        });
    }
    _getTransactionRequest(transaction) {
        return base_provider_awaiter(this, void 0, void 0, function* () {
            const values = yield transaction;
            const tx = {};
            ["from", "to"].forEach((key) => {
                if (values[key] == null) {
                    return;
                }
                tx[key] = Promise.resolve(values[key]).then((v) => (v ? this._getAddress(v) : null));
            });
            ["gasLimit", "gasPrice", "maxFeePerGas", "maxPriorityFeePerGas", "value"].forEach((key) => {
                if (values[key] == null) {
                    return;
                }
                tx[key] = Promise.resolve(values[key]).then((v) => (v ? bignumber_BigNumber.from(v) : null));
            });
            ["type"].forEach((key) => {
                if (values[key] == null) {
                    return;
                }
                tx[key] = Promise.resolve(values[key]).then((v) => ((v != null) ? v : null));
            });
            if (values.accessList) {
                tx.accessList = this.formatter.accessList(values.accessList);
            }
            ["data"].forEach((key) => {
                if (values[key] == null) {
                    return;
                }
                tx[key] = Promise.resolve(values[key]).then((v) => (v ? lib_esm_hexlify(v) : null));
            });
            return this.formatter.transactionRequest(yield resolveProperties(tx));
        });
    }
    _getFilter(filter) {
        return base_provider_awaiter(this, void 0, void 0, function* () {
            filter = yield filter;
            const result = {};
            if (filter.address != null) {
                result.address = this._getAddress(filter.address);
            }
            ["blockHash", "topics"].forEach((key) => {
                if (filter[key] == null) {
                    return;
                }
                result[key] = filter[key];
            });
            ["fromBlock", "toBlock"].forEach((key) => {
                if (filter[key] == null) {
                    return;
                }
                result[key] = this._getBlockTag(filter[key]);
            });
            return this.formatter.filter(yield resolveProperties(result));
        });
    }
    _call(transaction, blockTag, attempt) {
        return base_provider_awaiter(this, void 0, void 0, function* () {
            if (attempt >= MAX_CCIP_REDIRECTS) {
                base_provider_logger.throwError("CCIP read exceeded maximum redirections", lib_esm_Logger.errors.SERVER_ERROR, {
                    redirects: attempt, transaction
                });
            }
            const txSender = transaction.to;
            const result = yield this.perform("call", { transaction, blockTag });
            // CCIP Read request via OffchainLookup(address,string[],bytes,bytes4,bytes)
            if (attempt >= 0 && blockTag === "latest" && txSender != null && result.substring(0, 10) === "0x556f1830" && (lib_esm_hexDataLength(result) % 32 === 4)) {
                try {
                    const data = lib_esm_hexDataSlice(result, 4);
                    // Check the sender of the OffchainLookup matches the transaction
                    const sender = lib_esm_hexDataSlice(data, 0, 32);
                    if (!bignumber_BigNumber.from(sender).eq(txSender)) {
                        base_provider_logger.throwError("CCIP Read sender did not match", lib_esm_Logger.errors.CALL_EXCEPTION, {
                            name: "OffchainLookup",
                            signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                            transaction, data: result
                        });
                    }
                    // Read the URLs from the response
                    const urls = [];
                    const urlsOffset = bignumber_BigNumber.from(lib_esm_hexDataSlice(data, 32, 64)).toNumber();
                    const urlsLength = bignumber_BigNumber.from(lib_esm_hexDataSlice(data, urlsOffset, urlsOffset + 32)).toNumber();
                    const urlsData = lib_esm_hexDataSlice(data, urlsOffset + 32);
                    for (let u = 0; u < urlsLength; u++) {
                        const url = _parseString(urlsData, u * 32);
                        if (url == null) {
                            base_provider_logger.throwError("CCIP Read contained corrupt URL string", lib_esm_Logger.errors.CALL_EXCEPTION, {
                                name: "OffchainLookup",
                                signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                                transaction, data: result
                            });
                        }
                        urls.push(url);
                    }
                    // Get the CCIP calldata to forward
                    const calldata = _parseBytes(data, 64);
                    // Get the callbackSelector (bytes4)
                    if (!bignumber_BigNumber.from(lib_esm_hexDataSlice(data, 100, 128)).isZero()) {
                        base_provider_logger.throwError("CCIP Read callback selector included junk", lib_esm_Logger.errors.CALL_EXCEPTION, {
                            name: "OffchainLookup",
                            signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                            transaction, data: result
                        });
                    }
                    const callbackSelector = lib_esm_hexDataSlice(data, 96, 100);
                    // Get the extra data to send back to the contract as context
                    const extraData = _parseBytes(data, 128);
                    const ccipResult = yield this.ccipReadFetch(transaction, calldata, urls);
                    if (ccipResult == null) {
                        base_provider_logger.throwError("CCIP Read disabled or provided no URLs", lib_esm_Logger.errors.CALL_EXCEPTION, {
                            name: "OffchainLookup",
                            signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                            transaction, data: result
                        });
                    }
                    const tx = {
                        to: txSender,
                        data: hexConcat([callbackSelector, encodeBytes([ccipResult, extraData])])
                    };
                    return this._call(tx, blockTag, attempt + 1);
                }
                catch (error) {
                    if (error.code === lib_esm_Logger.errors.SERVER_ERROR) {
                        throw error;
                    }
                }
            }
            try {
                return lib_esm_hexlify(result);
            }
            catch (error) {
                return base_provider_logger.throwError("bad result from backend", lib_esm_Logger.errors.SERVER_ERROR, {
                    method: "call",
                    params: { transaction, blockTag }, result, error
                });
            }
        });
    }
    call(transaction, blockTag) {
        return base_provider_awaiter(this, void 0, void 0, function* () {
            yield this.getNetwork();
            const resolved = yield resolveProperties({
                transaction: this._getTransactionRequest(transaction),
                blockTag: this._getBlockTag(blockTag),
                ccipReadEnabled: Promise.resolve(transaction.ccipReadEnabled)
            });
            return this._call(resolved.transaction, resolved.blockTag, resolved.ccipReadEnabled ? 0 : -1);
        });
    }
    estimateGas(transaction) {
        return base_provider_awaiter(this, void 0, void 0, function* () {
            yield this.getNetwork();
            const params = yield resolveProperties({
                transaction: this._getTransactionRequest(transaction)
            });
            const result = yield this.perform("estimateGas", params);
            try {
                return bignumber_BigNumber.from(result);
            }
            catch (error) {
                return base_provider_logger.throwError("bad result from backend", lib_esm_Logger.errors.SERVER_ERROR, {
                    method: "estimateGas",
                    params, result, error
                });
            }
        });
    }
    _getAddress(addressOrName) {
        return base_provider_awaiter(this, void 0, void 0, function* () {
            addressOrName = yield addressOrName;
            if (typeof (addressOrName) !== "string") {
                base_provider_logger.throwArgumentError("invalid address or ENS name", "name", addressOrName);
            }
            const address = yield this.resolveName(addressOrName);
            if (address == null) {
                base_provider_logger.throwError("ENS name not configured", lib_esm_Logger.errors.UNSUPPORTED_OPERATION, {
                    operation: `resolveName(${JSON.stringify(addressOrName)})`
                });
            }
            return address;
        });
    }
    _getBlock(blockHashOrBlockTag, includeTransactions) {
        return base_provider_awaiter(this, void 0, void 0, function* () {
            yield this.getNetwork();
            blockHashOrBlockTag = yield blockHashOrBlockTag;
            // If blockTag is a number (not "latest", etc), this is the block number
            let blockNumber = -128;
            const params = {
                includeTransactions: !!includeTransactions
            };
            if (lib_esm_isHexString(blockHashOrBlockTag, 32)) {
                params.blockHash = blockHashOrBlockTag;
            }
            else {
                try {
                    params.blockTag = yield this._getBlockTag(blockHashOrBlockTag);
                    if (lib_esm_isHexString(params.blockTag)) {
                        blockNumber = parseInt(params.blockTag.substring(2), 16);
                    }
                }
                catch (error) {
                    base_provider_logger.throwArgumentError("invalid block hash or block tag", "blockHashOrBlockTag", blockHashOrBlockTag);
                }
            }
            return poll(() => base_provider_awaiter(this, void 0, void 0, function* () {
                const block = yield this.perform("getBlock", params);
                // Block was not found
                if (block == null) {
                    // For blockhashes, if we didn't say it existed, that blockhash may
                    // not exist. If we did see it though, perhaps from a log, we know
                    // it exists, and this node is just not caught up yet.
                    if (params.blockHash != null) {
                        if (this._emitted["b:" + params.blockHash] == null) {
                            return null;
                        }
                    }
                    // For block tags, if we are asking for a future block, we return null
                    if (params.blockTag != null) {
                        if (blockNumber > this._emitted.block) {
                            return null;
                        }
                    }
                    // Retry on the next block
                    return undefined;
                }
                // Add transactions
                if (includeTransactions) {
                    let blockNumber = null;
                    for (let i = 0; i < block.transactions.length; i++) {
                        const tx = block.transactions[i];
                        if (tx.blockNumber == null) {
                            tx.confirmations = 0;
                        }
                        else if (tx.confirmations == null) {
                            if (blockNumber == null) {
                                blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
                            }
                            // Add the confirmations using the fast block number (pessimistic)
                            let confirmations = (blockNumber - tx.blockNumber) + 1;
                            if (confirmations <= 0) {
                                confirmations = 1;
                            }
                            tx.confirmations = confirmations;
                        }
                    }
                    const blockWithTxs = this.formatter.blockWithTransactions(block);
                    blockWithTxs.transactions = blockWithTxs.transactions.map((tx) => this._wrapTransaction(tx));
                    return blockWithTxs;
                }
                return this.formatter.block(block);
            }), { oncePoll: this });
        });
    }
    getBlock(blockHashOrBlockTag) {
        return (this._getBlock(blockHashOrBlockTag, false));
    }
    getBlockWithTransactions(blockHashOrBlockTag) {
        return (this._getBlock(blockHashOrBlockTag, true));
    }
    getTransaction(transactionHash) {
        return base_provider_awaiter(this, void 0, void 0, function* () {
            yield this.getNetwork();
            transactionHash = yield transactionHash;
            const params = { transactionHash: this.formatter.hash(transactionHash, true) };
            return poll(() => base_provider_awaiter(this, void 0, void 0, function* () {
                const result = yield this.perform("getTransaction", params);
                if (result == null) {
                    if (this._emitted["t:" + transactionHash] == null) {
                        return null;
                    }
                    return undefined;
                }
                const tx = this.formatter.transactionResponse(result);
                if (tx.blockNumber == null) {
                    tx.confirmations = 0;
                }
                else if (tx.confirmations == null) {
                    const blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
                    // Add the confirmations using the fast block number (pessimistic)
                    let confirmations = (blockNumber - tx.blockNumber) + 1;
                    if (confirmations <= 0) {
                        confirmations = 1;
                    }
                    tx.confirmations = confirmations;
                }
                return this._wrapTransaction(tx);
            }), { oncePoll: this });
        });
    }
    getTransactionReceipt(transactionHash) {
        return base_provider_awaiter(this, void 0, void 0, function* () {
            yield this.getNetwork();
            transactionHash = yield transactionHash;
            const params = { transactionHash: this.formatter.hash(transactionHash, true) };
            return poll(() => base_provider_awaiter(this, void 0, void 0, function* () {
                const result = yield this.perform("getTransactionReceipt", params);
                if (result == null) {
                    if (this._emitted["t:" + transactionHash] == null) {
                        return null;
                    }
                    return undefined;
                }
                // "geth-etc" returns receipts before they are ready
                if (result.blockHash == null) {
                    return undefined;
                }
                const receipt = this.formatter.receipt(result);
                if (receipt.blockNumber == null) {
                    receipt.confirmations = 0;
                }
                else if (receipt.confirmations == null) {
                    const blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
                    // Add the confirmations using the fast block number (pessimistic)
                    let confirmations = (blockNumber - receipt.blockNumber) + 1;
                    if (confirmations <= 0) {
                        confirmations = 1;
                    }
                    receipt.confirmations = confirmations;
                }
                return receipt;
            }), { oncePoll: this });
        });
    }
    getLogs(filter) {
        return base_provider_awaiter(this, void 0, void 0, function* () {
            yield this.getNetwork();
            const params = yield resolveProperties({ filter: this._getFilter(filter) });
            const logs = yield this.perform("getLogs", params);
            logs.forEach((log) => {
                if (log.removed == null) {
                    log.removed = false;
                }
            });
            return Formatter.arrayOf(this.formatter.filterLog.bind(this.formatter))(logs);
        });
    }
    getEtherPrice() {
        return base_provider_awaiter(this, void 0, void 0, function* () {
            yield this.getNetwork();
            return this.perform("getEtherPrice", {});
        });
    }
    _getBlockTag(blockTag) {
        return base_provider_awaiter(this, void 0, void 0, function* () {
            blockTag = yield blockTag;
            if (typeof (blockTag) === "number" && blockTag < 0) {
                if (blockTag % 1) {
                    base_provider_logger.throwArgumentError("invalid BlockTag", "blockTag", blockTag);
                }
                let blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
                blockNumber += blockTag;
                if (blockNumber < 0) {
                    blockNumber = 0;
                }
                return this.formatter.blockTag(blockNumber);
            }
            return this.formatter.blockTag(blockTag);
        });
    }
    getResolver(name) {
        return base_provider_awaiter(this, void 0, void 0, function* () {
            let currentName = name;
            while (true) {
                if (currentName === "" || currentName === ".") {
                    return null;
                }
                // Optimization since the eth node cannot change and does
                // not have a wildcard resolver
                if (name !== "eth" && currentName === "eth") {
                    return null;
                }
                // Check the current node for a resolver
                const addr = yield this._getResolver(currentName, "getResolver");
                // Found a resolver!
                if (addr != null) {
                    const resolver = new Resolver(this, addr, name);
                    // Legacy resolver found, using EIP-2544 so it isn't safe to use
                    if (currentName !== name && !(yield resolver.supportsWildcard())) {
                        return null;
                    }
                    return resolver;
                }
                // Get the parent node
                currentName = currentName.split(".").slice(1).join(".");
            }
        });
    }
    _getResolver(name, operation) {
        return base_provider_awaiter(this, void 0, void 0, function* () {
            if (operation == null) {
                operation = "ENS";
            }
            const network = yield this.getNetwork();
            // No ENS...
            if (!network.ensAddress) {
                base_provider_logger.throwError("network does not support ENS", lib_esm_Logger.errors.UNSUPPORTED_OPERATION, { operation, network: network.name });
            }
            try {
                // keccak256("resolver(bytes32)")
                const addrData = yield this.call({
                    to: network.ensAddress,
                    data: ("0x0178b8bf" + namehash(name).substring(2))
                });
                return this.formatter.callAddress(addrData);
            }
            catch (error) {
                // ENS registry cannot throw errors on resolver(bytes32)
            }
            return null;
        });
    }
    resolveName(name) {
        return base_provider_awaiter(this, void 0, void 0, function* () {
            name = yield name;
            // If it is already an address, nothing to resolve
            try {
                return Promise.resolve(this.formatter.address(name));
            }
            catch (error) {
                // If is is a hexstring, the address is bad (See #694)
                if (lib_esm_isHexString(name)) {
                    throw error;
                }
            }
            if (typeof (name) !== "string") {
                base_provider_logger.throwArgumentError("invalid ENS name", "name", name);
            }
            // Get the addr from the resolver
            const resolver = yield this.getResolver(name);
            if (!resolver) {
                return null;
            }
            return yield resolver.getAddress();
        });
    }
    lookupAddress(address) {
        return base_provider_awaiter(this, void 0, void 0, function* () {
            address = yield address;
            address = this.formatter.address(address);
            const node = address.substring(2).toLowerCase() + ".addr.reverse";
            const resolverAddr = yield this._getResolver(node, "lookupAddress");
            if (resolverAddr == null) {
                return null;
            }
            // keccak("name(bytes32)")
            const name = _parseString(yield this.call({
                to: resolverAddr,
                data: ("0x691f3431" + namehash(node).substring(2))
            }), 0);
            const addr = yield this.resolveName(name);
            if (addr != address) {
                return null;
            }
            return name;
        });
    }
    getAvatar(nameOrAddress) {
        return base_provider_awaiter(this, void 0, void 0, function* () {
            let resolver = null;
            if (lib_esm_isHexString(nameOrAddress)) {
                // Address; reverse lookup
                const address = this.formatter.address(nameOrAddress);
                const node = address.substring(2).toLowerCase() + ".addr.reverse";
                const resolverAddress = yield this._getResolver(node, "getAvatar");
                if (!resolverAddress) {
                    return null;
                }
                // Try resolving the avatar against the addr.reverse resolver
                resolver = new Resolver(this, resolverAddress, node);
                try {
                    const avatar = yield resolver.getAvatar();
                    if (avatar) {
                        return avatar.url;
                    }
                }
                catch (error) {
                    if (error.code !== lib_esm_Logger.errors.CALL_EXCEPTION) {
                        throw error;
                    }
                }
                // Try getting the name and performing forward lookup; allowing wildcards
                try {
                    // keccak("name(bytes32)")
                    const name = _parseString(yield this.call({
                        to: resolverAddress,
                        data: ("0x691f3431" + namehash(node).substring(2))
                    }), 0);
                    resolver = yield this.getResolver(name);
                }
                catch (error) {
                    if (error.code !== lib_esm_Logger.errors.CALL_EXCEPTION) {
                        throw error;
                    }
                    return null;
                }
            }
            else {
                // ENS name; forward lookup with wildcard
                resolver = yield this.getResolver(nameOrAddress);
                if (!resolver) {
                    return null;
                }
            }
            const avatar = yield resolver.getAvatar();
            if (avatar == null) {
                return null;
            }
            return avatar.url;
        });
    }
    perform(method, params) {
        return base_provider_logger.throwError(method + " not implemented", lib_esm_Logger.errors.NOT_IMPLEMENTED, { operation: method });
    }
    _startEvent(event) {
        this.polling = (this._events.filter((e) => e.pollable()).length > 0);
    }
    _stopEvent(event) {
        this.polling = (this._events.filter((e) => e.pollable()).length > 0);
    }
    _addEventListener(eventName, listener, once) {
        const event = new Event(getEventTag(eventName), listener, once);
        this._events.push(event);
        this._startEvent(event);
        return this;
    }
    on(eventName, listener) {
        return this._addEventListener(eventName, listener, false);
    }
    once(eventName, listener) {
        return this._addEventListener(eventName, listener, true);
    }
    emit(eventName, ...args) {
        let result = false;
        let stopped = [];
        let eventTag = getEventTag(eventName);
        this._events = this._events.filter((event) => {
            if (event.tag !== eventTag) {
                return true;
            }
            setTimeout(() => {
                event.listener.apply(this, args);
            }, 0);
            result = true;
            if (event.once) {
                stopped.push(event);
                return false;
            }
            return true;
        });
        stopped.forEach((event) => { this._stopEvent(event); });
        return result;
    }
    listenerCount(eventName) {
        if (!eventName) {
            return this._events.length;
        }
        let eventTag = getEventTag(eventName);
        return this._events.filter((event) => {
            return (event.tag === eventTag);
        }).length;
    }
    listeners(eventName) {
        if (eventName == null) {
            return this._events.map((event) => event.listener);
        }
        let eventTag = getEventTag(eventName);
        return this._events
            .filter((event) => (event.tag === eventTag))
            .map((event) => event.listener);
    }
    off(eventName, listener) {
        if (listener == null) {
            return this.removeAllListeners(eventName);
        }
        const stopped = [];
        let found = false;
        let eventTag = getEventTag(eventName);
        this._events = this._events.filter((event) => {
            if (event.tag !== eventTag || event.listener != listener) {
                return true;
            }
            if (found) {
                return true;
            }
            found = true;
            stopped.push(event);
            return false;
        });
        stopped.forEach((event) => { this._stopEvent(event); });
        return this;
    }
    removeAllListeners(eventName) {
        let stopped = [];
        if (eventName == null) {
            stopped = this._events;
            this._events = [];
        }
        else {
            const eventTag = getEventTag(eventName);
            this._events = this._events.filter((event) => {
                if (event.tag !== eventTag) {
                    return true;
                }
                stopped.push(event);
                return false;
            });
        }
        stopped.forEach((event) => { this._stopEvent(event); });
        return this;
    }
}
//# sourceMappingURL=base-provider.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+providers@5.7.2_bufferutil@4.0.7_utf-8-validate@5.0.10/node_modules/@ethersproject/providers/lib.esm/json-rpc-provider.js

var json_rpc_provider_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};










const json_rpc_provider_logger = new lib_esm_Logger(providers_lib_esm_version_version);

const errorGas = ["call", "estimateGas"];
function spelunk(value, requireData) {
    if (value == null) {
        return null;
    }
    // These *are* the droids we're looking for.
    if (typeof (value.message) === "string" && value.message.match("reverted")) {
        const data = lib_esm_isHexString(value.data) ? value.data : null;
        if (!requireData || data) {
            return { message: value.message, data };
        }
    }
    // Spelunk further...
    if (typeof (value) === "object") {
        for (const key in value) {
            const result = spelunk(value[key], requireData);
            if (result) {
                return result;
            }
        }
        return null;
    }
    // Might be a JSON string we can further descend...
    if (typeof (value) === "string") {
        try {
            return spelunk(JSON.parse(value), requireData);
        }
        catch (error) { }
    }
    return null;
}
function checkError(method, error, params) {
    const transaction = params.transaction || params.signedTransaction;
    // Undo the "convenience" some nodes are attempting to prevent backwards
    // incompatibility; maybe for v6 consider forwarding reverts as errors
    if (method === "call") {
        const result = spelunk(error, true);
        if (result) {
            return result.data;
        }
        // Nothing descriptive..
        json_rpc_provider_logger.throwError("missing revert data in call exception; Transaction reverted without a reason string", lib_esm_Logger.errors.CALL_EXCEPTION, {
            data: "0x", transaction, error
        });
    }
    if (method === "estimateGas") {
        // Try to find something, with a preference on SERVER_ERROR body
        let result = spelunk(error.body, false);
        if (result == null) {
            result = spelunk(error, false);
        }
        // Found "reverted", this is a CALL_EXCEPTION
        if (result) {
            json_rpc_provider_logger.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", lib_esm_Logger.errors.UNPREDICTABLE_GAS_LIMIT, {
                reason: result.message, method, transaction, error
            });
        }
    }
    // @TODO: Should we spelunk for message too?
    let message = error.message;
    if (error.code === lib_esm_Logger.errors.SERVER_ERROR && error.error && typeof (error.error.message) === "string") {
        message = error.error.message;
    }
    else if (typeof (error.body) === "string") {
        message = error.body;
    }
    else if (typeof (error.responseText) === "string") {
        message = error.responseText;
    }
    message = (message || "").toLowerCase();
    // "insufficient funds for gas * price + value + cost(data)"
    if (message.match(/insufficient funds|base fee exceeds gas limit|InsufficientFunds/i)) {
        json_rpc_provider_logger.throwError("insufficient funds for intrinsic transaction cost", lib_esm_Logger.errors.INSUFFICIENT_FUNDS, {
            error, method, transaction
        });
    }
    // "nonce too low"
    if (message.match(/nonce (is )?too low/i)) {
        json_rpc_provider_logger.throwError("nonce has already been used", lib_esm_Logger.errors.NONCE_EXPIRED, {
            error, method, transaction
        });
    }
    // "replacement transaction underpriced"
    if (message.match(/replacement transaction underpriced|transaction gas price.*too low/i)) {
        json_rpc_provider_logger.throwError("replacement fee too low", lib_esm_Logger.errors.REPLACEMENT_UNDERPRICED, {
            error, method, transaction
        });
    }
    // "replacement transaction underpriced"
    if (message.match(/only replay-protected/i)) {
        json_rpc_provider_logger.throwError("legacy pre-eip-155 transactions not supported", lib_esm_Logger.errors.UNSUPPORTED_OPERATION, {
            error, method, transaction
        });
    }
    if (errorGas.indexOf(method) >= 0 && message.match(/gas required exceeds allowance|always failing transaction|execution reverted|revert/)) {
        json_rpc_provider_logger.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", lib_esm_Logger.errors.UNPREDICTABLE_GAS_LIMIT, {
            error, method, transaction
        });
    }
    throw error;
}
function timer(timeout) {
    return new Promise(function (resolve) {
        setTimeout(resolve, timeout);
    });
}
function getResult(payload) {
    if (payload.error) {
        // @TODO: not any
        const error = new Error(payload.error.message);
        error.code = payload.error.code;
        error.data = payload.error.data;
        throw error;
    }
    return payload.result;
}
function getLowerCase(value) {
    if (value) {
        return value.toLowerCase();
    }
    return value;
}
const json_rpc_provider_constructorGuard = {};
class JsonRpcSigner extends lib_esm_Signer {
    constructor(constructorGuard, provider, addressOrIndex) {
        super();
        if (constructorGuard !== json_rpc_provider_constructorGuard) {
            throw new Error("do not call the JsonRpcSigner constructor directly; use provider.getSigner");
        }
        lib_esm_defineReadOnly(this, "provider", provider);
        if (addressOrIndex == null) {
            addressOrIndex = 0;
        }
        if (typeof (addressOrIndex) === "string") {
            lib_esm_defineReadOnly(this, "_address", this.provider.formatter.address(addressOrIndex));
            lib_esm_defineReadOnly(this, "_index", null);
        }
        else if (typeof (addressOrIndex) === "number") {
            lib_esm_defineReadOnly(this, "_index", addressOrIndex);
            lib_esm_defineReadOnly(this, "_address", null);
        }
        else {
            json_rpc_provider_logger.throwArgumentError("invalid address or index", "addressOrIndex", addressOrIndex);
        }
    }
    connect(provider) {
        return json_rpc_provider_logger.throwError("cannot alter JSON-RPC Signer connection", lib_esm_Logger.errors.UNSUPPORTED_OPERATION, {
            operation: "connect"
        });
    }
    connectUnchecked() {
        return new UncheckedJsonRpcSigner(json_rpc_provider_constructorGuard, this.provider, this._address || this._index);
    }
    getAddress() {
        if (this._address) {
            return Promise.resolve(this._address);
        }
        return this.provider.send("eth_accounts", []).then((accounts) => {
            if (accounts.length <= this._index) {
                json_rpc_provider_logger.throwError("unknown account #" + this._index, lib_esm_Logger.errors.UNSUPPORTED_OPERATION, {
                    operation: "getAddress"
                });
            }
            return this.provider.formatter.address(accounts[this._index]);
        });
    }
    sendUncheckedTransaction(transaction) {
        transaction = lib_esm_shallowCopy(transaction);
        const fromAddress = this.getAddress().then((address) => {
            if (address) {
                address = address.toLowerCase();
            }
            return address;
        });
        // The JSON-RPC for eth_sendTransaction uses 90000 gas; if the user
        // wishes to use this, it is easy to specify explicitly, otherwise
        // we look it up for them.
        if (transaction.gasLimit == null) {
            const estimate = lib_esm_shallowCopy(transaction);
            estimate.from = fromAddress;
            transaction.gasLimit = this.provider.estimateGas(estimate);
        }
        if (transaction.to != null) {
            transaction.to = Promise.resolve(transaction.to).then((to) => json_rpc_provider_awaiter(this, void 0, void 0, function* () {
                if (to == null) {
                    return null;
                }
                const address = yield this.provider.resolveName(to);
                if (address == null) {
                    json_rpc_provider_logger.throwArgumentError("provided ENS name resolves to null", "tx.to", to);
                }
                return address;
            }));
        }
        return resolveProperties({
            tx: resolveProperties(transaction),
            sender: fromAddress
        }).then(({ tx, sender }) => {
            if (tx.from != null) {
                if (tx.from.toLowerCase() !== sender) {
                    json_rpc_provider_logger.throwArgumentError("from address mismatch", "transaction", transaction);
                }
            }
            else {
                tx.from = sender;
            }
            const hexTx = this.provider.constructor.hexlifyTransaction(tx, { from: true });
            return this.provider.send("eth_sendTransaction", [hexTx]).then((hash) => {
                return hash;
            }, (error) => {
                if (typeof (error.message) === "string" && error.message.match(/user denied/i)) {
                    json_rpc_provider_logger.throwError("user rejected transaction", lib_esm_Logger.errors.ACTION_REJECTED, {
                        action: "sendTransaction",
                        transaction: tx
                    });
                }
                return checkError("sendTransaction", error, hexTx);
            });
        });
    }
    signTransaction(transaction) {
        return json_rpc_provider_logger.throwError("signing transactions is unsupported", lib_esm_Logger.errors.UNSUPPORTED_OPERATION, {
            operation: "signTransaction"
        });
    }
    sendTransaction(transaction) {
        return json_rpc_provider_awaiter(this, void 0, void 0, function* () {
            // This cannot be mined any earlier than any recent block
            const blockNumber = yield this.provider._getInternalBlockNumber(100 + 2 * this.provider.pollingInterval);
            // Send the transaction
            const hash = yield this.sendUncheckedTransaction(transaction);
            try {
                // Unfortunately, JSON-RPC only provides and opaque transaction hash
                // for a response, and we need the actual transaction, so we poll
                // for it; it should show up very quickly
                return yield poll(() => json_rpc_provider_awaiter(this, void 0, void 0, function* () {
                    const tx = yield this.provider.getTransaction(hash);
                    if (tx === null) {
                        return undefined;
                    }
                    return this.provider._wrapTransaction(tx, hash, blockNumber);
                }), { oncePoll: this.provider });
            }
            catch (error) {
                error.transactionHash = hash;
                throw error;
            }
        });
    }
    signMessage(message) {
        return json_rpc_provider_awaiter(this, void 0, void 0, function* () {
            const data = ((typeof (message) === "string") ? toUtf8Bytes(message) : message);
            const address = yield this.getAddress();
            try {
                return yield this.provider.send("personal_sign", [lib_esm_hexlify(data), address.toLowerCase()]);
            }
            catch (error) {
                if (typeof (error.message) === "string" && error.message.match(/user denied/i)) {
                    json_rpc_provider_logger.throwError("user rejected signing", lib_esm_Logger.errors.ACTION_REJECTED, {
                        action: "signMessage",
                        from: address,
                        messageData: message
                    });
                }
                throw error;
            }
        });
    }
    _legacySignMessage(message) {
        return json_rpc_provider_awaiter(this, void 0, void 0, function* () {
            const data = ((typeof (message) === "string") ? toUtf8Bytes(message) : message);
            const address = yield this.getAddress();
            try {
                // https://github.com/ethereum/wiki/wiki/JSON-RPC#eth_sign
                return yield this.provider.send("eth_sign", [address.toLowerCase(), lib_esm_hexlify(data)]);
            }
            catch (error) {
                if (typeof (error.message) === "string" && error.message.match(/user denied/i)) {
                    json_rpc_provider_logger.throwError("user rejected signing", lib_esm_Logger.errors.ACTION_REJECTED, {
                        action: "_legacySignMessage",
                        from: address,
                        messageData: message
                    });
                }
                throw error;
            }
        });
    }
    _signTypedData(domain, types, value) {
        return json_rpc_provider_awaiter(this, void 0, void 0, function* () {
            // Populate any ENS names (in-place)
            const populated = yield TypedDataEncoder.resolveNames(domain, types, value, (name) => {
                return this.provider.resolveName(name);
            });
            const address = yield this.getAddress();
            try {
                return yield this.provider.send("eth_signTypedData_v4", [
                    address.toLowerCase(),
                    JSON.stringify(TypedDataEncoder.getPayload(populated.domain, types, populated.value))
                ]);
            }
            catch (error) {
                if (typeof (error.message) === "string" && error.message.match(/user denied/i)) {
                    json_rpc_provider_logger.throwError("user rejected signing", lib_esm_Logger.errors.ACTION_REJECTED, {
                        action: "_signTypedData",
                        from: address,
                        messageData: { domain: populated.domain, types, value: populated.value }
                    });
                }
                throw error;
            }
        });
    }
    unlock(password) {
        return json_rpc_provider_awaiter(this, void 0, void 0, function* () {
            const provider = this.provider;
            const address = yield this.getAddress();
            return provider.send("personal_unlockAccount", [address.toLowerCase(), password, null]);
        });
    }
}
class UncheckedJsonRpcSigner extends JsonRpcSigner {
    sendTransaction(transaction) {
        return this.sendUncheckedTransaction(transaction).then((hash) => {
            return {
                hash: hash,
                nonce: null,
                gasLimit: null,
                gasPrice: null,
                data: null,
                value: null,
                chainId: null,
                confirmations: 0,
                from: null,
                wait: (confirmations) => { return this.provider.waitForTransaction(hash, confirmations); }
            };
        });
    }
}
const json_rpc_provider_allowedTransactionKeys = {
    chainId: true, data: true, gasLimit: true, gasPrice: true, nonce: true, to: true, value: true,
    type: true, accessList: true,
    maxFeePerGas: true, maxPriorityFeePerGas: true
};
class JsonRpcProvider extends BaseProvider {
    constructor(url, network) {
        let networkOrReady = network;
        // The network is unknown, query the JSON-RPC for it
        if (networkOrReady == null) {
            networkOrReady = new Promise((resolve, reject) => {
                setTimeout(() => {
                    this.detectNetwork().then((network) => {
                        resolve(network);
                    }, (error) => {
                        reject(error);
                    });
                }, 0);
            });
        }
        super(networkOrReady);
        // Default URL
        if (!url) {
            url = lib_esm_getStatic(this.constructor, "defaultUrl")();
        }
        if (typeof (url) === "string") {
            lib_esm_defineReadOnly(this, "connection", Object.freeze({
                url: url
            }));
        }
        else {
            lib_esm_defineReadOnly(this, "connection", Object.freeze(lib_esm_shallowCopy(url)));
        }
        this._nextId = 42;
    }
    get _cache() {
        if (this._eventLoopCache == null) {
            this._eventLoopCache = {};
        }
        return this._eventLoopCache;
    }
    static defaultUrl() {
        return "http:/\/localhost:8545";
    }
    detectNetwork() {
        if (!this._cache["detectNetwork"]) {
            this._cache["detectNetwork"] = this._uncachedDetectNetwork();
            // Clear this cache at the beginning of the next event loop
            setTimeout(() => {
                this._cache["detectNetwork"] = null;
            }, 0);
        }
        return this._cache["detectNetwork"];
    }
    _uncachedDetectNetwork() {
        return json_rpc_provider_awaiter(this, void 0, void 0, function* () {
            yield timer(0);
            let chainId = null;
            try {
                chainId = yield this.send("eth_chainId", []);
            }
            catch (error) {
                try {
                    chainId = yield this.send("net_version", []);
                }
                catch (error) { }
            }
            if (chainId != null) {
                const getNetwork = lib_esm_getStatic(this.constructor, "getNetwork");
                try {
                    return getNetwork(bignumber_BigNumber.from(chainId).toNumber());
                }
                catch (error) {
                    return json_rpc_provider_logger.throwError("could not detect network", lib_esm_Logger.errors.NETWORK_ERROR, {
                        chainId: chainId,
                        event: "invalidNetwork",
                        serverError: error
                    });
                }
            }
            return json_rpc_provider_logger.throwError("could not detect network", lib_esm_Logger.errors.NETWORK_ERROR, {
                event: "noNetwork"
            });
        });
    }
    getSigner(addressOrIndex) {
        return new JsonRpcSigner(json_rpc_provider_constructorGuard, this, addressOrIndex);
    }
    getUncheckedSigner(addressOrIndex) {
        return this.getSigner(addressOrIndex).connectUnchecked();
    }
    listAccounts() {
        return this.send("eth_accounts", []).then((accounts) => {
            return accounts.map((a) => this.formatter.address(a));
        });
    }
    send(method, params) {
        const request = {
            method: method,
            params: params,
            id: (this._nextId++),
            jsonrpc: "2.0"
        };
        this.emit("debug", {
            action: "request",
            request: deepCopy(request),
            provider: this
        });
        // We can expand this in the future to any call, but for now these
        // are the biggest wins and do not require any serializing parameters.
        const cache = (["eth_chainId", "eth_blockNumber"].indexOf(method) >= 0);
        if (cache && this._cache[method]) {
            return this._cache[method];
        }
        const result = fetchJson(this.connection, JSON.stringify(request), getResult).then((result) => {
            this.emit("debug", {
                action: "response",
                request: request,
                response: result,
                provider: this
            });
            return result;
        }, (error) => {
            this.emit("debug", {
                action: "response",
                error: error,
                request: request,
                provider: this
            });
            throw error;
        });
        // Cache the fetch, but clear it on the next event loop
        if (cache) {
            this._cache[method] = result;
            setTimeout(() => {
                this._cache[method] = null;
            }, 0);
        }
        return result;
    }
    prepareRequest(method, params) {
        switch (method) {
            case "getBlockNumber":
                return ["eth_blockNumber", []];
            case "getGasPrice":
                return ["eth_gasPrice", []];
            case "getBalance":
                return ["eth_getBalance", [getLowerCase(params.address), params.blockTag]];
            case "getTransactionCount":
                return ["eth_getTransactionCount", [getLowerCase(params.address), params.blockTag]];
            case "getCode":
                return ["eth_getCode", [getLowerCase(params.address), params.blockTag]];
            case "getStorageAt":
                return ["eth_getStorageAt", [getLowerCase(params.address), hexZeroPad(params.position, 32), params.blockTag]];
            case "sendTransaction":
                return ["eth_sendRawTransaction", [params.signedTransaction]];
            case "getBlock":
                if (params.blockTag) {
                    return ["eth_getBlockByNumber", [params.blockTag, !!params.includeTransactions]];
                }
                else if (params.blockHash) {
                    return ["eth_getBlockByHash", [params.blockHash, !!params.includeTransactions]];
                }
                return null;
            case "getTransaction":
                return ["eth_getTransactionByHash", [params.transactionHash]];
            case "getTransactionReceipt":
                return ["eth_getTransactionReceipt", [params.transactionHash]];
            case "call": {
                const hexlifyTransaction = lib_esm_getStatic(this.constructor, "hexlifyTransaction");
                return ["eth_call", [hexlifyTransaction(params.transaction, { from: true }), params.blockTag]];
            }
            case "estimateGas": {
                const hexlifyTransaction = lib_esm_getStatic(this.constructor, "hexlifyTransaction");
                return ["eth_estimateGas", [hexlifyTransaction(params.transaction, { from: true })]];
            }
            case "getLogs":
                if (params.filter && params.filter.address != null) {
                    params.filter.address = getLowerCase(params.filter.address);
                }
                return ["eth_getLogs", [params.filter]];
            default:
                break;
        }
        return null;
    }
    perform(method, params) {
        return json_rpc_provider_awaiter(this, void 0, void 0, function* () {
            // Legacy networks do not like the type field being passed along (which
            // is fair), so we delete type if it is 0 and a non-EIP-1559 network
            if (method === "call" || method === "estimateGas") {
                const tx = params.transaction;
                if (tx && tx.type != null && bignumber_BigNumber.from(tx.type).isZero()) {
                    // If there are no EIP-1559 properties, it might be non-EIP-1559
                    if (tx.maxFeePerGas == null && tx.maxPriorityFeePerGas == null) {
                        const feeData = yield this.getFeeData();
                        if (feeData.maxFeePerGas == null && feeData.maxPriorityFeePerGas == null) {
                            // Network doesn't know about EIP-1559 (and hence type)
                            params = lib_esm_shallowCopy(params);
                            params.transaction = lib_esm_shallowCopy(tx);
                            delete params.transaction.type;
                        }
                    }
                }
            }
            const args = this.prepareRequest(method, params);
            if (args == null) {
                json_rpc_provider_logger.throwError(method + " not implemented", lib_esm_Logger.errors.NOT_IMPLEMENTED, { operation: method });
            }
            try {
                return yield this.send(args[0], args[1]);
            }
            catch (error) {
                return checkError(method, error, params);
            }
        });
    }
    _startEvent(event) {
        if (event.tag === "pending") {
            this._startPending();
        }
        super._startEvent(event);
    }
    _startPending() {
        if (this._pendingFilter != null) {
            return;
        }
        const self = this;
        const pendingFilter = this.send("eth_newPendingTransactionFilter", []);
        this._pendingFilter = pendingFilter;
        pendingFilter.then(function (filterId) {
            function poll() {
                self.send("eth_getFilterChanges", [filterId]).then(function (hashes) {
                    if (self._pendingFilter != pendingFilter) {
                        return null;
                    }
                    let seq = Promise.resolve();
                    hashes.forEach(function (hash) {
                        // @TODO: This should be garbage collected at some point... How? When?
                        self._emitted["t:" + hash.toLowerCase()] = "pending";
                        seq = seq.then(function () {
                            return self.getTransaction(hash).then(function (tx) {
                                self.emit("pending", tx);
                                return null;
                            });
                        });
                    });
                    return seq.then(function () {
                        return timer(1000);
                    });
                }).then(function () {
                    if (self._pendingFilter != pendingFilter) {
                        self.send("eth_uninstallFilter", [filterId]);
                        return;
                    }
                    setTimeout(function () { poll(); }, 0);
                    return null;
                }).catch((error) => { });
            }
            poll();
            return filterId;
        }).catch((error) => { });
    }
    _stopEvent(event) {
        if (event.tag === "pending" && this.listenerCount("pending") === 0) {
            this._pendingFilter = null;
        }
        super._stopEvent(event);
    }
    // Convert an ethers.js transaction into a JSON-RPC transaction
    //  - gasLimit => gas
    //  - All values hexlified
    //  - All numeric values zero-striped
    //  - All addresses are lowercased
    // NOTE: This allows a TransactionRequest, but all values should be resolved
    //       before this is called
    // @TODO: This will likely be removed in future versions and prepareRequest
    //        will be the preferred method for this.
    static hexlifyTransaction(transaction, allowExtra) {
        // Check only allowed properties are given
        const allowed = lib_esm_shallowCopy(json_rpc_provider_allowedTransactionKeys);
        if (allowExtra) {
            for (const key in allowExtra) {
                if (allowExtra[key]) {
                    allowed[key] = true;
                }
            }
        }
        checkProperties(transaction, allowed);
        const result = {};
        // JSON-RPC now requires numeric values to be "quantity" values
        ["chainId", "gasLimit", "gasPrice", "type", "maxFeePerGas", "maxPriorityFeePerGas", "nonce", "value"].forEach(function (key) {
            if (transaction[key] == null) {
                return;
            }
            const value = hexValue(bignumber_BigNumber.from(transaction[key]));
            if (key === "gasLimit") {
                key = "gas";
            }
            result[key] = value;
        });
        ["from", "to", "data"].forEach(function (key) {
            if (transaction[key] == null) {
                return;
            }
            result[key] = lib_esm_hexlify(transaction[key]);
        });
        if (transaction.accessList) {
            result["accessList"] = accessListify(transaction.accessList);
        }
        return result;
    }
}
//# sourceMappingURL=json-rpc-provider.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+abi@5.7.0/node_modules/@ethersproject/abi/lib.esm/_version.js
const abi_lib_esm_version_version = "abi/5.7.0";
//# sourceMappingURL=_version.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+abi@5.7.0/node_modules/@ethersproject/abi/lib.esm/coders/abstract-coder.js






const abstract_coder_logger = new lib_esm_Logger(abi_lib_esm_version_version);
function checkResultErrors(result) {
    // Find the first error (if any)
    const errors = [];
    const checkErrors = function (path, object) {
        if (!Array.isArray(object)) {
            return;
        }
        for (let key in object) {
            const childPath = path.slice();
            childPath.push(key);
            try {
                checkErrors(childPath, object[key]);
            }
            catch (error) {
                errors.push({ path: childPath, error: error });
            }
        }
    };
    checkErrors([], result);
    return errors;
}
class Coder {
    constructor(name, type, localName, dynamic) {
        // @TODO: defineReadOnly these
        this.name = name;
        this.type = type;
        this.localName = localName;
        this.dynamic = dynamic;
    }
    _throwError(message, value) {
        abstract_coder_logger.throwArgumentError(message, this.localName, value);
    }
}
class Writer {
    constructor(wordSize) {
        lib_esm_defineReadOnly(this, "wordSize", wordSize || 32);
        this._data = [];
        this._dataLength = 0;
        this._padding = new Uint8Array(wordSize);
    }
    get data() {
        return hexConcat(this._data);
    }
    get length() { return this._dataLength; }
    _writeData(data) {
        this._data.push(data);
        this._dataLength += data.length;
        return data.length;
    }
    appendWriter(writer) {
        return this._writeData(lib_esm_concat(writer._data));
    }
    // Arrayish items; padded on the right to wordSize
    writeBytes(value) {
        let bytes = lib_esm_arrayify(value);
        const paddingOffset = bytes.length % this.wordSize;
        if (paddingOffset) {
            bytes = lib_esm_concat([bytes, this._padding.slice(paddingOffset)]);
        }
        return this._writeData(bytes);
    }
    _getValue(value) {
        let bytes = lib_esm_arrayify(bignumber_BigNumber.from(value));
        if (bytes.length > this.wordSize) {
            abstract_coder_logger.throwError("value out-of-bounds", lib_esm_Logger.errors.BUFFER_OVERRUN, {
                length: this.wordSize,
                offset: bytes.length
            });
        }
        if (bytes.length % this.wordSize) {
            bytes = lib_esm_concat([this._padding.slice(bytes.length % this.wordSize), bytes]);
        }
        return bytes;
    }
    // BigNumberish items; padded on the left to wordSize
    writeValue(value) {
        return this._writeData(this._getValue(value));
    }
    writeUpdatableValue() {
        const offset = this._data.length;
        this._data.push(this._padding);
        this._dataLength += this.wordSize;
        return (value) => {
            this._data[offset] = this._getValue(value);
        };
    }
}
class Reader {
    constructor(data, wordSize, coerceFunc, allowLoose) {
        lib_esm_defineReadOnly(this, "_data", lib_esm_arrayify(data));
        lib_esm_defineReadOnly(this, "wordSize", wordSize || 32);
        lib_esm_defineReadOnly(this, "_coerceFunc", coerceFunc);
        lib_esm_defineReadOnly(this, "allowLoose", allowLoose);
        this._offset = 0;
    }
    get data() { return lib_esm_hexlify(this._data); }
    get consumed() { return this._offset; }
    // The default Coerce function
    static coerce(name, value) {
        let match = name.match("^u?int([0-9]+)$");
        if (match && parseInt(match[1]) <= 48) {
            value = value.toNumber();
        }
        return value;
    }
    coerce(name, value) {
        if (this._coerceFunc) {
            return this._coerceFunc(name, value);
        }
        return Reader.coerce(name, value);
    }
    _peekBytes(offset, length, loose) {
        let alignedLength = Math.ceil(length / this.wordSize) * this.wordSize;
        if (this._offset + alignedLength > this._data.length) {
            if (this.allowLoose && loose && this._offset + length <= this._data.length) {
                alignedLength = length;
            }
            else {
                abstract_coder_logger.throwError("data out-of-bounds", lib_esm_Logger.errors.BUFFER_OVERRUN, {
                    length: this._data.length,
                    offset: this._offset + alignedLength
                });
            }
        }
        return this._data.slice(this._offset, this._offset + alignedLength);
    }
    subReader(offset) {
        return new Reader(this._data.slice(this._offset + offset), this.wordSize, this._coerceFunc, this.allowLoose);
    }
    readBytes(length, loose) {
        let bytes = this._peekBytes(0, length, !!loose);
        this._offset += bytes.length;
        // @TODO: Make sure the length..end bytes are all 0?
        return bytes.slice(0, length);
    }
    readValue() {
        return bignumber_BigNumber.from(this.readBytes(this.wordSize));
    }
}
//# sourceMappingURL=abstract-coder.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+abi@5.7.0/node_modules/@ethersproject/abi/lib.esm/coders/address.js




class AddressCoder extends Coder {
    constructor(localName) {
        super("address", "address", localName, false);
    }
    defaultValue() {
        return "0x0000000000000000000000000000000000000000";
    }
    encode(writer, value) {
        try {
            value = lib_esm_getAddress(value);
        }
        catch (error) {
            this._throwError(error.message, value);
        }
        return writer.writeValue(value);
    }
    decode(reader) {
        return lib_esm_getAddress(hexZeroPad(reader.readValue().toHexString(), 20));
    }
}
//# sourceMappingURL=address.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+abi@5.7.0/node_modules/@ethersproject/abi/lib.esm/coders/anonymous.js


// Clones the functionality of an existing Coder, but without a localName
class AnonymousCoder extends Coder {
    constructor(coder) {
        super(coder.name, coder.type, undefined, coder.dynamic);
        this.coder = coder;
    }
    defaultValue() {
        return this.coder.defaultValue();
    }
    encode(writer, value) {
        return this.coder.encode(writer, value);
    }
    decode(reader) {
        return this.coder.decode(reader);
    }
}
//# sourceMappingURL=anonymous.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+abi@5.7.0/node_modules/@ethersproject/abi/lib.esm/coders/array.js



const array_logger = new lib_esm_Logger(abi_lib_esm_version_version);


function pack(writer, coders, values) {
    let arrayValues = null;
    if (Array.isArray(values)) {
        arrayValues = values;
    }
    else if (values && typeof (values) === "object") {
        let unique = {};
        arrayValues = coders.map((coder) => {
            const name = coder.localName;
            if (!name) {
                array_logger.throwError("cannot encode object for signature with missing names", lib_esm_Logger.errors.INVALID_ARGUMENT, {
                    argument: "values",
                    coder: coder,
                    value: values
                });
            }
            if (unique[name]) {
                array_logger.throwError("cannot encode object for signature with duplicate names", lib_esm_Logger.errors.INVALID_ARGUMENT, {
                    argument: "values",
                    coder: coder,
                    value: values
                });
            }
            unique[name] = true;
            return values[name];
        });
    }
    else {
        array_logger.throwArgumentError("invalid tuple value", "tuple", values);
    }
    if (coders.length !== arrayValues.length) {
        array_logger.throwArgumentError("types/value length mismatch", "tuple", values);
    }
    let staticWriter = new Writer(writer.wordSize);
    let dynamicWriter = new Writer(writer.wordSize);
    let updateFuncs = [];
    coders.forEach((coder, index) => {
        let value = arrayValues[index];
        if (coder.dynamic) {
            // Get current dynamic offset (for the future pointer)
            let dynamicOffset = dynamicWriter.length;
            // Encode the dynamic value into the dynamicWriter
            coder.encode(dynamicWriter, value);
            // Prepare to populate the correct offset once we are done
            let updateFunc = staticWriter.writeUpdatableValue();
            updateFuncs.push((baseOffset) => {
                updateFunc(baseOffset + dynamicOffset);
            });
        }
        else {
            coder.encode(staticWriter, value);
        }
    });
    // Backfill all the dynamic offsets, now that we know the static length
    updateFuncs.forEach((func) => { func(staticWriter.length); });
    let length = writer.appendWriter(staticWriter);
    length += writer.appendWriter(dynamicWriter);
    return length;
}
function unpack(reader, coders) {
    let values = [];
    // A reader anchored to this base
    let baseReader = reader.subReader(0);
    coders.forEach((coder) => {
        let value = null;
        if (coder.dynamic) {
            let offset = reader.readValue();
            let offsetReader = baseReader.subReader(offset.toNumber());
            try {
                value = coder.decode(offsetReader);
            }
            catch (error) {
                // Cannot recover from this
                if (error.code === lib_esm_Logger.errors.BUFFER_OVERRUN) {
                    throw error;
                }
                value = error;
                value.baseType = coder.name;
                value.name = coder.localName;
                value.type = coder.type;
            }
        }
        else {
            try {
                value = coder.decode(reader);
            }
            catch (error) {
                // Cannot recover from this
                if (error.code === lib_esm_Logger.errors.BUFFER_OVERRUN) {
                    throw error;
                }
                value = error;
                value.baseType = coder.name;
                value.name = coder.localName;
                value.type = coder.type;
            }
        }
        if (value != undefined) {
            values.push(value);
        }
    });
    // We only output named properties for uniquely named coders
    const uniqueNames = coders.reduce((accum, coder) => {
        const name = coder.localName;
        if (name) {
            if (!accum[name]) {
                accum[name] = 0;
            }
            accum[name]++;
        }
        return accum;
    }, {});
    // Add any named parameters (i.e. tuples)
    coders.forEach((coder, index) => {
        let name = coder.localName;
        if (!name || uniqueNames[name] !== 1) {
            return;
        }
        if (name === "length") {
            name = "_length";
        }
        if (values[name] != null) {
            return;
        }
        const value = values[index];
        if (value instanceof Error) {
            Object.defineProperty(values, name, {
                enumerable: true,
                get: () => { throw value; }
            });
        }
        else {
            values[name] = value;
        }
    });
    for (let i = 0; i < values.length; i++) {
        const value = values[i];
        if (value instanceof Error) {
            Object.defineProperty(values, i, {
                enumerable: true,
                get: () => { throw value; }
            });
        }
    }
    return Object.freeze(values);
}
class ArrayCoder extends Coder {
    constructor(coder, length, localName) {
        const type = (coder.type + "[" + (length >= 0 ? length : "") + "]");
        const dynamic = (length === -1 || coder.dynamic);
        super("array", type, localName, dynamic);
        this.coder = coder;
        this.length = length;
    }
    defaultValue() {
        // Verifies the child coder is valid (even if the array is dynamic or 0-length)
        const defaultChild = this.coder.defaultValue();
        const result = [];
        for (let i = 0; i < this.length; i++) {
            result.push(defaultChild);
        }
        return result;
    }
    encode(writer, value) {
        if (!Array.isArray(value)) {
            this._throwError("expected array value", value);
        }
        let count = this.length;
        if (count === -1) {
            count = value.length;
            writer.writeValue(value.length);
        }
        array_logger.checkArgumentCount(value.length, count, "coder array" + (this.localName ? (" " + this.localName) : ""));
        let coders = [];
        for (let i = 0; i < value.length; i++) {
            coders.push(this.coder);
        }
        return pack(writer, coders, value);
    }
    decode(reader) {
        let count = this.length;
        if (count === -1) {
            count = reader.readValue().toNumber();
            // Check that there is *roughly* enough data to ensure
            // stray random data is not being read as a length. Each
            // slot requires at least 32 bytes for their value (or 32
            // bytes as a link to the data). This could use a much
            // tighter bound, but we are erroring on the side of safety.
            if (count * 32 > reader._data.length) {
                array_logger.throwError("insufficient data length", lib_esm_Logger.errors.BUFFER_OVERRUN, {
                    length: reader._data.length,
                    count: count
                });
            }
        }
        let coders = [];
        for (let i = 0; i < count; i++) {
            coders.push(new AnonymousCoder(this.coder));
        }
        return reader.coerce(this.name, unpack(reader, coders));
    }
}
//# sourceMappingURL=array.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+abi@5.7.0/node_modules/@ethersproject/abi/lib.esm/coders/boolean.js


class BooleanCoder extends Coder {
    constructor(localName) {
        super("bool", "bool", localName, false);
    }
    defaultValue() {
        return false;
    }
    encode(writer, value) {
        return writer.writeValue(value ? 1 : 0);
    }
    decode(reader) {
        return reader.coerce(this.type, !reader.readValue().isZero());
    }
}
//# sourceMappingURL=boolean.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+abi@5.7.0/node_modules/@ethersproject/abi/lib.esm/coders/bytes.js



class DynamicBytesCoder extends Coder {
    constructor(type, localName) {
        super(type, type, localName, true);
    }
    defaultValue() {
        return "0x";
    }
    encode(writer, value) {
        value = lib_esm_arrayify(value);
        let length = writer.writeValue(value.length);
        length += writer.writeBytes(value);
        return length;
    }
    decode(reader) {
        return reader.readBytes(reader.readValue().toNumber(), true);
    }
}
class BytesCoder extends DynamicBytesCoder {
    constructor(localName) {
        super("bytes", localName);
    }
    decode(reader) {
        return reader.coerce(this.name, lib_esm_hexlify(super.decode(reader)));
    }
}
//# sourceMappingURL=bytes.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+abi@5.7.0/node_modules/@ethersproject/abi/lib.esm/coders/fixed-bytes.js



// @TODO: Merge this with bytes
class FixedBytesCoder extends Coder {
    constructor(size, localName) {
        let name = "bytes" + String(size);
        super(name, name, localName, false);
        this.size = size;
    }
    defaultValue() {
        return ("0x0000000000000000000000000000000000000000000000000000000000000000").substring(0, 2 + this.size * 2);
    }
    encode(writer, value) {
        let data = lib_esm_arrayify(value);
        if (data.length !== this.size) {
            this._throwError("incorrect data length", value);
        }
        return writer.writeBytes(data);
    }
    decode(reader) {
        return reader.coerce(this.name, lib_esm_hexlify(reader.readBytes(this.size)));
    }
}
//# sourceMappingURL=fixed-bytes.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+abi@5.7.0/node_modules/@ethersproject/abi/lib.esm/coders/null.js


class NullCoder extends Coder {
    constructor(localName) {
        super("null", "", localName, false);
    }
    defaultValue() {
        return null;
    }
    encode(writer, value) {
        if (value != null) {
            this._throwError("not null", value);
        }
        return writer.writeBytes([]);
    }
    decode(reader) {
        reader.readBytes(0);
        return reader.coerce(this.name, null);
    }
}
//# sourceMappingURL=null.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+abi@5.7.0/node_modules/@ethersproject/abi/lib.esm/coders/number.js




class NumberCoder extends Coder {
    constructor(size, signed, localName) {
        const name = ((signed ? "int" : "uint") + (size * 8));
        super(name, name, localName, false);
        this.size = size;
        this.signed = signed;
    }
    defaultValue() {
        return 0;
    }
    encode(writer, value) {
        let v = bignumber_BigNumber.from(value);
        // Check bounds are safe for encoding
        let maxUintValue = bignumbers_MaxUint256.mask(writer.wordSize * 8);
        if (this.signed) {
            let bounds = maxUintValue.mask(this.size * 8 - 1);
            if (v.gt(bounds) || v.lt(bounds.add(bignumbers_One).mul(bignumbers_NegativeOne))) {
                this._throwError("value out-of-bounds", value);
            }
        }
        else if (v.lt(bignumbers_Zero) || v.gt(maxUintValue.mask(this.size * 8))) {
            this._throwError("value out-of-bounds", value);
        }
        v = v.toTwos(this.size * 8).mask(this.size * 8);
        if (this.signed) {
            v = v.fromTwos(this.size * 8).toTwos(8 * writer.wordSize);
        }
        return writer.writeValue(v);
    }
    decode(reader) {
        let value = reader.readValue().mask(this.size * 8);
        if (this.signed) {
            value = value.fromTwos(this.size * 8);
        }
        return reader.coerce(this.name, value);
    }
}
//# sourceMappingURL=number.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+abi@5.7.0/node_modules/@ethersproject/abi/lib.esm/coders/string.js



class StringCoder extends DynamicBytesCoder {
    constructor(localName) {
        super("string", localName);
    }
    defaultValue() {
        return "";
    }
    encode(writer, value) {
        return super.encode(writer, toUtf8Bytes(value));
    }
    decode(reader) {
        return utf8_toUtf8String(super.decode(reader));
    }
}
//# sourceMappingURL=string.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+abi@5.7.0/node_modules/@ethersproject/abi/lib.esm/coders/tuple.js



class TupleCoder extends Coder {
    constructor(coders, localName) {
        let dynamic = false;
        const types = [];
        coders.forEach((coder) => {
            if (coder.dynamic) {
                dynamic = true;
            }
            types.push(coder.type);
        });
        const type = ("tuple(" + types.join(",") + ")");
        super("tuple", type, localName, dynamic);
        this.coders = coders;
    }
    defaultValue() {
        const values = [];
        this.coders.forEach((coder) => {
            values.push(coder.defaultValue());
        });
        // We only output named properties for uniquely named coders
        const uniqueNames = this.coders.reduce((accum, coder) => {
            const name = coder.localName;
            if (name) {
                if (!accum[name]) {
                    accum[name] = 0;
                }
                accum[name]++;
            }
            return accum;
        }, {});
        // Add named values
        this.coders.forEach((coder, index) => {
            let name = coder.localName;
            if (!name || uniqueNames[name] !== 1) {
                return;
            }
            if (name === "length") {
                name = "_length";
            }
            if (values[name] != null) {
                return;
            }
            values[name] = values[index];
        });
        return Object.freeze(values);
    }
    encode(writer, value) {
        return pack(writer, this.coders, value);
    }
    decode(reader) {
        return reader.coerce(this.name, unpack(reader, this.coders));
    }
}
//# sourceMappingURL=tuple.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+abi@5.7.0/node_modules/@ethersproject/abi/lib.esm/fragments.js





const fragments_logger = new lib_esm_Logger(abi_lib_esm_version_version);
;
const fragments_constructorGuard = {};
let ModifiersBytes = { calldata: true, memory: true, storage: true };
let ModifiersNest = { calldata: true, memory: true };
function checkModifier(type, name) {
    if (type === "bytes" || type === "string") {
        if (ModifiersBytes[name]) {
            return true;
        }
    }
    else if (type === "address") {
        if (name === "payable") {
            return true;
        }
    }
    else if (type.indexOf("[") >= 0 || type === "tuple") {
        if (ModifiersNest[name]) {
            return true;
        }
    }
    if (ModifiersBytes[name] || name === "payable") {
        fragments_logger.throwArgumentError("invalid modifier", "name", name);
    }
    return false;
}
// @TODO: Make sure that children of an indexed tuple are marked with a null indexed
function parseParamType(param, allowIndexed) {
    let originalParam = param;
    function throwError(i) {
        fragments_logger.throwArgumentError(`unexpected character at position ${i}`, "param", param);
    }
    param = param.replace(/\s/g, " ");
    function newNode(parent) {
        let node = { type: "", name: "", parent: parent, state: { allowType: true } };
        if (allowIndexed) {
            node.indexed = false;
        }
        return node;
    }
    let parent = { type: "", name: "", state: { allowType: true } };
    let node = parent;
    for (let i = 0; i < param.length; i++) {
        let c = param[i];
        switch (c) {
            case "(":
                if (node.state.allowType && node.type === "") {
                    node.type = "tuple";
                }
                else if (!node.state.allowParams) {
                    throwError(i);
                }
                node.state.allowType = false;
                node.type = verifyType(node.type);
                node.components = [newNode(node)];
                node = node.components[0];
                break;
            case ")":
                delete node.state;
                if (node.name === "indexed") {
                    if (!allowIndexed) {
                        throwError(i);
                    }
                    node.indexed = true;
                    node.name = "";
                }
                if (checkModifier(node.type, node.name)) {
                    node.name = "";
                }
                node.type = verifyType(node.type);
                let child = node;
                node = node.parent;
                if (!node) {
                    throwError(i);
                }
                delete child.parent;
                node.state.allowParams = false;
                node.state.allowName = true;
                node.state.allowArray = true;
                break;
            case ",":
                delete node.state;
                if (node.name === "indexed") {
                    if (!allowIndexed) {
                        throwError(i);
                    }
                    node.indexed = true;
                    node.name = "";
                }
                if (checkModifier(node.type, node.name)) {
                    node.name = "";
                }
                node.type = verifyType(node.type);
                let sibling = newNode(node.parent);
                //{ type: "", name: "", parent: node.parent, state: { allowType: true } };
                node.parent.components.push(sibling);
                delete node.parent;
                node = sibling;
                break;
            // Hit a space...
            case " ":
                // If reading type, the type is done and may read a param or name
                if (node.state.allowType) {
                    if (node.type !== "") {
                        node.type = verifyType(node.type);
                        delete node.state.allowType;
                        node.state.allowName = true;
                        node.state.allowParams = true;
                    }
                }
                // If reading name, the name is done
                if (node.state.allowName) {
                    if (node.name !== "") {
                        if (node.name === "indexed") {
                            if (!allowIndexed) {
                                throwError(i);
                            }
                            if (node.indexed) {
                                throwError(i);
                            }
                            node.indexed = true;
                            node.name = "";
                        }
                        else if (checkModifier(node.type, node.name)) {
                            node.name = "";
                        }
                        else {
                            node.state.allowName = false;
                        }
                    }
                }
                break;
            case "[":
                if (!node.state.allowArray) {
                    throwError(i);
                }
                node.type += c;
                node.state.allowArray = false;
                node.state.allowName = false;
                node.state.readArray = true;
                break;
            case "]":
                if (!node.state.readArray) {
                    throwError(i);
                }
                node.type += c;
                node.state.readArray = false;
                node.state.allowArray = true;
                node.state.allowName = true;
                break;
            default:
                if (node.state.allowType) {
                    node.type += c;
                    node.state.allowParams = true;
                    node.state.allowArray = true;
                }
                else if (node.state.allowName) {
                    node.name += c;
                    delete node.state.allowArray;
                }
                else if (node.state.readArray) {
                    node.type += c;
                }
                else {
                    throwError(i);
                }
        }
    }
    if (node.parent) {
        fragments_logger.throwArgumentError("unexpected eof", "param", param);
    }
    delete parent.state;
    if (node.name === "indexed") {
        if (!allowIndexed) {
            throwError(originalParam.length - 7);
        }
        if (node.indexed) {
            throwError(originalParam.length - 7);
        }
        node.indexed = true;
        node.name = "";
    }
    else if (checkModifier(node.type, node.name)) {
        node.name = "";
    }
    parent.type = verifyType(parent.type);
    return parent;
}
function populate(object, params) {
    for (let key in params) {
        lib_esm_defineReadOnly(object, key, params[key]);
    }
}
const FormatTypes = Object.freeze({
    // Bare formatting, as is needed for computing a sighash of an event or function
    sighash: "sighash",
    // Human-Readable with Minimal spacing and without names (compact human-readable)
    minimal: "minimal",
    // Human-Readable with nice spacing, including all names
    full: "full",
    // JSON-format a la Solidity
    json: "json"
});
const paramTypeArray = new RegExp(/^(.*)\[([0-9]*)\]$/);
class ParamType {
    constructor(constructorGuard, params) {
        if (constructorGuard !== fragments_constructorGuard) {
            fragments_logger.throwError("use fromString", lib_esm_Logger.errors.UNSUPPORTED_OPERATION, {
                operation: "new ParamType()"
            });
        }
        populate(this, params);
        let match = this.type.match(paramTypeArray);
        if (match) {
            populate(this, {
                arrayLength: parseInt(match[2] || "-1"),
                arrayChildren: ParamType.fromObject({
                    type: match[1],
                    components: this.components
                }),
                baseType: "array"
            });
        }
        else {
            populate(this, {
                arrayLength: null,
                arrayChildren: null,
                baseType: ((this.components != null) ? "tuple" : this.type)
            });
        }
        this._isParamType = true;
        Object.freeze(this);
    }
    // Format the parameter fragment
    //   - sighash: "(uint256,address)"
    //   - minimal: "tuple(uint256,address) indexed"
    //   - full:    "tuple(uint256 foo, address bar) indexed baz"
    format(format) {
        if (!format) {
            format = FormatTypes.sighash;
        }
        if (!FormatTypes[format]) {
            fragments_logger.throwArgumentError("invalid format type", "format", format);
        }
        if (format === FormatTypes.json) {
            let result = {
                type: ((this.baseType === "tuple") ? "tuple" : this.type),
                name: (this.name || undefined)
            };
            if (typeof (this.indexed) === "boolean") {
                result.indexed = this.indexed;
            }
            if (this.components) {
                result.components = this.components.map((comp) => JSON.parse(comp.format(format)));
            }
            return JSON.stringify(result);
        }
        let result = "";
        // Array
        if (this.baseType === "array") {
            result += this.arrayChildren.format(format);
            result += "[" + (this.arrayLength < 0 ? "" : String(this.arrayLength)) + "]";
        }
        else {
            if (this.baseType === "tuple") {
                if (format !== FormatTypes.sighash) {
                    result += this.type;
                }
                result += "(" + this.components.map((comp) => comp.format(format)).join((format === FormatTypes.full) ? ", " : ",") + ")";
            }
            else {
                result += this.type;
            }
        }
        if (format !== FormatTypes.sighash) {
            if (this.indexed === true) {
                result += " indexed";
            }
            if (format === FormatTypes.full && this.name) {
                result += " " + this.name;
            }
        }
        return result;
    }
    static from(value, allowIndexed) {
        if (typeof (value) === "string") {
            return ParamType.fromString(value, allowIndexed);
        }
        return ParamType.fromObject(value);
    }
    static fromObject(value) {
        if (ParamType.isParamType(value)) {
            return value;
        }
        return new ParamType(fragments_constructorGuard, {
            name: (value.name || null),
            type: verifyType(value.type),
            indexed: ((value.indexed == null) ? null : !!value.indexed),
            components: (value.components ? value.components.map(ParamType.fromObject) : null)
        });
    }
    static fromString(value, allowIndexed) {
        function ParamTypify(node) {
            return ParamType.fromObject({
                name: node.name,
                type: node.type,
                indexed: node.indexed,
                components: node.components
            });
        }
        return ParamTypify(parseParamType(value, !!allowIndexed));
    }
    static isParamType(value) {
        return !!(value != null && value._isParamType);
    }
}
;
function parseParams(value, allowIndex) {
    return splitNesting(value).map((param) => ParamType.fromString(param, allowIndex));
}
class Fragment {
    constructor(constructorGuard, params) {
        if (constructorGuard !== fragments_constructorGuard) {
            fragments_logger.throwError("use a static from method", lib_esm_Logger.errors.UNSUPPORTED_OPERATION, {
                operation: "new Fragment()"
            });
        }
        populate(this, params);
        this._isFragment = true;
        Object.freeze(this);
    }
    static from(value) {
        if (Fragment.isFragment(value)) {
            return value;
        }
        if (typeof (value) === "string") {
            return Fragment.fromString(value);
        }
        return Fragment.fromObject(value);
    }
    static fromObject(value) {
        if (Fragment.isFragment(value)) {
            return value;
        }
        switch (value.type) {
            case "function":
                return FunctionFragment.fromObject(value);
            case "event":
                return EventFragment.fromObject(value);
            case "constructor":
                return ConstructorFragment.fromObject(value);
            case "error":
                return ErrorFragment.fromObject(value);
            case "fallback":
            case "receive":
                // @TODO: Something? Maybe return a FunctionFragment? A custom DefaultFunctionFragment?
                return null;
        }
        return fragments_logger.throwArgumentError("invalid fragment object", "value", value);
    }
    static fromString(value) {
        // Make sure the "returns" is surrounded by a space and all whitespace is exactly one space
        value = value.replace(/\s/g, " ");
        value = value.replace(/\(/g, " (").replace(/\)/g, ") ").replace(/\s+/g, " ");
        value = value.trim();
        if (value.split(" ")[0] === "event") {
            return EventFragment.fromString(value.substring(5).trim());
        }
        else if (value.split(" ")[0] === "function") {
            return FunctionFragment.fromString(value.substring(8).trim());
        }
        else if (value.split("(")[0].trim() === "constructor") {
            return ConstructorFragment.fromString(value.trim());
        }
        else if (value.split(" ")[0] === "error") {
            return ErrorFragment.fromString(value.substring(5).trim());
        }
        return fragments_logger.throwArgumentError("unsupported fragment", "value", value);
    }
    static isFragment(value) {
        return !!(value && value._isFragment);
    }
}
class EventFragment extends Fragment {
    format(format) {
        if (!format) {
            format = FormatTypes.sighash;
        }
        if (!FormatTypes[format]) {
            fragments_logger.throwArgumentError("invalid format type", "format", format);
        }
        if (format === FormatTypes.json) {
            return JSON.stringify({
                type: "event",
                anonymous: this.anonymous,
                name: this.name,
                inputs: this.inputs.map((input) => JSON.parse(input.format(format)))
            });
        }
        let result = "";
        if (format !== FormatTypes.sighash) {
            result += "event ";
        }
        result += this.name + "(" + this.inputs.map((input) => input.format(format)).join((format === FormatTypes.full) ? ", " : ",") + ") ";
        if (format !== FormatTypes.sighash) {
            if (this.anonymous) {
                result += "anonymous ";
            }
        }
        return result.trim();
    }
    static from(value) {
        if (typeof (value) === "string") {
            return EventFragment.fromString(value);
        }
        return EventFragment.fromObject(value);
    }
    static fromObject(value) {
        if (EventFragment.isEventFragment(value)) {
            return value;
        }
        if (value.type !== "event") {
            fragments_logger.throwArgumentError("invalid event object", "value", value);
        }
        const params = {
            name: verifyIdentifier(value.name),
            anonymous: value.anonymous,
            inputs: (value.inputs ? value.inputs.map(ParamType.fromObject) : []),
            type: "event"
        };
        return new EventFragment(fragments_constructorGuard, params);
    }
    static fromString(value) {
        let match = value.match(regexParen);
        if (!match) {
            fragments_logger.throwArgumentError("invalid event string", "value", value);
        }
        let anonymous = false;
        match[3].split(" ").forEach((modifier) => {
            switch (modifier.trim()) {
                case "anonymous":
                    anonymous = true;
                    break;
                case "":
                    break;
                default:
                    fragments_logger.warn("unknown modifier: " + modifier);
            }
        });
        return EventFragment.fromObject({
            name: match[1].trim(),
            anonymous: anonymous,
            inputs: parseParams(match[2], true),
            type: "event"
        });
    }
    static isEventFragment(value) {
        return (value && value._isFragment && value.type === "event");
    }
}
function parseGas(value, params) {
    params.gas = null;
    let comps = value.split("@");
    if (comps.length !== 1) {
        if (comps.length > 2) {
            fragments_logger.throwArgumentError("invalid human-readable ABI signature", "value", value);
        }
        if (!comps[1].match(/^[0-9]+$/)) {
            fragments_logger.throwArgumentError("invalid human-readable ABI signature gas", "value", value);
        }
        params.gas = bignumber_BigNumber.from(comps[1]);
        return comps[0];
    }
    return value;
}
function parseModifiers(value, params) {
    params.constant = false;
    params.payable = false;
    params.stateMutability = "nonpayable";
    value.split(" ").forEach((modifier) => {
        switch (modifier.trim()) {
            case "constant":
                params.constant = true;
                break;
            case "payable":
                params.payable = true;
                params.stateMutability = "payable";
                break;
            case "nonpayable":
                params.payable = false;
                params.stateMutability = "nonpayable";
                break;
            case "pure":
                params.constant = true;
                params.stateMutability = "pure";
                break;
            case "view":
                params.constant = true;
                params.stateMutability = "view";
                break;
            case "external":
            case "public":
            case "":
                break;
            default:
                console.log("unknown modifier: " + modifier);
        }
    });
}
function verifyState(value) {
    let result = {
        constant: false,
        payable: true,
        stateMutability: "payable"
    };
    if (value.stateMutability != null) {
        result.stateMutability = value.stateMutability;
        // Set (and check things are consistent) the constant property
        result.constant = (result.stateMutability === "view" || result.stateMutability === "pure");
        if (value.constant != null) {
            if ((!!value.constant) !== result.constant) {
                fragments_logger.throwArgumentError("cannot have constant function with mutability " + result.stateMutability, "value", value);
            }
        }
        // Set (and check things are consistent) the payable property
        result.payable = (result.stateMutability === "payable");
        if (value.payable != null) {
            if ((!!value.payable) !== result.payable) {
                fragments_logger.throwArgumentError("cannot have payable function with mutability " + result.stateMutability, "value", value);
            }
        }
    }
    else if (value.payable != null) {
        result.payable = !!value.payable;
        // If payable we can assume non-constant; otherwise we can't assume
        if (value.constant == null && !result.payable && value.type !== "constructor") {
            fragments_logger.throwArgumentError("unable to determine stateMutability", "value", value);
        }
        result.constant = !!value.constant;
        if (result.constant) {
            result.stateMutability = "view";
        }
        else {
            result.stateMutability = (result.payable ? "payable" : "nonpayable");
        }
        if (result.payable && result.constant) {
            fragments_logger.throwArgumentError("cannot have constant payable function", "value", value);
        }
    }
    else if (value.constant != null) {
        result.constant = !!value.constant;
        result.payable = !result.constant;
        result.stateMutability = (result.constant ? "view" : "payable");
    }
    else if (value.type !== "constructor") {
        fragments_logger.throwArgumentError("unable to determine stateMutability", "value", value);
    }
    return result;
}
class ConstructorFragment extends Fragment {
    format(format) {
        if (!format) {
            format = FormatTypes.sighash;
        }
        if (!FormatTypes[format]) {
            fragments_logger.throwArgumentError("invalid format type", "format", format);
        }
        if (format === FormatTypes.json) {
            return JSON.stringify({
                type: "constructor",
                stateMutability: ((this.stateMutability !== "nonpayable") ? this.stateMutability : undefined),
                payable: this.payable,
                gas: (this.gas ? this.gas.toNumber() : undefined),
                inputs: this.inputs.map((input) => JSON.parse(input.format(format)))
            });
        }
        if (format === FormatTypes.sighash) {
            fragments_logger.throwError("cannot format a constructor for sighash", lib_esm_Logger.errors.UNSUPPORTED_OPERATION, {
                operation: "format(sighash)"
            });
        }
        let result = "constructor(" + this.inputs.map((input) => input.format(format)).join((format === FormatTypes.full) ? ", " : ",") + ") ";
        if (this.stateMutability && this.stateMutability !== "nonpayable") {
            result += this.stateMutability + " ";
        }
        return result.trim();
    }
    static from(value) {
        if (typeof (value) === "string") {
            return ConstructorFragment.fromString(value);
        }
        return ConstructorFragment.fromObject(value);
    }
    static fromObject(value) {
        if (ConstructorFragment.isConstructorFragment(value)) {
            return value;
        }
        if (value.type !== "constructor") {
            fragments_logger.throwArgumentError("invalid constructor object", "value", value);
        }
        let state = verifyState(value);
        if (state.constant) {
            fragments_logger.throwArgumentError("constructor cannot be constant", "value", value);
        }
        const params = {
            name: null,
            type: value.type,
            inputs: (value.inputs ? value.inputs.map(ParamType.fromObject) : []),
            payable: state.payable,
            stateMutability: state.stateMutability,
            gas: (value.gas ? bignumber_BigNumber.from(value.gas) : null)
        };
        return new ConstructorFragment(fragments_constructorGuard, params);
    }
    static fromString(value) {
        let params = { type: "constructor" };
        value = parseGas(value, params);
        let parens = value.match(regexParen);
        if (!parens || parens[1].trim() !== "constructor") {
            fragments_logger.throwArgumentError("invalid constructor string", "value", value);
        }
        params.inputs = parseParams(parens[2].trim(), false);
        parseModifiers(parens[3].trim(), params);
        return ConstructorFragment.fromObject(params);
    }
    static isConstructorFragment(value) {
        return (value && value._isFragment && value.type === "constructor");
    }
}
class FunctionFragment extends ConstructorFragment {
    format(format) {
        if (!format) {
            format = FormatTypes.sighash;
        }
        if (!FormatTypes[format]) {
            fragments_logger.throwArgumentError("invalid format type", "format", format);
        }
        if (format === FormatTypes.json) {
            return JSON.stringify({
                type: "function",
                name: this.name,
                constant: this.constant,
                stateMutability: ((this.stateMutability !== "nonpayable") ? this.stateMutability : undefined),
                payable: this.payable,
                gas: (this.gas ? this.gas.toNumber() : undefined),
                inputs: this.inputs.map((input) => JSON.parse(input.format(format))),
                outputs: this.outputs.map((output) => JSON.parse(output.format(format))),
            });
        }
        let result = "";
        if (format !== FormatTypes.sighash) {
            result += "function ";
        }
        result += this.name + "(" + this.inputs.map((input) => input.format(format)).join((format === FormatTypes.full) ? ", " : ",") + ") ";
        if (format !== FormatTypes.sighash) {
            if (this.stateMutability) {
                if (this.stateMutability !== "nonpayable") {
                    result += (this.stateMutability + " ");
                }
            }
            else if (this.constant) {
                result += "view ";
            }
            if (this.outputs && this.outputs.length) {
                result += "returns (" + this.outputs.map((output) => output.format(format)).join(", ") + ") ";
            }
            if (this.gas != null) {
                result += "@" + this.gas.toString() + " ";
            }
        }
        return result.trim();
    }
    static from(value) {
        if (typeof (value) === "string") {
            return FunctionFragment.fromString(value);
        }
        return FunctionFragment.fromObject(value);
    }
    static fromObject(value) {
        if (FunctionFragment.isFunctionFragment(value)) {
            return value;
        }
        if (value.type !== "function") {
            fragments_logger.throwArgumentError("invalid function object", "value", value);
        }
        let state = verifyState(value);
        const params = {
            type: value.type,
            name: verifyIdentifier(value.name),
            constant: state.constant,
            inputs: (value.inputs ? value.inputs.map(ParamType.fromObject) : []),
            outputs: (value.outputs ? value.outputs.map(ParamType.fromObject) : []),
            payable: state.payable,
            stateMutability: state.stateMutability,
            gas: (value.gas ? bignumber_BigNumber.from(value.gas) : null)
        };
        return new FunctionFragment(fragments_constructorGuard, params);
    }
    static fromString(value) {
        let params = { type: "function" };
        value = parseGas(value, params);
        let comps = value.split(" returns ");
        if (comps.length > 2) {
            fragments_logger.throwArgumentError("invalid function string", "value", value);
        }
        let parens = comps[0].match(regexParen);
        if (!parens) {
            fragments_logger.throwArgumentError("invalid function signature", "value", value);
        }
        params.name = parens[1].trim();
        if (params.name) {
            verifyIdentifier(params.name);
        }
        params.inputs = parseParams(parens[2], false);
        parseModifiers(parens[3].trim(), params);
        // We have outputs
        if (comps.length > 1) {
            let returns = comps[1].match(regexParen);
            if (returns[1].trim() != "" || returns[3].trim() != "") {
                fragments_logger.throwArgumentError("unexpected tokens", "value", value);
            }
            params.outputs = parseParams(returns[2], false);
        }
        else {
            params.outputs = [];
        }
        return FunctionFragment.fromObject(params);
    }
    static isFunctionFragment(value) {
        return (value && value._isFragment && value.type === "function");
    }
}
//export class StructFragment extends Fragment {
//}
function checkForbidden(fragment) {
    const sig = fragment.format();
    if (sig === "Error(string)" || sig === "Panic(uint256)") {
        fragments_logger.throwArgumentError(`cannot specify user defined ${sig} error`, "fragment", fragment);
    }
    return fragment;
}
class ErrorFragment extends Fragment {
    format(format) {
        if (!format) {
            format = FormatTypes.sighash;
        }
        if (!FormatTypes[format]) {
            fragments_logger.throwArgumentError("invalid format type", "format", format);
        }
        if (format === FormatTypes.json) {
            return JSON.stringify({
                type: "error",
                name: this.name,
                inputs: this.inputs.map((input) => JSON.parse(input.format(format))),
            });
        }
        let result = "";
        if (format !== FormatTypes.sighash) {
            result += "error ";
        }
        result += this.name + "(" + this.inputs.map((input) => input.format(format)).join((format === FormatTypes.full) ? ", " : ",") + ") ";
        return result.trim();
    }
    static from(value) {
        if (typeof (value) === "string") {
            return ErrorFragment.fromString(value);
        }
        return ErrorFragment.fromObject(value);
    }
    static fromObject(value) {
        if (ErrorFragment.isErrorFragment(value)) {
            return value;
        }
        if (value.type !== "error") {
            fragments_logger.throwArgumentError("invalid error object", "value", value);
        }
        const params = {
            type: value.type,
            name: verifyIdentifier(value.name),
            inputs: (value.inputs ? value.inputs.map(ParamType.fromObject) : [])
        };
        return checkForbidden(new ErrorFragment(fragments_constructorGuard, params));
    }
    static fromString(value) {
        let params = { type: "error" };
        let parens = value.match(regexParen);
        if (!parens) {
            fragments_logger.throwArgumentError("invalid error signature", "value", value);
        }
        params.name = parens[1].trim();
        if (params.name) {
            verifyIdentifier(params.name);
        }
        params.inputs = parseParams(parens[2], false);
        return checkForbidden(ErrorFragment.fromObject(params));
    }
    static isErrorFragment(value) {
        return (value && value._isFragment && value.type === "error");
    }
}
function verifyType(type) {
    // These need to be transformed to their full description
    if (type.match(/^uint($|[^1-9])/)) {
        type = "uint256" + type.substring(4);
    }
    else if (type.match(/^int($|[^1-9])/)) {
        type = "int256" + type.substring(3);
    }
    // @TODO: more verification
    return type;
}
// See: https://github.com/ethereum/solidity/blob/1f8f1a3db93a548d0555e3e14cfc55a10e25b60e/docs/grammar/SolidityLexer.g4#L234
const regexIdentifier = new RegExp("^[a-zA-Z$_][a-zA-Z0-9$_]*$");
function verifyIdentifier(value) {
    if (!value || !value.match(regexIdentifier)) {
        fragments_logger.throwArgumentError(`invalid identifier "${value}"`, "value", value);
    }
    return value;
}
const regexParen = new RegExp("^([^)(]*)\\((.*)\\)([^)(]*)$");
function splitNesting(value) {
    value = value.trim();
    let result = [];
    let accum = "";
    let depth = 0;
    for (let offset = 0; offset < value.length; offset++) {
        let c = value[offset];
        if (c === "," && depth === 0) {
            result.push(accum);
            accum = "";
        }
        else {
            accum += c;
            if (c === "(") {
                depth++;
            }
            else if (c === ")") {
                depth--;
                if (depth === -1) {
                    fragments_logger.throwArgumentError("unbalanced parenthesis", "value", value);
                }
            }
        }
    }
    if (accum) {
        result.push(accum);
    }
    return result;
}
//# sourceMappingURL=fragments.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+abi@5.7.0/node_modules/@ethersproject/abi/lib.esm/abi-coder.js

// See: https://github.com/ethereum/wiki/wiki/Ethereum-Contract-ABI




const abi_coder_logger = new lib_esm_Logger(abi_lib_esm_version_version);











const paramTypeBytes = new RegExp(/^bytes([0-9]*)$/);
const paramTypeNumber = new RegExp(/^(u?int)([0-9]*)$/);
class AbiCoder {
    constructor(coerceFunc) {
        lib_esm_defineReadOnly(this, "coerceFunc", coerceFunc || null);
    }
    _getCoder(param) {
        switch (param.baseType) {
            case "address":
                return new AddressCoder(param.name);
            case "bool":
                return new BooleanCoder(param.name);
            case "string":
                return new StringCoder(param.name);
            case "bytes":
                return new BytesCoder(param.name);
            case "array":
                return new ArrayCoder(this._getCoder(param.arrayChildren), param.arrayLength, param.name);
            case "tuple":
                return new TupleCoder((param.components || []).map((component) => {
                    return this._getCoder(component);
                }), param.name);
            case "":
                return new NullCoder(param.name);
        }
        // u?int[0-9]*
        let match = param.type.match(paramTypeNumber);
        if (match) {
            let size = parseInt(match[2] || "256");
            if (size === 0 || size > 256 || (size % 8) !== 0) {
                abi_coder_logger.throwArgumentError("invalid " + match[1] + " bit length", "param", param);
            }
            return new NumberCoder(size / 8, (match[1] === "int"), param.name);
        }
        // bytes[0-9]+
        match = param.type.match(paramTypeBytes);
        if (match) {
            let size = parseInt(match[1]);
            if (size === 0 || size > 32) {
                abi_coder_logger.throwArgumentError("invalid bytes length", "param", param);
            }
            return new FixedBytesCoder(size, param.name);
        }
        return abi_coder_logger.throwArgumentError("invalid type", "type", param.type);
    }
    _getWordSize() { return 32; }
    _getReader(data, allowLoose) {
        return new Reader(data, this._getWordSize(), this.coerceFunc, allowLoose);
    }
    _getWriter() {
        return new Writer(this._getWordSize());
    }
    getDefaultValue(types) {
        const coders = types.map((type) => this._getCoder(ParamType.from(type)));
        const coder = new TupleCoder(coders, "_");
        return coder.defaultValue();
    }
    encode(types, values) {
        if (types.length !== values.length) {
            abi_coder_logger.throwError("types/values length mismatch", lib_esm_Logger.errors.INVALID_ARGUMENT, {
                count: { types: types.length, values: values.length },
                value: { types: types, values: values }
            });
        }
        const coders = types.map((type) => this._getCoder(ParamType.from(type)));
        const coder = (new TupleCoder(coders, "_"));
        const writer = this._getWriter();
        coder.encode(writer, values);
        return writer.data;
    }
    decode(types, data, loose) {
        const coders = types.map((type) => this._getCoder(ParamType.from(type)));
        const coder = new TupleCoder(coders, "_");
        return coder.decode(this._getReader(lib_esm_arrayify(data), loose));
    }
}
const defaultAbiCoder = new AbiCoder();
//# sourceMappingURL=abi-coder.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+abi@5.7.0/node_modules/@ethersproject/abi/lib.esm/interface.js












const interface_logger = new lib_esm_Logger(abi_lib_esm_version_version);

class LogDescription extends Description {
}
class TransactionDescription extends Description {
}
class ErrorDescription extends Description {
}
class Indexed extends Description {
    static isIndexed(value) {
        return !!(value && value._isIndexed);
    }
}
const BuiltinErrors = {
    "0x08c379a0": { signature: "Error(string)", name: "Error", inputs: ["string"], reason: true },
    "0x4e487b71": { signature: "Panic(uint256)", name: "Panic", inputs: ["uint256"] }
};
function wrapAccessError(property, error) {
    const wrap = new Error(`deferred error during ABI decoding triggered accessing ${property}`);
    wrap.error = error;
    return wrap;
}
/*
function checkNames(fragment: Fragment, type: "input" | "output", params: Array<ParamType>): void {
    params.reduce((accum, param) => {
        if (param.name) {
            if (accum[param.name]) {
                logger.throwArgumentError(`duplicate ${ type } parameter ${ JSON.stringify(param.name) } in ${ fragment.format("full") }`, "fragment", fragment);
            }
            accum[param.name] = true;
        }
        return accum;
    }, <{ [ name: string ]: boolean }>{ });
}
*/
class Interface {
    constructor(fragments) {
        let abi = [];
        if (typeof (fragments) === "string") {
            abi = JSON.parse(fragments);
        }
        else {
            abi = fragments;
        }
        lib_esm_defineReadOnly(this, "fragments", abi.map((fragment) => {
            return Fragment.from(fragment);
        }).filter((fragment) => (fragment != null)));
        lib_esm_defineReadOnly(this, "_abiCoder", lib_esm_getStatic(new.target, "getAbiCoder")());
        lib_esm_defineReadOnly(this, "functions", {});
        lib_esm_defineReadOnly(this, "errors", {});
        lib_esm_defineReadOnly(this, "events", {});
        lib_esm_defineReadOnly(this, "structs", {});
        // Add all fragments by their signature
        this.fragments.forEach((fragment) => {
            let bucket = null;
            switch (fragment.type) {
                case "constructor":
                    if (this.deploy) {
                        interface_logger.warn("duplicate definition - constructor");
                        return;
                    }
                    //checkNames(fragment, "input", fragment.inputs);
                    lib_esm_defineReadOnly(this, "deploy", fragment);
                    return;
                case "function":
                    //checkNames(fragment, "input", fragment.inputs);
                    //checkNames(fragment, "output", (<FunctionFragment>fragment).outputs);
                    bucket = this.functions;
                    break;
                case "event":
                    //checkNames(fragment, "input", fragment.inputs);
                    bucket = this.events;
                    break;
                case "error":
                    bucket = this.errors;
                    break;
                default:
                    return;
            }
            let signature = fragment.format();
            if (bucket[signature]) {
                interface_logger.warn("duplicate definition - " + signature);
                return;
            }
            bucket[signature] = fragment;
        });
        // If we do not have a constructor add a default
        if (!this.deploy) {
            lib_esm_defineReadOnly(this, "deploy", ConstructorFragment.from({
                payable: false,
                type: "constructor"
            }));
        }
        lib_esm_defineReadOnly(this, "_isInterface", true);
    }
    format(format) {
        if (!format) {
            format = FormatTypes.full;
        }
        if (format === FormatTypes.sighash) {
            interface_logger.throwArgumentError("interface does not support formatting sighash", "format", format);
        }
        const abi = this.fragments.map((fragment) => fragment.format(format));
        // We need to re-bundle the JSON fragments a bit
        if (format === FormatTypes.json) {
            return JSON.stringify(abi.map((j) => JSON.parse(j)));
        }
        return abi;
    }
    // Sub-classes can override these to handle other blockchains
    static getAbiCoder() {
        return defaultAbiCoder;
    }
    static getAddress(address) {
        return lib_esm_getAddress(address);
    }
    static getSighash(fragment) {
        return lib_esm_hexDataSlice(id(fragment.format()), 0, 4);
    }
    static getEventTopic(eventFragment) {
        return id(eventFragment.format());
    }
    // Find a function definition by any means necessary (unless it is ambiguous)
    getFunction(nameOrSignatureOrSighash) {
        if (lib_esm_isHexString(nameOrSignatureOrSighash)) {
            for (const name in this.functions) {
                if (nameOrSignatureOrSighash === this.getSighash(name)) {
                    return this.functions[name];
                }
            }
            interface_logger.throwArgumentError("no matching function", "sighash", nameOrSignatureOrSighash);
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (nameOrSignatureOrSighash.indexOf("(") === -1) {
            const name = nameOrSignatureOrSighash.trim();
            const matching = Object.keys(this.functions).filter((f) => (f.split("(" /* fix:) */)[0] === name));
            if (matching.length === 0) {
                interface_logger.throwArgumentError("no matching function", "name", name);
            }
            else if (matching.length > 1) {
                interface_logger.throwArgumentError("multiple matching functions", "name", name);
            }
            return this.functions[matching[0]];
        }
        // Normalize the signature and lookup the function
        const result = this.functions[FunctionFragment.fromString(nameOrSignatureOrSighash).format()];
        if (!result) {
            interface_logger.throwArgumentError("no matching function", "signature", nameOrSignatureOrSighash);
        }
        return result;
    }
    // Find an event definition by any means necessary (unless it is ambiguous)
    getEvent(nameOrSignatureOrTopic) {
        if (lib_esm_isHexString(nameOrSignatureOrTopic)) {
            const topichash = nameOrSignatureOrTopic.toLowerCase();
            for (const name in this.events) {
                if (topichash === this.getEventTopic(name)) {
                    return this.events[name];
                }
            }
            interface_logger.throwArgumentError("no matching event", "topichash", topichash);
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (nameOrSignatureOrTopic.indexOf("(") === -1) {
            const name = nameOrSignatureOrTopic.trim();
            const matching = Object.keys(this.events).filter((f) => (f.split("(" /* fix:) */)[0] === name));
            if (matching.length === 0) {
                interface_logger.throwArgumentError("no matching event", "name", name);
            }
            else if (matching.length > 1) {
                interface_logger.throwArgumentError("multiple matching events", "name", name);
            }
            return this.events[matching[0]];
        }
        // Normalize the signature and lookup the function
        const result = this.events[EventFragment.fromString(nameOrSignatureOrTopic).format()];
        if (!result) {
            interface_logger.throwArgumentError("no matching event", "signature", nameOrSignatureOrTopic);
        }
        return result;
    }
    // Find a function definition by any means necessary (unless it is ambiguous)
    getError(nameOrSignatureOrSighash) {
        if (lib_esm_isHexString(nameOrSignatureOrSighash)) {
            const getSighash = lib_esm_getStatic(this.constructor, "getSighash");
            for (const name in this.errors) {
                const error = this.errors[name];
                if (nameOrSignatureOrSighash === getSighash(error)) {
                    return this.errors[name];
                }
            }
            interface_logger.throwArgumentError("no matching error", "sighash", nameOrSignatureOrSighash);
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (nameOrSignatureOrSighash.indexOf("(") === -1) {
            const name = nameOrSignatureOrSighash.trim();
            const matching = Object.keys(this.errors).filter((f) => (f.split("(" /* fix:) */)[0] === name));
            if (matching.length === 0) {
                interface_logger.throwArgumentError("no matching error", "name", name);
            }
            else if (matching.length > 1) {
                interface_logger.throwArgumentError("multiple matching errors", "name", name);
            }
            return this.errors[matching[0]];
        }
        // Normalize the signature and lookup the function
        const result = this.errors[FunctionFragment.fromString(nameOrSignatureOrSighash).format()];
        if (!result) {
            interface_logger.throwArgumentError("no matching error", "signature", nameOrSignatureOrSighash);
        }
        return result;
    }
    // Get the sighash (the bytes4 selector) used by Solidity to identify a function
    getSighash(fragment) {
        if (typeof (fragment) === "string") {
            try {
                fragment = this.getFunction(fragment);
            }
            catch (error) {
                try {
                    fragment = this.getError(fragment);
                }
                catch (_) {
                    throw error;
                }
            }
        }
        return lib_esm_getStatic(this.constructor, "getSighash")(fragment);
    }
    // Get the topic (the bytes32 hash) used by Solidity to identify an event
    getEventTopic(eventFragment) {
        if (typeof (eventFragment) === "string") {
            eventFragment = this.getEvent(eventFragment);
        }
        return lib_esm_getStatic(this.constructor, "getEventTopic")(eventFragment);
    }
    _decodeParams(params, data) {
        return this._abiCoder.decode(params, data);
    }
    _encodeParams(params, values) {
        return this._abiCoder.encode(params, values);
    }
    encodeDeploy(values) {
        return this._encodeParams(this.deploy.inputs, values || []);
    }
    decodeErrorResult(fragment, data) {
        if (typeof (fragment) === "string") {
            fragment = this.getError(fragment);
        }
        const bytes = lib_esm_arrayify(data);
        if (lib_esm_hexlify(bytes.slice(0, 4)) !== this.getSighash(fragment)) {
            interface_logger.throwArgumentError(`data signature does not match error ${fragment.name}.`, "data", lib_esm_hexlify(bytes));
        }
        return this._decodeParams(fragment.inputs, bytes.slice(4));
    }
    encodeErrorResult(fragment, values) {
        if (typeof (fragment) === "string") {
            fragment = this.getError(fragment);
        }
        return lib_esm_hexlify(lib_esm_concat([
            this.getSighash(fragment),
            this._encodeParams(fragment.inputs, values || [])
        ]));
    }
    // Decode the data for a function call (e.g. tx.data)
    decodeFunctionData(functionFragment, data) {
        if (typeof (functionFragment) === "string") {
            functionFragment = this.getFunction(functionFragment);
        }
        const bytes = lib_esm_arrayify(data);
        if (lib_esm_hexlify(bytes.slice(0, 4)) !== this.getSighash(functionFragment)) {
            interface_logger.throwArgumentError(`data signature does not match function ${functionFragment.name}.`, "data", lib_esm_hexlify(bytes));
        }
        return this._decodeParams(functionFragment.inputs, bytes.slice(4));
    }
    // Encode the data for a function call (e.g. tx.data)
    encodeFunctionData(functionFragment, values) {
        if (typeof (functionFragment) === "string") {
            functionFragment = this.getFunction(functionFragment);
        }
        return lib_esm_hexlify(lib_esm_concat([
            this.getSighash(functionFragment),
            this._encodeParams(functionFragment.inputs, values || [])
        ]));
    }
    // Decode the result from a function call (e.g. from eth_call)
    decodeFunctionResult(functionFragment, data) {
        if (typeof (functionFragment) === "string") {
            functionFragment = this.getFunction(functionFragment);
        }
        let bytes = lib_esm_arrayify(data);
        let reason = null;
        let message = "";
        let errorArgs = null;
        let errorName = null;
        let errorSignature = null;
        switch (bytes.length % this._abiCoder._getWordSize()) {
            case 0:
                try {
                    return this._abiCoder.decode(functionFragment.outputs, bytes);
                }
                catch (error) { }
                break;
            case 4: {
                const selector = lib_esm_hexlify(bytes.slice(0, 4));
                const builtin = BuiltinErrors[selector];
                if (builtin) {
                    errorArgs = this._abiCoder.decode(builtin.inputs, bytes.slice(4));
                    errorName = builtin.name;
                    errorSignature = builtin.signature;
                    if (builtin.reason) {
                        reason = errorArgs[0];
                    }
                    if (errorName === "Error") {
                        message = `; VM Exception while processing transaction: reverted with reason string ${JSON.stringify(errorArgs[0])}`;
                    }
                    else if (errorName === "Panic") {
                        message = `; VM Exception while processing transaction: reverted with panic code ${errorArgs[0]}`;
                    }
                }
                else {
                    try {
                        const error = this.getError(selector);
                        errorArgs = this._abiCoder.decode(error.inputs, bytes.slice(4));
                        errorName = error.name;
                        errorSignature = error.format();
                    }
                    catch (error) { }
                }
                break;
            }
        }
        return interface_logger.throwError("call revert exception" + message, lib_esm_Logger.errors.CALL_EXCEPTION, {
            method: functionFragment.format(),
            data: lib_esm_hexlify(data), errorArgs, errorName, errorSignature, reason
        });
    }
    // Encode the result for a function call (e.g. for eth_call)
    encodeFunctionResult(functionFragment, values) {
        if (typeof (functionFragment) === "string") {
            functionFragment = this.getFunction(functionFragment);
        }
        return lib_esm_hexlify(this._abiCoder.encode(functionFragment.outputs, values || []));
    }
    // Create the filter for the event with search criteria (e.g. for eth_filterLog)
    encodeFilterTopics(eventFragment, values) {
        if (typeof (eventFragment) === "string") {
            eventFragment = this.getEvent(eventFragment);
        }
        if (values.length > eventFragment.inputs.length) {
            interface_logger.throwError("too many arguments for " + eventFragment.format(), lib_esm_Logger.errors.UNEXPECTED_ARGUMENT, {
                argument: "values",
                value: values
            });
        }
        let topics = [];
        if (!eventFragment.anonymous) {
            topics.push(this.getEventTopic(eventFragment));
        }
        const encodeTopic = (param, value) => {
            if (param.type === "string") {
                return id(value);
            }
            else if (param.type === "bytes") {
                return lib_esm_keccak256(lib_esm_hexlify(value));
            }
            if (param.type === "bool" && typeof (value) === "boolean") {
                value = (value ? "0x01" : "0x00");
            }
            if (param.type.match(/^u?int/)) {
                value = bignumber_BigNumber.from(value).toHexString();
            }
            // Check addresses are valid
            if (param.type === "address") {
                this._abiCoder.encode(["address"], [value]);
            }
            return hexZeroPad(lib_esm_hexlify(value), 32);
        };
        values.forEach((value, index) => {
            let param = eventFragment.inputs[index];
            if (!param.indexed) {
                if (value != null) {
                    interface_logger.throwArgumentError("cannot filter non-indexed parameters; must be null", ("contract." + param.name), value);
                }
                return;
            }
            if (value == null) {
                topics.push(null);
            }
            else if (param.baseType === "array" || param.baseType === "tuple") {
                interface_logger.throwArgumentError("filtering with tuples or arrays not supported", ("contract." + param.name), value);
            }
            else if (Array.isArray(value)) {
                topics.push(value.map((value) => encodeTopic(param, value)));
            }
            else {
                topics.push(encodeTopic(param, value));
            }
        });
        // Trim off trailing nulls
        while (topics.length && topics[topics.length - 1] === null) {
            topics.pop();
        }
        return topics;
    }
    encodeEventLog(eventFragment, values) {
        if (typeof (eventFragment) === "string") {
            eventFragment = this.getEvent(eventFragment);
        }
        const topics = [];
        const dataTypes = [];
        const dataValues = [];
        if (!eventFragment.anonymous) {
            topics.push(this.getEventTopic(eventFragment));
        }
        if (values.length !== eventFragment.inputs.length) {
            interface_logger.throwArgumentError("event arguments/values mismatch", "values", values);
        }
        eventFragment.inputs.forEach((param, index) => {
            const value = values[index];
            if (param.indexed) {
                if (param.type === "string") {
                    topics.push(id(value));
                }
                else if (param.type === "bytes") {
                    topics.push(lib_esm_keccak256(value));
                }
                else if (param.baseType === "tuple" || param.baseType === "array") {
                    // @TODO
                    throw new Error("not implemented");
                }
                else {
                    topics.push(this._abiCoder.encode([param.type], [value]));
                }
            }
            else {
                dataTypes.push(param);
                dataValues.push(value);
            }
        });
        return {
            data: this._abiCoder.encode(dataTypes, dataValues),
            topics: topics
        };
    }
    // Decode a filter for the event and the search criteria
    decodeEventLog(eventFragment, data, topics) {
        if (typeof (eventFragment) === "string") {
            eventFragment = this.getEvent(eventFragment);
        }
        if (topics != null && !eventFragment.anonymous) {
            let topicHash = this.getEventTopic(eventFragment);
            if (!lib_esm_isHexString(topics[0], 32) || topics[0].toLowerCase() !== topicHash) {
                interface_logger.throwError("fragment/topic mismatch", lib_esm_Logger.errors.INVALID_ARGUMENT, { argument: "topics[0]", expected: topicHash, value: topics[0] });
            }
            topics = topics.slice(1);
        }
        let indexed = [];
        let nonIndexed = [];
        let dynamic = [];
        eventFragment.inputs.forEach((param, index) => {
            if (param.indexed) {
                if (param.type === "string" || param.type === "bytes" || param.baseType === "tuple" || param.baseType === "array") {
                    indexed.push(ParamType.fromObject({ type: "bytes32", name: param.name }));
                    dynamic.push(true);
                }
                else {
                    indexed.push(param);
                    dynamic.push(false);
                }
            }
            else {
                nonIndexed.push(param);
                dynamic.push(false);
            }
        });
        let resultIndexed = (topics != null) ? this._abiCoder.decode(indexed, lib_esm_concat(topics)) : null;
        let resultNonIndexed = this._abiCoder.decode(nonIndexed, data, true);
        let result = [];
        let nonIndexedIndex = 0, indexedIndex = 0;
        eventFragment.inputs.forEach((param, index) => {
            if (param.indexed) {
                if (resultIndexed == null) {
                    result[index] = new Indexed({ _isIndexed: true, hash: null });
                }
                else if (dynamic[index]) {
                    result[index] = new Indexed({ _isIndexed: true, hash: resultIndexed[indexedIndex++] });
                }
                else {
                    try {
                        result[index] = resultIndexed[indexedIndex++];
                    }
                    catch (error) {
                        result[index] = error;
                    }
                }
            }
            else {
                try {
                    result[index] = resultNonIndexed[nonIndexedIndex++];
                }
                catch (error) {
                    result[index] = error;
                }
            }
            // Add the keyword argument if named and safe
            if (param.name && result[param.name] == null) {
                const value = result[index];
                // Make error named values throw on access
                if (value instanceof Error) {
                    Object.defineProperty(result, param.name, {
                        enumerable: true,
                        get: () => { throw wrapAccessError(`property ${JSON.stringify(param.name)}`, value); }
                    });
                }
                else {
                    result[param.name] = value;
                }
            }
        });
        // Make all error indexed values throw on access
        for (let i = 0; i < result.length; i++) {
            const value = result[i];
            if (value instanceof Error) {
                Object.defineProperty(result, i, {
                    enumerable: true,
                    get: () => { throw wrapAccessError(`index ${i}`, value); }
                });
            }
        }
        return Object.freeze(result);
    }
    // Given a transaction, find the matching function fragment (if any) and
    // determine all its properties and call parameters
    parseTransaction(tx) {
        let fragment = this.getFunction(tx.data.substring(0, 10).toLowerCase());
        if (!fragment) {
            return null;
        }
        return new TransactionDescription({
            args: this._abiCoder.decode(fragment.inputs, "0x" + tx.data.substring(10)),
            functionFragment: fragment,
            name: fragment.name,
            signature: fragment.format(),
            sighash: this.getSighash(fragment),
            value: bignumber_BigNumber.from(tx.value || "0"),
        });
    }
    // @TODO
    //parseCallResult(data: BytesLike): ??
    // Given an event log, find the matching event fragment (if any) and
    // determine all its properties and values
    parseLog(log) {
        let fragment = this.getEvent(log.topics[0]);
        if (!fragment || fragment.anonymous) {
            return null;
        }
        // @TODO: If anonymous, and the only method, and the input count matches, should we parse?
        //        Probably not, because just because it is the only event in the ABI does
        //        not mean we have the full ABI; maybe just a fragment?
        return new LogDescription({
            eventFragment: fragment,
            name: fragment.name,
            signature: fragment.format(),
            topic: this.getEventTopic(fragment),
            args: this.decodeEventLog(fragment, log.data, log.topics)
        });
    }
    parseError(data) {
        const hexData = lib_esm_hexlify(data);
        let fragment = this.getError(hexData.substring(0, 10).toLowerCase());
        if (!fragment) {
            return null;
        }
        return new ErrorDescription({
            args: this._abiCoder.decode(fragment.inputs, "0x" + hexData.substring(10)),
            errorFragment: fragment,
            name: fragment.name,
            signature: fragment.format(),
            sighash: this.getSighash(fragment),
        });
    }
    /*
    static from(value: Array<Fragment | string | JsonAbi> | string | Interface) {
        if (Interface.isInterface(value)) {
            return value;
        }
        if (typeof(value) === "string") {
            return new Interface(JSON.parse(value));
        }
        return new Interface(value);
    }
    */
    static isInterface(value) {
        return !!(value && value._isInterface);
    }
}
//# sourceMappingURL=interface.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+contracts@5.7.0/node_modules/@ethersproject/contracts/lib.esm/_version.js
const contracts_lib_esm_version_version = "contracts/5.7.0";
//# sourceMappingURL=_version.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+contracts@5.7.0/node_modules/@ethersproject/contracts/lib.esm/index.js

var contracts_lib_esm_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};










const contracts_lib_esm_logger = new lib_esm_Logger(contracts_lib_esm_version_version);
;
;
///////////////////////////////
const contracts_lib_esm_allowedTransactionKeys = {
    chainId: true, data: true, from: true, gasLimit: true, gasPrice: true, nonce: true, to: true, value: true,
    type: true, accessList: true,
    maxFeePerGas: true, maxPriorityFeePerGas: true,
    customData: true,
    ccipReadEnabled: true
};
function resolveName(resolver, nameOrPromise) {
    return contracts_lib_esm_awaiter(this, void 0, void 0, function* () {
        const name = yield nameOrPromise;
        if (typeof (name) !== "string") {
            contracts_lib_esm_logger.throwArgumentError("invalid address or ENS name", "name", name);
        }
        // If it is already an address, just use it (after adding checksum)
        try {
            return lib_esm_getAddress(name);
        }
        catch (error) { }
        if (!resolver) {
            contracts_lib_esm_logger.throwError("a provider or signer is needed to resolve ENS names", lib_esm_Logger.errors.UNSUPPORTED_OPERATION, {
                operation: "resolveName"
            });
        }
        const address = yield resolver.resolveName(name);
        if (address == null) {
            contracts_lib_esm_logger.throwArgumentError("resolver or addr is not configured for ENS name", "name", name);
        }
        return address;
    });
}
// Recursively replaces ENS names with promises to resolve the name and resolves all properties
function resolveAddresses(resolver, value, paramType) {
    return contracts_lib_esm_awaiter(this, void 0, void 0, function* () {
        if (Array.isArray(paramType)) {
            return yield Promise.all(paramType.map((paramType, index) => {
                return resolveAddresses(resolver, ((Array.isArray(value)) ? value[index] : value[paramType.name]), paramType);
            }));
        }
        if (paramType.type === "address") {
            return yield resolveName(resolver, value);
        }
        if (paramType.type === "tuple") {
            return yield resolveAddresses(resolver, value, paramType.components);
        }
        if (paramType.baseType === "array") {
            if (!Array.isArray(value)) {
                return Promise.reject(contracts_lib_esm_logger.makeError("invalid value for array", lib_esm_Logger.errors.INVALID_ARGUMENT, {
                    argument: "value",
                    value
                }));
            }
            return yield Promise.all(value.map((v) => resolveAddresses(resolver, v, paramType.arrayChildren)));
        }
        return value;
    });
}
function populateTransaction(contract, fragment, args) {
    return contracts_lib_esm_awaiter(this, void 0, void 0, function* () {
        // If an extra argument is given, it is overrides
        let overrides = {};
        if (args.length === fragment.inputs.length + 1 && typeof (args[args.length - 1]) === "object") {
            overrides = lib_esm_shallowCopy(args.pop());
        }
        // Make sure the parameter count matches
        contracts_lib_esm_logger.checkArgumentCount(args.length, fragment.inputs.length, "passed to contract");
        // Populate "from" override (allow promises)
        if (contract.signer) {
            if (overrides.from) {
                // Contracts with a Signer are from the Signer's frame-of-reference;
                // but we allow overriding "from" if it matches the signer
                overrides.from = resolveProperties({
                    override: resolveName(contract.signer, overrides.from),
                    signer: contract.signer.getAddress()
                }).then((check) => contracts_lib_esm_awaiter(this, void 0, void 0, function* () {
                    if (lib_esm_getAddress(check.signer) !== check.override) {
                        contracts_lib_esm_logger.throwError("Contract with a Signer cannot override from", lib_esm_Logger.errors.UNSUPPORTED_OPERATION, {
                            operation: "overrides.from"
                        });
                    }
                    return check.override;
                }));
            }
            else {
                overrides.from = contract.signer.getAddress();
            }
        }
        else if (overrides.from) {
            overrides.from = resolveName(contract.provider, overrides.from);
            //} else {
            // Contracts without a signer can override "from", and if
            // unspecified the zero address is used
            //overrides.from = AddressZero;
        }
        // Wait for all dependencies to be resolved (prefer the signer over the provider)
        const resolved = yield resolveProperties({
            args: resolveAddresses(contract.signer || contract.provider, args, fragment.inputs),
            address: contract.resolvedAddress,
            overrides: (resolveProperties(overrides) || {})
        });
        // The ABI coded transaction
        const data = contract.interface.encodeFunctionData(fragment, resolved.args);
        const tx = {
            data: data,
            to: resolved.address
        };
        // Resolved Overrides
        const ro = resolved.overrides;
        // Populate simple overrides
        if (ro.nonce != null) {
            tx.nonce = bignumber_BigNumber.from(ro.nonce).toNumber();
        }
        if (ro.gasLimit != null) {
            tx.gasLimit = bignumber_BigNumber.from(ro.gasLimit);
        }
        if (ro.gasPrice != null) {
            tx.gasPrice = bignumber_BigNumber.from(ro.gasPrice);
        }
        if (ro.maxFeePerGas != null) {
            tx.maxFeePerGas = bignumber_BigNumber.from(ro.maxFeePerGas);
        }
        if (ro.maxPriorityFeePerGas != null) {
            tx.maxPriorityFeePerGas = bignumber_BigNumber.from(ro.maxPriorityFeePerGas);
        }
        if (ro.from != null) {
            tx.from = ro.from;
        }
        if (ro.type != null) {
            tx.type = ro.type;
        }
        if (ro.accessList != null) {
            tx.accessList = accessListify(ro.accessList);
        }
        // If there was no "gasLimit" override, but the ABI specifies a default, use it
        if (tx.gasLimit == null && fragment.gas != null) {
            // Compute the intrinsic gas cost for this transaction
            // @TODO: This is based on the yellow paper as of Petersburg; this is something
            // we may wish to parameterize in v6 as part of the Network object. Since this
            // is always a non-nil to address, we can ignore G_create, but may wish to add
            // similar logic to the ContractFactory.
            let intrinsic = 21000;
            const bytes = lib_esm_arrayify(data);
            for (let i = 0; i < bytes.length; i++) {
                intrinsic += 4;
                if (bytes[i]) {
                    intrinsic += 64;
                }
            }
            tx.gasLimit = bignumber_BigNumber.from(fragment.gas).add(intrinsic);
        }
        // Populate "value" override
        if (ro.value) {
            const roValue = bignumber_BigNumber.from(ro.value);
            if (!roValue.isZero() && !fragment.payable) {
                contracts_lib_esm_logger.throwError("non-payable method cannot override value", lib_esm_Logger.errors.UNSUPPORTED_OPERATION, {
                    operation: "overrides.value",
                    value: overrides.value
                });
            }
            tx.value = roValue;
        }
        if (ro.customData) {
            tx.customData = lib_esm_shallowCopy(ro.customData);
        }
        if (ro.ccipReadEnabled) {
            tx.ccipReadEnabled = !!ro.ccipReadEnabled;
        }
        // Remove the overrides
        delete overrides.nonce;
        delete overrides.gasLimit;
        delete overrides.gasPrice;
        delete overrides.from;
        delete overrides.value;
        delete overrides.type;
        delete overrides.accessList;
        delete overrides.maxFeePerGas;
        delete overrides.maxPriorityFeePerGas;
        delete overrides.customData;
        delete overrides.ccipReadEnabled;
        // Make sure there are no stray overrides, which may indicate a
        // typo or using an unsupported key.
        const leftovers = Object.keys(overrides).filter((key) => (overrides[key] != null));
        if (leftovers.length) {
            contracts_lib_esm_logger.throwError(`cannot override ${leftovers.map((l) => JSON.stringify(l)).join(",")}`, lib_esm_Logger.errors.UNSUPPORTED_OPERATION, {
                operation: "overrides",
                overrides: leftovers
            });
        }
        return tx;
    });
}
function buildPopulate(contract, fragment) {
    return function (...args) {
        return populateTransaction(contract, fragment, args);
    };
}
function buildEstimate(contract, fragment) {
    const signerOrProvider = (contract.signer || contract.provider);
    return function (...args) {
        return contracts_lib_esm_awaiter(this, void 0, void 0, function* () {
            if (!signerOrProvider) {
                contracts_lib_esm_logger.throwError("estimate require a provider or signer", lib_esm_Logger.errors.UNSUPPORTED_OPERATION, {
                    operation: "estimateGas"
                });
            }
            const tx = yield populateTransaction(contract, fragment, args);
            return yield signerOrProvider.estimateGas(tx);
        });
    };
}
function addContractWait(contract, tx) {
    const wait = tx.wait.bind(tx);
    tx.wait = (confirmations) => {
        return wait(confirmations).then((receipt) => {
            receipt.events = receipt.logs.map((log) => {
                let event = deepCopy(log);
                let parsed = null;
                try {
                    parsed = contract.interface.parseLog(log);
                }
                catch (e) { }
                // Successfully parsed the event log; include it
                if (parsed) {
                    event.args = parsed.args;
                    event.decode = (data, topics) => {
                        return contract.interface.decodeEventLog(parsed.eventFragment, data, topics);
                    };
                    event.event = parsed.name;
                    event.eventSignature = parsed.signature;
                }
                // Useful operations
                event.removeListener = () => { return contract.provider; };
                event.getBlock = () => {
                    return contract.provider.getBlock(receipt.blockHash);
                };
                event.getTransaction = () => {
                    return contract.provider.getTransaction(receipt.transactionHash);
                };
                event.getTransactionReceipt = () => {
                    return Promise.resolve(receipt);
                };
                return event;
            });
            return receipt;
        });
    };
}
function buildCall(contract, fragment, collapseSimple) {
    const signerOrProvider = (contract.signer || contract.provider);
    return function (...args) {
        return contracts_lib_esm_awaiter(this, void 0, void 0, function* () {
            // Extract the "blockTag" override if present
            let blockTag = undefined;
            if (args.length === fragment.inputs.length + 1 && typeof (args[args.length - 1]) === "object") {
                const overrides = lib_esm_shallowCopy(args.pop());
                if (overrides.blockTag != null) {
                    blockTag = yield overrides.blockTag;
                }
                delete overrides.blockTag;
                args.push(overrides);
            }
            // If the contract was just deployed, wait until it is mined
            if (contract.deployTransaction != null) {
                yield contract._deployed(blockTag);
            }
            // Call a node and get the result
            const tx = yield populateTransaction(contract, fragment, args);
            const result = yield signerOrProvider.call(tx, blockTag);
            try {
                let value = contract.interface.decodeFunctionResult(fragment, result);
                if (collapseSimple && fragment.outputs.length === 1) {
                    value = value[0];
                }
                return value;
            }
            catch (error) {
                if (error.code === lib_esm_Logger.errors.CALL_EXCEPTION) {
                    error.address = contract.address;
                    error.args = args;
                    error.transaction = tx;
                }
                throw error;
            }
        });
    };
}
function buildSend(contract, fragment) {
    return function (...args) {
        return contracts_lib_esm_awaiter(this, void 0, void 0, function* () {
            if (!contract.signer) {
                contracts_lib_esm_logger.throwError("sending a transaction requires a signer", lib_esm_Logger.errors.UNSUPPORTED_OPERATION, {
                    operation: "sendTransaction"
                });
            }
            // If the contract was just deployed, wait until it is mined
            if (contract.deployTransaction != null) {
                yield contract._deployed();
            }
            const txRequest = yield populateTransaction(contract, fragment, args);
            const tx = yield contract.signer.sendTransaction(txRequest);
            // Tweak the tx.wait so the receipt has extra properties
            addContractWait(contract, tx);
            return tx;
        });
    };
}
function buildDefault(contract, fragment, collapseSimple) {
    if (fragment.constant) {
        return buildCall(contract, fragment, collapseSimple);
    }
    return buildSend(contract, fragment);
}
function lib_esm_getEventTag(filter) {
    if (filter.address && (filter.topics == null || filter.topics.length === 0)) {
        return "*";
    }
    return (filter.address || "*") + "@" + (filter.topics ? filter.topics.map((topic) => {
        if (Array.isArray(topic)) {
            return topic.join("|");
        }
        return topic;
    }).join(":") : "");
}
class RunningEvent {
    constructor(tag, filter) {
        lib_esm_defineReadOnly(this, "tag", tag);
        lib_esm_defineReadOnly(this, "filter", filter);
        this._listeners = [];
    }
    addListener(listener, once) {
        this._listeners.push({ listener: listener, once: once });
    }
    removeListener(listener) {
        let done = false;
        this._listeners = this._listeners.filter((item) => {
            if (done || item.listener !== listener) {
                return true;
            }
            done = true;
            return false;
        });
    }
    removeAllListeners() {
        this._listeners = [];
    }
    listeners() {
        return this._listeners.map((i) => i.listener);
    }
    listenerCount() {
        return this._listeners.length;
    }
    run(args) {
        const listenerCount = this.listenerCount();
        this._listeners = this._listeners.filter((item) => {
            const argsCopy = args.slice();
            // Call the callback in the next event loop
            setTimeout(() => {
                item.listener.apply(this, argsCopy);
            }, 0);
            // Reschedule it if it not "once"
            return !(item.once);
        });
        return listenerCount;
    }
    prepareEvent(event) {
    }
    // Returns the array that will be applied to an emit
    getEmit(event) {
        return [event];
    }
}
class ErrorRunningEvent extends RunningEvent {
    constructor() {
        super("error", null);
    }
}
// @TODO Fragment should inherit Wildcard? and just override getEmit?
//       or have a common abstract super class, with enough constructor
//       options to configure both.
// A Fragment Event will populate all the properties that Wildcard
// will, and additionally dereference the arguments when emitting
class FragmentRunningEvent extends RunningEvent {
    constructor(address, contractInterface, fragment, topics) {
        const filter = {
            address: address
        };
        let topic = contractInterface.getEventTopic(fragment);
        if (topics) {
            if (topic !== topics[0]) {
                contracts_lib_esm_logger.throwArgumentError("topic mismatch", "topics", topics);
            }
            filter.topics = topics.slice();
        }
        else {
            filter.topics = [topic];
        }
        super(lib_esm_getEventTag(filter), filter);
        lib_esm_defineReadOnly(this, "address", address);
        lib_esm_defineReadOnly(this, "interface", contractInterface);
        lib_esm_defineReadOnly(this, "fragment", fragment);
    }
    prepareEvent(event) {
        super.prepareEvent(event);
        event.event = this.fragment.name;
        event.eventSignature = this.fragment.format();
        event.decode = (data, topics) => {
            return this.interface.decodeEventLog(this.fragment, data, topics);
        };
        try {
            event.args = this.interface.decodeEventLog(this.fragment, event.data, event.topics);
        }
        catch (error) {
            event.args = null;
            event.decodeError = error;
        }
    }
    getEmit(event) {
        const errors = checkResultErrors(event.args);
        if (errors.length) {
            throw errors[0].error;
        }
        const args = (event.args || []).slice();
        args.push(event);
        return args;
    }
}
// A Wildcard Event will attempt to populate:
//  - event            The name of the event name
//  - eventSignature   The full signature of the event
//  - decode           A function to decode data and topics
//  - args             The decoded data and topics
class WildcardRunningEvent extends RunningEvent {
    constructor(address, contractInterface) {
        super("*", { address: address });
        lib_esm_defineReadOnly(this, "address", address);
        lib_esm_defineReadOnly(this, "interface", contractInterface);
    }
    prepareEvent(event) {
        super.prepareEvent(event);
        try {
            const parsed = this.interface.parseLog(event);
            event.event = parsed.name;
            event.eventSignature = parsed.signature;
            event.decode = (data, topics) => {
                return this.interface.decodeEventLog(parsed.eventFragment, data, topics);
            };
            event.args = parsed.args;
        }
        catch (error) {
            // No matching event
        }
    }
}
class BaseContract {
    constructor(addressOrName, contractInterface, signerOrProvider) {
        // @TODO: Maybe still check the addressOrName looks like a valid address or name?
        //address = getAddress(address);
        lib_esm_defineReadOnly(this, "interface", lib_esm_getStatic(new.target, "getInterface")(contractInterface));
        if (signerOrProvider == null) {
            lib_esm_defineReadOnly(this, "provider", null);
            lib_esm_defineReadOnly(this, "signer", null);
        }
        else if (lib_esm_Signer.isSigner(signerOrProvider)) {
            lib_esm_defineReadOnly(this, "provider", signerOrProvider.provider || null);
            lib_esm_defineReadOnly(this, "signer", signerOrProvider);
        }
        else if (Provider.isProvider(signerOrProvider)) {
            lib_esm_defineReadOnly(this, "provider", signerOrProvider);
            lib_esm_defineReadOnly(this, "signer", null);
        }
        else {
            contracts_lib_esm_logger.throwArgumentError("invalid signer or provider", "signerOrProvider", signerOrProvider);
        }
        lib_esm_defineReadOnly(this, "callStatic", {});
        lib_esm_defineReadOnly(this, "estimateGas", {});
        lib_esm_defineReadOnly(this, "functions", {});
        lib_esm_defineReadOnly(this, "populateTransaction", {});
        lib_esm_defineReadOnly(this, "filters", {});
        {
            const uniqueFilters = {};
            Object.keys(this.interface.events).forEach((eventSignature) => {
                const event = this.interface.events[eventSignature];
                lib_esm_defineReadOnly(this.filters, eventSignature, (...args) => {
                    return {
                        address: this.address,
                        topics: this.interface.encodeFilterTopics(event, args)
                    };
                });
                if (!uniqueFilters[event.name]) {
                    uniqueFilters[event.name] = [];
                }
                uniqueFilters[event.name].push(eventSignature);
            });
            Object.keys(uniqueFilters).forEach((name) => {
                const filters = uniqueFilters[name];
                if (filters.length === 1) {
                    lib_esm_defineReadOnly(this.filters, name, this.filters[filters[0]]);
                }
                else {
                    contracts_lib_esm_logger.warn(`Duplicate definition of ${name} (${filters.join(", ")})`);
                }
            });
        }
        lib_esm_defineReadOnly(this, "_runningEvents", {});
        lib_esm_defineReadOnly(this, "_wrappedEmits", {});
        if (addressOrName == null) {
            contracts_lib_esm_logger.throwArgumentError("invalid contract address or ENS name", "addressOrName", addressOrName);
        }
        lib_esm_defineReadOnly(this, "address", addressOrName);
        if (this.provider) {
            lib_esm_defineReadOnly(this, "resolvedAddress", resolveName(this.provider, addressOrName));
        }
        else {
            try {
                lib_esm_defineReadOnly(this, "resolvedAddress", Promise.resolve(lib_esm_getAddress(addressOrName)));
            }
            catch (error) {
                // Without a provider, we cannot use ENS names
                contracts_lib_esm_logger.throwError("provider is required to use ENS name as contract address", lib_esm_Logger.errors.UNSUPPORTED_OPERATION, {
                    operation: "new Contract"
                });
            }
        }
        // Swallow bad ENS names to prevent Unhandled Exceptions
        this.resolvedAddress.catch((e) => { });
        const uniqueNames = {};
        const uniqueSignatures = {};
        Object.keys(this.interface.functions).forEach((signature) => {
            const fragment = this.interface.functions[signature];
            // Check that the signature is unique; if not the ABI generation has
            // not been cleaned or may be incorrectly generated
            if (uniqueSignatures[signature]) {
                contracts_lib_esm_logger.warn(`Duplicate ABI entry for ${JSON.stringify(signature)}`);
                return;
            }
            uniqueSignatures[signature] = true;
            // Track unique names; we only expose bare named functions if they
            // are ambiguous
            {
                const name = fragment.name;
                if (!uniqueNames[`%${name}`]) {
                    uniqueNames[`%${name}`] = [];
                }
                uniqueNames[`%${name}`].push(signature);
            }
            if (this[signature] == null) {
                lib_esm_defineReadOnly(this, signature, buildDefault(this, fragment, true));
            }
            // We do not collapse simple calls on this bucket, which allows
            // frameworks to safely use this without introspection as well as
            // allows decoding error recovery.
            if (this.functions[signature] == null) {
                lib_esm_defineReadOnly(this.functions, signature, buildDefault(this, fragment, false));
            }
            if (this.callStatic[signature] == null) {
                lib_esm_defineReadOnly(this.callStatic, signature, buildCall(this, fragment, true));
            }
            if (this.populateTransaction[signature] == null) {
                lib_esm_defineReadOnly(this.populateTransaction, signature, buildPopulate(this, fragment));
            }
            if (this.estimateGas[signature] == null) {
                lib_esm_defineReadOnly(this.estimateGas, signature, buildEstimate(this, fragment));
            }
        });
        Object.keys(uniqueNames).forEach((name) => {
            // Ambiguous names to not get attached as bare names
            const signatures = uniqueNames[name];
            if (signatures.length > 1) {
                return;
            }
            // Strip off the leading "%" used for prototype protection
            name = name.substring(1);
            const signature = signatures[0];
            // If overwriting a member property that is null, swallow the error
            try {
                if (this[name] == null) {
                    lib_esm_defineReadOnly(this, name, this[signature]);
                }
            }
            catch (e) { }
            if (this.functions[name] == null) {
                lib_esm_defineReadOnly(this.functions, name, this.functions[signature]);
            }
            if (this.callStatic[name] == null) {
                lib_esm_defineReadOnly(this.callStatic, name, this.callStatic[signature]);
            }
            if (this.populateTransaction[name] == null) {
                lib_esm_defineReadOnly(this.populateTransaction, name, this.populateTransaction[signature]);
            }
            if (this.estimateGas[name] == null) {
                lib_esm_defineReadOnly(this.estimateGas, name, this.estimateGas[signature]);
            }
        });
    }
    static getContractAddress(transaction) {
        return lib_esm_getContractAddress(transaction);
    }
    static getInterface(contractInterface) {
        if (Interface.isInterface(contractInterface)) {
            return contractInterface;
        }
        return new Interface(contractInterface);
    }
    // @TODO: Allow timeout?
    deployed() {
        return this._deployed();
    }
    _deployed(blockTag) {
        if (!this._deployedPromise) {
            // If we were just deployed, we know the transaction we should occur in
            if (this.deployTransaction) {
                this._deployedPromise = this.deployTransaction.wait().then(() => {
                    return this;
                });
            }
            else {
                // @TODO: Once we allow a timeout to be passed in, we will wait
                // up to that many blocks for getCode
                // Otherwise, poll for our code to be deployed
                this._deployedPromise = this.provider.getCode(this.address, blockTag).then((code) => {
                    if (code === "0x") {
                        contracts_lib_esm_logger.throwError("contract not deployed", lib_esm_Logger.errors.UNSUPPORTED_OPERATION, {
                            contractAddress: this.address,
                            operation: "getDeployed"
                        });
                    }
                    return this;
                });
            }
        }
        return this._deployedPromise;
    }
    // @TODO:
    // estimateFallback(overrides?: TransactionRequest): Promise<BigNumber>
    // @TODO:
    // estimateDeploy(bytecode: string, ...args): Promise<BigNumber>
    fallback(overrides) {
        if (!this.signer) {
            contracts_lib_esm_logger.throwError("sending a transactions require a signer", lib_esm_Logger.errors.UNSUPPORTED_OPERATION, { operation: "sendTransaction(fallback)" });
        }
        const tx = lib_esm_shallowCopy(overrides || {});
        ["from", "to"].forEach(function (key) {
            if (tx[key] == null) {
                return;
            }
            contracts_lib_esm_logger.throwError("cannot override " + key, lib_esm_Logger.errors.UNSUPPORTED_OPERATION, { operation: key });
        });
        tx.to = this.resolvedAddress;
        return this.deployed().then(() => {
            return this.signer.sendTransaction(tx);
        });
    }
    // Reconnect to a different signer or provider
    connect(signerOrProvider) {
        if (typeof (signerOrProvider) === "string") {
            signerOrProvider = new VoidSigner(signerOrProvider, this.provider);
        }
        const contract = new (this.constructor)(this.address, this.interface, signerOrProvider);
        if (this.deployTransaction) {
            lib_esm_defineReadOnly(contract, "deployTransaction", this.deployTransaction);
        }
        return contract;
    }
    // Re-attach to a different on-chain instance of this contract
    attach(addressOrName) {
        return new (this.constructor)(addressOrName, this.interface, this.signer || this.provider);
    }
    static isIndexed(value) {
        return Indexed.isIndexed(value);
    }
    _normalizeRunningEvent(runningEvent) {
        // Already have an instance of this event running; we can re-use it
        if (this._runningEvents[runningEvent.tag]) {
            return this._runningEvents[runningEvent.tag];
        }
        return runningEvent;
    }
    _getRunningEvent(eventName) {
        if (typeof (eventName) === "string") {
            // Listen for "error" events (if your contract has an error event, include
            // the full signature to bypass this special event keyword)
            if (eventName === "error") {
                return this._normalizeRunningEvent(new ErrorRunningEvent());
            }
            // Listen for any event that is registered
            if (eventName === "event") {
                return this._normalizeRunningEvent(new RunningEvent("event", null));
            }
            // Listen for any event
            if (eventName === "*") {
                return this._normalizeRunningEvent(new WildcardRunningEvent(this.address, this.interface));
            }
            // Get the event Fragment (throws if ambiguous/unknown event)
            const fragment = this.interface.getEvent(eventName);
            return this._normalizeRunningEvent(new FragmentRunningEvent(this.address, this.interface, fragment));
        }
        // We have topics to filter by...
        if (eventName.topics && eventName.topics.length > 0) {
            // Is it a known topichash? (throws if no matching topichash)
            try {
                const topic = eventName.topics[0];
                if (typeof (topic) !== "string") {
                    throw new Error("invalid topic"); // @TODO: May happen for anonymous events
                }
                const fragment = this.interface.getEvent(topic);
                return this._normalizeRunningEvent(new FragmentRunningEvent(this.address, this.interface, fragment, eventName.topics));
            }
            catch (error) { }
            // Filter by the unknown topichash
            const filter = {
                address: this.address,
                topics: eventName.topics
            };
            return this._normalizeRunningEvent(new RunningEvent(lib_esm_getEventTag(filter), filter));
        }
        return this._normalizeRunningEvent(new WildcardRunningEvent(this.address, this.interface));
    }
    _checkRunningEvents(runningEvent) {
        if (runningEvent.listenerCount() === 0) {
            delete this._runningEvents[runningEvent.tag];
            // If we have a poller for this, remove it
            const emit = this._wrappedEmits[runningEvent.tag];
            if (emit && runningEvent.filter) {
                this.provider.off(runningEvent.filter, emit);
                delete this._wrappedEmits[runningEvent.tag];
            }
        }
    }
    // Subclasses can override this to gracefully recover
    // from parse errors if they wish
    _wrapEvent(runningEvent, log, listener) {
        const event = deepCopy(log);
        event.removeListener = () => {
            if (!listener) {
                return;
            }
            runningEvent.removeListener(listener);
            this._checkRunningEvents(runningEvent);
        };
        event.getBlock = () => { return this.provider.getBlock(log.blockHash); };
        event.getTransaction = () => { return this.provider.getTransaction(log.transactionHash); };
        event.getTransactionReceipt = () => { return this.provider.getTransactionReceipt(log.transactionHash); };
        // This may throw if the topics and data mismatch the signature
        runningEvent.prepareEvent(event);
        return event;
    }
    _addEventListener(runningEvent, listener, once) {
        if (!this.provider) {
            contracts_lib_esm_logger.throwError("events require a provider or a signer with a provider", lib_esm_Logger.errors.UNSUPPORTED_OPERATION, { operation: "once" });
        }
        runningEvent.addListener(listener, once);
        // Track this running event and its listeners (may already be there; but no hard in updating)
        this._runningEvents[runningEvent.tag] = runningEvent;
        // If we are not polling the provider, start polling
        if (!this._wrappedEmits[runningEvent.tag]) {
            const wrappedEmit = (log) => {
                let event = this._wrapEvent(runningEvent, log, listener);
                // Try to emit the result for the parameterized event...
                if (event.decodeError == null) {
                    try {
                        const args = runningEvent.getEmit(event);
                        this.emit(runningEvent.filter, ...args);
                    }
                    catch (error) {
                        event.decodeError = error.error;
                    }
                }
                // Always emit "event" for fragment-base events
                if (runningEvent.filter != null) {
                    this.emit("event", event);
                }
                // Emit "error" if there was an error
                if (event.decodeError != null) {
                    this.emit("error", event.decodeError, event);
                }
            };
            this._wrappedEmits[runningEvent.tag] = wrappedEmit;
            // Special events, like "error" do not have a filter
            if (runningEvent.filter != null) {
                this.provider.on(runningEvent.filter, wrappedEmit);
            }
        }
    }
    queryFilter(event, fromBlockOrBlockhash, toBlock) {
        const runningEvent = this._getRunningEvent(event);
        const filter = lib_esm_shallowCopy(runningEvent.filter);
        if (typeof (fromBlockOrBlockhash) === "string" && lib_esm_isHexString(fromBlockOrBlockhash, 32)) {
            if (toBlock != null) {
                contracts_lib_esm_logger.throwArgumentError("cannot specify toBlock with blockhash", "toBlock", toBlock);
            }
            filter.blockHash = fromBlockOrBlockhash;
        }
        else {
            filter.fromBlock = ((fromBlockOrBlockhash != null) ? fromBlockOrBlockhash : 0);
            filter.toBlock = ((toBlock != null) ? toBlock : "latest");
        }
        return this.provider.getLogs(filter).then((logs) => {
            return logs.map((log) => this._wrapEvent(runningEvent, log, null));
        });
    }
    on(event, listener) {
        this._addEventListener(this._getRunningEvent(event), listener, false);
        return this;
    }
    once(event, listener) {
        this._addEventListener(this._getRunningEvent(event), listener, true);
        return this;
    }
    emit(eventName, ...args) {
        if (!this.provider) {
            return false;
        }
        const runningEvent = this._getRunningEvent(eventName);
        const result = (runningEvent.run(args) > 0);
        // May have drained all the "once" events; check for living events
        this._checkRunningEvents(runningEvent);
        return result;
    }
    listenerCount(eventName) {
        if (!this.provider) {
            return 0;
        }
        if (eventName == null) {
            return Object.keys(this._runningEvents).reduce((accum, key) => {
                return accum + this._runningEvents[key].listenerCount();
            }, 0);
        }
        return this._getRunningEvent(eventName).listenerCount();
    }
    listeners(eventName) {
        if (!this.provider) {
            return [];
        }
        if (eventName == null) {
            const result = [];
            for (let tag in this._runningEvents) {
                this._runningEvents[tag].listeners().forEach((listener) => {
                    result.push(listener);
                });
            }
            return result;
        }
        return this._getRunningEvent(eventName).listeners();
    }
    removeAllListeners(eventName) {
        if (!this.provider) {
            return this;
        }
        if (eventName == null) {
            for (const tag in this._runningEvents) {
                const runningEvent = this._runningEvents[tag];
                runningEvent.removeAllListeners();
                this._checkRunningEvents(runningEvent);
            }
            return this;
        }
        // Delete any listeners
        const runningEvent = this._getRunningEvent(eventName);
        runningEvent.removeAllListeners();
        this._checkRunningEvents(runningEvent);
        return this;
    }
    off(eventName, listener) {
        if (!this.provider) {
            return this;
        }
        const runningEvent = this._getRunningEvent(eventName);
        runningEvent.removeListener(listener);
        this._checkRunningEvents(runningEvent);
        return this;
    }
    removeListener(eventName, listener) {
        return this.off(eventName, listener);
    }
}
class Contract extends BaseContract {
}
class ContractFactory {
    constructor(contractInterface, bytecode, signer) {
        let bytecodeHex = null;
        if (typeof (bytecode) === "string") {
            bytecodeHex = bytecode;
        }
        else if (isBytes(bytecode)) {
            bytecodeHex = hexlify(bytecode);
        }
        else if (bytecode && typeof (bytecode.object) === "string") {
            // Allow the bytecode object from the Solidity compiler
            bytecodeHex = bytecode.object;
        }
        else {
            // Crash in the next verification step
            bytecodeHex = "!";
        }
        // Make sure it is 0x prefixed
        if (bytecodeHex.substring(0, 2) !== "0x") {
            bytecodeHex = "0x" + bytecodeHex;
        }
        // Make sure the final result is valid bytecode
        if (!isHexString(bytecodeHex) || (bytecodeHex.length % 2)) {
            contracts_lib_esm_logger.throwArgumentError("invalid bytecode", "bytecode", bytecode);
        }
        // If we have a signer, make sure it is valid
        if (signer && !Signer.isSigner(signer)) {
            contracts_lib_esm_logger.throwArgumentError("invalid signer", "signer", signer);
        }
        defineReadOnly(this, "bytecode", bytecodeHex);
        defineReadOnly(this, "interface", getStatic(new.target, "getInterface")(contractInterface));
        defineReadOnly(this, "signer", signer || null);
    }
    // @TODO: Future; rename to populateTransaction?
    getDeployTransaction(...args) {
        let tx = {};
        // If we have 1 additional argument, we allow transaction overrides
        if (args.length === this.interface.deploy.inputs.length + 1 && typeof (args[args.length - 1]) === "object") {
            tx = shallowCopy(args.pop());
            for (const key in tx) {
                if (!contracts_lib_esm_allowedTransactionKeys[key]) {
                    throw new Error("unknown transaction override " + key);
                }
            }
        }
        // Do not allow these to be overridden in a deployment transaction
        ["data", "from", "to"].forEach((key) => {
            if (tx[key] == null) {
                return;
            }
            contracts_lib_esm_logger.throwError("cannot override " + key, Logger.errors.UNSUPPORTED_OPERATION, { operation: key });
        });
        if (tx.value) {
            const value = BigNumber.from(tx.value);
            if (!value.isZero() && !this.interface.deploy.payable) {
                contracts_lib_esm_logger.throwError("non-payable constructor cannot override value", Logger.errors.UNSUPPORTED_OPERATION, {
                    operation: "overrides.value",
                    value: tx.value
                });
            }
        }
        // Make sure the call matches the constructor signature
        contracts_lib_esm_logger.checkArgumentCount(args.length, this.interface.deploy.inputs.length, " in Contract constructor");
        // Set the data to the bytecode + the encoded constructor arguments
        tx.data = hexlify(concat([
            this.bytecode,
            this.interface.encodeDeploy(args)
        ]));
        return tx;
    }
    deploy(...args) {
        return contracts_lib_esm_awaiter(this, void 0, void 0, function* () {
            let overrides = {};
            // If 1 extra parameter was passed in, it contains overrides
            if (args.length === this.interface.deploy.inputs.length + 1) {
                overrides = args.pop();
            }
            // Make sure the call matches the constructor signature
            contracts_lib_esm_logger.checkArgumentCount(args.length, this.interface.deploy.inputs.length, " in Contract constructor");
            // Resolve ENS names and promises in the arguments
            const params = yield resolveAddresses(this.signer, args, this.interface.deploy.inputs);
            params.push(overrides);
            // Get the deployment transaction (with optional overrides)
            const unsignedTx = this.getDeployTransaction(...params);
            // Send the deployment transaction
            const tx = yield this.signer.sendTransaction(unsignedTx);
            const address = getStatic(this.constructor, "getContractAddress")(tx);
            const contract = getStatic(this.constructor, "getContract")(address, this.interface, this.signer);
            // Add the modified wait that wraps events
            addContractWait(contract, tx);
            defineReadOnly(contract, "deployTransaction", tx);
            return contract;
        });
    }
    attach(address) {
        return (this.constructor).getContract(address, this.interface, this.signer);
    }
    connect(signer) {
        return new (this.constructor)(this.interface, this.bytecode, signer);
    }
    static fromSolidity(compilerOutput, signer) {
        if (compilerOutput == null) {
            contracts_lib_esm_logger.throwError("missing compiler output", Logger.errors.MISSING_ARGUMENT, { argument: "compilerOutput" });
        }
        if (typeof (compilerOutput) === "string") {
            compilerOutput = JSON.parse(compilerOutput);
        }
        const abi = compilerOutput.abi;
        let bytecode = null;
        if (compilerOutput.bytecode) {
            bytecode = compilerOutput.bytecode;
        }
        else if (compilerOutput.evm && compilerOutput.evm.bytecode) {
            bytecode = compilerOutput.evm.bytecode;
        }
        return new this(abi, bytecode, signer);
    }
    static getInterface(contractInterface) {
        return Contract.getInterface(contractInterface);
    }
    static getContractAddress(tx) {
        return getContractAddress(tx);
    }
    static getContract(address, contractInterface, signer) {
        return new Contract(address, contractInterface, signer);
    }
}
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+bignumber@5.7.0/node_modules/@ethersproject/bignumber/lib.esm/fixednumber.js




const fixednumber_logger = new lib_esm_Logger(bignumber_lib_esm_version_version);

const fixednumber_constructorGuard = {};
const fixednumber_Zero = bignumber_BigNumber.from(0);
const fixednumber_NegativeOne = bignumber_BigNumber.from(-1);
function fixednumber_throwFault(message, fault, operation, value) {
    const params = { fault: fault, operation: operation };
    if (value !== undefined) {
        params.value = value;
    }
    return fixednumber_logger.throwError(message, lib_esm_Logger.errors.NUMERIC_FAULT, params);
}
// Constant to pull zeros from for multipliers
let zeros = "0";
while (zeros.length < 256) {
    zeros += zeros;
}
// Returns a string "1" followed by decimal "0"s
function getMultiplier(decimals) {
    if (typeof (decimals) !== "number") {
        try {
            decimals = bignumber_BigNumber.from(decimals).toNumber();
        }
        catch (e) { }
    }
    if (typeof (decimals) === "number" && decimals >= 0 && decimals <= 256 && !(decimals % 1)) {
        return ("1" + zeros.substring(0, decimals));
    }
    return fixednumber_logger.throwArgumentError("invalid decimal size", "decimals", decimals);
}
function formatFixed(value, decimals) {
    if (decimals == null) {
        decimals = 0;
    }
    const multiplier = getMultiplier(decimals);
    // Make sure wei is a big number (convert as necessary)
    value = bignumber_BigNumber.from(value);
    const negative = value.lt(fixednumber_Zero);
    if (negative) {
        value = value.mul(fixednumber_NegativeOne);
    }
    let fraction = value.mod(multiplier).toString();
    while (fraction.length < multiplier.length - 1) {
        fraction = "0" + fraction;
    }
    // Strip training 0
    fraction = fraction.match(/^([0-9]*[1-9]|0)(0*)/)[1];
    const whole = value.div(multiplier).toString();
    if (multiplier.length === 1) {
        value = whole;
    }
    else {
        value = whole + "." + fraction;
    }
    if (negative) {
        value = "-" + value;
    }
    return value;
}
function parseFixed(value, decimals) {
    if (decimals == null) {
        decimals = 0;
    }
    const multiplier = getMultiplier(decimals);
    if (typeof (value) !== "string" || !value.match(/^-?[0-9.]+$/)) {
        fixednumber_logger.throwArgumentError("invalid decimal value", "value", value);
    }
    // Is it negative?
    const negative = (value.substring(0, 1) === "-");
    if (negative) {
        value = value.substring(1);
    }
    if (value === ".") {
        fixednumber_logger.throwArgumentError("missing value", "value", value);
    }
    // Split it into a whole and fractional part
    const comps = value.split(".");
    if (comps.length > 2) {
        fixednumber_logger.throwArgumentError("too many decimal points", "value", value);
    }
    let whole = comps[0], fraction = comps[1];
    if (!whole) {
        whole = "0";
    }
    if (!fraction) {
        fraction = "0";
    }
    // Trim trailing zeros
    while (fraction[fraction.length - 1] === "0") {
        fraction = fraction.substring(0, fraction.length - 1);
    }
    // Check the fraction doesn't exceed our decimals size
    if (fraction.length > multiplier.length - 1) {
        fixednumber_throwFault("fractional component exceeds decimals", "underflow", "parseFixed");
    }
    // If decimals is 0, we have an empty string for fraction
    if (fraction === "") {
        fraction = "0";
    }
    // Fully pad the string with zeros to get to wei
    while (fraction.length < multiplier.length - 1) {
        fraction += "0";
    }
    const wholeValue = bignumber_BigNumber.from(whole);
    const fractionValue = bignumber_BigNumber.from(fraction);
    let wei = (wholeValue.mul(multiplier)).add(fractionValue);
    if (negative) {
        wei = wei.mul(fixednumber_NegativeOne);
    }
    return wei;
}
class FixedFormat {
    constructor(constructorGuard, signed, width, decimals) {
        if (constructorGuard !== fixednumber_constructorGuard) {
            fixednumber_logger.throwError("cannot use FixedFormat constructor; use FixedFormat.from", lib_esm_Logger.errors.UNSUPPORTED_OPERATION, {
                operation: "new FixedFormat"
            });
        }
        this.signed = signed;
        this.width = width;
        this.decimals = decimals;
        this.name = (signed ? "" : "u") + "fixed" + String(width) + "x" + String(decimals);
        this._multiplier = getMultiplier(decimals);
        Object.freeze(this);
    }
    static from(value) {
        if (value instanceof FixedFormat) {
            return value;
        }
        if (typeof (value) === "number") {
            value = `fixed128x${value}`;
        }
        let signed = true;
        let width = 128;
        let decimals = 18;
        if (typeof (value) === "string") {
            if (value === "fixed") {
                // defaults...
            }
            else if (value === "ufixed") {
                signed = false;
            }
            else {
                const match = value.match(/^(u?)fixed([0-9]+)x([0-9]+)$/);
                if (!match) {
                    fixednumber_logger.throwArgumentError("invalid fixed format", "format", value);
                }
                signed = (match[1] !== "u");
                width = parseInt(match[2]);
                decimals = parseInt(match[3]);
            }
        }
        else if (value) {
            const check = (key, type, defaultValue) => {
                if (value[key] == null) {
                    return defaultValue;
                }
                if (typeof (value[key]) !== type) {
                    fixednumber_logger.throwArgumentError("invalid fixed format (" + key + " not " + type + ")", "format." + key, value[key]);
                }
                return value[key];
            };
            signed = check("signed", "boolean", signed);
            width = check("width", "number", width);
            decimals = check("decimals", "number", decimals);
        }
        if (width % 8) {
            fixednumber_logger.throwArgumentError("invalid fixed format width (not byte aligned)", "format.width", width);
        }
        if (decimals > 80) {
            fixednumber_logger.throwArgumentError("invalid fixed format (decimals too large)", "format.decimals", decimals);
        }
        return new FixedFormat(fixednumber_constructorGuard, signed, width, decimals);
    }
}
class FixedNumber {
    constructor(constructorGuard, hex, value, format) {
        if (constructorGuard !== fixednumber_constructorGuard) {
            fixednumber_logger.throwError("cannot use FixedNumber constructor; use FixedNumber.from", lib_esm_Logger.errors.UNSUPPORTED_OPERATION, {
                operation: "new FixedFormat"
            });
        }
        this.format = format;
        this._hex = hex;
        this._value = value;
        this._isFixedNumber = true;
        Object.freeze(this);
    }
    _checkFormat(other) {
        if (this.format.name !== other.format.name) {
            fixednumber_logger.throwArgumentError("incompatible format; use fixedNumber.toFormat", "other", other);
        }
    }
    addUnsafe(other) {
        this._checkFormat(other);
        const a = parseFixed(this._value, this.format.decimals);
        const b = parseFixed(other._value, other.format.decimals);
        return FixedNumber.fromValue(a.add(b), this.format.decimals, this.format);
    }
    subUnsafe(other) {
        this._checkFormat(other);
        const a = parseFixed(this._value, this.format.decimals);
        const b = parseFixed(other._value, other.format.decimals);
        return FixedNumber.fromValue(a.sub(b), this.format.decimals, this.format);
    }
    mulUnsafe(other) {
        this._checkFormat(other);
        const a = parseFixed(this._value, this.format.decimals);
        const b = parseFixed(other._value, other.format.decimals);
        return FixedNumber.fromValue(a.mul(b).div(this.format._multiplier), this.format.decimals, this.format);
    }
    divUnsafe(other) {
        this._checkFormat(other);
        const a = parseFixed(this._value, this.format.decimals);
        const b = parseFixed(other._value, other.format.decimals);
        return FixedNumber.fromValue(a.mul(this.format._multiplier).div(b), this.format.decimals, this.format);
    }
    floor() {
        const comps = this.toString().split(".");
        if (comps.length === 1) {
            comps.push("0");
        }
        let result = FixedNumber.from(comps[0], this.format);
        const hasFraction = !comps[1].match(/^(0*)$/);
        if (this.isNegative() && hasFraction) {
            result = result.subUnsafe(ONE.toFormat(result.format));
        }
        return result;
    }
    ceiling() {
        const comps = this.toString().split(".");
        if (comps.length === 1) {
            comps.push("0");
        }
        let result = FixedNumber.from(comps[0], this.format);
        const hasFraction = !comps[1].match(/^(0*)$/);
        if (!this.isNegative() && hasFraction) {
            result = result.addUnsafe(ONE.toFormat(result.format));
        }
        return result;
    }
    // @TODO: Support other rounding algorithms
    round(decimals) {
        if (decimals == null) {
            decimals = 0;
        }
        // If we are already in range, we're done
        const comps = this.toString().split(".");
        if (comps.length === 1) {
            comps.push("0");
        }
        if (decimals < 0 || decimals > 80 || (decimals % 1)) {
            fixednumber_logger.throwArgumentError("invalid decimal count", "decimals", decimals);
        }
        if (comps[1].length <= decimals) {
            return this;
        }
        const factor = FixedNumber.from("1" + zeros.substring(0, decimals), this.format);
        const bump = BUMP.toFormat(this.format);
        return this.mulUnsafe(factor).addUnsafe(bump).floor().divUnsafe(factor);
    }
    isZero() {
        return (this._value === "0.0" || this._value === "0");
    }
    isNegative() {
        return (this._value[0] === "-");
    }
    toString() { return this._value; }
    toHexString(width) {
        if (width == null) {
            return this._hex;
        }
        if (width % 8) {
            fixednumber_logger.throwArgumentError("invalid byte width", "width", width);
        }
        const hex = bignumber_BigNumber.from(this._hex).fromTwos(this.format.width).toTwos(width).toHexString();
        return hexZeroPad(hex, width / 8);
    }
    toUnsafeFloat() { return parseFloat(this.toString()); }
    toFormat(format) {
        return FixedNumber.fromString(this._value, format);
    }
    static fromValue(value, decimals, format) {
        // If decimals looks more like a format, and there is no format, shift the parameters
        if (format == null && decimals != null && !isBigNumberish(decimals)) {
            format = decimals;
            decimals = null;
        }
        if (decimals == null) {
            decimals = 0;
        }
        if (format == null) {
            format = "fixed";
        }
        return FixedNumber.fromString(formatFixed(value, decimals), FixedFormat.from(format));
    }
    static fromString(value, format) {
        if (format == null) {
            format = "fixed";
        }
        const fixedFormat = FixedFormat.from(format);
        const numeric = parseFixed(value, fixedFormat.decimals);
        if (!fixedFormat.signed && numeric.lt(fixednumber_Zero)) {
            fixednumber_throwFault("unsigned value cannot be negative", "overflow", "value", value);
        }
        let hex = null;
        if (fixedFormat.signed) {
            hex = numeric.toTwos(fixedFormat.width).toHexString();
        }
        else {
            hex = numeric.toHexString();
            hex = hexZeroPad(hex, fixedFormat.width / 8);
        }
        const decimal = formatFixed(numeric, fixedFormat.decimals);
        return new FixedNumber(fixednumber_constructorGuard, hex, decimal, fixedFormat);
    }
    static fromBytes(value, format) {
        if (format == null) {
            format = "fixed";
        }
        const fixedFormat = FixedFormat.from(format);
        if (lib_esm_arrayify(value).length > fixedFormat.width / 8) {
            throw new Error("overflow");
        }
        let numeric = bignumber_BigNumber.from(value);
        if (fixedFormat.signed) {
            numeric = numeric.fromTwos(fixedFormat.width);
        }
        const hex = numeric.toTwos((fixedFormat.signed ? 0 : 1) + fixedFormat.width).toHexString();
        const decimal = formatFixed(numeric, fixedFormat.decimals);
        return new FixedNumber(fixednumber_constructorGuard, hex, decimal, fixedFormat);
    }
    static from(value, format) {
        if (typeof (value) === "string") {
            return FixedNumber.fromString(value, format);
        }
        if (lib_esm_isBytes(value)) {
            return FixedNumber.fromBytes(value, format);
        }
        try {
            return FixedNumber.fromValue(value, 0, format);
        }
        catch (error) {
            // Allow NUMERIC_FAULT to bubble up
            if (error.code !== lib_esm_Logger.errors.INVALID_ARGUMENT) {
                throw error;
            }
        }
        return fixednumber_logger.throwArgumentError("invalid FixedNumber value", "value", value);
    }
    static isFixedNumber(value) {
        return !!(value && value._isFixedNumber);
    }
}
const ONE = FixedNumber.from(1);
const BUMP = FixedNumber.from("0.5");
//# sourceMappingURL=fixednumber.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+units@5.7.0/node_modules/@ethersproject/units/lib.esm/_version.js
const units_lib_esm_version_version = "units/5.7.0";
//# sourceMappingURL=_version.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+units@5.7.0/node_modules/@ethersproject/units/lib.esm/index.js




const units_lib_esm_logger = new lib_esm_Logger(units_lib_esm_version_version);
const names = [
    "wei",
    "kwei",
    "mwei",
    "gwei",
    "szabo",
    "finney",
    "ether",
];
// Some environments have issues with RegEx that contain back-tracking, so we cannot
// use them.
function commify(value) {
    const comps = String(value).split(".");
    if (comps.length > 2 || !comps[0].match(/^-?[0-9]*$/) || (comps[1] && !comps[1].match(/^[0-9]*$/)) || value === "." || value === "-.") {
        units_lib_esm_logger.throwArgumentError("invalid value", "value", value);
    }
    // Make sure we have at least one whole digit (0 if none)
    let whole = comps[0];
    let negative = "";
    if (whole.substring(0, 1) === "-") {
        negative = "-";
        whole = whole.substring(1);
    }
    // Make sure we have at least 1 whole digit with no leading zeros
    while (whole.substring(0, 1) === "0") {
        whole = whole.substring(1);
    }
    if (whole === "") {
        whole = "0";
    }
    let suffix = "";
    if (comps.length === 2) {
        suffix = "." + (comps[1] || "0");
    }
    while (suffix.length > 2 && suffix[suffix.length - 1] === "0") {
        suffix = suffix.substring(0, suffix.length - 1);
    }
    const formatted = [];
    while (whole.length) {
        if (whole.length <= 3) {
            formatted.unshift(whole);
            break;
        }
        else {
            const index = whole.length - 3;
            formatted.unshift(whole.substring(index));
            whole = whole.substring(0, index);
        }
    }
    return negative + formatted.join(",") + suffix;
}
function formatUnits(value, unitName) {
    if (typeof (unitName) === "string") {
        const index = names.indexOf(unitName);
        if (index !== -1) {
            unitName = 3 * index;
        }
    }
    return formatFixed(value, (unitName != null) ? unitName : 18);
}
function parseUnits(value, unitName) {
    if (typeof (value) !== "string") {
        units_lib_esm_logger.throwArgumentError("value must be a string", "value", value);
    }
    if (typeof (unitName) === "string") {
        const index = names.indexOf(unitName);
        if (index !== -1) {
            unitName = 3 * index;
        }
    }
    return parseFixed(value, (unitName != null) ? unitName : 18);
}
function formatEther(wei) {
    return formatUnits(wei, 18);
}
function parseEther(ether) {
    return parseUnits(ether, 18);
}
//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./node_modules/.pnpm/isomorphic-fetch@3.0.0/node_modules/isomorphic-fetch/fetch-npm-browserify.js
var fetch_npm_browserify = __webpack_require__(969);
;// CONCATENATED MODULE: ./src/data/peanutAbiV3.json
const peanutAbiV3_namespaceObject = JSON.parse('[{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"_index","type":"uint256"},{"indexed":false,"internalType":"uint8","name":"_contractType","type":"uint8"},{"indexed":false,"internalType":"uint256","name":"_amount","type":"uint256"},{"indexed":true,"internalType":"address","name":"_senderAddress","type":"address"}],"name":"DepositEvent","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"string","name":"message","type":"string"}],"name":"MessageEvent","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"_index","type":"uint256"},{"indexed":false,"internalType":"uint8","name":"_contractType","type":"uint8"},{"indexed":false,"internalType":"uint256","name":"_amount","type":"uint256"},{"indexed":true,"internalType":"address","name":"_recipientAddress","type":"address"}],"name":"WithdrawEvent","type":"event"},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"}],"name":"deposits","outputs":[{"internalType":"address","name":"pubKey20","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"},{"internalType":"address","name":"tokenAddress","type":"address"},{"internalType":"uint8","name":"contractType","type":"uint8"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getDepositCount","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_tokenAddress","type":"address"},{"internalType":"uint8","name":"_contractType","type":"uint8"},{"internalType":"uint256","name":"_amount","type":"uint256"},{"internalType":"uint256","name":"_tokenId","type":"uint256"},{"internalType":"address","name":"_pubKey20","type":"address"}],"name":"makeDeposit","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"address","name":"_operator","type":"address"},{"internalType":"address","name":"_from","type":"address"},{"internalType":"uint256[]","name":"_ids","type":"uint256[]"},{"internalType":"uint256[]","name":"_values","type":"uint256[]"},{"internalType":"bytes","name":"_data","type":"bytes"}],"name":"onERC1155BatchReceived","outputs":[{"internalType":"bytes4","name":"","type":"bytes4"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_operator","type":"address"},{"internalType":"address","name":"_from","type":"address"},{"internalType":"uint256","name":"_tokenId","type":"uint256"},{"internalType":"uint256","name":"_value","type":"uint256"},{"internalType":"bytes","name":"_data","type":"bytes"}],"name":"onERC1155Received","outputs":[{"internalType":"bytes4","name":"","type":"bytes4"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_operator","type":"address"},{"internalType":"address","name":"_from","type":"address"},{"internalType":"uint256","name":"_tokenId","type":"uint256"},{"internalType":"bytes","name":"_data","type":"bytes"}],"name":"onERC721Received","outputs":[{"internalType":"bytes4","name":"","type":"bytes4"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"bytes4","name":"_interfaceId","type":"bytes4"}],"name":"supportsInterface","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"_index","type":"uint256"},{"internalType":"address","name":"_recipientAddress","type":"address"},{"internalType":"bytes32","name":"_recipientAddressHash","type":"bytes32"},{"internalType":"bytes","name":"_signature","type":"bytes"}],"name":"withdrawDeposit","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"}]');
;// CONCATENATED MODULE: ./src/data/peanutAbiV4.json
const peanutAbiV4_namespaceObject = JSON.parse('[{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"uint256","name":"_index","type":"uint256"},{"indexed":true,"internalType":"uint8","name":"_contractType","type":"uint8"},{"indexed":false,"internalType":"uint256","name":"_amount","type":"uint256"},{"indexed":true,"internalType":"address","name":"_senderAddress","type":"address"}],"name":"DepositEvent","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"string","name":"message","type":"string"}],"name":"MessageEvent","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"uint256","name":"_index","type":"uint256"},{"indexed":true,"internalType":"uint8","name":"_contractType","type":"uint8"},{"indexed":false,"internalType":"uint256","name":"_amount","type":"uint256"},{"indexed":true,"internalType":"address","name":"_recipientAddress","type":"address"}],"name":"WithdrawEvent","type":"event"},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"}],"name":"deposits","outputs":[{"internalType":"address","name":"pubKey20","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"},{"internalType":"address","name":"tokenAddress","type":"address"},{"internalType":"uint8","name":"contractType","type":"uint8"},{"internalType":"uint256","name":"tokenId","type":"uint256"},{"internalType":"address","name":"senderAddress","type":"address"},{"internalType":"uint256","name":"timestamp","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getAllDeposits","outputs":[{"components":[{"internalType":"address","name":"pubKey20","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"},{"internalType":"address","name":"tokenAddress","type":"address"},{"internalType":"uint8","name":"contractType","type":"uint8"},{"internalType":"uint256","name":"tokenId","type":"uint256"},{"internalType":"address","name":"senderAddress","type":"address"},{"internalType":"uint256","name":"timestamp","type":"uint256"}],"internalType":"struct PeanutV4.Deposit[]","name":"","type":"tuple[]"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_address","type":"address"}],"name":"getAllDepositsForAddress","outputs":[{"components":[{"internalType":"address","name":"pubKey20","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"},{"internalType":"address","name":"tokenAddress","type":"address"},{"internalType":"uint8","name":"contractType","type":"uint8"},{"internalType":"uint256","name":"tokenId","type":"uint256"},{"internalType":"address","name":"senderAddress","type":"address"},{"internalType":"uint256","name":"timestamp","type":"uint256"}],"internalType":"struct PeanutV4.Deposit[]","name":"","type":"tuple[]"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"_index","type":"uint256"}],"name":"getDeposit","outputs":[{"components":[{"internalType":"address","name":"pubKey20","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"},{"internalType":"address","name":"tokenAddress","type":"address"},{"internalType":"uint8","name":"contractType","type":"uint8"},{"internalType":"uint256","name":"tokenId","type":"uint256"},{"internalType":"address","name":"senderAddress","type":"address"},{"internalType":"uint256","name":"timestamp","type":"uint256"}],"internalType":"struct PeanutV4.Deposit","name":"","type":"tuple"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getDepositCount","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"bytes32","name":"messageHash","type":"bytes32"},{"internalType":"bytes","name":"signature","type":"bytes"}],"name":"getSigner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"pure","type":"function"},{"inputs":[{"internalType":"address","name":"_tokenAddress","type":"address"},{"internalType":"uint8","name":"_contractType","type":"uint8"},{"internalType":"uint256","name":"_amount","type":"uint256"},{"internalType":"uint256","name":"_tokenId","type":"uint256"},{"internalType":"address","name":"_pubKey20","type":"address"}],"name":"makeDeposit","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"address","name":"_operator","type":"address"},{"internalType":"address","name":"_from","type":"address"},{"internalType":"uint256[]","name":"_ids","type":"uint256[]"},{"internalType":"uint256[]","name":"_values","type":"uint256[]"},{"internalType":"bytes","name":"_data","type":"bytes"}],"name":"onERC1155BatchReceived","outputs":[{"internalType":"bytes4","name":"","type":"bytes4"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_operator","type":"address"},{"internalType":"address","name":"_from","type":"address"},{"internalType":"uint256","name":"_tokenId","type":"uint256"},{"internalType":"uint256","name":"_value","type":"uint256"},{"internalType":"bytes","name":"_data","type":"bytes"}],"name":"onERC1155Received","outputs":[{"internalType":"bytes4","name":"","type":"bytes4"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_operator","type":"address"},{"internalType":"address","name":"_from","type":"address"},{"internalType":"uint256","name":"_tokenId","type":"uint256"},{"internalType":"bytes","name":"_data","type":"bytes"}],"name":"onERC721Received","outputs":[{"internalType":"bytes4","name":"","type":"bytes4"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"bytes4","name":"_interfaceId","type":"bytes4"}],"name":"supportsInterface","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"pure","type":"function"},{"inputs":[{"internalType":"uint256","name":"_index","type":"uint256"},{"internalType":"address","name":"_recipientAddress","type":"address"},{"internalType":"bytes32","name":"_recipientAddressHash","type":"bytes32"},{"internalType":"bytes","name":"_signature","type":"bytes"}],"name":"withdrawDeposit","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_index","type":"uint256"}],"name":"withdrawDepositSender","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"}]');
;// CONCATENATED MODULE: ./src/data/peanutBatcherV4.abi.json
const peanutBatcherV4_abi_namespaceObject = JSON.parse('[{"inputs":[{"internalType":"address","name":"_peanutAddress","type":"address"},{"internalType":"address","name":"_tokenAddress","type":"address"},{"internalType":"uint8","name":"_contractType","type":"uint8"},{"internalType":"uint256","name":"_amount","type":"uint256"},{"internalType":"uint256","name":"_tokenId","type":"uint256"},{"internalType":"address[]","name":"_pubKeys20","type":"address[]"}],"name":"batchMakeDeposit","outputs":[{"internalType":"uint256[]","name":"","type":"uint256[]"}],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"address","name":"_peanutAddress","type":"address"},{"internalType":"address[]","name":"_tokenAddresses","type":"address[]"},{"internalType":"uint8[]","name":"_contractTypes","type":"uint8[]"},{"internalType":"uint256[]","name":"_amounts","type":"uint256[]"},{"internalType":"uint256[]","name":"_tokenIds","type":"uint256[]"},{"internalType":"address[]","name":"_pubKeys20","type":"address[]"}],"name":"batchMakeDepositArbitrary","outputs":[{"internalType":"uint256[]","name":"","type":"uint256[]"}],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"address","name":"_peanutAddress","type":"address"},{"internalType":"address","name":"_tokenAddress","type":"address"},{"internalType":"uint8","name":"_contractType","type":"uint8"},{"internalType":"uint256","name":"_amount","type":"uint256"},{"internalType":"uint256","name":"_tokenId","type":"uint256"},{"internalType":"address[]","name":"_pubKeys20","type":"address[]"}],"name":"batchMakeDepositNoReturn","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[],"name":"peanut","outputs":[{"internalType":"contract IPeanut","name":"","type":"address"}],"stateMutability":"view","type":"function"}]');
;// CONCATENATED MODULE: ./src/data/erc20abi.json
const erc20abi_namespaceObject = JSON.parse('[{"constant":true,"inputs":[],"name":"name","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_spender","type":"address"},{"name":"_value","type":"uint256"}],"name":"approve","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_from","type":"address"},{"name":"_to","type":"address"},{"name":"_value","type":"uint256"}],"name":"transferFrom","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"decimals","outputs":[{"name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"_owner","type":"address"}],"name":"balanceOf","outputs":[{"name":"balance","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_to","type":"address"},{"name":"_value","type":"uint256"}],"name":"transfer","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"_owner","type":"address"},{"name":"_spender","type":"address"}],"name":"allowance","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"payable":true,"stateMutability":"payable","type":"fallback"},{"anonymous":false,"inputs":[{"indexed":true,"name":"owner","type":"address"},{"indexed":true,"name":"spender","type":"address"},{"indexed":false,"name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"from","type":"address"},{"indexed":true,"name":"to","type":"address"},{"indexed":false,"name":"value","type":"uint256"}],"name":"Transfer","type":"event"}]');
;// CONCATENATED MODULE: ./src/data/erc721abi.json
const erc721abi_namespaceObject = JSON.parse('[{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"approved","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"operator","type":"address"},{"indexed":false,"internalType":"bool","name":"approved","type":"bool"}],"name":"ApprovalForAll","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"_to","type":"address"},{"indexed":false,"internalType":"uint256","name":"_tokenId","type":"uint256"}],"name":"Mint","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"Transfer","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"_to","type":"address"},{"indexed":false,"internalType":"uint256","name":"_value","type":"uint256"}],"name":"Withdraw","type":"event"},{"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"approve","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"getApproved","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"operator","type":"address"}],"name":"isApprovedForAll","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint8","name":"count","type":"uint8"}],"name":"mint","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"ownerOf","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"safeTransferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"},{"internalType":"bytes","name":"data","type":"bytes"}],"name":"safeTransferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"operator","type":"address"},{"internalType":"bool","name":"approved","type":"bool"}],"name":"setApprovalForAll","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"bytes4","name":"interfaceId","type":"bytes4"}],"name":"supportsInterface","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"tokenExists","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"tokenURI","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"transferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"withdrawFunds","outputs":[],"stateMutability":"nonpayable","type":"function"}]');
;// CONCATENATED MODULE: ./src/data/erc1155abi.json
const erc1155abi_namespaceObject = JSON.parse('[{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"account","type":"address"},{"indexed":true,"internalType":"address","name":"operator","type":"address"},{"indexed":false,"internalType":"bool","name":"approved","type":"bool"}],"name":"ApprovalForAll","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"operator","type":"address"},{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256[]","name":"ids","type":"uint256[]"},{"indexed":false,"internalType":"uint256[]","name":"values","type":"uint256[]"}],"name":"TransferBatch","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"operator","type":"address"},{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"id","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"TransferSingle","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"string","name":"value","type":"string"},{"indexed":true,"internalType":"uint256","name":"id","type":"uint256"}],"name":"URI","type":"event"},{"inputs":[{"internalType":"address","name":"account","type":"address"},{"internalType":"uint256","name":"id","type":"uint256"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address[]","name":"accounts","type":"address[]"},{"internalType":"uint256[]","name":"ids","type":"uint256[]"}],"name":"balanceOfBatch","outputs":[{"internalType":"uint256[]","name":"","type":"uint256[]"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"},{"internalType":"address","name":"operator","type":"address"}],"name":"isApprovedForAll","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256[]","name":"ids","type":"uint256[]"},{"internalType":"uint256[]","name":"amounts","type":"uint256[]"},{"internalType":"bytes","name":"data","type":"bytes"}],"name":"safeBatchTransferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"id","type":"uint256"},{"internalType":"uint256","name":"amount","type":"uint256"},{"internalType":"bytes","name":"data","type":"bytes"}],"name":"safeTransferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"operator","type":"address"},{"internalType":"bool","name":"approved","type":"bool"}],"name":"setApprovalForAll","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"bytes4","name":"interfaceId","type":"bytes4"}],"name":"supportsInterface","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"id","type":"uint256"}],"name":"uri","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"}]');
;// CONCATENATED MODULE: ./src/data/contracts.json
const contracts_namespaceObject = JSON.parse('{"1":{"name":"ethereum-mainnet","mainnet":"true","v3":"0xdB60C736A30C41D9df0081057Eae73C3eb119895","v4":"0x40F3548E54a55B9cC21D5EeC3ddcAc151782c7E0","Bv4":"0x05C94c7A5f2FD53F3DC5E0a3F62F2E31F0013bc3"},"5":{"name":"ethereum-goerli","mainnet":"false","v1":"0x616d197A29E50EBD08a4287b26e47041286F171D","v2":"0xd4964Df4dc2eb6B2fD4157DFda264AA9dd720C92","v3":"0xd068b1F6F0623CbCC7ADC7545290f8991C9B8Ec9","v4":"0x891021b34fedc18e36c015bffaa64a2421738906","Bv4":"0xD605357aBbAF57d118c8DeDf6F2d71aEFa3ba9c5"},"10":{"name":"optimism-mainnet","mainnet":"true","v1":"0x9B0817fA08b46670B92300B58AA1f4AB155701ea","v3":"0x1aBe03DC4706aE47c4F2ae04EEBe5c8607c74e17","Bv4":"0x8471d15dE1f44c66cBDc30CBA8ce5cedf546DB8E","v4":"0xc430C74f02670823bB231DeD2c6bFd4e8C54F970"},"56":{"name":"bsc-mainnet","mainnet":"true","v3":"0x8d1a17A3A4504aEB17515645BA8098f1D75237f7","v4":"0x0abfA78f307920e0C1a463BCf5A16cA3F2180A78","Bv4":"0x287b67a4D320c15CE5569A09de4D8f6Cea1198f6"},"97":{"name":"bsc-testnet","mainnet":"false"},"100":{"name":"xdai-mainnet","mainnet":"true","v1":"0x8d1a17A3A4504aEB17515645BA8098f1D75237f7","v3":"0x897F8EDdB345F0d16081615823F76055Ad60A00c","v4":"0x0D3492437E86dabb67F2bCfAE5c597D2edA67D65","Bv4":"0x3857D844514f3c5230d2e05A7eC87593F2180A78"},"137":{"name":"polygon-mainnet","mainnet":"true","v1":"0xB184b7D19d747Db9084C355b5B6a093d7063B710","v2":"0x45fd48f58c47d929E9D181837fBB7Cda1974a773","v3":"0xCEd763C2Ff8d5B726b8a5D480c17C24B6686837F","v4":"0x86e2ab83ac9d91c618a3258653063beba0ff9461","Bv4":"0x3f3166f35dCb5F397bd16d7e40918c1c4A52BDb5"},"420":{"name":"optimism-goerli","mainnet":"false","v3":"0xDC608f2Bc4f0AFf02D12d51Ca8b543B343525c8a","v4":"0xD3fBCb1AF168e985c5Ab20B0D2dbe39840043291","Bv4":"0x131562e5b24F1aE3931750114fC541c104b835Ff"},"2001":{"name":"milkomeda-c1","mainnet":"true","v3":"0x897F8EDdB345F0d16081615823F76055Ad60A00c","v4":"0x1851359AB8B002217cf4D108d7F027B63563754C"},"8453":{"name":"base","mainnet":"true","v4":"0x5c1b67ED2809e371aabbc58D934282E8Aa7E3fd4","Bv4":"0xa1F413760E942dbbBDD36589526A11f4C013085b"},"10200":{"name":"gnosis chiado testnet","mainnet":"false","v4":"0x8d1a17A3A4504aEB17515645BA8098f1D75237f7","Bv4":"0x7B36e10AA3ff44576efF4b1AfB80587B9b3BA3a5"},"17000":{"name":"ethereum holesky testnet","mainnet":"false","v4":"0x8d1a17A3A4504aEB17515645BA8098f1D75237f7","Bv4":"0x7B36e10AA3ff44576efF4b1AfB80587B9b3BA3a5"},"42161":{"name":"arbitrum-mainnet","mainnet":"true","v1":"0x8d1a17A3A4504aEB17515645BA8098f1D75237f7","v3":"0x9B0817fA08b46670B92300B58AA1f4AB155701ea","Bv4":"0x61b1139B385d8F24b6708fC657afAf3d5D34252c","v4":"0x831D561607516Dfb11D06393FFE8336f84d625BD"},"43113":{"name":"avalanche-fuji","mainnet":"false"},"43114":{"name":"avalanche-mainnet","mainnet":"true","v1":"0x8d1a17A3A4504aEB17515645BA8098f1D75237f7","v4":"0x7B36e10AA3ff44576efF4b1AfB80587B9b3BA3a5","Bv4":"0x897F8EDdB345F0d16081615823F76055Ad60A00c"},"59140":{"name":"linea-testnet","v4":"0x897F8EDdB345F0d16081615823F76055Ad60A00c","Bv4":"0x7B36e10AA3ff44576efF4b1AfB80587B9b3BA3a5"},"59144":{"name":"linea","v4":"0x8d1a17A3A4504aEB17515645BA8098f1D75237f7","Bv4":"0x7B36e10AA3ff44576efF4b1AfB80587B9b3BA3a5"},"80001":{"name":"polygon-mumbai","mainnet":"false","v3":"0x1da738d367dd369cf95f53a51b213a9cc9146afb","v4":"0xec8f9a7f47dd6031e27ff9cef9d0f33e81fcece9","Bv4":"0x1CcD80448cD0Eb21b2912c54B4E61dafD01Ab3C5"},"84531":{"name":"base-goerli","mainnet":"false","v4":"0x897F8EDdB345F0d16081615823F76055Ad60A00c","Bv4":"0x1851359AB8B002217cf4D108d7F027B63563754C"},"200101":{"name":"milkomeda-c1-testnet","mainnet":"false","v3":"0x7B36e10AA3ff44576efF4b1AfB80587B9b3BA3a5","v4":"0x897F8EDdB345F0d16081615823F76055Ad60A00c"},"11155111":{"name":"sepolia testnet","mainnet":"false","v4":"0x897F8EDdB345F0d16081615823F76055Ad60A00c","Bv4":"0x1851359AB8B002217cf4D108d7F027B63563754C"}}');
;// CONCATENATED MODULE: ./src/data/chainMap.json
const chainMap_namespaceObject = JSON.parse('{"eth":1,"ethereum-mainnet":1,"goerli":5,"ethereum-goerli":5,"matic":137,"polygon-mainnet":137,"polygon-mumbai":80001,"mumbai":80001,"opt":10,"optimism-mainnet":10,"optimism-goerli":420,"moonbeam-mainnet":1284,"starkware-mainnet":1001,"arb":42161,"arbitrum-mainnet":42161,"xdai-mainnet":100,"xdai":100,"bsc-mainnet":56,"bnb":56,"filecoin-mainnet":314,"fil":314,"filecoin-hyperspace":3141,"fil-2":3141,"scroll-pre_alpha_l2":534354,"scroll-l2p":534354,"scroll-alpha_l2":534353,"scroll-alpha":534353,"avalanche-mainnet":43114,"avax":43114}');
;// CONCATENATED MODULE: ./src/data/chainDetails.json
const chainDetails_namespaceObject = JSON.parse('{"1":{"name":"Ethereum","chain":"ETH","icon":{"url":"https://raw.githubusercontent.com/spothq/cryptocurrency-icons/master/svg/color/eth.svg","format":"svg"},"rpc":["https://cloudflare-eth.com","https://ethereum.publicnode.com","https://mainnet.gateway.tenderly.co","https://mainnet.infura.io/v3/${INFURA_API_KEY}"],"features":[{"name":"EIP155"},{"name":"EIP1559"}],"faucets":[],"nativeCurrency":{"name":"Ether","symbol":"ETH","decimals":18},"infoURL":"https://ethereum.org","shortName":"Ethereum","chainId":1,"networkId":1,"slip44":60,"ens":{"registry":"0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e"},"explorers":[{"name":"etherscan","url":"https://etherscan.io","standard":"EIP3091"},{"name":"blockscout","url":"https://eth.blockscout.com","icon":"blockscout","standard":"EIP3091"}],"mainnet":true},"5":{"name":"Goerli","title":"Ethereum Testnet Goerli","chain":"ETH","rpc":["https://ethereum-goerli.publicnode.com","https://goerli.gateway.tenderly.co","https://goerli.infura.io/v3/${INFURA_API_KEY}"],"faucets":["http://fauceth.komputing.org?chain=5&address=${ADDRESS}","https://goerli-faucet.slock.it?address=${ADDRESS}","https://faucet.goerli.mudit.blog"],"nativeCurrency":{"name":"Goerli Ether","symbol":"ETH","decimals":18},"infoURL":"https://goerli.net/#about","shortName":"Goerli","chainId":5,"networkId":5,"ens":{"registry":"0x112234455c3a32fd11230c42e7bccd4a84e02010"},"explorers":[{"name":"etherscan-goerli","url":"https://goerli.etherscan.io","standard":"EIP3091"},{"name":"blockscout-goerli","url":"https://eth-goerli.blockscout.com","icon":"blockscout","standard":"EIP3091"}],"mainnet":false,"icon":{"url":"https://raw.githubusercontent.com/spothq/cryptocurrency-icons/master/svg/color/eth.svg","format":"svg"}},"10":{"name":"Optimism","chain":"ETH","rpc":["https://mainnet.optimism.io","https://optimism.publicnode.com","https://optimism.gateway.tenderly.co","https://optimism-mainnet.infura.io/v3/${INFURA_API_KEY}"],"faucets":[],"nativeCurrency":{"name":"Ether","symbol":"ETH","decimals":18},"infoURL":"https://optimism.io","shortName":"Optimism","chainId":10,"networkId":10,"explorers":[{"name":"etherscan","url":"https://optimistic.etherscan.io","standard":"EIP3091"},{"name":"blockscout","url":"https://optimism.blockscout.com","icon":"blockscout","standard":"EIP3091"}],"mainnet":true,"icon":{"url":"https://optimistic.etherscan.io/images/svg/brands/main.svg","format":"svg"}},"56":{"name":"BNB","chain":"BSC","rpc":["https://bsc-dataseed1.bnbchain.org","https://bsc-dataseed2.bnbchain.org","https://bsc-dataseed3.bnbchain.org","https://bsc-dataseed4.bnbchain.org","https://bsc-dataseed1.defibit.io","https://bsc-dataseed2.defibit.io","https://bsc-dataseed3.defibit.io","https://bsc-dataseed4.defibit.io","https://bsc-dataseed1.ninicoin.io","https://bsc-dataseed2.ninicoin.io","https://bsc-dataseed3.ninicoin.io","https://bsc-dataseed4.ninicoin.io","https://bsc.publicnode.com"],"faucets":["https://free-online-app.com/faucet-for-eth-evm-chains/"],"nativeCurrency":{"name":"BNB Chain Native Token","symbol":"BNB","decimals":18},"infoURL":"https://www.bnbchain.org/en","shortName":"BNB","chainId":56,"networkId":56,"slip44":714,"explorers":[{"name":"bscscan","url":"https://bscscan.com","standard":"EIP3091"}],"mainnet":true,"icon":{"url":"https://raw.githubusercontent.com/spothq/cryptocurrency-icons/master/svg/color/bnb.svg","format":"svg"}},"100":{"name":"Gnosis","chain":"GNO","icon":{"url":"https://gnosisscan.io/token/images/gnosans_32.png","format":"png"},"rpc":["https://rpc.gnosischain.com","https://rpc.gnosis.gateway.fm","https://rpc.ankr.com/gnosis","https://gnosischain-rpc.gateway.pokt.network","https://gnosis-mainnet.public.blastapi.io","https://gnosis.api.onfinality.io/public","https://gnosis.blockpi.network/v1/rpc/public","https://gnosis.oat.farm"],"faucets":["https://gnosisfaucet.com","https://stakely.io/faucet/gnosis-chain-xdai","https://faucet.prussia.dev/xdai"],"nativeCurrency":{"name":"xDAI","symbol":"XDAI","decimals":18},"infoURL":"https://docs.gnosischain.com","shortName":"Gnosis","chainId":100,"networkId":100,"slip44":700,"explorers":[{"name":"gnosisscan","url":"https://gnosisscan.io","standard":"EIP3091"},{"name":"blockscout","url":"https://gnosis.blockscout.com","icon":"blockscout","standard":"EIP3091"}],"mainnet":true},"137":{"name":"Polygon","chain":"Polygon","icon":{"url":"https://polygonscan.com/images/svg/brands/matic.svg","format":"svg"},"rpc":["https://polygon-rpc.com","https://polygon.llamarpc.com","https://rpc-mainnet.maticvigil.com","https://rpc-mainnet.matic.quiknode.pro","https://polygon-bor.publicnode.com","https://polygon.gateway.tenderly.co","https://polygon-mainnet.infura.io/v3/${INFURA_API_KEY}"],"faucets":[],"nativeCurrency":{"name":"MATIC","symbol":"MATIC","decimals":18},"infoURL":"https://polygon.technology/","shortName":"Polygon","chainId":137,"networkId":137,"slip44":966,"explorers":[{"name":"polygonscan","url":"https://polygonscan.com","standard":"EIP3091"}],"mainnet":true},"420":{"name":"Optimism Goerli","chain":"ETH","rpc":["https://goerli.optimism.io","https://optimism-goerli.publicnode.com","https://optimism-goerli.gateway.tenderly.co","https://optimism-goerli.infura.io/v3/${INFURA_API_KEY}"],"faucets":[],"nativeCurrency":{"name":"Goerli Ether","symbol":"ETH","decimals":18},"infoURL":"https://optimism.io","shortName":"Optimism Goerli","chainId":420,"networkId":420,"explorers":[{"name":"blockscout","url":"https://optimism-goerli.blockscout.com","icon":"blockscout","standard":"EIP3091"}],"mainnet":false,"icon":{"url":"https://raw.githubusercontent.com/spothq/cryptocurrency-icons/master/svg/color/eth.svg","format":"svg"}},"2001":{"name":"Milkomeda C1","chain":"milkAda","icon":{"url":"https://ipfs.io/ipfs/QmdoUtvHDybu5ppYBZT8BMRp6AqByVSoQs8nFwKbaS55jd","format":"svg"},"rpc":["https://rpc-mainnet-cardano-evm.c1.milkomeda.com"],"faucets":[],"nativeCurrency":{"name":"milkAda","symbol":"mADA","decimals":18},"infoURL":"https://milkomeda.com","shortName":"Milkomeda","chainId":2001,"networkId":2001,"explorers":[{"name":"Blockscout","url":"https://explorer-mainnet-cardano-evm.c1.milkomeda.com","standard":"none"}],"mainnet":true},"8453":{"name":"Base","chain":"ETH","rpc":["https://mainnet.base.org/","https://developer-access-mainnet.base.org/","https://base.publicnode.com"],"faucets":[],"nativeCurrency":{"name":"Ether","symbol":"ETH","decimals":18},"infoURL":"https://base.org","shortName":"base","chainId":8453,"networkId":8453,"icon":{"url":"https://ipfs.io/ipfs/QmaxRoHpxZd8PqccAynherrMznMufG6sdmHZLihkECXmZv","format":"png"},"explorers":[{"name":"basescan","url":"https://basescan.org","standard":"none"},{"name":"basescout","url":"https://base.blockscout.com","icon":"blockscout","standard":"EIP3091"}],"status":"active","mainnet":true},"10200":{"name":"Gnosis Chiado","chain":"GNO","icon":{"url":"https://gnosisscan.io/token/images/gnosans_32.png","format":"png"},"rpc":["https://rpc.chiadochain.net","https://rpc.chiado.gnosis.gateway.fm","https://gnosis-chiado.publicnode.com"],"faucets":["https://gnosisfaucet.com"],"nativeCurrency":{"name":"Chiado xDAI","symbol":"XDAI","decimals":18},"infoURL":"https://docs.gnosischain.com","shortName":"Gnosis Chiado","chainId":10200,"networkId":10200,"explorers":[{"name":"blockscout-chiadochain","url":"https://blockscout.chiadochain.net","icon":"blockscout","standard":"EIP3091"},{"name":"blockscout","url":"https://gnosis-chiado.blockscout.com","icon":"blockscout","standard":"EIP3091"}],"mainnet":false},"17000":{"name":"Holesky","chain":"ETH","rpc":["https://rpc.holesky.ethpandaops.io","https://ethereum-holesky.publicnode.com"],"faucets":["https://faucet.holesky.ethpandaops.io","https://holesky-faucet.pk910.de"],"nativeCurrency":{"name":"Testnet ETH","symbol":"ETH","decimals":18},"infoURL":"https://holesky.ethpandaops.io","shortName":"holesky","chainId":17000,"networkId":17000,"icon":{"url":"https://ipfs.io/ipfs/QmdwQDr6vmBtXmK2TmknkEuZNoaDqTasFdZdu3DRw8b2wt","format":"png"},"status":"incubating","explorers":[{"name":"Holesky Explorer","url":"https://holesky.beaconcha.in","icon":"ethereum","standard":"EIP3091"},{"name":"otterscan-holesky","url":"https://holesky.otterscan.io","icon":"ethereum","standard":"EIP3091"},{"name":"Holesky Etherscan","url":"https://holesky.etherscan.io","icon":"ethereum","standard":"EIP3091"}],"mainnet":false},"42161":{"name":"Arbitrum One","chainId":42161,"shortName":"Arbitrum One","chain":"ETH","networkId":42161,"nativeCurrency":{"name":"Ether","symbol":"ETH","decimals":18},"rpc":["https://arb1.arbitrum.io/rpc","https://arbitrum-one.publicnode.com","https://arbitrum-mainnet.infura.io/v3/${INFURA_API_KEY}"],"faucets":[],"explorers":[{"name":"Arbiscan","url":"https://arbiscan.io","standard":"EIP3091"},{"name":"Arbitrum Explorer","url":"https://explorer.arbitrum.io","standard":"EIP3091"}],"infoURL":"https://arbitrum.io","parent":{"type":"L2","chain":"eip155-1","bridges":[{"url":"https://bridge.arbitrum.io"}]},"mainnet":true,"icon":{"url":"https://arbiscan.io/images/svg/brands/arbitrum.svg","format":"svg"}},"43114":{"name":"Avalanche","chain":"AVAX","icon":{"url":"https://ipfs.io/ipfs/QmRALA5qvQBRwWre8ofuhCbr3wxVmPS3kGetRR9uJqbqqe","format":"png"},"rpc":["https://api.avax.network/ext/bc/C/rpc","https://avalanche-c-chain.publicnode.com"],"features":[{"name":"EIP1559"}],"faucets":[],"nativeCurrency":{"name":"Avalanche","symbol":"AVAX","decimals":18},"infoURL":"https://www.avax.network/","shortName":"Avalanche","chainId":43114,"networkId":43114,"slip44":9005,"explorers":[{"name":"snowtrace","url":"https://snowtrace.io","standard":"EIP3091"}],"mainnet":true},"59140":{"name":"Linea Testnet","title":"Linea Goerli Testnet","chain":"ETH","rpc":["https://rpc.goerli.linea.build","https://linea-goerli.infura.io/v3/${INFURA_API_KEY}"],"faucets":["https://faucetlink.to/goerli"],"nativeCurrency":{"name":"Linea Ether","symbol":"ETH","decimals":18},"infoURL":"https://linea.build","shortName":"linea-testnet","chainId":59140,"networkId":59140,"icon":{"url":"https://ipfs.io/ipfs/QmURjritnHL7a8TwZgsFwp3f272DJmG5paaPtWDZ98QZwH","format":"svg"},"parent":{"type":"L2","chain":"eip155-5","bridges":[{"url":"https://goerli.hop.exchange/#/send?token=ETH&sourceNetwork=ethereum&destNetwork=linea"}]},"explorers":[{"name":"Etherscan","url":"https://goerli.lineascan.build","standard":"EIP3091","icon":"linea"},{"name":"Blockscout","url":"https://explorer.goerli.linea.build","standard":"EIP3091","icon":"linea"}],"status":"active","mainnet":false},"59144":{"name":"Linea","title":"Linea Mainnet","chain":"ETH","rpc":["https://rpc.linea.build","https://linea-mainnet.infura.io/v3/${INFURA_API_KEY}"],"faucets":[],"nativeCurrency":{"name":"Linea Ether","symbol":"ETH","decimals":18},"infoURL":"https://linea.build","shortName":"linea","chainId":59144,"networkId":59144,"icon":{"url":"https://ipfs.io/ipfs/QmURjritnHL7a8TwZgsFwp3f272DJmG5paaPtWDZ98QZwH","format":"svg"},"parent":{"type":"L2","chain":"eip155-1","bridges":[{"url":"https://bridge.linea.build"}]},"explorers":[{"name":"Etherscan","url":"https://lineascan.build","standard":"EIP3091","icon":"linea"},{"name":"Blockscout","url":"https://explorer.linea.build","standard":"EIP3091","icon":"linea"},{"name":"L2scan","url":"https://linea.l2scan.co","standard":"EIP3091","icon":"linea"}],"status":"active","mainnet":false},"80001":{"name":"Mumbai","title":"Polygon Testnet Mumbai","chain":"Polygon","icon":{"url":"https://polygonscan.com/images/svg/brands/matic.svg","format":"svg"},"rpc":["https://rpc-mumbai.maticvigil.com","https://polygon-mumbai-bor.publicnode.com","https://polygon-mumbai.gateway.tenderly.co","https://polygon-mumbai.infura.io/v3/${INFURA_API_KEY}"],"faucets":["https://faucet.polygon.technology/"],"nativeCurrency":{"name":"MATIC","symbol":"MATIC","decimals":18},"infoURL":"https://polygon.technology/","shortName":"Polygon Mumbai","chainId":80001,"networkId":80001,"explorers":[{"name":"polygonscan","url":"https://mumbai.polygonscan.com","standard":"EIP3091"}],"mainnet":false},"84531":{"name":"Base Goerli","chain":"ETH","rpc":["https://goerli.base.org","https://base-goerli.publicnode.com"],"faucets":["https://www.coinbase.com/faucets/base-ethereum-goerli-faucet"],"nativeCurrency":{"name":"Goerli Ether","symbol":"ETH","decimals":18},"infoURL":"https://base.org","shortName":"Base Goerli","chainId":84531,"networkId":84531,"icon":{"url":"https://ipfs.io/ipfs/QmaxRoHpxZd8PqccAynherrMznMufG6sdmHZLihkECXmZv","format":"png"},"explorers":[{"name":"basescan","url":"https://goerli.basescan.org","standard":"none"},{"name":"basescout","url":"https://base-goerli.blockscout.com","icon":"blockscout","standard":"EIP3091"}],"mainnet":false},"200101":{"name":"Milkomeda C1 Testnet","chain":"milkTAda","icon":{"url":"https://ipfs.io/ipfs/QmdoUtvHDybu5ppYBZT8BMRp6AqByVSoQs8nFwKbaS55jd","format":"svg"},"rpc":["https://rpc-devnet-cardano-evm.c1.milkomeda.com"],"faucets":[],"nativeCurrency":{"name":"milkTAda","symbol":"mTAda","decimals":18},"infoURL":"https://milkomeda.com","shortName":"Milkomeda Testnet","chainId":200101,"networkId":200101,"explorers":[{"name":"Blockscout","url":"https://explorer-devnet-cardano-evm.c1.milkomeda.com","standard":"none"}],"mainnet":false},"11155111":{"name":"Sepolia","title":"Ethereum Testnet Sepolia","chain":"ETH","rpc":["https://rpc.sepolia.org","https://rpc2.sepolia.org","https://rpc-sepolia.rockx.com","https://rpc.sepolia.ethpandaops.io","https://sepolia.infura.io/v3/${INFURA_API_KEY}","https://sepolia.gateway.tenderly.co"],"faucets":["http://fauceth.komputing.org?chain=11155111&address=${ADDRESS}"],"nativeCurrency":{"name":"Sepolia Ether","symbol":"ETH","decimals":18},"infoURL":"https://sepolia.otterscan.io","shortName":"Sepolia","chainId":11155111,"networkId":11155111,"explorers":[{"name":"etherscan-sepolia","url":"https://sepolia.etherscan.io","standard":"EIP3091"},{"name":"otterscan-sepolia","url":"https://sepolia.otterscan.io","standard":"EIP3091"}],"mainnet":false,"icon":{"url":"https://raw.githubusercontent.com/trustwallet/assets/8ee07e9d791bec6c3ada3cfac73ddfdc4f4a40b7/blockchains/sepolia/info/logo.png","format":"png"}}}');
;// CONCATENATED MODULE: ./src/data/tokenDetails.json
const tokenDetails_namespaceObject = JSON.parse('[{"chainId":"1","name":"Ethereum","tokens":[{"address":"0x0000000000000000000000000000000000000000","name":"Ether","symbol":"ETH","decimals":18,"logoURI":"https://raw.githubusercontent.com/spothq/cryptocurrency-icons/master/svg/color/eth.svg"},{"address":"0x27702a26126e0b3702af63ee09ac4d1a084ef628","name":"Aleph im","symbol":"ALEPH","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/11676/thumb/Aleph-Logo-BW.png?1696511566"},{"address":"0x6b785a0322126826d8226d77e173d75dafb84d11","name":"Bankroll Vault","symbol":"VLT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/11638/thumb/vlt-200.png?1696511531"},{"address":"0xc5f0f7b66764f6ec8c8dff7ba683102295e16409","name":"First Digital USD","symbol":"FDUSD","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31079/thumb/firstfigital.jpeg?1696529912"},{"address":"0xe5ca70281149be03da30778fb5ec6183d339f7a5","name":"Genius Playboy Billionaire Philanthropi","symbol":"GPBP","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/30827/thumb/photo_2023-06-20_16.17.43_copy.jpeg?1696529681"},{"address":"0xb69753c06bb5c366be51e73bfc0cc2e3dc07e371","name":"POOH","symbol":"POOH","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30091/thumb/Pooh-icon.png?1696529015"},{"address":"0x436da116249044e8b4464f0cf21dd93311d88190","name":"Colizeum","symbol":"ZEUM","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/24448/thumb/AB0cGpnx_400x400.jpg?1696523629"},{"address":"0xcc802c45b55581713cecd1eb17be9ab7fccb0844","name":"SBU Honey","symbol":"BHNY","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/26079/thumb/honey.png?1696525163"},{"address":"0x068e3563b1c19590f822c0e13445c4fa1b9eefa5","name":"Wrapped USD","symbol":"WUSD","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28854/thumb/wusd.png?1696527828"},{"address":"0x196c81385bc536467433014042788eb707703934","name":"CryptoTask","symbol":"CTASK","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/13965/thumb/cryptotask_logo.png?1696513700"},{"address":"0xc4e8a9d47000ab8e59c7031e311762c68215e467","name":"STARX","symbol":"STARX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/8417/thumb/starworks.PNG?1696508606"},{"address":"0x269616d549d7e8eaa82dfb17028d0b212d11232a","name":"Punk Vault  NFTX ","symbol":"PUNK","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/17018/thumb/Punk.png?1696516582"},{"address":"0x6a969d379700b2e5ea4e684d273d63c1c050ba49","name":"Pacific","symbol":"PAF","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/20915/thumb/paf.png?1696520306"},{"address":"0xc6dddb5bc6e61e0841c54f3e723ae1f3a807260b","name":"Aurox","symbol":"URUS","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/14122/thumb/Aurox.png?1696513842"},{"address":"0x8484e645a054586a6d6af60c0ee911d7b5180e64","name":"DYOR","symbol":"DYOR","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30149/thumb/dyor.jpeg?1696529070"},{"address":"0x69ed89ecd35082e031fe52b75123f801db083306","name":"Kaeri","symbol":"KAERI","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/27977/thumb/63370e2a1f2bea31fc7f6977_512x512_v2-p-500-2.png?1696526995"},{"address":"0xfca47962d45adfdfd1ab2d972315db4ce7ccf094","name":"iXledger","symbol":"IXT","decimals":8,"logoURI":"https://assets.coingecko.com/coins/images/814/thumb/ixledger.png?1696501963"},{"address":"0x341c05c0e9b33c0e38d64de76516b2ce970bb3be","name":"Diversified Staked ETH","symbol":"DSETH","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28751/thumb/dsETH-logo.png?1696527731"},{"address":"0x7fc66500c84a76ad7e9c93437bfc5ac33e2ddae9","name":"Aave","symbol":"AAVE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/12645/thumb/AAVE.png?1696512452"},{"address":"0xfcf8eda095e37a41e002e266daad7efc1579bc0a","name":"FLEX Coin","symbol":"FLEX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/9108/thumb/coinflex_logo.png?1696509233"},{"address":"0xb64ef51c888972c908cfacf59b47c1afbc0ab8ac","name":"Storj","symbol":"STORJ","decimals":8,"logoURI":"https://assets.coingecko.com/coins/images/949/thumb/storj.png?1696502065"},{"address":"0xcbcc0f036ed4788f63fc0fee32873d6a7487b908","name":"Humaniq","symbol":"HMQ","decimals":8,"logoURI":"https://assets.coingecko.com/coins/images/647/thumb/humaniq.jpg?1696501841"},{"address":"0x63b4f3e3fa4e438698ce330e365e831f7ccd1ef4","name":"CyberFi","symbol":"CFI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/13112/thumb/cyberfi_logo.jpeg?1696512897"},{"address":"0x6d4ca1177087924edfe0908ef655169ea766fdc3","name":"Hedgehog","symbol":"HEDGEHOG","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28552/thumb/hedgie.png?1696527543"},{"address":"0xa41161af8d4ee421ba5fed4328f2b12034796a21","name":"Artify","symbol":"AFY","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29219/thumb/200x200_trans.png?1696528177"},{"address":"0x486c280024b5428459ec3360f99183a61d41d9a3","name":"Ethlinq Tech","symbol":"ETHLINQ","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31477/thumb/200_200.png?1696530289"},{"address":"0x6fb3e0a217407efff7ca062d46c26e5d60a14d69","name":"IoTeX","symbol":"IOTX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/3334/thumb/iotex-logo.png?1696504041"},{"address":"0xaaca86b876ca011844b5798eca7a67591a9743c8","name":"0x nodes","symbol":"BIOS","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/15600/thumb/BIOS_01.png?1696515235"},{"address":"0x856c4efb76c1d1ae02e20ceb03a2a6a08b0b8dc3","name":"Origin Ether","symbol":"OETH","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29733/thumb/OETH.png?1696528663"},{"address":"0x3d26dcd840fcc8e4b2193ace8a092e4a65832f9f","name":"Aave AMM UniUNIWETH","symbol":"AAMMUNIUNIWETH","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/17225/thumb/aAmmUniUNIWETH.png?1696516780"},{"address":"0x08f40811c7d6c013744166f3d4cb1a9a92d3d54e","name":"NightVerse Game","symbol":"NVG","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29059/thumb/nvg.png?1696528026"},{"address":"0x491604c0fdf08347dd1fa4ee062a822a5dd06b5d","name":"Cartesi","symbol":"CTSI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/11038/thumb/Cartesi_Logo.png?1696510982"},{"address":"0xbc17729fdf562723f0267f79ff25ade441056d87","name":"Karus Starter","symbol":"KST","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/18862/thumb/logo-only.png?1696518322"},{"address":"0x0f2d719407fdbeff09d87557abb7232601fd9f29","name":"Synapse","symbol":"SYN","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/18024/thumb/synapse_social_icon.png?1696517540"},{"address":"0xdf801468a808a32656d2ed2d2d80b72a129739f4","name":"Somnium Space CUBEs","symbol":"CUBE","decimals":8,"logoURI":"https://assets.coingecko.com/coins/images/10687/thumb/CUBE_icon.png?1696510656"},{"address":"0x817bbdbc3e8a1204f3691d14bb44992841e3db35","name":"Cudos","symbol":"CUDOS","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/13651/thumb/CudosIconTransparent.png?1696513400"},{"address":"0xaecc217a749c2405b5ebc9857a16d58bdc1c367f","name":"Pawthereum","symbol":"PAWTH","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/19275/thumb/pawth.png?1696518718"},{"address":"0xd0f395aa1b49ad410b26f52348aebcff109940e8","name":"Liquid Share","symbol":"LSHARE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31818/thumb/200x200.png?1696530632"},{"address":"0xc2544a32872a91f4a553b404c6950e89de901fdb","name":"Frax Price Index Share","symbol":"FPIS","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/24944/thumb/FPIS_icon.png?1696524099"},{"address":"0x16cda4028e9e872a38acb903176719299beaed87","name":"MARS4","symbol":"MARS4","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/18709/thumb/mars4_logo.jpg?1696518177"},{"address":"0x820802fa8a99901f52e39acd21177b0be6ee2974","name":"EUROe Stablecoin","symbol":"EUROE","decimals":6,"logoURI":"https://assets.coingecko.com/coins/images/28913/thumb/euroe-200x200-round.png?1696527889"},{"address":"0xfe5f141bf94fe84bc28ded0ab966c16b17490657","name":"Libra Credit","symbol":"LBA","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/3673/thumb/libra-credit.png?1696504352"},{"address":"0x4d2ee5dae46c86da2ff521f7657dad98834f97b8","name":"Pepemon Pepeballs","symbol":"PPBLZ","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/12823/thumb/200pepebball-BIG.png?1696512615"},{"address":"0xfc4b4ec763722b71eb1d729749b447a9645f5f30","name":"DumbMoney","symbol":"GME","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/32058/thumb/DumbMoney_-_GME_-_Official_Logo_200x200px.png?1696530855"},{"address":"0x24a6a37576377f63f194caa5f518a60f45b42921","name":"Float Protocol","symbol":"BANK","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/14116/thumb/FLOAT-Bank_LOGO-reduced_01.png?1696513836"},{"address":"0x595832f8fc6bf59c85c527fec3740a1b7a361269","name":"Power Ledger","symbol":"POWR","decimals":6,"logoURI":"https://assets.coingecko.com/coins/images/1104/thumb/power-ledger.png?1696502201"},{"address":"0x37fe0f067fa808ffbdd12891c0858532cfe7361d","name":"Civilization","symbol":"CIV","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/17626/thumb/civ-200x200.png?1696517157"},{"address":"0x207e14389183a94343942de7afbc607f57460618","name":"AngelBlock","symbol":"THOL","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/25058/thumb/Tholos_circle_gradient_200x200.png?1696524208"},{"address":"0xbe1a001fe942f96eea22ba08783140b9dcc09d28","name":"Beta Finance","symbol":"BETA","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/18715/thumb/beta_finance.jpg?1696518183"},{"address":"0x1341a2257fa7b770420ef70616f888056f90926c","name":"Zoo","symbol":"ZOOT","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/15629/thumb/gyzERsO.png?1696515262"},{"address":"0xe6fd75ff38adca4b97fbcd938c86b98772431867","name":"Elastos","symbol":"ELA","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/2780/thumb/Elastos.png?1696503549"},{"address":"0xd3e4ba569045546d09cf021ecc5dfe42b1d7f6e4","name":"Morpheus Network","symbol":"MNW","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/2379/thumb/MRPH_CoinGecko.png?1696503245"},{"address":"0x6006fc2a849fedaba8330ce36f5133de01f96189","name":"Spaceswap SHAKE","symbol":"SHAKE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/12765/thumb/shake.png?1696512562"},{"address":"0x4c3bae16c79c30eeb1004fb03c878d89695e3a99","name":"Autumn","symbol":"AUTUMN","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/25366/thumb/autumn.png?1696524499"},{"address":"0x55296f69f40ea6d20e478533c15a6b08b654e758","name":"XYO Network","symbol":"XYO","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/4519/thumb/XYO_Network-logo.png?1696505103"},{"address":"0x3da932456d082cba208feb0b096d49b202bf89c8","name":"Dego Finance","symbol":"DEGO","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/12503/thumb/c185FKx.png?1696512318"},{"address":"0xee9e7bb7e55bbc86414047b61d65c9c0d91ffbd0","name":"Fracton Protocol","symbol":"FT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/26809/thumb/CtH9UlRl_400x400.jpeg?1696525869"},{"address":"0xdb298285fe4c5410b05390ca80e8fbe9de1f259b","name":"handle fi","symbol":"FOREX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/18533/thumb/handle.fiFOREXLogoDark200x200.png?1696518013"},{"address":"0x51a59a02ba906194285e81eb1f98ffa28e7cf4c9","name":"Pepe King Prawn","symbol":"PEPE","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/31942/thumb/Pepe_King_Prawn.png?1696530749"},{"address":"0xf88baf18fab7e330fa0c4f83949e23f52fececce","name":"Granary","symbol":"GRAIN","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29740/thumb/Grain.png?1696528670"},{"address":"0x31429d1856ad1377a8a0079410b297e1a9e214c2","name":"ANGLE","symbol":"ANGLE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/19060/thumb/ANGLE_Token-light.png?1696518509"},{"address":"0x0001a500a6b18995b03f44bb040a5ffc28e45cb0","name":"Autonolas","symbol":"OLAS","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31099/thumb/OLAS-token.png?1696529930"},{"address":"0xf90c7f66eac7e2130bf677d69a250b2136cf6697","name":"HAKI Token","symbol":"HAKI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/7945/thumb/haki.png?1696508175"},{"address":"0xfa99a87b14b02e2240c79240c5a20f945ca5ef76","name":"GG","symbol":"GGTK","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/13666/thumb/ggtk.png?1696513416"},{"address":"0x88800092ff476844f74dc2fc427974bbee2794ae","name":"Ambire Wallet","symbol":"WALLET","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/23154/thumb/wallet.PNG?1696522445"},{"address":"0xfaba6f8e4a5e8ab82f62fe7c39859fa577269be3","name":"Ondo","symbol":"ONDO","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/26580/thumb/ONDO.png?1696525656"},{"address":"0x766a824314bd1d9fa27c8461754c276772bc666a","name":"Scam Coin","symbol":"SCAM","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30792/thumb/logo_%281%29_%281%29.png?1696529659"},{"address":"0x009c43b42aefac590c719e971020575974122803","name":"Bibox","symbol":"BIX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/1441/thumb/bibox-token.png?1696502491"},{"address":"0xa1a4e303e9c56962f201c5e834abc1e677a3c4f3","name":"CVNX","symbol":"CVNX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/862/thumb/CVNX-logo.png?1696501996"},{"address":"0x8929e9dbd2785e3ba16175e596cdd61520fee0d1","name":"Altitude","symbol":"ALTD","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30114/thumb/logo.png?1696529036"},{"address":"0xd12443d642d021dc52d0af8f5f6191e02d1e9419","name":"Ignite The Chain","symbol":"IGNT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31731/thumb/Ignite.png?1696530551"},{"address":"0xfac0403a24229d7e2edd994d50f5940624cbeac2","name":"Theopetra","symbol":"THEO","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/29431/thumb/MicrosoftTeams-image_%2826%29.png?1696528379"},{"address":"0xbd2949f67dcdc549c6ebe98696449fa79d988a9f","name":"Meter Governance mapped by Meter io","symbol":"EMTRG","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/12175/thumb/Dark-blue-icon-transparent-vector-white-icon200x200.png?1696512012"},{"address":"0xe3818504c1b32bf1557b16c238b2e01fd3149c17","name":"Pillar","symbol":"PLR","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/809/thumb/v2logo-1.png?1696501958"},{"address":"0x0ec72cd6690db40b16be166858299f19d4f8e5b0","name":"Teh Golden One","symbol":"GOLD1","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/27290/thumb/teh_golden_one_200x200.png?1696526342"},{"address":"0xdd78b3e430361560a70b9cbb7d98d961f0428b61","name":"Patrick","symbol":"PAT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30266/thumb/500x500_%282%29.png?1696529174"},{"address":"0x5de8ab7e27f6e7a1fff3e5b337584aa43961beef","name":"SmarDex","symbol":"SDEX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29470/thumb/SDEX_logo_transparent.png?1696528415"},{"address":"0xcfcecfe2bd2fed07a9145222e8a7ad9cf1ccd22a","name":"Adshares","symbol":"ADS","decimals":11,"logoURI":"https://assets.coingecko.com/coins/images/868/thumb/rnO9DyJ.png?1696502001"},{"address":"0x4be2b2c45b432ba362f198c08094017b61e3bdc6","name":"Marswap","symbol":"MSWAP","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31280/thumb/Mars-1.png?1696530103"},{"address":"0xe55d97a97ae6a17706ee281486e98a84095d8aaf","name":"AIPad","symbol":"AIPAD","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28894/thumb/JZadeHu.jpeg?1696527870"},{"address":"0x3dbb00c9be5a327e25caf4f650844c5dba81e34b","name":"StaFi Staked MATIC","symbol":"RMATIC","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29610/thumb/rMATIC.png?1696528546"},{"address":"0xd43be54c1aedf7ee4099104f2dae4ea88b18a249","name":"Traxx","symbol":"TRAXX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/24441/thumb/TT.png?1696523622"},{"address":"0xf29ae508698bdef169b89834f76704c3b205aedf","name":"SNX yVault","symbol":"YVSNX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28797/thumb/yvSNX-128-0xF29AE508698bDeF169B89834F76704C3B205aedf.png?1696527775"},{"address":"0x030ba81f1c18d280636f32af80b9aad02cf0854e","name":"Aave WETH","symbol":"AWETH","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/17238/thumb/aWETH_2x.png?1696516795"},{"address":"0x6710c63432a2de02954fc0f851db07146a6c0312","name":"Smart MFG","symbol":"MFG","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/1842/thumb/Smart_MFG_Cropped_Logo.png?1696502841"},{"address":"0x35bd01fc9d6d5d81ca9e055db88dc49aa2c699a8","name":"Friends With Benefits Pro","symbol":"FWB","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/14391/thumb/xRGEXmQN_400x400.png?1696514082"},{"address":"0xfc82bb4ba86045af6f327323a46e80412b91b27d","name":"Prom","symbol":"PROM","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/8825/thumb/Ticker.png?1696508978"},{"address":"0x9469d013805bffb7d3debe5e7839237e535ec483","name":"Darwinia Network","symbol":"RING","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/9443/thumb/RING.png?1696509535"},{"address":"0x0ec78ed49c2d27b315d462d43b5bab94d2c79bf8","name":"ZERO","symbol":"MEOW","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/21530/thumb/UlyJW87D_400x400.jpg?1696520889"},{"address":"0x6f2dec5da475333b0af4a3ffc9a33b0211a9a452","name":"CryptoTwitter","symbol":"CT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30237/thumb/200x200px.png?1696529147"},{"address":"0x1f573d6fb3f13d689ff844b4ce37794d79a7ff1c","name":"Bancor Network","symbol":"BNT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/736/thumb/bancor-bnt.png?1696501892"},{"address":"0x593114f03a0a575aece9ed675e52ed68d2172b8c","name":"BidiPass","symbol":"BDP","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/3890/thumb/AxiFAoHc_400x400.jpg?1696504552"},{"address":"0x054f76beed60ab6dbeb23502178c52d6c5debe40","name":"DeFiner","symbol":"FIN","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/12780/thumb/PdaW8Lb.png?1696512575"},{"address":"0x168e209d7b2f58f1f24b8ae7b7d35e662bbf11cc","name":"LayerAI","symbol":"LAI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29223/thumb/Favicon_200x200px.png?1696528181"},{"address":"0x112b08621e27e10773ec95d250604a041f36c582","name":"Wrapped Kaspa","symbol":"KAS","decimals":8,"logoURI":"https://assets.coingecko.com/coins/images/31037/thumb/WKAS-256-black-ETH-3.png?1696529872"},{"address":"0xd502f487e1841fdc805130e13eae80c61186bc98","name":"Integral","symbol":"ITGR","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/18381/thumb/icon.png?1696517873"},{"address":"0x674c6ad92fd080e4004b2312b45f796a192d27a0","name":"Neutrino Index Token","symbol":"XTN","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/10117/thumb/USDN_Logo.jpg?1696510143"},{"address":"0xc666081073e8dff8d3d1c2292a29ae1a2153ec09","name":"Digitex","symbol":"DGTX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/2188/thumb/DGTX.png?1696503145"},{"address":"0xd528cf2e081f72908e086f8800977df826b5a483","name":"Paribus","symbol":"PBX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/18410/thumb/paribus.PNG?1696517900"},{"address":"0xa3ad8c7ab6b731045b5b16e3fdf77975c71abe79","name":"Dinerobet","symbol":"DINERO","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28248/thumb/CABA1DE1-2CB1-46D3-97BC-20305EA67FBB.png?1696527251"},{"address":"0xd559f20296ff4895da39b5bd9add54b442596a61","name":"FintruX","symbol":"FTX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/1928/thumb/token-500x500.png?1696502917"},{"address":"0x6de037ef9ad2725eb40118bb1702ebb27e4aeb24","name":"Render","symbol":"RNDR","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/11636/thumb/rndr.png?1696511529"},{"address":"0x1e2c4fb7ede391d116e6b41cd0608260e8801d59","name":"Backed CSPX Core S P 500","symbol":"BCSPX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31891/thumb/b-CSPX-200x200.png?1696530702"},{"address":"0x846c66cf71c43f80403b51fe3906b3599d63336f","name":"PumaPay","symbol":"PMA","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/2307/thumb/pumapay_dark_rounded_256x256.png?1696503200"},{"address":"0x9ab7bb7fdc60f4357ecfef43986818a2a3569c62","name":"Guild of Guardians","symbol":"GOG","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/17362/thumb/V2QDNoLg_400x400.jpg?1696516913"},{"address":"0xcb84d72e61e383767c4dfeb2d8ff7f4fb89abc6e","name":"Vega Protocol","symbol":"VEGA","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/15870/thumb/vega.PNG?1696515485"},{"address":"0x3136ef851592acf49ca4c825131e364170fa32b3","name":"CoinFi","symbol":"COFI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/1709/thumb/coinfi.png?1696502727"},{"address":"0x017e9db34fc69af0dc7c7b4b33511226971cddc7","name":"On Chain Dynamics","symbol":"OCD","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31639/thumb/Screenshot_2023-09-01_010740.png?1696530455"},{"address":"0xd13cfd3133239a3c73a9e535a5c4dadee36b395c","name":"Vaiot","symbol":"VAI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/13981/thumb/VAIOT_logo.png?1696513714"},{"address":"0x1f16d41f9b3db03b462bdd6c92245ee708d1c103","name":"Rangers Protocol","symbol":"RPG","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/18791/thumb/tO8MlqiM_400x400.png?1633421196"},{"address":"0xbd89b8d708809e7022135313683663911826977e","name":"O MEE","symbol":"OME","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/25099/thumb/logo-mark-full-colour-cmyk-693px_300ppi.jpg?1696524249"},{"address":"0x4f5fa8f2d12e5eb780f6082dd656c565c48e0f24","name":"Gourmet Galaxy","symbol":"GUM","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/13846/thumb/gum.png?1696513592"},{"address":"0xbe428c3867f05dea2a89fc76a102b544eac7f772","name":"CyberVein","symbol":"CVT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/3886/thumb/CyberVein_LOGO.png?1696504547"},{"address":"0x4fabb145d64652a948d72533023f6e7a623c7c53","name":"BUSD","symbol":"BUSD","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/9576/thumb/BUSDLOGO.jpg?1696509654"},{"address":"0x02de007d412266a2e0fa9287c103474170f06560","name":"Exorde","symbol":"EXD","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28684/thumb/logo-exorde.png?1696527668"},{"address":"0x60d604890feaa0b5460b28a424407c24fe89374a","name":"Balancer Aave v3 Boosted Pool  WETH ","symbol":"BB-A-WETH","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30386/thumb/bb-a-weth.png?1696529275"},{"address":"0xe8e06a5613dc86d459bc8fb989e173bb8b256072","name":"Feyorra","symbol":"FEY","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/13689/thumb/1_XiKKk5_400x400.jpg?1696513436"},{"address":"0xe9b7b5d5e8d2bcc78884f9f9099bfa42a9e5c1a5","name":"Zenland","symbol":"ZENF","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29477/thumb/tokenicon200px.png?1696528421"},{"address":"0x1e797ce986c3cff4472f7d38d5c4aba55dfefe40","name":"BlockCDN","symbol":"BCDN","decimals":15,"logoURI":"https://assets.coingecko.com/coins/images/1301/thumb/blockcdn.png?1696502370"},{"address":"0x5d60d8d7ef6d37e16ebabc324de3be57f135e0bc","name":"MyBit","symbol":"MYB","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/1240/thumb/mybit.png?1696502315"},{"address":"0x0c90c57aaf95a3a87eadda6ec3974c99d786511f","name":"HanChain","symbol":"HAN","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/27374/thumb/logo_200.png?1696526418"},{"address":"0x8a3d77e9d6968b780564936d15b09805827c21fa","name":"Archethic","symbol":"UCO","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/12330/thumb/Archethic_logo.png?1696512158"},{"address":"0x76306f029f8f99effe509534037ba7030999e3cf","name":"Acreage Coin","symbol":"ACR","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/5100/thumb/acreage-coin.jpg?1696505621"},{"address":"0xcd7492db29e2ab436e819b249452ee1bbdf52214","name":"SafeMoon Inu","symbol":"SMI","decimals":8,"logoURI":"https://assets.coingecko.com/coins/images/16091/thumb/SMI.png?1696515699"},{"address":"0x888888848b652b3e3a0f34c96e00eec0f3a23f72","name":"Alien Worlds","symbol":"TLM","decimals":4,"logoURI":"https://assets.coingecko.com/coins/images/14676/thumb/kY-C4o7RThfWrDQsLCAG4q4clZhBDDfJQVhWUEKxXAzyQYMj4Jmq1zmFwpRqxhAJFPOa0AsW_PTSshoPuMnXNwq3rU7Imp15QimXTjlXMx0nC088mt1rIwRs75GnLLugWjSllxgzvQ9YrP4tBgclK4_rb17hjnusGj_c0u2fx0AvVokjSNB-v2poTj0xT9BZRCbzRE3-lF1.jpg?1696514350"},{"address":"0x4e452b391a86c9240e98df7277ce0bea5be08e43","name":"Pax Unitas","symbol":"PAXU","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31648/thumb/IMG_11C5EA8BD781-1.jpeg?1696530463"},{"address":"0xa0f0546eb5e3ee7e8cfc5da12e5949f3ae622675","name":"Tokoin","symbol":"TOKO","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/8807/thumb/TOKOIN_LOGO_%28no_text%29.png?1696508959"},{"address":"0x9f284e1337a815fe77d2ff4ae46544645b20c5ff","name":"Darwinia Commitment","symbol":"KTON","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/11895/thumb/KTON.png?1696511761"},{"address":"0x626e8036deb333b408be468f951bdb42433cbf18","name":"AIOZ Network","symbol":"AIOZ","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/14631/thumb/aioz-logo-200.png?1696514309"},{"address":"0xe7ac8545e34771de3706598abb3db9a19af2a07f","name":"MONKED","symbol":"MONKED","decimals":8,"logoURI":"https://assets.coingecko.com/coins/images/30011/thumb/monked200.png?1696528935"},{"address":"0x57700244b20f84799a31c6c96dadff373ca9d6c5","name":"TrustDAO","symbol":"TRUST","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/11923/thumb/trustwhite.png?1696511785"},{"address":"0x2001f2a0cf801ecfda622f6c28fb6e10d803d969","name":"CoinLoan","symbol":"CLT","decimals":8,"logoURI":"https://assets.coingecko.com/coins/images/1713/thumb/blue-logo-transparent-200x200.png?1696502730"},{"address":"0x6eff556748ee452cbdaf31bcb8c76a28651509bd","name":"TiUSD","symbol":"TIUSD","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30697/thumb/TIUDS.png?1696529566"},{"address":"0xd7efb00d12c2c13131fd319336fdf952525da2af","name":"XPR Network","symbol":"XPR","decimals":4,"logoURI":"https://assets.coingecko.com/coins/images/10941/thumb/XPR.jpg?1696510891"},{"address":"0x42bbfa2e77757c645eeaad1655e0911a7553efbc","name":"Boba Network","symbol":"BOBA","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/20285/thumb/Boba-200x200---white.png?1696519690"},{"address":"0xa71dcaaf5ba390b1b2012323a8810fac121f90dd","name":"SafeGrow","symbol":"SFG","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29715/thumb/IMG_20230402_021040_191.png?1696528647"},{"address":"0xac51066d7bec65dc4589368da368b212745d63e8","name":"My Neighbor Alice","symbol":"ALICE","decimals":6,"logoURI":"https://assets.coingecko.com/coins/images/14375/thumb/alice_logo.jpg?1696514067"},{"address":"0xc4cb5793bd58bad06bf51fb37717b86b02cbe8a4","name":"PROXI DeFi","symbol":"CREDIT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/12212/thumb/_credit.png?1696512046"},{"address":"0x5f3b3c37f47d8532836c800f75e7f262623aa3bb","name":"Jarvis AI","symbol":"JAI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29757/thumb/logo200x200PNG.png?1696528689"},{"address":"0x7ba5273d53d8a964b0a338e25def0c082f5c29d3","name":"WEN","symbol":"WEN","decimals":8,"logoURI":"https://assets.coingecko.com/coins/images/31835/thumb/Wen_small.png?1696530649"},{"address":"0xc0eb85285d83217cd7c891702bcbc0fc401e2d9d","name":"Hiveterminal","symbol":"HVN","decimals":8,"logoURI":"https://assets.coingecko.com/coins/images/899/thumb/Hiveterminal_token.jpg?1696502022"},{"address":"0xfeb6d5238ed8f1d59dcab2db381aa948e625966d","name":"Doge TV","symbol":"DGTV","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28050/thumb/532a5b9e-8294-4be1-be18-f04a2cf5f0a9.png?1696527063"},{"address":"0x0b4c2708f052dca413600e237675e4d6778a9375","name":"CoinClaim","symbol":"CLM","decimals":16,"logoURI":"https://assets.coingecko.com/coins/images/6687/thumb/coinclaim.jpg?1696507028"},{"address":"0x77e06c9eccf2e797fd462a92b6d7642ef85b0a44","name":"Wrapped TAO","symbol":"WTAO","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/29087/thumb/wtao.png?1696528051"},{"address":"0x4cc19356f2d37338b9802aa8e8fc58b0373296e7","name":"SelfKey","symbol":"KEY","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/2034/thumb/selfkey.png?1696503004"},{"address":"0x5ea82c27efc7634f1c5ad20a3561c453433a2f3a","name":"BTRIPS","symbol":"BTR","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/19273/thumb/btr.png?1696518716"},{"address":"0x6d765cbe5bc922694afe112c140b8878b9fb0390","name":"SUSHI yVault","symbol":"YVSUSHI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28789/thumb/yvSUSHI-128-0x6d765CbE5bC922694afE112C140b8878b9FB0390.png?1696527767"},{"address":"0x3feb4fea5132695542f8ede5076ac43296d17c6d","name":"Bitcoin 2 0","symbol":"BTC20","decimals":8,"logoURI":"https://assets.coingecko.com/coins/images/30984/thumb/btc2-200x200.png?1696529823"},{"address":"0x55a380d134d722006a5ce2d510562e1239d225b1","name":"Marvin Inu","symbol":"MARVIN","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/22039/thumb/lVshyCp.png?1696521384"},{"address":"0x4485561db76614ff727f8e0a3ea95690b8b16022","name":"Invox Finance","symbol":"INVOX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/3200/thumb/invox.png?1696503919"},{"address":"0x4057db5bd9f67a566aa10e5587b1a964affc6a16","name":"Truefeedback","symbol":"TFBX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/8842/thumb/5rd7a55q_400x400.png?1696508994"},{"address":"0xaa6e8127831c9de45ae56bb1b0d4d4da6e5665bd","name":"Index Coop   ETH 2x Flexible Leverage I","symbol":"ETH2X-FLI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/14392/thumb/ETH2x-FLI_%281%29.png?1696514083"},{"address":"0xcbe7142f5c16755d8683ba329efa1abf7b54482d","name":"MedicalVeda","symbol":"MVEDA","decimals":8,"logoURI":"https://assets.coingecko.com/coins/images/13069/thumb/medicalveda_new_logo_final_%281%29.png?1696512858"},{"address":"0xc18360217d8f7ab5e7c516566761ea12ce7f9d72","name":"Ethereum Name Service","symbol":"ENS","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/19785/thumb/acatxTm8_400x400.jpg?1696519207"},{"address":"0x0cec1a9154ff802e7934fc916ed7ca50bde6844e","name":"PoolTogether","symbol":"POOL","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/14003/thumb/PoolTogether.png?1696513732"},{"address":"0x18084fba666a33d37592fa2633fd49a74dd93a88","name":"tBTC","symbol":"TBTC","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/11224/thumb/0x18084fba666a33d37592fa2633fd49a74dd93a88.png?1696511155"},{"address":"0xe47f1cd2a37c6fe69e3501ae45eca263c5a87b2b","name":"Zunami Ether","symbol":"ZETH","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31176/thumb/Brand_symbol_Color.png?1696530004"},{"address":"0xb67718b98d52318240c52e71a898335da4a28c42","name":"Innovative Bioresearch Coin","symbol":"INNBC","decimals":6,"logoURI":"https://assets.coingecko.com/coins/images/4043/thumb/INNBC.png?1696504678"},{"address":"0x9b9647431632af44be02ddd22477ed94d14aacaa","name":"KOK","symbol":"KOK","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/10502/thumb/logo_navy.png?1696510490"},{"address":"0x37da9de38c4094e090c014325f6ef4baeb302626","name":"OTSea","symbol":"OTSEA","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31900/thumb/photo_2023-09-17_16-46-21.jpg?1696530711"},{"address":"0x1da87b114f35e1dc91f72bf57fc07a768ad40bb0","name":"Equalizer","symbol":"EQZ","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/14741/thumb/X2p5mb2f_400x400.png?1696514410"},{"address":"0x7dd9c5cba05e151c895fde1cf355c9a1d5da6429","name":"Golem","symbol":"GLM","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/542/thumb/Golem_Submark_Positive_RGB.png?1696501761"},{"address":"0x3cbc780d2934d55a06069e837fabd3e6fc23dab0","name":"DBX","symbol":"DBX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/15682/thumb/logo.png?1696515312"},{"address":"0x8c81121b15197fa0eeaee1dc75533419dcfd3151","name":"IdleWBTC  Best Yield ","symbol":"IDLEWBTCYIELD","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/11936/thumb/idlewbtcv3maxyield_32.png?1696511797"},{"address":"0xacfa209fb73bf3dd5bbfb1101b9bc999c49062a5","name":"EvidenZ","symbol":"BCDT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/2014/thumb/evidenz-512.png?1696502988"},{"address":"0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48","name":"USDC","symbol":"USDC","decimals":6,"logoURI":"https://assets.coingecko.com/coins/images/6319/thumb/usdc.png?1696506694"},{"address":"0x22b6c31c2beb8f2d0d5373146eed41ab9ede3caf","name":"cocktailbar finance","symbol":"COC","decimals":8,"logoURI":"https://assets.coingecko.com/coins/images/13121/thumb/Cocktail_Bar_logo_%281%29_%281%29.png?1696512909"},{"address":"0x3391bc034f2935ef0e1e41619445f998b2680d35","name":"IdleUSDC  Risk Adjusted ","symbol":"IDLEUSDCSAFE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/11930/thumb/idleusdc-safe.png?1696511791"},{"address":"0xbddf903f43dc7d9801f3f0034ba306169074ef8e","name":"Apes Go Bananas","symbol":"AGB","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30465/thumb/agb_logo.jpeg?1696529352"},{"address":"0xf819d9cb1c2a819fd991781a822de3ca8607c3c9","name":"Unibot","symbol":"UNIBOT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30462/thumb/logonoline_%281%29.png?1696529349"},{"address":"0x1aa51bc7eb181ce48ce626bf62f8956fa9555136","name":"PAWZONE","symbol":"PAW","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29598/thumb/PAW_Token_Logo.png?1696528536"},{"address":"0xfae4ee59cdd86e3be9e8b90b53aa866327d7c090","name":"CPChain","symbol":"CPC","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/2760/thumb/cpchain.png?1696503533"},{"address":"0x3472a5a71965499acd81997a54bba8d852c6e53d","name":"Badger DAO","symbol":"BADGER","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/13287/thumb/badger_dao_logo.jpg?1696513059"},{"address":"0x30cf203b48edaa42c3b4918e955fed26cd012a3f","name":"MetaGame","symbol":"SEED","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/13099/thumb/V8phEz8V.png?1696512885"},{"address":"0xea7cc765ebc94c4805e3bff28d7e4ae48d06468a","name":"Pad Fi","symbol":"PAD","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/18117/thumb/pad.fi.png?1696517620"},{"address":"0x36ac219f90f5a6a3c77f2a7b660e3cc701f68e25","name":"Coinmetro","symbol":"XCM","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/3125/thumb/XCM_Token_Logo_.png?1696503850"},{"address":"0x2c537e5624e4af88a7ae4060c022609376c8d0eb","name":"BiLira","symbol":"TRYB","decimals":6,"logoURI":"https://assets.coingecko.com/coins/images/10119/thumb/JBs9jiXO_400x400.jpg?1696510144"},{"address":"0x170dec83c7753aaad20c01a0016b5a2e143990d4","name":"Wigger","symbol":"WIGGER","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/32128/thumb/SmartSelect_20231003_234100_Telegram.jpg?1696588180"},{"address":"0x28dee01d53fed0edf5f6e310bf8ef9311513ae40","name":"BlitzPick","symbol":"XBP","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/2458/thumb/BlitzPredict.jpg?1696503288"},{"address":"0x470c8950c0c3aa4b09654bc73b004615119a44b5","name":"Kizuna","symbol":"KIZUNA","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/32113/thumb/IMG_9968.png?1696585475"},{"address":"0x446c9033e7516d820cc9a2ce2d0b7328b579406f","name":"SOLVE","symbol":"SOLVE","decimals":8,"logoURI":"https://assets.coingecko.com/coins/images/1768/thumb/Solve.Token_logo_200_200_wiyhout_BG.png?1696502776"},{"address":"0x7c8155909cd385f120a56ef90728dd50f9ccbe52","name":"Nahmii","symbol":"NII","decimals":15,"logoURI":"https://assets.coingecko.com/coins/images/9786/thumb/nahmii-sm_icon-full-color.png?1696509845"},{"address":"0xeed3ae7b0f8b5b9bb8c035a9941382b1822671cd","name":"EveryCoin","symbol":"EVY","decimals":12,"logoURI":"https://assets.coingecko.com/coins/images/5629/thumb/TutkUC1x_400x400_%281%29.jpg?1696506092"},{"address":"0xe28b3b32b6c345a34ff64674606124dd5aceca30","name":"Injective","symbol":"INJ","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/12882/thumb/Secondary_Symbol.png?1696512670"},{"address":"0xb16d3ed603d62b125c6bd45519eda40829549489","name":"Insureum","symbol":"ISR","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/4888/thumb/insureum.png?1696505428"},{"address":"0x03ee5026c07d85ff8ae791370dd0f4c1ae6c97fc","name":"0x Leverage","symbol":"OXL","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31977/thumb/Ox.jpeg?1696530780"},{"address":"0xdd2e93924bdd4e20c3cf4a8736e5955224fa450e","name":"Foho Coin","symbol":"FOHO","decimals":8,"logoURI":"https://assets.coingecko.com/coins/images/17933/thumb/FOHO.Coin_colour-02-1.png?1696517454"},{"address":"0x320d31183100280ccdf69366cd56180ea442a3e8","name":"Lightcoin","symbol":"LHC","decimals":8,"logoURI":"https://assets.coingecko.com/coins/images/16381/thumb/lhc.PNG?1696515979"},{"address":"0x9cf98eb8a8b28c83e8612046cf55701ce3eb0063","name":"Unreal Finance","symbol":"UGT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/17943/thumb/11292.png?1696517464"},{"address":"0xc12d099be31567add4e4e4d0d45691c3f58f5663","name":"Auctus","symbol":"AUC","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/2165/thumb/Auc_Discord_Avatar1.png?1696503126"},{"address":"0xe3fedaecd47aa8eab6b23227b0ee56f092c967a9","name":"Primas","symbol":"PST","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/917/thumb/primas.png?1696502039"},{"address":"0x80d55c03180349fff4a229102f62328220a96444","name":"Opulous","symbol":"OPUL","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/16548/thumb/opulous.PNG?1696516110"},{"address":"0x7df18e4efd6e6f73cfb462937dac40fe42533016","name":"Zkitty Bot","symbol":"ZKITTY","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31474/thumb/AnN0reNi_400x400.jpg?1696530286"},{"address":"0x06af07097c9eeb7fd685c692751d5c66db49c215","name":"Chai","symbol":"CHAI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/10147/thumb/CHAI.png?1696510169"},{"address":"0xadb2437e6f65682b85f814fbc12fec0508a7b1d0","name":"UNCX Network","symbol":"UNCX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/12871/thumb/uncx.png?1696512659"},{"address":"0xb62e45c3df611dce236a6ddc7a493d79f9dfadef","name":"Wall Street Memes","symbol":"WSM","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31975/thumb/Wall_Street_Memes_Logo_resize.png?1696530778"},{"address":"0x056c1d42fb1326f57da7f19ebb7dda4673f1ff55","name":"Gains","symbol":"GAINS","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/14681/thumb/200x200.png?1696514354"},{"address":"0x2be5e8c109e2197d077d13a82daead6a9b3433c5","name":"Tokamak Network","symbol":"TON","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/12260/thumb/D919x5-s_400x400.png?1696512091"},{"address":"0x8727c112c712c4a03371ac87a74dd6ab104af768","name":"Jetcoin","symbol":"JET","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/2487/thumb/jetcoin.png?1696503306"},{"address":"0xaaaf91d9b90df800df4f55c205fd6989c977e73a","name":"Monolith","symbol":"TKN","decimals":8,"logoURI":"https://assets.coingecko.com/coins/images/675/thumb/Monolith.png?1696501865"},{"address":"0x9c2dc0c3cc2badde84b0025cf4df1c5af288d835","name":"COR Token","symbol":"COR","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/12856/thumb/COR.png?1696512646"}]},{"chainId":"5","name":"Goerli","tokens":[{"address":"0x0000000000000000000000000000000000000000","name":"Goerli Ether","symbol":"ETH","decimals":18,"logoURI":"https://raw.githubusercontent.com/spothq/cryptocurrency-icons/master/svg/color/eth.svg"}]},{"chainId":"137","name":"Polygon","tokens":[{"address":"0x0000000000000000000000000000000000000000","name":"MATIC","symbol":"MATIC","decimals":18,"logoURI":"https://polygonscan.com/images/svg/brands/matic.svg"},{"address":"0x998013798440d44c1dd4c767bdd9580e16e46e28","name":"ITSBLOC","symbol":"ITSB","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/27268/thumb/ezgif-2-1826f94a8a.jpeg?1663135869"},{"address":"0xc2a45fe7d40bcac8369371b08419ddafd3131b4a","name":"Lucidao","symbol":"LCD","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/23693/thumb/lcd-icon-color-200px.png?1645450706"},{"address":"0x76e63a3e7ba1e2e61d3da86a87479f983de89a7e","name":"Augury Finance","symbol":"OMEN","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/16573/thumb/omen.PNG?1624498786"},{"address":"0xbc5eb84c052fd012bb902c258c9fd241b17c0005","name":"XNET Mobile","symbol":"XNET","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31799/thumb/depin.jpeg?1695089489"},{"address":"0x6e65ae5572df196fae40be2545ebc2a9a24eace9","name":"Shack","symbol":"SHACK","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/25699/thumb/shack_no_bg_no_pad3.png?1653441433"},{"address":"0x5dfd5edfde4d8ec9e632dca9d09fc7e833f74210","name":"Infinity Skies","symbol":"ISKY","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/22583/thumb/isky.png?1642141576"},{"address":"0x0184316f58b9a44acdd3e683257259dc0cf2202a","name":"PolyGold","symbol":"POLYGOLD","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/16055/thumb/wYRJKCT.png?1622699065"},{"address":"0xa3d315e8e0a62e9abd4a910d07b4768a1b3ff525","name":"AGOS","symbol":"AGOS","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31902/thumb/GT_200x200.png?1695641490"},{"address":"0xf5ea626334037a2cf0155d49ea6462fddc6eff19","name":"PolygonFarm Finance","symbol":"SPADE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/17364/thumb/Polygon-Farm-Finance-Logo-200x200.png?1627389003"},{"address":"0xa0af9f13e067562aae8e52a5fb6a74febfcf7d41","name":"EMG SuperApp","symbol":"EMGS","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28516/thumb/IMG_20230726_152907_551.jpg?1690432225"},{"address":"0xa2c638b78783e9afe26a16ec8b11de54eb169360","name":"Pay It Now","symbol":"PIN","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/22482/thumb/PINlogo.png?1668686774"},{"address":"0x89c90e480a39fbe3886bb5bd53ba5b1acc69d4fb","name":"Aladdin cvxCRV","symbol":"ACRV","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/25395/thumb/Sv06cFHS_400x400.jpg?1651707422"},{"address":"0x5d48a5e5a3e737322ae27e25897f1c9e19ecc941","name":"OkLetsPlay","symbol":"OKLP","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/22796/thumb/262654028_2202751929890590_982664396355018092_n.png?1642582073"},{"address":"0x6ae96cc93331c19148541d4d2f31363684917092","name":"Caviar","symbol":"CVR","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31354/thumb/caviar-token_200x200.png?1692613048"},{"address":"0xc59132fbdf8de8fbe510f568a5d831c991b4fc38","name":"Borderless Money","symbol":"BOM","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28399/thumb/Logo_BOM_200x200.png?1670299538"},{"address":"0x925fadb35b73720238cc78777d02ed4dd3100816","name":"AutoSingle","symbol":"AUTOS","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/27083/thumb/autos.png?1661764923"},{"address":"0x5d089336f95e649e491c054279d64a86565e8b25","name":"MonoLend","symbol":"MLD","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30143/thumb/MLD.png?1683281135"},{"address":"0xde75b08765d6b9a5d02f7ec709955644a52abb5d","name":"VRJAM  BLUE ","symbol":"VRJAM","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28049/thumb/VRJAM_coin_logo_%28gradient_on_white%29.png?1667279615"},{"address":"0x428360b02c1269bc1c79fbc399ad31d58c1e8fda","name":"Digital Fitness","symbol":"DEFIT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/14699/thumb/Defit.png?1623738365"},{"address":"0xefee2de82343be622dcb4e545f75a3b9f50c272d","name":"TryHards","symbol":"TRY","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/18624/thumb/TryHards_Tokenticker.png?1650437198"},{"address":"0xdda40cdfe4a0090f42ff49f264a831402adb801a","name":"Dogira","symbol":"DOGIRA","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/14634/thumb/IQgaRw0.png?1622439620"},{"address":"0x4bfce5a1acc3b847afa9579ba91da33b08e66fb7","name":"JP3Gvault","symbol":"JP3G","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/24656/thumb/JPEGvault_-_Black_font.png?1648526731"},{"address":"0x76bf0c28e604cc3fe9967c83b3c3f31c213cfe64","name":"Crystl Finance","symbol":"CRYSTL","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/17023/thumb/CRYSTL_Rebrand_Logo.png?1651745246"},{"address":"0xff76c0b48363a7c7307868a81548d340049b0023","name":"Derby Stars RUN","symbol":"DSRUN","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31203/thumb/download.png?1691380383"},{"address":"0xdd9ba3b2571bea0854beb0508ce10fed0eca7e3e","name":"EnviDa","symbol":"EDAT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/20342/thumb/logo1.png?1636941786"},{"address":"0xcb898b0efb084df14dd8e018da37b4d0f06ab26d","name":"Sing","symbol":"SING","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/17682/thumb/200_%2810%29.png?1628841873"},{"address":"0x421b9b487d5a9b76e4b81809c0f1b9bb8cb24cb9","name":"Phobos Token","symbol":"PBOS","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28529/thumb/Phobos_Token_symbol.png?1671434138"},{"address":"0x948d0a28b600bdbd77af4ea30e6f338167034181","name":"NSHARE","symbol":"NSHARE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/21692/thumb/NF_nshare_2_200x200.png?1639721239"},{"address":"0x9719d867a500ef117cc201206b8ab51e794d3f82","name":"Matic Aave Interest Bearing USDC","symbol":"MAUSDC","decimals":6,"logoURI":"https://assets.coingecko.com/coins/images/14074/thumb/maUSDC.png?1614156225"},{"address":"0xe06bd4f5aac8d0aa337d13ec88db6defc6eaeefe","name":"Planet IX","symbol":"IXT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/20927/thumb/IXT_LOGO_PNG_RGB_200X.png?1657602069"},{"address":"0x0f8db146ec1288fc35c05e3b78c2f27d3fa7c4a5","name":"Tradeleaf","symbol":"TLF","decimals":6,"logoURI":"https://assets.coingecko.com/coins/images/29718/thumb/TLF_200x200.png?1682405915"},{"address":"0xdfce1e99a31c4597a3f8a8945cbfa9037655e335","name":"Astrafer","symbol":"ASTRAFER","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/26246/thumb/ATSRA_Token.png?1657276411"},{"address":"0xabede05598760e399ed7eb24900b30c51788f00f","name":"Stepwatch","symbol":"SWP","decimals":8,"logoURI":"https://assets.coingecko.com/coins/images/26384/thumb/MPY_u-OE_400x400.jpg?1657678801"},{"address":"0x329f5e8aff351327e63acdb264389c798a46c2d3","name":"PolyGamma Finance","symbol":"GAMMA","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/19590/thumb/gamma.png?1635473502"},{"address":"0x9eb8a789ed1bd38d281962b523349d5d17a37d47","name":"Xion Finance","symbol":"XGT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/14039/thumb/xgt.png?1613965612"},{"address":"0x2b3b16826719bf0b494c8ddebaa5e882093ee37e","name":"FibSwap DEX","symbol":"FIBO","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/17306/thumb/coingeckofile.png?1655195281"},{"address":"0x32934cb16da43fd661116468c1b225fc26cf9a8c","name":"StrongNode","symbol":"SNE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/19303/thumb/sne.png?1640227905"},{"address":"0x6acda5e7eb1117733dc7cb6158fc67f226b32022","name":"Carb0n fi","symbol":"ZRO","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/23378/thumb/Signet_Zoom_200px_Transparent.png?1643961561"},{"address":"0x7fc9e0aa043787bfad28e29632ada302c790ce33","name":"tetuBAL","symbol":"TETUBAL","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/27969/thumb/tetuBal.png?1667556746"},{"address":"0x580a84c73811e1839f75d86d75d88cca0c241ff4","name":"Qi Dao","symbol":"QI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/15329/thumb/qi.png?1620540969"},{"address":"0x27f8d03b3a2196956ed754badc28d73be8830a6e","name":"Aave Polygon DAI","symbol":"AMDAI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/17251/thumb/amDAI_2x.png?1626942084"},{"address":"0x18e73a5333984549484348a94f4d219f4fab7b81","name":"Yellow Duckies","symbol":"DUCKIES","decimals":8,"logoURI":"https://assets.coingecko.com/coins/images/27630/thumb/Icon_coin_200px.png?1665748614"},{"address":"0x9cd552551ec130b50c1421649c8d11e76ac821e1","name":"Crypto Volatility","symbol":"CVI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/24008/thumb/govi-dao.03ef3083.png?1646029661"},{"address":"0x3b7e1ce09afe2bb3a23919afb65a38e627cfbe97","name":"Dragon Soul Token","symbol":"DST","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29937/thumb/DST_200x200.jpg?1684474899"},{"address":"0x0c47298beee5203358e7bc30b9954b584361eab5","name":"Black Stallion","symbol":"BS","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29207/thumb/bs.png?1677376107"},{"address":"0x95093f8348c6678df4812c008248d88cad344069","name":"War Legends","symbol":"WAR","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30672/thumb/wZBMVBr2_400x400.jpg?1686211615"},{"address":"0x01d35cbc2070a3b76693ce2b6364eae24eb88591","name":"Polygen","symbol":"PGEN","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/21476/thumb/polygen-logo_1.jpeg?1639350369"},{"address":"0x00a0d4f2fe50e023aec0648271ce1a6616c702e2","name":"TOKHIT","symbol":"HITT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29356/thumb/IMG_0634.jpg?1678695708"},{"address":"0xf401e2c1ce8f252947b60bfb92578f84217a1545","name":"Arch Balanced Portfolio","symbol":"ABAL","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30639/thumb/ABAL.png?1686035062"},{"address":"0xd7c8469c7ec40f853da5f651de81b45aed47e5ab","name":"Potcoin","symbol":"POT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/51/thumb/potcoin.png?1547033701"},{"address":"0xec38621e72d86775a89c7422746de1f52bba5320","name":"Davos Protocol","symbol":"DUSD","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28775/thumb/dusd_logo_200x200.png?1685432656"},{"address":"0x6f3cc27e17a0f2e52d8e7693ff0d892cea1854bf","name":"Gooeys","symbol":"GOO","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/25802/thumb/GOO-200.png?1653977205"},{"address":"0x87f654c4b347230c60cad8d7ea9cf0d7238bcc79","name":"Yamp Finance","symbol":"YAMP","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/17301/thumb/0x87f654c4b347230C60CAD8d7ea9cF0D7238bcc79.png?1627267863"},{"address":"0x0395e3178305e64ff9e8d942eb3a470b5d88fae8","name":"Beebox","symbol":"XBBC","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31811/thumb/XBBC_logo.png?1695202972"},{"address":"0x77a6f2e9a9e44fd5d5c3f9be9e52831fc1c3c0a0","name":"World tateCoin","symbol":"WC","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29636/thumb/wsc_polygon_logo_200.png?1680160427"},{"address":"0x27842334c55c01ddfe81bf687425f906816c5141","name":"Veloce","symbol":"VEXT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31214/thumb/VEXT_Logo.jpg?1691461995"},{"address":"0x823cd4264c1b951c9209ad0deaea9988fe8429bf","name":"Matic Aave Interest Bearing AAVE","symbol":"MAAAVE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/14077/thumb/maAAVE.png?1614158144"},{"address":"0x81ee105457c4eafc061b8c8fedc7bb45d22286d2","name":"Space Rebase XUSD","symbol":"XUSD","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28311/thumb/XUSD.png?1669350292"},{"address":"0x8a16d4bf8a0a716017e8d2262c4ac32927797a2f","name":"ViciCoin","symbol":"VCNT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31305/thumb/ViciCoin_-_small.png?1692345105"},{"address":"0x8343091f2499fd4b6174a46d067a920a3b851ff9","name":"Jarvis Synthetic Japanese Yen","symbol":"JJPY","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/24327/thumb/jJPY.png?1647357906"},{"address":"0x0fced30234c3ea94a7b47cc88006ecb7a39dc30e","name":"BITmarkets Token","symbol":"BTMT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31547/thumb/btmt-token_%282%29.png?1693795244"},{"address":"0x70e29b7e036b14d496431b77e0b6eb0008be6165","name":"Captain Tsubasa","symbol":"TSUGT","decimals":8,"logoURI":"https://assets.coingecko.com/coins/images/31757/thumb/TSUBASAGT.png?1694767496"},{"address":"0xe5417af564e4bfda1c483642db72007871397896","name":"Gains Network","symbol":"GNS","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/19737/thumb/logo.png?1635909203"},{"address":"0xf9c1f70f9bf57fad5f63c6e1e25c2e895f04c0a6","name":"DeltaHub Community","symbol":"DHC","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/12656/thumb/DHC_Transparent_200x200.png?1601440150"},{"address":"0x14ee88cd0e3c1534bff13d6d716b8575532c7138","name":"EDNS Domains","symbol":"EDNS","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30880/thumb/ednslogo.jpg?1688459892"},{"address":"0xcfe2cf35d2bdde84967e67d00ad74237e234ce59","name":"PolyPup","symbol":"PUP","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/16420/thumb/2_%288%29.png?1623983944"},{"address":"0x656bf6767fa8863ac0dd0b7d2a26602b838a2e70","name":"Fitmint","symbol":"FITT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/27021/thumb/logo_black.png?1692002490"},{"address":"0xd14d1e501b2b52d6134db1ad0857aa91f9bfe2dd","name":"shuts Wave","symbol":"SWAVE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28830/thumb/swave_logo.png?1675844090"},{"address":"0x3d468ab2329f296e1b9d8476bb54dd77d8c2320f","name":"20WETH 80BAL","symbol":"20WETH-80BAL","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28005/thumb/0x3d468ab2329f296e1b9d8476bb54dd77d8c2320f.png?1666937655"},{"address":"0x4c665bbafd28ec9e5d792345f470ebfca21e3d15","name":"SKYPlay","symbol":"SKP","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/27129/thumb/SKP_logo_20x20.png?1662021510"},{"address":"0x6c526368e1185e4cd8a50468eb3429c5aeb674f3","name":"Selfbar","symbol":"SBAR","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/20599/thumb/sbar-icon.png?1637286886"},{"address":"0xd3f07ea86ddf7baebefd49731d7bbd207fedc53b","name":"Polly DeFi Nest","symbol":"NDEFI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/18317/thumb/nDEFI.png?1631516554"},{"address":"0xe261d618a959afffd53168cd07d12e37b26761db","name":"DIMO","symbol":"DIMO","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28383/thumb/Token_Logo.png?1670052785"},{"address":"0xa0df47432d9d88bcc040e9ee66ddc7e17a882715","name":"Ripae pMATIC","symbol":"PMATIC","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/26366/thumb/l5k8DuE3_400x400.png?1657604405"},{"address":"0xaa9654becca45b5bdfa5ac646c939c62b527d394","name":"DinoSwap","symbol":"DINO","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/17103/thumb/DINO.png?1626244014"},{"address":"0x304243a820d4a3718becc89a3f33513586162cf0","name":"Cri3x","symbol":"CRI3X","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29944/thumb/200x200_logo.png?1682405786"},{"address":"0xe8377a076adabb3f9838afb77bee96eac101ffb1","name":"MetaSoccer","symbol":"MSU","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/21670/thumb/Om_U3jQg_400x400.jpg?1639706776"},{"address":"0x1fd6cf265fd3428f655378a803658942095b4c4e","name":"PolyYeld","symbol":"YELD","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/16401/thumb/pxSN2UtB_400x400.jpg?1623913991"},{"address":"0x00e8c0e92eb3ad88189e7125ec8825edc03ab265","name":"Wrapped USDR","symbol":"WUSDR","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/28800/thumb/wUSDRlogo.png?1674283345"},{"address":"0x315b16bfc91bd6c5d9054f961938b924c7da4964","name":"UC Finance","symbol":"UCF","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31337/thumb/20230805_143400.png?1692600349"},{"address":"0xad9f61563b104281b14322fec8b42eb67711bf68","name":"Synergy Land Token","symbol":"SNG","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30471/thumb/15919.png?1684671822"},{"address":"0x44a6e0be76e1d9620a7f76588e4509fe4fa8e8c8","name":"Aavegotchi FOMO","symbol":"FOMO","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/24737/thumb/fomo.png?1648769659"},{"address":"0xf46cb10e8c5fb9368bbf497a3176b80c0af66d44","name":"Vortex Protocol","symbol":"VP","decimals":11,"logoURI":"https://assets.coingecko.com/coins/images/28122/thumb/vp.png?1667636113"},{"address":"0xbd9c89536e406478d8a42c51b35bcfb6bf8a1384","name":"GrabCoinClub","symbol":"GC","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30742/thumb/GrabCoinClub.png?1689931628"},{"address":"0x05089c9ebffa4f0aca269e32056b1b36b37ed71b","name":"Polywhale","symbol":"KRILL","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/15016/thumb/2.png?1619442213"},{"address":"0x57fcbd6503c8be3b1abad191bc7799ef414a5b31","name":"tSILVER","symbol":"TXAG","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/27829/thumb/tSILVER_token_2D.jpg?1666165851"},{"address":"0x7e4c577ca35913af564ee2a24d882a4946ec492b","name":"MoonEdge","symbol":"MOONED","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/17393/thumb/ME_logo_200_200.png?1627526275"},{"address":"0x4a81f8796e0c6ad4877a51c86693b0de8093f2ef","name":"Iron Finance","symbol":"ICE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/17024/thumb/ice_logo.jpg?1626104736"},{"address":"0xf28164a485b0b2c90639e47b0f377b4a438a16b1","name":"Dragon s Quick","symbol":"DQUICK","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/15185/thumb/quick.png?1676951165"},{"address":"0x0c93709c4389b6eebdb0a4d3d60092bb61446382","name":"Zexicon","symbol":"ZEXI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30217/thumb/ZEXI_Logo%28200x200%29.png?1683628667"},{"address":"0x4ec465d5db20a01bc8404dc84f33bb7a398b8335","name":"Floxypay","symbol":"FXY","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30702/thumb/mNfZxsg__400x400.jpg?1686560258"},{"address":"0x40379a439d4f6795b6fc9aa5687db461677a2dba","name":"Real USD","symbol":"USDR","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/27973/thumb/USDR-200x200.png?1666772134"},{"address":"0x372246175d50db4fd42c2aba4e3292a0fe41ce2e","name":"AMAUROT","symbol":"AMA","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28229/thumb/10b06d6c-379f-4c34-b3f2-196a770a4512.png?1668569067"},{"address":"0x8df3aad3a84da6b69a4da8aec3ea40d9091b2ac4","name":"Aave Polygon WMATIC","symbol":"AMWMATIC","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/17267/thumb/amWMATIC_2x.png?1626967624"},{"address":"0x39ab6574c289c3ae4d88500eec792ab5b947a5eb","name":"Dystopia","symbol":"DYST","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/25786/thumb/dystopialogo.jpg?1653882298"},{"address":"0x04b33078ea1aef29bf3fb29c6ab7b200c58ea126","name":"Safle","symbol":"SAFLE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/21674/thumb/56835021.png?1639710939"},{"address":"0x16dfb898cf7029303c2376031392cb9bac450f94","name":"Dragoma","symbol":"DMA","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/26244/thumb/DMA.png?1656920073"},{"address":"0x5a3064cbdccf428ae907796cf6ad5a664cd7f3d8","name":"PolyQuity","symbol":"PYQ","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/16740/thumb/85542908.png?1624869736"},{"address":"0x6bd10299f4f1d31b3489dc369ea958712d27c81b","name":"Art de Finance","symbol":"ADF","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31348/thumb/200x200.png?1692609865"},{"address":"0x21fdb8e43d84420afbd6351d645f50c9138daae0","name":"EcoCREDIT","symbol":"ECO","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/23363/thumb/Eco-CREDIT-Logo.png?1643947272"},{"address":"0xd60deba014459f07bbcc077a5b817f31dafd5229","name":"Croatian FF Fan Token","symbol":"VATRENI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28295/thumb/Vatreni.png?1669792199"},{"address":"0x311434160d7537be358930def317afb606c0d737","name":"Nakamoto Games","symbol":"NAKA","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/19073/thumb/flCKDeh6_400x400.jpg?1634280509"},{"address":"0xf868939ee81f04f463010bc52eab91c0839ef08c","name":"Attack Wagon","symbol":"ATK","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/21333/thumb/attack.PNG?1638948221"},{"address":"0x90f3edc7d5298918f7bb51694134b07356f7d0c7","name":"DDAO Hunters","symbol":"DDAO","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/23018/thumb/New-Logo.jpg?1673638762"},{"address":"0x0c1eb50007974c4e017a6eccf751110bac287ebb","name":"Metable","symbol":"MTBL","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31594/thumb/MEtable.jpg?1693994433"},{"address":"0x3ed4c2d63def617f436eb031bacae16f478f3b00","name":"DPEX","symbol":"DPEX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31038/thumb/logo-ai.png?1689847877"},{"address":"0xefcfece12a99d1dbbf6f3264ee97f8c045e97f1f","name":"The Unfettered Souls","symbol":"SOULS","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30591/thumb/un.jpg?1686202090"},{"address":"0x346404079b3792a6c548b072b9c4dddfb92948d5","name":"GeniuX","symbol":"IUX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/26078/thumb/black_IUX-coin-logo2.png?1661767150"},{"address":"0x0b6afe834dab840335f87d99b45c2a4bd81a93c7","name":"Polylauncher","symbol":"ANGEL","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/17739/thumb/Polylauncher_-_200_x_200.png?1629121147"},{"address":"0xe7a24ef0c5e95ffb0f6684b813a78f2a3ad7d171","name":"Curve fi amDAI amUSDC amUSDT","symbol":"AM3CRV","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/26740/thumb/W1sQNVWo_400x400.jpeg?1659953467"},{"address":"0xb1cb9d9c85aa10c332083bcd03d2fcf871556e52","name":"Gascoin","symbol":"GCN","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31901/thumb/GAS_LOGO.jpg?1695641429"},{"address":"0x6d0a48dd4c3b2a4d65c71b9be4da859ecf076485","name":"Immortl","symbol":"IMRTL","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29216/thumb/immortl.png?1677406854"},{"address":"0x47dae46d31f31f84336ac120b15efda261d484fb","name":"Bund V2","symbol":"BUND","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/13219/thumb/IMG_20230201_114958_189.png?1675906710"},{"address":"0xb763f1177e9b2fb66fbe0d50372e3e2575c043e5","name":"Karmaverse","symbol":"KNOT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/24239/thumb/knot.png?1647088638"},{"address":"0xd1f9c58e33933a993a3891f8acfe05a68e1afc05","name":"Sunflower Land","symbol":"SFL","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/25514/thumb/download.png?1652164203"},{"address":"0xb2c63830d4478cb331142fac075a39671a5541dc","name":"Bombcrypto Coin","symbol":"BOMB","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/26399/thumb/Bombcrypto_Coin.png?1657797692"},{"address":"0x25c498781ca536547b147e2199f572e5393d36f0","name":"AirTnT","symbol":"AIRTNT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28328/thumb/airtnt.png?1669457251"},{"address":"0x08715f5c743f747de0005ad6c45336c163711137","name":"cLFi","symbol":"CLFI","decimals":8,"logoURI":"https://assets.coingecko.com/coins/images/31454/thumb/CLFI.png?1692939765"},{"address":"0x103965213122805c9aa63d8036ed0ef692c19650","name":"D Drops","symbol":"DOP","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/26611/thumb/ddrops_%281%29.png?1694747621"},{"address":"0x0bd49815ea8e2682220bcb41524c0dd10ba71d41","name":"Playermon","symbol":"PYM","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/20682/thumb/eALRa3rZ_400x400.png?1637552321"},{"address":"0x8f18dc399594b451eda8c5da02d0563c0b2d0f16","name":"moonwolf io","symbol":"WOLF","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/14698/thumb/oC37AkkD_400x400.jpg?1617835365"},{"address":"0xe78649874bcdb7a9d1666e665f340723a0187482","name":"BIM","symbol":"BIM","decimals":17,"logoURI":"https://assets.coingecko.com/coins/images/30137/thumb/logo200x200.png?1683276854"},{"address":"0x4c392822d4be8494b798cea17b43d48b2308109c","name":"Polly Finance","symbol":"POLLY","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/18354/thumb/POLLY.png?1631604593"},{"address":"0xd86b5923f3ad7b585ed81b448170ae026c65ae9a","name":"Iron","symbol":"IRON","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/14588/thumb/logo_-_2021-03-31T123525.615.png?1617165339"},{"address":"0x5e6602b762f76d8bfdc7321aa0b787b1e67b187f","name":"KRED","symbol":"KRED","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/22935/thumb/kred_logo_200.png?1643004614"},{"address":"0xf9d3d8b25b95bcda979025b74fdfa7ac3f380f9f","name":"Cookies Protocol","symbol":"CP","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28432/thumb/IMG_20221207_200805_897.jpg?1670556204"},{"address":"0x262b8aa7542004f023b0eb02bc6b96350a02b728","name":"Sway Social","symbol":"SWAY","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/18915/thumb/sway.png?1638944259"},{"address":"0xacbdc2b7a577299718309ed5c4b703fb5ed7af90","name":"Signed","symbol":"SIGN","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/24030/thumb/wjnKYes.png?1646115896"},{"address":"0x28424507fefb6f7f8e9d3860f56504e4e5f5f390","name":"Aave Polygon WETH","symbol":"AMWETH","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/17266/thumb/amWETH_2x.png?1626967258"},{"address":"0x4550003152f12014558e5ce025707e4dd841100f","name":"Kaizen Finance","symbol":"KZEN","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/24396/thumb/PKl5OVRv_400x400.png?1647522756"},{"address":"0x0c705862f56cd8ec70337f5f5184fea4158a3c00","name":"Abyss World","symbol":"AWT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30679/thumb/black.png?1686215515"},{"address":"0x0e2c818fea38e7df50410f772b7d59af20589a62","name":"Dominium","symbol":"DOM","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/24506/thumb/DOM-Token-Icon-200-200-px.png?1647883646"},{"address":"0x9a4eb698e5de3d3df0a68f681789072de1e50222","name":"Fidira","symbol":"FID","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/19446/thumb/nl0qESy3_400x400.jpg?1635236436"},{"address":"0x3c5a5885f6ee4acc2597069fe3c19f49c6efba96","name":"Krida Fans","symbol":"KRIDA","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/23104/thumb/bIdz6haF_400x400.jpg?1643233205"},{"address":"0x6a8ec2d9bfbdd20a7f5a4e89d640f7e7ceba4499","name":"MSquare Global","symbol":"MSQ","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/25305/thumb/19743.png?1651204766"},{"address":"0x669ddc70273084ea30e6cd4f28ca6e2c70735065","name":"AGA Carbon Credit","symbol":"AGAC","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/16728/thumb/agac128.png?1624856514"},{"address":"0x21a77520d0a25eede18a34ad4bc7a769d785c6ff","name":"Stars","symbol":"SRX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31157/thumb/Stars.jpg?1691045994"},{"address":"0x839f1a22a59eaaf26c85958712ab32f80fea23d9","name":"Axion","symbol":"AXN","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/13110/thumb/AXION.png?1634887383"},{"address":"0xaaa5b9e6c589642f98a1cda99b9d024b8407285a","name":"IRON Titanium","symbol":"TITAN","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/16031/thumb/titan.png?1636080284"},{"address":"0x97d45ec651d25b90701ec49c959e75efe4e1f36c","name":"NX7","symbol":"NX7","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/31791/thumb/nx7-02-.png?1695025696"},{"address":"0xd0b3a0e0ea080a0882d6e048cae8558f010ce81f","name":"TORA","symbol":"TORA","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29332/thumb/200tora.jpg?1678172774"},{"address":"0x3f374ed3c8e61a0d250f275609be2219005c021e","name":"Arcadium","symbol":"ARCADIUM","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/17717/thumb/4dyLxHe.png?1629085958"},{"address":"0x6002410dda2fb88b4d0dc3c1d562f7761191ea80","name":"The Employment Commons Work","symbol":"WORK","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/18546/thumb/mXSw8Qw.png?1632362691"},{"address":"0xbc2659ead8d2d13a157a75bfc5acc156e1ea06df","name":"Ommniverse","symbol":"OMMI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29394/thumb/ommi_gold.png?1678508218"},{"address":"0x36596a1dc57c695bed1a063470a7802797dca133","name":"Umma Token","symbol":"UMMA","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31681/thumb/UMMA_200x200.png?1694401647"},{"address":"0x6749441fdc8650b5b5a854ed255c82ef361f1596","name":"Lucha","symbol":"LUCHA","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/22794/thumb/lucha.png?1642581523"},{"address":"0x9008d70a5282a936552593f410abcbce2f891a97","name":"Penrose Finance","symbol":"PEN","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/26105/thumb/6iWxdkG.png?1655872325"},{"address":"0xaf3cbaeba9fe7a7d4e7531f1b2553972fd1c4e9c","name":"Zizy","symbol":"ZIZY","decimals":8,"logoURI":"https://assets.coingecko.com/coins/images/30123/thumb/ZIZYlogo_%282%29.png?1683258195"},{"address":"0xb988bd378a0754957d5d9471c96e0f8051645a26","name":"iNFTspace","symbol":"INS","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/24681/thumb/4hTuPCCC_400x400.jpg?1648560503"},{"address":"0x67eb41a14c0fe5cd701fc9d5a3d6597a72f641a6","name":"Giddy","symbol":"GDDY","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/24960/thumb/gddy.png?1649573862"},{"address":"0x5a7bb7b8eff493625a2bb855445911e63a490e42","name":"TSUBASA Utilitiy Token","symbol":"TSUBASAUT","decimals":8,"logoURI":"https://assets.coingecko.com/coins/images/31796/thumb/TSUBASAUT.png?1695026842"},{"address":"0x301595f6fd5f69fad7a488dacb8971e7c0c2f559","name":"Wrapped ThunderPOKT","symbol":"WTPOKT","decimals":12,"logoURI":"https://assets.coingecko.com/coins/images/24835/thumb/vjCQH6sw.jpg?1649060228"},{"address":"0xd57f8b6f3e5d1e0ab85118f5e0dd893a08c43346","name":"Omnisea","symbol":"OSEA","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/26475/thumb/293837892_407994084681555_3167689470652146992_n.png?1658195766"},{"address":"0xfd290dab8ec58fb7e9c7ce6e36b9a5a1a90ec164","name":"Metalands","symbol":"PVP","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30609/thumb/pvp_token.png?1685691164"},{"address":"0x027d14b07299ee2e74a3b7aba561e5b4adf29966","name":"SpaceShipX SSX","symbol":"SSX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28704/thumb/CRYTOLOGO.png?1673426191"},{"address":"0xe77abb1e75d2913b2076dd16049992ffeaca5235","name":"Decentrawood","symbol":"DEOD","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29308/thumb/LOGO.png?1677994638"},{"address":"0x968b493a2b27d03dad92b9ea1e2e8232a72c9c2c","name":"Swords of Blood","symbol":"SWDTKN","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31358/thumb/Swoordsofblood_-_m11-200x200.png?1692619417"},{"address":"0x8a953cfe442c5e8855cc6c61b1293fa648bae472","name":"PolyDoge","symbol":"POLYDOGE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/15146/thumb/p1kSco1h_400x400.jpg?1619842715"},{"address":"0x1c5ea1a050633dd9136e42ce675211116f465692","name":"MnICorp","symbol":"MNI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30411/thumb/logo-mni-2022-white-text_%281%29.png?1684386782"},{"address":"0xdab35042e63e93cc8556c9bae482e5415b5ac4b1","name":"Iris","symbol":"IRIS","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/18361/thumb/hermes.PNG?1631609306"},{"address":"0x081ec4c0e30159c8259bad8f4887f83010a681dc","name":"Denet File Token","symbol":"DE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31086/thumb/0x081ec4c0e30159c8259bad8f4887f83010a681dc_%281%29.png?1690445100"},{"address":"0x20c750c57c3bc5145af4b7a33d4fb66a8e79fe05","name":"Orbcity","symbol":"ORB","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/24332/thumb/OrbCity_enlarged.jpg?1669370209"},{"address":"0xcce87c5b269c94b31ec437b1d7d85bf1413b7804","name":"Oort Digital","symbol":"OORT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29553/thumb/512_512.png?1695347887"},{"address":"0x05f52cc483c50c2a7e25a13dac17d736fa50f259","name":"Bloxies Coin","symbol":"BXC","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31400/thumb/BXC_Coin_200x200.png?1692783061"},{"address":"0x3ce1327867077b551ae9a6987bf10c9fd08edce1","name":"SwissCheese","symbol":"SWCH","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31344/thumb/IMG_7198.jpeg?1692606890"},{"address":"0x4cd44ced63d9a6fef595f6ad3f7ced13fceac768","name":"tetuQi","symbol":"TETUQI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28314/thumb/tetuQi.png?1669357389"},{"address":"0x9f95e17b2668afe01f8fbd157068b0a4405cc08d","name":"Bullieverse","symbol":"BULL","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/24174/thumb/KR3qVAQe_400x400.jpg?1646747837"},{"address":"0x6e8a8726639d12935b3219892155520bdc57366b","name":"GNOME","symbol":"GNOME","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/20885/thumb/gnome.png?1637829973"},{"address":"0xac0f66379a6d7801d7726d5a943356a172549adb","name":"Geodnet","symbol":"GEOD","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31608/thumb/Circular_White.png?1694072309"},{"address":"0xe46b4a950c389e80621d10dfc398e91613c7e25e","name":"PartyFi","symbol":"PFI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/27548/thumb/GU_yPtme_400x400.jpeg?1664442276"},{"address":"0xd125443f38a69d776177c2b9c041f462936f8218","name":"FireBot","symbol":"FBX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/21713/thumb/fbx200.png?1639785014"},{"address":"0x1d2a0e5ec8e5bbdca5cb219e649b565d8e5c3360","name":"Aave Polygon AAVE","symbol":"AMAAVE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/17239/thumb/amAAVE_2x.png?1626940769"},{"address":"0x0308a3a9c433256ad7ef24dbef9c49c8cb01300a","name":"GoldPesa Option","symbol":"GPO","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/23813/thumb/15462.png?1645513212"},{"address":"0x9dbfc1cbf7a1e711503a29b4b5f9130ebeccac96","name":"UpOnly","symbol":"UPO","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/24900/thumb/f-WNwLNJ_400x400.jpg?1649323846"},{"address":"0x7e7737c40878e720b32e7bc9cd096259f876d69f","name":"Catheon Gaming","symbol":"CATHEON","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/28052/thumb/_removal.ai__tmp-635fe0271d6a3%281%29.png?1667286253"},{"address":"0x2760e46d9bb43dafcbecaad1f64b93207f9f0ed7","name":"Metavault Trade","symbol":"MVX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/25402/thumb/mvx.png?1660380728"},{"address":"0x38a232cabb8a7f745c7d6e0a5bf300e3499aa8a6","name":"PIVN","symbol":"PIVN","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29617/thumb/pivn.png?1680056941"},{"address":"0x04cc80c7665e4d57f57e16a1212a57c0c11927ce","name":"Aniverse Metaverse","symbol":"ANIV","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29090/thumb/aniv.png?1676524404"},{"address":"0x6f06e6bed64cf4c4187c06ee2a4732f6a171bc4e","name":"FoodChain Global","symbol":"FOOD","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/23755/thumb/food.png?1645347956"},{"address":"0x9af3b7dc29d3c4b1a5731408b6a9656fa7ac3b72","name":"PUSD Polyquity","symbol":"PUSD","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/16762/thumb/PUSD-purple-200.png?1624937879"},{"address":"0x7cc15fef543f205bf21018f038f591c6bada941c","name":"PolyCub","symbol":"POLYCUB","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/24124/thumb/polycub.png?1646462759"},{"address":"0xc1c93d475dc82fe72dbc7074d55f5a734f8ceeae","name":"Pegaxy Stone","symbol":"PGX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/19305/thumb/Logo_200x200_%281%29.png?1634972378"},{"address":"0x0d0b8488222f7f83b23e365320a4021b12ead608","name":"Next Earth","symbol":"NXTT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/23264/thumb/kG1zm83.png?1643363107"},{"address":"0x2e6978ceea865948f4c5685e35aec72652e3cb88","name":"tPLATINUM","symbol":"TXPT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/27830/thumb/tPLATINUM_%28TXPT%29_Token.png?1692951159"},{"address":"0x6d9c0b104e5af90a6d11a13eb77288e533333301","name":"MAXX Finance","symbol":"MAXX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/27203/thumb/maxxfinance.jpeg?1662604201"},{"address":"0xe8d17b127ba8b9899a160d9a07b69bca8e08bfc6","name":"NASDEX","symbol":"NSDX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/18634/thumb/nadex.PNG?1632727863"},{"address":"0xcd86152047e800d67bdf00a4c635a8b6c0e5c4c2","name":"Nacho Finance","symbol":"NACHO","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/21635/thumb/NF_nacho_2_200x200.png?1639627573"},{"address":"0xb6169e71144b4debd9caa2dbb851fc8ffde6119f","name":"DuDe","symbol":"DUDE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/25924/thumb/dude-logo-png.jpg?1654672849"},{"address":"0x578fee9def9a270c20865242cfd4ff86f31d0e5b","name":"Runy","symbol":"RUNY","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29125/thumb/Coin_Runy_200_200.png?1676947037"},{"address":"0x204820b6e6feae805e376d2c6837446186e57981","name":"ROND","symbol":"ROND","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/27601/thumb/rond.png?1664716228"},{"address":"0x64060ab139feaae7f06ca4e63189d86adeb51691","name":"Unicorn Milk","symbol":"UNIM","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/23321/thumb/SVJI5-cerIpV4P1K3d_LeLKN3ZlE4eaazbnPEzrKhnU.png?1646707129"},{"address":"0x2db0db271a10661e7090b6758350e18f6798a49d","name":"Mobius Finance","symbol":"MOT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/18144/thumb/11322.png?1630668459"},{"address":"0x03f61137bfb86be07394f0fd07a33984020f96d8","name":"Xpendium","symbol":"XPND","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/24520/thumb/2XyH_HyB_400x400.jpg?1647963390"},{"address":"0xf287d97b6345bad3d88856b26fb7c0ab3f2c7976","name":"Index Coop   MATIC 2x Flexible Leverage","symbol":"MATIC2X-FLI-P","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/23388/thumb/MATIC2x-FLI.png?1644061428"},{"address":"0x202655af326de310491cb54f120e02ee0da92b55","name":"Creta World","symbol":"CRETA","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29129/thumb/colour_icon.png?1676954572"},{"address":"0x82362ec182db3cf7829014bc61e9be8a2e82868a","name":"Meshswap Protocol","symbol":"MESH","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/25609/thumb/VxtSquTp_400x400.jpeg?1652844613"},{"address":"0xcc1b9517460d8ae86fe576f614d091fca65a28fc","name":"Vigorus","symbol":"VIS","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/21245/thumb/VIS.PNG?1638768736"},{"address":"0xfa3c05c2023918a4324fde7163591fe6bebd1692","name":"Cresio","symbol":"XCRE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/8032/thumb/logoXCRE.png?1644387161"},{"address":"0x61daecab65ee2a1d5b6032df030f3faa3d116aa7","name":"Dark Magic","symbol":"DMAGIC","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/15842/thumb/Dark_Magic.png?1622092194"},{"address":"0x6d295da283c4c0658eafe608e4145e8a86777b88","name":"SolarX","symbol":"SOLX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31877/thumb/x_black.png?1695355230"}]},{"chainId":"80001","name":"Mumbai","tokens":[{"address":"0x0000000000000000000000000000000000000000","name":"MATIC","symbol":"MATIC","decimals":18,"logoURI":"https://polygonscan.com/images/svg/brands/matic.svg"}]},{"chainId":"10","name":"Optimism","tokens":[{"address":"0x0000000000000000000000000000000000000000","name":"Ether","symbol":"ETH","decimals":18,"logoURI":"https://optimistic.etherscan.io/images/svg/brands/main.svg"},{"address":"0x9560e827af36c94d2ac33a39bce1fe78631088db","name":"Velodrome Finance","symbol":"VELO","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/25783/thumb/velo.png?1653817876"},{"address":"0x3ee6107d9c93955acbb3f39871d32b02f82b78ab","name":"Staked Ethos Reserve Note","symbol":"STERN","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31522/thumb/stERN.png?1693565722"},{"address":"0xe4d8701c69b3b94a620ff048e4226c895b67b2c0","name":"Minerva Money","symbol":"MINE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30701/thumb/016-D86-A7-E242-4-DC5-860-A-E09-C92-F79-DD2.png?1686544289"},{"address":"0xcdb4bb51801a1f399d4402c61bc098a72c382e65","name":"OPX Finance","symbol":"OPX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28225/thumb/logo_OPX.png?1668501930"},{"address":"0xc4d4500326981eacd020e20a81b1c479c161c7ef","name":"Exactly Wrapped Ether","symbol":"EXAWETH","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31174/thumb/ExaETH_1.png?1691117420"},{"address":"0xa430a427bd00210506589906a71b54d6c256cedb","name":"Exactly Optimism","symbol":"EXAOP","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31173/thumb/ExaOP_1.png?1691117360"},{"address":"0xc26921b5b9ee80773774d36c84328ccb22c3a819","name":"Wrapped OptiDoge","symbol":"WOPTIDOGE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31066/thumb/Wrapped_OptiDoge_logo_200x200px_.png?1690178968"},{"address":"0xf8e943f646816e4b51279b8934753821ed832dca","name":"Cthulhu Finance","symbol":"CTH","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29487/thumb/logo200.png?1679213444"},{"address":"0xb532178708814f0c174b29b991d2b355106afbc3","name":"Astrava","symbol":"AST","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31122/thumb/Astrava2.jpeg?1690773767"},{"address":"0x81c9a7b55a4df39a9b7b5f781ec0e53539694873","name":"Exactly USD Coin","symbol":"EXAUSDC","decimals":6,"logoURI":"https://assets.coingecko.com/coins/images/31175/thumb/ExaUSDC_1.png?1691117494"},{"address":"0x7da25bc4cfaed3f29414c6779676e53b19a356f5","name":"Kokomo Finance","symbol":"KOKO","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29572/thumb/Logo_%282%29.png?1679738524"},{"address":"0x2513486f18eee1498d7b6281f668b955181dd0d9","name":"OpenXSwap Gov  Token","symbol":"XOPENX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28325/thumb/X_op_red_sm.png?1669446855"},{"address":"0xbf0c7ccb143126c1be90a426f676f5cb313956d9","name":"Tempest","symbol":"TEM","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31395/thumb/logo200.png?1692764126"},{"address":"0x970d50d09f3a656b43e11b0d45241a84e3a6e011","name":"Overnight fi DAI ","symbol":"DAI+","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29634/thumb/DAI_.png?1680160024"},{"address":"0x96d17e1301b31556e5e263389583a9331e6749e9","name":"RillaFi","symbol":"RILLA","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29193/thumb/output-onlinepngtools.png?1677301164"},{"address":"0x4200000000000000000000000000000000000042","name":"Optimism","symbol":"OP","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/25244/thumb/Optimism.png?1660904599"},{"address":"0x22ab31cd55130435b5efbf9224b6a9d5ec36533f","name":"Exactly Wrapped stETH","symbol":"EXAWSTETH","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31172/thumb/ExawstETH_1.png?1691117228"},{"address":"0x7f5c764cbc14f9669b88837ca1490cca17c31607","name":"Bridged USD Coin  Optimism ","symbol":"USDCE","decimals":6,"logoURI":"https://assets.coingecko.com/coins/images/31580/thumb/USDC-icon.png?1693978463"},{"address":"0xfa436399d0458dbe8ab890c3441256e3e09022a8","name":"ZipSwap","symbol":"ZIP","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/22910/thumb/zip.png?1642949795"},{"address":"0xc3864f98f2a61a7caeb95b039d031b4e2f55e0e9","name":"OpenXSwap","symbol":"OPENX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/27663/thumb/sx7muGTv_400x400.jpeg?1665116515"},{"address":"0x61baadcf22d2565b0f471b291c475db5555e0b76","name":"Aelin","symbol":"AELIN","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/22303/thumb/aelien.jpg?1641445323"},{"address":"0x1db2466d9f5e10d7090e7152b68d62703a2245f0","name":"Sonne Finance","symbol":"SONNE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/27540/thumb/Token1.png?1664422231"},{"address":"0x1e925de1c68ef83bd98ee3e130ef14a50309c01b","name":"Exactly Token","symbol":"EXA","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31089/thumb/EXA.png?1690447530"},{"address":"0x920cf626a271321c151d027030d5d08af699456b","name":"Kwenta","symbol":"KWENTA","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/27409/thumb/kwenta.png?1668768595"},{"address":"0x2dad3a13ef0c6366220f989157009e501e7938f8","name":"Extra Finance","symbol":"EXTRA","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30973/thumb/Ex_logo-white-blue_ring_288x.png?1689307279"},{"address":"0xc5b001dc33727f8f26880b184090d3e252470d45","name":"Ethos Reserve Note","symbol":"ERN","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29744/thumb/ERN200x200.png?1681106290"},{"address":"0x8b21e9b7daf2c4325bf3d18c1beb79a347fe902a","name":"Collab Land","symbol":"COLLAB","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29098/thumb/collab.png?1676566517"},{"address":"0x9a601c5bb360811d96a23689066af316a30c3027","name":"Pika Protocol","symbol":"PIKA","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30279/thumb/Pika_protocol.png?1683796032"},{"address":"0x6c84a8f1c29108f47a79964b5fe888d4f4d0de40","name":"tBTC","symbol":"TBTC","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/11224/thumb/0x18084fba666a33d37592fa2633fd49a74dd93a88.png?1674474504"},{"address":"0x395ae52bb17aef68c2888d941736a71dc6d4e125","name":"PoolTogether","symbol":"POOL","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/14003/thumb/PoolTogether.png?1613585632"},{"address":"0xecf46257ed31c329f204eb43e254c609dee143b3","name":"RigoBlock","symbol":"GRG","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/1532/thumb/Symbol-RigoblockRGB.png?1547035682"},{"address":"0x1f514a61bcde34f94bc39731235690ab9da737f7","name":"Tarot","symbol":"TAROT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31800/thumb/TAROT.jpg?1695096221"},{"address":"0xaf20f5f19698f1d19351028cd7103b63d30de7d7","name":"Wagmi","symbol":"WAGMI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31887/thumb/wagmi_token_logo.png?1695372579"},{"address":"0xe453d6649643f1f460c371dc3d1da98f7922fe51","name":"Fuse","symbol":"FUSE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/10347/thumb/fuse.png?1685331339"},{"address":"0x81ab7e0d570b01411fcc4afd3d50ec8c241cb74b","name":"Equalizer","symbol":"EQZ","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/14741/thumb/X2p5mb2f_400x400.png?1618005664"},{"address":"0x14778860e937f509e651192a90589de711fb88a9","name":"CyberConnect","symbol":"CYBER","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31274/thumb/cyberconnect.png?1692101771"},{"address":"0x28b42698caf46b4b012cf38b6c75867e0762186d","name":"UniDex","symbol":"UNIDX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/13178/thumb/unidx.png?1634888975"},{"address":"0x9c9e5fd8bbc25984b178fdce6117defa39d2db39","name":"Binance Peg BUSD","symbol":"BUSD","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31273/thumb/new_binance-peg-busd.png?1692097938"},{"address":"0x29faf5905bff9cfcc7cf56a5ed91e0f091f8664b","name":"Bankless DAO","symbol":"BANK","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/15227/thumb/j4WEJrwU.png?1622615796"},{"address":"0x8637725ada78db0674a679cea2a5e0a0869ef4a1","name":"NFTEarth","symbol":"NFTE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29116/thumb/20230223_224134.jpg?1677224110"},{"address":"0x58b9cb810a68a7f3e1e4f8cb45d1b9b3c79705e8","name":"Connext","symbol":"NEXT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31293/thumb/connext.png?1692331440"},{"address":"0x0b2c639c533813f4aa9d7837caf62653d097ff85","name":"USDC","symbol":"USDC","decimals":6,"logoURI":"https://assets.coingecko.com/coins/images/6319/thumb/usdc.png?1695374272"},{"address":"0x23ee2343b892b1bb63503a4fabc840e0e2c6810f","name":"Axelar","symbol":"AXL","decimals":6,"logoURI":"https://assets.coingecko.com/coins/images/27277/thumb/V-65_xQ1_400x400.jpeg?1663121730"},{"address":"0x94025780a1ab58868d9b2dbbb775f44b32e8e6e5","name":"BetSwirl","symbol":"BETS","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/26618/thumb/icon_200.png?1659073275"},{"address":"0xb396b31599333739a97951b74652c117be86ee1d","name":"Davos Protocol","symbol":"DUSD","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28775/thumb/dusd_logo_200x200.png?1685432656"},{"address":"0xc03b43d492d904406db2d7d57e67c7e8234ba752","name":"Wrapped USDR","symbol":"WUSDR","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/28800/thumb/wUSDRlogo.png?1674283345"},{"address":"0xb829b68f57cc546da7e5806a929e53be32a4625d","name":"Axelar Wrapped Ether","symbol":"AXLETH","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28171/thumb/weth-wei_D_3x.png?1691399543"},{"address":"0x3e5d9d8a63cc8a88748f229999cf59487e90721e","name":"MetalSwap","symbol":"XMT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/22075/thumb/Logo_COIN_-_Gradiente.png?1670579810"},{"address":"0x6f0fecbc276de8fc69257065fe47c5a03d986394","name":"Popcorn","symbol":"POP","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/21438/thumb/pop-1_200_x_200.png?1662607611"},{"address":"0x2e3d870790dc77a83dd1d18184acc7439a53f475","name":"Frax","symbol":"FRAX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/13422/thumb/FRAX_icon.png?1679886922"},{"address":"0xcb59a0a753fdb7491d5f3d794316f1ade197b21e","name":"Bridged TrueUSD","symbol":"TUSD","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30837/thumb/tusd.jpeg?1687837876"},{"address":"0xff733b2a3557a7ed6697007ab5d11b79fdd1b76b","name":"Across Protocol","symbol":"ACX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28161/thumb/across-200x200.png?1668168201"},{"address":"0xaddb6a0412de1ba0f936dcaeb8aaa24578dcf3b2","name":"Coinbase Wrapped Staked ETH","symbol":"CBETH","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/27008/thumb/cbeth.png?1661390066"},{"address":"0x276cf9e7a43d1b9422decd1f1d2608f3d588caad","name":"AllianceBlock","symbol":"ALBT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/12392/thumb/alliance_block_logo.jpg?1599546617"},{"address":"0x39fde572a18448f8139b7788099f0a0740f51205","name":"OATH","symbol":"OATH","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/24075/thumb/oldOATH_2023.png?1692667545"},{"address":"0x374ad0f47f4ca39c78e5cc54f1c9e426ff8f231a","name":"Premia","symbol":"PREMIA","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/13962/thumb/apple-touch-icon.png?1623679482"},{"address":"0xb0ae108669ceb86e9e98e8fe9e40d98b867855fd","name":"OneRing","symbol":"RING","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/23273/thumb/ring.png?1648278585"},{"address":"0xd3ac016b1b8c80eeadde4d186a9138c9324e4189","name":"Okcash","symbol":"OK","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/274/thumb/ok-logo-200px.png?1665792994"},{"address":"0xbfd291da8a403daaf7e5e9dc1ec0aceacd4848b9","name":"dForce USD","symbol":"USX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/17422/thumb/usx_32.png?1627600920"},{"address":"0x8ae125e8653821e851f12a49f7765db9a9ce7384","name":"DOLA","symbol":"DOLA","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/14287/thumb/dola.png?1667738374"},{"address":"0x74ccbe53f77b08632ce0cb91d3a545bf6b8e0979","name":"Fantom Bomb","symbol":"BOMB","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/24109/thumb/logo-blue.png?1646376874"},{"address":"0x9bcef72be871e61ed4fbbc7630889bee758eb81d","name":"Rocket Pool ETH","symbol":"RETH","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/20764/thumb/reth.png?1637652366"},{"address":"0x15e770b95edd73fd96b02ece0266247d50895e76","name":"Jarvis Reward","symbol":"JRT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/10390/thumb/cfeii0y.png?1578868949"},{"address":"0x7f5373ae26c3e8ffc4c77b7255df7ec1a9af52a6","name":"Bridged Tether  Axelar ","symbol":"AXLUSDT","decimals":6,"logoURI":"https://assets.coingecko.com/coins/images/31002/thumb/uusdt_D_3x.png?1689648389"},{"address":"0x1e3c6c53f9f60bf8aae0d7774c21fa6b1afddc57","name":"xShrap","symbol":"XSHRAP","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29346/thumb/xshrapnel.png?1678253037"},{"address":"0xd652776de7ad802be5ec7bebfafda37600222b48","name":"SoliMax","symbol":"SLM","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29440/thumb/slmlogo.png?1678864547"},{"address":"0xaf8ca653fa2772d58f4368b0a71980e9e3ceb888","name":"Tellor Tributes","symbol":"TRB","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/9644/thumb/Blk_icon_current.png?1584980686"},{"address":"0x47536f17f4ff30e64a96a7555826b8f9e66ec468","name":"Mummy Finance","symbol":"MMY","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28547/thumb/Logo_MMY.png?1671599329"},{"address":"0x6806411765af15bddd26f8f544a34cc40cb9838b","name":"Frax Ether","symbol":"FRXETH","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28284/thumb/frxETH_icon.png?1679886981"},{"address":"0xb153fb3d196a8eb25522705560ac152eeec57901","name":"Magic Internet Money","symbol":"MIM","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/16786/thumb/mimlogopng.png?1624979612"},{"address":"0x484c2d6e3cdd945a8b2df735e079178c1036578c","name":"Staked Frax Ether","symbol":"SFRXETH","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28285/thumb/sfrxETH_icon.png?1679886768"},{"address":"0x3a18dcc9745edcd1ef33ecb93b0b6eba5671e7ca","name":"Kujira","symbol":"KUJI","decimals":6,"logoURI":"https://assets.coingecko.com/coins/images/20685/thumb/kuji-200x200.png?1637557201"},{"address":"0xfd389dc9533717239856190f42475d3f263a270d","name":"Granary","symbol":"GRAIN","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29740/thumb/Grain.png?1681096624"},{"address":"0xdc6ff44d5d932cbd77b52e5612ba0529dc6226f1","name":"Worldcoin","symbol":"WLD","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31069/thumb/worldcoin.jpeg?1690182386"},{"address":"0xc27d9bc194a648fe3069955a5126699c4e49351c","name":"Alongside Crypto Market Index","symbol":"AMKT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28496/thumb/22999.png?1676455314"},{"address":"0xdb4ea87ff83eb1c80b8976fc47731da6a31d35e5","name":"wTBT","symbol":"WTBT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29772/thumb/WTBT.png?1681265480"},{"address":"0xd3594e879b358f430e20f82bea61e83562d49d48","name":"ParaSwap","symbol":"PSP","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/20403/thumb/ep7GqM19_400x400.jpg?1636979120"},{"address":"0x929b939f8524c3be977af57a4a0ad3fb1e374b50","name":"mStable Governance  Meta","symbol":"MTA","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/11846/thumb/mStable.png?1594950533"},{"address":"0x9ed7e4b1bff939ad473da5e7a218c771d1569456","name":"Reunit Wallet","symbol":"REUNI","decimals":6,"logoURI":"https://assets.coingecko.com/coins/images/29492/thumb/reunit_200.png?1679280627"},{"address":"0xf1a0da3367bc7aa04f8d94ba57b862ff37ced174","name":"ShapeShift FOX","symbol":"FOX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/9988/thumb/FOX.png?1574330622"},{"address":"0xbc7b1ff1c6989f006a1185318ed4e7b5796e66e1","name":"Pendle","symbol":"PENDLE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/15069/thumb/Pendle_Logo_Normal-03.png?1634196276"},{"address":"0xb25ea095997f5bbaa6cea962c4fbf3bfc3c09776","name":"Promethios","symbol":"FIRE","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/30750/thumb/Fire_Logo.png?1686728534"},{"address":"0xeb466342c4d449bc9f53a865d5cb90586f405215","name":"Bridged USD Coin  Axelar ","symbol":"AXLUSDC","decimals":6,"logoURI":"https://assets.coingecko.com/coins/images/26476/thumb/uausdc_D_3x.png?1690776252"},{"address":"0x625e7708f30ca75bfd92586e17077590c60eb4cd","name":"Aave USDC","symbol":"AUSDC","decimals":6,"logoURI":"https://assets.coingecko.com/coins/images/14318/thumb/aUSDC.e260d492.png?1615527797"},{"address":"0x6ab707aca953edaefbc4fd23ba73294241490620","name":"Aave USDT","symbol":"AUSDT","decimals":6,"logoURI":"https://assets.coingecko.com/coins/images/14243/thumb/aUSDT.78f5faae.png?1615528400"},{"address":"0x82e64f49ed5ec1bc6e43dad4fc8af9bb3a2312ee","name":"Aave DAI","symbol":"ADAI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/14242/thumb/aDAI.84b6c41f.png?1615528749"},{"address":"0x191c10aa4af7c30e871e70c95db0e4eb77237530","name":"Aave LINK","symbol":"ALINK","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/14315/thumb/aLINK.412c6589.png?1615527827"},{"address":"0xe50fa9b3c56ffb159cb0fca61f5c9d750e8128c8","name":"Aave WETH","symbol":"AWETH","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/17238/thumb/aWETH_2x.png?1626940782"},{"address":"0x078f358208685046a11c85e8ad32895ded33a249","name":"Aave WBTC","symbol":"AWBTC","decimals":8,"logoURI":"https://assets.coingecko.com/coins/images/14244/thumb/aWBTC.41453c2a.png?1615528721"},{"address":"0x6d80113e533a2c0fe82eabd35f1875dcea89ea97","name":"Aave SUSD","symbol":"ASUSD","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/14266/thumb/aSUSD.9b00ffc6.png?1615528241"},{"address":"0xfe8b128ba8c78aabc59d4c64cee7ff28e9379921","name":"Balancer","symbol":"BAL","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/11683/thumb/Balancer.png?1592792958"},{"address":"0x76fb31fb4af56892a25e32cfc43de717950c9278","name":"Aave","symbol":"AAVE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/12645/thumb/AAVE.png?1601374110"},{"address":"0xe4de4b87345815c71aa843ea4841bcdc682637bb","name":"BUILD","symbol":"BUILD","decimals":4,"logoURI":"https://assets.coingecko.com/coins/images/26533/thumb/BUILD.png?1658714842"},{"address":"0x66e8617d1df7ab523a316a6c01d16aa5bed93681","name":"Shack","symbol":"SHACK","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/25699/thumb/shack_no_bg_no_pad3.png?1653441433"},{"address":"0xf899e3909b4492859d44260e1de41a9e663e70f5","name":"RadioShack","symbol":"RADIO","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/25307/thumb/ZVoPiysPJq6dPIZm_Se-6vjmsBepwhHlTQfdYZRILbHyVVTRUYCO-wmJJ4zT10HXCGv1j-ZyWr2u2sBaVlap5Y-ILqeXZuIquWdBDxxG0E0qDpgH7omLqYdgWWLSM_TUK9d1PiiYdu6bERdCDaucgFjlqwmhVQK4uV4jyUiXzchVUnu8Qt6SnxlNxz88G0mQ_tfiwkFv_vKqtgb1CcPycVZVz9.jpg?1651211260"},{"address":"0x3f56e0c36d275367b8c502090edf38289b3dea0d","name":"Qi Dao","symbol":"QI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/15329/thumb/qi.png?1620540969"},{"address":"0x5a5fff6f753d7c11a56a52fe47a177a87e431655","name":"Synapse","symbol":"SYN","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/18024/thumb/synapse_social_icon.png?1663921797"},{"address":"0x6f620ec89b8479e97a6985792d0c64f237566746","name":"WePiggy Coin","symbol":"WPC","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/21914/thumb/WPC200.png?1640262945"},{"address":"0xaf9fe3b5ccdae78188b1f8b9a49da7ae9510f151","name":"dHEDGE DAO","symbol":"DHT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/12508/thumb/dht.png?1600752201"},{"address":"0x375488f097176507e39b9653b88fdc52cde736bf","name":"Tarot V1","symbol":"TAROT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/17881/thumb/tarot-200px.png?1629704943"},{"address":"0x97513e975a7fa9072c72c92d8000b0db90b163c5","name":"Beethoven X","symbol":"BEETS","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/19158/thumb/beets-icon-large.png?1634545465"},{"address":"0xee9801669c6138e84bd50deb500827b776777d28","name":"O3 Swap","symbol":"O3","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/15460/thumb/o3.png?1620904316"},{"address":"0x10010078a54396f62c96df8532dc2b4847d47ed3","name":"Hundred Finance","symbol":"HND","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/18445/thumb/hnd.PNG?1632054703"},{"address":"0x50bce64397c75488465253c0a034b8097fea6578","name":"HanChain","symbol":"HAN","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/27374/thumb/logo_200.png?1663732819"},{"address":"0x00f932f0fe257456b32deda4758922e56a4f4b42","name":"Dope Wars Paper","symbol":"PAPER","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/18166/thumb/EQHGcBO__400x400.jpeg?1663726283"},{"address":"0xa00e3a3511aac35ca78530c85007afcd31753819","name":"Kyber Network Crystal","symbol":"KNC","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/14899/thumb/RwdVsGcw_400x400.jpg?1618923851"},{"address":"0xfdb794692724153d1488ccdbe0c56c252596735f","name":"Lido DAO","symbol":"LDO","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/13573/thumb/Lido_DAO.png?1609873644"},{"address":"0x6fd9d7ad17242c41f7131d257212c54a0e816691","name":"Uniswap","symbol":"UNI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/12504/thumb/uni.jpg?1687143398"},{"address":"0x8c6f28f2f1a3c87f0f938b96d27520d9751ec8d9","name":"sUSD","symbol":"SUSD","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/5013/thumb/sUSD.png?1616150765"},{"address":"0x8700daec35af8ff88c16bdf0418774cb3d7599b4","name":"Synthetix Network","symbol":"SNX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/3406/thumb/SNX.png?1598631139"},{"address":"0xe0bb0d3de8c10976511e5030ca403dbf4c25165b","name":"0xBitcoin","symbol":"0XBTC","decimals":8,"logoURI":"https://assets.coingecko.com/coins/images/4454/thumb/0xbtc.png?1561603765"},{"address":"0xe3c332a5dce0e1d9bc2cc72a68437790570c28a4","name":"BLOCKv","symbol":"VEE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/1266/thumb/blockv.png?1547351380"},{"address":"0x8f69ee043d52161fd29137aedf63f5e70cd504d5","name":"The Doge NFT","symbol":"DOG","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/18111/thumb/Doge.png?1630696110"},{"address":"0x4200000000000000000000000000000000000006","name":"WETH","symbol":"WETH","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/2518/thumb/weth.png?1628852295"},{"address":"0x1da650c3b2daa8aa9ff6f661d4156ce24d08a062","name":"Dentacoin","symbol":"DCN","decimals":0,"logoURI":"https://assets.coingecko.com/coins/images/850/thumb/dentacoin.png?1547034647"},{"address":"0x296f55f8fb28e498b858d0bcda06d955b2cb3f97","name":"Stargate Finance","symbol":"STG","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/24413/thumb/STG_LOGO.png?1647654518"},{"address":"0x9e1028f5f1d5ede59748ffcee5532509976840e0","name":"Perpetual Protocol","symbol":"PERP","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/12381/thumb/60d18e06844a844ad75901a9_mark_only_03.png?1628674771"},{"address":"0xc04fb38f10ad352c5f16bd4546f7456e7f1a2d9e","name":"Minato","symbol":"MNTO","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/24622/thumb/MNTO_200x200.png?1648448664"},{"address":"0xb12c13e66ade1f72f71834f2fc5082db8c091358","name":"Roobee","symbol":"ROOBEE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/8791/thumb/Group_11.png?1580344629"},{"address":"0x3e29d3a9316dab217754d13b28646b76607c5f04","name":"Alchemix ETH","symbol":"ALETH","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/16271/thumb/aleth.png?1685957289"},{"address":"0xdfa46478f9e5ea86d57387849598dbfb2e964b02","name":"MAI","symbol":"MIMATIC","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/15264/thumb/mimatic-red.png?1620281018"},{"address":"0x73cb180bf0521828d8849bc8cf2b920918e23032","name":"Overnight fi USD ","symbol":"USD+","decimals":6,"logoURI":"https://assets.coingecko.com/coins/images/25757/thumb/USD__logo.png?1653519267"},{"address":"0x3e7ef8f50246f725885102e8238cbba33f276747","name":"BarnBridge","symbol":"BOND","decimals":17,"logoURI":"https://assets.coingecko.com/coins/images/12811/thumb/barnbridge.jpg?1602728853"},{"address":"0x00a35fd824c717879bf370e70ac6868b95870dfb","name":"Iron Bank","symbol":"IB","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/22902/thumb/ironbank.png?1642872464"},{"address":"0x1f32b1c2345538c0c6f582fcb022739c4a194ebb","name":"Wrapped stETH","symbol":"WSTETH","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/18834/thumb/wstETH.png?1633565443"},{"address":"0xc5102fe9359fd9a28f877a67e36b0f050d81a3cc","name":"Hop Protocol","symbol":"HOP","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/25445/thumb/hop.png?1665541677"},{"address":"0x0994206dfe8de6ec6920ff4d779b0d950605fb53","name":"Curve DAO","symbol":"CRV","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/12124/thumb/Curve.png?1597369484"},{"address":"0xcb8fa9a76b8e203d8c3797bf438d8fb81ea3326a","name":"Alchemix USD","symbol":"ALUSD","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/14114/thumb/Alchemix_USD.png?1614410406"},{"address":"0xb0b195aefa3650a6908f15cdac7d92f8a5791b0b","name":"BOB","symbol":"BOB","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/27266/thumb/Bob-logo.png?1663073030"},{"address":"0xc40f949f8a4e094d1b49a23ea9241d289b7b2819","name":"Liquity USD","symbol":"LUSD","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/14666/thumb/Group_3.png?1617631327"},{"address":"0xda10009cbd5d07dd0cecc66161fc93d7c9000da1","name":"Dai","symbol":"DAI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/9956/thumb/Badge_Dai.png?1687143508"},{"address":"0x350a791bfc2c21f9ed5d10980dad2e2638ffa7f6","name":"Chainlink","symbol":"LINK","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/877/thumb/chainlink-new-logo.png?1547034700"},{"address":"0xec6adef5e1006bb305bb1975333e8fc4071295bf","name":"Cartesi","symbol":"CTSI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/11038/thumb/Cartesi_Logo.png?1689603517"},{"address":"0x7fb688ccf682d58f86d7e38e03f9d22e7705448b","name":"Rai Reflex Index","symbol":"RAI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/14004/thumb/RAI-logo-coin.png?1613592334"},{"address":"0xe405de8f52ba7559f9df3c368500b6e6ae6cee49","name":"sETH","symbol":"SETH","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/8843/thumb/sETH.png?1616150207"},{"address":"0xf98dcd95217e15e05d8638da4c91125e59590b07","name":"Kromatika","symbol":"KROM","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/20541/thumb/KROM_Transparent.png?1641398421"},{"address":"0x50c5725949a6f0c72e6c4a641f24049a917db0cb","name":"Lyra Finance","symbol":"LYRA","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/21490/thumb/Add-a-heading-26.png?1639364177"},{"address":"0x68f180fcce6836688e9084f035309e29bf0a2095","name":"Wrapped Bitcoin","symbol":"WBTC","decimals":8,"logoURI":"https://assets.coingecko.com/coins/images/7598/thumb/wrapped_bitcoin_wbtc.png?1548822744"},{"address":"0x94b008aa00579c1307b0ef2c499ad98a8ce58e58","name":"Tether","symbol":"USDT","decimals":6,"logoURI":"https://assets.coingecko.com/coins/images/325/thumb/Tether.png?1668148663"},{"address":"0x217d47011b23bb961eb6d93ca9945b7501a5bb11","name":"Thales","symbol":"THALES","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/18388/thumb/CLVZJN_C_400x400.png?1631758808"},{"address":"0xd52f94df742a6f4b4c8b033369fe13a41782bf44","name":"Layer2DAO","symbol":"L2DAO","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/23699/thumb/Khp7Y4Sn.png?1645081048"}]},{"chainId":"420","name":"Optimism Goerli","tokens":[{"address":"0x0000000000000000000000000000000000000000","name":"Goerli Ether","symbol":"ETH","decimals":18,"logoURI":"https://raw.githubusercontent.com/spothq/cryptocurrency-icons/master/svg/color/eth.svg"}]},{"chainId":"42161","name":"Arbitrum One","tokens":[{"address":"0x0000000000000000000000000000000000000000","name":"Ether","symbol":"ETH","decimals":18,"logoURI":"https://arbiscan.io/images/svg/brands/arbitrum.svg"},{"address":"0x1bd013bd089c2b6b2d30a0e0b545810a5844e761","name":"OtterHome","symbol":"HOME","decimals":16,"logoURI":"https://assets.coingecko.com/coins/images/30740/thumb/LOGO.png?1686724589"},{"address":"0x0f96d8c1277bd75a251238af952a7a99db1320e3","name":"GMCash Share","symbol":"GSHARE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29730/thumb/logoABS.ac04548d_2.png?1681093523"},{"address":"0x6fc2680d8ad8e8312191441b4eca9eff8d06b45a","name":"Artichoke","symbol":"CHOKE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30354/thumb/Choke_icon_-_Small.png?1684225563"},{"address":"0xf50874f8246776ca4b89eef471e718f70f38458f","name":"Arbswap","symbol":"ARBS","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30565/thumb/Arb-Logo_Circle_DARK_LOGO_ONLY.png?1685074061"},{"address":"0xf4ac71a71b7b4d95b9f04b603a7b9ed87762d5f3","name":"CatMouseWorld RICE","symbol":"RICE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29946/thumb/favicon200.png?1682327215"},{"address":"0xd1c533a00548dd9c1e7b0f8ea834f65383b116de","name":"MetaPocket","symbol":"MPCKT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31163/thumb/android-chrome-192x192.png?1691049961"},{"address":"0x4c4b907bd5c38d14a084aac4f511a9b46f7ec429","name":"RB Share","symbol":"RBX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29660/thumb/Share_token.png?1680506526"},{"address":"0xbfbcfe8873fe28dfa25f1099282b088d52bbad9c","name":"Equilibria Finance","symbol":"EQB","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30645/thumb/QLLK8pmR_400x400.jpg?1686103901"},{"address":"0xd5954c3084a1ccd70b4da011e67760b8e78aee84","name":"Arbidex","symbol":"ARX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29506/thumb/tokenlogo.png?1679382097"},{"address":"0x6d038130b9b379a373b1d33a29d5904ed1bb9026","name":"Quick Intel","symbol":"QUICKI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29605/thumb/IMG_6589D0616DF1-1.jpeg?1679994169"},{"address":"0x7a2c1b8e26c48a5b73816b7ec826fd4053f5f34b","name":"GoSleep ZZZ","symbol":"ZZZ","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29901/thumb/ZZZ200_200.png?1681984063"},{"address":"0x11f98c7e42a367dab4f200d2fdc460fb445ce9a8","name":"SpartaDEX","symbol":"SPARTA","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30836/thumb/SpartaDex_200x200.jpg?1687769674"},{"address":"0xeee18334c414a47fb886a7317e1885b2bfb8c2a6","name":"Savvy BTC","symbol":"SVBTC","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31004/thumb/logo_%287%29.png?1689655080"},{"address":"0x0b5c6ac0e1082f2d81e829b8c2957886e6bb3994","name":"Prism","symbol":"PRISM","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31081/thumb/download_%2818%29.png?1690356004"},{"address":"0x2f27118e3d2332afb7d165140cf1bb127ea6975d","name":"Gridex","symbol":"GDX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29182/thumb/gridex-token.png?1678773757"},{"address":"0x32e4d98d3010ac12d75019c484caa78665b03986","name":"GBOT","symbol":"GBOT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31429/thumb/fW3tA1ZL_400x400.jpg?1692858996"},{"address":"0x872bad41cfc8ba731f811fea8b2d0b9fd6369585","name":"BattleFly","symbol":"GFLY","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28828/thumb/GFLY_LOGO.png?1675844078"},{"address":"0xc47d9753f3b32aa9548a7c3f30b6aec3b2d2798c","name":"Tender fi","symbol":"TND","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28659/thumb/tenderlogo.png?1673624410"},{"address":"0x847db21ef9de627c23d3dff470af6599b1a30d3f","name":"Black Rabbit AI","symbol":"BRAIN","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28966/thumb/200x200.png?1675745240"},{"address":"0xf1a82bfa7fceb8b8741e7e04a6b8efd348ca6393","name":"ArbShib","symbol":"AISHIB","decimals":6,"logoURI":"https://assets.coingecko.com/coins/images/29945/thumb/200200.jpg?1682405897"},{"address":"0x09e18590e8f76b6cf471b3cd75fe1a1a9d2b2c2b","name":"ArbDoge AI","symbol":"AIDOGE","decimals":6,"logoURI":"https://assets.coingecko.com/coins/images/29852/thumb/photo_2023-04-18_14-25-28.jpg?1681799160"},{"address":"0xa15907f3e7fdd0a83ec56f4ac543cb10f4d783eb","name":"Kewl","symbol":"KEWL","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30534/thumb/Group_599.png?1684892398"},{"address":"0xc7d91ec2b29cd22c45c15760abc189c4e78e8036","name":"Uramaki","symbol":"MAKI","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/28909/thumb/Maki_Logo.png?1675308275"},{"address":"0x232baf8cfc14520140c3686fbab53fa596a50552","name":"Cruize Finance","symbol":"CRUIZE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/26181/thumb/_KjiKgiG_400x400.jpeg?1669111982"},{"address":"0x700e4edb5c7d8f53ccb0cf212b81a121728e1d5b","name":"LOPO","symbol":"LOPO","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/29250/thumb/IMG_20230220_222454_192.png?1677642606"},{"address":"0x640278bada847b7ce71bb22f20517a009a049640","name":"GoSleep NGT","symbol":"NGT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29826/thumb/NGT200_200.png?1681705868"},{"address":"0xce3a75572bc375476438206f6f29f46f8466ecc2","name":"XLSD Coin","symbol":"XLSD","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30747/thumb/Icon-200.png?1686728014"},{"address":"0xce0b3f1258189da17bbd8c7e0509f5f7e001a998","name":"Moon Pepe","symbol":"MPEPE","decimals":6,"logoURI":"https://assets.coingecko.com/coins/images/29891/thumb/Moonpepe_Logo_1x%28200x200%29.png?1681981687"},{"address":"0x982239d38af50b0168da33346d85fb12929c4c07","name":"Arbitrove Governance Token","symbol":"TROVE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29017/thumb/trove.png?1676541888"},{"address":"0xc8ccbd97b96834b976c995a67bf46e5754e2c48e","name":"Parallax","symbol":"PLX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31536/thumb/Parallax_round_logo_-_transparent_bg.png?1693787841"},{"address":"0xe9a5af50874c0ef2748b5db70104b5ccb5557f6d","name":"GMBL COMPUTER CHiP","symbol":"GMBL","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31659/thumb/GMBL.png?1694168380"},{"address":"0x6dd963c510c2d2f09d5eddb48ede45fed063eb36","name":"FactorDAO","symbol":"FCTR","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29018/thumb/FactorLogo.png?1685954655"},{"address":"0x7a5d193fe4ed9098f7eadc99797087c96b002907","name":"Plutus ARB","symbol":"PLSARB","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30636/thumb/plsARB.png?1686019260"},{"address":"0xfb1f65955e168e0ef500b170eed4a4efeb99ae32","name":"LiquiCats","symbol":"MEOW","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28810/thumb/AdZJegQB_400x400.jpg?1674452846"},{"address":"0xfc5a1a6eb076a2c7ad06ed22c90d7e710e35ad0a","name":"GMX","symbol":"GMX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/18323/thumb/arbit.png?1631532468"},{"address":"0x1922c36f3bc762ca300b4a46bb2102f84b1684ab","name":"Compounded Marinated UMAMI","symbol":"CMUMAMI","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/28433/thumb/Cqx8QjSL_400x400.jpeg?1670564068"},{"address":"0xde31e75182276738b0c025daa8f80020a4f2fbfe","name":"Honey Pot BeeKeepers","symbol":"HONEY","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/18380/thumb/ac6fTCfDQDIV.jpg?1631695015"},{"address":"0xbbea044f9e7c0520195e49ad1e561572e7e1b948","name":"Mizar","symbol":"MZR","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/23272/thumb/V1DTptkT_400x400.jpg?1678424217"},{"address":"0xb49b6a3fd1f4bb510ef776de7a88a9e65904478a","name":"Arbitrove ALP","symbol":"ALP","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30769/thumb/alp.jpg?1686904470"},{"address":"0xd6e7c8af05d2d06a76811d44917613bdd258b995","name":"Brr Protocol","symbol":"BRR","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29558/thumb/BRR_Protocol.png?1679644136"},{"address":"0x319e222de462ac959baf2aec848697aec2bbd770","name":"OreoSwap","symbol":"OREO","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28582/thumb/oreoswapx.png?1671958777"},{"address":"0xaa54e84a3e6e5a80288d2c2f8e36ea5ca3a3ca30","name":"Sharbi","symbol":"SHARBI","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/29075/thumb/WhatsApp_Image_2023-01-25_at_12.08.22_PM-removebg-1.png?1676436684"},{"address":"0xc701f86e6d242b97d3035f6c2cecaf8e7087e898","name":"RunBlox  Arbitrum ","symbol":"RUX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29766/thumb/sh5z8C-0_400x400.jpg?1681194047"},{"address":"0xd5da32ad4c7510457c0e46fa4332f75f6c4c4dc0","name":"AutoEarn Token","symbol":"ATE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30938/thumb/ATE_logo.jpg?1689082964"},{"address":"0xafa5676a6ef790f08290dd4a45e0ec2a5cc5cdab","name":"Cat   Mouse","symbol":"CATMOUSE","decimals":0,"logoURI":"https://assets.coingecko.com/coins/images/29947/thumb/favicon200.png?1682327275"},{"address":"0xd2568accd10a4c98e87c44e9920360031ad89fcb","name":"3xcalibur Ecosystem Token","symbol":"XCAL","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28134/thumb/XCAL_Logo.png?1667719684"},{"address":"0x912ce59144191c1204e64559fe8253a0e49e6548","name":"Arbitrum","symbol":"ARB","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/16547/thumb/photo_2023-03-29_21.47.00.jpeg?1680097630"},{"address":"0xfc0c4114ccba4a91d05bdab4a8480cbec46654dd","name":"RB Finance","symbol":"RB","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29623/thumb/Main_token.png?1680078266"},{"address":"0x9e724698051da34994f281bd81c3e7372d1960ae","name":"Ascension Protocol","symbol":"ASCEND","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/16019/thumb/icon200.png?1622612188"},{"address":"0x748b5be12ac1ce2ef73035189f943591c1822b7d","name":"MetaLine Gold","symbol":"MTG","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30494/thumb/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20230520183429%281%29.png?1684721348"},{"address":"0xb3180df05e46f9fcdd589a2023470a9007df01ca","name":"Chibi Finance","symbol":"CHIBI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30818/thumb/chibi_no_bg.jpg?1687749870"},{"address":"0x5f320aae9b786a9f329a39e41a74e88e14783067","name":"PEPEX","symbol":"PEPEX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30028/thumb/COIN.png?1682584785"},{"address":"0x83d6c8c06ac276465e4c92e7ac8c23740f435140","name":"HMX","symbol":"HMX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31206/thumb/HMXlogo_CG.png?1691381608"},{"address":"0xaf5db6e1cc585ca312e8c8f7c499033590cf5c98","name":"Arken Finance","symbol":"ARKEN","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/26137/thumb/arken.png?1678783976"},{"address":"0x3e6b3021dab44debf93091030dbfcbdf52464afe","name":"ArbiTen","symbol":"ARBITEN","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29799/thumb/arbiten_logo_200.png?1681348539"},{"address":"0xa684cd057951541187f288294a1e1c2646aa2d24","name":"Vesta Finance","symbol":"VSTA","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/23306/thumb/vesta-finance.png?1643692530"},{"address":"0xcb6460d56825ddc12229c7a7d94b6b26a9f9c867","name":"DefiTankLand","symbol":"DFTL","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29136/thumb/tank_%282%29.png?1676962439"},{"address":"0x7241bc8035b65865156ddb5edef3eb32874a3af6","name":"Jones GLP","symbol":"JGLP","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28892/thumb/hatGLP.png?1675157548"},{"address":"0x7f90122bf0700f9e7e1f688fe926940e8839f353","name":"Curve fi USDC USDT","symbol":"2CRV","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28365/thumb/curve2.png?1669881651"},{"address":"0x8a66794e1aaebc7018a7b75f61f384e30ae3b159","name":"BlueSale","symbol":"BLS","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30300/thumb/logo_BLS_200_bg.png?1690274850"},{"address":"0xf40f19cafaaa25bf9b52134646c6e325e76e0e93","name":"GLSD Coin","symbol":"GLSD","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30875/thumb/Icon-200.png?1688375787"},{"address":"0x40301951af3f80b8c1744ca77e55111dd3c1dba1","name":"The Ennead","symbol":"NEADRAM","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29748/thumb/Ennead.png?1681110419"},{"address":"0x45d780cfe839b8a8f292c9e26aa5d1805bc536dc","name":"Zoci","symbol":"ZOCI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31809/thumb/200x.png?1695202768"},{"address":"0xc8a1c0d8255bc2eb5f6236e119e3428fd0c33a74","name":"ArbiTen 10SHARE","symbol":"10SHARE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29798/thumb/arbiten-s-200.png?1681348488"},{"address":"0xb1070c40d5b3d10e1f1c8876c3d2ff5ffed4b3ac","name":"FengLvZiV2","symbol":"FENGLVZIV2","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30324/thumb/logo.png?1684119145"},{"address":"0x65c936f008bc34fe819bce9fa5afd9dc2d49977f","name":"Y2K","symbol":"Y2K","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28542/thumb/l7jRo-5-_400x400.jpg?1671585317"},{"address":"0xc56dc613c8ef3c57314171d73eaefe87aa469186","name":"TLSD Coin","symbol":"TLSD","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30748/thumb/Icon-200.png?1686728108"},{"address":"0x80dd74145b8bb10cef01bf914f796bd8b54d7809","name":"Hepton","symbol":"HTE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30274/thumb/HTECoingecko.png?1683781091"},{"address":"0xf236ea74b515ef96a9898f5a4ed4aa591f253ce1","name":"Plutus DPX","symbol":"PLSDPX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29652/thumb/plsDPX.png?1685070920"},{"address":"0xfc1e18fd211314900cb506993b9b14ec72e3f574","name":"Arb Furbo","symbol":"FARB","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30200/thumb/vDg0AKfN_400x400.jpg?1683615303"},{"address":"0x1f6e4b5ffc94cca08cf6bb1479148d6329d4baf5","name":"Ether Wars","symbol":"WAR","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30665/thumb/l_logo_blue.png?1686187610"},{"address":"0x93c157932e5649e794df8999714af8690226a1c9","name":"Dragon Arena","symbol":"DRA","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30156/thumb/da.jpeg?1683518601"},{"address":"0xb5a628803ee72d82098d4bcaf29a42e63531b441","name":"Unstoppable DeFi","symbol":"UND","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29819/thumb/und.png?1684417798"},{"address":"0xb4e3eeec43ebc04f28d31f2c021d15e9f56f0e54","name":"MAW","symbol":"MAW","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31152/thumb/MAW._LOGO.png?1691037847"},{"address":"0x547c669cbbf746652e19f4686716763c8dba703f","name":"Open Meta Trade","symbol":"OMT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29494/thumb/OMT_Token_Logo_200x200.png?1679291742"},{"address":"0x02150e97271fdc0d6e3a16d9094a0948266f07dd","name":"Hamachi Finance","symbol":"HAMI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28783/thumb/icon.png?1674195898"},{"address":"0x1605bbdab3b38d10fa23a7ed0d0e8f4fea5bff59","name":"Plutus RDNT","symbol":"PLSRDNT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30635/thumb/plsRDNT.png?1686018355"},{"address":"0xe66998533a1992ece9ea99cdf47686f4fc8458e0","name":"Jones USDC","symbol":"JUSDC","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28893/thumb/jUSDC.png?1675157687"},{"address":"0xbcad8e85669a3fc9ea9b5d692bd8bdcc2464df31","name":"Goldbank","symbol":"GB","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30563/thumb/200x200.jpg?1685069694"},{"address":"0x0d8f04522c5792c7378e39c92ab348f315f4fc4f","name":"AIENGLISH","symbol":"AIEN","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30291/thumb/200.png?1683866512"},{"address":"0xf387359fab862eaef4b7c03d2174755918c58d4d","name":"Yogi","symbol":"YOGI","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/29596/thumb/YOGI.png?1679892193"},{"address":"0x54355cc6913b26a15cca1f820cf17d362fa65db5","name":"SolidLizard synthetic USD","symbol":"SLZUSDC","decimals":6,"logoURI":"https://assets.coingecko.com/coins/images/29900/thumb/slzUSDC2.png?1681983868"},{"address":"0x4e1b1c450cebc7a4e1561e8edd99a8c650dfb1a9","name":"Arbisphere Launchpad","symbol":"ARSH","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29653/thumb/200x200.png?1680493672"},{"address":"0x51b902f19a56f0c8e409a34a215ad2673edf3284","name":"NFTEarth","symbol":"NFTE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29116/thumb/20230223_224134.jpg?1677224110"},{"address":"0x3a74a9032f731d504f10e02d7247d23b939ea4f6","name":"CEX AI","symbol":"CEX-AI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29231/thumb/200x200_black.png?1677543400"},{"address":"0xc614d40998dc18e51d4070756c9112c0dc8374e1","name":"CryptoZOON ARB","symbol":"ZOON","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30886/thumb/2023-07-01_17.38.30.jpg?1688520986"},{"address":"0x954ac1c73e16c77198e83c088ade88f6223f3d44","name":"LeverageInu","symbol":"LEVI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28147/thumb/IMG_20221107_091938_841.png?1667896989"},{"address":"0xec13336bbd50790a00cdc0feddf11287eaf92529","name":"gmUSD","symbol":"GMUSD","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30345/thumb/Logo.jpg?1684196823"},{"address":"0xb21be1caf592a5dc1e75e418704d1b6d50b0d083","name":"MIND Games CORTEX","symbol":"CRX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29446/thumb/CRX200x200.png?1678867314"},{"address":"0xcb24b141ecaaad0d2c255d6f99d6f4790546a75c","name":"Exponential Capital","symbol":"EXPO","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29646/thumb/expo_capital.jpg?1680484046"},{"address":"0xb2dcbd5258a22385240e4ac13fc6726b66f0de96","name":"ZenithSwap","symbol":"ZSP","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29658/thumb/zenithswaplogo.png?1680573781"},{"address":"0xee9857de0e55d4a54d36a5a5a73a15e57435fdca","name":"AsgardX","symbol":"ODIN","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29157/thumb/IMG_20230222_053621_351.jpg?1677039274"},{"address":"0x5575552988a3a80504bbaeb1311674fcfd40ad4b","name":"Sperax","symbol":"SPA","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/12232/thumb/sperax_logo.jpg?1598342904"},{"address":"0x635d0e13f98e107cf6c5cdfbf52c19843f87e76a","name":"Dominator Domains","symbol":"DOMDOM","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29731/thumb/IMG_20230406_230429_102.jpg?1681093734"},{"address":"0x2c110867ca90e43d372c1c2e92990b00ea32818b","name":"Stabilize","symbol":"STBZ","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/12753/thumb/icon.png?1608771101"},{"address":"0xa0df47432d9d88bcc040e9ee66ddc7e17a882715","name":"Ripae pETH","symbol":"PETH","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29121/thumb/pETH.png?1676787291"},{"address":"0x654c908305021b2eaf881cee774ece1d2bcac5fc","name":"GMCash","symbol":"GMC","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29722/thumb/Token.png?1680848723"},{"address":"0x580e933d90091b9ce380740e3a4a39c67eb85b4c","name":"GameSwift","symbol":"GSWIFT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30949/thumb/GameSwift_Token.png?1689214020"},{"address":"0x9eb6299e4bb6669e42cb295a254c8492f67ae2c6","name":"The Bet","symbol":"BET","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29545/thumb/200.png?1679560843"},{"address":"0x34772c4d12f288368aa35ae7bc527a6b2b3e8906","name":"Monopoly Layer 3 POLY","symbol":"POLY","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30758/thumb/ZkdFe8ym_400x400.jpg?1686823094"},{"address":"0xab9ec601b82a22fbf2b030ac0dd7c1c34f52fa04","name":"1minBET","symbol":"1MB","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29606/thumb/CGK.png?1679994481"},{"address":"0xef261714f7e5ba6b86f4780eb6e3bf26b10729cf","name":"White Lotus","symbol":"LOTUS","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30206/thumb/logo2.png?1683617014"},{"address":"0x3006e4cc90440c7d011c20f36c841a269ae6601a","name":"Nuclear Waste Water","symbol":"NCWW","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31544/thumb/IMG_20230830_084557.jpg?1693793159"},{"address":"0x9925130735a30cae869230a9f19eedbaa71a2c02","name":"Horny Hyenas","symbol":"HORNY","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28979/thumb/horny.png?1675757395"},{"address":"0xdb0c6fc9e01cd95eb1d3bbae6689962de489cd7b","name":"Dsquared finance","symbol":"DSQ","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29016/thumb/dsquared.finance.jpg?1675944769"},{"address":"0x50e401255275dc405a99d3281f396cca681eea9d","name":"Kortana","symbol":"KORA","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30966/thumb/Logo_Kortana_Redondo-4_%281%29.png?1689240173"},{"address":"0x0a1694716de67c98f61942b2cab7df7fe659c87a","name":"Crescentswap Moonlight","symbol":"MNLT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30687/thumb/Untitled_design_%282%29.png?1686275892"},{"address":"0x17afc249db786fc300f2d26381fec5cf0c3913fb","name":"Shiba Cartel","symbol":"PESOS","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/29512/thumb/Shiba_cartel.jpeg?1679384590"},{"address":"0x22ab6bc52cad84aae84bd5781258677a6e0cfab0","name":"ELSD Coin","symbol":"ELSD","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30746/thumb/Icon-200.png?1686727929"},{"address":"0xf202ab403cd7e90197ec0f010ee897e283037706","name":"Savvy USD","symbol":"SVUSD","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31006/thumb/logo_%289%29.png?1689655293"},{"address":"0xd3f1da62cafb7e7bc6531ff1cef6f414291f03d3","name":"Doubloon","symbol":"DBL","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/23660/thumb/galleon-sky.png?1651744892"},{"address":"0x07dd5beaffb65b8ff2e575d500bdf324a05295dc","name":"ArbiPad","symbol":"ARBI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30275/thumb/ARBI_Logo.png?1684141736"},{"address":"0x417a1afd44250314bffb11ff68e989775e990ab6","name":"Volta Protocol","symbol":"VOLTA","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29130/thumb/real_VoltaLogo.png?1678849220"},{"address":"0xc136e6b376a9946b156db1ed3a34b08afdaed76d","name":"CreDA","symbol":"CREDA","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/22551/thumb/gZ4EgSXD_400x400.jpg?1642053045"},{"address":"0x810cf1757b51963102e0b4fe9fdfcdf749dea98a","name":"Sanctum Coin","symbol":"SANCTA","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30135/thumb/image_%289%29.png?1683273456"},{"address":"0x1e3c6c53f9f60bf8aae0d7774c21fa6b1afddc57","name":"xShrap","symbol":"XSHRAP","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29346/thumb/xshrapnel.png?1678253037"},{"address":"0x2c093f7d7db41057a2ddd3cb1ad8b4e9c3dffbec","name":"USDEX ","symbol":"USDEX+","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30670/thumb/USDEX_-icon-200x200.png?1686210121"},{"address":"0x894a3abb764a0ef5da69c62336ac3c15b88bf106","name":"Chunks","symbol":"CHUNKS","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30163/thumb/Chunks_Logo_v2_200x200.png?1683528710"},{"address":"0x85667409a723684fe1e57dd1abde8d88c2f54214","name":"MagicGLP","symbol":"MAGICGLP","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29071/thumb/Token-mGLP.png?1676396985"},{"address":"0x53bcf6698c911b2a7409a740eacddb901fc2a2c6","name":"Kabosu  Arbitrum ","symbol":"KABOSU","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30320/thumb/IMG_20230510_204814_554_copy_200x200.jpg?1684114905"},{"address":"0x2ef61fbe7adc237611e847e9bee5ed1a401fd854","name":"Roller","symbol":"ROLL","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29765/thumb/Roller.png?1681193325"},{"address":"0x986a3db4317177b4f84b05127e9e39a7abd7187a","name":"CatKing","symbol":"CKING","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29373/thumb/64060a800f39c27aa37e242d_256_photo_2023-02-06_18.56.14_Y.png?1678350624"},{"address":"0x73ed68b834e44096eb4bea6edead038c945722f1","name":"Sharky Swap","symbol":"SHARKY","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29152/thumb/SharkySwapPNG.png?1676972639"},{"address":"0xff970a61a04b1ca14834a43f5de4533ebddb5cc8","name":"Bridged USD Coin  Arbitrum ","symbol":"USDCE","decimals":6,"logoURI":"https://assets.coingecko.com/coins/images/30691/thumb/usdc.png?1686280970"},{"address":"0xb98058640970d8aa7bbce3b067b2d63c14143786","name":"Baby Arbitrum","symbol":"BARB","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29671/thumb/BabyArbitrum200x200.png?1680574625"},{"address":"0x3082cc23568ea640225c2467653db90e9250aaa0","name":"Radiant Capital","symbol":"RDNT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/26536/thumb/Radiant-Logo-200x200.png?1658715865"},{"address":"0x842216e0aa2ae608699f7b1063f26ce6b30c5311","name":"UrDEX Finance","symbol":"URD","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29970/thumb/UrDEXLogo.png?1682393181"},{"address":"0xab10645297d5b2b124523b5181df2e8815190aeb","name":"Forge","symbol":"FORGE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29768/thumb/logo_200x200.png?1681196307"},{"address":"0x97d4a4d04f41b4f958290bfdda45c1f3db4adda3","name":"Fortune Cookie","symbol":"FCT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29589/thumb/CNjBnZ-6_400x400.jpg?1679885737"},{"address":"0x3789be915951e0f0a676588c99e7357d3fdb586b","name":"Party Dice","symbol":"DICE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29778/thumb/cgdice.png?1681277715"},{"address":"0x500756c7d239aee30f52c7e52af4f4f008d1a98f","name":"Petroleum OIL","symbol":"OIL","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28350/thumb/OIL_200.png?1669770894"},{"address":"0xd2eb76feff5fbd549ca078908fb5efce7533a09d","name":"TronAI","symbol":"TAI","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/29117/thumb/100.png?1676713346"},{"address":"0x8933fedd98cbb482e27c41e1bd7216a4e42ebd39","name":"PegasusBot","symbol":"PGS","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31306/thumb/baneer8.png?1692345300"},{"address":"0x4fc2a3fb655847b7b72e19eaa2f10fdb5c2addbe","name":"Pepe Governance Token","symbol":"PEG","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30150/thumb/PEG-token-200px.png?1683516033"},{"address":"0x29c1ea5ed7af53094b1a79ef60d20641987c867e","name":"Acid","symbol":"ACID","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/29418/thumb/acid_200_200.png?1678696816"},{"address":"0x2e516ba5bf3b7ee47fb99b09eadb60bde80a82e0","name":"aEGGS","symbol":"AEGGS","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29520/thumb/aeggs.png?1679452069"},{"address":"0x1b8d516e2146d7a32aca0fcbf9482db85fd42c3a","name":"AlphaScan","symbol":"ASCN","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31180/thumb/AlphaScan_logo.jpg?1691122269"},{"address":"0x2c852d3334188be136bfc540ef2bb8c37b590bad","name":"MagicLand","symbol":"MAGIC","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/18844/thumb/logo_-_2021-10-07T141625.399.png?1633587397"},{"address":"0xe2db86ce824cf3dcc0c31a073de294239fdde060","name":"OMO Exchange","symbol":"OMO","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29270/thumb/omo.png?1677735669"},{"address":"0x2cab3abfc1670d1a452df502e216a66883cdf079","name":"Layer2DAO","symbol":"L2DAO","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/23699/thumb/Khp7Y4Sn.png?1645081048"},{"address":"0x67c31056358b8977ea95a3a899dd380d4bced706","name":"ETHforestAI","symbol":"ETHFAI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29515/thumb/ethfai_logo.png?1679393754"},{"address":"0x4305c4bc521b052f17d389c2fe9d37cabeb70d54","name":"Overlay Protocol","symbol":"OVL","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28507/thumb/OVL-black-white-bkgr.png?1674805812"},{"address":"0x51318b7d00db7acc4026c88c3952b66278b6a67f","name":"PlutusDAO","symbol":"PLS","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/25326/thumb/M6nUndNU_400x400.jpg?1651233987"},{"address":"0x10393c20975cf177a3513071bc110f7962cd67da","name":"Jones DAO","symbol":"JONES","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/23290/thumb/3c8c2ed8-afb3-4b67-9937-5493acd88b50.jpg?1648597625"},{"address":"0xc19669a405067927865b40ea045a2baabbbe57f5","name":"Star","symbol":"STAR","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31277/thumb/STAR.png?1692152883"},{"address":"0x1622bf67e6e5747b81866fe0b85178a93c7f86e3","name":"Umami","symbol":"UMAMI","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/21159/thumb/_UMAMI-200px.jpg?1666844492"},{"address":"0x50aa7a13b28eea97dc6c3f5e8aaa7fe512e7306d","name":"XBlue Finance","symbol":"XB","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29375/thumb/photo_2023-03-04_15-07-08.png?1678419109"},{"address":"0x816e21c33fa5f8440ebcdf6e01d39314541bea72","name":"LiquidDriver","symbol":"LQDR","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/15782/thumb/LQDR_Glowing_Icon.png?1631200053"},{"address":"0xbcc9c1763d54427bdf5efb6e9eb9494e5a1fbabf","name":"Honor World Token","symbol":"HWT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28559/thumb/hwt.png?1671706521"},{"address":"0x6609be1547166d1c4605f3a243fdcff467e600c3","name":"Neutra Finance","symbol":"NEU","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28813/thumb/NEU_Token_logo.png?1674455093"},{"address":"0x493070ef5280e7a275a106a30b0414dbdb21febd","name":"AI Supreme","symbol":"AISP","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/30900/thumb/200.png?1688549201"},{"address":"0x6bb7a17acc227fd1f6781d1eedeae01b42047ee0","name":"LEXER Markets","symbol":"LEX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29888/thumb/LEX.png?1681981030"},{"address":"0x1459e51b1ada43aaabb7c22c262bdffd122e1296","name":"ArbiGoat","symbol":"AGT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29693/thumb/cg.png?1680673156"},{"address":"0x3d9907f9a368ad0a51be60f7da3b97cf940982d8","name":"Camelot Token","symbol":"GRAIL","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28416/thumb/vj5DIMhP_400x400.jpeg?1670457013"},{"address":"0x43ab8f7d2a8dd4102ccea6b438f6d747b1b9f034","name":"Savvy","symbol":"SVY","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31253/thumb/SAVVY.png?1692758681"},{"address":"0x4cfa50b7ce747e2d61724fcac57f24b748ff2b2a","name":"Fluid USDC","symbol":"FUSDC","decimals":6,"logoURI":"https://assets.coingecko.com/coins/images/28471/thumb/fUSDC-200x200.png?1671002126"},{"address":"0x7ddf25cb4861590578f1fb85fcf1c5afd00a01de","name":"PEPER","symbol":"PEPER","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30603/thumb/peper_logo.jpg?1685516540"},{"address":"0xd2f8b81cfff297c70e5d58ac58762dd5d213ea20","name":"artGPT","symbol":"AGPT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29111/thumb/IMG_20230217_063445_776.png?1677126652"},{"address":"0xee0b14e8fc86691cf6ee42b9954985b4cf968534","name":"ZenPandaCoin","symbol":"ZPC","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30269/thumb/panda.png?1683777031"},{"address":"0xe6be2f5ab2ad4b8b146e3008f81832cf7b279f43","name":"ToxicGarden finance SEED","symbol":"SEED","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30736/thumb/SEED200x200.png?1686722246"},{"address":"0x51f9f9ff6cb2266d68c04ec289c7aba81378a383","name":"iGameS","symbol":"IGS","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31416/thumb/igs_logo.png?1692848933"},{"address":"0x42972edecd94bdd19a622a6a419bdded2de56e08","name":"Wonderly Finance","symbol":"AFX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28973/thumb/afx.png?1675748753"},{"address":"0x077bc655c8d81b7de71c79318d0eb8f987e12820","name":"Yuri","symbol":"YURI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31032/thumb/Yuri_logo_200x200.jpg?1689839862"},{"address":"0xf16585365bfe050eff7c926f22df87f46da2cafe","name":"Adv3nture xyz Gold","symbol":"GOLD","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29126/thumb/gold.png?1676947304"},{"address":"0x9ed7e4b1bff939ad473da5e7a218c771d1569456","name":"Reunit Wallet","symbol":"REUNI","decimals":6,"logoURI":"https://assets.coingecko.com/coins/images/29492/thumb/reunit_200.png?1679280627"},{"address":"0x1f52145666c862ed3e2f1da213d479e61b2892af","name":"Funny Coin","symbol":"FUC","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30081/thumb/fuc.png?1683016112"},{"address":"0xb4b07b60455a2f38cba98a8f3dd161f7ca396a9c","name":"Onchain Trade Protocol","symbol":"OT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29133/thumb/OTCMC.png?1676958182"},{"address":"0xb4bbfe92702730ef7f1d28e4b9e42381182f48a5","name":"Hold VIP","symbol":"HOLD","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30129/thumb/RteOSWQ__400x400.jpg?1683261669"},{"address":"0x3a0a3f724094407ac332f98ddb405a11afe609d2","name":"PufDAO","symbol":"PUF","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29868/thumb/A3A24BB6-7087-408B-A889-C44ECE47FB0B.jpeg?1681892046"},{"address":"0x7ca0b5ca80291b1feb2d45702ffe56a7a53e7a97","name":"Radiate Protocol","symbol":"RADT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30925/thumb/RDAT_transparent_noglow.png?1688961972"},{"address":"0x05d35769a222affd6185e20f3f3676abde56c25f","name":"Unlimited Network Token","symbol":"UWU","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30829/thumb/_UWU_new_logo.png?1689737977"},{"address":"0x0d111e482146fe9ac9ca3a65d92e65610bbc1ba6","name":"plsSPA","symbol":"PLSSPA","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30552/thumb/plsSPA.png?1685000417"},{"address":"0x8b0e6f19ee57089f7649a455d89d7bc6314d04e8","name":"Dream Machine Token","symbol":"DMT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30505/thumb/dmt.png?1684821418"},{"address":"0x4406509b532b111bd39b5b579561001cbf0d7acf","name":"Antspace","symbol":"ANT","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/30464/thumb/fb0d911c2ac181aed2bc06dc9862ab3.png?1684663590"},{"address":"0x8616e8ea83f048ab9a5ec513c9412dd2993bce3f","name":"handleUSD","symbol":"FXUSD","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/26954/thumb/fxUSDlogo.png?1677465474"},{"address":"0x1772d876f9df830693b8004322cb8885b77e47e5","name":"AuradX","symbol":"DALLE2","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29511/thumb/200_pix.png?1679383984"},{"address":"0xff191514a9baba76bfd19e3943a4d37e8ec9a111","name":"Auragi","symbol":"AGI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29784/thumb/Auragi_Logo.png?1681286705"},{"address":"0xfc77b86f3ade71793e1eec1e7944db074922856e","name":"Mugen Finance","symbol":"MGN","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/27340/thumb/Group_2915.jpg?1663549948"},{"address":"0xd77b108d4f6cefaa0cae9506a934e825becca46e","name":"WINR Protocol","symbol":"WINR","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29340/thumb/WINR.png?1679561562"},{"address":"0x033f193b3fceb22a440e89a2867e8fee181594d9","name":"Rodeo Finance","symbol":"RDO","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30905/thumb/RDO_ticker_logo_-_color-01-01.png?1688622901"},{"address":"0x62cffe9917790edd44fbc36a76cb8e4920bd1268","name":"Twister Finance","symbol":"TWST","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30330/thumb/unnamed.jpg?1684232574"},{"address":"0xdc8184ba488e949815d4aafb35b3c56ad03b4179","name":"Roseon","symbol":"ROSX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29698/thumb/roseon.png?1680736074"},{"address":"0xccd05a0fcfc1380e9da27862adb2198e58e0d66f","name":"ANIMA","symbol":"ANIMA","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30377/thumb/anima_logo_yellow.png?1684298625"},{"address":"0xea1e79d4a0d347edcadd78d98a7da65d15e8cba1","name":"RocketVerse","symbol":"RKV","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30004/thumb/RVK.jpg?1682496217"},{"address":"0x602eb0d99a5e3e76d1510372c4d2020e12eaea8a","name":"TridentDAO","symbol":"PSI","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/28955/thumb/trident.jpg?1675689110"},{"address":"0x655a6beebf2361a19549a99486ff65f709bd2646","name":"LilAI","symbol":"LILAI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30621/thumb/LogoLilai_CoinGecko.png?1685772677"},{"address":"0x4c70d32295de15fdf302d3bcbb7fc2631ace1c91","name":"LSDoge","symbol":"LSDOGE","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/29999/thumb/LSDoge_200_200.png?1682473086"},{"address":"0xfac38532829fdd744373fdcd4708ab90fa0c4078","name":"tLPT","symbol":"TLPT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/26972/thumb/tenderLPT.png?1661152923"},{"address":"0xb2498cde54810424a24fdd23579164265a0c14c5","name":"Taikula Coin","symbol":"TAIKULA","decimals":6,"logoURI":"https://assets.coingecko.com/coins/images/30265/thumb/8MV4Pr9j_400x400.png?1683774968"},{"address":"0xeca66820ed807c096e1bd7a1a091cd3d3152cc79","name":"Ghast","symbol":"GHA","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30497/thumb/gha.png?1684724366"},{"address":"0xd3934a2e428e31ffc14b1f69b0bec79db3e0c614","name":"Concentric fi","symbol":"CONE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31713/thumb/cone_logo_small.png?1694580221"},{"address":"0x5fd71280b6385157b291b9962f22153fc9e79000","name":"Garbi Protocol","symbol":"GRB","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29142/thumb/garbi.png?1676963839"},{"address":"0x2c7513f299778a84797f293503db1a73a15fd48d","name":"OpenbetAI","symbol":"OPENBET","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29774/thumb/openbetlogo200x200.png?1681266627"},{"address":"0x5326e71ff593ecc2cf7acae5fe57582d6e74cff1","name":"plvGLP","symbol":"PLVGLP","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30554/thumb/plvGLP.png?1685005757"},{"address":"0x9c8ef67c9168587134e1f29a71405dc753500a45","name":"Legends Token","symbol":"LG","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30079/thumb/004_%281%29.png?1683015379"},{"address":"0x1eb747cace61eab366c98a18617b7e210d03818e","name":"Hood AI","symbol":"HOOD","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30981/thumb/HOOD_LOGO_200X200.jpg?1689323024"}]},{"chainId":"100","name":"Gnosis","tokens":[{"address":"0x0000000000000000000000000000000000000000","name":"xDAI","symbol":"XDAI","decimals":18,"logoURI":"https://gnosisscan.io/token/images/gnosans_32.png"},{"address":"0x5df8339c5e282ee48c0c7ce8a7d01a73d38b3b27","name":"Token Engineering Commons","symbol":"TEC","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/18233/thumb/72481541.png?1643198626"},{"address":"0x71850b7e9ee3f13ab46d67167341e4bdc905eef9","name":"Honey","symbol":"HNY","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/12895/thumb/hnys.png?1614100588"},{"address":"0x3a3e9715018d80916740e8ac300713fdf6614d19","name":"hiveWater","symbol":"HIVEWATER","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30424/thumb/hivewater_transparent.png?1684397277"},{"address":"0x38fb649ad3d6ba1113be5f57b927053e97fc5bf7","name":"xDai Native Comb","symbol":"XCOMB","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/16012/thumb/logo.png?1622603137"},{"address":"0xb5d592f85ab2d955c25720ebe6ff8d4d1e1be300","name":"Particle","symbol":"PRTCLE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/14395/thumb/unknown.png?1648702694"},{"address":"0x3a97704a1b25f08aa230ae53b352e2e72ef52843","name":"Agave","symbol":"AGVE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/14146/thumb/agve.png?1614659384"},{"address":"0x63e62989d9eb2d37dfdb1f93a22f063635b07d51","name":"Minerva Wallet","symbol":"MIVA","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/14732/thumb/MIVA-Token_200x200.png?1617958701"},{"address":"0x4291f029b9e7acb02d49428458cf6fceac545f81","name":"1Hive Water","symbol":"WATER","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/26089/thumb/water_logo.png?1655778743"},{"address":"0xe91d153e0b41518a2ce8dd3d7944fa863463a97d","name":"Wrapped XDAI","symbol":"WXDAI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/14584/thumb/wrapped-xdai-logo.png?1641888881"},{"address":"0x18e9262e68cc6c6004db93105cc7c001bb103e49","name":"Raid","symbol":"RAID","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/18133/thumb/raid_200_oswlvz.png?1630631876"},{"address":"0x48b1b0d077b4919b65b4e4114806dd803901e1d9","name":"Etherisc DIP","symbol":"DIP","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/4586/thumb/dip.png?1547039863"},{"address":"0x4537e328bf7e4efa29d05caea260d7fe26af9d74","name":"Uniswap","symbol":"UNI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/12504/thumb/uni.jpg?1687143398"},{"address":"0xdfc20ae04ed70bd9c7d720f449eedae19f659d65","name":"Badger DAO","symbol":"BADGER","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/13287/thumb/badger_dao_logo.jpg?1607054976"},{"address":"0x6a8cb6714b1ee5b471a7d2ec4302cb4f5ff25ec2","name":"Energy Web","symbol":"EWT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/10886/thumb/R9gQTJV__400x400.png?1585604557"},{"address":"0x07279343ce61c11cb091142c8a20a1f8194d0ca8","name":"Zenland","symbol":"ZENF","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29477/thumb/tokenicon200px.png?1679130231"},{"address":"0xbf65bfcb5da067446cee6a706ba3fe2fb1a9fdfd","name":"yearn finance","symbol":"YFI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/11849/thumb/yearn.jpg?1687142705"},{"address":"0x524b969793a64a602342d89bc2789d43a016b13a","name":"Donut","symbol":"DONUT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/7538/thumb/Donut.png?1548234345"},{"address":"0xddafbb505ad214d7b80b1f830fccc89b60fb7a83","name":"USDC","symbol":"USDC","decimals":6,"logoURI":"https://assets.coingecko.com/coins/images/6319/thumb/usdc.png?1695374272"},{"address":"0xb0c5f3100a4d9d9532a4cfd68c55f1ae8da987eb","name":"DAOhaus","symbol":"HAUS","decimals":35,"logoURI":"https://assets.coingecko.com/coins/images/14551/thumb/jN3kkqke_400x400.png?1616990048"},{"address":"0x8c88ea1fd60462ef7004b9e288afcb4680a3c50c","name":"0xMonero","symbol":"0XMR","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/11035/thumb/0xmnr.PNG?1587357680"},{"address":"0x58b9cb810a68a7f3e1e4f8cb45d1b9b3c79705e8","name":"Connext","symbol":"NEXT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31293/thumb/connext.png?1692331440"},{"address":"0x84e2c67cbefae6b5148fca7d02b341b12ff4b5bb","name":"Swash","symbol":"SWASH","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/18774/thumb/swash.png?1634089759"},{"address":"0x21a42669643f45bc0e086b8fc2ed70c23d67509d","name":"ShapeShift FOX","symbol":"FOX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/9988/thumb/FOX.png?1574330622"},{"address":"0x2d5563da42b06fbbf9c67b7dc073cf6a7842239e","name":"Jarvis Synthetic Swiss Franc","symbol":"JCHF","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/15727/thumb/jCHF.png?1634046084"},{"address":"0x532801ed6f82fffd2dab70a19fc2d7b2772c4f4b","name":"Swapr","symbol":"SWPR","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/18740/thumb/swapr.jpg?1633516501"},{"address":"0x431d5dff03120afa4bdf332c61a6e1766ef37bdb","name":"JPY Coin","symbol":"JPYC","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/25971/thumb/2023jpyc.png?1675935375"},{"address":"0x703120f2f2011a0d03a03a531ac0e84e81f15989","name":"UNCL","symbol":"UNCL","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/13102/thumb/uncl_logo.png?1605230945"},{"address":"0x4ecaba5870353805a9f068101a40e0f32ed605c6","name":"Tether","symbol":"USDT","decimals":6,"logoURI":"https://assets.coingecko.com/coins/images/325/thumb/Tether.png?1668148663"},{"address":"0x6c76971f98945ae98dd7d4dfca8711ebea946ea6","name":"Wrapped stETH","symbol":"WSTETH","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/18834/thumb/wstETH.png?1633565443"},{"address":"0x4b1e2c2762667331bc91648052f646d1b0d35984","name":"agEUR","symbol":"AGEUR","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/19479/thumb/agEUR.png?1635283566"},{"address":"0x7ecf26cd9a36990b8ea477853663092333f59979","name":"Perpetual Protocol","symbol":"PERP","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/12381/thumb/60d18e06844a844ad75901a9_mark_only_03.png?1628674771"},{"address":"0x7ef541e2a22058048904fe5744f9c7e4c57af717","name":"Balancer","symbol":"BAL","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/11683/thumb/Balancer.png?1592792958"},{"address":"0xdbf3ea6f5bee45c02255b2c26a16f300502f68da","name":"Swarm","symbol":"BZZ","decimals":16,"logoURI":"https://assets.coingecko.com/coins/images/16509/thumb/Circle_Orange_onWhite.png?1675184920"},{"address":"0xcb444e90d8198415266c6a2724b7900fb12fc56e","name":"Monerium EUR emoney","symbol":"EURE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/23354/thumb/eur.png?1643926562"},{"address":"0xaad66432d27737ecf6ed183160adc5ef36ab99f2","name":"Tellor Tributes","symbol":"TRB","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/9644/thumb/Blk_icon_current.png?1584980686"},{"address":"0x1e2c4fb7ede391d116e6b41cd0608260e8801d59","name":"Backed CSPX Core S P 500","symbol":"BCSPX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31891/thumb/b-CSPX-200x200.png?1695624236"},{"address":"0xd589f00fa2eb83367f732ab3cda92ee0940389cf","name":"Fuse","symbol":"FUSE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/10347/thumb/fuse.png?1685331339"},{"address":"0x9fb1d52596c44603198fb0aee434fac3a679f702","name":"Jarvis Synthetic Euro","symbol":"JEUR","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/15725/thumb/jEUR.png?1634046044"},{"address":"0x20c64dee8fda5269a78f2d5bdba861ca1d83df7a","name":"Backed HIGH   High Yield Corp Bond","symbol":"BHIGH","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31868/thumb/b-HIGH-200x200.png?1695350464"},{"address":"0x2f123cf3f37ce3328cc9b5b8415f9ec5109b45e7","name":"Backed GOVIES 0 6 months EURO","symbol":"BC3M","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31870/thumb/b-C3-M-200x200.png?1695351313"},{"address":"0x52d134c6db5889fad3542a09eaf7aa90c0fdf9e4","name":"Backed IBTA   Treasury Bond 1 3yr","symbol":"BIBTA","decimals":15,"logoURI":"https://assets.coingecko.com/coins/images/31880/thumb/b-IBTA-200x200.png?1695366147"},{"address":"0x2f11eeee0bf21e7661a22dbbbb9068f4ad191b86","name":"Backed NIU Technologies","symbol":"BNIU","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31869/thumb/b-NIU-200x200.png?1695351158"},{"address":"0xbbcb0356bb9e6b3faa5cbf9e5f36185d53403ac9","name":"Backed Coinbase Global","symbol":"BCOIN","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31872/thumb/b-COIN-200x200.png?1695351481"},{"address":"0x6a023ccd1ff6f2045c3309768ead9e68f978f6e1","name":"WETH","symbol":"WETH","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/2518/thumb/weth.png?1628852295"},{"address":"0x0116e28b43a358162b96f70b4de14c98a4465f25","name":"UNCX Network","symbol":"UNCX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/12871/thumb/uncx.png?1676952157"},{"address":"0xe2e73a1c69ecf83f464efce6a5be353a37ca09b2","name":"Chainlink","symbol":"LINK","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/877/thumb/chainlink-new-logo.png?1547034700"},{"address":"0xa899e4476ff5da39dcd9ddec7a6e2c651d8614bf","name":"Bitcoin BR","symbol":"BTCBR","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/21205/thumb/btcbr.png?1661666691"},{"address":"0xb17d999e840e0c1b157ca5ab8039bd958b5fa317","name":"Etho Protocol","symbol":"ETHO","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/5194/thumb/ether1new-transparent.png?1578298993"},{"address":"0xb7d311e2eb55f2f68a9440da38e7989210b9a05e","name":"STAKE","symbol":"STAKE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/11061/thumb/xdai.png?1587714165"},{"address":"0x364b5975385b4de226cf450df82d7ed69902ac5a","name":"TORG","symbol":"TORG","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/17596/thumb/TORG_Logo_200x200.png?1628586056"},{"address":"0x8b8407c6184f1f0fd1082e83d6a3b8349caced12","name":"Circuits of Value","symbol":"COVAL","decimals":8,"logoURI":"https://assets.coingecko.com/coins/images/588/thumb/coval-logo.png?1599493950"},{"address":"0x83ff60e2f93f8edd0637ef669c69d5fb4f64ca8e","name":"BrightID","symbol":"BRIGHT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/18415/thumb/bright.PNG?1631841211"},{"address":"0xfa57aa7beed63d03aaf85ffd1753f5f6242588fb","name":"Mt Pelerin Shares","symbol":"MPS","decimals":0,"logoURI":"https://assets.coingecko.com/coins/images/11471/thumb/MPS.png?1590319120"},{"address":"0x9c58bacc331c9aa871afd802db6379a98e80cedb","name":"Gnosis","symbol":"GNO","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/662/thumb/logo_square_simple_300px.png?1609402668"},{"address":"0x4f4f9b8d5b4d0dc10506e5551b0513b61fd59e75","name":"Giveth","symbol":"GIV","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/21792/thumb/GIVToken_200x200.png?1640055088"},{"address":"0x8e5bbbb09ed1ebde8674cda39a0c169401db4252","name":"Wrapped Bitcoin","symbol":"WBTC","decimals":8,"logoURI":"https://assets.coingecko.com/coins/images/7598/thumb/wrapped_bitcoin_wbtc.png?1548822744"},{"address":"0x256eb8a51f382650b2a1e946b8811953640ee47d","name":"Streamr","symbol":"DATA","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/17869/thumb/DATA_new_symbol_3x.png?1629692324"},{"address":"0x3f56e0c36d275367b8c502090edf38289b3dea0d","name":"MAI","symbol":"MIMATIC","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/15264/thumb/mimatic-red.png?1620281018"},{"address":"0x177127622c4a00f3d409b75571e12cb3c8973d3c","name":"CoW Protocol","symbol":"COW","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/24384/thumb/cow.png?1660960589"},{"address":"0xec3f3e6d7907acda3a7431abd230196cda3fbb19","name":"Ethix","symbol":"ETHIX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/3031/thumb/ETHIX_icon_256x256-256.png?1622195164"},{"address":"0xfbdd194376de19a88118e84e279b977f165d01b8","name":"DeHive","symbol":"DHV","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/14926/thumb/logo_200x200.png?1626181831"},{"address":"0x97edc0e345fbbbd8460847fcfa3bc2a13bf8641f","name":"DAOSquare","symbol":"RICE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/19084/thumb/tw5gu1dW_400x400.jpeg?1634389807"},{"address":"0x417602f4fbdd471a431ae29fb5fe0a681964c11b","name":"JPY Coin v1","symbol":"JPYC","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/17277/thumb/WoZ8rruL_400x400.png?1627016492"},{"address":"0xd3d47d5578e55c880505dc40648f7f9307c3e7a8","name":"DeFi Pulse Index","symbol":"DPI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/12465/thumb/defi_pulse_index_set.png?1600051053"},{"address":"0x37b60f4e9a31a64ccc0024dce7d0fd07eaa0f7b3","name":"Kleros","symbol":"PNK","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/3833/thumb/kleros.png?1547975322"},{"address":"0xeeeeeb57642040be42185f49c52f7e9b38f8eeee","name":"Elk Finance","symbol":"ELK","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/17813/thumb/elk.png?1629336971"},{"address":"0xdd96b45877d0e8361a4ddb732da741e97f3191ff","name":"BUSD","symbol":"BUSD","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/9576/thumb/BUSDLOGO.jpg?1695626858"},{"address":"0x44fa8e6f47987339850636f88629646662444217","name":"Dai","symbol":"DAI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/9956/thumb/Badge_Dai.png?1687143508"},{"address":"0xc5102fe9359fd9a28f877a67e36b0f050d81a3cc","name":"Hop Protocol","symbol":"HOP","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/25445/thumb/hop.png?1665541677"}]},{"chainId":"200101","name":"Milkomeda C1 Testnet","tokens":[{"address":"0x0000000000000000000000000000000000000000","name":"milkTAda","symbol":"mTAda","decimals":18,"logoURI":"https://ipfs.io/ipfs/QmdoUtvHDybu5ppYBZT8BMRp6AqByVSoQs8nFwKbaS55jd"}]},{"chainId":"2001","name":"Milkomeda C1","tokens":[{"address":"0x0000000000000000000000000000000000000000","name":"milkAda","symbol":"mADA","decimals":18,"logoURI":"https://ipfs.io/ipfs/QmdoUtvHDybu5ppYBZT8BMRp6AqByVSoQs8nFwKbaS55jd"},{"address":"0x063a5e4cd5e15ac66ea47134eb60e6b30a51b2bf","name":"MilkySwap","symbol":"MILKY","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/24792/thumb/milkyswap.jpeg?1648969258"},{"address":"0x9b7c74aa737fe278795fab2ad62defdbbaedfbca","name":"Ravelin Finance","symbol":"RAV","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/25487/thumb/rav200.png?1656560511"},{"address":"0x2d7289df2f41a25d3a628258081ad7b99eb4c83b","name":"MuesliSwap Yield","symbol":"MYIELD","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/25011/thumb/Icon.png?1652780364"},{"address":"0xae83571000af4499798d1e3b0fa0070eb3a3e3f9","name":"Wrapped ADA","symbol":"WADA","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/24791/thumb/ezgif-2-07900fc0ac.jpg?1648922062"},{"address":"0xf0c73e6287867baa4f865a17ee711ec989c78ac0","name":"OccamX","symbol":"OCX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28130/thumb/200x200.png?1667649434"},{"address":"0x7f27352d5f83db87a5a3e00f4b07cc2138d8ee52","name":"Wrapped BNB   Celer","symbol":"CEWBNB","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/25041/thumb/7192.png?1649905826"},{"address":"0x8d50a024b2f5593605d3ce8183ca8969226fcbf8","name":"Wrapped Bitcoin   Celer","symbol":"CEWBTC","decimals":8,"logoURI":"https://assets.coingecko.com/coins/images/25013/thumb/3717.png?1649825574"},{"address":"0x65e66a61d0a8f1e686c2d6083ad611a10d84d97a","name":"Wrapped AVAX","symbol":"WAVAX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/15075/thumb/wrapped-avax.png?1629873618"},{"address":"0x332730a4f6e03d9c55829435f10360e13cfa41ff","name":"Wrapped Fantom","symbol":"WFTM","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/16036/thumb/Fantom.png?1622679930"},{"address":"0xb44a9b6905af7c801311e8f4e76932ee959c663c","name":"USDC","symbol":"USDC","decimals":6,"logoURI":"https://assets.coingecko.com/coins/images/6319/thumb/usdc.png?1695374272"},{"address":"0x80a16016cc4a2e6a2caca8a4a498b1699ff0f844","name":"Tether","symbol":"USDT","decimals":6,"logoURI":"https://assets.coingecko.com/coins/images/325/thumb/Tether.png?1668148663"},{"address":"0x6ab6d61428fde76768d7b45d8bfeec19c6ef91a8","name":"Wrapped Bitcoin","symbol":"WBTC","decimals":8,"logoURI":"https://assets.coingecko.com/coins/images/7598/thumb/wrapped_bitcoin_wbtc.png?1548822744"},{"address":"0x461d52769884ca6235b685ef2040f47d30c94eb5","name":"OccamFi","symbol":"OCC","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/14801/thumb/occfi.PNG?1618531140"},{"address":"0xe3f5a90f9cb311505cd691a46596599aa1a0ad7d","name":"WETH","symbol":"WETH","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/2518/thumb/weth.png?1628852295"},{"address":"0x6a2d262d56735dba19dd70682b39f6be9a931d98","name":"Bridged USD Coin  Celer ","symbol":"CEUSDC","decimals":6,"logoURI":"https://assets.coingecko.com/coins/images/24823/thumb/usdc.png?1649041374"},{"address":"0x3795c36e7d12a8c252a20c5a7b455f7c57b60283","name":"Bridged Tether  Celer ","symbol":"CEUSDT","decimals":6,"logoURI":"https://assets.coingecko.com/coins/images/24826/thumb/usdt.png?1649042538"},{"address":"0x639a647fbe20b6c8ac19e48e2de44ea792c62c5c","name":"Dai","symbol":"DAI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/9956/thumb/Badge_Dai.png?1687143508"},{"address":"0x218c3c3d49d0e7b37aff0d8bb079de36ae61a4c0","name":"BUSD","symbol":"BUSD","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/9576/thumb/BUSDLOGO.jpg?1695626858"},{"address":"0x81ecac0d6be0550a00ff064a4f9dd2400585fe9c","name":"Wrapped Ether   Celer","symbol":"CEWETH","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/24827/thumb/weth.png?1649047091"},{"address":"0xf390830df829cf22c53c8840554b98eafc5dcbc2","name":"Chainlink","symbol":"LINK","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/877/thumb/chainlink-new-logo.png?1547034700"},{"address":"0x5a955fddf055f2de3281d99718f5f1531744b102","name":"USD Coin   Nomad","symbol":"NOMADUSDC","decimals":6,"logoURI":"https://assets.coingecko.com/coins/images/24829/thumb/usdc.png?1649048319"},{"address":" 0x386e685b5cbaa7bc06e3dd2eecdc56105076e4fa","name":"MuesliSwap MILK","symbol":"MILK","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/24184/thumb/17275.png?1646788041"},{"address":"0xfbdd194376de19a88118e84e279b977f165d01b8","name":"Wrapped BNB","symbol":"WBNB","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/12591/thumb/binance-coin-logo.png?1600947313"},{"address":"0xb9c8f0d3254007ee4b98970b94544e473cd610ec","name":"MAI","symbol":"MIMATIC","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/15264/thumb/mimatic-red.png?1620281018"}]},{"chainId":"56","name":"BNB","tokens":[{"address":"0x0000000000000000000000000000000000000000","name":"BNB Chain Native Token","symbol":"BNB","decimals":18,"logoURI":"https://raw.githubusercontent.com/spothq/cryptocurrency-icons/master/svg/color/bnb.svg"},{"address":"0x499fc0ec9aade85de50af0c17513c7b850eb275f","name":"AICrew","symbol":"AICR","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31569/thumb/Token_AICR.png?1693809531"},{"address":"0xa532cfaa916c465a094daf29fea07a13e41e5b36","name":"Hibiki Finance","symbol":"HIBIKI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/17936/thumb/logo_%281%29.png?1629860624"},{"address":"0xc98a06e7362789f57c8861e8f33f2ebe3d32eed1","name":"Pitquidity Capital","symbol":"PITQC","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/27603/thumb/PITQD_LOGO_TWITER.png?1664779799"},{"address":"0x9babcd3a6f62d9adc709e919d5faa39aa85749fc","name":"Indian Shiba Inu","symbol":"INDSHIB","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/24941/thumb/mvnnSVVU_400x400.jpg?1649424156"},{"address":"0x9f485c50a611199fde9c849c56be7df888a90725","name":"The Cat Inu","symbol":"THECAT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/24624/thumb/200.png?1648449338"},{"address":"0x50ba8bf9e34f0f83f96a340387d1d3888ba4b3b5","name":"RugZombie","symbol":"ZMBE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/18670/thumb/MKHznEfH_400x400.jpg?1632875374"},{"address":"0x1b818cecf52e3b47ee47f7c909e023e4d1b3027c","name":"Xrpcashone","symbol":"XCE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31452/thumb/XRPcashone.png?1692937343"},{"address":"0x5c10e4660ec45a89de85a1fd1b22355b0398fb66","name":"NFTCloud","symbol":"CLOUD","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29242/thumb/cloud.png?1677575684"},{"address":"0x10f6f2b97f3ab29583d9d38babf2994df7220c21","name":"Teddy Doge","symbol":"TEDDY","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/23389/thumb/17859.png?1644112621"},{"address":"0x9e1170c12fddd3b00fec42ddf4c942565d9be577","name":"Space Token BSC","symbol":"SPACE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/20676/thumb/jYw3kgsY_400x400.png?1637550733"},{"address":"0x20dd734594dadc69df313cd143b34a70a3d9214e","name":"Origen DEFI","symbol":"ORIGEN","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29561/thumb/200x200.png?1679725478"},{"address":"0x8f1fe4e6707cd4236b704759d2ee15166c68183a","name":"Tom Coin","symbol":"TMC","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/25849/thumb/65e20074cf9e4bba897431f80da64ffd.jpeg?1654150541"},{"address":"0xa89bf95c5f15a847c8eb8d348cd7fed719ad7d80","name":"Chat AI","symbol":"AI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29441/thumb/200.png?1678865520"},{"address":"0x021f48697343a6396bafc01795a4c140b637f4b4","name":"Magic Yearn Share","symbol":"MYS","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29343/thumb/mys.png?1678186682"},{"address":"0x510ca7d22a84599e7d0f15f09e674056a6255389","name":"LABSV2","symbol":"LABSV2","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/14401/thumb/CMC_logo.jpg?1664964940"},{"address":"0xaf41054c1487b0e5e2b9250c0332ecbce6ce9d71","name":"Ellipsis X","symbol":"EPX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/25444/thumb/ellipsis-light_%281%29.png?1651786591"},{"address":"0x2db0d5cb907014c67dc201886624716fb5c71123","name":"Ainu","symbol":"AINU","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/17022/thumb/AINU.jpg?1629342905"},{"address":"0x550d7984b7adfff88815e5528e12e322df6d3b9b","name":"PandAI","symbol":"PANDAI","decimals":6,"logoURI":"https://assets.coingecko.com/coins/images/29203/thumb/%C5%AFlll.jpeg?1677308621"},{"address":"0x33333ee26a7d02e41c33828b42fb1e0889143477","name":"Topshelf Finance","symbol":"LIQR","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/21580/thumb/b-MDs-Uqg-Q-400x400.jpg?1639532412"},{"address":"0xc8cc4bbd33264db465e4c9ea011f895d02505959","name":"Sorcery Finance","symbol":"SOR","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31635/thumb/New_Project_%2866%29.png?1694501608"},{"address":"0xe580074a10360404af3abfe2d524d5806d993ea3","name":"PayBolt","symbol":"PAY","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/24175/thumb/logo.png?1646748269"},{"address":"0xee0736c93e98b2e9fbf11f47db19e7b68db71e94","name":"FarmerDoge","symbol":"CROP","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/19910/thumb/farmer.jpeg?1636107276"},{"address":"0x123458c167a371250d325bd8b1fff12c8af692a7","name":"DRAC Network","symbol":"DRAC","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/27438/thumb/200X200.png?1663934782"},{"address":"0xdf0121a3ba5c10816ea2943c722650c4a4b0dbe6","name":"Octopus Protocol","symbol":"OPS","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/16383/thumb/ops_logo.jpg?1623853585"},{"address":"0x78aae7e000bf6fc98a6b717d5ec8ef2bcd04f428","name":"GemPad","symbol":"GEMS","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/25319/thumb/KQLfrRw.png?1651217242"},{"address":"0xc98a8ec7a07f1b743e86896a52434c4c6a0dbc42","name":"ASIX","symbol":"ASIX","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/23282/thumb/asix.png?1643535598"},{"address":"0x67915e893b68fbc436a288564fff1476b632b009","name":"Bone","symbol":"BONE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/24860/thumb/Bone_200_x_200.jpeg?1656560269"},{"address":"0x06082951efdb5095e45e3c08cb103782645a2e69","name":"Wateenswap","symbol":"WTN","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/26333/thumb/Xs5yrJym_400x400.jpeg?1657492066"},{"address":"0x891e4554227385c5c740f9b483e935e3cbc29f01","name":"Robust","symbol":"RBT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/17137/thumb/CG-200x.png?1626438233"},{"address":"0xd869eb44cffa0276ba5c757cda77e25102054eb6","name":"PEPE OPTIMUS","symbol":"PEPO","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30472/thumb/IMG_7307.png?1684671894"},{"address":"0xe0813549bb6817305dfd31ae24b09d3a1c041e9e","name":"WORLDWIDE","symbol":"WORLD","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31862/thumb/Final_Logo_TP1.png?1695289117"},{"address":"0xbb95cc1c662d89822bda29d2e147b124406e6e42","name":"Terran Coin","symbol":"TRR","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/15351/thumb/TERRAN-500px.png?1620626066"},{"address":"0x57c81885faad67fc4de892102f6fead3b9215f6b","name":"Zenith Chain","symbol":"ZENITH","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/21266/thumb/Jqtp-OVG_400x400.png?1638837643"},{"address":"0x213fd3c787b6c452f50fd91f14e12ddf04a7ab4a","name":"ZodiacsV2","symbol":"ZDCV2","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/22589/thumb/LUl0lEMr_400x400.jpg?1642144242"},{"address":"0x31c573d1a50a745b01862edaf2ae72017cea036a","name":"Souls of Meta","symbol":"SOM","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/25515/thumb/soulsofmeta.7527682e.jpg?1652164537"},{"address":"0x715c2f44e3653e44397de00de9d010c4664c456f","name":"CrossDEX","symbol":"CDX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31528/thumb/Logo_Trans_%281%29.png?1693783506"},{"address":"0xd618ad98e6557532d3c65e88bf1ff765724f21c9","name":"Trade Tech AI","symbol":"TTAI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29502/thumb/TAI__logo_200.png?1679372549"},{"address":"0x38fab266089aaf3bc2f11b791213840ea3d587c7","name":"Aquachain","symbol":"AQUA","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/5596/thumb/aqua.png?1586745922"},{"address":"0x8a5d7fcd4c90421d21d30fcc4435948ac3618b2f","name":"Cake Monster","symbol":"MONSTA","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/16441/thumb/Monster-Icon-CG200x200transparent.png?1656392071"},{"address":"0x211ffbe424b90e25a15531ca322adf1559779e45","name":"BUX","symbol":"BUX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/2316/thumb/BUXC.png?1600760731"},{"address":"0xf3be1a4a47576208c1592cc027087ce154b00672","name":"Xillion","symbol":"XIL","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/18247/thumb/projectx.PNG?1631134123"},{"address":"0xe0399378f7a92a39da849eb64cddde2940e234bb","name":"ZionTopia","symbol":"ZION","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/25902/thumb/logo.png?1654501700"},{"address":"0xe5431bcf8769fcc7f2f3dbdd93300b9696747c4c","name":"Gold Guaranteed Coin","symbol":"GGCM","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/26265/thumb/200x200.png?1656983771"},{"address":"0xab3bcb0e39b505de2a3545ce721e117de75d1e1d","name":"Strelka AI","symbol":"STRELKAAI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29208/thumb/Strelka-logo.png?1677390546"},{"address":"0xe0167c41bea56432f8588a4ceff0f5f3642120e7","name":"Viking Elon","symbol":"VELON","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/25346/thumb/Viking_Elon_200.png?1651303559"},{"address":"0x6f9f0c4ad9af7ebd61ac5a1d4e0f2227f7b0e5f9","name":"Era7","symbol":"ERA","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/24061/thumb/18483.png?1646204630"},{"address":"0x546dded7c535e192c4132f5c998db017af824d96","name":"Baby Pepe","symbol":"BABYPEPE","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/29990/thumb/200x200.png?1682415517"},{"address":"0x971341c2e487bb51643573bc8b9f08b44dbc92e6","name":"MoonPot Finance","symbol":"MOONPOT","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/28888/thumb/IMG_20230130_210408.png?1675154885"},{"address":"0x79ca48c3f6bfb3ef284b4d4c39ca51286830f9ae","name":"Polka Classic","symbol":"DOTC","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/22307/thumb/Polka-Classic.png?1641446596"},{"address":"0xc75cbd824d5d40b30739905e8b857ba091b8bf2a","name":"MetaXCosmos","symbol":"METAX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29763/thumb/1212.png?1681181143"},{"address":"0x2bc8c2ae9dad57948fa4168e56e177a29ae0c0b1","name":"BattleForTEN","symbol":"BFT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28355/thumb/BFT_LOGO_200X200.png?1669774806"},{"address":"0x28b9aed756de31b6b362aa0f23211d13093ebb79","name":"LunaGens","symbol":"LUNG","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/26592/thumb/4-FAECD18-620-B-421-E-A27-E-70-D58-DDCE11-B.png?1658972100"},{"address":"0xb65528415eb3d737033fe9101a536f6e4c27a8b0","name":"BabyPepeEntire","symbol":"BABYPEPE","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/30480/thumb/Frame_2197_%281%29.png?1684709051"},{"address":"0x9186359f82c3c0cc005a0b3563dc4ccd2627d82a","name":"AntNetworX  OLD ","symbol":"ANTX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/27628/thumb/photo_2023-07-17_19-38-50.jpg?1689846412"},{"address":"0xdfb3c678c32b9a547b3802d4c2f7cb063bdfe9c9","name":"MerryChristmas","symbol":"HOHOHO","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29263/thumb/merrychristmas.jpg?1677659566"},{"address":"0x0f76142d83ddef359753cca33647cc4dcee1c6d1","name":"EarnX V2","symbol":"EARNX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/24234/thumb/earnx.PNG?1646990052"},{"address":"0xb1528a7be5a96b77de5337988ba69029ca6e2c7a","name":"Barking","symbol":"BARK","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/15828/thumb/bark.png?1622025223"},{"address":"0xea51801b8f5b88543ddad3d1727400c15b209d8f","name":"Inuko Finance","symbol":"INUKO","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/27821/thumb/inuko-logo-200x200.png?1666263695"},{"address":"0xf709e948daed701a6a018e6f6090ca1930055966","name":"AI DogeMini","symbol":"AIDOGEMINI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28995/thumb/Logo_200px_x_200px.jpg?1675823705"},{"address":"0xdfaabaa57dec10c049335bdaa2e949b4ce2ead30","name":"Catbonk","symbol":"CABO","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/20917/thumb/cabo.png?1637923769"},{"address":"0x1fc71fe3e333d5262828f3d348c12c7e52306b8a","name":"Glory Token","symbol":"GLR","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29854/thumb/Logo_icon_200x200.png?1681906976"},{"address":"0xc9f8c639135fc1412f011cc84810635d6bbca19d","name":"TLifeCoin","symbol":"TLIFE","decimals":8,"logoURI":"https://assets.coingecko.com/coins/images/31673/thumb/tlife_logo.png?1694399257"},{"address":"0xa7deade7bbba2bf0af1572a25b47e477749ef383","name":"Primo DAO","symbol":"PRIMO","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/25508/thumb/19700.png?1652161306"},{"address":"0x6e4a971b81ca58045a2aa982eaa3d50c4ac38f42","name":"Bridge Oracle","symbol":"BRG","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/12512/thumb/brg.png?1661754280"},{"address":"0x3c0fe6c4acd3a21615a51372d2a430eb68ccde43","name":"Red Floki CEO","symbol":"REDFLOKICEO","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/30039/thumb/FcOcx_B7_400x400.jpg?1682661431"},{"address":"0x71809c4ff017ceade03038a8b597ecabb6519918","name":"Cockapoo","symbol":"CPOO","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/16852/thumb/cpoo.png?1644648415"},{"address":"0xce6b8b2787c657f1b98b7a66b5b63178863fd719","name":"ZFMCOIN","symbol":"ZFM","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28232/thumb/20221106_193725.png?1668574239"},{"address":"0x8abfa6a4f4b9865b0e7acfdce1839a2584636d06","name":"MAGIKAL ai","symbol":"MGKL","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29584/thumb/magikal.png?1679883085"},{"address":"0xf97c30f0b31aee9b1ab087f8ccf5b14bf354d29f","name":"Real Estate Token","symbol":"R3T","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29569/thumb/R3T.png?1679737424"},{"address":"0x59c49b54d4425c7ff1e49f40958a14d48cc87c26","name":"Tap Fantasy MC","symbol":"TFMC","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/26483/thumb/Tap-Fantasy-MC-Logo.png?1658279327"},{"address":"0x730cb2ba0f654ddec32470d265555f26fe545eb8","name":"ElonDoge DAO","symbol":"EDAO","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/17323/thumb/edao_logo.png?1627305989"},{"address":"0xf8759de7f2c8d3f32fd8f8e4c0c02d436a05ddeb","name":"Urubit","symbol":"URUB","decimals":8,"logoURI":"https://assets.coingecko.com/coins/images/19902/thumb/54UYxwFE_400x400.jpg?1636099182"},{"address":"0xe6884e29ffe5c6f68f4958cf201b0e308f982ac9","name":"Vegasino","symbol":"VEGAS","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/25905/thumb/third_about_img.png?1654502494"},{"address":"0x515e62a3ac560fd5df08536d08336e63aed3b182","name":"SMP Finance","symbol":"SMPF","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30891/thumb/20230913_091919.jpg?1694665554"},{"address":"0xfecca80ff6deb2b492e93df3b67f0c523cfd3a48","name":"AlgoBlocks","symbol":"ALGOBLK","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/25120/thumb/tncthV9K_400x400.jpg?1650370062"},{"address":"0xf93f6b686f4a6557151455189a9173735d668154","name":"Gamerse","symbol":"LFG","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/19582/thumb/gamerse.PNG?1635470285"},{"address":"0x181c0f81d56102f64ec805ca444638b18a191db3","name":"PEPE DAO","symbol":"PEPED","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30286/thumb/IMG_20230510_010937_683.jpg?1683864154"},{"address":"0x8f2714b178676ba0f9cfb226f6519b92dd8def9d","name":"Big Panda","symbol":"PANDA","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30889/thumb/Panda_logo_.png?1688524544"},{"address":"0x7da07fb98f16c26a6417ca5627719194a6944211","name":"8BITEARN","symbol":"8BIT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28908/thumb/WhatsApp_Image_2023-01-18_at_12.38.16.jpeg?1675307617"},{"address":"0xa11ff9976018fda2a8c4ccfa6ffbe8423c5ab668","name":"Floki Cash","symbol":"FLOKICASH","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29865/thumb/E68106E0-F8A1-406A-9C25-3B22644936A9.jpeg?1681890065"},{"address":"0x93bb13e90678ccd8bbab07d1daef15086746dc9b","name":"PlayPad","symbol":"PPAD","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/20202/thumb/playpad.PNG?1636622174"},{"address":"0x38ffa52c7628f5ccf871472e40c462e4483215c9","name":"SwirlToken  OLD ","symbol":"SWIRL","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/22575/thumb/swirl200.png?1679455443"},{"address":"0xfafbc48f6aa3587984ea50e472304802b39c2604","name":"DogyRace","symbol":"DOR","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/21514/thumb/DogyRaceLogo.png?1639376008"},{"address":"0x2ff3d0f6990a40261c66e1ff2017acbc282eb6d0","name":"Venus SXP","symbol":"VSXP","decimals":8,"logoURI":"https://assets.coingecko.com/coins/images/13918/thumb/sxp.png?1612844350"},{"address":"0x63290fc683d11ea077aba09596ff7387d49df912","name":"Ramifi Protocol","symbol":"RAM","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/14602/thumb/76572462.png?1618003618"},{"address":"0xd773affb89f9dbef8b1bcd2003a9de421f979416","name":"LendrR","symbol":"LNDRR","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31620/thumb/LendrR_200x200.png?1694075070"},{"address":"0x1b2128abc4119474d16bb0a04200b63b0e68a971","name":"Connex","symbol":"CONX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31779/thumb/conx-cg.png?1694774308"},{"address":"0xf29480344d8e21efeab7fde39f8d8299056a7fea","name":"TBCC","symbol":"TBCC","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/13353/thumb/200-200.png?1625755548"},{"address":"0xb3a95bdbe4ac65b0628db1e6600f71ed59b89255","name":"Unityventures","symbol":"UV","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/19673/thumb/IMG_0302_%281%29.JPG?1678945248"},{"address":"0x3244b3b6030f374bafa5f8f80ec2f06aaf104b64","name":"HeroFi ROFI","symbol":"ROFI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/21296/thumb/herofi_logo.jpg?1638875897"},{"address":"0x45d486479ed1db8b164d1386b3c89c05cee8ca86","name":"YSL USDy","symbol":"USDY","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30489/thumb/USDy_Light_Mode.png?1684718190"},{"address":"0xbe0d3526fc797583dada3f30bc390013062a048b","name":"PLEARN","symbol":"PLN","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/24723/thumb/plearn200x200.png?1648697974"},{"address":"0xe2efe9d38e21293347018914ee1d23913ecb811c","name":"Intelly","symbol":"INTL","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28782/thumb/logo_200x200.jpeg?1674195662"},{"address":"0xbfdfa2143d1aa3efea094e5177295df9e77202a8","name":"Hokkaido Inu","symbol":"HOKA","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/29595/thumb/HOKKA.png?1679887935"},{"address":"0x631e20a3b5f523499ae4f5d6239d36f1cd0ddf8e","name":"Cacom","symbol":"CACOM","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30951/thumb/IMG_20230710_221155_578.png?1689214855"},{"address":"0xf3ed4770e6efe9168c3f2f50a6d9d0f97a550df1","name":"DKEY Bank","symbol":"DKEY","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/20212/thumb/dkey.PNG?1636669147"},{"address":"0x8626264b6a1b4e920905efd381002aba52ea0eea","name":"BlackHat Coin","symbol":"BLKC","decimals":8,"logoURI":"https://assets.coingecko.com/coins/images/15987/thumb/logo_light.png?1622537905"},{"address":"0x88c55b3255ae1e6628c953c5cdff27ad3cc33c81","name":"My DeFi Legends","symbol":"DLEGENDS","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/18006/thumb/my_defi_legends.png?1630157431"},{"address":"0x59769630b236398c2471eb26e6a529448030d94f","name":"NKYC Token","symbol":"NKYC","decimals":16,"logoURI":"https://assets.coingecko.com/coins/images/30337/thumb/NKYC-Logo.png?1684156847"},{"address":"0xcffd4d3b517b77be32c76da768634de6c738889b","name":"ESPL Arena","symbol":"ARENA","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28728/thumb/200x200_Logo.png?1673688766"},{"address":"0x57528b45134f09f2e0069334a36a7e14af74745f","name":"SugarYield","symbol":"SUGAR","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29026/thumb/Safeimagekit-resized-img.png?1676018993"},{"address":"0xaee234825dc4687fae606485c1ebd06336052bcc","name":"Duke Inu","symbol":"DUKE","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/16121/thumb/3axfBIw.jpeg?1623036247"},{"address":"0xb465f3cb6aba6ee375e12918387de1eac2301b05","name":"Trivians","symbol":"TRIVIA","decimals":3,"logoURI":"https://assets.coingecko.com/coins/images/26303/thumb/trv-icon-full.png?1657180183"},{"address":"0x8263cd1601fe73c066bf49cc09841f35348e3be0","name":"Altura","symbol":"ALU","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/15127/thumb/logo-dark.png?1667292591"},{"address":"0x264387ad73d19408e34b5d5e13a93174a35cea33","name":"Rare FND","symbol":"FND","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/26690/thumb/fnd.png?1674896811"},{"address":"0x4e53522932608e61b6bd8d50cf15a5501054db4e","name":"Aboat Token","symbol":"ABOAT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30132/thumb/aboat.jpg?1683270108"},{"address":"0xde2a66c92583332e8e1f0aeeb03deb749a3fd33a","name":"Goblin","symbol":"GOBLIN","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/22726/thumb/goblin.png?1654329580"},{"address":"0xe283d0e3b8c102badf5e8166b73e02d96d92f688","name":"Elephant Money","symbol":"ELEPHANT","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/15549/thumb/elephant-200.png?1621200793"},{"address":"0x9fbd6973f7e6e49eac8ff2eb857fdeed41d2e482","name":"Quantic Protocol","symbol":"QUANTIC","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31251/thumb/QuanticTransparent-2.png?1691740875"},{"address":"0x6746e37a756da9e34f0bbf1c0495784ba33b79b4","name":"EFUN","symbol":"EFUN","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/21882/thumb/6GyaKgva_400x400.jpg?1640214177"},{"address":"0x1f88e9956c8f8f64c8d5fef5ed8a818e2237112c","name":"YouCoin","symbol":"UCON","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29841/thumb/ucoin.jpg?1681719637"},{"address":"0x7b9f36a2f331ece03a7483d2713cfd806f9beef2","name":"Iris Ecosystem","symbol":"IRISTOKEN","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/26518/thumb/200x200.png?1658454212"},{"address":"0xa4d92138537bb0bbeaeab095381be422d785e7c4","name":"SwapDEX","symbol":"SDXB","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/13717/thumb/sdx.png?1611116537"},{"address":"0xdcb624c870d73cdd0b3345762977cb14de598cd0","name":"H2Finance","symbol":"YFIH2","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/23077/thumb/wnzHxD5M_400x400.jpg?1643176541"},{"address":"0x491347561cec563ad7d91135f92dbdc700277505","name":"BFX Finance","symbol":"BFX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30694/thumb/BFX.png?1686282879"},{"address":"0x6f13b1fb6b2897bb40adbc09f7f6cfad181c0904","name":"GEURO","symbol":"GEURO","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29688/thumb/CG.png?1680668398"},{"address":"0xb9c255c115636d8cbe107fc953364b243cacdbce","name":"Neural AI","symbol":"NEURALAI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29049/thumb/Neural-AI-logo_%281%29.png?1676294231"},{"address":"0xe350b08079f9523b24029b838184f177baf961ff","name":"Helena Financial  OLD ","symbol":"HELENA","decimals":5,"logoURI":"https://assets.coingecko.com/coins/images/28364/thumb/helenav2.png?1670815154"},{"address":"0x947fe50c2ae24d5ff56f0e4e7c9043eb6ee1abe7","name":"ElvishMagic","symbol":"EMP","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29198/thumb/IMG_20230222_112333_651_%281%29.png?1677305300"},{"address":"0x43bee29430a2dda4bc053dd5669a56efd6e0556a","name":"DogeZilla Ai","symbol":"DAI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29352/thumb/Dogezila_ai_logo.PNG?1678262261"},{"address":"0x1fd991fb6c3102873ba68a4e6e6a87b3a5c10271","name":"Atlantis Loans","symbol":"ATL","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/19362/thumb/atl.png?1635209629"},{"address":"0x35bedbf9291b22218a0da863170dcc9329ef2563","name":"Tap Fantasy","symbol":"TAP","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/23854/thumb/17718.png?1645576059"},{"address":"0xd8126b749e4ec149c97bffbe875ab9960bdb8916","name":"Hey Floki Ai","symbol":"A2E","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/29178/thumb/200x200.png?1677141478"},{"address":"0xdde3ed0bb77c1cafabf8b38f9a1e81edddc7ddc9","name":"Metaverse VR","symbol":"MEVR","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/23437/thumb/cmc3.png?1656560704"},{"address":"0x87e04a05499cb8d352c2e367870d4cf0ead460f0","name":"FLOSHIDO INU","symbol":"FLOSHIDO","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/29004/thumb/photo_2023-02-08_23-51-29.jpg?1675913281"},{"address":"0x09f062cbf43d56df6df8e5381f8a9df2a64c68c0","name":"DecentralFree","symbol":"FREELA","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30003/thumb/DecentralFee_logo.png?1682476391"},{"address":"0x6eda890c7c914e9c6b42415d2a3273b022e7b5e7","name":"Risitas Coin","symbol":"RISITA","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30781/thumb/meme200.png?1687238168"},{"address":"0x12de91acb5f544b37b1e66438324b8db26a91d8a","name":"MetaFootball","symbol":"MTF","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/21945/thumb/2duK7I_h_400x400.png?1640317237"},{"address":"0x95b0fffabd2817959ce410070600d77bce93d454","name":"Shockwaves","symbol":"NEUROS","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30105/thumb/NEUROS_Logo.png?1683083293"},{"address":"0x1603441703472aff8cdf1871961176cc494588dc","name":"Finance AI","symbol":"FINANCEAI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29113/thumb/B351-E2-C5-8-F1-C-404-D-854-C-068996-C1-B476.jpg?1676693388"},{"address":"0x0747cda49c82d3fc6b06df1822e1de0c16673e9f","name":"Flux Protocol","symbol":"FLUX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/15002/thumb/logo.dabc411c.png?1619402947"},{"address":"0x04df8c91fccfd703cd15047bf6c1ce76d335c6ce","name":"Baby Lovely Inu","symbol":"BLOVELY","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/23608/thumb/blovely.png?1644746419"},{"address":"0xeb33cbbe6f1e699574f10606ed9a495a196476df","name":"DeFi Coin","symbol":"DEFC","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/17020/thumb/deficoin.png?1626094280"},{"address":"0x8ea5219a16c2dbf1d6335a6aa0c6bd45c50347c5","name":"OpenOcean","symbol":"OOE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/17014/thumb/ooe_log.png?1626074195"},{"address":"0x843d4a358471547f51534e3e51fae91cb4dc3f28","name":"Loser Coin","symbol":"LOWB","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/15378/thumb/loser.PNG?1620693920"},{"address":"0xd7c5d2a3b7868e6dd539e145c98a565f29ef3fa4","name":"WeGro","symbol":"WEGRO","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/21675/thumb/wegrocoin_logo_favicon.png?1639711396"},{"address":"0x07728696ee70a28c9c032926577af1d524df30f9","name":"PlaceWar Governance","symbol":"PLACE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/19993/thumb/place.png?1636361494"},{"address":"0xd73f32833b6d5d9c8070c23e599e283a3039823c","name":"Waterfall Governance","symbol":"WTF","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/19189/thumb/wtf_icon_avatar_200x200.png?1634631004"},{"address":"0xf018aea0a08a5d88674f0837bdac27ab89824dee","name":"Mad Monkey Guild","symbol":"MMG","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/27226/thumb/LogoAnimate.png?1662702513"},{"address":"0x7ffc1243232da3ac001994208e2002816b57c669","name":"CryptoZoo","symbol":"ZOO","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/17337/thumb/cryptozoo.PNG?1627354086"},{"address":"0x1b219aca875f8c74c33cff9ff98f3a9b62fcbff5","name":"Fins","symbol":"FINS","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/18568/thumb/fins_200x200.png?1632448775"},{"address":"0xf899e83e6c6df1a0d4887cf0209193aa97236322","name":"MBD Financials","symbol":"MBD","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/25617/thumb/mbd-transparent_%281%29.png?1652856277"},{"address":"0x23396cf899ca06c4472205fc903bdb4de249d6fc","name":"Wrapped USTC","symbol":"USTC","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/15462/thumb/ust.png?1620910058"},{"address":"0x23ce9e926048273ef83be0a3a8ba9cb6d45cd978","name":"Mines of Dalarnia","symbol":"DAR","decimals":6,"logoURI":"https://assets.coingecko.com/coins/images/19837/thumb/dar.png?1636014223"},{"address":"0x38b967d090fe06f7927a2b65cc57987c8594766b","name":"Infinity Protocol","symbol":"INFINITY","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28291/thumb/200x200.png?1669256067"},{"address":"0xfb2c085a8b266b264ff0a38b9687ae14ef8a67fb","name":"HalisWorld","symbol":"HLS","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29338/thumb/logo.png?1678175325"},{"address":"0xbd01a5b92ebef331f42d2ea99ff087e5834621ac","name":"BaseBank","symbol":"BBANK","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31847/thumb/bbanklogo.png?1695285790"},{"address":"0x4634d58982138e93c951c1485d25bc619cbd1f75","name":"AiONE","symbol":"AIONE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30431/thumb/200_%281%29.png?1684463739"},{"address":"0x25ee36b6eb10da8225a40462d725b15ed259c51a","name":"X Project","symbol":"X-TOKEN","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30756/thumb/Frame_12_%281%29.png?1686821283"},{"address":"0x759bd4ed07a34b9ea761f8f2ed9f0e102675a29c","name":"Have Fun Token","symbol":"HF","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/30257/thumb/0XUodgfR_400x400.jpg?1683771703"},{"address":"0xf8dfc70a422ccf0ab206adf7b043fdfb410caab5","name":"Elysium Token","symbol":"ELYS","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30176/thumb/our_logo_in_png.png?1683547019"},{"address":"0x1c25222994531c4ac35e4d94bbf7552c9aa92e32","name":"Wrapped PKT","symbol":"WPKT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/19003/thumb/200x200wpkt-04.png?1634138697"},{"address":"0x3b95702dd0ce375462f131f805f9ee6e1563f8d5","name":"This is Fine","symbol":"FINE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31851/thumb/IMG_0371.png?1695286212"},{"address":"0x09d975c3351dbded28617517fc6982284a787f03","name":"Crypto Island","symbol":"CISLA","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/17897/thumb/200x200_CISLA.png?1629769640"},{"address":"0xef7d50069406a2f5a53806f7250a6c0f17ad9dcd","name":"beFITTER","symbol":"FIU","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/25995/thumb/FIU_Token.jpg?1655194561"},{"address":"0x25382fb31e4b22e0ea09cb0761863df5ad97ed72","name":"Paragen","symbol":"RGEN","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/24198/thumb/TH-Y4qWF_400x400.jpg?1646863203"},{"address":"0xa78775bba7a542f291e5ef7f13c6204e704a90ba","name":"Metafluence","symbol":"METO","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/22998/thumb/Asset_1.png?1643087185"},{"address":"0x81372c18c87f6d2fe91f416d7c8a109cea48c332","name":"Swinca","symbol":"SWI","decimals":4,"logoURI":"https://assets.coingecko.com/coins/images/25534/thumb/LOGO-TOKEN-2.jpeg?1652251811"},{"address":"0x80b199fedb89eb5fd6b4efd9f000508ecc76f81c","name":"MicroCreditToken","symbol":"1MCT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/24144/thumb/1mct.png?1646559344"},{"address":"0xfa4a5c4ce029fd6872400545df44675219c2e037","name":"Kephi Gallery","symbol":"KPHI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/17696/thumb/XJb3jROS_400x400.jpg?1628978969"},{"address":"0x70bfbcf22a82f412bd4fb6ba00fabb2022f04929","name":"COINMARKETPRIME","symbol":"CMP","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31775/thumb/IMG_20230915_031637_766.jpg?1694773959"},{"address":"0xd50b6c116b05be1bbe50a19bc5273fa1e6f48026","name":"Purr","symbol":"PURR","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31442/thumb/IMG_20230822_112421_407.jpg?1692863813"},{"address":"0x626cab57051e80f4b84551856588b62983bdb94e","name":"RabbitKing","symbol":"RB","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28994/thumb/rabbit.JPG?1676107094"},{"address":"0x552594612f935441c01c6854edf111f343c1ca07","name":"Galaxy War","symbol":"GWT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/22166/thumb/e2x7gMJ4_400x400.jpg?1641166277"},{"address":"0x3c70260eee0a2bfc4b375feb810325801f289fbd","name":"Omni Consumer Protocol","symbol":"OCP","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/15243/thumb/ocp-200px.png?1622175368"},{"address":"0xc1cbfb96a1d5361590b8df04ef78de2fa3178390","name":"Peachfolio","symbol":"PCHF","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/16529/thumb/7d578071-601e-4ef6-9a98-cc7984b258c4.png?1624342728"},{"address":"0x42be29132756ddd6e8b3b94584ca0bab20545eec","name":"Bali Token","symbol":"BLI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/21989/thumb/logo.jpg?1640582239"},{"address":"0x35f3ffffcb622bc9f64fa561d74e983fd488d90c","name":"PirateCash","symbol":"PIRATE","decimals":8,"logoURI":"https://assets.coingecko.com/coins/images/7155/thumb/logo_%281%29.png?1637683371"},{"address":"0x9d173e6c594f479b4d47001f8e6a95a7adda42bc","name":"CryptoZoon","symbol":"ZOON","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/17419/thumb/logo200_%2820%29.png?1627599450"},{"address":"0x5c65badf7f97345b7b92776b22255c973234efe7","name":"Local Traders","symbol":"LCT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/27936/thumb/LT-Logo-200x200_%281%29_%281%29.png?1666510280"},{"address":"0x0b34d4a7c5bfc7004b9a193f8309523e99ca766e","name":"Shon","symbol":"SHON","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/17135/thumb/200x200_LOGO.png?1626425839"},{"address":"0x55a633b3fce52144222e468a326105aa617cc1cc","name":"Truth Seekers","symbol":"TRUTH","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29507/thumb/Truth_Logo.jpg?1679455422"},{"address":"0xf7722aa0714096f1fb5ef83e6041cebb4d58a08e","name":"Ruby Play Network","symbol":"RUBY","decimals":12,"logoURI":"https://assets.coingecko.com/coins/images/24301/thumb/v7j5bIgX_400x400.jpg?1647269369"},{"address":"0x49c7295ff86eabf5bf58c6ebc858db4805738c01","name":"Hero Arena","symbol":"HERA","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/19160/thumb/hera.png?1634549874"},{"address":"0xd4099a517f2fbe8a730d2ecaad1d0824b75e084a","name":"The Monopolist","symbol":"MONO","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/21184/thumb/ab05Nt4UN1q5.png?1638512515"},{"address":"0x3ca994d9f723736381d44388bc8dd1e7ee8c1653","name":"Samurai Legends","symbol":"SMG","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/24440/thumb/e20nuH89_400x400.png?1647670350"},{"address":"0x237ace23ab2c36a004aa5e4fb134fe5c1cedf06c","name":"CEO","symbol":"CEO","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29210/thumb/IMG-20230225-WA0002.png?1677394544"},{"address":"0xc23be03f64a834b3fa6ae62c97ac8b40f3eec6a9","name":"Peoplez","symbol":"LEZ","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/21185/thumb/peoplez.PNG?1638513746"},{"address":"0x0dfcb45eae071b3b846e220560bbcdd958414d78","name":"Libero Financial","symbol":"LIBERO","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/23971/thumb/libero.png?1645869416"},{"address":"0xbccd27062ae1a2bea5731c904b96edfb163aba21","name":"Dogcoin","symbol":"DOGS","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/29065/thumb/1024_%281%29.png?1676366022"},{"address":"0x747d74db20cc422f39ab54edb2a3ce21f3c98af1","name":"Crypto Global United","symbol":"CGU","decimals":8,"logoURI":"https://assets.coingecko.com/coins/images/20751/thumb/2022_CGU-MG_RGB.png?1666606977"},{"address":"0x11fd9ed04f1eb43ef9df6425a6990609f2468895","name":"SmartFi","symbol":"SMTF","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/25264/thumb/618d410e849c474a30fe91ae_SMTF_token_-_transparent_background.png?1651044829"},{"address":"0x185674a45c57ebb884c609c2619740f2994767e9","name":"Helena Financial V2","symbol":"HELENA2","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30545/thumb/Helena_v2.jpg?1684986648"},{"address":"0x49a516bd4406b2d4074c738a58de6db397d0abc9","name":"IKOLF","symbol":"IKOLF","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/26868/thumb/IMG_20220814_132323_400.jpg?1660537118"},{"address":"0xfdfc1ab8bf1e2d6920caf405aa488987a077fc4b","name":"CBYTE Network","symbol":"CBYTE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29248/thumb/photo_2023-02-06_02-15-30.jpg?1677641533"},{"address":"0x3cb26f04223e948b8d810a7bd170620afbd42e67","name":"Areon Network","symbol":"AREA","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28764/thumb/photo_2023-01-04_22-48-03.jpg?1674002274"},{"address":"0xa78628ecba2bf5fedf3fe27a7cedaa363b46708f","name":"Little Bunny Rocket","symbol":"LBR","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/19233/thumb/lrb.PNG?1634768519"},{"address":"0xd0840d5f67206f865aee7cce075bd4484cd3cc81","name":"AFEN Blockchain","symbol":"AFEN","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/14957/thumb/cropped-cropped-afen-e1616095076861.png?1619144008"},{"address":"0x3843f234b35a311e195608d32283a68284b3c44d","name":"La Peseta  OLD ","symbol":"PTA","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/21645/thumb/VB_hrqI7_400x400.jpg?1639636015"},{"address":"0x4e5ab517719a2bdbafefc22c712d7b5bc5f5544e","name":"Brick","symbol":"BRICK","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/16741/thumb/TILE1.png?1649223169"},{"address":"0x49324d59327fb799813b902db55b2a118d601547","name":"Boss","symbol":"BOSS","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/17927/thumb/XL7jo4j.png?1629809801"},{"address":"0xfa139cc2f5c5b8c72309be8e63c3024d03b7e63c","name":"Genie Protocol","symbol":"GNP","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/18753/thumb/colori.png?1633322631"},{"address":"0x5c7bb1e6c45b055a7831f0c82740f9677bbf6d43","name":"InteractWith","symbol":"INTER","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29587/thumb/Pfp_Transparent_1.png?1679885064"},{"address":"0xe5b5d4bea7468b4994fa676949308a79497aa24c","name":"Sheikh Inu","symbol":"SHINU","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28948/thumb/photo_2023-02-04_17-32-00_prev_ui_%282%29.png?1675572486"},{"address":"0xcd392021084683803525fe5e6c00cae9c6be5774","name":"Adonis","symbol":"ADON","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/26793/thumb/Jugvt5z5_400x400.jpeg?1660129722"},{"address":"0xa79b1dea0d35d39003630ba3e10e5ba2d7318082","name":"Spider Man","symbol":"SPIDER","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/30819/thumb/Frame_2229.png?1687750411"},{"address":"0xadcfc6bf853a0a8ad7f9ff4244140d10cf01363c","name":"TrustPad","symbol":"TPAD","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/15272/thumb/p3zMHrp1_400x400.jpg?1620336854"},{"address":"0xa528d8b9cd90b06d373373c37f8f188e44cad3be","name":"Monster Ball","symbol":"MFB","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29145/thumb/05E42231-5338-4104-A074-65A00964BA6F.png?1676965245"},{"address":"0xf84fd783e7c38a3c99030535919fb89350387502","name":"Upfront Protocol","symbol":"UP","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30559/thumb/IMG_20230524_134842_946.jpg?1685016080"}]},{"chainId":"11155111","name":"Sepolia","tokens":[{"address":"0x0000000000000000000000000000000000000000","name":"Sepolia Ether","symbol":"ETH","decimals":18,"logoURI":"https://raw.githubusercontent.com/trustwallet/assets/8ee07e9d791bec6c3ada3cfac73ddfdc4f4a40b7/blockchains/sepolia/info/logo.png"}]},{"chainId":"17000","name":"Holesky","tokens":[{"address":"0x0000000000000000000000000000000000000000","name":"Testnet ETH","symbol":"ETH","decimals":18,"logoURI":"https://ipfs.io/ipfs/QmdwQDr6vmBtXmK2TmknkEuZNoaDqTasFdZdu3DRw8b2wt"}]},{"chainId":"8453","name":"Base","tokens":[{"address":"0x0000000000000000000000000000000000000000","name":"Ether","symbol":"ETH","decimals":18,"logoURI":"https://ipfs.io/ipfs/QmaxRoHpxZd8PqccAynherrMznMufG6sdmHZLihkECXmZv"},{"address":"0x80a3d4999b2836a5ac90b4742da133f5f5f6c27d","name":"UncleSam Finance","symbol":"SAM","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31403/thumb/logo_256.png?1692842782"},{"address":"0x639c0d019c257966c4907bd4e68e3f349bb58109","name":"Quack Token","symbol":"QUACK","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31436/thumb/0x639C0D019C257966C4907bD4E68E3F349bB58109.png?1692863214"},{"address":"0x6653dd4b92a0e5bf8ae570a98906d9d6fd2eec09","name":"RocketSwap","symbol":"RCKT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31281/thumb/200_logo.png?1692155061"},{"address":"0xc5bebd5a6ae6be4fcf383eea014fb1dbd43789ca","name":"Base Name Service","symbol":"BNS","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31543/thumb/4okORXcg_400x400.png?1693792742"},{"address":"0x2dc1cda9186a4993bd36de60d08787c0c382bead","name":"Magnate Finance","symbol":"MAG","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31278/thumb/192.png?1692153076"},{"address":"0x78a087d713be963bf307b18f2ff8122ef9a63ae9","name":"BaseSwap","symbol":"BSWAP","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31245/thumb/Baseswap_LogoNew.jpg?1692696730"},{"address":"0x1dd2d631c92b1acdfcdd51a0f7145a50130050c4","name":"AlienBase","symbol":"ALB","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31301/thumb/alb_token.jpg?1692343510"},{"address":"0xbd2dbb8ecea9743ca5b16423b4eaa26bdcfe5ed2","name":"Synthswap","symbol":"SYNTH","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31190/thumb/synth.png?1691145281"},{"address":"0x60359a0dd148b18d5cf1ddf8aa1916221ed0cbcd","name":"NetherFi","symbol":"NFI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31557/thumb/Logo_2.png?1693800830"},{"address":"0x236eec6359fb44cce8f97e99387aa7f8cd5cde1f","name":"Overnight fi USD ","symbol":"USD+","decimals":6,"logoURI":"https://assets.coingecko.com/coins/images/25757/thumb/USD__logo.png?1653519267"},{"address":"0x48138275f394da1e9aba82eaaa9cf4a5b82bf013","name":"Adam Cochran  Friend tech ","symbol":"ADAM","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31335/thumb/adam.jpeg?1692592207"},{"address":"0x548f93779fbc992010c07467cbaf329dd5f059b7","name":"BMX","symbol":"BMX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31699/thumb/bmx_white.png?1694511309"},{"address":"0x37defbc399e5737d53dfb5533d9954572f5b19bf","name":"BlazeBot","symbol":"BLAZE","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/31279/thumb/blazebot.jpeg?1692153987"},{"address":"0xbefd5c25a59ef2c1316c5a4944931171f30cd3e4","name":"GoldenBoys","symbol":"GOLD","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31353/thumb/goldenboys.png?1692612836"},{"address":"0x23e1a3bcdcee4c59209d8871140eb7dd2bd9d1ce","name":"Baso Finance","symbol":"BASO","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31327/thumb/baso.jpeg?1692356076"},{"address":"0x09f29e2acdb76a831668b03ce2e3ad7bb41aaa5c","name":"Baseape","symbol":"BAPE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31211/thumb/bapeicon.png?1691402979"},{"address":"0x940181a94a35a4569e4529a3cdfb74e38fd98631","name":"Aerodrome Finance","symbol":"AERO","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31745/thumb/token.png?1694749704"},{"address":"0x62f40e8c13f6c0201c789060191c72f7281a93de","name":"Icebergy  Friend tech ","symbol":"ICE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31334/thumb/ice.jpeg?1692590375"},{"address":"0xc2bc7a73613b9bd5f373fe10b55c59a69f4d617b","name":"DackieSwap","symbol":"DACKIE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30752/thumb/WFGTvO1b_400x400.jpg?1686729073"},{"address":"0x0a074378461fb7ed3300ea638c6cc38246db4434","name":"El Dorado Exchange  Base ","symbol":"EDE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31296/thumb/ede.jpeg?1692338200"},{"address":"0xd022723a5005f53c95b51d1822f42b1a3366ee4d","name":"COIN","symbol":"COIN","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31210/thumb/android-chrome-512x512.png?1691402812"},{"address":"0x4e74d4db6c0726ccded4656d0bce448876bb4c7a","name":"Wrapped BMX Liquidity Token","symbol":"WBLT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31532/thumb/wBLT_200x200.png?1693786810"},{"address":"0xd5046b976188eb40f6de40fb527f89c05b323385","name":"BaseX","symbol":"BSX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31419/thumb/bsxlogo.png?1692850774"},{"address":"0x0868d3aecd29fe4e4f4490b4d3d0e937c6ef07ec","name":"Sisyphus  Friend tech ","symbol":"SIS","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31332/thumb/sis.png?1692589705"},{"address":"0x28ed8909de1b3881400413ea970cce377a004cca","name":"Punk X","symbol":"PUNK","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31299/thumb/punkx.jpeg?1692339542"},{"address":"0xef0b2ccb53a683fa48799245f376d6a60929f003","name":"MoonBase","symbol":"MOON","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31867/thumb/moon-logo-200x200.png?1695290347"},{"address":"0xa4220a2b0cb10bf5fdc3b8c3d9e13728f5e7ca56","name":"Mochi","symbol":"MOCHI","decimals":8,"logoURI":"https://assets.coingecko.com/coins/images/31290/thumb/UoypIsNd_400x400.jpg?1692325392"},{"address":"0x9252384e10ba6beae1a52dbb2a3beca2592268d9","name":"Torch","symbol":"TORCH","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31788/thumb/Coin_TORCH_FullColor_circle_200.png?1695019082"},{"address":"0x4788de271f50ea6f5d5d2a5072b8d3c61d650326","name":"Basin Finance","symbol":"BASIN","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31276/thumb/logo_basin.png?1692152158"},{"address":"0x12345ad24808b228f7031de863d9bc006ca8ee48","name":"Farmstrong Seed","symbol":"SEED","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31258/thumb/image.png?1692065212"},{"address":"0x6d6080492d0bd40f1e44cc16791cc1664357f685","name":"ChocoBase","symbol":"CHOCO","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31370/thumb/logo_simple_choco_%282%29.png?1692695305"},{"address":"0xca7465e2c4e6ffa198e11ddfa2e6c6b3522bf799","name":"Mark Jeffrey  Friend tech ","symbol":"MARK","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31372/thumb/mark.jpeg?1692696763"},{"address":"0x52c45d3068c937cb1e6b4a7f2c2a66b85056dd24","name":"Landtorn Shard","symbol":"SHARD","decimals":8,"logoURI":"https://assets.coingecko.com/coins/images/31268/thumb/shard.jpg?1692069343"},{"address":"0x71e8f538f47397cd9a544041555cafc7a0ce9ae3","name":"Perpboost","symbol":"BOOST","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31254/thumb/Logo-Colour.png?1692064104"},{"address":"0x7d1b04f97dda1fddf0ad9ef5a606e4a956261ac8","name":"Based Money Finance","symbol":"BASED","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31388/thumb/BASED256.png?1692760405"},{"address":"0x17d8217c0f4b4742aaace053281f42eb05ab211d","name":"CloudBase","symbol":"CLOUD","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31391/thumb/CloudBaselogo_%281%29.png?1692762173"},{"address":"0x5eb7edfcad75415abb54c345a4ea6ec390f77207","name":"Fortune Bets","symbol":"FORTUNE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31286/thumb/200200.png?1692240003"},{"address":"0x4b1b0ce9613cd9ffc490b0ea7947238a056d73b9","name":"Foobar  Friend tech ","symbol":"FOO","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31333/thumb/foobar.jpeg?1692590052"},{"address":"0xe1f9ac62a2f34881f6fe0f84322de9d7024c2b8e","name":"Mochi  Old ","symbol":"MOCHI","decimals":8,"logoURI":"https://assets.coingecko.com/coins/images/31207/thumb/mochi-coingecko.png?1691482004"},{"address":"0xd07379a755a8f11b57610154861d694b2a0f615a","name":"Base","symbol":"BASE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31199/thumb/59302ba8-022e-45a4-8d00-e29fe2ee768c-removebg-preview.png?1691377221"},{"address":"0x8544fe9d190fd7ec52860abbf45088e81ee24a8c","name":"Toshi","symbol":"TOSHI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31126/thumb/5dajOmhM_400x400.jpg?1690777236"},{"address":"0xb3ce4ce692e035720b25880f678871cfc5a863ca","name":"BaseTools","symbol":"BASE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31127/thumb/logo_%2811%29_%281%29.png?1690778566"},{"address":"0x9cbd543f1b1166b2df36b68eb6bb1dce24e6abdf","name":"Based Farm","symbol":"BASED","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31641/thumb/Based_Token_Icon.png?1694144147"},{"address":"0xba5e6fa2f33f3955f0cef50c63dcc84861eab663","name":"based markets","symbol":"BASED","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31265/thumb/based_logo_200.png?1692068131"},{"address":"0x0fa70e156cd3b03ac4080bfe55bd8ab50f5bcb98","name":"Youcoin","symbol":"YOU","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31218/thumb/Group_4.png?1691477921"},{"address":"0x3421cc14f0e3822cf3b73c3a4bec2a1023b8d9cf","name":"Rebase","symbol":"REBASE","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/31444/thumb/R_Transparent.png?1692864071"},{"address":"0x527bb8424126a16fddf2a86e2504b5ed95de5443","name":"BasedBets","symbol":"BET","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31397/thumb/BasedBets.png?1692764445"},{"address":"0x22dc834c3ff3e45f484bf24b9b07b851b981900f","name":"Smudge Cat","symbol":"SMUDCAT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31209/thumb/logo192.png?1691402644"},{"address":"0x798acf1bd6e556f0c3cd72e77b3d169d26a28ab5","name":"Throne","symbol":"OATH","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31287/thumb/200x200logo.png?1692240281"},{"address":"0xadba4694f5deaf3251d06dec38c86946f8952efb","name":"DIP Exchange","symbol":"DIP","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31497/thumb/token2.png?1693357123"},{"address":"0xbe3111856e4aca828593274ea6872f27968c8dd6","name":"Krav","symbol":"KRAV","decimals":2,"logoURI":"https://assets.coingecko.com/coins/images/31243/thumb/Screen_Shot_2023-08-05_at_2.13.21_PM.png?1691719668"},{"address":"0xd386a121991e51eab5e3433bf5b1cf4c8884b47a","name":"Base Velocimeter","symbol":"BVM","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31336/thumb/bvm_%281%29.png?1692598660"},{"address":"0x71f6b11b371de742c8c65d0ef9e8a0837a61e5da","name":"INK","symbol":"INK","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31132/thumb/oasisswap.jpeg?1690800554"},{"address":"0x63e71271719f03d7233f4fa306b6ea868d0f52ff","name":"BaseInu","symbol":"BINU","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31229/thumb/Safeimagekit-resized-img.png?1691632783"},{"address":"0x614747c53cb1636b4b962e15e1d66d3214621100","name":"CookieBase","symbol":"COOKIE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31217/thumb/logo.png?1691477248"},{"address":"0x27d2decb4bfc9c76f0309b8e88dec3a601fe25a8","name":"Bald","symbol":"BALD","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31119/thumb/cdjxKSjo_400x400.jpg?1690721640"},{"address":"0xd9aaec86b65d86f6a7b5b1b0c42ffa531710b6ca","name":"Bridged USD Coin  Base ","symbol":"USDBC","decimals":6,"logoURI":"https://assets.coingecko.com/coins/images/31164/thumb/baseusdc.jpg?1691075428"},{"address":"0x15a98e2a1b3025e9ee91bfe2480b387eb7c0ece4","name":"JKrantz  Friend tech ","symbol":"JEFF","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31373/thumb/jeff.jpeg?1692697250"},{"address":"0x0963a1abaf36ca88c21032b82e479353126a1c4b","name":"LeetSwap  Base ","symbol":"LEET","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31090/thumb/leet.png?1690964578"},{"address":"0x4158734d47fc9692176b5085e0f52ee0da5d47f1","name":"Balancer","symbol":"BAL","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/11683/thumb/Balancer.png?1592792958"},{"address":"0x2ae3f1ec7f1f5012cfeab0185bfc7aa3cf0dec22","name":"Coinbase Wrapped Staked ETH","symbol":"CBETH","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/27008/thumb/cbeth.png?1661390066"},{"address":"0x65a2508c429a6078a7bc2f7df81ab575bd9d9275","name":"Overnight fi DAI ","symbol":"DAI+","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29634/thumb/DAI_.png?1680160024"},{"address":"0x8fbd0648971d56f1f2c35fa075ff5bc75fb0e39d","name":"UNKJD","symbol":"MBS","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/20841/thumb/monkeyball.png?1639023123"},{"address":"0xf7c1cefcf7e1dd8161e00099facd3e1db9e528ee","name":"Tower","symbol":"TOWER","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/14134/thumb/tower-circular-1000.png?1632195469"},{"address":"0x50c5725949a6f0c72e6c4a641f24049a917db0cb","name":"Dai","symbol":"DAI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/9956/thumb/Badge_Dai.png?1687143508"},{"address":"0xec4cb1148ec60e00a6bfcfce4482db724db6bdde","name":"Swirl Protocol","symbol":"SWI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31263/thumb/256.png?1692067005"},{"address":"0x236aa50979d5f3de3bd1eeb40e81137f22ab794b","name":"tBTC","symbol":"TBTC","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/11224/thumb/0x18084fba666a33d37592fa2633fd49a74dd93a88.png?1674474504"},{"address":"0xfa980ced6895ac314e7de34ef1bfae90a5add21b","name":"Echelon Prime","symbol":"PRIME","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29053/thumb/prime-logo-small-border_%282%29.png?1684901261"},{"address":"0xa334884bf6b0a066d553d19e507315e839409e62","name":"Ethos Reserve Note","symbol":"ERN","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29744/thumb/ERN200x200.png?1681106290"},{"address":"0xc5102fe9359fd9a28f877a67e36b0f050d81a3cc","name":"Hop Protocol","symbol":"HOP","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/25445/thumb/hop.png?1665541677"},{"address":"0x09188484e1ab980daef53a9755241d759c5b7d60","name":"RigoBlock","symbol":"GRG","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/1532/thumb/Symbol-RigoblockRGB.png?1547035682"},{"address":"0x430c67ed118f0637ffe74c98e9b90919c93b7233","name":"Squid Game","symbol":"SQUID","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/20506/thumb/squid.png?1638506382"},{"address":"0xff8adec2221f9f4d8dfbafa6b9a297d17603493d","name":"Moonwell","symbol":"WELL","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/26133/thumb/WELL.png?1690178473"},{"address":"0x6b4712ae9797c199edd44f897ca09bc57628a1cf","name":"UniDex","symbol":"UNIDX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/13178/thumb/unidx.png?1634888975"},{"address":"0xbf0c7ccb143126c1be90a426f676f5cb313956d9","name":"Tempest","symbol":"TEM","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31395/thumb/logo200.png?1692764126"},{"address":"0xf34e0cff046e154cafcae502c7541b9e5fd8c249","name":"Thales","symbol":"THALES","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/18388/thumb/CLVZJN_C_400x400.png?1631758808"},{"address":"0xc2106ca72996e49bbadcb836eec52b765977fd20","name":"NFTEarth","symbol":"NFTE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29116/thumb/20230223_224134.jpg?1677224110"},{"address":"0xfd4330b0312fdeec6d4225075b82e00493ff2e3f","name":"SmarDex","symbol":"SDEX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29470/thumb/SDEX_logo_transparent.png?1690430205"},{"address":"0x833589fcd6edb6e08f4c7c32d4f71b54bda02913","name":"USDC","symbol":"USDC","decimals":6,"logoURI":"https://assets.coingecko.com/coins/images/6319/thumb/usdc.png?1695374272"},{"address":"0x2dad3a13ef0c6366220f989157009e501e7938f8","name":"Extra Finance","symbol":"EXTRA","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30973/thumb/Ex_logo-white-blue_ring_288x.png?1689307279"},{"address":"0x4200000000000000000000000000000000000006","name":"WETH","symbol":"WETH","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/2518/thumb/weth.png?1628852295"},{"address":"0x74ccbe53f77b08632ce0cb91d3a545bf6b8e0979","name":"Fantom Bomb","symbol":"BOMB","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/24109/thumb/logo-blue.png?1646376874"},{"address":"0x23ee2343b892b1bb63503a4fabc840e0e2c6810f","name":"Axelar","symbol":"AXL","decimals":6,"logoURI":"https://assets.coingecko.com/coins/images/27277/thumb/V-65_xQ1_400x400.jpeg?1663121730"},{"address":"0xeb466342c4d449bc9f53a865d5cb90586f405215","name":"Bridged USD Coin  Axelar ","symbol":"AXLUSDC","decimals":6,"logoURI":"https://assets.coingecko.com/coins/images/26476/thumb/uausdc_D_3x.png?1690776252"},{"address":"0xf544251d25f3d243a36b07e7e7962a678f952691","name":"Tarot","symbol":"TAROT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31800/thumb/TAROT.jpg?1695096221"},{"address":"0x703d57164ca270b0b330a87fd159cfef1490c0a5","name":"RAI Finance","symbol":"SOFI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/14686/thumb/sofi.png?1640249595"},{"address":"0xda3de145054ed30ee937865d31b500505c4bdfe7","name":"Overnight fi USD ","symbol":"USD+","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/25757/thumb/USD__logo.png?1653519267"},{"address":"0xc19669a405067927865b40ea045a2baabbbe57f5","name":"Star","symbol":"STAR","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31277/thumb/STAR.png?1692152883"}]},{"chainId":"84531","name":"Base Goerli","tokens":[{"address":"0x0000000000000000000000000000000000000000","name":"Goerli Ether","symbol":"ETH","decimals":18,"logoURI":"https://ipfs.io/ipfs/QmaxRoHpxZd8PqccAynherrMznMufG6sdmHZLihkECXmZv"}]},{"chainId":"10200","name":"Gnosis Chiado","tokens":[{"address":"0x0000000000000000000000000000000000000000","name":"Chiado xDAI","symbol":"XDAI","decimals":18,"logoURI":"https://gnosisscan.io/token/images/gnosans_32.png"}]},{"chainId":"43114","name":"Avalanche","tokens":[{"address":"0x0000000000000000000000000000000000000000","name":"Avalanche","symbol":"AVAX","decimals":18,"logoURI":"https://ipfs.io/ipfs/QmRALA5qvQBRwWre8ofuhCbr3wxVmPS3kGetRR9uJqbqqe"},{"address":"0x938fe3788222a74924e062120e7bfac829c719fb","name":"Ape In","symbol":"APEIN","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/18262/thumb/apein.PNG?1631158082"},{"address":"0xe9d62a1daffaa10e4f239936972807955ad765b4","name":"Earniverse","symbol":"EIV","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/23929/thumb/HGpGTTBc_400x400.jpg?1689323712"},{"address":"0x0da67235dd5787d67955420c84ca1cecd4e5bb3b","name":"Wonderful Memories","symbol":"WMEMO","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/22392/thumb/wMEMO.png?1665832927"},{"address":"0xeeeeeb57642040be42185f49c52f7e9b38f8eeee","name":"Elk Finance","symbol":"ELK","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/17813/thumb/elk.png?1629336971"},{"address":"0x395908aeb53d33a9b8ac35e148e9805d34a555d3","name":"Walrus","symbol":"WLRS","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/25865/thumb/1.png?1667726885"},{"address":"0x73f2af605ea8a3d8410b83ee05b8d6fc0da1aca4","name":"Rides Finance","symbol":"RIDES","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/24172/thumb/5Hj1cTR.png?1646744055"},{"address":"0x107d2b7c619202d994a4d044c762dd6f8e0c5326","name":"Flair Dex","symbol":"FLDX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29949/thumb/Frame_481586.png?1682327933"},{"address":"0xc7198437980c041c805a1edcba50c1ce5db95118","name":"Bridged Tether  Avalanche ","symbol":"USDTE","decimals":6,"logoURI":"https://assets.coingecko.com/coins/images/24189/thumb/Usdt.e.png?1646819144"},{"address":"0x5085434227ab73151fad2de546210cbc8663df96","name":"Metaderby","symbol":"DBY","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/25242/thumb/metaderby.png?1650974944"},{"address":"0x50c72103940d419fb64448f258f7eabba784f84b","name":"Deliq","symbol":"DLQ","decimals":16,"logoURI":"https://assets.coingecko.com/coins/images/24457/thumb/JT5SiYhr_400x400.jpg?1647679369"},{"address":"0xa77e70d0af1ac7ff86726740db1bd065c3566937","name":"PLAYA3ULL GAMES","symbol":"3ULL","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30695/thumb/App_Icon_Round.png?1686297419"},{"address":"0x8c3633ee619a42d3755327c2524e4d108838c47f","name":"Zeus Finance","symbol":"ZEUS","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/27107/thumb/logo.9dcd586c.png?1662008384"},{"address":"0x69260b9483f9871ca57f81a90d91e2f96c2cd11d","name":"GoGoPool","symbol":"GGP","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30267/thumb/GGP_logo_square.png?1683776057"},{"address":"0xfda866cfece71f4c17b4a5e5f9a00ac08c72eadc","name":"Pera Finance","symbol":"PERA","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/16185/thumb/Pera-Finance-200x200.png?1650104052"},{"address":"0x13e7bcefdde72492e656f3fa58bae6029708e673","name":"AGX Coin","symbol":"AGX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28297/thumb/AGX-Coin_200.png?1669265558"},{"address":"0xe19a1684873fab5fb694cfd06607100a632ff21c","name":"Baklava","symbol":"BAVA","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/23780/thumb/200x200_BAVA_LOGO_%282%29.png?1645435712"},{"address":"0x00ee200df31b869a321b10400da10b561f3ee60d","name":"Arable Protocol","symbol":"ACRE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/23659/thumb/acre_token-02.png?1644989289"},{"address":"0x66b071a55b7c258c2086527e35ee355771aa05b8","name":"Stella","symbol":"STL","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30914/thumb/STL_Token_Logo.png?1688712609"},{"address":"0x5541d83efad1f281571b343977648b75d95cdac2","name":"Grape Finance","symbol":"GRAPE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/22718/thumb/grape.png?1642474204"},{"address":"0xf9a075c9647e91410bf6c402bdf166e1540f67f0","name":"Sing  Avalanche ","symbol":"SING","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/18846/thumb/sing_token.png?1633589686"},{"address":"0x37f44b98316ad2815357113aebe0459029543e1e","name":"AvaDex Token","symbol":"AVEX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28393/thumb/IMG_20221129_125713_361.png?1670211091"},{"address":"0xf538030ba4b39e35a3576bd6698cfcc6ac34a81f","name":"NEMO","symbol":"NEMO","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/27473/thumb/NEMO_logo.png?1672731824"},{"address":"0xa1afcc973d44ce1c65a21d9e644cb82489d26503","name":"RunBlox","symbol":"RUX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/26156/thumb/img_v2_37fc1523-649d-45bc-a75f-387f9de1bfch.png?1656405106"},{"address":"0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7","name":"Wrapped AVAX","symbol":"WAVAX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/15075/thumb/wrapped-avax.png?1629873618"},{"address":"0x9366d30feba284e62900f6295bc28c9906f33172","name":"BiometricFinancial","symbol":"BIOFI","decimals":6,"logoURI":"https://assets.coingecko.com/coins/images/25207/thumb/CoinGekoBioFiImage.png?1650771084"},{"address":"0x7761e2338b35bceb6bda6ce477ef012bde7ae611","name":"Chikn Egg","symbol":"EGG","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/21811/thumb/EggToken_200_Transparent.png?1640069901"},{"address":"0x6c1c0319d8ddcb0ffe1a68c5b3829fd361587db4","name":"POLAR","symbol":"POLAR","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/22682/thumb/lZqXDw8a_400x400.png?1649143703"},{"address":"0xb279f8dd152b99ec1d84a489d32c35bc0c7f5674","name":"SteakHut Finance","symbol":"STEAK","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/25688/thumb/logo_400.png?1669718298"},{"address":"0x4c9b4e1ac6f24cde3660d5e4ef1ebf77c710c084","name":"Lydia Finance","symbol":"LYD","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/15195/thumb/512_pure_logo.png?1620083279"},{"address":"0x45c13620b55c35a5f539d26e88247011eb10fdbd","name":"HurricaneSwap","symbol":"HCT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/18912/thumb/hurricane.PNG?1633911773"},{"address":"0x9c846d808a41328a209e235b5e3c4e626dab169e","name":"Chikn Fert","symbol":"FERT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/25425/thumb/200x200_FERT.png?1651737353"},{"address":"0x18706c65b12595edb43643214eacdb4f618dd166","name":"BayMax Finance","symbol":"BAY","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28757/thumb/BayMax_Logo.jpg?1673995445"},{"address":"0xc69eba65e87889f0805db717af06797055a0ba07","name":"Nitro Network","symbol":"NCASH","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28415/thumb/XeaMbijo_400x400.jpeg?1670422437"},{"address":"0xc38f41a296a4493ff429f1238e030924a1542e50","name":"Snowball","symbol":"SNOB","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/14347/thumb/snowball.png?1615879335"},{"address":"0xfd538ca3f58dc309da55b11f007ff53fb4602876","name":"Battle For Giostone","symbol":"BFG","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/27715/thumb/BFG-token-logo.00b4b09c.png?1665453193"},{"address":"0x68327a91e79f87f501bc8522fc333fb7a72393cb","name":"AUX Coin","symbol":"AUX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28298/thumb/AUX-Coin_200.png?1669265680"},{"address":"0xab592d197acc575d16c3346f4eb70c703f308d1e","name":"chikn feed","symbol":"FEED","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/22417/thumb/bJIvBemg_400x400.jpg?1641805638"},{"address":"0x6afd5a1ea4b793cc1526d6dc7e99a608b356ef7b","name":"Storm","symbol":"STORM","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/18170/thumb/nFiYZ2xO_400x400.png?1630888844"},{"address":"0xb00f1ad977a949a3ccc389ca1d1282a2946963b0","name":"Boo Finance","symbol":"BOOFI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/18727/thumb/xrbdgaJc_400x400.jpg?1633191904"},{"address":"0x3eefb18003d033661f84e48360ebecd181a84709","name":"Islander","symbol":"ISA","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/22375/thumb/islander-new-logo.png?1649051752"},{"address":"0x916aba115f5162960e48a2675ad4d8cbd09ce8e4","name":"MCVERSE","symbol":"MCV","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29564/thumb/mcv-token-logo-200x200.png?1679736111"},{"address":"0x77777777777d4554c39223c354a05825b2e8faa3","name":"Yeti Finance","symbol":"YETI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/25022/thumb/1_oJ0F2Zf6CuAhLP0zOboo6w.png?1649837363"},{"address":"0xeeee99b35eb6af5e7d76dd846dbe4bcc0c60ca1d","name":"SoliSnek","symbol":"SNEK","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29877/thumb/SoliSnek2.png?1681973947"},{"address":"0x1ecd47ff4d9598f89721a2866bfeb99505a413ed","name":"AVME","symbol":"AVME","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/17184/thumb/avme_logo.png?1626820475"},{"address":"0xc55036b5348cfb45a932481744645985010d3a44","name":"Wine Shares","symbol":"WINE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/22739/thumb/gshare.png?1642497110"},{"address":"0xf693248f96fe03422fea95ac0afbbbc4a8fdd172","name":"Treasure Under Sea","symbol":"TUS","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/20012/thumb/img-tus.png?1636378482"},{"address":"0x4fbf0429599460d327bd5f55625e30e4fc066095","name":"Teddy Dollar","symbol":"TSD","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/18678/thumb/TSDfinalresize.png?1632963741"},{"address":"0x7086e045b78e1e72f741f25231c08d238812cf8a","name":"RaceX","symbol":"RACEX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/20424/thumb/logo-1_%281%29.png?1637031917"},{"address":"0xb1466d4cf0dcfc0bcddcf3500f473cdacb88b56d","name":"Weble Ecosystem","symbol":"WET","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/17353/thumb/cropped-logo-wombat.png?1627368904"},{"address":"0xe06fba763c2104db5027f57f6a5be0a0d86308af","name":"Akitavax","symbol":"AKITAX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/23043/thumb/coingeckologoakitax.png?1643100394"},{"address":"0xd9d90f882cddd6063959a9d837b05cb748718a05","name":"Moremoney Finance","symbol":"MORE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/23294/thumb/Moremoney_05.jpg?1643579505"},{"address":"0x3ce2fcec09879af073b53bef5f4d04327a1bc032","name":"Hurricane NFT","symbol":"NHCT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/24974/thumb/624fd8f9e5546b00017c915d_NHCT_icon_3x.png?1649651709"},{"address":"0x79ba10485ae46a9436d560d9664369176ec2eb2b","name":"Chikn Worm","symbol":"WORM","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28497/thumb/Worm_Icon_01_1340.png?1671109415"},{"address":"0x0f34919404a290e71fc6a510cb4a6acb8d764b24","name":"Blizz Finance","symbol":"BLZZ","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/20010/thumb/blizz_finance.jpg?1636370042"},{"address":"0xe533b81297b820d2eb2cd837263926596328e8d2","name":"EMDX","symbol":"EMDX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30774/thumb/EMDX_200x200.png?1687149980"},{"address":"0x7d1232b90d3f809a54eeaeebc639c62df8a8942f","name":"Snowbank","symbol":"SB","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/19947/thumb/sb.png?1636337110"},{"address":"0xae4aa155d2987b454c29450ef4f862cf00907b61","name":"Thorus","symbol":"THO","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/22297/thumb/THO_200x200.png?1641425001"},{"address":"0x54a77f27d2346c3a8f5b43a501434f0f21f33e3c","name":"Kingdom Quest","symbol":"KGC","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/25021/thumb/Q-SHreiW_400x400.jpg?1649835774"},{"address":"0xa9ef87eb3fdc2f08ef5ee401326f7331d4d312cf","name":"Index Avalanche DeFi","symbol":"IXAD","decimals":17,"logoURI":"https://assets.coingecko.com/coins/images/30069/thumb/IXAD_token.png?1683009673"},{"address":"0xdbabd6c54d43361e457a06d677341049ac23efac","name":"FLUUS","symbol":"FLUUS","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29554/thumb/fluus-token-logo.png?1679626137"},{"address":"0x1db749847c4abb991d8b6032102383e6bfd9b1c7","name":"Dogeon","symbol":"DON","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/22647/thumb/0CHCbFtm_400x400.jpg?1642397618"},{"address":"0xb723783e0f9015c8e20b87f6cf7ae24df6479e62","name":"ChoccySwap","symbol":"CCY","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/25252/thumb/logo200.png?1651040284"},{"address":"0x5817d4f0b62a59b17f75207da1848c2ce75e7af4","name":"Vector Finance","symbol":"VTX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/24001/thumb/token-icon-brand2000px.png?1646028055"},{"address":"0x885d748c00a279b67a7749ec6b03301700dd0455","name":"Maximus","symbol":"MAXI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/20485/thumb/RH7DeA5K_400x400.jpg?1637118568"},{"address":"0xab547a8dc764408ce9dea41bdf689aeeb349da12","name":"Owloper Owl","symbol":"OWL","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/26453/thumb/Jq6a3dLK_400x400.jpeg?1658114178"},{"address":"0x924157b5dbb387a823719916b25256410a4ad470","name":"Snowtomb LOT","symbol":"SLOT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/23297/thumb/200slot.png?1643598272"},{"address":"0x771c01e1917b5ab5b791f7b96f0cd69e22f6dbcf","name":"Nunu Spirits","symbol":"NNT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/24378/thumb/NNT_99cc33.png?1649120059"},{"address":"0xbf1230bb63bfd7f5d628ab7b543bcefa8a24b81b","name":"Chronicum","symbol":"CHRO","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/26165/thumb/Untitled_%28200_%C3%97_200_px%29.png?1657245976"},{"address":"0x82fe038ea4b50f9c957da326c412ebd73462077c","name":"Joe Hat","symbol":"HAT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/24789/thumb/logo_%281%29.png?1649386782"},{"address":"0xd05b010eddb2dc65d5bd5a1389330d475049a4d5","name":"Deepwaters","symbol":"WTR","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29143/thumb/WTR-icon-200x200.png?1677725911"},{"address":"0x7b2b702706d9b361dfe3f00bd138c0cfda7fb2cf","name":"Pollen","symbol":"PLN","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/21679/thumb/pln.png?1640329453"},{"address":"0x7a023a408f51c23760eb31190fc731bc12b52954","name":"Janus Network","symbol":"JNS","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/27115/thumb/200x200.png?1662012142"},{"address":"0xb648fa7a5f5ed3b3c743140346e3dc3fe94a9125","name":"altFINS","symbol":"AFINS","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/26280/thumb/AFINS_token_logo_200x200.png?1657017692"},{"address":"0x9f285507ea5b4f33822ca7abb5ec8953ce37a645","name":"Degis","symbol":"DEG","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/24333/thumb/DEG_Logo.png?1647359628"},{"address":"0x7086c48c997b8597a1692798155b4fcf2cee7f0f","name":"AVATA Network","symbol":"AVAT","decimals":6,"logoURI":"https://assets.coingecko.com/coins/images/24899/thumb/round.png?1649322555"},{"address":"0xb2a85c5ecea99187a977ac34303b80acbddfa208","name":"Roco Finance","symbol":"ROCO","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/19234/thumb/86109466.png?1634769540"},{"address":"0x695fa794d59106cebd40ab5f5ca19f458c723829","name":"HakuSwap","symbol":"HAKU","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/23611/thumb/haku.png?1644752685"},{"address":"0xccf719c44e2c36e919335692e89d22cf13d6aaeb","name":"OpenBlox","symbol":"OBX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/26150/thumb/OBX_token-black_background_preview.png?1656042112"},{"address":"0x97d367a5f900f5c9db4370d0d801fc52332244c7","name":"Statik","symbol":"STATIK","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/22298/thumb/STATIK_200x200.png?1641424859"},{"address":"0x95ced7c63ea990588f3fd01cdde25247d04b8d98","name":"GrapeVine","symbol":"XGRAPE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/27741/thumb/CRYTOLOGO.png?1665579088"},{"address":"0xc1c57c2975622ebe97d5c0980cf231787324024c","name":"Mu Meme","symbol":"MUME","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28431/thumb/mu-meme-logo.png?1670552840"},{"address":"0x060556209e507d30f2167a101bfc6d256ed2f3e1","name":"xPTP","symbol":"XPTP","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/24965/thumb/xptp.png?1649586016"},{"address":"0xf7d9281e8e363584973f946201b82ba72c965d27","name":"Yield Yak AVAX","symbol":"YYAVAX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/27221/thumb/yyAVAX_Token__200x200.png?1662685308"},{"address":"0x100cc3a819dd3e8573fd2e46d1e66ee866068f30","name":"Dragon Crypto Aurum","symbol":"DCAU","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/20226/thumb/7f7e57.jpeg?1656977391"},{"address":"0xb418417374fca27bb54169d3c777492e6fe17ee7","name":"Brillion","symbol":"DUA","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/27976/thumb/Screenshot_2023-06-13_at_11.58.02_AM.png?1686628721"},{"address":"0x595c8481c48894771ce8fade54ac6bf59093f9e8","name":"Gaj Finance","symbol":"GAJ","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/15257/thumb/logo200x200.png?1629887093"},{"address":"0xf30c5083a1479865c9a8916dec6ddadd82e8907b","name":"Spice Trade","symbol":"SPICE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/25770/thumb/SPICE.png?1653607602"},{"address":"0x9c3254bb4f7f6a05a4aaf2cadce592c848d043c1","name":"Alpha Shares V2","symbol":"ALPHA","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28136/thumb/alpha.png?1667739192"},{"address":"0x7bddaf6dbab30224aa2116c4291521c7a60d5f55","name":"VaporFi","symbol":"VAPE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29235/thumb/logo_vape.png?1677555835"},{"address":"0xbbaaa0420d474b34be197f95a323c2ff3829e811","name":"LODE Token","symbol":"LODE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28296/thumb/LODE-Token_200.png?1669265495"},{"address":"0x397bbd6a0e41bdf4c3f971731e180db8ad06ebc1","name":"Avaxtars","symbol":"AVXT","decimals":6,"logoURI":"https://assets.coingecko.com/coins/images/18336/thumb/avxt.PNG?1631588090"},{"address":"0x346a59146b9b4a77100d369a3d18e8007a9f46a6","name":"Orca AVAI","symbol":"AVAI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/18859/thumb/ic_orca.png?1633603714"},{"address":"0x9a8e0217cd870783c3f2317985c57bf570969153","name":"Cosmic Universe Magic","symbol":"MAGIC","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/19313/thumb/13037.png?1635025843"},{"address":"0x714f020c54cc9d104b6f4f6998c63ce2a31d1888","name":"Step App","symbol":"FITFI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/25015/thumb/801485424e1f49bc8d0facff9287eb9b_photo.png?1649827972"},{"address":"0x83a283641c6b4df383bcddf807193284c84c5342","name":"VaporNodes","symbol":"VPND","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/21977/thumb/logo-rounded.png?1644476484"},{"address":"0xf32398dae246c5f672b52a54e9b413dffcae1a44","name":"Kassandra","symbol":"KACY","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/22918/thumb/kacy.png?1643459818"},{"address":"0x240248628b7b6850352764c5dfa50d1592a033a8","name":"Swapsicle","symbol":"POPS","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/25864/thumb/Swapsicle-Icon_DarkCircle.png?1654238011"},{"address":"0x0f577433bf59560ef2a79c124e9ff99fca258948","name":"Moremoney USD","symbol":"MONEY","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/24237/thumb/money.png?1647087223"},{"address":"0x65378b697853568da9ff8eab60c13e1ee9f4a654","name":"Husky AVAX","symbol":"HUSKY","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/17812/thumb/husky.png?1629721413"},{"address":"0xe0bb6fed446a2dbb27f84d3c27c4ed8ea7603366","name":"Metaderby Hoof","symbol":"HOOF","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/25397/thumb/hoof.png?1651718867"},{"address":"0x3709e8615e02c15b096f8a9b460ccb8ca8194e86","name":"Vee Finance","symbol":"VEE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/18418/thumb/logo_-_2021-09-17T100305.788.png?1631844192"},{"address":"0xf14f4ce569cb3679e99d5059909e23b07bd2f387","name":"NXUSD","symbol":"NXUSD","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/25101/thumb/nxusd-logo.png?1650286304"},{"address":"0x5a15bdcf9a3a8e799fa4381e666466a516f2d9c8","name":"Snail Trail","symbol":"SLIME","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/25394/thumb/logo_%283%29.png?1651706562"},{"address":"0x769bfeb9faacd6eb2746979a8dd0b7e9920ac2a4","name":"zJOE","symbol":"ZJOE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/25532/thumb/zJOE-200px.png?1652250895"},{"address":"0xc3344870d52688874b06d844e0c36cc39fc727f6","name":"Ankr Staked AVAX","symbol":"ANKRAVAX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28695/thumb/ankrAVAX.png?1673413425"},{"address":"0xcf8419a615c57511807236751c0af38db4ba3351","name":"Axial Token","symbol":"AXIAL","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/20502/thumb/E5nD9pPv_400x400.jpg?1637139692"},{"address":"0xc7f4debc8072e23fe9259a5c0398326d8efb7f5c","name":"HeroesChained","symbol":"HEC","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/22813/thumb/logo_-_2022-01-20T140628.062.png?1642658814"},{"address":"0xe896cdeaac9615145c0ca09c8cd5c25bced6384c","name":"Penguin Finance","symbol":"PEFI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/14643/thumb/pefi.png?1643460876"},{"address":"0xf891214fdcf9cdaa5fdc42369ee4f27f226adad6","name":"Imperium Empires","symbol":"IME","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/21933/thumb/X6_UI3rs_400x400.jpg?1640301057"},{"address":"0x8d88e48465f30acfb8dac0b3e35c9d6d7d36abaf","name":"Canary","symbol":"CNR","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/16764/thumb/logo_-_2021-06-29T113338.436.png?1624937628"},{"address":"0x2905d6d6957983d9ed73bc019ff2782c39dd7a49","name":"Snake City","symbol":"SNCT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/27331/thumb/02-38-02-LogoFooter_%281%29.png?1663397749"},{"address":"0x51e48670098173025c477d9aa3f0eff7bf9f7812","name":"DegenX","symbol":"DGNX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/27204/thumb/33358FE4-080B-4987-86A9-202CDEE46F06.png?1662604600"},{"address":"0xf69c2fcd9128d49dfa22348c69177f9380438eb8","name":"NFT Soccer Games","symbol":"NFSG","decimals":6,"logoURI":"https://assets.coingecko.com/coins/images/23461/thumb/nftsg_logo_200.png?1644216602"},{"address":"0xca8ebfb8e1460aaac7c272cb9053b3d42412aac2","name":"Gamer Arena","symbol":"GAU","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28151/thumb/200x200.png?1668150505"},{"address":"0x65031e28cb0e8cc21ae411f9dd22c9b1bd260ce4","name":"Brokkr","symbol":"BRO","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/27813/thumb/bro.png?1665908418"},{"address":"0x846d50248baf8b7ceaa9d9b53bfd12d7d7fbb25a","name":"Verso","symbol":"VSO","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/15169/thumb/versa.PNG?1620011126"},{"address":"0x250bdca7d1845cd543bb55e7d82dca24d48e9f0f","name":"Dragon Crypto Argenti","symbol":"DCAR","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/26613/thumb/dcar%283%29.png?1659067097"},{"address":"0xa7d7079b0fead91f3e65f86e8915cb59c1a4c664","name":"Bridged USD Coin  Avalanche ","symbol":"USDC","decimals":6,"logoURI":"https://assets.coingecko.com/coins/images/23263/thumb/3408.png?1643362756"},{"address":"0xdacde03d7ab4d81feddc3a20faa89abac9072ce2","name":"Platypus USD","symbol":"USP","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28963/thumb/USP_4168x4168.png?1675745232"},{"address":"0xd036414fa2bcbb802691491e323bff1348c5f4ba","name":"Mu Coin","symbol":"MU","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/24884/thumb/coingeckomucoin.png?1649236392"},{"address":"0x937e077abaea52d3abf879c9b9d3f2ebd15baa21","name":"Oh  Finance","symbol":"OH","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/19493/thumb/oh-token-logo-200.png?1635303795"},{"address":"0x8f47416cae600bccf9530e9f3aeaa06bdd1caa79","name":"ThorFi","symbol":"THOR","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/21322/thumb/ThorFi-Mark-Storm2x.png?1670736181"},{"address":"0xfcc6ce74f4cd7edef0c5429bb99d38a3608043a5","name":"The Phoenix","symbol":"FIRE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/22709/thumb/2QuHdcO.png?1642469283"},{"address":"0x502580fc390606b47fc3b741d6d49909383c28a9","name":"HatchyPocket","symbol":"HATCHY","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/27560/thumb/HATCHY_200x200_Logo.png?1664519097"},{"address":"0x1c1cdf8928824dac36d84b3486d598b9799ba6c0","name":"aBASED","symbol":"ABASED","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29528/thumb/based.png?1679476911"},{"address":"0xab05b04743e0aeaf9d2ca81e5d3b8385e4bf961e","name":"SpiceUSD","symbol":"USDS","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/25697/thumb/USDS.png?1653440948"},{"address":"0x42006ab57701251b580bdfc24778c43c9ff589a1","name":"EvoVerses","symbol":"EVO","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/25088/thumb/evoToken.png?1650269135"},{"address":"0x093783055f9047c2bff99c4e414501f8a147bc69","name":"Dexalot","symbol":"ALOT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/24188/thumb/logo_200x200.png?1646838979"},{"address":"0xec3492a2508ddf4fdc0cd76f31f340b30d1793e6","name":"Colony","symbol":"CLY","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/21358/thumb/colony.PNG?1639013005"},{"address":"0x6d923f688c7ff287dc3a5943caeefc994f97b290","name":"SmarterCoin","symbol":"SMRTR","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/19634/thumb/kXN8SJ0.png?1635735394"},{"address":"0xed2b42d3c9c6e97e11755bb37df29b6375ede3eb","name":"Heroes of NFT","symbol":"HON","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/23527/thumb/tokenlogo200.png?1644368289"},{"address":"0x6121191018baf067c6dc6b18d42329447a164f05","name":"Pizza Game","symbol":"PIZZA","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/23771/thumb/eh-lDaUq_400x400.jpg?1645430643"},{"address":"0x8729438eb15e2c8b576fcc6aecda6a148776c0f5","name":"BENQI","symbol":"QI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/16362/thumb/GergDDN3_400x400.jpg?1644984441"},{"address":"0x78ea3fef1c1f07348199bf44f45b803b9b0dbe28","name":"Hoppers Game","symbol":"FLY","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/24296/thumb/FLY.png?1647266279"},{"address":"0x8ae8be25c23833e0a01aa200403e826f611f9cd2","name":"TaleCraft","symbol":"CRAFT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/20934/thumb/3mrl6Lfw_400x400.jpg?1638003612"},{"address":"0xa2776a53da0bf664ea34b8efa1c8ab4241a10968","name":"Blizzard Network","symbol":"BLIZZ","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/18446/thumb/blizz.PNG?1632059955"},{"address":"0x152b9d0fdc40c096757f570a51e494bd4b943e50","name":"Bitcoin Avalanche Bridged  BTC b ","symbol":"BTCB","decimals":8,"logoURI":"https://assets.coingecko.com/coins/images/26115/thumb/btcb.png?1655921693"},{"address":"0xb27c8941a7df8958a1778c0259f76d1f8b711c35","name":"Kalao","symbol":"KLO","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/18641/thumb/KALAO.jpg?1632752637"},{"address":"0x60781c2586d68229fde47564546784ab3faca982","name":"Pangolin","symbol":"PNG","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/14023/thumb/PNG_token.png?1675590250"},{"address":"0x22d4002028f537599be9f666d1c4fa138522f9c8","name":"Platypus Finance","symbol":"PTP","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/21724/thumb/7r2U_2Ig_400x400.jpg?1639961666"},{"address":"0xe6d1afea0b76c8f51024683dd27fa446ddaf34b6","name":"Frozen Walrus Share","symbol":"WSHARE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/25866/thumb/3.png?1667726765"},{"address":"0xfac235f442ed946087c1db9f70075b51e698a487","name":"Pterosaur Finance","symbol":"PTER","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29348/thumb/pterosaur-coin%28200-200%29.png?1678261284"},{"address":"0x440abbf18c54b2782a4917b80a1746d3a2c2cce1","name":"Shibavax","symbol":"SHIBX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/17913/thumb/Logo_Shibx_200x200.jpg?1674723495"},{"address":"0x6e84a6216ea6dacc71ee8e6b0a5b7322eebc0fdd","name":"JOE","symbol":"JOE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/17569/thumb/traderjoe.png?1685690062"},{"address":"0xeb8343d5284caec921f035207ca94db6baaacbcd","name":"Echidna","symbol":"ECD","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/24000/thumb/ecd.png?1645961865"},{"address":"0xc11bf915db4b43714bc8d32bf83bf5ea53d40981","name":"Cheems Inu  NEW ","symbol":"CINU","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/29393/thumb/cinu.png?1678506316"},{"address":"0x111111111111ed1d73f860f57b2798b683f2d325","name":"YUSD Stablecoin","symbol":"YUSD","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/25024/thumb/1_oJ0F2Zf6CuAhLP0zOboo6w.png?1649837252"},{"address":"0x48f88a3fe843ccb0b5003e70b4192c1d7448bef0","name":"Colony Avalanche Index","symbol":"CAI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/27196/thumb/CAI_logo.png?1662549770"},{"address":"0x3712871408a829c5cd4e86da1f4ce727efcd28f6","name":"Glacier","symbol":"GLCR","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29803/thumb/glacier.PNG?1681356808"},{"address":"0x6e7f5c0b9f4432716bdd0a77a3601291b9d9e985","name":"Spore","symbol":"SPORE","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/14470/thumb/SPORE.png?1616567184"},{"address":"0x59414b3089ce2af0010e7523dea7e2b35d776ec7","name":"Yield Yak","symbol":"YAK","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/17654/thumb/yieldyak.png?1665824438"},{"address":"0x449674b82f05d498e126dd6615a1057a9c088f2c","name":"Lost World","symbol":"LOST","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/24921/thumb/logo.png?1649383661"},{"address":"0xa32608e873f9ddef944b24798db69d80bbb4d1ed","name":"Crabada","symbol":"CRA","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/20011/thumb/crabada_icon_%281%29.png?1636372872"},{"address":"0x31c994ac062c1970c086260bc61babb708643fac","name":"XANA","symbol":"XETA","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/24379/thumb/XANA_Logo_neon_pink.png?1658197388"},{"address":"0x2b2c81e08f1af8835a78bb2a90ae924ace0ea4be","name":"BENQI Liquid Staked AVAX","symbol":"SAVAX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/23657/thumb/savax_blue.png?1644989825"},{"address":"0xb54f16fb19478766a268f172c9480f8da1a7c9c3","name":"Wonderland TIME","symbol":"TIME","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/18126/thumb/time.PNG?1630621941"},{"address":"0x32975907733f93305be28e2bfd123666b7a9c863","name":"Ink Fantom","symbol":"INK","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/23511/thumb/v3INKLogo-03.png?1694426392"},{"address":"0x3ab1c9adb065f3fca0059652cd7a52b05c98f9a9","name":"Orbs","symbol":"ORBS","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/4630/thumb/Orbs.jpg?1547039896"},{"address":"0x5ecfec22aa950cb5a3b4fd7249dc30b2bd160f18","name":"Tarot","symbol":"TAROT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31800/thumb/TAROT.jpg?1695096221"},{"address":"0xdf474b7109b73b7d57926d43598d5934131136b2","name":"Ankr Network","symbol":"ANKR","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/4324/thumb/U85xTl2.png?1608111978"},{"address":"0x1e2c4fb7ede391d116e6b41cd0608260e8801d59","name":"Backed CSPX Core S P 500","symbol":"BCSPX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31891/thumb/b-CSPX-200x200.png?1695624236"},{"address":"0x20c64dee8fda5269a78f2d5bdba861ca1d83df7a","name":"Backed HIGH   High Yield Corp Bond","symbol":"BHIGH","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31868/thumb/b-HIGH-200x200.png?1695350464"},{"address":"0x2f123cf3f37ce3328cc9b5b8415f9ec5109b45e7","name":"Backed GOVIES 0 6 months EURO","symbol":"BC3M","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31870/thumb/b-C3-M-200x200.png?1695351313"},{"address":"0x52d134c6db5889fad3542a09eaf7aa90c0fdf9e4","name":"Backed IBTA   Treasury Bond 1 3yr","symbol":"BIBTA","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31880/thumb/b-IBTA-200x200.png?1695366147"},{"address":"0xaf20f5f19698f1d19351028cd7103b63d30de7d7","name":"Wagmi","symbol":"WAGMI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31887/thumb/wagmi_token_logo.png?1695372579"},{"address":"0x2f11eeee0bf21e7661a22dbbbb9068f4ad191b86","name":"Backed NIU Technologies","symbol":"BNIU","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31869/thumb/b-NIU-200x200.png?1695351158"},{"address":"0xbbcb0356bb9e6b3faa5cbf9e5f36185d53403ac9","name":"Backed Coinbase Global","symbol":"BCOIN","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31872/thumb/b-COIN-200x200.png?1695351481"},{"address":"0x228a48df6819ccc2eca01e2192ebafffdad56c19","name":"VNX Swiss Franc","symbol":"VCHF","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29547/thumb/VNXCHF_%282%29.png?1679561328"},{"address":"0x431d5dff03120afa4bdf332c61a6e1766ef37bdb","name":"JPY Coin","symbol":"JPYC","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/25971/thumb/2023jpyc.png?1675935375"},{"address":"0x9bedce29f79076b21dd04958a9fd4b22f63fd86d","name":"Freebie Life Finance","symbol":"FRB","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/26262/thumb/Logo_%28200x200%29.png?1656942812"},{"address":"0x491a4eb4f1fc3bff8e1d2fc856a6a46663ad556f","name":"Brazilian Digital","symbol":"BRZ","decimals":4,"logoURI":"https://assets.coingecko.com/coins/images/8472/thumb/MicrosoftTeams-image_%286%29.png?1674480131"},{"address":"0x99083d1b9c6744c71d0cf70b8965faca37684527","name":"FRANCE REV FINANCE","symbol":"FRF","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/22224/thumb/LOGO200_FRF.png?1641218289"},{"address":"0x1fe70939c2cec8f31e8f7729442658586b469972","name":"GMD","symbol":"GMD","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/28088/thumb/gmd.png?1676044809"},{"address":"0x820802fa8a99901f52e39acd21177b0be6ee2974","name":"EUROe Stablecoin","symbol":"EUROE","decimals":6,"logoURI":"https://assets.coingecko.com/coins/images/28913/thumb/euroe-200x200-round.png?1675338103"},{"address":"0x644192291cc835a93d6330b24ea5f5fedd0eef9e","name":"AllianceBlock Nexera","symbol":"NXRA","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29181/thumb/nxra.png?1677148772"},{"address":"0x1e3c6c53f9f60bf8aae0d7774c21fa6b1afddc57","name":"xShrap","symbol":"XSHRAP","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29346/thumb/xshrapnel.png?1678253037"},{"address":"0x089d3daf549f99553c2182db24bc4336a4f0c824","name":"Impermax","symbol":"IBEX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/27606/thumb/IqwOmX-c_400x400.jpeg?1664846656"},{"address":"0x9df4ac62f9e435dbcd85e06c990a7f0ea32739a9","name":"Granary","symbol":"GRAIN","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29740/thumb/Grain.png?1681096624"},{"address":"0x2c69095d81305f1e3c6ed372336d407231624cea","name":"OATH","symbol":"OATH","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/24075/thumb/oldOATH_2023.png?1692667545"},{"address":"0x7678e162f38ec9ef2bfd1d0aaf9fd93355e5fa0b","name":"VNX EURO","symbol":"VEUR","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29351/thumb/VNXEUR_%281%29.png?1678262021"},{"address":"0x8908ea968d2f79d078d893c0bcecd63eacdd9322","name":"Libera Financial","symbol":"LIBERA","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/26194/thumb/20791.png?1656403503"},{"address":"0xc685e8eddc9f078666794cbfcd8d8351bac404ef","name":"ULTRON","symbol":"ULX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/26977/thumb/ULTRON-Profile-Pic.jpg?1690184603"},{"address":"0x12d8ce035c5de3ce39b1fdd4c1d5a745eaba3b8c","name":"Ankr Staked ETH","symbol":"ANKRETH","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/13403/thumb/aETHc.png?1625756490"},{"address":"0xe15bcb9e0ea69e6ab9fa080c4c4a5632896298c3","name":"Balancer","symbol":"BAL","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/11683/thumb/Balancer.png?1592792958"},{"address":"0x08d58f06ddfa9b99ae651f68232014be3914c5cd","name":"Ethos Reserve Note","symbol":"ERN","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29744/thumb/ERN200x200.png?1681106290"},{"address":"0x9c9e5fd8bbc25984b178fdce6117defa39d2db39","name":"Binance Peg BUSD","symbol":"BUSD","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31273/thumb/new_binance-peg-busd.png?1692097938"},{"address":"0x8929e9dbd2785e3ba16175e596cdd61520fee0d1","name":"Altitude","symbol":"ALTD","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30114/thumb/logo.png?1683102953"},{"address":"0xd47e4f1ef1aa4090bc27420bdd5cb379ced81440","name":"NFTEarth","symbol":"NFTE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29116/thumb/20230223_224134.jpg?1677224110"},{"address":"0x09211dc67f9fe98fb7bbb91be0ef05f4a12fa2b2","name":"Space Token BSC","symbol":"SPACE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/20676/thumb/jYw3kgsY_400x400.png?1637550733"},{"address":"0xd3ac016b1b8c80eeadde4d186a9138c9324e4189","name":"Okcash","symbol":"OK","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/274/thumb/ok-logo-200px.png?1665792994"},{"address":"0x0cbd6fadcf8096cc9a43d90b45f65826102e3ece","name":"CheckDot","symbol":"CDT","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/20370/thumb/token-200x200_%281%29.png?1636949075"},{"address":"0x9b06f3c5de42d4623d7a2bd940ec735103c68a76","name":"Volta Club","symbol":"VOLTA","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31602/thumb/volta-200x200.png?1693996744"},{"address":"0x333000333b26ee30214b4af6419d9ab07a450400","name":"MELD","symbol":"MELD","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/30170/thumb/Twitter.jpg?1683534747"},{"address":"0x590eb2920486486c2d9bb3eb651f73b81df87bcf","name":"Bobcoin","symbol":"BOBC","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/24264/thumb/bobc.png?1647171532"},{"address":"0x9ed7e4b1bff939ad473da5e7a218c771d1569456","name":"Reunit Wallet","symbol":"REUNI","decimals":6,"logoURI":"https://assets.coingecko.com/coins/images/29492/thumb/reunit_200.png?1679280627"},{"address":"0x11d6dd25c1695764e64f439e32cc7746f3945543","name":"Soul Swap","symbol":"SOUL","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/18581/thumb/soul.jpg?1632491969"},{"address":"0x945ca41d03ec19b6a6ebf2ef0f4d0a50b23e4f2c","name":"GRELF","symbol":"GRELF","decimals":8,"logoURI":"https://assets.coingecko.com/coins/images/29656/thumb/GRELF_Token_Icon.png?1680497527"},{"address":"0xc891eb4cbdeff6e073e859e987815ed1505c2acd","name":"EURC","symbol":"EURC","decimals":6,"logoURI":"https://assets.coingecko.com/coins/images/26045/thumb/euro.png?1695374456"},{"address":"0xe397784960f814ba35c9ee0bc4c9dffdf86925f9","name":"Monsterra","symbol":"MSTR","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/24377/thumb/MSTR.png?1660801591"},{"address":"0x444444444444c1a66f394025ac839a535246fcc8","name":"Genius","symbol":"GENI","decimals":9,"logoURI":"https://assets.coingecko.com/coins/images/28621/thumb/GENI200x200.png?1672707726"}]},{"chainId":"59144","name":"Linea","tokens":[{"address":"0x0000000000000000000000000000000000000000","name":"Linea Ether","symbol":"ETH","decimals":18,"logoURI":"https://ipfs.io/ipfs/QmURjritnHL7a8TwZgsFwp3f272DJmG5paaPtWDZ98QZwH"},{"address":"0xcc22f6aa610d1b2a0e89ef228079cb3e1831b1d1","name":"Linea Velocore","symbol":"LVC","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31537/thumb/LVC.png?1693788207"},{"address":"0xe5d7c2a44ffddf6b295a15c148167daaaf5cf34f","name":"Wrapped Ether  Linea ","symbol":"WETH","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31019/thumb/download_%2817%29.png?1689828171"},{"address":"0x176211869ca2b568f2a7d4ee941e073a821ee1ff","name":"Bridged USD Coin  Linea ","symbol":"USDC","decimals":6,"logoURI":"https://assets.coingecko.com/coins/images/31270/thumb/USDC-icon.png?1692091139"},{"address":"0xa219439258ca9da29e9cc4ce5596924745e12b93","name":"Bridged Tether  Linea ","symbol":"USDT","decimals":6,"logoURI":"https://assets.coingecko.com/coins/images/31271/thumb/usdt.jpeg?1692092485"},{"address":"0x0963a1abaf36ca88c21032b82e479353126a1c4b","name":"LeetSwap  Linea ","symbol":"LEET","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31128/thumb/leet.png?1690856071"},{"address":"0x9201f3b9dfab7c13cd659ac5695d12d605b5f1e6","name":"EchoDEX Community Portion","symbol":"ECP","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31112/thumb/EchoDex.logo.200x200_%281%29.png?1690525270"},{"address":"0x43e8809ea748eff3204ee01f08872f063e44065f","name":"Mendi Finance","symbol":"MENDI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31418/thumb/mendi_finance_token_logo_v1.png?1692850182"},{"address":"0x7d43aabc515c356145049227cee54b608342c0ad","name":"Binance USD  Linea ","symbol":"BUSD","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31020/thumb/download_%2816%29.png?1689828129"},{"address":"0x4af15ec2a0bd43db75dd04e62faa3b8ef36b00d5","name":"Bridged Dai Stablecoin  Linea ","symbol":"DAI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31272/thumb/dai-stablecoin.png?1692092750"},{"address":"0x0b1a02a7309dfbfad1cd4adc096582c87e8a3ac1","name":"Horizon","symbol":"HZN","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31156/thumb/Circle_logo_black_%281%29.png?1691040942"},{"address":"0xec4cb1148ec60e00a6bfcfce4482db724db6bdde","name":"Swirl Protocol","symbol":"SWI","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31263/thumb/256.png?1692067005"},{"address":"0xeb466342c4d449bc9f53a865d5cb90586f405215","name":"Bridged USD Coin  Axelar ","symbol":"AXLUSDC","decimals":6,"logoURI":"https://assets.coingecko.com/coins/images/26476/thumb/uausdc_D_3x.png?1690776252"},{"address":"0x6ef95b6f3b0f39508e3e04054be96d5ee39ede0d","name":"Symbiosis","symbol":"SIS","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/20805/thumb/SymbiosisFinance_logo-150x150.jpeg?1637707064"},{"address":"0xf5c6825015280cdfd0b56903f9f8b5a2233476f5","name":"Wrapped BNB","symbol":"WBNB","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/12591/thumb/binance-coin-logo.png?1600947313"},{"address":"0x265b25e22bcd7f10a5bd6e6410f10537cc7567e8","name":"Wrapped Matic","symbol":"WMATIC","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/14073/thumb/matic.png?1628852392"},{"address":"0x2140ea50bc3b6ac3971f9e9ea93a1442665670e4","name":"NFTEarth","symbol":"NFTE","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29116/thumb/20230223_224134.jpg?1677224110"},{"address":"0xb79dd08ea68a908a97220c76d19a6aa9cbde4376","name":"Overnight fi USD ","symbol":"USD+","decimals":6,"logoURI":"https://assets.coingecko.com/coins/images/25757/thumb/USD__logo.png?1653519267"},{"address":"0x5471ea8f739dd37e9b81be9c5c77754d8aa953e4","name":"Wrapped AVAX","symbol":"WAVAX","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/15075/thumb/wrapped-avax.png?1629873618"},{"address":"0x13a7f090d46c74acba98c51786a5c46ed9a474f0","name":"ScamFari","symbol":"SCM","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/31267/thumb/Ava_Scamfari_%281%29.png?1692069166"},{"address":"0xa334884bf6b0a066d553d19e507315e839409e62","name":"Ethos Reserve Note","symbol":"ERN","decimals":18,"logoURI":"https://assets.coingecko.com/coins/images/29744/thumb/ERN200x200.png?1681106290"}]},{"chainId":"59140","name":"Linea Testnet","tokens":[{"address":"0x0000000000000000000000000000000000000000","name":"Linea Ether","symbol":"ETH","decimals":18,"logoURI":"https://ipfs.io/ipfs/QmURjritnHL7a8TwZgsFwp3f272DJmG5paaPtWDZ98QZwH"}]}]');
;// CONCATENATED MODULE: ./src/data/package.json
const package_namespaceObject = {"i8":"0.2.24"};
;// CONCATENATED MODULE: ./src/data.ts











var VERSION = package_namespaceObject.i8;

// CONSTANTS
var TOKEN_TYPES = Object.freeze({
  ETH: 0,
  ERC20: 1,
  ERC721: 2,
  ERC1155: 3
});
var DEFAULT_CONTRACT_VERSION = 'v4';
var FALLBACK_CONTRACT_VERSION = 'v3';
var DEFAULT_BATCHER_VERSION = 'Bv4';

// export all these functions (imported in index.js)

;// CONCATENATED MODULE: ./src/config.ts
var config = {
  verbose: false
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+hash@5.7.0/node_modules/@ethersproject/hash/lib.esm/message.js



const messagePrefix = "\x19Ethereum Signed Message:\n";
function hashMessage(message) {
    if (typeof (message) === "string") {
        message = toUtf8Bytes(message);
    }
    return lib_esm_keccak256(lib_esm_concat([
        toUtf8Bytes(messagePrefix),
        toUtf8Bytes(String(message.length)),
        message
    ]));
}
//# sourceMappingURL=message.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+pbkdf2@5.7.0/node_modules/@ethersproject/pbkdf2/lib.esm/pbkdf2.js



function pbkdf2(password, salt, iterations, keylen, hashAlgorithm) {
    password = lib_esm_arrayify(password);
    salt = lib_esm_arrayify(salt);
    let hLen;
    let l = 1;
    const DK = new Uint8Array(keylen);
    const block1 = new Uint8Array(salt.length + 4);
    block1.set(salt);
    //salt.copy(block1, 0, 0, salt.length)
    let r;
    let T;
    for (let i = 1; i <= l; i++) {
        //block1.writeUInt32BE(i, salt.length)
        block1[salt.length] = (i >> 24) & 0xff;
        block1[salt.length + 1] = (i >> 16) & 0xff;
        block1[salt.length + 2] = (i >> 8) & 0xff;
        block1[salt.length + 3] = i & 0xff;
        //let U = createHmac(password).update(block1).digest();
        let U = lib_esm_arrayify(computeHmac(hashAlgorithm, password, block1));
        if (!hLen) {
            hLen = U.length;
            T = new Uint8Array(hLen);
            l = Math.ceil(keylen / hLen);
            r = keylen - (l - 1) * hLen;
        }
        //U.copy(T, 0, 0, hLen)
        T.set(U);
        for (let j = 1; j < iterations; j++) {
            //U = createHmac(password).update(U).digest();
            U = lib_esm_arrayify(computeHmac(hashAlgorithm, password, U));
            for (let k = 0; k < hLen; k++)
                T[k] ^= U[k];
        }
        const destPos = (i - 1) * hLen;
        const len = (i === l ? r : hLen);
        //T.copy(DK, destPos, 0, len)
        DK.set(lib_esm_arrayify(T).slice(0, len), destPos);
    }
    return lib_esm_hexlify(DK);
}
//# sourceMappingURL=pbkdf2.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+wordlists@5.7.0/node_modules/@ethersproject/wordlists/lib.esm/_version.js
const wordlists_lib_esm_version_version = "wordlists/5.7.0";
//# sourceMappingURL=_version.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+wordlists@5.7.0/node_modules/@ethersproject/wordlists/lib.esm/wordlist.js

// This gets overridden by rollup
const exportWordlist = false;




const wordlist_logger = new lib_esm_Logger(wordlists_lib_esm_version_version);
class Wordlist {
    constructor(locale) {
        wordlist_logger.checkAbstract(new.target, Wordlist);
        lib_esm_defineReadOnly(this, "locale", locale);
    }
    // Subclasses may override this
    split(mnemonic) {
        return mnemonic.toLowerCase().split(/ +/g);
    }
    // Subclasses may override this
    join(words) {
        return words.join(" ");
    }
    static check(wordlist) {
        const words = [];
        for (let i = 0; i < 2048; i++) {
            const word = wordlist.getWord(i);
            /* istanbul ignore if */
            if (i !== wordlist.getWordIndex(word)) {
                return "0x";
            }
            words.push(word);
        }
        return id(words.join("\n") + "\n");
    }
    static register(lang, name) {
        if (!name) {
            name = lang.locale;
        }
        /* istanbul ignore if */
        if (exportWordlist) {
            try {
                const anyGlobal = window;
                if (anyGlobal._ethers && anyGlobal._ethers.wordlists) {
                    if (!anyGlobal._ethers.wordlists[name]) {
                        lib_esm_defineReadOnly(anyGlobal._ethers.wordlists, name, lang);
                    }
                }
            }
            catch (error) { }
        }
    }
}
//# sourceMappingURL=wordlist.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+wordlists@5.7.0/node_modules/@ethersproject/wordlists/lib.esm/lang-en.js


const words = "AbandonAbilityAbleAboutAboveAbsentAbsorbAbstractAbsurdAbuseAccessAccidentAccountAccuseAchieveAcidAcousticAcquireAcrossActActionActorActressActualAdaptAddAddictAddressAdjustAdmitAdultAdvanceAdviceAerobicAffairAffordAfraidAgainAgeAgentAgreeAheadAimAirAirportAisleAlarmAlbumAlcoholAlertAlienAllAlleyAllowAlmostAloneAlphaAlreadyAlsoAlterAlwaysAmateurAmazingAmongAmountAmusedAnalystAnchorAncientAngerAngleAngryAnimalAnkleAnnounceAnnualAnotherAnswerAntennaAntiqueAnxietyAnyApartApologyAppearAppleApproveAprilArchArcticAreaArenaArgueArmArmedArmorArmyAroundArrangeArrestArriveArrowArtArtefactArtistArtworkAskAspectAssaultAssetAssistAssumeAsthmaAthleteAtomAttackAttendAttitudeAttractAuctionAuditAugustAuntAuthorAutoAutumnAverageAvocadoAvoidAwakeAwareAwayAwesomeAwfulAwkwardAxisBabyBachelorBaconBadgeBagBalanceBalconyBallBambooBananaBannerBarBarelyBargainBarrelBaseBasicBasketBattleBeachBeanBeautyBecauseBecomeBeefBeforeBeginBehaveBehindBelieveBelowBeltBenchBenefitBestBetrayBetterBetweenBeyondBicycleBidBikeBindBiologyBirdBirthBitterBlackBladeBlameBlanketBlastBleakBlessBlindBloodBlossomBlouseBlueBlurBlushBoardBoatBodyBoilBombBoneBonusBookBoostBorderBoringBorrowBossBottomBounceBoxBoyBracketBrainBrandBrassBraveBreadBreezeBrickBridgeBriefBrightBringBriskBroccoliBrokenBronzeBroomBrotherBrownBrushBubbleBuddyBudgetBuffaloBuildBulbBulkBulletBundleBunkerBurdenBurgerBurstBusBusinessBusyButterBuyerBuzzCabbageCabinCableCactusCageCakeCallCalmCameraCampCanCanalCancelCandyCannonCanoeCanvasCanyonCapableCapitalCaptainCarCarbonCardCargoCarpetCarryCartCaseCashCasinoCastleCasualCatCatalogCatchCategoryCattleCaughtCauseCautionCaveCeilingCeleryCementCensusCenturyCerealCertainChairChalkChampionChangeChaosChapterChargeChaseChatCheapCheckCheeseChefCherryChestChickenChiefChildChimneyChoiceChooseChronicChuckleChunkChurnCigarCinnamonCircleCitizenCityCivilClaimClapClarifyClawClayCleanClerkCleverClickClientCliffClimbClinicClipClockClogCloseClothCloudClownClubClumpClusterClutchCoachCoastCoconutCodeCoffeeCoilCoinCollectColorColumnCombineComeComfortComicCommonCompanyConcertConductConfirmCongressConnectConsiderControlConvinceCookCoolCopperCopyCoralCoreCornCorrectCostCottonCouchCountryCoupleCourseCousinCoverCoyoteCrackCradleCraftCramCraneCrashCraterCrawlCrazyCreamCreditCreekCrewCricketCrimeCrispCriticCropCrossCrouchCrowdCrucialCruelCruiseCrumbleCrunchCrushCryCrystalCubeCultureCupCupboardCuriousCurrentCurtainCurveCushionCustomCuteCycleDadDamageDampDanceDangerDaringDashDaughterDawnDayDealDebateDebrisDecadeDecemberDecideDeclineDecorateDecreaseDeerDefenseDefineDefyDegreeDelayDeliverDemandDemiseDenialDentistDenyDepartDependDepositDepthDeputyDeriveDescribeDesertDesignDeskDespairDestroyDetailDetectDevelopDeviceDevoteDiagramDialDiamondDiaryDiceDieselDietDifferDigitalDignityDilemmaDinnerDinosaurDirectDirtDisagreeDiscoverDiseaseDishDismissDisorderDisplayDistanceDivertDivideDivorceDizzyDoctorDocumentDogDollDolphinDomainDonateDonkeyDonorDoorDoseDoubleDoveDraftDragonDramaDrasticDrawDreamDressDriftDrillDrinkDripDriveDropDrumDryDuckDumbDuneDuringDustDutchDutyDwarfDynamicEagerEagleEarlyEarnEarthEasilyEastEasyEchoEcologyEconomyEdgeEditEducateEffortEggEightEitherElbowElderElectricElegantElementElephantElevatorEliteElseEmbarkEmbodyEmbraceEmergeEmotionEmployEmpowerEmptyEnableEnactEndEndlessEndorseEnemyEnergyEnforceEngageEngineEnhanceEnjoyEnlistEnoughEnrichEnrollEnsureEnterEntireEntryEnvelopeEpisodeEqualEquipEraEraseErodeErosionErrorEruptEscapeEssayEssenceEstateEternalEthicsEvidenceEvilEvokeEvolveExactExampleExcessExchangeExciteExcludeExcuseExecuteExerciseExhaustExhibitExileExistExitExoticExpandExpectExpireExplainExposeExpressExtendExtraEyeEyebrowFabricFaceFacultyFadeFaintFaithFallFalseFameFamilyFamousFanFancyFantasyFarmFashionFatFatalFatherFatigueFaultFavoriteFeatureFebruaryFederalFeeFeedFeelFemaleFenceFestivalFetchFeverFewFiberFictionFieldFigureFileFilmFilterFinalFindFineFingerFinishFireFirmFirstFiscalFishFitFitnessFixFlagFlameFlashFlatFlavorFleeFlightFlipFloatFlockFloorFlowerFluidFlushFlyFoamFocusFogFoilFoldFollowFoodFootForceForestForgetForkFortuneForumForwardFossilFosterFoundFoxFragileFrameFrequentFreshFriendFringeFrogFrontFrostFrownFrozenFruitFuelFunFunnyFurnaceFuryFutureGadgetGainGalaxyGalleryGameGapGarageGarbageGardenGarlicGarmentGasGaspGateGatherGaugeGazeGeneralGeniusGenreGentleGenuineGestureGhostGiantGiftGiggleGingerGiraffeGirlGiveGladGlanceGlareGlassGlideGlimpseGlobeGloomGloryGloveGlowGlueGoatGoddessGoldGoodGooseGorillaGospelGossipGovernGownGrabGraceGrainGrantGrapeGrassGravityGreatGreenGridGriefGritGroceryGroupGrowGruntGuardGuessGuideGuiltGuitarGunGymHabitHairHalfHammerHamsterHandHappyHarborHardHarshHarvestHatHaveHawkHazardHeadHealthHeartHeavyHedgehogHeightHelloHelmetHelpHenHeroHiddenHighHillHintHipHireHistoryHobbyHockeyHoldHoleHolidayHollowHomeHoneyHoodHopeHornHorrorHorseHospitalHostHotelHourHoverHubHugeHumanHumbleHumorHundredHungryHuntHurdleHurryHurtHusbandHybridIceIconIdeaIdentifyIdleIgnoreIllIllegalIllnessImageImitateImmenseImmuneImpactImposeImproveImpulseInchIncludeIncomeIncreaseIndexIndicateIndoorIndustryInfantInflictInformInhaleInheritInitialInjectInjuryInmateInnerInnocentInputInquiryInsaneInsectInsideInspireInstallIntactInterestIntoInvestInviteInvolveIronIslandIsolateIssueItemIvoryJacketJaguarJarJazzJealousJeansJellyJewelJobJoinJokeJourneyJoyJudgeJuiceJumpJungleJuniorJunkJustKangarooKeenKeepKetchupKeyKickKidKidneyKindKingdomKissKitKitchenKiteKittenKiwiKneeKnifeKnockKnowLabLabelLaborLadderLadyLakeLampLanguageLaptopLargeLaterLatinLaughLaundryLavaLawLawnLawsuitLayerLazyLeaderLeafLearnLeaveLectureLeftLegLegalLegendLeisureLemonLendLengthLensLeopardLessonLetterLevelLiarLibertyLibraryLicenseLifeLiftLightLikeLimbLimitLinkLionLiquidListLittleLiveLizardLoadLoanLobsterLocalLockLogicLonelyLongLoopLotteryLoudLoungeLoveLoyalLuckyLuggageLumberLunarLunchLuxuryLyricsMachineMadMagicMagnetMaidMailMainMajorMakeMammalManManageMandateMangoMansionManualMapleMarbleMarchMarginMarineMarketMarriageMaskMassMasterMatchMaterialMathMatrixMatterMaximumMazeMeadowMeanMeasureMeatMechanicMedalMediaMelodyMeltMemberMemoryMentionMenuMercyMergeMeritMerryMeshMessageMetalMethodMiddleMidnightMilkMillionMimicMindMinimumMinorMinuteMiracleMirrorMiseryMissMistakeMixMixedMixtureMobileModelModifyMomMomentMonitorMonkeyMonsterMonthMoonMoralMoreMorningMosquitoMotherMotionMotorMountainMouseMoveMovieMuchMuffinMuleMultiplyMuscleMuseumMushroomMusicMustMutualMyselfMysteryMythNaiveNameNapkinNarrowNastyNationNatureNearNeckNeedNegativeNeglectNeitherNephewNerveNestNetNetworkNeutralNeverNewsNextNiceNightNobleNoiseNomineeNoodleNormalNorthNoseNotableNoteNothingNoticeNovelNowNuclearNumberNurseNutOakObeyObjectObligeObscureObserveObtainObviousOccurOceanOctoberOdorOffOfferOfficeOftenOilOkayOldOliveOlympicOmitOnceOneOnionOnlineOnlyOpenOperaOpinionOpposeOptionOrangeOrbitOrchardOrderOrdinaryOrganOrientOriginalOrphanOstrichOtherOutdoorOuterOutputOutsideOvalOvenOverOwnOwnerOxygenOysterOzonePactPaddlePagePairPalacePalmPandaPanelPanicPantherPaperParadeParentParkParrotPartyPassPatchPathPatientPatrolPatternPausePavePaymentPeacePeanutPearPeasantPelicanPenPenaltyPencilPeoplePepperPerfectPermitPersonPetPhonePhotoPhrasePhysicalPianoPicnicPicturePiecePigPigeonPillPilotPinkPioneerPipePistolPitchPizzaPlacePlanetPlasticPlatePlayPleasePledgePluckPlugPlungePoemPoetPointPolarPolePolicePondPonyPoolPopularPortionPositionPossiblePostPotatoPotteryPovertyPowderPowerPracticePraisePredictPreferPreparePresentPrettyPreventPricePridePrimaryPrintPriorityPrisonPrivatePrizeProblemProcessProduceProfitProgramProjectPromoteProofPropertyProsperProtectProudProvidePublicPuddingPullPulpPulsePumpkinPunchPupilPuppyPurchasePurityPurposePursePushPutPuzzlePyramidQualityQuantumQuarterQuestionQuickQuitQuizQuoteRabbitRaccoonRaceRackRadarRadioRailRainRaiseRallyRampRanchRandomRangeRapidRareRateRatherRavenRawRazorReadyRealReasonRebelRebuildRecallReceiveRecipeRecordRecycleReduceReflectReformRefuseRegionRegretRegularRejectRelaxReleaseReliefRelyRemainRememberRemindRemoveRenderRenewRentReopenRepairRepeatReplaceReportRequireRescueResembleResistResourceResponseResultRetireRetreatReturnReunionRevealReviewRewardRhythmRibRibbonRiceRichRideRidgeRifleRightRigidRingRiotRippleRiskRitualRivalRiverRoadRoastRobotRobustRocketRomanceRoofRookieRoomRoseRotateRoughRoundRouteRoyalRubberRudeRugRuleRunRunwayRuralSadSaddleSadnessSafeSailSaladSalmonSalonSaltSaluteSameSampleSandSatisfySatoshiSauceSausageSaveSayScaleScanScareScatterSceneSchemeSchoolScienceScissorsScorpionScoutScrapScreenScriptScrubSeaSearchSeasonSeatSecondSecretSectionSecuritySeedSeekSegmentSelectSellSeminarSeniorSenseSentenceSeriesServiceSessionSettleSetupSevenShadowShaftShallowShareShedShellSheriffShieldShiftShineShipShiverShockShoeShootShopShortShoulderShoveShrimpShrugShuffleShySiblingSickSideSiegeSightSignSilentSilkSillySilverSimilarSimpleSinceSingSirenSisterSituateSixSizeSkateSketchSkiSkillSkinSkirtSkullSlabSlamSleepSlenderSliceSlideSlightSlimSloganSlotSlowSlushSmallSmartSmileSmokeSmoothSnackSnakeSnapSniffSnowSoapSoccerSocialSockSodaSoftSolarSoldierSolidSolutionSolveSomeoneSongSoonSorrySortSoulSoundSoupSourceSouthSpaceSpareSpatialSpawnSpeakSpecialSpeedSpellSpendSphereSpiceSpiderSpikeSpinSpiritSplitSpoilSponsorSpoonSportSpotSpraySpreadSpringSpySquareSqueezeSquirrelStableStadiumStaffStageStairsStampStandStartStateStaySteakSteelStemStepStereoStickStillStingStockStomachStoneStoolStoryStoveStrategyStreetStrikeStrongStruggleStudentStuffStumbleStyleSubjectSubmitSubwaySuccessSuchSuddenSufferSugarSuggestSuitSummerSunSunnySunsetSuperSupplySupremeSureSurfaceSurgeSurpriseSurroundSurveySuspectSustainSwallowSwampSwapSwarmSwearSweetSwiftSwimSwingSwitchSwordSymbolSymptomSyrupSystemTableTackleTagTailTalentTalkTankTapeTargetTaskTasteTattooTaxiTeachTeamTellTenTenantTennisTentTermTestTextThankThatThemeThenTheoryThereTheyThingThisThoughtThreeThriveThrowThumbThunderTicketTideTigerTiltTimberTimeTinyTipTiredTissueTitleToastTobaccoTodayToddlerToeTogetherToiletTokenTomatoTomorrowToneTongueTonightToolToothTopTopicToppleTorchTornadoTortoiseTossTotalTouristTowardTowerTownToyTrackTradeTrafficTragicTrainTransferTrapTrashTravelTrayTreatTreeTrendTrialTribeTrickTriggerTrimTripTrophyTroubleTruckTrueTrulyTrumpetTrustTruthTryTubeTuitionTumbleTunaTunnelTurkeyTurnTurtleTwelveTwentyTwiceTwinTwistTwoTypeTypicalUglyUmbrellaUnableUnawareUncleUncoverUnderUndoUnfairUnfoldUnhappyUniformUniqueUnitUniverseUnknownUnlockUntilUnusualUnveilUpdateUpgradeUpholdUponUpperUpsetUrbanUrgeUsageUseUsedUsefulUselessUsualUtilityVacantVacuumVagueValidValleyValveVanVanishVaporVariousVastVaultVehicleVelvetVendorVentureVenueVerbVerifyVersionVeryVesselVeteranViableVibrantViciousVictoryVideoViewVillageVintageViolinVirtualVirusVisaVisitVisualVitalVividVocalVoiceVoidVolcanoVolumeVoteVoyageWageWagonWaitWalkWallWalnutWantWarfareWarmWarriorWashWaspWasteWaterWaveWayWealthWeaponWearWeaselWeatherWebWeddingWeekendWeirdWelcomeWestWetWhaleWhatWheatWheelWhenWhereWhipWhisperWideWidthWifeWildWillWinWindowWineWingWinkWinnerWinterWireWisdomWiseWishWitnessWolfWomanWonderWoodWoolWordWorkWorldWorryWorthWrapWreckWrestleWristWriteWrongYardYearYellowYouYoungYouthZebraZeroZoneZoo";
let wordlist = null;
function loadWords(lang) {
    if (wordlist != null) {
        return;
    }
    wordlist = words.replace(/([A-Z])/g, " $1").toLowerCase().substring(1).split(" ");
    // Verify the computed list matches the official list
    /* istanbul ignore if */
    if (Wordlist.check(lang) !== "0x3c8acc1e7b08d8e76f9fda015ef48dc8c710a73cb7e0f77b2c18a9b5a7adde60") {
        wordlist = null;
        throw new Error("BIP39 Wordlist for en (English) FAILED");
    }
}
class LangEn extends Wordlist {
    constructor() {
        super("en");
    }
    getWord(index) {
        loadWords(this);
        return wordlist[index];
    }
    getWordIndex(word) {
        loadWords(this);
        return wordlist.indexOf(word);
    }
}
const langEn = new LangEn();
Wordlist.register(langEn);

//# sourceMappingURL=lang-en.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+wordlists@5.7.0/node_modules/@ethersproject/wordlists/lib.esm/wordlists.js


const wordlists = {
    en: langEn
};
//# sourceMappingURL=wordlists.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+hdnode@5.7.0/node_modules/@ethersproject/hdnode/lib.esm/_version.js
const hdnode_lib_esm_version_version = "hdnode/5.7.0";
//# sourceMappingURL=_version.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+hdnode@5.7.0/node_modules/@ethersproject/hdnode/lib.esm/index.js













const hdnode_lib_esm_logger = new lib_esm_Logger(hdnode_lib_esm_version_version);
const N = bignumber_BigNumber.from("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141");
// "Bitcoin seed"
const MasterSecret = toUtf8Bytes("Bitcoin seed");
const HardenedBit = 0x80000000;
// Returns a byte with the MSB bits set
function getUpperMask(bits) {
    return ((1 << bits) - 1) << (8 - bits);
}
// Returns a byte with the LSB bits set
function getLowerMask(bits) {
    return (1 << bits) - 1;
}
function bytes32(value) {
    return hexZeroPad(lib_esm_hexlify(value), 32);
}
function base58check(data) {
    return Base58.encode(lib_esm_concat([data, lib_esm_hexDataSlice(sha256(sha256(data)), 0, 4)]));
}
function getWordlist(wordlist) {
    if (wordlist == null) {
        return wordlists["en"];
    }
    if (typeof (wordlist) === "string") {
        const words = wordlists[wordlist];
        if (words == null) {
            hdnode_lib_esm_logger.throwArgumentError("unknown locale", "wordlist", wordlist);
        }
        return words;
    }
    return wordlist;
}
const lib_esm_constructorGuard = {};
const defaultPath = "m/44'/60'/0'/0/0";
;
class HDNode {
    /**
     *  This constructor should not be called directly.
     *
     *  Please use:
     *   - fromMnemonic
     *   - fromSeed
     */
    constructor(constructorGuard, privateKey, publicKey, parentFingerprint, chainCode, index, depth, mnemonicOrPath) {
        /* istanbul ignore if */
        if (constructorGuard !== lib_esm_constructorGuard) {
            throw new Error("HDNode constructor cannot be called directly");
        }
        if (privateKey) {
            const signingKey = new SigningKey(privateKey);
            lib_esm_defineReadOnly(this, "privateKey", signingKey.privateKey);
            lib_esm_defineReadOnly(this, "publicKey", signingKey.compressedPublicKey);
        }
        else {
            lib_esm_defineReadOnly(this, "privateKey", null);
            lib_esm_defineReadOnly(this, "publicKey", lib_esm_hexlify(publicKey));
        }
        lib_esm_defineReadOnly(this, "parentFingerprint", parentFingerprint);
        lib_esm_defineReadOnly(this, "fingerprint", lib_esm_hexDataSlice(ripemd160(sha256(this.publicKey)), 0, 4));
        lib_esm_defineReadOnly(this, "address", computeAddress(this.publicKey));
        lib_esm_defineReadOnly(this, "chainCode", chainCode);
        lib_esm_defineReadOnly(this, "index", index);
        lib_esm_defineReadOnly(this, "depth", depth);
        if (mnemonicOrPath == null) {
            // From a source that does not preserve the path (e.g. extended keys)
            lib_esm_defineReadOnly(this, "mnemonic", null);
            lib_esm_defineReadOnly(this, "path", null);
        }
        else if (typeof (mnemonicOrPath) === "string") {
            // From a source that does not preserve the mnemonic (e.g. neutered)
            lib_esm_defineReadOnly(this, "mnemonic", null);
            lib_esm_defineReadOnly(this, "path", mnemonicOrPath);
        }
        else {
            // From a fully qualified source
            lib_esm_defineReadOnly(this, "mnemonic", mnemonicOrPath);
            lib_esm_defineReadOnly(this, "path", mnemonicOrPath.path);
        }
    }
    get extendedKey() {
        // We only support the mainnet values for now, but if anyone needs
        // testnet values, let me know. I believe current sentiment is that
        // we should always use mainnet, and use BIP-44 to derive the network
        //   - Mainnet: public=0x0488B21E, private=0x0488ADE4
        //   - Testnet: public=0x043587CF, private=0x04358394
        if (this.depth >= 256) {
            throw new Error("Depth too large!");
        }
        return base58check(lib_esm_concat([
            ((this.privateKey != null) ? "0x0488ADE4" : "0x0488B21E"),
            lib_esm_hexlify(this.depth),
            this.parentFingerprint,
            hexZeroPad(lib_esm_hexlify(this.index), 4),
            this.chainCode,
            ((this.privateKey != null) ? lib_esm_concat(["0x00", this.privateKey]) : this.publicKey),
        ]));
    }
    neuter() {
        return new HDNode(lib_esm_constructorGuard, null, this.publicKey, this.parentFingerprint, this.chainCode, this.index, this.depth, this.path);
    }
    _derive(index) {
        if (index > 0xffffffff) {
            throw new Error("invalid index - " + String(index));
        }
        // Base path
        let path = this.path;
        if (path) {
            path += "/" + (index & ~HardenedBit);
        }
        const data = new Uint8Array(37);
        if (index & HardenedBit) {
            if (!this.privateKey) {
                throw new Error("cannot derive child of neutered node");
            }
            // Data = 0x00 || ser_256(k_par)
            data.set(lib_esm_arrayify(this.privateKey), 1);
            // Hardened path
            if (path) {
                path += "'";
            }
        }
        else {
            // Data = ser_p(point(k_par))
            data.set(lib_esm_arrayify(this.publicKey));
        }
        // Data += ser_32(i)
        for (let i = 24; i >= 0; i -= 8) {
            data[33 + (i >> 3)] = ((index >> (24 - i)) & 0xff);
        }
        const I = lib_esm_arrayify(computeHmac(SupportedAlgorithm.sha512, this.chainCode, data));
        const IL = I.slice(0, 32);
        const IR = I.slice(32);
        // The private key
        let ki = null;
        // The public key
        let Ki = null;
        if (this.privateKey) {
            ki = bytes32(bignumber_BigNumber.from(IL).add(this.privateKey).mod(N));
        }
        else {
            const ek = new SigningKey(lib_esm_hexlify(IL));
            Ki = ek._addPoint(this.publicKey);
        }
        let mnemonicOrPath = path;
        const srcMnemonic = this.mnemonic;
        if (srcMnemonic) {
            mnemonicOrPath = Object.freeze({
                phrase: srcMnemonic.phrase,
                path: path,
                locale: (srcMnemonic.locale || "en")
            });
        }
        return new HDNode(lib_esm_constructorGuard, ki, Ki, this.fingerprint, bytes32(IR), index, this.depth + 1, mnemonicOrPath);
    }
    derivePath(path) {
        const components = path.split("/");
        if (components.length === 0 || (components[0] === "m" && this.depth !== 0)) {
            throw new Error("invalid path - " + path);
        }
        if (components[0] === "m") {
            components.shift();
        }
        let result = this;
        for (let i = 0; i < components.length; i++) {
            const component = components[i];
            if (component.match(/^[0-9]+'$/)) {
                const index = parseInt(component.substring(0, component.length - 1));
                if (index >= HardenedBit) {
                    throw new Error("invalid path index - " + component);
                }
                result = result._derive(HardenedBit + index);
            }
            else if (component.match(/^[0-9]+$/)) {
                const index = parseInt(component);
                if (index >= HardenedBit) {
                    throw new Error("invalid path index - " + component);
                }
                result = result._derive(index);
            }
            else {
                throw new Error("invalid path component - " + component);
            }
        }
        return result;
    }
    static _fromSeed(seed, mnemonic) {
        const seedArray = lib_esm_arrayify(seed);
        if (seedArray.length < 16 || seedArray.length > 64) {
            throw new Error("invalid seed");
        }
        const I = lib_esm_arrayify(computeHmac(SupportedAlgorithm.sha512, MasterSecret, seedArray));
        return new HDNode(lib_esm_constructorGuard, bytes32(I.slice(0, 32)), null, "0x00000000", bytes32(I.slice(32)), 0, 0, mnemonic);
    }
    static fromMnemonic(mnemonic, password, wordlist) {
        // If a locale name was passed in, find the associated wordlist
        wordlist = getWordlist(wordlist);
        // Normalize the case and spacing in the mnemonic (throws if the mnemonic is invalid)
        mnemonic = entropyToMnemonic(mnemonicToEntropy(mnemonic, wordlist), wordlist);
        return HDNode._fromSeed(mnemonicToSeed(mnemonic, password), {
            phrase: mnemonic,
            path: "m",
            locale: wordlist.locale
        });
    }
    static fromSeed(seed) {
        return HDNode._fromSeed(seed, null);
    }
    static fromExtendedKey(extendedKey) {
        const bytes = Base58.decode(extendedKey);
        if (bytes.length !== 82 || base58check(bytes.slice(0, 78)) !== extendedKey) {
            hdnode_lib_esm_logger.throwArgumentError("invalid extended key", "extendedKey", "[REDACTED]");
        }
        const depth = bytes[4];
        const parentFingerprint = lib_esm_hexlify(bytes.slice(5, 9));
        const index = parseInt(lib_esm_hexlify(bytes.slice(9, 13)).substring(2), 16);
        const chainCode = lib_esm_hexlify(bytes.slice(13, 45));
        const key = bytes.slice(45, 78);
        switch (lib_esm_hexlify(bytes.slice(0, 4))) {
            // Public Key
            case "0x0488b21e":
            case "0x043587cf":
                return new HDNode(lib_esm_constructorGuard, null, lib_esm_hexlify(key), parentFingerprint, chainCode, index, depth, null);
            // Private Key
            case "0x0488ade4":
            case "0x04358394 ":
                if (key[0] !== 0) {
                    break;
                }
                return new HDNode(lib_esm_constructorGuard, lib_esm_hexlify(key.slice(1)), null, parentFingerprint, chainCode, index, depth, null);
        }
        return hdnode_lib_esm_logger.throwArgumentError("invalid extended key", "extendedKey", "[REDACTED]");
    }
}
function mnemonicToSeed(mnemonic, password) {
    if (!password) {
        password = "";
    }
    const salt = toUtf8Bytes("mnemonic" + password, UnicodeNormalizationForm.NFKD);
    return pbkdf2(toUtf8Bytes(mnemonic, UnicodeNormalizationForm.NFKD), salt, 2048, 64, "sha512");
}
function mnemonicToEntropy(mnemonic, wordlist) {
    wordlist = getWordlist(wordlist);
    hdnode_lib_esm_logger.checkNormalize();
    const words = wordlist.split(mnemonic);
    if ((words.length % 3) !== 0) {
        throw new Error("invalid mnemonic");
    }
    const entropy = lib_esm_arrayify(new Uint8Array(Math.ceil(11 * words.length / 8)));
    let offset = 0;
    for (let i = 0; i < words.length; i++) {
        let index = wordlist.getWordIndex(words[i].normalize("NFKD"));
        if (index === -1) {
            throw new Error("invalid mnemonic");
        }
        for (let bit = 0; bit < 11; bit++) {
            if (index & (1 << (10 - bit))) {
                entropy[offset >> 3] |= (1 << (7 - (offset % 8)));
            }
            offset++;
        }
    }
    const entropyBits = 32 * words.length / 3;
    const checksumBits = words.length / 3;
    const checksumMask = getUpperMask(checksumBits);
    const checksum = lib_esm_arrayify(sha256(entropy.slice(0, entropyBits / 8)))[0] & checksumMask;
    if (checksum !== (entropy[entropy.length - 1] & checksumMask)) {
        throw new Error("invalid checksum");
    }
    return lib_esm_hexlify(entropy.slice(0, entropyBits / 8));
}
function entropyToMnemonic(entropy, wordlist) {
    wordlist = getWordlist(wordlist);
    entropy = lib_esm_arrayify(entropy);
    if ((entropy.length % 4) !== 0 || entropy.length < 16 || entropy.length > 32) {
        throw new Error("invalid entropy");
    }
    const indices = [0];
    let remainingBits = 11;
    for (let i = 0; i < entropy.length; i++) {
        // Consume the whole byte (with still more to go)
        if (remainingBits > 8) {
            indices[indices.length - 1] <<= 8;
            indices[indices.length - 1] |= entropy[i];
            remainingBits -= 8;
            // This byte will complete an 11-bit index
        }
        else {
            indices[indices.length - 1] <<= remainingBits;
            indices[indices.length - 1] |= entropy[i] >> (8 - remainingBits);
            // Start the next word
            indices.push(entropy[i] & getLowerMask(8 - remainingBits));
            remainingBits += 3;
        }
    }
    // Compute the checksum bits
    const checksumBits = entropy.length / 4;
    const checksum = lib_esm_arrayify(sha256(entropy))[0] & getUpperMask(checksumBits);
    // Shift the checksum into the word indices
    indices[indices.length - 1] <<= checksumBits;
    indices[indices.length - 1] |= (checksum >> (8 - checksumBits));
    return wordlist.join(indices.map((index) => wordlist.getWord(index)));
}
function isValidMnemonic(mnemonic, wordlist) {
    try {
        mnemonicToEntropy(mnemonic, wordlist);
        return true;
    }
    catch (error) { }
    return false;
}
function getAccountPath(index) {
    if (typeof (index) !== "number" || index < 0 || index >= HardenedBit || index % 1) {
        hdnode_lib_esm_logger.throwArgumentError("invalid account index", "index", index);
    }
    return `m/44'/60'/${index}'/0/0`;
}
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+random@5.7.0/node_modules/@ethersproject/random/lib.esm/_version.js
const random_lib_esm_version_version = "random/5.7.0";
//# sourceMappingURL=_version.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+random@5.7.0/node_modules/@ethersproject/random/lib.esm/random.js




const random_logger = new lib_esm_Logger(random_lib_esm_version_version);
// Debugging line for testing browser lib in node
//const window = { crypto: { getRandomValues: () => { } } };
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis
function getGlobal() {
    if (typeof self !== 'undefined') {
        return self;
    }
    if (typeof window !== 'undefined') {
        return window;
    }
    if (typeof __webpack_require__.g !== 'undefined') {
        return __webpack_require__.g;
    }
    throw new Error('unable to locate global object');
}
;
const anyGlobal = getGlobal();
let random_crypto = anyGlobal.crypto || anyGlobal.msCrypto;
if (!random_crypto || !random_crypto.getRandomValues) {
    random_logger.warn("WARNING: Missing strong random number source");
    random_crypto = {
        getRandomValues: function (buffer) {
            return random_logger.throwError("no secure random source avaialble", lib_esm_Logger.errors.UNSUPPORTED_OPERATION, {
                operation: "crypto.getRandomValues"
            });
        }
    };
}
function randomBytes(length) {
    if (length <= 0 || length > 1024 || (length % 1) || length != length) {
        random_logger.throwArgumentError("invalid length", "length", length);
    }
    const result = new Uint8Array(length);
    random_crypto.getRandomValues(result);
    return lib_esm_arrayify(result);
}
;
//# sourceMappingURL=random.js.map
// EXTERNAL MODULE: ./node_modules/.pnpm/aes-js@3.0.0/node_modules/aes-js/index.js
var aes_js = __webpack_require__(556);
var aes_js_default = /*#__PURE__*/__webpack_require__.n(aes_js);
// EXTERNAL MODULE: ./node_modules/.pnpm/scrypt-js@3.0.1/node_modules/scrypt-js/scrypt.js
var scrypt = __webpack_require__(495);
var scrypt_default = /*#__PURE__*/__webpack_require__.n(scrypt);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+json-wallets@5.7.0/node_modules/@ethersproject/json-wallets/lib.esm/utils.js



function looseArrayify(hexString) {
    if (typeof (hexString) === 'string' && hexString.substring(0, 2) !== '0x') {
        hexString = '0x' + hexString;
    }
    return lib_esm_arrayify(hexString);
}
function zpad(value, length) {
    value = String(value);
    while (value.length < length) {
        value = '0' + value;
    }
    return value;
}
function getPassword(password) {
    if (typeof (password) === 'string') {
        return toUtf8Bytes(password, UnicodeNormalizationForm.NFKC);
    }
    return lib_esm_arrayify(password);
}
function searchPath(object, path) {
    let currentChild = object;
    const comps = path.toLowerCase().split('/');
    for (let i = 0; i < comps.length; i++) {
        // Search for a child object with a case-insensitive matching key
        let matchingChild = null;
        for (const key in currentChild) {
            if (key.toLowerCase() === comps[i]) {
                matchingChild = currentChild[key];
                break;
            }
        }
        // Didn't find one. :'(
        if (matchingChild === null) {
            return null;
        }
        // Now check this child...
        currentChild = matchingChild;
    }
    return currentChild;
}
// See: https://www.ietf.org/rfc/rfc4122.txt (Section 4.4)
function uuidV4(randomBytes) {
    const bytes = lib_esm_arrayify(randomBytes);
    // Section: 4.1.3:
    // - time_hi_and_version[12:16] = 0b0100
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    // Section 4.4
    // - clock_seq_hi_and_reserved[6] = 0b0
    // - clock_seq_hi_and_reserved[7] = 0b1
    bytes[8] = (bytes[8] & 0x3f) | 0x80;
    const value = lib_esm_hexlify(bytes);
    return [
        value.substring(2, 10),
        value.substring(10, 14),
        value.substring(14, 18),
        value.substring(18, 22),
        value.substring(22, 34),
    ].join("-");
}
//# sourceMappingURL=utils.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+json-wallets@5.7.0/node_modules/@ethersproject/json-wallets/lib.esm/_version.js
const json_wallets_lib_esm_version_version = "json-wallets/5.7.0";
//# sourceMappingURL=_version.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+json-wallets@5.7.0/node_modules/@ethersproject/json-wallets/lib.esm/keystore.js

var keystore_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};













const keystore_logger = new lib_esm_Logger(json_wallets_lib_esm_version_version);
// Exported Types
function hasMnemonic(value) {
    return (value != null && value.mnemonic && value.mnemonic.phrase);
}
class KeystoreAccount extends Description {
    isKeystoreAccount(value) {
        return !!(value && value._isKeystoreAccount);
    }
}
function _decrypt(data, key, ciphertext) {
    const cipher = searchPath(data, "crypto/cipher");
    if (cipher === "aes-128-ctr") {
        const iv = looseArrayify(searchPath(data, "crypto/cipherparams/iv"));
        const counter = new (aes_js_default()).Counter(iv);
        const aesCtr = new (aes_js_default()).ModeOfOperation.ctr(key, counter);
        return lib_esm_arrayify(aesCtr.decrypt(ciphertext));
    }
    return null;
}
function _getAccount(data, key) {
    const ciphertext = looseArrayify(searchPath(data, "crypto/ciphertext"));
    const computedMAC = lib_esm_hexlify(lib_esm_keccak256(lib_esm_concat([key.slice(16, 32), ciphertext]))).substring(2);
    if (computedMAC !== searchPath(data, "crypto/mac").toLowerCase()) {
        throw new Error("invalid password");
    }
    const privateKey = _decrypt(data, key.slice(0, 16), ciphertext);
    if (!privateKey) {
        keystore_logger.throwError("unsupported cipher", lib_esm_Logger.errors.UNSUPPORTED_OPERATION, {
            operation: "decrypt"
        });
    }
    const mnemonicKey = key.slice(32, 64);
    const address = computeAddress(privateKey);
    if (data.address) {
        let check = data.address.toLowerCase();
        if (check.substring(0, 2) !== "0x") {
            check = "0x" + check;
        }
        if (lib_esm_getAddress(check) !== address) {
            throw new Error("address mismatch");
        }
    }
    const account = {
        _isKeystoreAccount: true,
        address: address,
        privateKey: lib_esm_hexlify(privateKey)
    };
    // Version 0.1 x-ethers metadata must contain an encrypted mnemonic phrase
    if (searchPath(data, "x-ethers/version") === "0.1") {
        const mnemonicCiphertext = looseArrayify(searchPath(data, "x-ethers/mnemonicCiphertext"));
        const mnemonicIv = looseArrayify(searchPath(data, "x-ethers/mnemonicCounter"));
        const mnemonicCounter = new (aes_js_default()).Counter(mnemonicIv);
        const mnemonicAesCtr = new (aes_js_default()).ModeOfOperation.ctr(mnemonicKey, mnemonicCounter);
        const path = searchPath(data, "x-ethers/path") || defaultPath;
        const locale = searchPath(data, "x-ethers/locale") || "en";
        const entropy = lib_esm_arrayify(mnemonicAesCtr.decrypt(mnemonicCiphertext));
        try {
            const mnemonic = entropyToMnemonic(entropy, locale);
            const node = HDNode.fromMnemonic(mnemonic, null, locale).derivePath(path);
            if (node.privateKey != account.privateKey) {
                throw new Error("mnemonic mismatch");
            }
            account.mnemonic = node.mnemonic;
        }
        catch (error) {
            // If we don't have the locale wordlist installed to
            // read this mnemonic, just bail and don't set the
            // mnemonic
            if (error.code !== lib_esm_Logger.errors.INVALID_ARGUMENT || error.argument !== "wordlist") {
                throw error;
            }
        }
    }
    return new KeystoreAccount(account);
}
function pbkdf2Sync(passwordBytes, salt, count, dkLen, prfFunc) {
    return lib_esm_arrayify(pbkdf2(passwordBytes, salt, count, dkLen, prfFunc));
}
function keystore_pbkdf2(passwordBytes, salt, count, dkLen, prfFunc) {
    return Promise.resolve(pbkdf2Sync(passwordBytes, salt, count, dkLen, prfFunc));
}
function _computeKdfKey(data, password, pbkdf2Func, scryptFunc, progressCallback) {
    const passwordBytes = getPassword(password);
    const kdf = searchPath(data, "crypto/kdf");
    if (kdf && typeof (kdf) === "string") {
        const throwError = function (name, value) {
            return keystore_logger.throwArgumentError("invalid key-derivation function parameters", name, value);
        };
        if (kdf.toLowerCase() === "scrypt") {
            const salt = looseArrayify(searchPath(data, "crypto/kdfparams/salt"));
            const N = parseInt(searchPath(data, "crypto/kdfparams/n"));
            const r = parseInt(searchPath(data, "crypto/kdfparams/r"));
            const p = parseInt(searchPath(data, "crypto/kdfparams/p"));
            // Check for all required parameters
            if (!N || !r || !p) {
                throwError("kdf", kdf);
            }
            // Make sure N is a power of 2
            if ((N & (N - 1)) !== 0) {
                throwError("N", N);
            }
            const dkLen = parseInt(searchPath(data, "crypto/kdfparams/dklen"));
            if (dkLen !== 32) {
                throwError("dklen", dkLen);
            }
            return scryptFunc(passwordBytes, salt, N, r, p, 64, progressCallback);
        }
        else if (kdf.toLowerCase() === "pbkdf2") {
            const salt = looseArrayify(searchPath(data, "crypto/kdfparams/salt"));
            let prfFunc = null;
            const prf = searchPath(data, "crypto/kdfparams/prf");
            if (prf === "hmac-sha256") {
                prfFunc = "sha256";
            }
            else if (prf === "hmac-sha512") {
                prfFunc = "sha512";
            }
            else {
                throwError("prf", prf);
            }
            const count = parseInt(searchPath(data, "crypto/kdfparams/c"));
            const dkLen = parseInt(searchPath(data, "crypto/kdfparams/dklen"));
            if (dkLen !== 32) {
                throwError("dklen", dkLen);
            }
            return pbkdf2Func(passwordBytes, salt, count, dkLen, prfFunc);
        }
    }
    return keystore_logger.throwArgumentError("unsupported key-derivation function", "kdf", kdf);
}
function decryptSync(json, password) {
    const data = JSON.parse(json);
    const key = _computeKdfKey(data, password, pbkdf2Sync, (scrypt_default()).syncScrypt);
    return _getAccount(data, key);
}
function decrypt(json, password, progressCallback) {
    return keystore_awaiter(this, void 0, void 0, function* () {
        const data = JSON.parse(json);
        const key = yield _computeKdfKey(data, password, keystore_pbkdf2, (scrypt_default()).scrypt, progressCallback);
        return _getAccount(data, key);
    });
}
function encrypt(account, password, options, progressCallback) {
    try {
        // Check the address matches the private key
        if (lib_esm_getAddress(account.address) !== computeAddress(account.privateKey)) {
            throw new Error("address/privateKey mismatch");
        }
        // Check the mnemonic (if any) matches the private key
        if (hasMnemonic(account)) {
            const mnemonic = account.mnemonic;
            const node = HDNode.fromMnemonic(mnemonic.phrase, null, mnemonic.locale).derivePath(mnemonic.path || defaultPath);
            if (node.privateKey != account.privateKey) {
                throw new Error("mnemonic mismatch");
            }
        }
    }
    catch (e) {
        return Promise.reject(e);
    }
    // The options are optional, so adjust the call as needed
    if (typeof (options) === "function" && !progressCallback) {
        progressCallback = options;
        options = {};
    }
    if (!options) {
        options = {};
    }
    const privateKey = lib_esm_arrayify(account.privateKey);
    const passwordBytes = getPassword(password);
    let entropy = null;
    let path = null;
    let locale = null;
    if (hasMnemonic(account)) {
        const srcMnemonic = account.mnemonic;
        entropy = lib_esm_arrayify(mnemonicToEntropy(srcMnemonic.phrase, srcMnemonic.locale || "en"));
        path = srcMnemonic.path || defaultPath;
        locale = srcMnemonic.locale || "en";
    }
    let client = options.client;
    if (!client) {
        client = "ethers.js";
    }
    // Check/generate the salt
    let salt = null;
    if (options.salt) {
        salt = lib_esm_arrayify(options.salt);
    }
    else {
        salt = randomBytes(32);
        ;
    }
    // Override initialization vector
    let iv = null;
    if (options.iv) {
        iv = lib_esm_arrayify(options.iv);
        if (iv.length !== 16) {
            throw new Error("invalid iv");
        }
    }
    else {
        iv = randomBytes(16);
    }
    // Override the uuid
    let uuidRandom = null;
    if (options.uuid) {
        uuidRandom = lib_esm_arrayify(options.uuid);
        if (uuidRandom.length !== 16) {
            throw new Error("invalid uuid");
        }
    }
    else {
        uuidRandom = randomBytes(16);
    }
    // Override the scrypt password-based key derivation function parameters
    let N = (1 << 17), r = 8, p = 1;
    if (options.scrypt) {
        if (options.scrypt.N) {
            N = options.scrypt.N;
        }
        if (options.scrypt.r) {
            r = options.scrypt.r;
        }
        if (options.scrypt.p) {
            p = options.scrypt.p;
        }
    }
    // We take 64 bytes:
    //   - 32 bytes   As normal for the Web3 secret storage (derivedKey, macPrefix)
    //   - 32 bytes   AES key to encrypt mnemonic with (required here to be Ethers Wallet)
    return scrypt_default().scrypt(passwordBytes, salt, N, r, p, 64, progressCallback).then((key) => {
        key = lib_esm_arrayify(key);
        // This will be used to encrypt the wallet (as per Web3 secret storage)
        const derivedKey = key.slice(0, 16);
        const macPrefix = key.slice(16, 32);
        // This will be used to encrypt the mnemonic phrase (if any)
        const mnemonicKey = key.slice(32, 64);
        // Encrypt the private key
        const counter = new (aes_js_default()).Counter(iv);
        const aesCtr = new (aes_js_default()).ModeOfOperation.ctr(derivedKey, counter);
        const ciphertext = lib_esm_arrayify(aesCtr.encrypt(privateKey));
        // Compute the message authentication code, used to check the password
        const mac = lib_esm_keccak256(lib_esm_concat([macPrefix, ciphertext]));
        // See: https://github.com/ethereum/wiki/wiki/Web3-Secret-Storage-Definition
        const data = {
            address: account.address.substring(2).toLowerCase(),
            id: uuidV4(uuidRandom),
            version: 3,
            crypto: {
                cipher: "aes-128-ctr",
                cipherparams: {
                    iv: lib_esm_hexlify(iv).substring(2),
                },
                ciphertext: lib_esm_hexlify(ciphertext).substring(2),
                kdf: "scrypt",
                kdfparams: {
                    salt: lib_esm_hexlify(salt).substring(2),
                    n: N,
                    dklen: 32,
                    p: p,
                    r: r
                },
                mac: mac.substring(2)
            }
        };
        // If we have a mnemonic, encrypt it into the JSON wallet
        if (entropy) {
            const mnemonicIv = randomBytes(16);
            const mnemonicCounter = new (aes_js_default()).Counter(mnemonicIv);
            const mnemonicAesCtr = new (aes_js_default()).ModeOfOperation.ctr(mnemonicKey, mnemonicCounter);
            const mnemonicCiphertext = lib_esm_arrayify(mnemonicAesCtr.encrypt(entropy));
            const now = new Date();
            const timestamp = (now.getUTCFullYear() + "-" +
                zpad(now.getUTCMonth() + 1, 2) + "-" +
                zpad(now.getUTCDate(), 2) + "T" +
                zpad(now.getUTCHours(), 2) + "-" +
                zpad(now.getUTCMinutes(), 2) + "-" +
                zpad(now.getUTCSeconds(), 2) + ".0Z");
            data["x-ethers"] = {
                client: client,
                gethFilename: ("UTC--" + timestamp + "--" + data.address),
                mnemonicCounter: lib_esm_hexlify(mnemonicIv).substring(2),
                mnemonicCiphertext: lib_esm_hexlify(mnemonicCiphertext).substring(2),
                path: path,
                locale: locale,
                version: "0.1"
            };
        }
        return JSON.stringify(data);
    });
}
//# sourceMappingURL=keystore.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+json-wallets@5.7.0/node_modules/@ethersproject/json-wallets/lib.esm/crowdsale.js










const crowdsale_logger = new lib_esm_Logger(json_wallets_lib_esm_version_version);

class CrowdsaleAccount extends Description {
    isCrowdsaleAccount(value) {
        return !!(value && value._isCrowdsaleAccount);
    }
}
// See: https://github.com/ethereum/pyethsaletool
function crowdsale_decrypt(json, password) {
    const data = JSON.parse(json);
    password = getPassword(password);
    // Ethereum Address
    const ethaddr = lib_esm_getAddress(searchPath(data, "ethaddr"));
    // Encrypted Seed
    const encseed = looseArrayify(searchPath(data, "encseed"));
    if (!encseed || (encseed.length % 16) !== 0) {
        crowdsale_logger.throwArgumentError("invalid encseed", "json", json);
    }
    const key = lib_esm_arrayify(pbkdf2(password, password, 2000, 32, "sha256")).slice(0, 16);
    const iv = encseed.slice(0, 16);
    const encryptedSeed = encseed.slice(16);
    // Decrypt the seed
    const aesCbc = new (aes_js_default()).ModeOfOperation.cbc(key, iv);
    const seed = aes_js_default().padding.pkcs7.strip(lib_esm_arrayify(aesCbc.decrypt(encryptedSeed)));
    // This wallet format is weird... Convert the binary encoded hex to a string.
    let seedHex = "";
    for (let i = 0; i < seed.length; i++) {
        seedHex += String.fromCharCode(seed[i]);
    }
    const seedHexBytes = toUtf8Bytes(seedHex);
    const privateKey = lib_esm_keccak256(seedHexBytes);
    return new CrowdsaleAccount({
        _isCrowdsaleAccount: true,
        address: ethaddr,
        privateKey: privateKey
    });
}
//# sourceMappingURL=crowdsale.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+json-wallets@5.7.0/node_modules/@ethersproject/json-wallets/lib.esm/inspect.js


function isCrowdsaleWallet(json) {
    let data = null;
    try {
        data = JSON.parse(json);
    }
    catch (error) {
        return false;
    }
    return (data.encseed && data.ethaddr);
}
function isKeystoreWallet(json) {
    let data = null;
    try {
        data = JSON.parse(json);
    }
    catch (error) {
        return false;
    }
    if (!data.version || parseInt(data.version) !== data.version || parseInt(data.version) !== 3) {
        return false;
    }
    // @TODO: Put more checks to make sure it has kdf, iv and all that good stuff
    return true;
}
//export function isJsonWallet(json: string): boolean {
//    return (isSecretStorageWallet(json) || isCrowdsaleWallet(json));
//}
function getJsonWalletAddress(json) {
    if (isCrowdsaleWallet(json)) {
        try {
            return getAddress(JSON.parse(json).ethaddr);
        }
        catch (error) {
            return null;
        }
    }
    if (isKeystoreWallet(json)) {
        try {
            return getAddress(JSON.parse(json).address);
        }
        catch (error) {
            return null;
        }
    }
    return null;
}
//# sourceMappingURL=inspect.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+json-wallets@5.7.0/node_modules/@ethersproject/json-wallets/lib.esm/index.js




function decryptJsonWallet(json, password, progressCallback) {
    if (isCrowdsaleWallet(json)) {
        if (progressCallback) {
            progressCallback(0);
        }
        const account = crowdsale_decrypt(json, password);
        if (progressCallback) {
            progressCallback(1);
        }
        return Promise.resolve(account);
    }
    if (isKeystoreWallet(json)) {
        return decrypt(json, password, progressCallback);
    }
    return Promise.reject(new Error("invalid JSON wallet"));
}
function decryptJsonWalletSync(json, password) {
    if (isCrowdsaleWallet(json)) {
        return crowdsale_decrypt(json, password);
    }
    if (isKeystoreWallet(json)) {
        return decryptSync(json, password);
    }
    throw new Error("invalid JSON wallet");
}

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+wallet@5.7.0/node_modules/@ethersproject/wallet/lib.esm/_version.js
const wallet_lib_esm_version_version = "wallet/5.7.0";
//# sourceMappingURL=_version.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+wallet@5.7.0/node_modules/@ethersproject/wallet/lib.esm/index.js

var wallet_lib_esm_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};














const wallet_lib_esm_logger = new lib_esm_Logger(wallet_lib_esm_version_version);
function isAccount(value) {
    return (value != null && lib_esm_isHexString(value.privateKey, 32) && value.address != null);
}
function lib_esm_hasMnemonic(value) {
    const mnemonic = value.mnemonic;
    return (mnemonic && mnemonic.phrase);
}
class Wallet extends lib_esm_Signer {
    constructor(privateKey, provider) {
        super();
        if (isAccount(privateKey)) {
            const signingKey = new SigningKey(privateKey.privateKey);
            lib_esm_defineReadOnly(this, "_signingKey", () => signingKey);
            lib_esm_defineReadOnly(this, "address", computeAddress(this.publicKey));
            if (this.address !== lib_esm_getAddress(privateKey.address)) {
                wallet_lib_esm_logger.throwArgumentError("privateKey/address mismatch", "privateKey", "[REDACTED]");
            }
            if (lib_esm_hasMnemonic(privateKey)) {
                const srcMnemonic = privateKey.mnemonic;
                lib_esm_defineReadOnly(this, "_mnemonic", () => ({
                    phrase: srcMnemonic.phrase,
                    path: srcMnemonic.path || defaultPath,
                    locale: srcMnemonic.locale || "en"
                }));
                const mnemonic = this.mnemonic;
                const node = HDNode.fromMnemonic(mnemonic.phrase, null, mnemonic.locale).derivePath(mnemonic.path);
                if (computeAddress(node.privateKey) !== this.address) {
                    wallet_lib_esm_logger.throwArgumentError("mnemonic/address mismatch", "privateKey", "[REDACTED]");
                }
            }
            else {
                lib_esm_defineReadOnly(this, "_mnemonic", () => null);
            }
        }
        else {
            if (SigningKey.isSigningKey(privateKey)) {
                /* istanbul ignore if */
                if (privateKey.curve !== "secp256k1") {
                    wallet_lib_esm_logger.throwArgumentError("unsupported curve; must be secp256k1", "privateKey", "[REDACTED]");
                }
                lib_esm_defineReadOnly(this, "_signingKey", () => privateKey);
            }
            else {
                // A lot of common tools do not prefix private keys with a 0x (see: #1166)
                if (typeof (privateKey) === "string") {
                    if (privateKey.match(/^[0-9a-f]*$/i) && privateKey.length === 64) {
                        privateKey = "0x" + privateKey;
                    }
                }
                const signingKey = new SigningKey(privateKey);
                lib_esm_defineReadOnly(this, "_signingKey", () => signingKey);
            }
            lib_esm_defineReadOnly(this, "_mnemonic", () => null);
            lib_esm_defineReadOnly(this, "address", computeAddress(this.publicKey));
        }
        /* istanbul ignore if */
        if (provider && !Provider.isProvider(provider)) {
            wallet_lib_esm_logger.throwArgumentError("invalid provider", "provider", provider);
        }
        lib_esm_defineReadOnly(this, "provider", provider || null);
    }
    get mnemonic() { return this._mnemonic(); }
    get privateKey() { return this._signingKey().privateKey; }
    get publicKey() { return this._signingKey().publicKey; }
    getAddress() {
        return Promise.resolve(this.address);
    }
    connect(provider) {
        return new Wallet(this, provider);
    }
    signTransaction(transaction) {
        return resolveProperties(transaction).then((tx) => {
            if (tx.from != null) {
                if (lib_esm_getAddress(tx.from) !== this.address) {
                    wallet_lib_esm_logger.throwArgumentError("transaction from address mismatch", "transaction.from", transaction.from);
                }
                delete tx.from;
            }
            const signature = this._signingKey().signDigest(lib_esm_keccak256(serialize(tx)));
            return serialize(tx, signature);
        });
    }
    signMessage(message) {
        return wallet_lib_esm_awaiter(this, void 0, void 0, function* () {
            return joinSignature(this._signingKey().signDigest(hashMessage(message)));
        });
    }
    _signTypedData(domain, types, value) {
        return wallet_lib_esm_awaiter(this, void 0, void 0, function* () {
            // Populate any ENS names
            const populated = yield TypedDataEncoder.resolveNames(domain, types, value, (name) => {
                if (this.provider == null) {
                    wallet_lib_esm_logger.throwError("cannot resolve ENS names without a provider", lib_esm_Logger.errors.UNSUPPORTED_OPERATION, {
                        operation: "resolveName",
                        value: name
                    });
                }
                return this.provider.resolveName(name);
            });
            return joinSignature(this._signingKey().signDigest(TypedDataEncoder.hash(populated.domain, types, populated.value)));
        });
    }
    encrypt(password, options, progressCallback) {
        if (typeof (options) === "function" && !progressCallback) {
            progressCallback = options;
            options = {};
        }
        if (progressCallback && typeof (progressCallback) !== "function") {
            throw new Error("invalid callback");
        }
        if (!options) {
            options = {};
        }
        return encrypt(this, password, options, progressCallback);
    }
    /**
     *  Static methods to create Wallet instances.
     */
    static createRandom(options) {
        let entropy = randomBytes(16);
        if (!options) {
            options = {};
        }
        if (options.extraEntropy) {
            entropy = lib_esm_arrayify(lib_esm_hexDataSlice(lib_esm_keccak256(lib_esm_concat([entropy, options.extraEntropy])), 0, 16));
        }
        const mnemonic = entropyToMnemonic(entropy, options.locale);
        return Wallet.fromMnemonic(mnemonic, options.path, options.locale);
    }
    static fromEncryptedJson(json, password, progressCallback) {
        return decryptJsonWallet(json, password, progressCallback).then((account) => {
            return new Wallet(account);
        });
    }
    static fromEncryptedJsonSync(json, password) {
        return new Wallet(decryptJsonWalletSync(json, password));
    }
    static fromMnemonic(mnemonic, path, wordlist) {
        if (!path) {
            path = defaultPath;
        }
        return new Wallet(HDNode.fromMnemonic(mnemonic, null, wordlist).derivePath(path));
    }
}
function verifyMessage(message, signature) {
    return lib_esm_recoverAddress(hashMessage(message), signature);
}
function verifyTypedData(domain, types, value, signature) {
    return recoverAddress(_TypedDataEncoder.hash(domain, types, value), signature);
}
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+solidity@5.7.0/node_modules/@ethersproject/solidity/lib.esm/_version.js
const solidity_lib_esm_version_version = "solidity/5.7.0";
//# sourceMappingURL=_version.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@ethersproject+solidity@5.7.0/node_modules/@ethersproject/solidity/lib.esm/index.js






const regexBytes = new RegExp("^bytes([0-9]+)$");
const regexNumber = new RegExp("^(u?int)([0-9]*)$");
const regexArray = new RegExp("^(.*)\\[([0-9]*)\\]$");
const lib_esm_Zeros = "0000000000000000000000000000000000000000000000000000000000000000";


const solidity_lib_esm_logger = new lib_esm_Logger(solidity_lib_esm_version_version);
function _pack(type, value, isArray) {
    switch (type) {
        case "address":
            if (isArray) {
                return zeroPad(value, 32);
            }
            return lib_esm_arrayify(value);
        case "string":
            return toUtf8Bytes(value);
        case "bytes":
            return lib_esm_arrayify(value);
        case "bool":
            value = (value ? "0x01" : "0x00");
            if (isArray) {
                return zeroPad(value, 32);
            }
            return lib_esm_arrayify(value);
    }
    let match = type.match(regexNumber);
    if (match) {
        //let signed = (match[1] === "int")
        let size = parseInt(match[2] || "256");
        if ((match[2] && String(size) !== match[2]) || (size % 8 !== 0) || size === 0 || size > 256) {
            solidity_lib_esm_logger.throwArgumentError("invalid number type", "type", type);
        }
        if (isArray) {
            size = 256;
        }
        value = bignumber_BigNumber.from(value).toTwos(size);
        return zeroPad(value, size / 8);
    }
    match = type.match(regexBytes);
    if (match) {
        const size = parseInt(match[1]);
        if (String(size) !== match[1] || size === 0 || size > 32) {
            solidity_lib_esm_logger.throwArgumentError("invalid bytes type", "type", type);
        }
        if (lib_esm_arrayify(value).byteLength !== size) {
            solidity_lib_esm_logger.throwArgumentError(`invalid value for ${type}`, "value", value);
        }
        if (isArray) {
            return lib_esm_arrayify((value + lib_esm_Zeros).substring(0, 66));
        }
        return value;
    }
    match = type.match(regexArray);
    if (match && Array.isArray(value)) {
        const baseType = match[1];
        const count = parseInt(match[2] || String(value.length));
        if (count != value.length) {
            solidity_lib_esm_logger.throwArgumentError(`invalid array length for ${type}`, "value", value);
        }
        const result = [];
        value.forEach(function (value) {
            result.push(_pack(baseType, value, true));
        });
        return lib_esm_concat(result);
    }
    return solidity_lib_esm_logger.throwArgumentError("invalid type", "type", type);
}
// @TODO: Array Enum
function lib_esm_pack(types, values) {
    if (types.length != values.length) {
        solidity_lib_esm_logger.throwArgumentError("wrong number of values; expected ${ types.length }", "values", values);
    }
    const tight = [];
    types.forEach(function (type, index) {
        tight.push(_pack(type, values[index]));
    });
    return lib_esm_hexlify(lib_esm_concat(tight));
}
function solidity_lib_esm_keccak256(types, values) {
    return lib_esm_keccak256(lib_esm_pack(types, values));
}
function lib_esm_sha256(types, values) {
    return hashSha256(lib_esm_pack(types, values));
}
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./src/util.ts
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _signMessageWithPrivatekey, _signAddress, _getRandomString;
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
 // v5


function util_assert(condition, message) {
  if (!condition) {
    throw new Error(message || 'Assertion failed');
  }
}

/**
 * Prints a greeting message to the console.
 */
function greeting() {
  console.log('🥜 Hello & thanks for using the Peanut SDK! If you run into any issues, dm @hugomont on telegram or hop on the Peanut Protocol discord');
}

/**
 * Generates a deterministic key pair from an arbitrary length string
 *
 * @param {string} string - The string to generate a key pair from
 * @returns {Object} - An object containing the address and privateKey
 */
function generateKeysFromString(string) {
  var privateKey = lib_esm_keccak256(toUtf8Bytes(string)); // v5
  var wallet = new Wallet(privateKey);
  return {
    address: wallet.address,
    privateKey: privateKey
  };
}

/**
 * Converts a string to bytes, pads it to 32 bytes and hashes it
 */
function hash_string(str) {
  //@HUGO: I've added in a .toString() here, but I'm not sure if it's good
  var hash = ethers.utils.toUtf8Bytes(str).toString(); // v5
  hash = ethers.utils.hexlify(hash); // v5
  hash = ethers.utils.hexZeroPad(hash, 32); // v5
  hash = ethers.utils.keccak256(hash); // v5
  return hash;
}

/**
 * Signs a message with a private key and returns the signature
 * THIS SHOULD BE AN UNHASHED, UNPREFIXED MESSAGE
 */
function signMessageWithPrivatekey(_x, _x2) {
  return (_signMessageWithPrivatekey = _signMessageWithPrivatekey || _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(message, privateKey) {
    var signer;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          signer = new Wallet(privateKey);
          return _context.abrupt("return", signer.signMessage(message));
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }))).apply(this, arguments);
}

/**
 * Verifies a signature with a public key and returns true if valid
 */
function verifySignature(message, signature, address) {
  var messageSigner = verifyMessage(message, signature); // v5
  return messageSigner == address;
}

/**
 * Adds the EIP191 prefix to a message and hashes it same as solidity
 */
function solidityHashBytesEIP191(bytes) {
  return hashMessage(bytes); // v5
}

/**
 * Hashes an address to a 32 byte hex string
 */
function solidityHashAddress(address) {
  return solidity_lib_esm_keccak256(['address'], [address]); // v5
}

/**
 * Hashes a plain address, adds an Ethereum message prefix, hashes it again and then signs it
 */
function signAddress(_x3, _x4) {
  return (_signAddress = _signAddress || _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(string, privateKey) {
    var stringHash, stringHashbinary, signer, signature;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          stringHash = solidity_lib_esm_keccak256(['address'], [string]); // v5
          stringHashbinary = lib_esm_arrayify(stringHash); // v5
          signer = new Wallet(privateKey);
          _context2.next = 5;
          return signer.signMessage(stringHashbinary);
        case 5:
          signature = _context2.sent;
          return _context2.abrupt("return", signature);
        case 7:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }))).apply(this, arguments);
}

/**
 * Generates a random string of the specified length
 *  need to avoid bias: https://gist.github.com/joepie91/7105003c3b26e65efcea63f3db82dfba#so-how-do-i-obtain-random-values-securely
 * h/t to Nanak Nihal from Holonym
 * browser: tries to use secure generateKey if available, otherwise falls back to getRandomValues
 * node: uses secure crypto.randomBytes
 */
function getRandomString() {
  return (_getRandomString = _getRandomString || _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    var _ref;
    var n,
      charset,
      charsetLength,
      maxByteValue,
      maxUnbiasedByte,
      randomString,
      generateKeyRandomBytes,
      getRandomValuesRandomBytes,
      randomBytes,
      _iterator,
      _step,
      _byte,
      randomIndex,
      _args4 = arguments;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          n = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : 16;
          charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
          charsetLength = charset.length;
          maxByteValue = 256; // Each byte has 256 possible values
          maxUnbiasedByte = maxByteValue - maxByteValue % charsetLength;
          randomString = '';
          generateKeyRandomBytes = function generateKeyRandomBytes(_x5) {
            return (_ref = _ref || _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(length) {
              var cryptoSubtle, key, keyBuffer;
              return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                while (1) switch (_context3.prev = _context3.next) {
                  case 0:
                    cryptoSubtle = typeof window !== 'undefined' && window.crypto && window.crypto.subtle ? window.crypto.subtle : undefined;
                    if (!cryptoSubtle) {
                      _context3.next = 15;
                      break;
                    }
                    _context3.prev = 2;
                    _context3.next = 5;
                    return cryptoSubtle.generateKey({
                      name: 'AES-GCM',
                      length: length * 8 // Convert byte length to bit length
                      // TODO: non 16/32 length passwords?
                    }, true, ['encrypt', 'decrypt']);
                  case 5:
                    key = _context3.sent;
                    _context3.next = 8;
                    return cryptoSubtle.exportKey('raw', key);
                  case 8:
                    keyBuffer = _context3.sent;
                    return _context3.abrupt("return", new Uint8Array(keyBuffer));
                  case 12:
                    _context3.prev = 12;
                    _context3.t0 = _context3["catch"](2);
                    console.warn('Failed to use generateKey. Falling back to getRandomValues.', _context3.t0);
                  case 15:
                    return _context3.abrupt("return", getRandomValuesRandomBytes(length));
                  case 16:
                  case "end":
                    return _context3.stop();
                }
              }, _callee3, null, [[2, 12]]);
            }))).apply(this, arguments);
          };
          getRandomValuesRandomBytes = function getRandomValuesRandomBytes(length) {
            if (typeof window !== 'undefined' && window.crypto && window.crypto.getRandomValues) {
              // Browser
              var array = new Uint8Array(length);
              window.crypto.getRandomValues(array);
              return array;
            } else {
              // Node
              // eslint-disable-next-line @typescript-eslint/no-var-requires
              var crypto = __webpack_require__(85);
              return crypto.randomBytes(length);
            }
          };
        case 8:
          if (!(randomString.length < n)) {
            _context4.next = 16;
            break;
          }
          _context4.next = 11;
          return generateKeyRandomBytes(n - randomString.length);
        case 11:
          randomBytes = _context4.sent;
          _iterator = _createForOfIteratorHelper(randomBytes);
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              _byte = _step.value;
              if (_byte < maxUnbiasedByte) {
                randomIndex = _byte % charsetLength;
                randomString += charset.charAt(randomIndex);
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          _context4.next = 8;
          break;
        case 16:
          return _context4.abrupt("return", randomString);
        case 17:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }))).apply(this, arguments);
}

/**
 * Returns the parameters from the current page url
 */
function getParamsFromPageURL() {
  var _params$get;
  /* returns the parameters from the current page url */
  var params = new URLSearchParams(window.location.search);
  var chainId = params.get('c'); // can be chain name or chain id
  chainId = chainMap_namespaceObject[String(chainId)].toString();
  var contractVersion = params.get('v');
  var depositIdx = (_params$get = params.get('i')) !== null && _params$get !== void 0 ? _params$get : '';
  depositIdx = parseInt(depositIdx).toString();
  var password = params.get('p');
  return {
    chainId: chainId,
    contractVersion: contractVersion,
    depositIdx: depositIdx,
    password: password
  };
}

/**
 * Returns the parameters from a link
 */
function getParamsFromLink(link) {
  var _params$get2, _params$get3, _params$get4, _params$get5;
  /* returns the parameters from a link */
  var url = new URL(link);
  var search = url.search;

  // If there is no search params, try to get params after hash
  if (search === '') {
    search = url.hash.startsWith('#?') ? url.hash.substring(1) : '';
  }
  var params = new URLSearchParams(search);
  var _chainId = (_params$get2 = params.get('c')) !== null && _params$get2 !== void 0 ? _params$get2 : ''; // can be chain name or chain id
  var chainId = 0;
  // if can be casted to int, then it's a chain id
  if (parseInt(_chainId)) {
    chainId = parseInt(_chainId);
  } else {
    // otherwise it's a chain name
    chainId = chainMap_namespaceObject[String(_chainId)];
  }
  var contractVersion = (_params$get3 = params.get('v')) !== null && _params$get3 !== void 0 ? _params$get3 : '';
  var depositIdx = (_params$get4 = params.get('i')) !== null && _params$get4 !== void 0 ? _params$get4 : '';
  depositIdx = parseInt(depositIdx);
  var password = (_params$get5 = params.get('p')) !== null && _params$get5 !== void 0 ? _params$get5 : '';
  var trackId = ''; // optional
  if (params.get('t')) {
    var _params$get6;
    trackId = (_params$get6 = params.get('t')) !== null && _params$get6 !== void 0 ? _params$get6 : '';
  }
  return {
    chainId: chainId,
    contractVersion: contractVersion,
    depositIdx: depositIdx,
    password: password,
    trackId: trackId
  };
}

/**
 * Returns a link from the given parameters
 */
function getLinkFromParams(chainId, contractVersion, depositIdx, password) {
  var baseUrl = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'https://peanut.to/claim';
  var trackId = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
  /* returns a link from the given parameters */

  var link = baseUrl + '#?c=' + chainId + '&v=' + contractVersion + '&i=' + depositIdx + '&p=' + password;
  if (trackId != '') {
    return link + '&t=' + trackId;
  }
  return link;
}

/**
 * Returns the deposit index from a tx receipt
 */
function getDepositIdx(txReceipt, chainId, contractVersion) {
  /* returns the deposit index from a tx receipt */
  var logs = txReceipt.logs;
  var depositIdx;
  var logIndex;

  // Identify the logIndex based on chainId
  if (chainId === 137 || chainId === 80001) {
    logIndex = logs.length - 2;
  } else {
    logIndex = logs.length - 1;
  }

  // Handle the deposit index extraction based on contract version
  if (contractVersion === 'v3') {
    try {
      depositIdx = logs[logIndex].args[0];
    } catch (error) {
      // get uint256 from data (first 32 bytes)
      var data = logs[logIndex].data;
      var depositIdxHex = data.slice(0, 66);
      //@HUGO: I've removed the parseInt here since it's already a bigInt
      depositIdx = BigInt(depositIdxHex);
    }
  } else if (contractVersion === 'v4') {
    // In v5, the index is now an indexed topic rather than part of the log data
    try {
      // Based on the etherscan example, the index is now the 1st topic.
      //@HUGO: I've removed the parseInt here since it's already a bigInt
      depositIdx = BigInt("0x".concat(logs[logIndex].topics[1].slice(2)));
    } catch (error) {
      console.error('Error parsing deposit index from v5 logs:', error);
    }
  } else {
    console.error('Unsupported contract version:', contractVersion);
  }
  return depositIdx;
}

/**
 * Returns an array of deposit indices from a batch transaction receipt
 */
function getDepositIdxs(txReceipt, chainId, contractVersion) {
  var logs = txReceipt.logs;
  var depositIdxs = [];

  // events
  // event DepositEvent(
  //     uint256 indexed _index, uint8 indexed _contractType, uint256 _amount, address indexed _senderAddress
  // );
  // const logTopic = ethers.utils.id('Deposit(uint256,address,uint64,uint8,uint64,uint256)') // Update with correct event signature
  var logTopic = id('DepositEvent(uint256,uint8,uint256,address)'); // Update with correct event signature

  var _PEANUT_CONTRACTS = contracts_namespaceObject;
  var contractAddress = _PEANUT_CONTRACTS[chainId][contractVersion];
  config.verbose && console.log(contractAddress, contractVersion, chainId);
  for (var i = 0; i < logs.length; i++) {
    if (logs[i].address.toLowerCase() === contractAddress.toLowerCase() && logs[i].topics[0] === logTopic) {
      var depositIdx = bignumber_BigNumber.from(logs[i].topics[1]).toNumber();
      depositIdxs.push(depositIdx);
    }
  }
  return depositIdxs;
}
function getLinksFromMultilink(link) {
  var _searchParams$get, _searchParams$get2;
  var url = new URL(link);
  var searchParams = new URLSearchParams(url.search);

  // If there is a hash, treat the part after the hash as additional search parameters
  if (url.hash.startsWith('#?')) {
    var hashParams = new URLSearchParams(url.hash.slice(2));
    var _iterator2 = _createForOfIteratorHelper(hashParams),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _step2$value = _slicedToArray(_step2.value, 2),
          key = _step2$value[0],
          value = _step2$value[1];
        searchParams.append(key, value);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  var cParams = ((_searchParams$get = searchParams.get('c')) === null || _searchParams$get === void 0 ? void 0 : _searchParams$get.split(',')) || [];
  var iParams = ((_searchParams$get2 = searchParams.get('i')) === null || _searchParams$get2 === void 0 ? void 0 : _searchParams$get2.split(',')) || [];
  if (cParams.length !== iParams.length && cParams.length !== 1) {
    throw new Error('Mismatch in length of c and i parameters');
  }
  var links = iParams.map(function (i, index) {
    var newUrl = new URL(url.origin + url.pathname); // clone the original URL without search and hash
    var newSearchParams = new URLSearchParams(searchParams.toString()); // clone the original search parameters
    newSearchParams.set('c', cParams.length === 1 ? cParams[0] : cParams[index]);
    newSearchParams.set('i', i);
    newUrl.hash = '#?' + newSearchParams.toString();
    return newUrl.toString();
  });
  return links;
}
function createMultiLinkFromLinks(links) {
  if (links.length === 0) {
    throw new Error('No links provided');
  }
  var cParams = [];
  var iParams = [];
  var baseUrl = '';
  var contractVersion = '';
  var password = '';
  var trackId = '';
  var additionalParams = new Map();
  links.forEach(function (link) {
    var url = new URL(link);
    var searchParams = new URLSearchParams(url.search);
    if (url.hash.startsWith('#?')) {
      var hashParams = new URLSearchParams(url.hash.slice(2));
      var _iterator3 = _createForOfIteratorHelper(hashParams),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _step3$value = _slicedToArray(_step3.value, 2),
            key = _step3$value[0],
            value = _step3$value[1];
          searchParams.append(key, value);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
    cParams.push(searchParams.get('c') || '');
    iParams.push(searchParams.get('i') || '');
    baseUrl = url.origin + url.pathname;
    contractVersion = searchParams.get('v') || '';
    password = searchParams.get('p') || '';
    trackId = searchParams.get('t') || '';

    // Store all additional parameters
    var _iterator4 = _createForOfIteratorHelper(searchParams.entries()),
      _step4;
    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var _step4$value = _slicedToArray(_step4.value, 2),
          _key = _step4$value[0],
          _value = _step4$value[1];
        if (!['c', 'v', 'i', 'p', 't'].includes(_key)) {
          additionalParams.set(_key, _value);
        }
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
  });

  // Check if all chainIds are the same
  var allSameChainId = cParams.every(function (val) {
    return val === cParams[0];
  });
  var multiLink = getLinkFromParams(allSameChainId ? cParams[0] : cParams.join(','), contractVersion, iParams.join(','), password, baseUrl, trackId);

  // Add all additional parameters to the hash of the multi-link
  var url = new URL(multiLink);
  var hashString = url.hash.slice(2); // remove the '#?' at the start
  var _iterator5 = _createForOfIteratorHelper(additionalParams.entries()),
    _step5;
  try {
    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
      var _step5$value = _slicedToArray(_step5.value, 2),
        key = _step5$value[0],
        value = _step5$value[1];
      hashString += "&".concat(key, "=").concat(value);
    }
  } catch (err) {
    _iterator5.e(err);
  } finally {
    _iterator5.f();
  }
  url.hash = '#?' + hashString;
  return url.toString();
}
;// CONCATENATED MODULE: ./src/consts/interfaces.consts.ts
function interfaces_consts_typeof(o) { "@babel/helpers - typeof"; return interfaces_consts_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, interfaces_consts_typeof(o); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return interfaces_consts_typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (interfaces_consts_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (interfaces_consts_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (interfaces_consts_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
//General export interface s and enums

var EPeanutLinkType = /*#__PURE__*/function (EPeanutLinkType) {
  EPeanutLinkType[EPeanutLinkType["native"] = 0] = "native";
  EPeanutLinkType[EPeanutLinkType["erc20"] = 1] = "erc20";
  EPeanutLinkType[EPeanutLinkType["erc721"] = 2] = "erc721";
  EPeanutLinkType[EPeanutLinkType["erc1155"] = 3] = "erc1155";
  EPeanutLinkType[EPeanutLinkType["inflationarytokens"] = 4] = "inflationarytokens";
  return EPeanutLinkType;
}({}); // we might leave this out for now?

//createLink

//createLinks

var ECreateLinksStatusCodes = /*#__PURE__*/function (ECreateLinksStatusCodes) {
  ECreateLinksStatusCodes[ECreateLinksStatusCodes["SUCCESS"] = 0] = "SUCCESS";
  ECreateLinksStatusCodes[ECreateLinksStatusCodes["ERROR_PREPARING_TXs"] = 1] = "ERROR_PREPARING_TXs";
  ECreateLinksStatusCodes[ECreateLinksStatusCodes["ERROR_SIGNING_AND_SUBMITTING_TX"] = 2] = "ERROR_SIGNING_AND_SUBMITTING_TX";
  ECreateLinksStatusCodes[ECreateLinksStatusCodes["ERROR_GETTING_LINKS_FROM_TX"] = 3] = "ERROR_GETTING_LINKS_FROM_TX";
  return ECreateLinksStatusCodes;
}({});

//claimLinkGasless

//ClaimLink

//prepareCreatetxs

//signAndSubmitTx

//getLink

//prepareClaimTx

//getLinkDetails

//error object and enums

var ECreateLinkStatusCodes = /*#__PURE__*/function (ECreateLinkStatusCodes) {
  ECreateLinkStatusCodes[ECreateLinkStatusCodes["SUCCESS"] = 0] = "SUCCESS";
  ECreateLinkStatusCodes[ECreateLinkStatusCodes["ERROR_VALIDATING_LINK_DETAILS"] = 1] = "ERROR_VALIDATING_LINK_DETAILS";
  ECreateLinkStatusCodes[ECreateLinkStatusCodes["ERROR_PREPARING_TX"] = 2] = "ERROR_PREPARING_TX";
  ECreateLinkStatusCodes[ECreateLinkStatusCodes["ERROR_SIGNING_AND_SUBMITTING_TX"] = 3] = "ERROR_SIGNING_AND_SUBMITTING_TX";
  ECreateLinkStatusCodes[ECreateLinkStatusCodes["ERROR_GETTING_LINKS_FROM_TX"] = 4] = "ERROR_GETTING_LINKS_FROM_TX";
  return ECreateLinkStatusCodes;
}({});
var EPrepareCreateTxsStatusCodes = /*#__PURE__*/function (EPrepareCreateTxsStatusCodes) {
  EPrepareCreateTxsStatusCodes[EPrepareCreateTxsStatusCodes["SUCCESS"] = 0] = "SUCCESS";
  EPrepareCreateTxsStatusCodes[EPrepareCreateTxsStatusCodes["ERROR_VALIDATING_LINK_DETAILS"] = 1] = "ERROR_VALIDATING_LINK_DETAILS";
  EPrepareCreateTxsStatusCodes[EPrepareCreateTxsStatusCodes["ERROR_GETTING_DEFAULT_PROVIDER"] = 2] = "ERROR_GETTING_DEFAULT_PROVIDER";
  EPrepareCreateTxsStatusCodes[EPrepareCreateTxsStatusCodes["ERROR_GETTING_TX_COUNT"] = 3] = "ERROR_GETTING_TX_COUNT";
  EPrepareCreateTxsStatusCodes[EPrepareCreateTxsStatusCodes["ERROR_PREPARING_APPROVE_ERC20_TX"] = 4] = "ERROR_PREPARING_APPROVE_ERC20_TX";
  EPrepareCreateTxsStatusCodes[EPrepareCreateTxsStatusCodes["ERROR_PREPARING_APPROVE_ERC721_TX"] = 5] = "ERROR_PREPARING_APPROVE_ERC721_TX";
  EPrepareCreateTxsStatusCodes[EPrepareCreateTxsStatusCodes["ERROR_PREPARING_APPROVE_ERC1155_TX"] = 6] = "ERROR_PREPARING_APPROVE_ERC1155_TX";
  EPrepareCreateTxsStatusCodes[EPrepareCreateTxsStatusCodes["ERROR_SETTING_FEE_OPTIONS"] = 7] = "ERROR_SETTING_FEE_OPTIONS";
  EPrepareCreateTxsStatusCodes[EPrepareCreateTxsStatusCodes["ERROR_ESTIMATING_GAS_LIMIT"] = 8] = "ERROR_ESTIMATING_GAS_LIMIT";
  EPrepareCreateTxsStatusCodes[EPrepareCreateTxsStatusCodes["ERROR_MAKING_DEPOSIT"] = 9] = "ERROR_MAKING_DEPOSIT";
  return EPrepareCreateTxsStatusCodes;
}({});
var ESignAndSubmitTx = /*#__PURE__*/function (ESignAndSubmitTx) {
  ESignAndSubmitTx[ESignAndSubmitTx["SUCCESS"] = 0] = "SUCCESS";
  ESignAndSubmitTx[ESignAndSubmitTx["ERROR_SENDING_TX"] = 1] = "ERROR_SENDING_TX";
  return ESignAndSubmitTx;
}({});
var EGetLinkFromTxStatusCodes = /*#__PURE__*/function (EGetLinkFromTxStatusCodes) {
  EGetLinkFromTxStatusCodes[EGetLinkFromTxStatusCodes["SUCCESS"] = 0] = "SUCCESS";
  EGetLinkFromTxStatusCodes[EGetLinkFromTxStatusCodes["ERROR_GETTING_TX_RECEIPT_FROM_HASH"] = 1] = "ERROR_GETTING_TX_RECEIPT_FROM_HASH";
  return EGetLinkFromTxStatusCodes;
}({});
var EClaimLinkStatusCodes = /*#__PURE__*/function (EClaimLinkStatusCodes) {
  EClaimLinkStatusCodes[EClaimLinkStatusCodes["SUCCESS"] = 0] = "SUCCESS";
  EClaimLinkStatusCodes[EClaimLinkStatusCodes["ERROR"] = 1] = "ERROR";
  return EClaimLinkStatusCodes;
}({});
var SDKStatus = /*#__PURE__*/function (_Error) {
  _inherits(SDKStatus, _Error);
  var _super = _createSuper(SDKStatus);
  function SDKStatus(code, message, extraInfo) {
    var _this;
    _classCallCheck(this, SDKStatus);
    _this = _super.call(this, message);
    _this.code = code;
    _this.message = extraInfo;

    // Ensure the instance of is correct
    Object.setPrototypeOf(_assertThisInitialized(_this), SDKStatus.prototype);
    return _this;
  }
  return _createClass(SDKStatus);
}( /*#__PURE__*/_wrapNativeSuper(Error));
;// CONCATENATED MODULE: ./src/index.ts
function src_typeof(o) { "@babel/helpers - typeof"; return src_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, src_typeof(o); }
var _checkRpc, _fetchGetBalance, _getDefaultProvider, _getContract, _getAllowanceERC, _getApprovedERC, _getApprovedERC2, _prepareApproveERC20Tx, _prepareApproveERC721Tx, _prepareApproveERC1155Tx, _setFeeOptions, _estimateGasLimit, _prepareTxs, _signAndSubmitTx, _getLinksFromTx, _getTxReceiptFromHash, _createLink, _createLinks, _claimLink, _getAllDepositsForSigner, _createClaimPayload, _getLinkDetails, _claimLinkGasless;
function src_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = src_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = src_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function src_toPropertyKey(arg) { var key = src_toPrimitive(arg, "string"); return src_typeof(key) === "symbol" ? key : String(key); }
function src_toPrimitive(input, hint) { if (src_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (src_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function src_slicedToArray(arr, i) { return src_arrayWithHoles(arr) || src_iterableToArrayLimit(arr, i) || src_unsupportedIterableToArray(arr, i) || src_nonIterableRest(); }
function src_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function src_iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function src_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || src_unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function src_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return src_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return src_arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return src_arrayLikeToArray(arr); }
function src_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function src_regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ src_regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == src_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(src_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function src_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function src_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { src_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { src_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
////////////////// Peanut Library ///////////////////////
//
//  The intent of this library is to provide a set of stable functions to interact
//  with Peanut Protocol. This library is compatible with ethers v5, and
//  supports both node and browser environments.
//
/////////////////////////////////////////////////////////

 // v5

 // isomorphic-fetch is a library that implements fetch in node.js and the browser





// async function getAbstractSigner(signer: any) {
// 	// TODO: create abstract signer class that is compatible with ethers v5, v6, viem, web3js
// 	return signer
// }

function timeout(ms, promise) {
  return new Promise(function (resolve, reject) {
    var timer = setTimeout(function () {
      reject(new Error("Timed out after ".concat(ms, " ms")));
    }, ms);
    promise.then(resolve)["catch"](reject)["finally"](function () {
      return clearTimeout(timer);
    });
  });
}
function checkRpc(_x) {
  return (_checkRpc = _checkRpc || src_asyncToGenerator( /*#__PURE__*/src_regeneratorRuntime().mark(function _callee(rpc) {
    var response;
    return src_regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          config.verbose && console.log('checkRpc rpc:', rpc);
          _context.prev = 1;
          _context.next = 4;
          return timeout(2000, fetchGetBalance(rpc));
        case 4:
          response = _context.sent;
          if (!response.error) {
            _context.next = 8;
            break;
          }
          config.verbose && console.log('JSON RPC Error for:', rpc, response.error.message);
          return _context.abrupt("return", false);
        case 8:
          return _context.abrupt("return", true);
        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](1);
          console.log('Error checking provider:', rpc, 'Error:', _context.t0);
          return _context.abrupt("return", false);
        case 15:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 11]]);
  }))).apply(this, arguments);
}
function fetchGetBalance(_x2) {
  return (_fetchGetBalance = _fetchGetBalance || src_asyncToGenerator( /*#__PURE__*/src_regeneratorRuntime().mark(function _callee2(rpcUrl) {
    var res, json;
    return src_regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return fetch(rpcUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              jsonrpc: '2.0',
              method: 'eth_getBalance',
              params: ['0x0000000000000000000000000000000000000000', 'latest'],
              id: 1
            })
          });
        case 2:
          res = _context2.sent;
          _context2.next = 5;
          return res.json();
        case 5:
          json = _context2.sent;
          return _context2.abrupt("return", json);
        case 7:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }))).apply(this, arguments);
}
/**
 * Returns the default provider for a given chainId
 */
function getDefaultProvider(_x3) {
  return (_getDefaultProvider = _getDefaultProvider || src_asyncToGenerator( /*#__PURE__*/src_regeneratorRuntime().mark(function _callee6(chainId) {
    var _ref2;
    var rpcs, checkPromises;
    return src_regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          config.verbose && console.log('Getting default provider for chainId ', chainId);
          if (chainDetails_namespaceObject[chainId]) {
            _context6.next = 3;
            break;
          }
          throw new Error("Chain ID ".concat(chainId, " not supported yet"));
        case 3:
          rpcs = chainDetails_namespaceObject[chainId].rpc;
          config.verbose && console.log('rpcs', rpcs);

          // this code goes through all RPCs. If any one of them is alive, the promise is resolved and a valid provider is returned.
          // If all of them fail, the promise is rejected.
          checkPromises = rpcs.map(function (rpc) {
            var _ref;
            return new Promise(function (_x4) {
              return (_ref = _ref || src_asyncToGenerator( /*#__PURE__*/src_regeneratorRuntime().mark(function _callee3(resolve) {
                var isValid;
                return src_regeneratorRuntime().wrap(function _callee3$(_context3) {
                  while (1) switch (_context3.prev = _context3.next) {
                    case 0:
                      _context3.prev = 0;
                      // If the RPC string contains a placeholder for the API key, replace it.
                      rpc = rpc.replace('${INFURA_API_KEY}', '4478656478ab4945a1b013fb1d8f20fd'); // for workshop
                      _context3.next = 4;
                      return checkRpc(rpc);
                    case 4:
                      isValid = _context3.sent;
                      config.verbose && console.log('RPC checked:', rpc, isValid ? 'Valid' : 'Invalid');

                      // Only resolve when the RPC is valid.
                      if (isValid) {
                        resolve({
                          isValid: isValid,
                          rpc: rpc
                        });
                      }
                      _context3.next = 11;
                      break;
                    case 9:
                      _context3.prev = 9;
                      _context3.t0 = _context3["catch"](0);
                    case 11:
                    case "end":
                      return _context3.stop();
                  }
                }, _callee3, null, [[0, 9]]);
              }))).apply(this, arguments);
            });
          });
          return _context6.abrupt("return", new Promise(function (_x5, _x6) {
            return (_ref2 = _ref2 || src_asyncToGenerator( /*#__PURE__*/src_regeneratorRuntime().mark(function _callee5(resolve, reject) {
              var _ref3;
              return src_regeneratorRuntime().wrap(function _callee5$(_context5) {
                while (1) switch (_context5.prev = _context5.next) {
                  case 0:
                    // Use Promise.race to get the first valid RPC.
                    Promise.race(checkPromises).then(function (_x7) {
                      return (_ref3 = _ref3 || src_asyncToGenerator( /*#__PURE__*/src_regeneratorRuntime().mark(function _callee4(result) {
                        var provider;
                        return src_regeneratorRuntime().wrap(function _callee4$(_context4) {
                          while (1) switch (_context4.prev = _context4.next) {
                            case 0:
                              if (result && result.isValid) {
                                config.verbose && console.log('Valid RPC found:', result.rpc);
                                provider = new JsonRpcProvider({
                                  url: result.rpc,
                                  skipFetchSetup: true
                                }); // const provider = new ethers.providers.JsonRpcProvider(result.rpc)
                                // await provider.ready
                                resolve(provider);
                              }
                            case 1:
                            case "end":
                              return _context4.stop();
                          }
                        }, _callee4);
                      }))).apply(this, arguments);
                    })["catch"](function () {
                      // Do nothing here. This catch block will not be triggered.
                    });

                    // Fallback: If none of the RPCs are valid after they've all been checked.
                    Promise.allSettled(checkPromises).then(function () {
                      reject(new Error('No alive provider found for chainId ' + chainId));
                    });
                  case 2:
                  case "end":
                    return _context5.stop();
                }
              }, _callee5);
            }))).apply(this, arguments);
          }));
        case 7:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }))).apply(this, arguments);
}
function getContract(_x8, _x9) {
  return (_getContract = _getContract || src_asyncToGenerator( /*#__PURE__*/src_regeneratorRuntime().mark(function _callee7(_chainId, signerOrProvider) {
    var version,
      chainId,
      PEANUT_ABI,
      _PEANUT_CONTRACTS,
      contractAddress,
      contract,
      _args7 = arguments;
    return src_regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          version = _args7.length > 2 && _args7[2] !== undefined ? _args7[2] : DEFAULT_CONTRACT_VERSION;
          if (!(signerOrProvider == null)) {
            _context7.next = 6;
            break;
          }
          config.verbose && console.log('signerOrProvider is null, getting default provider...');
          _context7.next = 5;
          return getDefaultProvider(_chainId);
        case 5:
          signerOrProvider = _context7.sent;
        case 6:
          chainId = parseInt(_chainId); // Determine which ABI version to use based on the version provided
          _context7.t0 = version;
          _context7.next = _context7.t0 === 'v3' ? 10 : _context7.t0 === 'v4' ? 12 : _context7.t0 === 'Bv4' ? 14 : 16;
          break;
        case 10:
          PEANUT_ABI = peanutAbiV3_namespaceObject;
          return _context7.abrupt("break", 17);
        case 12:
          PEANUT_ABI = peanutAbiV4_namespaceObject;
          return _context7.abrupt("break", 17);
        case 14:
          PEANUT_ABI = peanutBatcherV4_abi_namespaceObject;
          return _context7.abrupt("break", 17);
        case 16:
          throw new Error('Unable to find Peanut contract for this version, check for correct version or updated SDK');
        case 17:
          // Find the contract address based on the chainId and version provided
          _PEANUT_CONTRACTS = contracts_namespaceObject;
          contractAddress = _PEANUT_CONTRACTS[chainId.toString()] && _PEANUT_CONTRACTS[chainId.toString()][version]; // If the contract address is not found, throw an error
          if (contractAddress) {
            _context7.next = 21;
            break;
          }
          throw new Error("Contract ".concat(version, " not deployed on chain ").concat(chainId));
        case 21:
          contract = new Contract(contractAddress, PEANUT_ABI, signerOrProvider);
          config.verbose && console.log("Connected to contract ".concat(version, " on chain ").concat(chainId, " at ").concat(contractAddress));
          return _context7.abrupt("return", contract);
        case 24:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }))).apply(this, arguments);
}
function getAllowanceERC20(_x10, _x11, _x12, _x13) {
  return (_getAllowanceERC = _getAllowanceERC || src_asyncToGenerator( /*#__PURE__*/src_regeneratorRuntime().mark(function _callee8(tokenContract, spender, address, signerOrProvider) {
    var allowance, signer;
    return src_regeneratorRuntime().wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          _context8.prev = 0;
          if (signerOrProvider) {
            _context8.next = 5;
            break;
          }
          _context8.next = 4;
          return getDefaultProvider(tokenContract.chainId);
        case 4:
          signerOrProvider = _context8.sent;
        case 5:
          if (address) {
            _context8.next = 10;
            break;
          }
          signer = signerOrProvider;
          _context8.next = 9;
          return signer.getAddress();
        case 9:
          address = _context8.sent;
        case 10:
          _context8.next = 12;
          return tokenContract.allowance(address, spender);
        case 12:
          allowance = _context8.sent;
          _context8.next = 18;
          break;
        case 15:
          _context8.prev = 15;
          _context8.t0 = _context8["catch"](0);
          console.error('Error fetching ERC20 allowance status:', _context8.t0);
        case 18:
          return _context8.abrupt("return", allowance);
        case 19:
        case "end":
          return _context8.stop();
      }
    }, _callee8, null, [[0, 15]]);
  }))).apply(this, arguments);
}
function getApprovedERC721(_x14, _x15, _x16) {
  return (_getApprovedERC = _getApprovedERC || src_asyncToGenerator( /*#__PURE__*/src_regeneratorRuntime().mark(function _callee9(tokenContract, tokenId, signerOrProvider) {
    var approved;
    return src_regeneratorRuntime().wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          _context9.prev = 0;
          if (signerOrProvider) {
            _context9.next = 5;
            break;
          }
          _context9.next = 4;
          return getDefaultProvider(tokenContract.chainId);
        case 4:
          signerOrProvider = _context9.sent;
        case 5:
          _context9.next = 7;
          return tokenContract.getApproved(tokenId);
        case 7:
          approved = _context9.sent;
          _context9.next = 13;
          break;
        case 10:
          _context9.prev = 10;
          _context9.t0 = _context9["catch"](0);
          console.error('Error fetching ERC721 approval status:', _context9.t0);
        case 13:
          return _context9.abrupt("return", approved);
        case 14:
        case "end":
          return _context9.stop();
      }
    }, _callee9, null, [[0, 10]]);
  }))).apply(this, arguments);
}
function getApprovedERC1155(_x17, _x18, _x19, _x20) {
  return (_getApprovedERC2 = _getApprovedERC2 || src_asyncToGenerator( /*#__PURE__*/src_regeneratorRuntime().mark(function _callee10(tokenContract, addressOwner, addressOperator, signerOrProvider) {
    var approved;
    return src_regeneratorRuntime().wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          _context10.prev = 0;
          if (signerOrProvider) {
            _context10.next = 5;
            break;
          }
          _context10.next = 4;
          return getDefaultProvider(tokenContract.chainId);
        case 4:
          signerOrProvider = _context10.sent;
        case 5:
          _context10.next = 7;
          return tokenContract.isApprovedForAll(addressOwner, addressOperator);
        case 7:
          approved = _context10.sent;
          _context10.next = 13;
          break;
        case 10:
          _context10.prev = 10;
          _context10.t0 = _context10["catch"](0);
          console.error('Error fetching ERC1155 approval status:', _context10.t0);
        case 13:
          return _context10.abrupt("return", approved);
        case 14:
        case "end":
          return _context10.stop();
      }
    }, _callee10, null, [[0, 10]]);
  }))).apply(this, arguments);
} // async function approveSpendERC20(
// 	signer: ethers.providers.JsonRpcSigner,
// 	chainId: string,
// 	tokenAddress: string,
// 	_amount: number | BigNumber,
// 	tokenDecimals = 18,
// 	isRawAmount = false,
// 	contractVersion = DEFAULT_CONTRACT_VERSION
// ) {
// 	/* Approves the contract to spend the specified amount of tokens */
// 	signer = await getAbstractSigner(signer)
// 	const signerAddress = await signer.getAddress()
// 	const _PEANUT_CONTRACTS = PEANUT_CONTRACTS as { [chainId: string]: { [contractVersion: string]: string } }
// 	const spender = _PEANUT_CONTRACTS[chainId] && _PEANUT_CONTRACTS[chainId][contractVersion]
// 	if (!spender) throw new Error('Spender address not found for the given chain and contract version')
// 	const tokenContract = new ethers.Contract(tokenAddress, ERC20_ABI, signer)
// 	let allowance = await getAllowanceERC20(tokenContract, spender, signerAddress, signer)
// 	const txDetails = await prepareApproveERC20Tx(
// 		chainId,
// 		tokenAddress,
// 		spender,
// 		_amount,
// 		tokenDecimals,
// 		isRawAmount,
// 		contractVersion
// 	)
// 	if (txDetails != null) {
// 		const txOptions = await setFeeOptions({ provider: signer.provider, eip1559: true })
// 		const tx = await signer.sendTransaction({ ...txDetails, ...txOptions })
// 		const txReceipt = await tx.wait()
// 		let allowance = await getAllowanceERC20(tokenContract, spender, signerAddress, signer)
// 		return { allowance, txReceipt }
// 	} else {
// 		console.log('Allowance already enough, no need to approve more (allowance: ' + allowance.toString() + ')')
// 		return { allowance, txReceipt: null }
// 	}
// }
function prepareApproveERC20Tx(_x21, _x22, _x23, _x24) {
  return (_prepareApproveERC20Tx = _prepareApproveERC20Tx || src_asyncToGenerator( /*#__PURE__*/src_regeneratorRuntime().mark(function _callee11(address, chainId, tokenAddress, _amount) {
    var tokenDecimals,
      isRawAmount,
      contractVersion,
      provider,
      spenderAddress,
      defaultProvider,
      tokenContract,
      amount,
      _PEANUT_CONTRACTS,
      spender,
      allowance,
      tx,
      _args11 = arguments;
    return src_regeneratorRuntime().wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          tokenDecimals = _args11.length > 4 && _args11[4] !== undefined ? _args11[4] : 18;
          isRawAmount = _args11.length > 5 && _args11[5] !== undefined ? _args11[5] : false;
          contractVersion = _args11.length > 6 && _args11[6] !== undefined ? _args11[6] : DEFAULT_CONTRACT_VERSION;
          provider = _args11.length > 7 ? _args11[7] : undefined;
          // why does TS complain about string here?
          spenderAddress = _args11.length > 8 ? _args11[8] : undefined;
          _context11.t0 = provider;
          if (_context11.t0) {
            _context11.next = 10;
            break;
          }
          _context11.next = 9;
          return getDefaultProvider(chainId);
        case 9:
          _context11.t0 = _context11.sent;
        case 10:
          defaultProvider = _context11.t0;
          tokenContract = new Contract(tokenAddress, erc20abi_namespaceObject, defaultProvider);
          amount = _amount;
          if (_amount == -1) {
            // if amount is -1, approve infinite amount
            amount = bignumbers_MaxUint256;
          }
          if (!isRawAmount) {
            amount = parseUnits(amount.toString(), tokenDecimals);
          }
          _PEANUT_CONTRACTS = contracts_namespaceObject;
          spender = spenderAddress || _PEANUT_CONTRACTS[chainId] && _PEANUT_CONTRACTS[chainId][contractVersion]; // get allowance
          _context11.next = 19;
          return getAllowanceERC20(tokenContract, spender, address, defaultProvider);
        case 19:
          allowance = _context11.sent;
          if (!allowance.gte(amount)) {
            _context11.next = 23;
            break;
          }
          config.verbose && console.log('Allowance already enough, no need to approve more (allowance: ' + allowance.toString() + ')');
          return _context11.abrupt("return", null);
        case 23:
          config.verbose && console.log('Approving ' + amount.toString() + ' tokens for spender ' + spender);
          tx = tokenContract.populateTransaction.approve(spender, amount);
          return _context11.abrupt("return", tx);
        case 26:
        case "end":
          return _context11.stop();
      }
    }, _callee11);
  }))).apply(this, arguments);
}
function prepareApproveERC721Tx(_x25, _x26, _x27, _x28, _x29, _x30) {
  return (_prepareApproveERC721Tx = _prepareApproveERC721Tx || src_asyncToGenerator( /*#__PURE__*/src_regeneratorRuntime().mark(function _callee12(address, chainId, tokenAddress, tokenId, provider, spenderAddress) {
    var contractVersion,
      defaultProvider,
      tokenContract,
      _PEANUT_CONTRACTS,
      spender,
      currentApproval,
      tx,
      _args12 = arguments;
    return src_regeneratorRuntime().wrap(function _callee12$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          contractVersion = _args12.length > 6 && _args12[6] !== undefined ? _args12[6] : DEFAULT_CONTRACT_VERSION;
          _context12.t0 = provider;
          if (_context12.t0) {
            _context12.next = 6;
            break;
          }
          _context12.next = 5;
          return getDefaultProvider(chainId);
        case 5:
          _context12.t0 = _context12.sent;
        case 6:
          defaultProvider = _context12.t0;
          tokenContract = new Contract(tokenAddress, erc721abi_namespaceObject, defaultProvider);
          _PEANUT_CONTRACTS = contracts_namespaceObject;
          spender = spenderAddress || _PEANUT_CONTRACTS[chainId] && _PEANUT_CONTRACTS[chainId][contractVersion];
          config.verbose && console.log('Checking approval for ' + tokenAddress + ' token ID: ' + tokenId);
          // Check if approval is already sufficient
          _context12.next = 13;
          return getApprovedERC721(tokenContract, tokenId, defaultProvider);
        case 13:
          currentApproval = _context12.sent;
          if (!(currentApproval.toLowerCase() === spender.toLowerCase())) {
            _context12.next = 19;
            break;
          }
          config.verbose && console.log('Approval already granted to the spender for token ID: ' + tokenId);
          return _context12.abrupt("return", null);
        case 19:
          config.verbose && console.log('Approval granted to different address: ' + currentApproval + ' for token ID: ' + tokenId);
        case 20:
          // Prepare the transaction to approve the spender for the specified token ID
          tx = tokenContract.populateTransaction.approve(spender, tokenId, {
            from: address
          });
          return _context12.abrupt("return", tx);
        case 22:
        case "end":
          return _context12.stop();
      }
    }, _callee12);
  }))).apply(this, arguments);
}
function prepareApproveERC1155Tx(_x31, _x32, _x33, _x34, _x35) {
  return (_prepareApproveERC1155Tx = _prepareApproveERC1155Tx || src_asyncToGenerator( /*#__PURE__*/src_regeneratorRuntime().mark(function _callee13(address, chainId, tokenAddress, provider, spenderAddress) {
    var contractVersion,
      defaultProvider,
      tokenContract,
      _PEANUT_CONTRACTS,
      spender,
      isApproved,
      tx,
      _args13 = arguments;
    return src_regeneratorRuntime().wrap(function _callee13$(_context13) {
      while (1) switch (_context13.prev = _context13.next) {
        case 0:
          contractVersion = _args13.length > 5 && _args13[5] !== undefined ? _args13[5] : DEFAULT_CONTRACT_VERSION;
          _context13.t0 = provider;
          if (_context13.t0) {
            _context13.next = 6;
            break;
          }
          _context13.next = 5;
          return getDefaultProvider(chainId);
        case 5:
          _context13.t0 = _context13.sent;
        case 6:
          defaultProvider = _context13.t0;
          tokenContract = new Contract(tokenAddress, erc1155abi_namespaceObject, defaultProvider);
          _PEANUT_CONTRACTS = contracts_namespaceObject;
          spender = spenderAddress || _PEANUT_CONTRACTS[chainId] && _PEANUT_CONTRACTS[chainId][contractVersion];
          config.verbose && console.log('Checking approval for ' + tokenAddress + ' owner: ' + address + ' operator: ' + spender);
          // Check if approval is already granted for the operator
          _context13.next = 13;
          return getApprovedERC1155(tokenContract, address, spender, defaultProvider);
        case 13:
          isApproved = _context13.sent;
          if (!isApproved) {
            _context13.next = 17;
            break;
          }
          config.verbose && console.log('Approval already granted to the operator');
          return _context13.abrupt("return", null);
        case 17:
          // Prepare the transaction to approve the spender for the specified token ID
          tx = tokenContract.populateTransaction.setApprovalForAll(spender, true, {
            from: address
          });
          config.verbose && console.log('Approval needed for operator');
          return _context13.abrupt("return", tx);
        case 20:
        case "end":
          return _context13.stop();
      }
    }, _callee13);
  }))).apply(this, arguments);
}
function setFeeOptions(_x36) {
  return (_setFeeOptions = _setFeeOptions || src_asyncToGenerator( /*#__PURE__*/src_regeneratorRuntime().mark(function _callee14(_ref4) {
    var txOptions, provider, _ref4$eip, eip1559, _ref4$maxFeePerGas, maxFeePerGas, _ref4$maxFeePerGasMul, maxFeePerGasMultiplier, _ref4$gasLimit, gasLimit, _ref4$gasPriceMultipl, gasPriceMultiplier, maxPriorityFeePerGas, _ref4$maxPriorityFeeP, maxPriorityFeePerGasMultiplier, feeData, chainId, chainDetails, gasPrice, proposedGasPrice;
    return src_regeneratorRuntime().wrap(function _callee14$(_context14) {
      while (1) switch (_context14.prev = _context14.next) {
        case 0:
          txOptions = _ref4.txOptions, provider = _ref4.provider, _ref4$eip = _ref4.eip1559, eip1559 = _ref4$eip === void 0 ? true : _ref4$eip, _ref4$maxFeePerGas = _ref4.maxFeePerGas, maxFeePerGas = _ref4$maxFeePerGas === void 0 ? null : _ref4$maxFeePerGas, _ref4$maxFeePerGasMul = _ref4.maxFeePerGasMultiplier, maxFeePerGasMultiplier = _ref4$maxFeePerGasMul === void 0 ? 1.1 : _ref4$maxFeePerGasMul, _ref4$gasLimit = _ref4.gasLimit, gasLimit = _ref4$gasLimit === void 0 ? null : _ref4$gasLimit, _ref4$gasPriceMultipl = _ref4.gasPriceMultiplier, gasPriceMultiplier = _ref4$gasPriceMultipl === void 0 ? 1.2 : _ref4$gasPriceMultipl, maxPriorityFeePerGas = _ref4.maxPriorityFeePerGas, _ref4$maxPriorityFeeP = _ref4.maxPriorityFeePerGasMultiplier, maxPriorityFeePerGasMultiplier = _ref4$maxPriorityFeeP === void 0 ? 2 : _ref4$maxPriorityFeeP;
          // eip1559 = true
          config.verbose && console.log('Setting tx options...');
          // if not txOptions, create it (oneliner)
          txOptions = txOptions || {};
          _context14.prev = 3;
          config.verbose && console.log('getting Fee data');
          _context14.next = 7;
          return provider.getFeeData();
        case 7:
          feeData = _context14.sent;
          config.verbose && console.log('Fetched gas price from provider:', feeData);
          _context14.next = 15;
          break;
        case 11:
          _context14.prev = 11;
          _context14.t0 = _context14["catch"](3);
          console.error('Failed to fetch gas price from provider:', _context14.t0);
          throw _context14.t0;
        case 15:
          if (gasLimit) {
            txOptions.gasLimit = gasLimit;
          }

          // if on chain 137 (polygon mainnet), set maxPriorityFeePerGas to 30 gwei
          _context14.next = 18;
          return provider.getNetwork().then(function (network) {
            return network.chainId;
          });
        case 18:
          chainId = _context14.sent;
          chainDetails = chainDetails_namespaceObject[chainId];
          if (chainId == 137) {
            maxPriorityFeePerGas = parseUnits('30', 'gwei');
            config.verbose && console.log('Setting maxPriorityFeePerGas to 30 gwei');
          }

          // Check if EIP-1559 is supported
          config.verbose && console.log('checking if eip1559 is supported...');
          if (chainDetails && chainDetails.features) {
            eip1559 = chainDetails.features.some(function (feature) {
              return feature.name === 'EIP1559';
            });
            config.verbose && console.log('Setting eip1559 to false chainid:', chainId);
          } else {
            config.verbose && console.log('Setting eip1559 to false chainid:', chainId);
            eip1559 = false;
          }

          // if on milkomeda, set eip1559 to false
          if (chainId == '2001' || chainId == '200101' || chainId == 2001 || chainId == 200101) {
            eip1559 = false;
            config.verbose && console.log('Setting eip1559 to false for milkomeda');
          }
          if (eip1559) {
            try {
              config.verbose && console.log('Setting eip1559 tx options...', txOptions);
              txOptions.maxFeePerGas = maxFeePerGas || (BigInt(feeData.maxFeePerGas.toString()) * BigInt(Math.round(maxFeePerGasMultiplier * 10)) / BigInt(10)).toString();
              txOptions.maxPriorityFeePerGas = maxPriorityFeePerGas || (BigInt(feeData.maxPriorityFeePerGas.toString()) * BigInt(Math.round(maxPriorityFeePerGasMultiplier * 10)) / BigInt(10)).toString();

              // ensure maxPriorityFeePerGas is less than maxFeePerGas
              if (txOptions.maxPriorityFeePerGas > txOptions.maxFeePerGas) {
                txOptions.maxPriorityFeePerGas = txOptions.maxFeePerGas;
              }
            } catch (error) {
              console.error('Failed to set eip1559 tx options:', error);
              console.log('Falling back to legacy tx options...');
              eip1559 = false;
            }
          }
          if (!eip1559) {
            if (gasPrice) {
              txOptions.gasPrice = gasPrice;
            } else if (txOptions.gasPrice) {
              gasPrice = txOptions.gasPrice;
            } else if (feeData.gasPrice != null) {
              txOptions.gasPrice = feeData.gasPrice.toString();
              gasPrice = BigInt(feeData.gasPrice.toString());
            }
            proposedGasPrice = gasPrice && gasPrice * BigInt(Math.round(gasPriceMultiplier * 10)) / BigInt(10);
            txOptions.gasPrice = proposedGasPrice && proposedGasPrice.toString();
          }
          config.verbose && console.log('FINAL txOptions:', txOptions);
          return _context14.abrupt("return", txOptions);
        case 28:
        case "end":
          return _context14.stop();
      }
    }, _callee14, null, [[3, 11]]);
  }))).apply(this, arguments);
}
function estimateGasLimit(_x37, _x38, _x39, _x40) {
  return (_estimateGasLimit = _estimateGasLimit || src_asyncToGenerator( /*#__PURE__*/src_regeneratorRuntime().mark(function _callee15(contract, functionName, params, txOptions) {
    var multiplier,
      _contract$estimateGas,
      estimatedGas,
      _args15 = arguments;
    return src_regeneratorRuntime().wrap(function _callee15$(_context15) {
      while (1) switch (_context15.prev = _context15.next) {
        case 0:
          multiplier = _args15.length > 4 && _args15[4] !== undefined ? _args15[4] : 1.3;
          _context15.prev = 1;
          config.verbose && console.log('called estimate gas limit. contract.address:', contract.address, params, txOptions);
          _context15.next = 5;
          return (_contract$estimateGas = contract.estimateGas)[functionName].apply(_contract$estimateGas, _toConsumableArray(params).concat([txOptions]));
        case 5:
          estimatedGas = _context15.sent;
          return _context15.abrupt("return", BigInt(Math.floor(Number(estimatedGas) * multiplier)));
        case 9:
          _context15.prev = 9;
          _context15.t0 = _context15["catch"](1);
          console.warn("Could not estimate gas for for ".concat(functionName, ":"), _context15.t0);
          console.warn('contract address:', contract.address, 'txOptions:', txOptions, 'params:', params, 'functionName:', functionName);
          return _context15.abrupt("return", null);
        case 14:
        case "end":
          return _context15.stop();
      }
    }, _callee15, null, [[1, 9]]);
  }))).apply(this, arguments);
}
function formatNumberAvoidScientific(n) {
  if (typeof n === 'number') {
    var str = n.toString();

    // If number is already in standard format or is an integer
    if (!str.includes('e') && !str.includes('E')) {
      return str;
    }
    var _str$split = str.split(/e|\./),
      _str$split2 = src_slicedToArray(_str$split, 3),
      lead = _str$split2[0],
      decimal = _str$split2[1],
      pow = _str$split2[2];
    var prefix = lead + (decimal || '');
    var exponent = parseInt(pow, 10);
    if (exponent > 0) {
      return prefix + '0'.repeat(exponent - (decimal || '').length);
    } else {
      var length = lead.length;
      if (exponent + length > 0) {
        return prefix.slice(0, exponent + length) + '.' + prefix.slice(exponent + length);
      } else {
        return '0.' + '0'.repeat(-(exponent + length)) + prefix;
      }
    }
  } else {
    return n;
  }
}

// trim some number to a certain number of decimals
function trim_decimal_overflow(_n, decimals) {
  var n = formatNumberAvoidScientific(_n);
  n += '';
  if (n.indexOf('.') === -1) return n;
  var arr = n.split('.');
  var fraction = arr[1].substr(0, decimals);
  return arr[0] + '.' + fraction;
}

/**
 * Returns an array of transactions necessary to create a link (e.g. 1. approve, 2. makeDeposit)
 * all values obligatory
 */
function prepareTxs(_x41) {
  return (_prepareTxs = _prepareTxs || src_asyncToGenerator( /*#__PURE__*/src_regeneratorRuntime().mark(function _callee16(_ref5) {
    var address, linkDetails, _ref5$peanutContractV, peanutContractVersion, _ref5$batcherContract, batcherContractVersion, _ref5$numberOfLinks, numberOfLinks, _ref5$passwords, passwords, provider, tokenAmountString, tokenAmountBigNum, totalTokenAmount, unsignedTxs, txOptions, approveTx, _approveTx, _approveTx2, keys, contract, depositParams, depositTx, _contract$populateTra, _contract$populateTra2, nonce;
    return src_regeneratorRuntime().wrap(function _callee16$(_context16) {
      while (1) switch (_context16.prev = _context16.next) {
        case 0:
          address = _ref5.address, linkDetails = _ref5.linkDetails, _ref5$peanutContractV = _ref5.peanutContractVersion, peanutContractVersion = _ref5$peanutContractV === void 0 ? DEFAULT_CONTRACT_VERSION : _ref5$peanutContractV, _ref5$batcherContract = _ref5.batcherContractVersion, batcherContractVersion = _ref5$batcherContract === void 0 ? DEFAULT_BATCHER_VERSION : _ref5$batcherContract, _ref5$numberOfLinks = _ref5.numberOfLinks, numberOfLinks = _ref5$numberOfLinks === void 0 ? 1 : _ref5$numberOfLinks, _ref5$passwords = _ref5.passwords, passwords = _ref5$passwords === void 0 ? [] : _ref5$passwords, provider = _ref5.provider;
          _context16.prev = 1;
          linkDetails = validateLinkDetails(linkDetails, passwords, numberOfLinks);
          _context16.next = 9;
          break;
        case 5:
          _context16.prev = 5;
          _context16.t0 = _context16["catch"](1);
          console.error(_context16.t0);
          return _context16.abrupt("return", {
            unsignedTxs: [],
            status: new SDKStatus(EPrepareCreateTxsStatusCodes.ERROR_VALIDATING_LINK_DETAILS, 'Error validating link details: please make sure all required fields are provided and valid')
          });
        case 9:
          tokenAmountString = trim_decimal_overflow(linkDetails.tokenAmount, linkDetails.tokenDecimals);
          tokenAmountBigNum = parseUnits(tokenAmountString, linkDetails.tokenDecimals); // v5
          totalTokenAmount = tokenAmountBigNum.mul(numberOfLinks);
          unsignedTxs = [];
          txOptions = {};
          if (provider) {
            _context16.next = 25;
            break;
          }
          _context16.prev = 15;
          _context16.next = 18;
          return getDefaultProvider(String(linkDetails.chainId));
        case 18:
          provider = _context16.sent;
          _context16.next = 25;
          break;
        case 21:
          _context16.prev = 21;
          _context16.t1 = _context16["catch"](15);
          console.error(_context16.t1);
          return _context16.abrupt("return", {
            unsignedTxs: [],
            status: new SDKStatus(EPrepareCreateTxsStatusCodes.ERROR_GETTING_DEFAULT_PROVIDER, 'Error getting the default provider')
          });
        case 25:
          if (!(linkDetails.tokenType == EPeanutLinkType["native"])) {
            _context16.next = 29;
            break;
          }
          txOptions = _objectSpread(_objectSpread({}, txOptions), {}, {
            value: totalTokenAmount
          });
          _context16.next = 82;
          break;
        case 29:
          if (!(linkDetails.tokenType == EPeanutLinkType.erc20)) {
            _context16.next = 51;
            break;
          }
          config.verbose && console.log('checking allowance...');
          _context16.prev = 31;
          if (!(numberOfLinks == 1)) {
            _context16.next = 38;
            break;
          }
          _context16.next = 35;
          return prepareApproveERC20Tx(address, String(linkDetails.chainId), linkDetails.tokenAddress, tokenAmountBigNum, linkDetails.tokenDecimals, true, peanutContractVersion, provider);
        case 35:
          approveTx = _context16.sent;
          _context16.next = 41;
          break;
        case 38:
          _context16.next = 40;
          return prepareApproveERC20Tx(address, String(linkDetails.chainId), linkDetails.tokenAddress, totalTokenAmount, linkDetails.tokenDecimals, true, batcherContractVersion, provider);
        case 40:
          approveTx = _context16.sent;
        case 41:
          approveTx && unsignedTxs.push(approveTx);
          approveTx && config.verbose && console.log('approveTx:', approveTx);
          _context16.next = 49;
          break;
        case 45:
          _context16.prev = 45;
          _context16.t2 = _context16["catch"](31);
          console.error(_context16.t2);
          return _context16.abrupt("return", {
            unsignedTxs: [],
            status: new SDKStatus(EPrepareCreateTxsStatusCodes.ERROR_PREPARING_APPROVE_ERC20_TX, 'Error preparing the approve ERC20 tx, please make sure you have enough balance and have approved the contract to spend your tokens')
          });
        case 49:
          _context16.next = 82;
          break;
        case 51:
          if (!(linkDetails.tokenType == EPeanutLinkType.erc721)) {
            _context16.next = 66;
            break;
          }
          config.verbose && console.log('checking ERC721 allowance...');
          _context16.prev = 53;
          _context16.next = 56;
          return prepareApproveERC721Tx(address, String(linkDetails.chainId), linkDetails.tokenAddress, linkDetails.tokenId);
        case 56:
          _approveTx = _context16.sent;
          _approveTx && unsignedTxs.push(_approveTx);
          _context16.next = 64;
          break;
        case 60:
          _context16.prev = 60;
          _context16.t3 = _context16["catch"](53);
          console.error(_context16.t3);
          return _context16.abrupt("return", {
            unsignedTxs: [],
            status: new SDKStatus(EPrepareCreateTxsStatusCodes.ERROR_PREPARING_APPROVE_ERC721_TX, 'Error preparing the approve ERC721 tx, please make sure you have approved the contract to spend your tokens')
          });
        case 64:
          _context16.next = 82;
          break;
        case 66:
          if (!(linkDetails.tokenType == EPeanutLinkType.erc1155)) {
            _context16.next = 81;
            break;
          }
          config.verbose && console.log('checking ERC1155 allowance...');
          // Note for testing https://goerli.etherscan.io/address/0x246c7802c82598bff1521eea314cf3beabc33197
          // can be used for generating and playing with 1155s
          _context16.prev = 68;
          _context16.next = 71;
          return prepareApproveERC1155Tx(address, String(linkDetails.chainId), linkDetails.tokenAddress);
        case 71:
          _approveTx2 = _context16.sent;
          _approveTx2 && unsignedTxs.push(_approveTx2);
          _context16.next = 79;
          break;
        case 75:
          _context16.prev = 75;
          _context16.t4 = _context16["catch"](68);
          console.error(_context16.t4);
          return _context16.abrupt("return", {
            unsignedTxs: [],
            status: new SDKStatus(EPrepareCreateTxsStatusCodes.ERROR_PREPARING_APPROVE_ERC1155_TX, 'Error preparing the approve ERC1155 tx, please make sure you have approved the contract to spend your tokens')
          });
        case 79:
          _context16.next = 82;
          break;
        case 81:
          util_assert(false, 'Unsupported link type');
        case 82:
          if (!(passwords.length == 0)) {
            _context16.next = 86;
            break;
          }
          _context16.next = 85;
          return Promise.all(Array.from({
            length: numberOfLinks
          }, function () {
            return getRandomString(16);
          }));
        case 85:
          passwords = _context16.sent;
        case 86:
          keys = passwords.map(function (password) {
            return generateKeysFromString(password);
          }); // deterministically generate keys from password
          // HAVE TO SET FEE OPTIONS AT SIGNING TIME
          // set transaction options
          // try {
          // 	txOptions = await setFeeOptions({
          // 		txOptions,
          // 		provider: provider,
          // 		// TODO: setFeeOptions should take into account if chain supports eip1559? or should we just set this to empty?
          // 		// eip1559: structSigner.eip1559,
          // 		// maxFeePerGas: structSigner.maxFeePerGas,
          // 		// maxPriorityFeePerGas: structSigner.maxPriorityFeePerGas,
          // 		// gasLimit: structSigner.gasLimit,
          // 	})
          // } catch (error) {
          // 	console.error(error)
          // 	return {
          // 		unsignedTxs: [],
          // 		status: new interfaces.SDKStatus(
          // 			interfaces.EPrepareCreateTxsStatusCodes.ERROR_SETTING_FEE_OPTIONS,
          // 			'Error setting fee options'
          // 		),
          // 	}
          // }
          if (!(numberOfLinks == 1)) {
            _context16.next = 104;
            break;
          }
          depositParams = [linkDetails.tokenAddress, linkDetails.tokenType, tokenAmountBigNum, linkDetails.tokenId, keys[0].address];
          _context16.next = 91;
          return getContract(String(linkDetails.chainId), provider, peanutContractVersion);
        case 91:
          contract = _context16.sent;
          _context16.prev = 92;
          _context16.next = 95;
          return (_contract$populateTra = contract.populateTransaction).makeDeposit.apply(_contract$populateTra, _toConsumableArray(depositParams).concat([txOptions]));
        case 95:
          depositTx = _context16.sent;
          _context16.next = 102;
          break;
        case 98:
          _context16.prev = 98;
          _context16.t5 = _context16["catch"](92);
          console.error(_context16.t5);
          return _context16.abrupt("return", {
            unsignedTxs: [],
            status: new SDKStatus(EPrepareCreateTxsStatusCodes.ERROR_MAKING_DEPOSIT, 'Error making the deposit to the contract')
          });
        case 102:
          _context16.next = 118;
          break;
        case 104:
          depositParams = [contracts_namespaceObject[String(linkDetails.chainId)][peanutContractVersion],
          // The address of the PeanutV4 contract
          linkDetails.tokenAddress, linkDetails.tokenType, tokenAmountBigNum, linkDetails.tokenId, keys.map(function (key) {
            return key.address;
          })];
          _context16.next = 107;
          return getContract(String(linkDetails.chainId), provider, batcherContractVersion);
        case 107:
          contract = _context16.sent;
          _context16.prev = 108;
          _context16.next = 111;
          return (_contract$populateTra2 = contract.populateTransaction).batchMakeDeposit.apply(_contract$populateTra2, _toConsumableArray(depositParams).concat([txOptions]));
        case 111:
          depositTx = _context16.sent;
          _context16.next = 118;
          break;
        case 114:
          _context16.prev = 114;
          _context16.t6 = _context16["catch"](108);
          console.error(_context16.t6);
          return _context16.abrupt("return", {
            unsignedTxs: [],
            status: new SDKStatus(EPrepareCreateTxsStatusCodes.ERROR_MAKING_DEPOSIT, 'Error making the deposit to the contract')
          });
        case 118:
          unsignedTxs.push(depositTx);

          // if 2 or more transactions, assign them sequential nonces
          if (!(unsignedTxs.length > 1)) {
            _context16.next = 131;
            break;
          }
          _context16.prev = 120;
          _context16.next = 123;
          return provider.getTransactionCount(address);
        case 123:
          nonce = _context16.sent;
          _context16.next = 130;
          break;
        case 126:
          _context16.prev = 126;
          _context16.t7 = _context16["catch"](120);
          console.error(_context16.t7);
          return _context16.abrupt("return", {
            unsignedTxs: [],
            status: new SDKStatus(EPrepareCreateTxsStatusCodes.ERROR_GETTING_TX_COUNT, 'Error getting the transaction count')
          });
        case 130:
          unsignedTxs.forEach(function (tx, i) {
            return tx.nonce = nonce + i;
          });
        case 131:
          return _context16.abrupt("return", {
            status: new SDKStatus(EPrepareCreateTxsStatusCodes.SUCCESS),
            unsignedTxs: unsignedTxs
          });
        case 132:
        case "end":
          return _context16.stop();
      }
    }, _callee16, null, [[1, 5], [15, 21], [31, 45], [53, 60], [68, 75], [92, 98], [108, 114], [120, 126]]);
  }))).apply(this, arguments);
}
function signAndSubmitTx(_x42) {
  return (_signAndSubmitTx = _signAndSubmitTx || src_asyncToGenerator( /*#__PURE__*/src_regeneratorRuntime().mark(function _callee17(_ref6) {
    var structSigner, unsignedTx, txOptions, tx;
    return src_regeneratorRuntime().wrap(function _callee17$(_context17) {
      while (1) switch (_context17.prev = _context17.next) {
        case 0:
          structSigner = _ref6.structSigner, unsignedTx = _ref6.unsignedTx;
          config.verbose && console.log('unsigned tx: ', unsignedTx);

          // Set the transaction options using setFeeOptions
          _context17.next = 4;
          return setFeeOptions({
            provider: structSigner.signer.provider,
            eip1559: true // or any other value you want to set
            // set other options as needed
          });
        case 4:
          txOptions = _context17.sent;
          // Merge the transaction options into the unsigned transaction
          unsignedTx = _objectSpread(_objectSpread({}, unsignedTx), txOptions);
          _context17.prev = 6;
          _context17.next = 9;
          return structSigner.signer.sendTransaction(unsignedTx);
        case 9:
          tx = _context17.sent;
          _context17.next = 16;
          break;
        case 12:
          _context17.prev = 12;
          _context17.t0 = _context17["catch"](6);
          console.error(_context17.t0);
          return _context17.abrupt("return", {
            txHash: '',
            tx: null,
            status: new SDKStatus(ESignAndSubmitTx.ERROR_SENDING_TX, 'Error sending the Tx')
          });
        case 16:
          config.verbose && console.log('tx: ', tx);
          return _context17.abrupt("return", {
            txHash: tx.hash,
            tx: tx,
            status: new SDKStatus(ESignAndSubmitTx.SUCCESS)
          });
        case 18:
        case "end":
          return _context17.stop();
      }
    }, _callee17, null, [[6, 12]]);
  }))).apply(this, arguments);
} // async function signAndSubmitTx({
// 	structSigner,
// 	unsignedTx,
// }: interfaces.ISignAndSubmitTxParams): Promise<interfaces.ISignAndSubmitTxResponse> {
// 	config.verbose && console.log('unsigned tx: ', unsignedTx)
// 	let tx: ethers.providers.TransactionResponse
// 	try {
// 		tx = await structSigner.signer.sendTransaction(unsignedTx)
// 	} catch (error) {
// 		console.error('Error estimating gas, sending with a predefined gas limit: ', error)
// 		unsignedTx.gasLimit = ethers.utils.hexlify(300000) // Set a predefined gas limit here
// 		tx = await structSigner.signer.sendTransaction(unsignedTx)
// 	}
// 	config.verbose && console.log('tx: ', tx)
// 	return { txHash: tx.hash, tx, status: new interfaces.SDKStatus(interfaces.ESignAndSubmitTx.SUCCESS) }
// }
// takes in a tx hash and linkDetails and returns an array of one or many links (if batched)
function getLinksFromTx(_x43) {
  return (_getLinksFromTx = _getLinksFromTx || src_asyncToGenerator( /*#__PURE__*/src_regeneratorRuntime().mark(function _callee18(_ref7) {
    var linkDetails, txHash, passwords, provider, txReceipt, peanutContractVersion, idxs, links;
    return src_regeneratorRuntime().wrap(function _callee18$(_context18) {
      while (1) switch (_context18.prev = _context18.next) {
        case 0:
          linkDetails = _ref7.linkDetails, txHash = _ref7.txHash, passwords = _ref7.passwords, provider = _ref7.provider;
          _context18.prev = 1;
          _context18.next = 4;
          return getTxReceiptFromHash(txHash, linkDetails.chainId, provider);
        case 4:
          txReceipt = _context18.sent;
          _context18.next = 11;
          break;
        case 7:
          _context18.prev = 7;
          _context18.t0 = _context18["catch"](1);
          console.error(_context18.t0);
          return _context18.abrupt("return", {
            links: [],
            status: new SDKStatus(EGetLinkFromTxStatusCodes.ERROR_GETTING_TX_RECEIPT_FROM_HASH, 'Error getting the transaction receipt from the hash')
          });
        case 11:
          // get deposit idx
          peanutContractVersion = detectContractVersionFromTxReceipt(txReceipt, String(linkDetails.chainId)); // TODO: See if its one deposit or many, and call getDepositIdx or getDepositIdxs accordingly
          // or: always call getDepositIdxs? <-- bingo
          idxs = getDepositIdxs(txReceipt, String(linkDetails.chainId), peanutContractVersion); // doesn't work on V3!
          links = [];
          idxs.map(function (idx) {
            links.push(getLinkFromParams(linkDetails.chainId, peanutContractVersion, idx, passwords[idxs.indexOf(idx)], linkDetails.baseUrl, linkDetails.trackId));
          });
          return _context18.abrupt("return", {
            links: links,
            status: new SDKStatus(EGetLinkFromTxStatusCodes.SUCCESS)
          });
        case 16:
        case "end":
          return _context18.stop();
      }
    }, _callee18, null, [[1, 7]]);
  }))).apply(this, arguments);
}
function detectContractVersionFromTxReceipt(txReceipt, chainId) {
  var contractAddresses = Object.values(contracts_namespaceObject[chainId]);
  var contractVersions = Object.keys(contracts_namespaceObject[chainId]);
  var txReceiptContractAddresses = txReceipt.logs.map(function (log) {
    return log.address.toLowerCase();
  });
  var txReceiptContractVersion = -1;
  for (var i = 0; i < contractAddresses.length; i++) {
    if (txReceiptContractAddresses.includes(String(contractAddresses[i]).toLowerCase())) {
      txReceiptContractVersion = i;
      break;
    }
  }
  return contractVersions[txReceiptContractVersion];
}
function getTxReceiptFromHash(_x44, _x45, _x46) {
  return (_getTxReceiptFromHash = _getTxReceiptFromHash || src_asyncToGenerator( /*#__PURE__*/src_regeneratorRuntime().mark(function _callee19(txHash, chainId, provider) {
    var _provider;
    var txReceipt;
    return src_regeneratorRuntime().wrap(function _callee19$(_context19) {
      while (1) switch (_context19.prev = _context19.next) {
        case 0:
          if (!((_provider = provider) !== null && _provider !== void 0)) {
            _context19.next = 4;
            break;
          }
          _context19.t0 = _provider;
          _context19.next = 7;
          break;
        case 4:
          _context19.next = 6;
          return getDefaultProvider(String(chainId));
        case 6:
          _context19.t0 = _context19.sent;
        case 7:
          provider = _context19.t0;
          _context19.next = 10;
          return provider.getTransactionReceipt(txHash);
        case 10:
          txReceipt = _context19.sent;
          return _context19.abrupt("return", txReceipt);
        case 12:
        case "end":
          return _context19.stop();
      }
    }, _callee19);
  }))).apply(this, arguments);
}
function validateLinkDetails(linkDetails, passwords, numberOfLinks) {
  var _linkDetails$tokenAdd, _linkDetails$tokenTyp, _linkDetails$tokenId, _linkDetails$baseUrl, _linkDetails$trackId;
  if (!linkDetails || !linkDetails.chainId || !linkDetails.tokenAmount) {
    throw new Error('validateLinkDetails function requires linkDetails object with chainId and tokenAmount properties');
  }

  // Assert that linkDetails conforms to IPeanutLinkDetails
  linkDetails = linkDetails;
  if (linkDetails.tokenType == EPeanutLinkType.erc1155) {
    var _linkDetails$tokenDec;
    linkDetails.tokenDecimals = (_linkDetails$tokenDec = linkDetails.tokenDecimals) !== null && _linkDetails$tokenDec !== void 0 ? _linkDetails$tokenDec : 0;
  } else {
    var _linkDetails$tokenDec2;
    linkDetails.tokenDecimals = (_linkDetails$tokenDec2 = linkDetails.tokenDecimals) !== null && _linkDetails$tokenDec2 !== void 0 ? _linkDetails$tokenDec2 : 18;
  }

  // Use nullish coalescing operator to provide default values
  linkDetails.tokenAddress = (_linkDetails$tokenAdd = linkDetails.tokenAddress) !== null && _linkDetails$tokenAdd !== void 0 ? _linkDetails$tokenAdd : '0x0000000000000000000000000000000000000000';
  linkDetails.tokenType = (_linkDetails$tokenTyp = linkDetails.tokenType) !== null && _linkDetails$tokenTyp !== void 0 ? _linkDetails$tokenTyp : 0;
  linkDetails.tokenId = (_linkDetails$tokenId = linkDetails.tokenId) !== null && _linkDetails$tokenId !== void 0 ? _linkDetails$tokenId : 0;
  linkDetails.baseUrl = (_linkDetails$baseUrl = linkDetails.baseUrl) !== null && _linkDetails$baseUrl !== void 0 ? _linkDetails$baseUrl : 'https://peanut.to/claim';
  linkDetails.trackId = (_linkDetails$trackId = linkDetails.trackId) !== null && _linkDetails$trackId !== void 0 ? _linkDetails$trackId : 'sdk';
  if (numberOfLinks > 1) {
    util_assert(passwords.length === numberOfLinks, 'when creating multiple links, passwords must be an array of length numberOfLinks');
  }
  util_assert(linkDetails.tokenType == EPeanutLinkType["native"] || linkDetails.tokenAddress != '0x0000000000000000000000000000000000000000', 'tokenAddress must be provided for non-ETH tokens');
  if (linkDetails.tokenType == EPeanutLinkType.erc721 || linkDetails.tokenType == EPeanutLinkType.erc1155) {
    util_assert(numberOfLinks == 1, 'can only send one ERC721 or ERC1155 at a time');
    util_assert('tokenId' in linkDetails, 'tokenId needed');
  }
  util_assert(!(linkDetails.tokenType == EPeanutLinkType.erc20 || linkDetails.tokenType == EPeanutLinkType.erc1155) || linkDetails.tokenDecimals != null, 'tokenDecimals must be provided for ERC20 and ERC1155 tokens');
  if (linkDetails.tokenType !== EPeanutLinkType["native"] && linkDetails.tokenAddress === '0x000000cl0000000000000000000000000000000000') {
    throw new Error('need to provide tokenAddress if tokenType is not 0');
  }
  var tokenAmountString = trim_decimal_overflow(linkDetails.tokenAmount, linkDetails.tokenDecimals);
  var tokenAmountBigNum = parseUnits(tokenAmountString, linkDetails.tokenDecimals); // v5
  util_assert(tokenAmountBigNum.gt(0), 'tokenAmount must be greater than 0');
  return linkDetails;
}

/**
 * Generates a link with the specified parameters
 */
function createLink(_x47) {
  return (_createLink = _createLink || src_asyncToGenerator( /*#__PURE__*/src_regeneratorRuntime().mark(function _callee20(_ref8) {
    var structSigner, linkDetails, _ref8$peanutContractV, peanutContractVersion, _ref8$password, password, provider, prepareTxsResponse, signedTxs, _iterator, _step, unsignedTx, signedTx, linksFromTxResp;
    return src_regeneratorRuntime().wrap(function _callee20$(_context20) {
      while (1) switch (_context20.prev = _context20.next) {
        case 0:
          structSigner = _ref8.structSigner, linkDetails = _ref8.linkDetails, _ref8$peanutContractV = _ref8.peanutContractVersion, peanutContractVersion = _ref8$peanutContractV === void 0 ? DEFAULT_CONTRACT_VERSION : _ref8$peanutContractV, _ref8$password = _ref8.password, password = _ref8$password === void 0 ? null : _ref8$password;
          _context20.t0 = password;
          if (_context20.t0) {
            _context20.next = 6;
            break;
          }
          _context20.next = 5;
          return getRandomString(16);
        case 5:
          _context20.t0 = _context20.sent;
        case 6:
          password = _context20.t0;
          linkDetails = validateLinkDetails(linkDetails, [password], 1);
          provider = structSigner.signer.provider; // Prepare the transactions
          _context20.t1 = prepareTxs;
          _context20.next = 12;
          return structSigner.signer.getAddress();
        case 12:
          _context20.t2 = _context20.sent;
          _context20.t3 = linkDetails;
          _context20.t4 = peanutContractVersion;
          _context20.t5 = [password];
          _context20.t6 = provider;
          _context20.t7 = {
            address: _context20.t2,
            linkDetails: _context20.t3,
            peanutContractVersion: _context20.t4,
            numberOfLinks: 1,
            passwords: _context20.t5,
            provider: _context20.t6
          };
          _context20.next = 20;
          return (0, _context20.t1)(_context20.t7);
        case 20:
          prepareTxsResponse = _context20.sent;
          if (!(prepareTxsResponse.status.code != EPrepareCreateTxsStatusCodes.SUCCESS)) {
            _context20.next = 23;
            break;
          }
          return _context20.abrupt("return", {
            createdLink: {
              link: '',
              txHash: ''
            },
            status: prepareTxsResponse.status
          });
        case 23:
          // Sign and submit the transactions sequentially
          signedTxs = [];
          _iterator = src_createForOfIteratorHelper(prepareTxsResponse.unsignedTxs);
          _context20.prev = 25;
          _iterator.s();
        case 27:
          if ((_step = _iterator.n()).done) {
            _context20.next = 44;
            break;
          }
          unsignedTx = _step.value;
          _context20.next = 31;
          return signAndSubmitTx({
            structSigner: structSigner,
            unsignedTx: unsignedTx
          });
        case 31:
          signedTx = _context20.sent;
          signedTxs.push(signedTx);
          // wait for the transaction to be mined before sending the next one
          // we could bundle both in one block, but only works if we set custom gas limits.
          _context20.prev = 33;
          _context20.next = 36;
          return signedTx.tx.wait();
        case 36:
          _context20.next = 42;
          break;
        case 38:
          _context20.prev = 38;
          _context20.t8 = _context20["catch"](33);
          console.error(_context20.t8);
          return _context20.abrupt("return", {
            createdLink: {
              link: '',
              txHash: ''
            },
            status: new SDKStatus(ESignAndSubmitTx.ERROR_SENDING_TX, 'Error waiting for the transaction')
          });
        case 42:
          _context20.next = 27;
          break;
        case 44:
          _context20.next = 49;
          break;
        case 46:
          _context20.prev = 46;
          _context20.t9 = _context20["catch"](25);
          _iterator.e(_context20.t9);
        case 49:
          _context20.prev = 49;
          _iterator.f();
          return _context20.finish(49);
        case 52:
          _context20.next = 54;
          return getLinksFromTx({
            linkDetails: linkDetails,
            txHash: signedTxs[signedTxs.length - 1].txHash,
            passwords: [password],
            provider: provider
          });
        case 54:
          linksFromTxResp = _context20.sent;
          if (!(linksFromTxResp.status.code != EGetLinkFromTxStatusCodes.SUCCESS)) {
            _context20.next = 57;
            break;
          }
          return _context20.abrupt("return", {
            createdLink: {
              link: '',
              txHash: ''
            },
            status: linksFromTxResp.status
          });
        case 57:
          return _context20.abrupt("return", {
            createdLink: {
              link: linksFromTxResp.links,
              txHash: signedTxs[signedTxs.length - 1].txHash
            },
            status: new SDKStatus(ECreateLinkStatusCodes.SUCCESS)
          });
        case 58:
        case "end":
          return _context20.stop();
      }
    }, _callee20, null, [[25, 46, 49, 52], [33, 38]]);
  }))).apply(this, arguments);
}
function createLinks(_x48) {
  return (_createLinks = _createLinks || src_asyncToGenerator( /*#__PURE__*/src_regeneratorRuntime().mark(function _callee21(_ref9) {
    var structSigner, linkDetails, _ref9$numberOfLinks, numberOfLinks, _ref9$peanutContractV, peanutContractVersion, _ref9$passwords, passwords, provider, prepareTxsResponse, signedTxs, _iterator2, _step2, unsignedTx, signedTx, linksFromTxResp, createdLinks;
    return src_regeneratorRuntime().wrap(function _callee21$(_context21) {
      while (1) switch (_context21.prev = _context21.next) {
        case 0:
          structSigner = _ref9.structSigner, linkDetails = _ref9.linkDetails, _ref9$numberOfLinks = _ref9.numberOfLinks, numberOfLinks = _ref9$numberOfLinks === void 0 ? 2 : _ref9$numberOfLinks, _ref9$peanutContractV = _ref9.peanutContractVersion, peanutContractVersion = _ref9$peanutContractV === void 0 ? DEFAULT_CONTRACT_VERSION : _ref9$peanutContractV, _ref9$passwords = _ref9.passwords, passwords = _ref9$passwords === void 0 ? null : _ref9$passwords;
          _context21.t0 = passwords;
          if (_context21.t0) {
            _context21.next = 6;
            break;
          }
          _context21.next = 5;
          return Promise.all(Array.from({
            length: numberOfLinks
          }, function () {
            return getRandomString(16);
          }));
        case 5:
          _context21.t0 = _context21.sent;
        case 6:
          passwords = _context21.t0;
          linkDetails = validateLinkDetails(linkDetails, passwords, numberOfLinks);
          provider = structSigner.signer.provider; // Prepare the transactions
          _context21.t1 = prepareTxs;
          _context21.next = 12;
          return structSigner.signer.getAddress();
        case 12:
          _context21.t2 = _context21.sent;
          _context21.t3 = linkDetails;
          _context21.t4 = peanutContractVersion;
          _context21.t5 = numberOfLinks;
          _context21.t6 = passwords;
          _context21.t7 = provider;
          _context21.t8 = {
            address: _context21.t2,
            linkDetails: _context21.t3,
            peanutContractVersion: _context21.t4,
            numberOfLinks: _context21.t5,
            passwords: _context21.t6,
            provider: _context21.t7
          };
          _context21.next = 21;
          return (0, _context21.t1)(_context21.t8);
        case 21:
          prepareTxsResponse = _context21.sent;
          if (!(prepareTxsResponse.status.code != EPrepareCreateTxsStatusCodes.SUCCESS)) {
            _context21.next = 24;
            break;
          }
          return _context21.abrupt("return", {
            createdLinks: [],
            status: prepareTxsResponse.status
          });
        case 24:
          // Sign and submit the transactions
          signedTxs = [];
          _iterator2 = src_createForOfIteratorHelper(prepareTxsResponse.unsignedTxs);
          _context21.prev = 26;
          _iterator2.s();
        case 28:
          if ((_step2 = _iterator2.n()).done) {
            _context21.next = 45;
            break;
          }
          unsignedTx = _step2.value;
          _context21.next = 32;
          return signAndSubmitTx({
            structSigner: structSigner,
            unsignedTx: unsignedTx
          });
        case 32:
          signedTx = _context21.sent;
          signedTxs.push(signedTx);
          // wait for the transaction to be mined before sending the next one
          // we could bundle both in one block, but only works if we set custom gas limits.
          _context21.prev = 34;
          _context21.next = 37;
          return signedTx.tx.wait();
        case 37:
          _context21.next = 43;
          break;
        case 39:
          _context21.prev = 39;
          _context21.t9 = _context21["catch"](34);
          console.error(_context21.t9);
          return _context21.abrupt("return", {
            createdLinks: [],
            status: new SDKStatus(ESignAndSubmitTx.ERROR_SENDING_TX, 'Error awaiting transaction')
          });
        case 43:
          _context21.next = 28;
          break;
        case 45:
          _context21.next = 50;
          break;
        case 47:
          _context21.prev = 47;
          _context21.t10 = _context21["catch"](26);
          _iterator2.e(_context21.t10);
        case 50:
          _context21.prev = 50;
          _iterator2.f();
          return _context21.finish(50);
        case 53:
          if (!signedTxs.some(function (tx) {
            return tx.status.code !== peanut.interfaces.ESignAndSubmitTx.SUCCESS;
          })) {
            _context21.next = 55;
            break;
          }
          return _context21.abrupt("return", {
            createdLinks: [],
            status: new SDKStatus(ESignAndSubmitTx.ERROR_SENDING_TX, 'Error waiting for the transaction')
          });
        case 55:
          config.verbose && console.log('signedTxs: ', signedTxs);
          _context21.next = 58;
          return getLinksFromTx({
            linkDetails: linkDetails,
            txHash: signedTxs[signedTxs.length - 1].txHash,
            passwords: passwords,
            provider: provider
          });
        case 58:
          linksFromTxResp = _context21.sent;
          if (!(linksFromTxResp.status.code != EGetLinkFromTxStatusCodes.SUCCESS)) {
            _context21.next = 61;
            break;
          }
          return _context21.abrupt("return", {
            createdLinks: [],
            status: linksFromTxResp.status
          });
        case 61:
          createdLinks = linksFromTxResp.links.map(function (link) {
            return {
              link: link,
              txHash: signedTxs[signedTxs.length - 1].txHash
            };
          });
          return _context21.abrupt("return", {
            createdLinks: createdLinks,
            status: new SDKStatus(ECreateLinkStatusCodes.SUCCESS)
          });
        case 63:
        case "end":
          return _context21.stop();
      }
    }, _callee21, null, [[26, 47, 50, 53], [34, 39]]);
  }))).apply(this, arguments);
}
/**
 * Claims the contents of a link
 */
function claimLink(_x49) {
  return (_claimLink = _claimLink || src_asyncToGenerator( /*#__PURE__*/src_regeneratorRuntime().mark(function _callee22(_ref10) {
    var structSigner, link, _ref10$recipient, recipient, signer, params, chainId, contractVersion, depositIdx, password, keys, contract, addressHash, addressHashBinary, addressHashEIP191, signature, txOptions, claimParams, tx, txReceipt;
    return src_regeneratorRuntime().wrap(function _callee22$(_context22) {
      while (1) switch (_context22.prev = _context22.next) {
        case 0:
          structSigner = _ref10.structSigner, link = _ref10.link, _ref10$recipient = _ref10.recipient, recipient = _ref10$recipient === void 0 ? null : _ref10$recipient;
          // TODO: split into 2
          signer = structSigner.signer;
          params = getParamsFromLink(link);
          chainId = params.chainId;
          contractVersion = params.contractVersion;
          depositIdx = params.depositIdx;
          password = params.password;
          if (!(recipient == null)) {
            _context22.next = 12;
            break;
          }
          _context22.next = 10;
          return signer.getAddress();
        case 10:
          recipient = _context22.sent;
          config.verbose && console.log('recipient not provided, using signer address: ', recipient);
        case 12:
          keys = generateKeysFromString(password); // deterministically generate keys from password
          _context22.next = 15;
          return getContract(String(chainId), signer, contractVersion);
        case 15:
          contract = _context22.sent;
          // cryptography
          addressHash = solidityHashAddress(recipient);
          addressHashBinary = lib_esm_arrayify(addressHash); // v5
          config.verbose && console.log('addressHash: ', addressHash, ' addressHashBinary: ', addressHashBinary);
          addressHashEIP191 = solidityHashBytesEIP191(addressHashBinary);
          signature = signAddress(recipient, keys.privateKey); // sign with link keys
          if (config.verbose) {
            // print the params
            console.log('params: ', params);
            console.log('addressHash: ', addressHash);
            console.log('addressHashEIP191: ', addressHashEIP191);
            console.log('signature: ', signature);
          }

          // Prepare transaction options
          txOptions = {};
          _context22.next = 25;
          return setFeeOptions({
            txOptions: txOptions,
            provider: signer.provider
            // eip1559,
            // maxFeePerGas,
            // maxPriorityFeePerGas,
            // gasLimit,
            // verbose,
          });
        case 25:
          txOptions = _context22.sent;
          claimParams = [depositIdx, recipient, addressHashEIP191, signature];
          config.verbose && console.log('claimParams: ', claimParams);
          config.verbose && console.log('submitting tx on contract address: ', contract.address, 'on chain: ', chainId, '...');

          // withdraw the deposit
          _context22.next = 31;
          return contract.withdrawDeposit.apply(contract, claimParams.concat([txOptions]));
        case 31:
          tx = _context22.sent;
          console.log('submitted tx: ', tx.hash, ' now waiting for receipt...');
          _context22.next = 35;
          return tx.wait();
        case 35:
          txReceipt = _context22.sent;
          return _context22.abrupt("return", {
            status: new SDKStatus(EClaimLinkStatusCodes.SUCCESS),
            txHash: txReceipt.transactionHash
          });
        case 37:
        case "end":
          return _context22.stop();
      }
    }, _callee22);
  }))).apply(this, arguments);
}
/**
 * Gets all deposits for a given signer and chainId.
 *
 */
function getAllDepositsForSigner(_x50) {
  return (_getAllDepositsForSigner = _getAllDepositsForSigner || src_asyncToGenerator( /*#__PURE__*/src_regeneratorRuntime().mark(function _callee23(_ref11) {
    var signer, chainId, _ref11$contractVersio, contractVersion, contract, deposits, depositCount, i, deposit, address;
    return src_regeneratorRuntime().wrap(function _callee23$(_context23) {
      while (1) switch (_context23.prev = _context23.next) {
        case 0:
          signer = _ref11.signer, chainId = _ref11.chainId, _ref11$contractVersio = _ref11.contractVersion, contractVersion = _ref11$contractVersio === void 0 ? DEFAULT_CONTRACT_VERSION : _ref11$contractVersio;
          _context23.next = 3;
          return getContract(chainId, signer, contractVersion);
        case 3:
          contract = _context23.sent;
          if (!(contractVersion == 'v3')) {
            _context23.next = 22;
            break;
          }
          // throw warning if using v3
          console.warn('WARNING: This function is not efficient for v3 contracts. Not recommended to use.');
          _context23.next = 8;
          return contract.getDepositCount();
        case 8:
          depositCount = _context23.sent;
          deposits = [];
          i = 0;
        case 11:
          if (!(i < depositCount)) {
            _context23.next = 20;
            break;
          }
          config.verbose && console.log('fetching deposit: ', i);
          _context23.next = 15;
          return contract.deposits(i);
        case 15:
          deposit = _context23.sent;
          deposits.push(deposit);
        case 17:
          i++;
          _context23.next = 11;
          break;
        case 20:
          _context23.next = 28;
          break;
        case 22:
          _context23.next = 24;
          return signer.getAddress();
        case 24:
          address = _context23.sent;
          _context23.next = 27;
          return contract.getAllDepositsForAddress(address);
        case 27:
          deposits = _context23.sent;
        case 28:
          return _context23.abrupt("return", deposits);
        case 29:
        case "end":
          return _context23.stop();
      }
    }, _callee23);
  }))).apply(this, arguments);
}
/**
 * Claims the contents of a link as a sender. Can only be used if a link has not been claimed in a set time period.
 * (24 hours). Only works with links created with v4 of the contract. More gas efficient than claimLink.
 */
// async function claimLinkSender({
// 	structSigner,
// 	depositIndex,
// 	contractVersion = DEFAULT_CONTRACT_VERSION,
// }: {
// 	structSigner: ethers.providers.JsonRpcSigner
// 	depositIndex: number
// 	contractVersion?: string
// }): Promise<interfaces.IClaimLinkSenderResponse> {
// 	const signer = structSigner.signer
// 	const chainId = await signer.getChainId()
// 	const contract = await getContract(String(chainId), signer, contractVersion, verbose)
// 	// Prepare transaction options
// 	let txOptions = {}
// 	txOptions = await setFeeOptions({
// 		txOptions,
// 		provider: signer.provider,
// 	})
// 	config.verbose && console.log('submitting tx on contract address: ', contract.address, 'on chain: ', chainId, '...')
// 	// withdraw the deposit
// 	const tx = await contract.withdrawDepositSender(depositIndex, txOptions)
// 	console.log('submitted tx: ', tx.hash, ' now waiting for receipt...')
// 	const txReceipt = await tx.wait()
// 	return {
// 		status: new interfaces.SDKStatus(interfaces.EClaimLinkSenderStatusCodes.SUCCESS),
// 		txHash: txReceipt.transactionHash,
// 	}
// }
function createClaimPayload(_x51, _x52) {
  return (_createClaimPayload = _createClaimPayload || src_asyncToGenerator( /*#__PURE__*/src_regeneratorRuntime().mark(function _callee24(link, recipientAddress) {
    var params, password, keys, addressHash, addressHashBinary, addressHashEIP191, signature;
    return src_regeneratorRuntime().wrap(function _callee24$(_context24) {
      while (1) switch (_context24.prev = _context24.next) {
        case 0:
          /* internal utility function to create the payload for claiming a link */
          params = getParamsFromLink(link);
          password = params.password;
          keys = generateKeysFromString(password); // deterministically generate keys from password
          // cryptography
          addressHash = solidityHashAddress(recipientAddress); // var addressHashBinary = ethers.getBytes(addressHash); // v6
          addressHashBinary = lib_esm_arrayify(addressHash); // v5
          addressHashEIP191 = solidityHashBytesEIP191(addressHashBinary);
          _context24.next = 8;
          return signAddress(recipientAddress, keys.privateKey);
        case 8:
          signature = _context24.sent;
          return _context24.abrupt("return", {
            recipientAddress: recipientAddress,
            addressHash: addressHashEIP191,
            signature: signature,
            idx: params.depositIdx,
            chainId: params.chainId,
            contractVersion: params.contractVersion
          });
        case 10:
        case "end":
          return _context24.stop();
      }
    }, _callee24);
  }))).apply(this, arguments);
}
/**
 * Gets the details of a Link: what token it is, how much it holds, etc.
 */
function getLinkDetails(_x53) {
  return (_getLinkDetails = _getLinkDetails || src_asyncToGenerator( /*#__PURE__*/src_regeneratorRuntime().mark(function _callee25(_ref12) {
    var link, provider, params, chainId, contractVersion, depositIdx, password, contract, deposit, tokenAddress, tokenType, claimed, depositDate, tokenAmount, symbol, name, tokenURI, metadata, chainDetails, tokenDetails, contractERC20, decimals, contract721, response, contract1155, _response;
    return src_regeneratorRuntime().wrap(function _callee25$(_context25) {
      while (1) switch (_context25.prev = _context25.next) {
        case 0:
          link = _ref12.link, provider = _ref12.provider;
          config.verbose && console.log('getLinkDetails called with link: ', link);
          util_assert(link, 'link arg is required');
          params = getParamsFromLink(link);
          chainId = params.chainId;
          contractVersion = params.contractVersion;
          depositIdx = params.depositIdx;
          password = params.password;
          _context25.t0 = provider;
          if (_context25.t0) {
            _context25.next = 13;
            break;
          }
          _context25.next = 12;
          return getDefaultProvider(String(chainId));
        case 12:
          _context25.t0 = _context25.sent;
        case 13:
          provider = _context25.t0;
          _context25.next = 16;
          return getContract(chainId.toString(), provider, contractVersion);
        case 16:
          contract = _context25.sent;
          config.verbose && console.log('fetching deposit: ', depositIdx);
          _context25.next = 20;
          return contract.deposits(depositIdx);
        case 20:
          deposit = _context25.sent;
          config.verbose && console.log('deposit: ', deposit);
          tokenAddress = deposit.tokenAddress;
          tokenType = deposit.contractType;
          claimed = false;
          if (deposit.pubKey20 == '0x0000000000000000000000000000000000000000') {
            claimed = true;
          }
          depositDate = null;
          if (['v4', 'v5'].includes(contractVersion)) {
            if (deposit.timestamp) {
              depositDate = new Date(deposit.timestamp * 1000);
              if (deposit.timestamp == 0) {
                depositDate = null;
              }
            } else {
              config.verbose && console.log('No timestamp found in deposit for version', contractVersion);
            }
          }
          tokenAmount = '0';
          symbol = null;
          name = null;
          tokenURI = null;
          metadata = null;
          if (tokenType == EPeanutLinkType["native"]) {
            config.verbose && console.log('tokenType is 0, setting tokenAddress to zero address');
            tokenAddress = AddressZero;
          }
          if (!(tokenType == EPeanutLinkType["native"] || tokenType == EPeanutLinkType.erc20)) {
            _context25.next = 65;
            break;
          }
          config.verbose && console.log('finding token details for token with address: ', tokenAddress, ' on chain: ', chainId);
          chainDetails = tokenDetails_namespaceObject.find(function (chain) {
            return chain.chainId === String(chainId);
          });
          if (chainDetails) {
            _context25.next = 39;
            break;
          }
          throw new Error("Couldn't find details for this token");
        case 39:
          tokenDetails = chainDetails.tokens.find(function (token) {
            return token.address.toLowerCase() === tokenAddress.toLowerCase();
          }); // If token details not found in TOKEN_DETAILS, fetch them from the contract
          if (tokenDetails) {
            _context25.next = 60;
            break;
          }
          _context25.prev = 41;
          contractERC20 = new Contract(tokenAddress, erc20abi_namespaceObject, provider);
          _context25.next = 45;
          return contractERC20.symbol();
        case 45:
          symbol = _context25.sent;
          _context25.next = 48;
          return contractERC20.name();
        case 48:
          name = _context25.sent;
          _context25.next = 51;
          return contractERC20.decimals();
        case 51:
          decimals = _context25.sent;
          tokenAmount = formatUnits(deposit.amount, decimals);
          _context25.next = 58;
          break;
        case 55:
          _context25.prev = 55;
          _context25.t1 = _context25["catch"](41);
          console.error('Error fetching ERC20 info:', _context25.t1);
        case 58:
          _context25.next = 63;
          break;
        case 60:
          symbol = tokenDetails.symbol;
          name = tokenDetails.name;
          tokenAmount = formatUnits(deposit.amount, tokenDetails.decimals);
        case 63:
          _context25.next = 113;
          break;
        case 65:
          if (!(tokenType == EPeanutLinkType.erc721)) {
            _context25.next = 92;
            break;
          }
          _context25.prev = 66;
          contract721 = new Contract(tokenAddress, erc721abi_namespaceObject, provider);
          _context25.next = 70;
          return contract721.name();
        case 70:
          name = _context25.sent;
          _context25.next = 73;
          return contract721.symbol();
        case 73:
          symbol = _context25.sent;
          _context25.next = 76;
          return contract721.tokenURI(deposit.tokenId);
        case 76:
          tokenURI = _context25.sent;
          _context25.next = 79;
          return fetch(tokenURI);
        case 79:
          response = _context25.sent;
          if (!response.ok) {
            _context25.next = 84;
            break;
          }
          _context25.next = 83;
          return response.json();
        case 83:
          metadata = _context25.sent;
        case 84:
          _context25.next = 89;
          break;
        case 86:
          _context25.prev = 86;
          _context25.t2 = _context25["catch"](66);
          console.error('Error fetching ERC721 info:', _context25.t2);
        case 89:
          tokenAmount = '1';
          _context25.next = 113;
          break;
        case 92:
          if (!(tokenType == EPeanutLinkType.erc1155)) {
            _context25.next = 113;
            break;
          }
          _context25.prev = 93;
          contract1155 = new Contract(tokenAddress, erc1155abi_namespaceObject, provider);
          name = 'ERC1155 Token (' + deposit.tokenId + ')';
          symbol = '1155';
          _context25.next = 99;
          return contract1155.tokenURI(deposit.tokenId);
        case 99:
          tokenURI = _context25.sent;
          _context25.next = 102;
          return fetch(tokenURI);
        case 102:
          _response = _context25.sent;
          if (!_response.ok) {
            _context25.next = 107;
            break;
          }
          _context25.next = 106;
          return _response.json();
        case 106:
          metadata = _context25.sent;
        case 107:
          _context25.next = 112;
          break;
        case 109:
          _context25.prev = 109;
          _context25.t3 = _context25["catch"](93);
          console.error('Error fetching ERC1155 info:', _context25.t3);
        case 112:
          tokenAmount = '1';
        case 113:
          return _context25.abrupt("return", {
            link: link,
            chainId: chainId,
            depositIndex: depositIdx,
            contractVersion: contractVersion,
            password: password,
            tokenType: deposit.contractType,
            tokenAddress: deposit.tokenAddress,
            tokenSymbol: symbol,
            tokenName: name,
            tokenAmount: tokenAmount,
            tokenId: bignumber_BigNumber.from(deposit.tokenId).toNumber(),
            claimed: claimed,
            depositDate: depositDate,
            tokenURI: tokenURI,
            metadata: metadata
          });
        case 114:
        case "end":
          return _context25.stop();
      }
    }, _callee25, null, [[41, 55], [66, 86], [93, 109]]);
  }))).apply(this, arguments);
}
/**
 * Claims a link through the Peanut API
 */
function claimLinkGasless(_x54) {
  return (_claimLinkGasless = _claimLinkGasless || src_asyncToGenerator( /*#__PURE__*/src_regeneratorRuntime().mark(function _callee26(_ref13) {
    var link, recipientAddress, APIKey, _ref13$baseUrl, baseUrl, payload, headers, body, response, error, data;
    return src_regeneratorRuntime().wrap(function _callee26$(_context26) {
      while (1) switch (_context26.prev = _context26.next) {
        case 0:
          link = _ref13.link, recipientAddress = _ref13.recipientAddress, APIKey = _ref13.APIKey, _ref13$baseUrl = _ref13.baseUrl, baseUrl = _ref13$baseUrl === void 0 ? 'https://api.peanut.to/claim' : _ref13$baseUrl;
          config.verbose && console.log('claiming link through Peanut API...');
          config.verbose && console.log('link: ', link, ' recipientAddress: ', recipientAddress, ' apiKey: ', APIKey, ' url: ', baseUrl);
          _context26.next = 5;
          return createClaimPayload(link, recipientAddress);
        case 5:
          payload = _context26.sent;
          config.verbose && console.log('payload: ', payload);
          if (baseUrl == 'local') {
            config.verbose && console.log('using local api');
            baseUrl = 'http://127.0.0.1:5001/claim';
          }
          headers = {
            'Content-Type': 'application/json'
          };
          body = {
            address: payload.recipientAddress,
            address_hash: payload.addressHash,
            signature: payload.signature,
            idx: payload.idx,
            chain: payload.chainId,
            version: payload.contractVersion,
            api_key: APIKey
          }; // if axios error, return the error message
          _context26.next = 12;
          return fetch(baseUrl, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(body)
          });
        case 12:
          response = _context26.sent;
          config.verbose && console.log('response status: ', response.status);
          if (response.ok) {
            _context26.next = 21;
            break;
          }
          _context26.next = 17;
          return response.text();
        case 17:
          error = _context26.sent;
          throw new Error(error);
        case 21:
          _context26.next = 23;
          return response.json();
        case 23:
          data = _context26.sent;
          return _context26.abrupt("return", data);
        case 25:
        case "end":
          return _context26.stop();
      }
    }, _callee26);
  }))).apply(this, arguments);
}
function toggleVerbose() {
  config.verbose = !config.verbose;
  console.log('Peanut-SDK: toggled verbose mode to: ', config.verbose);
}
var peanut = {
  toggleVerbose: toggleVerbose,
  greeting: greeting,
  generateKeysFromString: generateKeysFromString,
  signMessageWithPrivatekey: signMessageWithPrivatekey,
  verifySignature: verifySignature,
  solidityHashBytesEIP191: solidityHashBytesEIP191,
  solidityHashAddress: solidityHashAddress,
  signAddress: signAddress,
  getRandomString: getRandomString,
  detectContractVersionFromTxReceipt: detectContractVersionFromTxReceipt,
  getContract: getContract,
  getDefaultProvider: getDefaultProvider,
  checkRpc: checkRpc,
  getDepositIdx: getDepositIdx,
  getDepositIdxs: getDepositIdxs,
  getAllDepositsForSigner: getAllDepositsForSigner,
  getLinkDetails: getLinkDetails,
  getParamsFromLink: getParamsFromLink,
  getParamsFromPageURL: getParamsFromPageURL,
  getLinkFromParams: getLinkFromParams,
  createLink: createLink,
  createLinks: createLinks,
  claimLink: claimLink,
  claimLinkGasless: claimLinkGasless,
  estimateGasLimit: estimateGasLimit,
  // claimLinkSender,
  prepareTxs: prepareTxs,
  signAndSubmitTx: signAndSubmitTx,
  getLinksFromTx: getLinksFromTx,
  getLinksFromMultilink: getLinksFromMultilink,
  createMultiLinkFromLinks: createMultiLinkFromLinks,
  formatNumberAvoidScientific: formatNumberAvoidScientific,
  trim_decimal_overflow: trim_decimal_overflow,
  VERSION: VERSION,
  version: VERSION,
  CHAIN_DETAILS: chainDetails_namespaceObject,
  TOKEN_DETAILS: tokenDetails_namespaceObject,
  TOKEN_TYPES: TOKEN_TYPES,
  DEFAULT_CONTRACT_VERSION: DEFAULT_CONTRACT_VERSION,
  PEANUT_CONTRACTS: contracts_namespaceObject,
  interfaces: interfaces_consts_namespaceObject
};
console.log('peanut-sdk version: ', VERSION);
/* harmony default export */ const src = (peanut);

})();

var __webpack_exports__CHAIN_DETAILS = __webpack_exports__.$;
var __webpack_exports__DEFAULT_CONTRACT_VERSION = __webpack_exports__.Tg;
var __webpack_exports__PEANUT_CONTRACTS = __webpack_exports__.ez;
var __webpack_exports__TOKEN_DETAILS = __webpack_exports__.k;
var __webpack_exports__TOKEN_TYPES = __webpack_exports__.uN;
var __webpack_exports__VERSION = __webpack_exports__.q4;
var __webpack_exports__claimLink = __webpack_exports__.UM;
var __webpack_exports__claimLinkGasless = __webpack_exports__.OH;
var __webpack_exports__createLink = __webpack_exports__.EW;
var __webpack_exports__createLinks = __webpack_exports__.jf;
var __webpack_exports__default = __webpack_exports__.ZP;
var __webpack_exports__estimateGasLimit = __webpack_exports__.$K;
var __webpack_exports__getLinkFromParams = __webpack_exports__.Vk;
var __webpack_exports__getLinksFromTx = __webpack_exports__.m9;
var __webpack_exports__getParamsFromLink = __webpack_exports__.ay;
var __webpack_exports__getParamsFromPageURL = __webpack_exports__._y;
var __webpack_exports__getRandomString = __webpack_exports__.zO;
var __webpack_exports__greeting = __webpack_exports__.Qw;
var __webpack_exports__peanut = __webpack_exports__.oA;
var __webpack_exports__prepareTxs = __webpack_exports__.qT;
var __webpack_exports__signAndSubmitTx = __webpack_exports__.Y_;
var __webpack_exports__toggleVerbose = __webpack_exports__.EQ;
export { __webpack_exports__CHAIN_DETAILS as CHAIN_DETAILS, __webpack_exports__DEFAULT_CONTRACT_VERSION as DEFAULT_CONTRACT_VERSION, __webpack_exports__PEANUT_CONTRACTS as PEANUT_CONTRACTS, __webpack_exports__TOKEN_DETAILS as TOKEN_DETAILS, __webpack_exports__TOKEN_TYPES as TOKEN_TYPES, __webpack_exports__VERSION as VERSION, __webpack_exports__claimLink as claimLink, __webpack_exports__claimLinkGasless as claimLinkGasless, __webpack_exports__createLink as createLink, __webpack_exports__createLinks as createLinks, __webpack_exports__default as default, __webpack_exports__estimateGasLimit as estimateGasLimit, __webpack_exports__getLinkFromParams as getLinkFromParams, __webpack_exports__getLinksFromTx as getLinksFromTx, __webpack_exports__getParamsFromLink as getParamsFromLink, __webpack_exports__getParamsFromPageURL as getParamsFromPageURL, __webpack_exports__getRandomString as getRandomString, __webpack_exports__greeting as greeting, __webpack_exports__peanut as peanut, __webpack_exports__prepareTxs as prepareTxs, __webpack_exports__signAndSubmitTx as signAndSubmitTx, __webpack_exports__toggleVerbose as toggleVerbose };

